/******/ (function(modules) { // webpackBootstrap
/******/ 	// install a JSONP callback for chunk loading
/******/ 	var parentJsonpFunction = window["webpackJsonp"];
/******/ 	window["webpackJsonp"] = function webpackJsonpCallback(chunkIds, moreModules, executeModules) {
/******/ 		// add "moreModules" to the modules object,
/******/ 		// then flag all "chunkIds" as loaded and fire callback
/******/ 		var moduleId, chunkId, i = 0, resolves = [], result;
/******/ 		for(;i < chunkIds.length; i++) {
/******/ 			chunkId = chunkIds[i];
/******/ 			if(installedChunks[chunkId]) {
/******/ 				resolves.push(installedChunks[chunkId][0]);
/******/ 			}
/******/ 			installedChunks[chunkId] = 0;
/******/ 		}
/******/ 		for(moduleId in moreModules) {
/******/ 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
/******/ 				modules[moduleId] = moreModules[moduleId];
/******/ 			}
/******/ 		}
/******/ 		if(parentJsonpFunction) parentJsonpFunction(chunkIds, moreModules, executeModules);
/******/ 		while(resolves.length) {
/******/ 			resolves.shift()();
/******/ 		}
/******/ 		if(executeModules) {
/******/ 			for(i=0; i < executeModules.length; i++) {
/******/ 				result = __webpack_require__(__webpack_require__.s = executeModules[i]);
/******/ 			}
/******/ 		}
/******/ 		return result;
/******/ 	};
/******/
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// objects to store loaded and loading chunks
/******/ 	var installedChunks = {
/******/ 		27: 0
/******/ 	};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/ 	// This file contains only the entry chunk.
/******/ 	// The chunk loading function for additional chunks
/******/ 	__webpack_require__.e = function requireEnsure(chunkId) {
/******/ 		var installedChunkData = installedChunks[chunkId];
/******/ 		if(installedChunkData === 0) {
/******/ 			return new Promise(function(resolve) { resolve(); });
/******/ 		}
/******/
/******/ 		// a Promise means "currently loading".
/******/ 		if(installedChunkData) {
/******/ 			return installedChunkData[2];
/******/ 		}
/******/
/******/ 		// setup Promise in chunk cache
/******/ 		var promise = new Promise(function(resolve, reject) {
/******/ 			installedChunkData = installedChunks[chunkId] = [resolve, reject];
/******/ 		});
/******/ 		installedChunkData[2] = promise;
/******/
/******/ 		// start chunk loading
/******/ 		var head = document.getElementsByTagName('head')[0];
/******/ 		var script = document.createElement('script');
/******/ 		script.type = 'text/javascript';
/******/ 		script.charset = 'utf-8';
/******/ 		script.async = true;
/******/ 		script.timeout = 120000;
/******/
/******/ 		if (__webpack_require__.nc) {
/******/ 			script.setAttribute("nonce", __webpack_require__.nc);
/******/ 		}
/******/ 		script.src = __webpack_require__.p + "" + chunkId + ".js";
/******/ 		var timeout = setTimeout(onScriptComplete, 120000);
/******/ 		script.onerror = script.onload = onScriptComplete;
/******/ 		function onScriptComplete() {
/******/ 			// avoid mem leaks in IE.
/******/ 			script.onerror = script.onload = null;
/******/ 			clearTimeout(timeout);
/******/ 			var chunk = installedChunks[chunkId];
/******/ 			if(chunk !== 0) {
/******/ 				if(chunk) {
/******/ 					chunk[1](new Error('Loading chunk ' + chunkId + ' failed.'));
/******/ 				}
/******/ 				installedChunks[chunkId] = undefined;
/******/ 			}
/******/ 		};
/******/ 		head.appendChild(script);
/******/
/******/ 		return promise;
/******/ 	};
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// on error function for async loading
/******/ 	__webpack_require__.oe = function(err) { console.error(err); throw err; };
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 214);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

module.exports = jQuery;

/***/ }),
/* 1 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return noopActions; });
/* harmony export (immutable) */ __webpack_exports__["a"] = registerJQueryPlugin;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_isString__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_isString___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_isString__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_isUndefined__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_isUndefined___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_isUndefined__);
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
/**
 * This simple helper aids in the creation of creating/registering a jquery
 * plugin.
 * @module lib/createJqueryPlugin
 */




var NOOP = function NOOP() {};

/**
 * Provides noop actions for sensible defaults.
 * @type {Object}
 */
var noopActions = {
  deregister: NOOP
};

/**
 * Contains a number of methods representing actions.
 * @param {HTMLElement} el - The element applied to the plugin
 * @param {string} name - The name of the plugin
 */
var actions = function actions(el, name) {
  return {
    /**
     * Performs a deregisteration on the plugin
     */
    deregister: function deregister() {
      return __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.removeData(el, name);
    }
  };
};
var DEFAULT_OPTIONS = {
  cache: true
};

/**
 * Simple helper function that creates/register a jQuery plugin.
 * @param {string} name - The name of the plugin to reguster
 * @param {jQueryPluginCallback} cb - A callback function
 */
function registerJQueryPlugin(name, cb) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var _Object$assign = Object.assign({}, DEFAULT_OPTIONS, options),
    cache = _Object$assign.cache;
  __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.fn[name] = function pluginRegister() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    var $obj = this;
    var opt = args[0];
    var _$obj$toArray$map$fil = $obj.toArray().map(function (el) {
        if (__WEBPACK_IMPORTED_MODULE_1_lodash_isString___default()(opt)) {
          var instance = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.data(el, name);
          if (!instance) {
            // eslint-disable-next-line no-console
            return console.warn("Attempted to call method ".concat(opt, " when no instance existed for ").concat(name));
          }
          if (!instance[opt]) {
            // eslint-disable-next-line no-console
            return console.warn("No method found for ".concat(opt, " on ").concat(name));
          }
          var argList = args.slice(1);
          return instance[opt].apply(instance, _toConsumableArray(argList));
        }
        if (__WEBPACK_IMPORTED_MODULE_2_lodash_isUndefined___default()(__WEBPACK_IMPORTED_MODULE_0_jquery___default.a.data(el, name)) || !cache) {
          __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.data(el, name, cb(el, opt, actions(el, name)) || {});
        }

        // this is here so we can identify that chaining should occur and also
        // shut up eslint from complaining about a needed return value
        return undefined;
      }).filter(function (val) {
        return !__WEBPACK_IMPORTED_MODULE_2_lodash_isUndefined___default()(val);
      }),
      _$obj$toArray$map$fil2 = _slicedToArray(_$obj$toArray$map$fil, 1),
      result = _$obj$toArray$map$fil2[0];
    return result || $obj;
  };
}

/**
 * This callback is used for registering a jQuery plugin.
 * @callback jQueryPluginCallback
 * @param {HTMLElement} el - The element applied to the plugin
 * @param {Object} options - Options forwarded along to the plugin.
 * @param {Object} actions - Actions that can be taken on the plugin
 */

/***/ }),
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Merges together all the options and the various conditions in which they
 * can be set.
 * @param  {jQuery} $el - The container element
 * @param  {Object} [options={}] - Any options provided upon initialization
 * @return {Object} Immutable version of the options
 */

var mergeOptions = function mergeOptions() {
  var DEFAULTS = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var $el = arguments.length > 2 ? arguments[2] : undefined;
  var opts = Object.assign({}, DEFAULTS, options, $el ? $el.data() : {});
  return opts;
};
/* harmony default export */ __webpack_exports__["a"] = (mergeOptions);

/***/ }),
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/**
 * Keyboard JS
 * Parses keyboard events
 * Trap the focus in the given element
 */


var keyCodes = {
  9: 'TAB',
  13: 'ENTER',
  27: 'ESCAPE',
  32: 'SPACE',
  37: 'ARROWLEFT',
  38: 'ARROWUP',
  39: 'ARROWRIGHT',
  40: 'ARROWDOWN'
};
/*
 * Constants for easier comparing.
 * Can be used like Keyboard.parseKey(event) === Keyboard.keys.SPACE
 */
var getKeyCodes = function getKeyCodes(kcs) {
  var k = {};
  Object.keys(kcs).forEach(function (key) {
    k[kcs[key]] = kcs[key];
  });
  return k;
};
var Keyboard = {
  keys: getKeyCodes(keyCodes),
  /**
   * Parses the (keyboard) event and returns a String that represents its key
   * Can be used like Keyboard.parseKey(event) === Keyboard.keys.SPACE
   * @param {Event} event - the event generated by the event handler
   * @return String key - String that represents the key pressed
   */
  parseKey: function parseKey(event) {
    var key;
    if (event.key !== undefined) {
      if (event.key === ' ') {
        key = 'SPACE';
      } else {
        key = event.key.toUpperCase();
      }
    } else {
      key = keyCodes[event.which || event.keyCode] || String.fromCharCode(event.which).toUpperCase();
    }

    // Remove un-printable characters, e.g. for `fromCharCode` calls for CTRL only events
    key = key.replace(/\W+/, '');
    if (event.shiftKey) key = "SHIFT_".concat(key);
    if (event.ctrlKey) key = "CTRL_".concat(key);
    if (event.altKey) key = "ALT_".concat(key);

    // Remove trailing underscore, in case only modifiers were used (e.g. only `CTRL_ALT`)
    key = key.replace(/_$/, '');
    return key;
  },
  /**
   * Finds all focusable elements within the given `$element`
   * @param {jQuery} $el - jQuery object to search within
   * @return {jQuery} $focusable - all focusable elements within `$el`
   */
  findFocusable: function findFocusable($el) {
    // only have visible elements and those that have a tabindex greater or equal 0
    return $el.find('a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), iframe, object, embed, *[tabindex], *[contenteditable]').filter(':visible').filter(function (index, el) {
      return el.getAttribute('tabindex') >= 0;
    });
  },
  /**
   * Traps the focus in the given element.
   * @param  {jQuery} $el - jQuery object to trap the foucs into.
   */
  trapFocus: function trapFocus($el) {
    $el.on('keydown.trapfocus', function (event) {
      var parsedKey = Keyboard.parseKey(event);
      if (parsedKey === 'TAB' || parsedKey === 'SHIFT_TAB') {
        // New element might be loaded. If the target is the same as the last,
        // attempt to rerun trapFocus Logic.
        var $focusable = Keyboard.findFocusable($el);
        var $firstFocusable = $focusable.eq(0);
        var $lastFocusable = $focusable.eq(-1);
        if (parsedKey === 'TAB' && event.target === $lastFocusable[0]) {
          event.preventDefault();
          $firstFocusable.focus();
        } else if (parsedKey === 'SHIFT_TAB') {
          if (event.target === $firstFocusable[0]) {
            event.preventDefault();
            $lastFocusable.focus();
          }

          // Accounting for firstFocusable possibly being in a list that could change
          if (event.target.name === $firstFocusable[0].name && $firstFocusable[0].name !== '') {
            event.preventDefault();
            $lastFocusable.focus();
          }
          if (__WEBPACK_IMPORTED_MODULE_0_jquery___default.a.inArray(event.target, $focusable) === -1) {
            $lastFocusable.focus();
          }
        }
      }
    });
  },
  /**
   * Releases the trapped focus from the given element.
   * @param  {jQuery} $el  jQuery object to release the focus for.
   * @param  {jQuery} $lastFocus return to last focus
   */
  releaseFocus: function releaseFocus($el, $lastFocus) {
    $el.off('keydown.trapfocus');
    if ($lastFocus) {
      $lastFocus.focus();
    }
  }
};
/* harmony default export */ __webpack_exports__["a"] = (Keyboard);

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

var freeGlobal = __webpack_require__(151);

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

module.exports = root;


/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_defaults__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_defaults___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_defaults__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_get__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_get__);



var PRODUCT_CODE = 'data-pcode';
var SELECTORS = {
  totalCount: '#tr_top_heart_mhp_count',
  favHeart: '.fav_heart'
};
var CLASS_NAMES = {
  activated: 'favorite-button--active'
};
var REQUESTS = {
  heartProduct: {
    url: '/r/ajaxHeartProduct.jsp?',
    method: 'POST'
  }
};
var TRANSLATIONS = {
  favorite: __WEBPACK_IMPORTED_MODULE_2_lodash_get___default()(window, 'rcProps.hearts.textFields.favorite', 'Favorite'),
  unfavorite: __WEBPACK_IMPORTED_MODULE_2_lodash_get___default()(window, 'rcProps.hearts.textFields.unfavorite', 'Unfavorite'),
  addFavorite: __WEBPACK_IMPORTED_MODULE_2_lodash_get___default()(window, 'rcProps.hearts.textFields.addFavorite', 'has been added to your favorites'),
  removeFavorite: __WEBPACK_IMPORTED_MODULE_2_lodash_get___default()(window, 'rcProps.hearts.textFields.removeFavorite', 'has been removed from your favorites'),
  favoriteBrand: __WEBPACK_IMPORTED_MODULE_2_lodash_get___default()(window, 'rcProps.hearts.textFields.favoriteBrand', 'Add this brand to your FAVORITES'),
  unfavoriteBrand: __WEBPACK_IMPORTED_MODULE_2_lodash_get___default()(window, 'rcProps.hearts.textFields.unfavoriteBrand', 'Unfavorite this brand')
};
__WEBPACK_IMPORTED_MODULE_1_lodash_defaults___default()(init, {
  heartProductM: heartProductM,
  heartAll: heartAll,
  submitHeart: submitHeart,
  submitHeartBrand: updateHeartBrandPLP,
  updateHeartCount: updateHeartCount,
  SELECTORS: SELECTORS,
  CLASS_NAMES: CLASS_NAMES,
  REQUESTS: REQUESTS,
  TRANSLATIONS: TRANSLATIONS
});
function getActiveClass() {
  return window.rcProps && window.rcProps.favoriteActiveClass || CLASS_NAMES.activated;
}
function init(selector, delegateTo, paramProductCode) {
  var $el = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(selector);
  if (paramProductCode) {
    heartProductM(null, paramProductCode);
  } else if (!$el.data('plugin_hearting')) {
    $el.data('plugin_hearting', true); // Prevent duplicate events
    if (delegateTo) {
      $el.on('click', delegateTo, function (e) {
        e.preventDefault();
        var target = e.currentTarget;
        heartProductM(target, target.getAttribute(PRODUCT_CODE));
      });
    } else {
      $el.on('click', function (e) {
        e.preventDefault();
        var target = e.target;
        heartProductM(target, target.getAttribute(PRODUCT_CODE));
      });
    }
  }
  window.updateHeartBrandPLP = updateHeartBrandPLP;
  window.updateHeartBrandIndex = updateHeartBrandIndex;
  window.updateHeartBrandIndexWithTab = updateHeartBrandIndexWithTab;
  window.reloadDesignersList = reloadDesignersList;
}
// Add / Update a key-value pair in the URL query parameters
function updateUrlParameter(uri, key, value) {
  var i = uri.indexOf('#');
  var hash = i === -1 ? '' : uri.substr(i);
  uri = i === -1 ? uri : uri.substr(0, i);
  var re = new RegExp("([?&])" + key + "=.*?(&|$)", "i");
  var separator = uri.indexOf('?') !== -1 ? "&" : "?";
  if (uri.match(re)) {
    uri = uri.replace(re, '$1' + key + "=" + value + '$2');
  } else {
    uri = uri + separator + key + "=" + value;
  }
  return uri + hash;
}
function heartProductM(elem, pcode, size, sectionUrl) {
  var $span = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(elem);
  var $favoriteNotify = $span.next('.js-favorite-notify');
  var unfavoritedMessageNotif = $span.data('unfavorite-notification');
  var favoritedMessageNotif = $span.data('favorite-notification');
  var unfavoriteMessage = $span.data('unfavorite-message');
  var favoriteMessage = $span.data('favorite-message');
  var messageContainer = '.u-screen-reader';
  var activeClass = getActiveClass();
  if ($span.hasClass(activeClass)) {
    $span.removeClass(activeClass);
    $favoriteNotify.text(unfavoritedMessageNotif);
    $span.find(messageContainer).text(favoriteMessage);
    submitHeart('product', pcode, 'remove', size, sectionUrl);
    if (window.rcProps.removeItemOnUnhearted) {
      var $citeDiv = $span.parents('.js-plp-container');
      $citeDiv.fadeOut();
      $citeDiv.remove();
      var $plpCount = __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#plp-item-count");
      var countRef = $plpCount.html();
      var itemCountDescriptionArr = countRef.split(' ');
      var count = parseInt($plpCount.data("count"), 10) || 0;
      if (count > 0) {
        count = count - 1;
      }
      var itemCountText = count.toLocaleString();
      var $textEl = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#plp-item-text');
      if ($textEl.length > 0) {
        var text = '';
        if (count === 1) {
          text = $textEl.data("textone");
        } else {
          text = $textEl.data("text");
        }
        $textEl.html(text);
      } else if (itemCountDescriptionArr.length > 1) {
        itemCountText = itemCountText + ' ' + itemCountDescriptionArr[1];
      }
      $plpCount.html(itemCountText);
      $plpCount.data("count", count);
    }
  } else {
    var productSize = parseInt(__WEBPACK_IMPORTED_MODULE_0_jquery___default()(SELECTORS.totalCount).data('count'), 10);
    if (!window.rcProps.isApp) {
      if (window.rcProps.isGuest && !(window.rcProps.hearts.enabledforGuest && productSize <= window.rcProps.hearts.maxCountGuest) || !window.rcProps.isGuest && productSize > window.rcProps.hearts.maxCount) {
        showExceedsLimitModal(pcode);
        return;
      }
    }
    return submitHeart('product', pcode, 'add', size, sectionUrl, function () {
      $favoriteNotify.text(favoritedMessageNotif);
      $span.find(messageContainer).text(unfavoriteMessage);
    }, elem, activeClass);
  }
}
function showExceedsLimitModal(productCode) {
  __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.modal({
    url: "/content/favorites/fav-max-popup-markup",
    triggerOpen: true,
    onOpen: function onOpen() {
      if (window.rcProps.isGuest) {
        var _donde = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#loadDnde');
        var refUrl = window.location.pathname + window.location.search;
        if (_donde && _donde.val()) {
          refUrl = updateUrlParameter(refUrl, 'loadDnde', _donde.val());
        }
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#guestLimitPop, #fav-create-link').attr('href', "/r/mobile/LoginPage.jsp?favcode=" + productCode + "&ref=" + encodeURIComponent(refUrl));
      }
    }
  });
}
window.showExceedsLimitModal = showExceedsLimitModal;
function updateHeartBrandPLP(elem, designer, callback) {
  var activeClass = getActiveClass();
  var $elem = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(elem);
  if ($elem.hasClass(activeClass) || $elem.data('is-active')) {
    $elem.removeClass(activeClass);
    $elem.find(".favorite-msg").html(TRANSLATIONS.favoriteBrand);
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#favorite-designer').find('p').html(designer + " " + TRANSLATIONS.removeFavorite);
    submitHeart("brand", designer, "remove");
  } else {
    if (!$elem.data('use-active-attr')) {
      $elem.addClass(activeClass);
    }
    $elem.find(".favorite-msg").html(TRANSLATIONS.unfavoriteBrand);
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#favorite-designer').find('p').html(designer + " " + TRANSLATIONS.addFavorite);
    submitHeart("brand", designer, "add");
  }
  if (callback && typeof callback === 'function') {
    callback();
  } else {
    __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.modal({
      triggerOpen: true,
      open: "favorite-designer"
    });
  }
}
function updateHeartBrandIndex(elem, designer, isGuest) {
  var activeClass = getActiveClass();
  var gender = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#home').data('gender');
  var $elem = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(elem);
  if ($elem.hasClass(activeClass)) {
    $elem.removeClass(activeClass);
    $elem.find('.u-screen-reader').html(TRANSLATIONS.favorite + " " + designer);
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#unfavorite-button').find('p').html(designer + " " + TRANSLATIONS.removeFavorite);
    if ($elem.parents('#favorite-designer-list').length == 1) {
      return submitHeart("brand", designer, "remove").then(function () {
        location.reload();
      });
    } else {
      return submitHeart("brand", designer, "remove").then(function () {
        __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.modal({
          triggerOpen: true,
          open: "unfavorite-button"
        });
      }).then(function () {
        return reloadFavoriteDesignerList(gender);
      });
    }
  } else {
    if (isGuest) {
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#favorite-designer-modal').find('#fav-modal-sign-in').attr('href', '/r/mobile/LoginPage.jsp?d=' + gender + '&favbrand=' + designer + '&ref=' + encodeURIComponent('/r/mobile/DesignerAZ.jsp?d=' + gender));
      __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.modal({
        triggerOpen: true,
        open: "favorite-designer-modal"
      });
    } else {
      $elem.addClass(activeClass);
      $elem.find('.u-screen-reader').html(TRANSLATIONS.unfavorite + " " + designer);
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#favorite-button').find('p').html(designer + " " + TRANSLATIONS.addFavorite);
      return submitHeart("brand", designer, "add").then(function () {
        __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.modal({
          triggerOpen: true,
          open: "favorite-button"
        });
      }).then(function () {
        return reloadFavoriteDesignerList(gender);
      });
    }
  }
}
function reloadDesignersList(tab, $element) {
  __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.ajax({
    url: window.rcProps.designerListHref + '&tab=' + encodeURIComponent(tab),
    success: function success(response) {
      if ($element) {
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()(".designer-nav__link").removeClass('action-button--dark');
        $element.addClass('action-button--dark');
      }
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#designer-content").html(response);
    }
  });
}
function updateHeartBrandIndexWithTab(elem, designer, isGuest, tab, gender) {
  var activeClass = getActiveClass();
  var $elem = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(elem);
  if ($elem.hasClass(activeClass)) {
    $elem.removeClass(activeClass);
    $elem.find('.u-screen-reader').html(TRANSLATIONS.favorite + " " + designer);
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#unfavorite-button').find('p').html(designer + " " + TRANSLATIONS.removeFavorite);
    if ($elem.parents('#favorite-designer-list').length == 1) {
      return submitHeart("brand", designer, "remove").then(function () {
        reloadDesignersList(tab);
      }).then(function () {
        __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.modal({
          triggerOpen: true,
          open: "unfavorite-button"
        });
      });
    } else {
      return submitHeart("brand", designer, "remove").then(function () {
        return reloadDesignersList(tab);
      }).then(function () {
        __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.modal({
          triggerOpen: true,
          open: "unfavorite-button"
        });
      });
    }
  } else {
    if (isGuest && !window.rcProps.hearts.enabledforGuest) {
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#favorite-designer-modal').find('#fav-modal-sign-in').attr('href', '/r/mobile/LoginPage.jsp?d=' + gender + '&favbrand=' + designer + '&ref=' + encodeURIComponent(location.pathname + '?d=' + gender + '&tab=' + tab));
      __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.modal({
        triggerOpen: true,
        open: "favorite-designer-modal"
      });
    } else {
      $elem.addClass(activeClass);
      $elem.find('.u-screen-reader').html(TRANSLATIONS.unfavorite + " " + designer);
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#favorite-button').find('p').html(designer + " " + TRANSLATIONS.addFavorite);
      return submitHeart("brand", designer, "add").then(function () {
        __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.modal({
          triggerOpen: true,
          open: "favorite-button"
        });
      }).then(function () {
        return reloadFavoriteDesignerList(gender, tab);
      });
    }
  }
}
function reloadFavoriteDesignerList(gender, tab) {
  if (location.pathname.indexOf('/content/lp/beauty/shop-by-brand/mobile') !== -1) {
    return; // do not reload designerlist on shop by beauty brand page
  }
  var data = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.param({
    gender: gender,
    tab: tab
  });
  __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.ajax({
    type: 'GET',
    url: '/r/ajax/reloadFavoriteDesignerList.jsp',
    data: data,
    success: function success(rtn) {
      if (rtn.trim()) {
        if (!__WEBPACK_IMPORTED_MODULE_0_jquery___default()("#menu-title").is(":visible")) {
          __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#menu-title").show();
          __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-fav-info').hide();
        }
      } else {
        if (__WEBPACK_IMPORTED_MODULE_0_jquery___default()("#menu-title").is(":visible")) {
          __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#menu-title").hide();
          __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-fav-info').show();
        }
      }
      if (window.rcProps.redesignedMarkup) {
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-fav-designer').remove();
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#menu-title').after(rtn);
      } else {
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#favorite-designer-list').html(rtn);
      }
    }
  });
}
function submitHeart(paramtype, paramvalue, action, psize, sectionUrl, callback, elem, activeClass) {
  var data = {};
  var heartInfo = {};
  if (!paramtype) {
    return rejectPromise('param type is required when hearting a product');
  } else if (!paramvalue) {
    return rejectPromise('param value is required when hearting a product');
  } else if (!action) {
    return rejectPromise('action is required when hearting a product');
  }
  switch (paramtype) {
    case 'product':
      data.pcode = paramvalue;
      break;
    case 'brand':
      data.bcode = paramvalue;
      break;
  }
  data.action_T = action;
  var department = __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#tr_top_heart_mhp_count").data('department');
  if (department) {
    data.mensBrand = encodeURIComponent(department.toLowerCase() === "mens");
    data.kidsBrand = encodeURIComponent(department.toLowerCase() === "kids");
  }
  if (psize) {
    data.psize = psize;
  }
  if (sectionUrl) {
    data.sectionURL = sectionUrl;
  }
  if (paramtype == 'product') {
    if (typeof gaUpdateHeartItem === 'function') {
      gaUpdateHeartItem(action, paramvalue);
    }
    if (typeof taboolaWishListAction === 'function') {
      taboolaWishListAction(action, paramvalue);
    }
    if (typeof iPinYouHeartItem === 'function' && action != 'undefined' && action === 'add') {
      iPinYouHeartItem(paramvalue);
    }
    if (typeof insertRTBHouseHeartItem === 'function' && action != 'undefined' && action === 'add') {
      insertRTBHouseHeartItem(paramvalue);
    }
  } else if (paramtype == 'brand') {
    if (typeof gaUpdateHeartBrand === 'function') {
      gaUpdateHeartBrand(action, paramvalue);
    }
  }
  return requestHeartProduct(data).then(function (heartStatus) {
    if (heartStatus.exceedsLimit) {
      showExceedsLimitModal(paramvalue);
      if (typeof window.updateSwatchHeart === 'function') {
        window.updateSwatchHeart(data.pcode, false);
      }
    } else if (heartStatus.success) {
      if (typeof callback == 'function') {
        callback();
      }
      updateHeartCount(heartStatus.count);
      if (action == 'add' && paramtype == 'product' && elem && activeClass) {
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()(elem).addClass(activeClass);
      }
    }
    return heartStatus;
  }).then(function (heartStatus) {
    if (heartStatus && heartStatus.count == 0 && location.pathname.indexOf('/mr_favorites.jsp') !== -1) {
      var redirectUrl = "/content/myfav/onboarding/mobile?d=" + department;
      window.location.replace(redirectUrl);
    }
    if (action == 'add' && paramtype == 'product') {
      insertCordialUpdateHeartItem('add', paramvalue);
    }
    if (action == 'remove' && paramtype == 'product') {
      insertCordialUpdateHeartItem('remove', paramvalue);
    }
    if (paramtype === 'brand') {
      if (typeof brazeBrandFavorites === 'function') {
        brazeBrandFavorites(heartStatus.action, heartStatus.brandName, heartStatus.brandId);
      }
    } else if (paramtype === 'product') {
      if (typeof brazeAddToFavorites === 'function') {
        brazeAddToFavorites(action, heartStatus.code, heartStatus.name, heartStatus.size, heartStatus.imageUrl, heartStatus.productUrl, heartStatus.price, heartStatus.currency, heartStatus.department, heartStatus.color, heartStatus.brandName, heartStatus.category, heartStatus.cat1);
      }
    }
    return true;
  });
}
function sanitizeResponse(str) {
  return str.replace(/^\s+|\s+$/g, '');
}
function rejectPromise(msg) {
  return __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.Deferred().reject(new Error(msg));
}
function requestHeartProduct(data) {
  if (window.rcProps.isApp) {
    window.location.href = "/AppHeartProductIntercept.jsp?" + __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.param(data);
  } else {
    return __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.ajax({
      type: REQUESTS.heartProduct.method,
      url: REQUESTS.heartProduct.url,
      data: data
    }).then(function (res) {
      return res;
    });
  }
}
function updateHeartCount(count) {
  if (count > 99) {
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()(SELECTORS.totalCount).html("99+");
  } else if (count === 0) {
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()(SELECTORS.totalCount).html(count);
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.fav-count--ab').hide();
  } else {
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()(SELECTORS.totalCount).html(count);
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.fav-count--ab').show();
  }
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()(SELECTORS.totalCount).data('count', count);
}

//this method only use in mobile display product page
function heartAll(elem) {
  var activeClass = getActiveClass();
  if (__WEBPACK_IMPORTED_MODULE_0_jquery___default()(elem).find('span').hasClass(activeClass)) {
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.fav_heart').removeClass(activeClass);
  } else {
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.fav_heart').addClass(activeClass);
  }
}
/* harmony default export */ __webpack_exports__["a"] = (init);

/***/ }),
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = addToBag;
/* harmony export (immutable) */ __webpack_exports__["a"] = addToBagWithData;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);


// This function is deprecated in favor of addToBagWithData
function addToBag(productCode, size, count, callbacks, tryOnSize, dateAdded) {
  var data = {
    colorSelect: productCode,
    sizeSelect: size,
    fitItemSizes: tryOnSize,
    count: count || 1,
    dateAdded: dateAdded
  };
  addToBagWithData(data, callbacks);
}
function addToBagWithData(dataObj, callbacks, addToBagUrl) {
  if (!dataObj) {
    return;
  }
  var updateCartProductCount = false;
  if (!addToBagUrl) {
    addToBagUrl = '/r/ajax/AddItemToBag.jsp';
    updateCartProductCount = true;
  }
  var rcProps = window.rcProps || {};
  dataObj.mobile = true;
  if (!dataObj.sectionURL) {
    dataObj.sectionURL = rcProps.sectionUrl;
  }
  if (!dataObj.csrfHash) {
    dataObj.csrfHash = rcProps.csrfHash;
  }
  if (!dataObj.d) {
    dataObj.d = rcProps.department;
  }
  if (!dataObj.contextReferrer) {
    dataObj.contextReferrer = document.referrer;
  }
  dataObj.supportReCAPTCHA = true;
  if (dataObj.code && !dataObj.colorSelect) {
    dataObj.colorSelect = dataObj.code;
  }
  if (dataObj.size && !dataObj.sizeSelect) {
    dataObj.sizeSelect = dataObj.size;
  }
  var serializedData = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.param(dataObj);
  var code = dataObj.code;
  var size = dataObj.size;
  if (!code) {
    code = dataObj.colorSelect;
  }
  if (!size) {
    size = dataObj.sizeSelect;
  }
  __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.ajax({
    type: 'POST',
    url: addToBagUrl,
    data: serializedData,
    success: function success(data) {
      var obj = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.parseJSON(data);
      if (obj.reCAPTCHA) {
        var reCAPTCHAData = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.param({
          mobile: true
        });
        __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.modal({
          url: "/r/dialog/VerifyHuman.jsp?" + reCAPTCHAData,
          type: "full",
          open: null,
          cache: false,
          overlayClose: true,
          triggerOpen: true
        });
      } else if (obj.reachedBagLimit) {
        var limitData = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.param({
          code: code,
          size: size,
          mobile: true
        });
        __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.modal({
          url: "/r/dialog/ShoppingBagLimit.jsp?" + limitData,
          type: "small",
          open: null,
          cache: false,
          overlayClose: true,
          triggerOpen: true,
          onComplete: function onComplete() {}
        });
      } else if (obj.success) {
        if (typeof insertRTBHouseAddToCart === 'function') {
          insertRTBHouseAddToCart(code);
        }
        if (typeof insertCriteoAddToCart === 'function') {
          insertCriteoAddToCart(code);
        }
        if (typeof iPinYouAddtoCart === 'function') {
          iPinYouAddtoCart(code);
        }
        if (typeof insertTaboolaAddToCart === 'function') {
          insertTaboolaAddToCart('add', code);
        }
        if (typeof addToCartPixelGTM === 'function') {
          addToCartPixelGTM('add', code, obj.msg1, obj.msg5, 1, obj.msg2, obj.msg16);
        }
        if (typeof insertTiktokAddToCart === 'function') {
          insertTiktokAddToCart(code);
        }
        if (typeof insertSnapchatAddToCart === 'function') {
          insertSnapchatAddToCart(code);
        }
        if (typeof pushAddProductToCordial === 'function') {
          pushAddProductToCordial(obj.msg1, code, obj.msg5, obj.msg3, obj.msg16, null, obj.msg28, 1, obj.msg29, obj.msg30);
        }
        if (callbacks && typeof callbacks.success === 'function') {
          callbacks.success(obj);
        }
      }
      if (updateCartProductCount && obj.msg22) {
        var itemCount = parseInt(obj.msg22, 10);
        if (!Number.isNaN(itemCount)) {
          __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#shopping_bag_count").html(itemCount);
          if (itemCount === 0) {
            __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.bag-count--ab').hide();
          } else {
            __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.bag-count--ab').show();
          }
        }
      }
      if (callbacks && typeof callbacks.done === 'function') {
        callbacks.done(obj);
      }
    }
  });
  window.rcProps.ReCAPTCHACallBack = function () {
    addToBagWithData(dataObj, callbacks, addToBagUrl);
  };
}

/***/ }),
/* 7 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

module.exports = isObject;


/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

var baseGet = __webpack_require__(134);

/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */
function get(object, path, defaultValue) {
  var result = object == null ? undefined : baseGet(object, path);
  return result === undefined ? defaultValue : result;
}

module.exports = get;


/***/ }),
/* 9 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

module.exports = isArray;


/***/ }),
/* 10 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

module.exports = isObjectLike;


/***/ }),
/* 11 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export updateStore */
/* unused harmony export clearStore */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return get; });
/* unused harmony export set */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isUndefined__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isUndefined___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_isUndefined__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_property__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_property___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_property__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_clone__ = __webpack_require__(471);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_clone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_clone__);
/**
 * Responsible for setting up page specific properties. These properties are
 * intended to be used for environment specific properties such as URLs or
 * values that are used throughout multiple pages.
 * @module lib/props
 */



var props = window.rcProps || {};

/**
 * Responsible for overriding the existing store.
 * @param {Object} obj - Values used for replacing the store
 */
var updateStore = function updateStore(obj) {
  props = obj;
};

/**
 * Responsible for clearing or wiping out a store.
 */
var clearStore = function clearStore() {
  props = {};
};

/**
 * Responsible for obtaining a value from a store of properties. It will accept
 * a defaultValue if no value is found in the store. To ensure safety in
 * obtaining a value, the name takes a string in dot notation in order of
 * object nesting.
 *
 * @example
 * get('character');
 * get('character.bowls.onShabbos');
 * get('character.bowls.onShabbos', true);
 * @param {string} name - Property name looked up
 * @param {string} defaultValue - Provided if no property exists
 * @return {*} The value coming from the store
 */
var get = function get(name, defaultValue) {
  if (__WEBPACK_IMPORTED_MODULE_0_lodash_isUndefined___default()(name)) {
    throw new Error('A property name is required when getting a property value');
  }
  /**
   * props represents window.rcProps
   * checks for if name has rcProps and removes it
   */
  var rcPropsPrefix = 'rcProps.';
  var nameHasRCProps = name.indexOf(rcPropsPrefix) === 0;
  var finalName = nameHasRCProps ? name.slice(rcPropsPrefix.length) : name;
  var value = __WEBPACK_IMPORTED_MODULE_1_lodash_property___default()(finalName)(props);
  if (!__WEBPACK_IMPORTED_MODULE_0_lodash_isUndefined___default()(value)) {
    return __WEBPACK_IMPORTED_MODULE_2_lodash_clone___default()(value);
  }
  return defaultValue;
};

/**
 * Responsible for setting a value in the store. In most cases, properties
 * will already be predefined, but this exists in case any properties need to
 * set dynamically or on demand. It will ensure that values overridden are
 * intentional by providing a flag.
 * @param {string} name - Property name used for setting
 * @param {*} value - The value of the property
 * @param {boolean} [override=false] - Allows a property to be overriden
 */
var set = function set(name, value) {
  var override = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  if (__WEBPACK_IMPORTED_MODULE_0_lodash_isUndefined___default()(name)) {
    throw new Error('A property name is required when setting a property');
  }
  if (__WEBPACK_IMPORTED_MODULE_0_lodash_isUndefined___default()(value)) {
    throw new Error('A property value is required when setting a property');
  }
  var existingValue = get(name);
  if (!__WEBPACK_IMPORTED_MODULE_0_lodash_isUndefined___default()(existingValue) && !override) {
    throw new Error('Cannot override an existing property. If this is intentional, then pass the override flag.');
  }
  props[name] = value;
};

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
/* eslint-disable */
/*
     _ _      _       _
 ___| (_) ___| | __  (_)___
/ __| | |/ __| |/ /  | / __|
\__ \ | | (__|   < _ | \__ \
|___/_|_|\___|_|\_(_)/ |___/
                   |__/

 Version: 1.8.1
  Author: Ken Wheeler
 Website: http://kenwheeler.github.io
    Docs: http://kenwheeler.github.io/slick
    Repo: http://github.com/kenwheeler/slick
  Issues: http://github.com/kenwheeler/slick/issues

 */
/* global window, document, define, jQuery, setInterval, clearInterval */
;
(function (factory) {
  'use strict';

  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== 'undefined') {
    module.exports = factory(require('jquery'));
  } else {
    factory(jQuery);
  }
})(function ($) {
  'use strict';

  var Slick = window.Slick || {};
  Slick = function () {
    var instanceUid = 0;
    function Slick(element, settings) {
      var _ = this,
        dataSettings;
      _.defaults = {
        accessibility: true,
        adaptiveHeight: false,
        appendArrows: $(element),
        appendDots: $(element),
        arrows: true,
        asNavFor: null,
        prevArrow: '<button class="slick-prev" aria-label="Previous" type="button">Previous</button>',
        nextArrow: '<button class="slick-next" aria-label="Next" type="button">Next</button>',
        autoplay: false,
        autoplaySpeed: 3000,
        centerMode: false,
        centerPadding: '50px',
        cssEase: 'ease',
        customPaging: function customPaging(slider, i) {
          return $('<button />').text(i + 1);
        },
        dots: false,
        dotsClass: 'slick-dots',
        draggable: true,
        easing: 'linear',
        edgeFriction: 0.35,
        fade: false,
        focusOnSelect: false,
        focusOnChange: false,
        infinite: true,
        initialSlide: 0,
        lazyLoad: 'ondemand',
        mobileFirst: false,
        pauseOnHover: true,
        pauseOnFocus: true,
        pauseOnDotsHover: false,
        respondTo: 'window',
        responsive: null,
        rows: 1,
        rtl: false,
        slide: '',
        slidesPerRow: 1,
        slidesToShow: 1,
        slidesToScroll: 1,
        speed: 500,
        swipe: true,
        swipeToSlide: false,
        touchMove: true,
        touchThreshold: 5,
        useCSS: true,
        useTransform: true,
        variableWidth: false,
        vertical: false,
        verticalSwiping: false,
        waitForAnimate: true,
        zIndex: 1000
      };
      _.initials = {
        animating: false,
        dragging: false,
        autoPlayTimer: null,
        currentDirection: 0,
        currentLeft: null,
        currentSlide: 0,
        direction: 1,
        $dots: null,
        listWidth: null,
        listHeight: null,
        loadIndex: 0,
        $nextArrow: null,
        $prevArrow: null,
        scrolling: false,
        slideCount: null,
        slideWidth: null,
        $slideTrack: null,
        $slides: null,
        sliding: false,
        slideOffset: 0,
        swipeLeft: null,
        swiping: false,
        $list: null,
        touchObject: {},
        transformsEnabled: false,
        unslicked: false
      };
      $.extend(_, _.initials);
      _.activeBreakpoint = null;
      _.animType = null;
      _.animProp = null;
      _.breakpoints = [];
      _.breakpointSettings = [];
      _.cssTransitions = false;
      _.focussed = false;
      _.interrupted = false;
      _.hidden = 'hidden';
      _.paused = true;
      _.positionProp = null;
      _.respondTo = null;
      _.rowCount = 1;
      _.shouldClick = true;
      _.$slider = $(element);
      _.$slidesCache = null;
      _.transformType = null;
      _.transitionType = null;
      _.visibilityChange = 'visibilitychange';
      _.windowWidth = 0;
      _.windowTimer = null;
      dataSettings = $(element).data('slick') || {};
      _.options = $.extend({}, _.defaults, settings, dataSettings);
      _.currentSlide = _.options.initialSlide;
      _.originalSettings = _.options;
      if (typeof document.mozHidden !== 'undefined') {
        _.hidden = 'mozHidden';
        _.visibilityChange = 'mozvisibilitychange';
      } else if (typeof document.webkitHidden !== 'undefined') {
        _.hidden = 'webkitHidden';
        _.visibilityChange = 'webkitvisibilitychange';
      }
      _.autoPlay = $.proxy(_.autoPlay, _);
      _.autoPlayClear = $.proxy(_.autoPlayClear, _);
      _.autoPlayIterator = $.proxy(_.autoPlayIterator, _);
      _.changeSlide = $.proxy(_.changeSlide, _);
      _.clickHandler = $.proxy(_.clickHandler, _);
      _.selectHandler = $.proxy(_.selectHandler, _);
      _.setPosition = $.proxy(_.setPosition, _);
      _.swipeHandler = $.proxy(_.swipeHandler, _);
      _.dragHandler = $.proxy(_.dragHandler, _);
      _.keyHandler = $.proxy(_.keyHandler, _);
      _.instanceUid = instanceUid++;

      // A simple way to check for HTML strings
      // Strict HTML recognition (must start with <)
      // Extracted from jQuery v1.11 source
      _.htmlExpr = /^(?:\s*(<[\w\W]+>)[^>]*)$/;
      _.registerBreakpoints();
      _.init(true);
    }
    return Slick;
  }();
  Slick.prototype.activateADA = function () {
    var _ = this;
    _.$slideTrack.find('.slick-active').attr({
      'aria-hidden': 'false'
    }).find('a, input, button, select').attr({
      'tabindex': '0'
    });
  };
  Slick.prototype.addSlide = Slick.prototype.slickAdd = function (markup, index, addBefore) {
    var _ = this;
    if (typeof index === 'boolean') {
      addBefore = index;
      index = null;
    } else if (index < 0 || index >= _.slideCount) {
      return false;
    }
    _.unload();
    if (typeof index === 'number') {
      if (index === 0 && _.$slides.length === 0) {
        $(markup).appendTo(_.$slideTrack);
      } else if (addBefore) {
        $(markup).insertBefore(_.$slides.eq(index));
      } else {
        $(markup).insertAfter(_.$slides.eq(index));
      }
    } else {
      if (addBefore === true) {
        $(markup).prependTo(_.$slideTrack);
      } else {
        $(markup).appendTo(_.$slideTrack);
      }
    }
    _.$slides = _.$slideTrack.children(this.options.slide);
    _.$slideTrack.children(this.options.slide).detach();
    _.$slideTrack.append(_.$slides);
    _.$slides.each(function (index, element) {
      $(element).attr('data-slick-index', index);
    });
    _.$slidesCache = _.$slides;
    _.reinit();
  };
  Slick.prototype.animateHeight = function () {
    var _ = this;
    if (_.options.slidesToShow === 1 && _.options.adaptiveHeight === true && _.options.vertical === false) {
      var targetHeight = _.$slides.eq(_.currentSlide).outerHeight(true);
      _.$list.animate({
        height: targetHeight
      }, _.options.speed);
    }
  };
  Slick.prototype.animateSlide = function (targetLeft, callback) {
    var animProps = {},
      _ = this;
    _.animateHeight();
    if (_.options.rtl === true && _.options.vertical === false) {
      targetLeft = -targetLeft;
    }
    if (_.transformsEnabled === false) {
      if (_.options.vertical === false) {
        _.$slideTrack.animate({
          left: targetLeft
        }, _.options.speed, _.options.easing, callback);
      } else {
        _.$slideTrack.animate({
          top: targetLeft
        }, _.options.speed, _.options.easing, callback);
      }
    } else {
      if (_.cssTransitions === false) {
        if (_.options.rtl === true) {
          _.currentLeft = -_.currentLeft;
        }
        $({
          animStart: _.currentLeft
        }).animate({
          animStart: targetLeft
        }, {
          duration: _.options.speed,
          easing: _.options.easing,
          step: function step(now) {
            now = Math.ceil(now);
            if (_.options.vertical === false) {
              animProps[_.animType] = 'translate(' + now + 'px, 0px)';
              _.$slideTrack.css(animProps);
            } else {
              animProps[_.animType] = 'translate(0px,' + now + 'px)';
              _.$slideTrack.css(animProps);
            }
          },
          complete: function complete() {
            if (callback) {
              callback.call();
            }
          }
        });
      } else {
        _.applyTransition();
        targetLeft = Math.ceil(targetLeft);
        if (_.options.vertical === false) {
          animProps[_.animType] = 'translate3d(' + targetLeft + 'px, 0px, 0px)';
        } else {
          animProps[_.animType] = 'translate3d(0px,' + targetLeft + 'px, 0px)';
        }
        _.$slideTrack.css(animProps);
        if (callback) {
          setTimeout(function () {
            _.disableTransition();
            callback.call();
          }, _.options.speed);
        }
      }
    }
  };
  Slick.prototype.getNavTarget = function () {
    var _ = this,
      asNavFor = _.options.asNavFor;
    if (asNavFor && asNavFor !== null) {
      asNavFor = $(asNavFor).not(_.$slider);
    }
    return asNavFor;
  };
  Slick.prototype.asNavFor = function (index) {
    var _ = this,
      asNavFor = _.getNavTarget();
    if (asNavFor !== null && _typeof(asNavFor) === 'object') {
      asNavFor.each(function () {
        var target = $(this).slick('getSlick');
        if (!target.unslicked) {
          target.slideHandler(index, true);
        }
      });
    }
  };
  Slick.prototype.applyTransition = function (slide) {
    var _ = this,
      transition = {};
    if (_.options.fade === false) {
      transition[_.transitionType] = _.transformType + ' ' + _.options.speed + 'ms ' + _.options.cssEase;
    } else {
      transition[_.transitionType] = 'opacity ' + _.options.speed + 'ms ' + _.options.cssEase;
    }
    if (_.options.fade === false) {
      _.$slideTrack.css(transition);
    } else {
      _.$slides.eq(slide).css(transition);
    }
  };
  Slick.prototype.autoPlay = function () {
    var _ = this;
    _.autoPlayClear();
    if (_.slideCount > _.options.slidesToShow) {
      _.autoPlayTimer = setInterval(_.autoPlayIterator, _.options.autoplaySpeed);
    }
  };
  Slick.prototype.autoPlayClear = function () {
    var _ = this;
    if (_.autoPlayTimer) {
      clearInterval(_.autoPlayTimer);
    }
  };
  Slick.prototype.autoPlayIterator = function () {
    var _ = this,
      slideTo = _.currentSlide + _.options.slidesToScroll;
    if (!_.paused && !_.interrupted && !_.focussed) {
      if (_.options.infinite === false) {
        if (_.direction === 1 && _.currentSlide + 1 === _.slideCount - 1) {
          _.direction = 0;
        } else if (_.direction === 0) {
          slideTo = _.currentSlide - _.options.slidesToScroll;
          if (_.currentSlide - 1 === 0) {
            _.direction = 1;
          }
        }
      }
      _.slideHandler(slideTo);
    }
  };
  Slick.prototype.buildArrows = function () {
    var _ = this;
    if (_.options.arrows === true) {
      _.$prevArrow = $(_.options.prevArrow).addClass('slick-arrow');
      _.$nextArrow = $(_.options.nextArrow).addClass('slick-arrow');
      if (_.slideCount > _.options.slidesToShow) {
        _.$prevArrow.removeClass('slick-hidden slick-disabled').removeAttr('aria-hidden tabindex');
        _.$nextArrow.removeClass('slick-hidden slick-disabled').removeAttr('aria-hidden tabindex');
        if (_.htmlExpr.test(_.options.prevArrow)) {
          _.$prevArrow.prependTo(_.options.appendArrows);
        }
        if (_.htmlExpr.test(_.options.nextArrow)) {
          _.$nextArrow.appendTo(_.options.appendArrows);
        }
        if (_.options.infinite !== true) {
          _.$prevArrow.addClass('slick-disabled').attr('aria-disabled', 'true');
        }
      } else {
        _.$prevArrow.add(_.$nextArrow).addClass('slick-hidden slick-disabled').attr({
          'aria-disabled': 'true',
          'tabindex': '-1'
        });
      }
    }
  };
  Slick.prototype.buildDots = function () {
    var _ = this,
      i,
      dot;
    if (_.options.dots === true && _.slideCount > _.options.slidesToShow) {
      _.$slider.addClass('slick-dotted');
      dot = $('<ul />').addClass(_.options.dotsClass);
      for (i = 0; i <= _.getDotCount(); i += 1) {
        dot.append($('<li />').append(_.options.customPaging.call(this, _, i)));
      }
      _.$dots = dot.appendTo(_.options.appendDots);
      _.$dots.find('li').first().addClass('slick-active');
    }
  };
  Slick.prototype.buildOut = function () {
    var _ = this;
    _.$slides = _.$slider.children(_.options.slide + ':not(.slick-cloned)').addClass('slick-slide');
    _.slideCount = _.$slides.length;
    _.$slides.each(function (index, element) {
      $(element).attr('data-slick-index', index).data('originalStyling', $(element).attr('style') || '');
    });
    _.$slider.addClass('slick-slider');
    _.$slideTrack = _.slideCount === 0 ? $('<ul class="slick-track"/>').appendTo(_.$slider) : _.$slides.wrapAll('<ul class="slick-track"/>').parent();
    _.$list = _.$slideTrack.wrap('<div class="slick-list"/>').parent();
    _.$slideTrack.css('opacity', 0);
    if (_.options.centerMode === true || _.options.swipeToSlide === true) {
      _.options.slidesToScroll = 1;
    }
    $('img[data-lazy]', _.$slider).not('[src]').addClass('slick-loading');
    _.setupInfinite();
    _.buildArrows();
    _.buildDots();
    _.updateDots();
    _.setSlideClasses(typeof _.currentSlide === 'number' ? _.currentSlide : 0);
    if (_.options.draggable === true) {
      _.$list.addClass('draggable');
    }
  };
  Slick.prototype.buildRows = function () {
    var _ = this,
      a,
      b,
      c,
      newSlides,
      numOfSlides,
      originalSlides,
      slidesPerSection;
    newSlides = document.createDocumentFragment();
    originalSlides = _.$slider.children();
    if (_.options.rows > 0) {
      slidesPerSection = _.options.slidesPerRow * _.options.rows;
      numOfSlides = Math.ceil(originalSlides.length / slidesPerSection);
      for (a = 0; a < numOfSlides; a++) {
        var slide = document.createElement('li');
        for (b = 0; b < _.options.rows; b++) {
          var row = document.createElement('div');
          for (c = 0; c < _.options.slidesPerRow; c++) {
            var target = a * slidesPerSection + (b * _.options.slidesPerRow + c);
            if (originalSlides.get(target)) {
              row.appendChild(originalSlides.get(target));
            }
          }
          slide.appendChild(row);
        }
        newSlides.appendChild(slide);
      }
      _.$slider.empty().append(newSlides);
      _.$slider.children().children().children().css({
        'width': 100 / _.options.slidesPerRow + '%',
        'display': 'inline-block'
      });
    }
  };
  Slick.prototype.checkResponsive = function (initial, forceUpdate) {
    var _ = this,
      breakpoint,
      targetBreakpoint,
      respondToWidth,
      triggerBreakpoint = false;
    var sliderWidth = _.$slider.width();
    var windowWidth = window.innerWidth || $(window).width();
    if (_.respondTo === 'window') {
      respondToWidth = windowWidth;
    } else if (_.respondTo === 'slider') {
      respondToWidth = sliderWidth;
    } else if (_.respondTo === 'min') {
      respondToWidth = Math.min(windowWidth, sliderWidth);
    }
    if (_.options.responsive && _.options.responsive.length && _.options.responsive !== null) {
      targetBreakpoint = null;
      for (breakpoint in _.breakpoints) {
        if (_.breakpoints.hasOwnProperty(breakpoint)) {
          if (_.originalSettings.mobileFirst === false) {
            if (respondToWidth < _.breakpoints[breakpoint]) {
              targetBreakpoint = _.breakpoints[breakpoint];
            }
          } else {
            if (respondToWidth > _.breakpoints[breakpoint]) {
              targetBreakpoint = _.breakpoints[breakpoint];
            }
          }
        }
      }
      if (targetBreakpoint !== null) {
        if (_.activeBreakpoint !== null) {
          if (targetBreakpoint !== _.activeBreakpoint || forceUpdate) {
            _.activeBreakpoint = targetBreakpoint;
            if (_.breakpointSettings[targetBreakpoint] === 'unslick') {
              _.unslick(targetBreakpoint);
            } else {
              _.options = $.extend({}, _.originalSettings, _.breakpointSettings[targetBreakpoint]);
              if (initial === true) {
                _.currentSlide = _.options.initialSlide;
              }
              _.refresh(initial);
            }
            triggerBreakpoint = targetBreakpoint;
          }
        } else {
          _.activeBreakpoint = targetBreakpoint;
          if (_.breakpointSettings[targetBreakpoint] === 'unslick') {
            _.unslick(targetBreakpoint);
          } else {
            _.options = $.extend({}, _.originalSettings, _.breakpointSettings[targetBreakpoint]);
            if (initial === true) {
              _.currentSlide = _.options.initialSlide;
            }
            _.refresh(initial);
          }
          triggerBreakpoint = targetBreakpoint;
        }
      } else {
        if (_.activeBreakpoint !== null) {
          _.activeBreakpoint = null;
          _.options = _.originalSettings;
          if (initial === true) {
            _.currentSlide = _.options.initialSlide;
          }
          _.refresh(initial);
          triggerBreakpoint = targetBreakpoint;
        }
      }

      // only trigger breakpoints during an actual break. not on initialize.
      if (!initial && triggerBreakpoint !== false) {
        _.$slider.trigger('breakpoint', [_, triggerBreakpoint]);
      }
    }
  };
  Slick.prototype.changeSlide = function (event, dontAnimate) {
    var _ = this,
      $target = $(event.currentTarget),
      indexOffset,
      slideOffset,
      unevenOffset;

    // If target is a link, prevent default action.
    if ($target.is('a')) {
      event.preventDefault();
    }

    // If target is not the <li> element (ie: a child), find the <li>.
    if (!$target.is('li')) {
      $target = $target.closest('li');
    }
    unevenOffset = _.slideCount % _.options.slidesToScroll !== 0;
    indexOffset = unevenOffset ? 0 : (_.slideCount - _.currentSlide) % _.options.slidesToScroll;
    switch (event.data.message) {
      case 'previous':
        slideOffset = indexOffset === 0 ? _.options.slidesToScroll : _.options.slidesToShow - indexOffset;
        if (_.slideCount > _.options.slidesToShow) {
          _.slideHandler(_.currentSlide - slideOffset, false, dontAnimate);
        }
        break;
      case 'next':
        slideOffset = indexOffset === 0 ? _.options.slidesToScroll : indexOffset;
        if (_.slideCount > _.options.slidesToShow) {
          _.slideHandler(_.currentSlide + slideOffset, false, dontAnimate);
        }
        break;
      case 'index':
        var index = event.data.index === 0 ? 0 : event.data.index || $target.index() * _.options.slidesToScroll;
        _.slideHandler(_.checkNavigable(index), false, dontAnimate);
        $target.children().trigger('focus');
        break;
      default:
        return;
    }
  };
  Slick.prototype.checkNavigable = function (index) {
    var _ = this,
      navigables,
      prevNavigable;
    navigables = _.getNavigableIndexes();
    prevNavigable = 0;
    if (index > navigables[navigables.length - 1]) {
      index = navigables[navigables.length - 1];
    } else {
      for (var n in navigables) {
        if (index < navigables[n]) {
          index = prevNavigable;
          break;
        }
        prevNavigable = navigables[n];
      }
    }
    return index;
  };
  Slick.prototype.cleanUpEvents = function () {
    var _ = this;
    if (_.options.dots && _.$dots !== null) {
      $('li', _.$dots).off('click.slick', _.changeSlide).off('mouseenter.slick', $.proxy(_.interrupt, _, true)).off('mouseleave.slick', $.proxy(_.interrupt, _, false));
      if (_.options.accessibility === true) {
        _.$dots.off('keydown.slick', _.keyHandler);
      }
    }
    _.$slider.off('focus.slick blur.slick');
    if (_.options.arrows === true && _.slideCount > _.options.slidesToShow) {
      _.$prevArrow && _.$prevArrow.off('click.slick', _.changeSlide);
      _.$nextArrow && _.$nextArrow.off('click.slick', _.changeSlide);
      if (_.options.accessibility === true) {
        _.$prevArrow && _.$prevArrow.off('keydown.slick', _.keyHandler);
        _.$nextArrow && _.$nextArrow.off('keydown.slick', _.keyHandler);
      }
    }
    _.$list.off('touchstart.slick mousedown.slick', _.swipeHandler);
    _.$list.off('touchmove.slick mousemove.slick', _.swipeHandler);
    _.$list.off('touchend.slick mouseup.slick', _.swipeHandler);
    _.$list.off('touchcancel.slick mouseleave.slick', _.swipeHandler);
    _.$list.off('click.slick', _.clickHandler);
    $(document).off(_.visibilityChange, _.visibility);
    _.cleanUpSlideEvents();
    if (_.options.accessibility === true) {
      _.$list.off('keydown.slick', _.keyHandler);
    }
    if (_.options.focusOnSelect === true) {
      $(_.$slideTrack).children().off('click.slick', _.selectHandler);
    }
    $(window).off('orientationchange.slick.slick-' + _.instanceUid, _.orientationChange);
    $(window).off('resize.slick.slick-' + _.instanceUid, _.resize);
    $('[draggable!=true]', _.$slideTrack).off('dragstart', _.preventDefault);
    $(window).off('load.slick.slick-' + _.instanceUid, _.setPosition);
  };
  Slick.prototype.cleanUpSlideEvents = function () {
    var _ = this;
    _.$list.off('mouseenter.slick', $.proxy(_.interrupt, _, true));
    _.$list.off('mouseleave.slick', $.proxy(_.interrupt, _, false));
  };
  Slick.prototype.cleanUpRows = function () {
    var _ = this,
      originalSlides;
    if (_.options.rows > 0) {
      originalSlides = _.$slides.children().children();
      originalSlides.removeAttr('style');
      _.$slider.empty().append(originalSlides);
    }
  };
  Slick.prototype.clickHandler = function (event) {
    var _ = this;
    if (_.shouldClick === false) {
      event.stopImmediatePropagation();
      event.stopPropagation();
      event.preventDefault();
    }
  };
  Slick.prototype.destroy = function (refresh) {
    var _ = this;
    _.autoPlayClear();
    _.touchObject = {};
    _.cleanUpEvents();
    $('.slick-cloned', _.$slider).detach();
    if (_.$dots) {
      _.$dots.remove();
    }
    if (_.$prevArrow && _.$prevArrow.length) {
      _.$prevArrow.removeClass('slick-disabled slick-arrow slick-hidden').removeAttr('aria-hidden aria-disabled tabindex').css('display', '');
      if (_.htmlExpr.test(_.options.prevArrow)) {
        _.$prevArrow.remove();
      }
    }
    if (_.$nextArrow && _.$nextArrow.length) {
      _.$nextArrow.removeClass('slick-disabled slick-arrow slick-hidden').removeAttr('aria-hidden aria-disabled tabindex').css('display', '');
      if (_.htmlExpr.test(_.options.nextArrow)) {
        _.$nextArrow.remove();
      }
    }
    if (_.$slides) {
      _.$slides.removeClass('slick-slide slick-active slick-center slick-visible slick-current').removeAttr('aria-hidden').removeAttr('data-slick-index').each(function () {
        $(this).attr('style', $(this).data('originalStyling'));
      });
      _.$slideTrack.children(this.options.slide).detach();
      _.$slideTrack.detach();
      _.$list.detach();
      _.$slider.append(_.$slides);
    }
    _.cleanUpRows();
    _.$slider.removeClass('slick-slider');
    _.$slider.removeClass('slick-initialized');
    _.$slider.removeClass('slick-dotted');
    _.unslicked = true;
    if (!refresh) {
      _.$slider.trigger('destroy', [_]);
    }
  };
  Slick.prototype.disableTransition = function (slide) {
    var _ = this,
      transition = {};
    transition[_.transitionType] = '';
    if (_.options.fade === false) {
      _.$slideTrack.css(transition);
    } else {
      _.$slides.eq(slide).css(transition);
    }
  };
  Slick.prototype.fadeSlide = function (slideIndex, callback) {
    var _ = this;
    if (_.cssTransitions === false) {
      _.$slides.eq(slideIndex).css({
        zIndex: _.options.zIndex
      });
      _.$slides.eq(slideIndex).animate({
        opacity: 1
      }, _.options.speed, _.options.easing, callback);
    } else {
      _.applyTransition(slideIndex);
      _.$slides.eq(slideIndex).css({
        opacity: 1,
        zIndex: _.options.zIndex
      });
      if (callback) {
        setTimeout(function () {
          _.disableTransition(slideIndex);
          callback.call();
        }, _.options.speed);
      }
    }
  };
  Slick.prototype.fadeSlideOut = function (slideIndex) {
    var _ = this;
    if (_.cssTransitions === false) {
      _.$slides.eq(slideIndex).animate({
        opacity: 0,
        zIndex: _.options.zIndex - 2
      }, _.options.speed, _.options.easing);
    } else {
      _.applyTransition(slideIndex);
      _.$slides.eq(slideIndex).css({
        opacity: 0,
        zIndex: _.options.zIndex - 2
      });
    }
  };
  Slick.prototype.filterSlides = Slick.prototype.slickFilter = function (filter) {
    var _ = this;
    if (filter !== null) {
      _.$slidesCache = _.$slides;
      _.unload();
      _.$slideTrack.children(this.options.slide).detach();
      _.$slidesCache.filter(filter).appendTo(_.$slideTrack);
      _.reinit();
    }
  };
  Slick.prototype.focusHandler = function () {
    var _ = this;
    _.$slider.off('focus.slick blur.slick').on('focus.slick blur.slick', '*', function (event) {
      event.stopImmediatePropagation();
      var $sf = $(this);
      setTimeout(function () {
        if (_.options.pauseOnFocus) {
          _.focussed = $sf.is(':focus');
          _.autoPlay();
        }
      }, 0);
    });
  };
  Slick.prototype.getCurrent = Slick.prototype.slickCurrentSlide = function () {
    var _ = this;
    return _.currentSlide;
  };
  Slick.prototype.getDotCount = function () {
    var _ = this;
    var breakPoint = 0;
    var counter = 0;
    var pagerQty = 0;
    if (_.options.infinite === true) {
      if (_.slideCount <= _.options.slidesToShow) {
        ++pagerQty;
      } else {
        while (breakPoint < _.slideCount) {
          ++pagerQty;
          breakPoint = counter + _.options.slidesToScroll;
          counter += _.options.slidesToScroll <= _.options.slidesToShow ? _.options.slidesToScroll : _.options.slidesToShow;
        }
      }
    } else if (_.options.centerMode === true) {
      pagerQty = _.slideCount;
    } else if (!_.options.asNavFor) {
      pagerQty = 1 + Math.ceil((_.slideCount - _.options.slidesToShow) / _.options.slidesToScroll);
    } else {
      while (breakPoint < _.slideCount) {
        ++pagerQty;
        breakPoint = counter + _.options.slidesToScroll;
        counter += _.options.slidesToScroll <= _.options.slidesToShow ? _.options.slidesToScroll : _.options.slidesToShow;
      }
    }
    return pagerQty - 1;
  };
  Slick.prototype.getLeft = function (slideIndex) {
    var _ = this,
      targetLeft,
      verticalHeight,
      verticalOffset = 0,
      targetSlide,
      coef;
    _.slideOffset = 0;
    verticalHeight = _.$slides.first().outerHeight(true);
    if (_.options.infinite === true) {
      if (_.slideCount > _.options.slidesToShow) {
        _.slideOffset = _.slideWidth * _.options.slidesToShow * -1;
        coef = -1;
        if (_.options.vertical === true && _.options.centerMode === true) {
          if (_.options.slidesToShow === 2) {
            coef = -1.5;
          } else if (_.options.slidesToShow === 1) {
            coef = -2;
          }
        }
        verticalOffset = verticalHeight * _.options.slidesToShow * coef;
      }
      if (_.slideCount % _.options.slidesToScroll !== 0) {
        if (slideIndex + _.options.slidesToScroll > _.slideCount && _.slideCount > _.options.slidesToShow) {
          if (slideIndex > _.slideCount) {
            _.slideOffset = (_.options.slidesToShow - (slideIndex - _.slideCount)) * _.slideWidth * -1;
            verticalOffset = (_.options.slidesToShow - (slideIndex - _.slideCount)) * verticalHeight * -1;
          } else {
            _.slideOffset = _.slideCount % _.options.slidesToScroll * _.slideWidth * -1;
            verticalOffset = _.slideCount % _.options.slidesToScroll * verticalHeight * -1;
          }
        }
      }
    } else {
      if (slideIndex + _.options.slidesToShow > _.slideCount) {
        _.slideOffset = (slideIndex + _.options.slidesToShow - _.slideCount) * _.slideWidth;
        verticalOffset = (slideIndex + _.options.slidesToShow - _.slideCount) * verticalHeight;
      }
    }
    if (_.slideCount <= _.options.slidesToShow) {
      _.slideOffset = 0;
      verticalOffset = 0;
    }
    if (_.options.centerMode === true && _.slideCount <= _.options.slidesToShow) {
      _.slideOffset = _.slideWidth * Math.floor(_.options.slidesToShow) / 2 - _.slideWidth * _.slideCount / 2;
    } else if (_.options.centerMode === true && _.options.infinite === true) {
      _.slideOffset += _.slideWidth * Math.floor(_.options.slidesToShow / 2) - _.slideWidth;
    } else if (_.options.centerMode === true) {
      _.slideOffset = 0;
      _.slideOffset += _.slideWidth * Math.floor(_.options.slidesToShow / 2);
    }
    if (_.options.vertical === false) {
      targetLeft = slideIndex * _.slideWidth * -1 + _.slideOffset;
    } else {
      targetLeft = slideIndex * verticalHeight * -1 + verticalOffset;
    }
    if (_.options.variableWidth === true) {
      if (_.slideCount <= _.options.slidesToShow || _.options.infinite === false) {
        targetSlide = _.$slideTrack.children('.slick-slide').eq(slideIndex);
      } else {
        targetSlide = _.$slideTrack.children('.slick-slide').eq(slideIndex + _.options.slidesToShow);
      }
      if (_.options.rtl === true) {
        if (targetSlide[0]) {
          targetLeft = (_.$slideTrack.width() - targetSlide[0].offsetLeft - targetSlide.width()) * -1;
        } else {
          targetLeft = 0;
        }
      } else {
        targetLeft = targetSlide[0] ? targetSlide[0].offsetLeft * -1 : 0;
      }
      if (_.options.centerMode === true) {
        if (_.slideCount <= _.options.slidesToShow || _.options.infinite === false) {
          targetSlide = _.$slideTrack.children('.slick-slide').eq(slideIndex);
        } else {
          targetSlide = _.$slideTrack.children('.slick-slide').eq(slideIndex + _.options.slidesToShow + 1);
        }
        if (_.options.rtl === true) {
          if (targetSlide[0]) {
            targetLeft = (_.$slideTrack.width() - targetSlide[0].offsetLeft - targetSlide.width()) * -1;
          } else {
            targetLeft = 0;
          }
        } else {
          targetLeft = targetSlide[0] ? targetSlide[0].offsetLeft * -1 : 0;
        }
        targetLeft += (_.$list.width() - targetSlide.outerWidth()) / 2;
      }
    }
    return targetLeft;
  };
  Slick.prototype.getOption = Slick.prototype.slickGetOption = function (option) {
    var _ = this;
    return _.options[option];
  };
  Slick.prototype.getNavigableIndexes = function () {
    var _ = this,
      breakPoint = 0,
      counter = 0,
      indexes = [],
      max;
    if (_.options.infinite === false) {
      max = _.slideCount;
    } else {
      breakPoint = _.options.slidesToScroll * -1;
      counter = _.options.slidesToScroll * -1;
      max = _.slideCount * 2;
    }
    while (breakPoint < max) {
      indexes.push(breakPoint);
      breakPoint = counter + _.options.slidesToScroll;
      counter += _.options.slidesToScroll <= _.options.slidesToShow ? _.options.slidesToScroll : _.options.slidesToShow;
    }
    return indexes;
  };
  Slick.prototype.getSlick = function () {
    return this;
  };
  Slick.prototype.getSlideCount = function () {
    var _ = this,
      slidesTraversed,
      swipedSlide,
      centerOffset;
    centerOffset = _.options.centerMode === true ? _.slideWidth * Math.floor(_.options.slidesToShow / 2) : 0;
    if (_.options.swipeToSlide === true) {
      _.$slideTrack.find('.slick-slide').each(function (index, slide) {
        if (slide.offsetLeft - centerOffset + $(slide).outerWidth() / 2 > _.swipeLeft * -1) {
          swipedSlide = slide;
          return false;
        }
      });
      slidesTraversed = Math.abs($(swipedSlide).attr('data-slick-index') - _.currentSlide) || 1;
      return slidesTraversed;
    } else {
      return _.options.slidesToScroll;
    }
  };
  Slick.prototype.goTo = Slick.prototype.slickGoTo = function (slide, dontAnimate) {
    var _ = this;
    _.changeSlide({
      data: {
        message: 'index',
        index: parseInt(slide)
      }
    }, dontAnimate);
  };
  Slick.prototype.init = function (creation) {
    var _ = this;
    if (!$(_.$slider).hasClass('slick-initialized')) {
      $(_.$slider).addClass('slick-initialized');
      _.buildRows();
      _.buildOut();
      _.setProps();
      _.startLoad();
      _.loadSlider();
      _.initializeEvents();
      _.updateArrows();
      _.updateDots();
      _.checkResponsive(true);
      _.focusHandler();
    }
    if (creation) {
      _.$slider.trigger('init', [_]);
    }
    if (_.options.accessibility === true) {
      _.initADA();
    }
    if (_.options.autoplay) {
      _.paused = false;
      _.autoPlay();
    }
  };
  Slick.prototype.initADA = function () {
    var _ = this,
      numDotGroups = Math.ceil(_.slideCount / _.options.slidesToShow),
      tabControlIndexes = _.getNavigableIndexes().filter(function (val) {
        return val >= 0 && val < _.slideCount;
      });
    _.$slides.add(_.$slideTrack.find('.slick-cloned')).attr({
      'aria-hidden': 'true',
      'tabindex': '-1'
    }).find('a, input, button, select').attr({
      'tabindex': '-1'
    });
    if (_.$dots !== null) {
      _.$slides.not(_.$slideTrack.find('.slick-cloned')).each(function (i) {
        var slideControlIndex = tabControlIndexes.indexOf(i);
        $(this).attr({
          'role': 'presentation',
          'id': 'slick-slide' + _.instanceUid + i,
          'tabindex': -1
        });
        if (slideControlIndex !== -1) {
          var ariaButtonControl = 'slick-slide-control' + _.instanceUid + slideControlIndex;
          if ($('#' + ariaButtonControl).length) {
            $(this).attr({
              'aria-describedby': ariaButtonControl
            });
          }
        }
      });
      _.$dots.attr('role', 'tablist').find('li').each(function (i) {
        var mappedSlideIndex = tabControlIndexes[i];
        $(this).attr({
          'role': 'presentation'
        });
        $(this).find('button').first().attr({
          'id': 'slick-slide-control' + _.instanceUid + i,
          'aria-controls': 'slick-slide' + _.instanceUid + mappedSlideIndex,
          'aria-label': i + 1 + ' of ' + numDotGroups,
          'aria-selected': null
        });
      }).eq(_.currentSlide).find('button').attr({
        'aria-selected': 'true',
        'tabindex': '0'
      }).end();
    }
    for (var i = _.currentSlide, max = i + _.options.slidesToShow; i < max; i++) {
      if (_.options.focusOnChange) {
        // UX-16985 - Check for focusable element
        var $focusableSlide = $(_.$slides.eq(i));
        var $focusableSlideElement = $focusableSlide.find('a, button');
        if ($focusableSlideElement) {
          // if slide has a focusable child element then remove tabindex
          $focusableSlide.removeAttr('tabindex');
        } else {
          // if slide does NOT have a focusable child element then add tabindex 0
          $focusableSlide.attr({
            'tabindex': '0'
          });
        }
      } else {
        _.$slides.eq(i).removeAttr('tabindex');
      }
    }
    _.activateADA();
  };
  Slick.prototype.initArrowEvents = function () {
    var _ = this;
    if (_.options.arrows === true && _.slideCount > _.options.slidesToShow) {
      _.$prevArrow.off('click.slick').on('click.slick', {
        message: 'previous'
      }, _.changeSlide);
      _.$nextArrow.off('click.slick').on('click.slick', {
        message: 'next'
      }, _.changeSlide);
      if (_.options.accessibility === true) {
        _.$prevArrow.on('keydown.slick', _.keyHandler);
        _.$nextArrow.on('keydown.slick', _.keyHandler);
      }
    }
  };
  Slick.prototype.initDotEvents = function () {
    var _ = this;
    if (_.options.dots === true && _.slideCount > _.options.slidesToShow) {
      $('li', _.$dots).on('click.slick', {
        message: 'index'
      }, _.changeSlide);
      // if (_.options.accessibility === true) {
      //     _.$dots.on('keydown.slick', _.keyHandler);
      // }
    }
    if (_.options.dots === true && _.options.pauseOnDotsHover === true && _.slideCount > _.options.slidesToShow) {
      $('li', _.$dots).on('mouseenter.slick', $.proxy(_.interrupt, _, true)).on('mouseleave.slick', $.proxy(_.interrupt, _, false));
    }
  };
  Slick.prototype.initSlideEvents = function () {
    var _ = this;
    if (_.options.pauseOnHover) {
      _.$list.on('mouseenter.slick', $.proxy(_.interrupt, _, true));
      _.$list.on('mouseleave.slick', $.proxy(_.interrupt, _, false));
    }
  };
  Slick.prototype.initializeEvents = function () {
    var _ = this;
    _.initArrowEvents();
    _.initDotEvents();
    _.initSlideEvents();
    _.$list.on('touchstart.slick mousedown.slick', {
      action: 'start'
    }, _.swipeHandler);
    _.$list.on('touchmove.slick mousemove.slick', {
      action: 'move'
    }, _.swipeHandler);
    _.$list.on('touchend.slick mouseup.slick', {
      action: 'end'
    }, _.swipeHandler);
    _.$list.on('touchcancel.slick mouseleave.slick', {
      action: 'end'
    }, _.swipeHandler);
    _.$list.on('click.slick', _.clickHandler);
    $(document).on(_.visibilityChange, $.proxy(_.visibility, _));
    if (_.options.accessibility === true) {
      _.$list.on('keydown.slick', _.keyHandler);
    }
    if (_.options.focusOnSelect === true) {
      $(_.$slideTrack).children().on('click.slick', _.selectHandler);
    }
    $(window).on('orientationchange.slick.slick-' + _.instanceUid, $.proxy(_.orientationChange, _));
    $(window).on('resize.slick.slick-' + _.instanceUid, $.proxy(_.resize, _));
    $('[draggable!=true]', _.$slideTrack).on('dragstart', _.preventDefault);
    $(window).on('load.slick.slick-' + _.instanceUid, _.setPosition);
    $(_.setPosition);
  };
  Slick.prototype.initUI = function () {
    var _ = this;
    if (_.options.arrows === true && _.slideCount > _.options.slidesToShow) {
      _.$prevArrow.show();
      _.$nextArrow.show();
    }
    if (_.options.dots === true && _.slideCount > _.options.slidesToShow) {
      _.$dots.show();
    }
  };
  Slick.prototype.keyHandler = function (event) {
    var _ = this;
    //Dont slide if the cursor is inside the form fields and arrow keys are pressed
    if (!event.target.tagName.match('TEXTAREA|INPUT|SELECT')) {
      if (event.keyCode === 37 && _.options.accessibility === true) {
        _.changeSlide({
          data: {
            message: _.options.rtl === true ? 'next' : 'previous'
          }
        });
      } else if (event.keyCode === 39 && _.options.accessibility === true) {
        _.changeSlide({
          data: {
            message: _.options.rtl === true ? 'previous' : 'next'
          }
        });
      }
    }
  };
  Slick.prototype.lazyLoad = function () {
    var _ = this,
      loadRange,
      cloneRange,
      rangeStart,
      rangeEnd;
    function loadImages(imagesScope) {
      $('img[data-lazy]', imagesScope).each(function () {
        var image = $(this),
          imageSource = $(this).attr('data-lazy'),
          imageSrcSet = $(this).attr('data-srcset'),
          imageSizes = $(this).attr('data-sizes') || _.$slider.attr('data-sizes'),
          imageToLoad = document.createElement('img');
        imageToLoad.onload = function () {
          image.animate({
            opacity: 0
          }, 100, function () {
            if (imageSrcSet) {
              image.attr('srcset', imageSrcSet);
              if (imageSizes) {
                image.attr('sizes', imageSizes);
              }
            }
            image.attr('src', imageSource).animate({
              opacity: 1
            }, 200, function () {
              image.removeAttr('data-lazy data-srcset data-sizes').removeClass('slick-loading');
            });
            _.$slider.trigger('lazyLoaded', [_, image, imageSource]);
          });
        };
        imageToLoad.onerror = function () {
          image.removeAttr('data-lazy').removeClass('slick-loading').addClass('slick-lazyload-error');
          _.$slider.trigger('lazyLoadError', [_, image, imageSource]);
        };
        if (imageSrcSet) {
          imageToLoad.srcset = imageSrcSet;
        }
        imageToLoad.src = imageSource;
      });
    }
    if (_.options.centerMode === true) {
      if (_.options.infinite === true) {
        rangeStart = _.currentSlide + (_.options.slidesToShow / 2 + 1);
        rangeEnd = rangeStart + _.options.slidesToShow + 2;
      } else {
        rangeStart = Math.max(0, _.currentSlide - (_.options.slidesToShow / 2 + 1));
        rangeEnd = 2 + (_.options.slidesToShow / 2 + 1) + _.currentSlide;
      }
    } else {
      rangeStart = _.options.infinite ? _.options.slidesToShow + _.currentSlide : _.currentSlide;
      rangeEnd = Math.ceil(rangeStart + _.options.slidesToShow);
      if (_.options.fade === true) {
        if (rangeStart > 0) rangeStart--;
        if (rangeEnd <= _.slideCount) rangeEnd++;
      }
    }
    loadRange = _.$slider.find('.slick-slide').slice(rangeStart, rangeEnd);
    if (_.options.lazyLoad === 'anticipated') {
      var prevSlide = rangeStart - 1,
        nextSlide = rangeEnd,
        $slides = _.$slider.find('.slick-slide');
      for (var i = 0; i < _.options.slidesToScroll; i++) {
        if (prevSlide < 0) prevSlide = _.slideCount - 1;
        loadRange = loadRange.add($slides.eq(prevSlide));
        loadRange = loadRange.add($slides.eq(nextSlide));
        prevSlide--;
        nextSlide++;
      }
    }
    loadImages(loadRange);
    if (_.slideCount <= _.options.slidesToShow) {
      cloneRange = _.$slider.find('.slick-slide');
      loadImages(cloneRange);
    } else if (_.currentSlide >= _.slideCount - _.options.slidesToShow) {
      cloneRange = _.$slider.find('.slick-cloned').slice(0, _.options.slidesToShow);
      loadImages(cloneRange);
    } else if (_.currentSlide === 0) {
      cloneRange = _.$slider.find('.slick-cloned').slice(_.options.slidesToShow * -1);
      loadImages(cloneRange);
    }
  };
  Slick.prototype.loadSlider = function () {
    var _ = this;
    _.setPosition();
    _.$slideTrack.css({
      opacity: 1
    });
    _.$slider.removeClass('slick-loading');
    _.initUI();
    if (_.options.lazyLoad === 'progressive') {
      _.progressiveLazyLoad();
    }
  };
  Slick.prototype.next = Slick.prototype.slickNext = function () {
    var _ = this;
    _.changeSlide({
      data: {
        message: 'next'
      }
    });
  };
  Slick.prototype.orientationChange = function () {
    var _ = this;
    _.checkResponsive();
    _.setPosition();
  };
  Slick.prototype.pause = Slick.prototype.slickPause = function () {
    var _ = this;
    _.autoPlayClear();
    _.paused = true;
  };
  Slick.prototype.play = Slick.prototype.slickPlay = function () {
    var _ = this;
    _.autoPlay();
    _.options.autoplay = true;
    _.paused = false;
    _.focussed = false;
    _.interrupted = false;
  };
  Slick.prototype.postSlide = function (index) {
    var _ = this;
    if (!_.unslicked) {
      _.$slider.trigger('afterChange', [_, index]);
      _.animating = false;
      if (_.slideCount > _.options.slidesToShow) {
        _.setPosition();
      }
      _.swipeLeft = null;
      if (_.options.autoplay) {
        _.autoPlay();
      }
      if (_.options.accessibility === true) {
        _.initADA();
        if (_.options.focusOnChange) {
          // UX-16985 - Check for focusable element
          var $currentSlide = $(_.$slides.get(_.currentSlide));
          $currentSlide.attr('tabindex', -1);
          // if currentSlide has a focusable child element then focus on clickable element
          var $currentSlideAnchor = $currentSlide.find('a, button');
          if ($currentSlideAnchor) {
            $currentSlideAnchor.focus();
          } else {
            // if currentSlide does NOT have a focusable child element then keep focus on current slide
            $currentSlide.focus();
          }
        }
      }
    }
  };
  Slick.prototype.prev = Slick.prototype.slickPrev = function () {
    var _ = this;
    _.changeSlide({
      data: {
        message: 'previous'
      }
    });
  };
  Slick.prototype.preventDefault = function (event) {
    event.preventDefault();
  };
  Slick.prototype.progressiveLazyLoad = function (tryCount) {
    tryCount = tryCount || 1;
    var _ = this,
      $imgsToLoad = $('img[data-lazy]', _.$slider),
      image,
      imageSource,
      imageSrcSet,
      imageSizes,
      imageToLoad;
    if ($imgsToLoad.length) {
      image = $imgsToLoad.first();
      imageSource = image.attr('data-lazy');
      imageSrcSet = image.attr('data-srcset');
      imageSizes = image.attr('data-sizes') || _.$slider.attr('data-sizes');
      imageToLoad = document.createElement('img');
      imageToLoad.onload = function () {
        if (imageSrcSet) {
          image.attr('srcset', imageSrcSet);
          if (imageSizes) {
            image.attr('sizes', imageSizes);
          }
        }
        image.attr('src', imageSource).removeAttr('data-lazy data-srcset data-sizes').removeClass('slick-loading');
        if (_.options.adaptiveHeight === true) {
          _.setPosition();
        }
        _.$slider.trigger('lazyLoaded', [_, image, imageSource]);
        _.progressiveLazyLoad();
      };
      imageToLoad.onerror = function () {
        if (tryCount < 3) {
          /**
           * try to load the image 3 times,
           * leave a slight delay so we don't get
           * servers blocking the request.
           */
          setTimeout(function () {
            _.progressiveLazyLoad(tryCount + 1);
          }, 500);
        } else {
          image.removeAttr('data-lazy').removeClass('slick-loading').addClass('slick-lazyload-error');
          _.$slider.trigger('lazyLoadError', [_, image, imageSource]);
          _.progressiveLazyLoad();
        }
      };
      if (imageSrcSet) {
        imageToLoad.srcset = imageSrcSet;
      }
      imageToLoad.src = imageSource;
    } else {
      _.$slider.trigger('allImagesLoaded', [_]);
    }
  };
  Slick.prototype.refresh = function (initializing) {
    var _ = this,
      currentSlide,
      lastVisibleIndex;
    lastVisibleIndex = _.slideCount - _.options.slidesToShow;

    // in non-infinite sliders, we don't want to go past the
    // last visible index.
    if (!_.options.infinite && _.currentSlide > lastVisibleIndex) {
      _.currentSlide = lastVisibleIndex;
    }

    // if less slides than to show, go to start.
    if (_.slideCount <= _.options.slidesToShow) {
      _.currentSlide = 0;
    }
    currentSlide = _.currentSlide;
    _.destroy(true);
    $.extend(_, _.initials, {
      currentSlide: currentSlide
    });
    _.init();
    if (!initializing) {
      _.changeSlide({
        data: {
          message: 'index',
          index: currentSlide
        }
      }, false);
    }
  };
  Slick.prototype.registerBreakpoints = function () {
    var _ = this,
      breakpoint,
      currentBreakpoint,
      l,
      responsiveSettings = _.options.responsive || null;
    if ($.type(responsiveSettings) === 'array' && responsiveSettings.length) {
      _.respondTo = _.options.respondTo || 'window';
      for (breakpoint in responsiveSettings) {
        l = _.breakpoints.length - 1;
        if (responsiveSettings.hasOwnProperty(breakpoint)) {
          currentBreakpoint = responsiveSettings[breakpoint].breakpoint;

          // loop through the breakpoints and cut out any existing
          // ones with the same breakpoint number, we don't want dupes.
          while (l >= 0) {
            if (_.breakpoints[l] && _.breakpoints[l] === currentBreakpoint) {
              _.breakpoints.splice(l, 1);
            }
            l--;
          }
          _.breakpoints.push(currentBreakpoint);
          _.breakpointSettings[currentBreakpoint] = responsiveSettings[breakpoint].settings;
        }
      }
      _.breakpoints.sort(function (a, b) {
        return _.options.mobileFirst ? a - b : b - a;
      });
    }
  };
  Slick.prototype.reinit = function () {
    var _ = this;
    _.$slides = _.$slideTrack.children(_.options.slide).addClass('slick-slide');
    _.slideCount = _.$slides.length;
    if (_.currentSlide >= _.slideCount && _.currentSlide !== 0) {
      _.currentSlide = _.currentSlide - _.options.slidesToScroll;
    }
    if (_.slideCount <= _.options.slidesToShow) {
      _.currentSlide = 0;
    }
    _.registerBreakpoints();
    _.setProps();
    _.setupInfinite();
    _.buildArrows();
    _.updateArrows();
    _.initArrowEvents();
    _.buildDots();
    _.updateDots();
    _.initDotEvents();
    _.cleanUpSlideEvents();
    _.initSlideEvents();
    _.checkResponsive(false, true);
    if (_.options.focusOnSelect === true) {
      $(_.$slideTrack).children().on('click.slick', _.selectHandler);
    }
    _.setSlideClasses(typeof _.currentSlide === 'number' ? _.currentSlide : 0);
    _.setPosition();
    _.focusHandler();
    _.paused = !_.options.autoplay;
    _.autoPlay();
    _.$slider.trigger('reInit', [_]);
  };
  Slick.prototype.resize = function () {
    var _ = this;
    if ($(window).width() !== _.windowWidth) {
      clearTimeout(_.windowDelay);
      _.windowDelay = window.setTimeout(function () {
        _.windowWidth = $(window).width();
        _.checkResponsive();
        if (!_.unslicked) {
          _.setPosition();
        }
      }, 50);
    }
  };
  Slick.prototype.removeSlide = Slick.prototype.slickRemove = function (index, removeBefore, removeAll) {
    var _ = this;
    if (typeof index === 'boolean') {
      removeBefore = index;
      index = removeBefore === true ? 0 : _.slideCount - 1;
    } else {
      index = removeBefore === true ? --index : index;
    }
    if (_.slideCount < 1 || index < 0 || index > _.slideCount - 1) {
      return false;
    }
    _.unload();
    if (removeAll === true) {
      _.$slideTrack.children().remove();
    } else {
      _.$slideTrack.children(this.options.slide).eq(index).remove();
    }
    _.$slides = _.$slideTrack.children(this.options.slide);
    _.$slideTrack.children(this.options.slide).detach();
    _.$slideTrack.append(_.$slides);
    _.$slidesCache = _.$slides;
    _.reinit();
  };
  Slick.prototype.setCSS = function (position) {
    var _ = this,
      positionProps = {},
      x,
      y;
    if (_.options.rtl === true) {
      position = -position;
    }
    x = _.positionProp == 'left' ? Math.ceil(position) + 'px' : '0px';
    y = _.positionProp == 'top' ? Math.ceil(position) + 'px' : '0px';
    positionProps[_.positionProp] = position;
    if (_.transformsEnabled === false) {
      _.$slideTrack.css(positionProps);
    } else {
      positionProps = {};
      if (_.cssTransitions === false) {
        positionProps[_.animType] = 'translate(' + x + ', ' + y + ')';
        _.$slideTrack.css(positionProps);
      } else {
        positionProps[_.animType] = 'translate3d(' + x + ', ' + y + ', 0px)';
        _.$slideTrack.css(positionProps);
      }
    }
  };
  Slick.prototype.setDimensions = function () {
    var _ = this;
    if (_.options.vertical === false) {
      if (_.options.centerMode === true) {
        _.$list.css({
          padding: '0px ' + _.options.centerPadding
        });
      }
    } else {
      _.$list.height(_.$slides.first().outerHeight(true) * _.options.slidesToShow);
      if (_.options.centerMode === true) {
        _.$list.css({
          padding: _.options.centerPadding + ' 0px'
        });
      }
    }
    _.listWidth = _.$list.width();
    _.listHeight = _.$list.height();
    if (_.options.vertical === false && _.options.variableWidth === false) {
      _.slideWidth = Math.ceil(_.listWidth / _.options.slidesToShow);
      _.$slideTrack.width(Math.ceil(_.slideWidth * _.$slideTrack.children('.slick-slide').length));
    } else if (_.options.variableWidth === true) {
      _.$slideTrack.width(5000 * _.slideCount);
    } else {
      _.slideWidth = Math.ceil(_.listWidth);
      _.$slideTrack.height(Math.ceil(_.$slides.first().outerHeight(true) * _.$slideTrack.children('.slick-slide').length));
    }
    var offset = _.$slides.first().outerWidth(true) - _.$slides.first().width();
    if (_.options.variableWidth === false) _.$slideTrack.children('.slick-slide').width(_.slideWidth - offset);
  };
  Slick.prototype.setFade = function () {
    var _ = this,
      targetLeft;
    _.$slides.each(function (index, element) {
      targetLeft = _.slideWidth * index * -1;
      if (_.options.rtl === true) {
        $(element).css({
          position: 'relative',
          right: targetLeft,
          top: 0,
          zIndex: _.options.zIndex - 2,
          opacity: 0
        });
      } else {
        $(element).css({
          position: 'relative',
          left: targetLeft,
          top: 0,
          zIndex: _.options.zIndex - 2,
          opacity: 0
        });
      }
    });
    _.$slides.eq(_.currentSlide).css({
      zIndex: _.options.zIndex - 1,
      opacity: 1
    });
  };
  Slick.prototype.setHeight = function () {
    var _ = this;
    if (_.options.slidesToShow === 1 && _.options.adaptiveHeight === true && _.options.vertical === false) {
      var targetHeight = _.$slides.eq(_.currentSlide).outerHeight(true);
      _.$list.css('height', targetHeight);
    }
  };
  Slick.prototype.setOption = Slick.prototype.slickSetOption = function () {
    /**
     * accepts arguments in format of:
     *
     *  - for changing a single option's value:
     *     .slick("setOption", option, value, refresh )
     *
     *  - for changing a set of responsive options:
     *     .slick("setOption", 'responsive', [{}, ...], refresh )
     *
     *  - for updating multiple values at once (not responsive)
     *     .slick("setOption", { 'option': value, ... }, refresh )
     */

    var _ = this,
      l,
      item,
      option,
      value,
      refresh = false,
      type;
    if ($.type(arguments[0]) === 'object') {
      option = arguments[0];
      refresh = arguments[1];
      type = 'multiple';
    } else if ($.type(arguments[0]) === 'string') {
      option = arguments[0];
      value = arguments[1];
      refresh = arguments[2];
      if (arguments[0] === 'responsive' && $.type(arguments[1]) === 'array') {
        type = 'responsive';
      } else if (typeof arguments[1] !== 'undefined') {
        type = 'single';
      }
    }
    if (type === 'single') {
      _.options[option] = value;
    } else if (type === 'multiple') {
      $.each(option, function (opt, val) {
        _.options[opt] = val;
      });
    } else if (type === 'responsive') {
      for (item in value) {
        if ($.type(_.options.responsive) !== 'array') {
          _.options.responsive = [value[item]];
        } else {
          l = _.options.responsive.length - 1;

          // loop through the responsive object and splice out duplicates.
          while (l >= 0) {
            if (_.options.responsive[l].breakpoint === value[item].breakpoint) {
              _.options.responsive.splice(l, 1);
            }
            l--;
          }
          _.options.responsive.push(value[item]);
        }
      }
    }
    if (refresh) {
      _.unload();
      _.reinit();
    }
  };
  Slick.prototype.setPosition = function () {
    var _ = this;
    _.setDimensions();
    _.setHeight();
    if (_.options.fade === false) {
      _.setCSS(_.getLeft(_.currentSlide));
    } else {
      _.setFade();
    }
    _.$slider.trigger('setPosition', [_]);
  };
  Slick.prototype.setProps = function () {
    var _ = this,
      bodyStyle = document.body.style;
    _.positionProp = _.options.vertical === true ? 'top' : 'left';
    if (_.positionProp === 'top') {
      _.$slider.addClass('slick-vertical');
    } else {
      _.$slider.removeClass('slick-vertical');
    }
    if (bodyStyle.WebkitTransition !== undefined || bodyStyle.MozTransition !== undefined || bodyStyle.msTransition !== undefined) {
      if (_.options.useCSS === true) {
        _.cssTransitions = true;
      }
    }
    if (_.options.fade) {
      if (typeof _.options.zIndex === 'number') {
        if (_.options.zIndex < 3) {
          _.options.zIndex = 3;
        }
      } else {
        _.options.zIndex = _.defaults.zIndex;
      }
    }
    if (bodyStyle.OTransform !== undefined) {
      _.animType = 'OTransform';
      _.transformType = '-o-transform';
      _.transitionType = 'OTransition';
      if (bodyStyle.perspectiveProperty === undefined && bodyStyle.webkitPerspective === undefined) _.animType = false;
    }
    if (bodyStyle.MozTransform !== undefined) {
      _.animType = 'MozTransform';
      _.transformType = '-moz-transform';
      _.transitionType = 'MozTransition';
      if (bodyStyle.perspectiveProperty === undefined && bodyStyle.MozPerspective === undefined) _.animType = false;
    }
    if (bodyStyle.webkitTransform !== undefined) {
      _.animType = 'webkitTransform';
      _.transformType = '-webkit-transform';
      _.transitionType = 'webkitTransition';
      if (bodyStyle.perspectiveProperty === undefined && bodyStyle.webkitPerspective === undefined) _.animType = false;
    }
    if (bodyStyle.msTransform !== undefined) {
      _.animType = 'msTransform';
      _.transformType = '-ms-transform';
      _.transitionType = 'msTransition';
      if (bodyStyle.msTransform === undefined) _.animType = false;
    }
    if (bodyStyle.transform !== undefined && _.animType !== false) {
      _.animType = 'transform';
      _.transformType = 'transform';
      _.transitionType = 'transition';
    }
    _.transformsEnabled = _.options.useTransform && _.animType !== null && _.animType !== false;
  };
  Slick.prototype.setSlideClasses = function (index) {
    var _ = this,
      centerOffset,
      allSlides,
      indexOffset,
      remainder;
    allSlides = _.$slider.find('.slick-slide').removeClass('slick-active slick-center slick-current').attr('aria-hidden', 'true');
    _.$slides.eq(index).addClass('slick-current');
    if (_.options.centerMode === true) {
      var evenCoef = _.options.slidesToShow % 2 === 0 ? 1 : 0;
      centerOffset = Math.floor(_.options.slidesToShow / 2);
      if (_.options.infinite === true) {
        if (index >= centerOffset && index <= _.slideCount - 1 - centerOffset) {
          _.$slides.slice(index - centerOffset + evenCoef, index + centerOffset + 1).addClass('slick-active').attr('aria-hidden', 'false');
        } else {
          indexOffset = _.options.slidesToShow + index;
          allSlides.slice(indexOffset - centerOffset + 1 + evenCoef, indexOffset + centerOffset + 2).addClass('slick-active').attr('aria-hidden', 'false');
        }
        if (index === 0) {
          allSlides.eq(allSlides.length - 1 - _.options.slidesToShow).addClass('slick-center');
        } else if (index === _.slideCount - 1) {
          allSlides.eq(_.options.slidesToShow).addClass('slick-center');
        }
      }
      _.$slides.eq(index).addClass('slick-center');
    } else {
      if (index >= 0 && index <= _.slideCount - _.options.slidesToShow) {
        _.$slides.slice(index, index + _.options.slidesToShow).addClass('slick-active').attr('aria-hidden', 'false');
      } else if (allSlides.length <= _.options.slidesToShow) {
        allSlides.addClass('slick-active').attr('aria-hidden', 'false');
      } else {
        remainder = _.slideCount % _.options.slidesToShow;
        indexOffset = _.options.infinite === true ? _.options.slidesToShow + index : index;
        if (_.options.slidesToShow == _.options.slidesToScroll && _.slideCount - index < _.options.slidesToShow) {
          allSlides.slice(indexOffset - (_.options.slidesToShow - remainder), indexOffset + remainder).addClass('slick-active').attr('aria-hidden', 'false');
        } else {
          allSlides.slice(indexOffset, indexOffset + _.options.slidesToShow).addClass('slick-active').attr('aria-hidden', 'false');
        }
      }
    }
    if (_.options.lazyLoad === 'ondemand' || _.options.lazyLoad === 'anticipated') {
      _.lazyLoad();
    }
  };
  Slick.prototype.setupInfinite = function () {
    var _ = this,
      i,
      slideIndex,
      infiniteCount;
    if (_.options.fade === true) {
      _.options.centerMode = false;
    }
    if (_.options.infinite === true && _.options.fade === false) {
      slideIndex = null;
      if (_.slideCount > _.options.slidesToShow) {
        if (_.options.centerMode === true) {
          infiniteCount = _.options.slidesToShow + 1;
        } else {
          infiniteCount = _.options.slidesToShow;
        }
        for (i = _.slideCount; i > _.slideCount - infiniteCount; i -= 1) {
          slideIndex = i - 1;
          $(_.$slides[slideIndex]).clone(true).attr('id', '').attr('data-slick-index', slideIndex - _.slideCount).prependTo(_.$slideTrack).addClass('slick-cloned');
        }
        for (i = 0; i < infiniteCount + _.slideCount; i += 1) {
          slideIndex = i;
          $(_.$slides[slideIndex]).clone(true).attr('id', '').attr('data-slick-index', slideIndex + _.slideCount).appendTo(_.$slideTrack).addClass('slick-cloned');
        }
        _.$slideTrack.find('.slick-cloned').find('[id]').each(function () {
          $(this).attr('id', '');
        });
      }
    }
  };
  Slick.prototype.interrupt = function (toggle) {
    var _ = this;
    if (!toggle) {
      _.autoPlay();
    }
    _.interrupted = toggle;
  };
  Slick.prototype.selectHandler = function (event) {
    var _ = this;
    var targetElement = $(event.target).is('.slick-slide') ? $(event.target) : $(event.target).parents('.slick-slide');
    var index = parseInt(targetElement.attr('data-slick-index'));
    if (!index) index = 0;
    if (_.slideCount <= _.options.slidesToShow) {
      _.slideHandler(index, false, true);
      return;
    }
    _.slideHandler(index);
  };
  Slick.prototype.slideHandler = function (index, sync, dontAnimate) {
    var targetSlide,
      animSlide,
      oldSlide,
      slideLeft,
      targetLeft = null,
      _ = this,
      navTarget;
    sync = sync || false;
    if (_.animating === true && _.options.waitForAnimate === true) {
      return;
    }
    if (_.options.fade === true && _.currentSlide === index) {
      return;
    }
    if (sync === false) {
      _.asNavFor(index);
    }
    targetSlide = index;
    targetLeft = _.getLeft(targetSlide);
    slideLeft = _.getLeft(_.currentSlide);
    _.currentLeft = _.swipeLeft === null ? slideLeft : _.swipeLeft;
    if (_.options.infinite === false && _.options.centerMode === false && (index < 0 || index > _.getDotCount() * _.options.slidesToScroll)) {
      if (_.options.fade === false) {
        targetSlide = _.currentSlide;
        if (dontAnimate !== true && _.slideCount > _.options.slidesToShow) {
          _.animateSlide(slideLeft, function () {
            _.postSlide(targetSlide);
          });
        } else {
          _.postSlide(targetSlide);
        }
      }
      return;
    } else if (_.options.infinite === false && _.options.centerMode === true && (index < 0 || index > _.slideCount - _.options.slidesToScroll)) {
      if (_.options.fade === false) {
        targetSlide = _.currentSlide;
        if (dontAnimate !== true && _.slideCount > _.options.slidesToShow) {
          _.animateSlide(slideLeft, function () {
            _.postSlide(targetSlide);
          });
        } else {
          _.postSlide(targetSlide);
        }
      }
      return;
    }
    if (_.options.autoplay) {
      clearInterval(_.autoPlayTimer);
    }
    if (targetSlide < 0) {
      if (_.slideCount % _.options.slidesToScroll !== 0) {
        animSlide = _.slideCount - _.slideCount % _.options.slidesToScroll;
      } else {
        animSlide = _.slideCount + targetSlide;
      }
    } else if (targetSlide >= _.slideCount) {
      if (_.slideCount % _.options.slidesToScroll !== 0) {
        animSlide = 0;
      } else {
        animSlide = targetSlide - _.slideCount;
      }
    } else {
      animSlide = targetSlide;
    }
    _.animating = true;
    _.$slider.trigger('beforeChange', [_, _.currentSlide, animSlide]);
    oldSlide = _.currentSlide;
    _.currentSlide = animSlide;
    _.setSlideClasses(_.currentSlide);
    if (_.options.asNavFor) {
      navTarget = _.getNavTarget();
      navTarget = navTarget.slick('getSlick');
      if (navTarget.slideCount <= navTarget.options.slidesToShow) {
        navTarget.setSlideClasses(_.currentSlide);
      }
    }
    _.updateDots();
    _.updateArrows();
    if (_.options.fade === true) {
      if (dontAnimate !== true) {
        _.fadeSlideOut(oldSlide);
        _.fadeSlide(animSlide, function () {
          _.postSlide(animSlide);
        });
      } else {
        _.postSlide(animSlide);
      }
      _.animateHeight();
      return;
    }
    if (dontAnimate !== true && _.slideCount > _.options.slidesToShow) {
      _.animateSlide(targetLeft, function () {
        _.postSlide(animSlide);
      });
    } else {
      _.postSlide(animSlide);
    }
  };
  Slick.prototype.startLoad = function () {
    var _ = this;
    if (_.options.arrows === true && _.slideCount > _.options.slidesToShow) {
      _.$prevArrow.hide();
      _.$nextArrow.hide();
    }
    if (_.options.dots === true && _.slideCount > _.options.slidesToShow) {
      _.$dots.hide();
    }
    _.$slider.addClass('slick-loading');
  };
  Slick.prototype.swipeDirection = function () {
    var xDist,
      yDist,
      r,
      swipeAngle,
      _ = this;
    xDist = _.touchObject.startX - _.touchObject.curX;
    yDist = _.touchObject.startY - _.touchObject.curY;
    r = Math.atan2(yDist, xDist);
    swipeAngle = Math.round(r * 180 / Math.PI);
    if (swipeAngle < 0) {
      swipeAngle = 360 - Math.abs(swipeAngle);
    }
    if (swipeAngle <= 45 && swipeAngle >= 0) {
      return _.options.rtl === false ? 'left' : 'right';
    }
    if (swipeAngle <= 360 && swipeAngle >= 315) {
      return _.options.rtl === false ? 'left' : 'right';
    }
    if (swipeAngle >= 135 && swipeAngle <= 225) {
      return _.options.rtl === false ? 'right' : 'left';
    }
    if (_.options.verticalSwiping === true) {
      if (swipeAngle >= 35 && swipeAngle <= 135) {
        return 'down';
      } else {
        return 'up';
      }
    }
    return 'vertical';
  };
  Slick.prototype.swipeEnd = function (event) {
    var _ = this,
      slideCount,
      direction;
    _.dragging = false;
    _.swiping = false;
    if (_.scrolling) {
      _.scrolling = false;
      return false;
    }
    _.interrupted = false;
    _.shouldClick = _.touchObject.swipeLength > 10 ? false : true;
    if (_.touchObject.curX === undefined) {
      return false;
    }
    if (_.touchObject.edgeHit === true) {
      _.$slider.trigger('edge', [_, _.swipeDirection()]);
    }
    if (_.touchObject.swipeLength >= _.touchObject.minSwipe) {
      direction = _.swipeDirection();
      switch (direction) {
        case 'left':
        case 'down':
          slideCount = _.options.swipeToSlide ? _.checkNavigable(_.currentSlide + _.getSlideCount()) : _.currentSlide + _.getSlideCount();
          _.currentDirection = 0;
          break;
        case 'right':
        case 'up':
          slideCount = _.options.swipeToSlide ? _.checkNavigable(_.currentSlide - _.getSlideCount()) : _.currentSlide - _.getSlideCount();
          _.currentDirection = 1;
          break;
        default:
      }
      if (direction != 'vertical') {
        _.slideHandler(slideCount);
        _.touchObject = {};
        _.$slider.trigger('swipe', [_, direction]);
      }
    } else {
      if (_.touchObject.startX !== _.touchObject.curX) {
        _.slideHandler(_.currentSlide);
        _.touchObject = {};
      }
    }
  };
  Slick.prototype.swipeHandler = function (event) {
    var _ = this;
    if (_.options.swipe === false || 'ontouchend' in document && _.options.swipe === false) {
      return;
    } else if (_.options.draggable === false && event.type.indexOf('mouse') !== -1) {
      return;
    }
    _.touchObject.fingerCount = event.originalEvent && event.originalEvent.touches !== undefined ? event.originalEvent.touches.length : 1;
    _.touchObject.minSwipe = _.listWidth / _.options.touchThreshold;
    if (_.options.verticalSwiping === true) {
      _.touchObject.minSwipe = _.listHeight / _.options.touchThreshold;
    }
    switch (event.data.action) {
      case 'start':
        _.swipeStart(event);
        break;
      case 'move':
        _.swipeMove(event);
        break;
      case 'end':
        _.swipeEnd(event);
        break;
    }
  };
  Slick.prototype.swipeMove = function (event) {
    var _ = this,
      edgeWasHit = false,
      curLeft,
      swipeDirection,
      swipeLength,
      positionOffset,
      touches,
      verticalSwipeLength;
    touches = event.originalEvent !== undefined ? event.originalEvent.touches : null;
    if (!_.dragging || _.scrolling || touches && touches.length !== 1) {
      return false;
    }
    curLeft = _.getLeft(_.currentSlide);
    _.touchObject.curX = touches !== undefined ? touches[0].pageX : event.clientX;
    _.touchObject.curY = touches !== undefined ? touches[0].pageY : event.clientY;
    _.touchObject.swipeLength = Math.round(Math.sqrt(Math.pow(_.touchObject.curX - _.touchObject.startX, 2)));
    verticalSwipeLength = Math.round(Math.sqrt(Math.pow(_.touchObject.curY - _.touchObject.startY, 2)));
    if (!_.options.verticalSwiping && !_.swiping && verticalSwipeLength > 4) {
      _.scrolling = true;
      return false;
    }
    if (_.options.verticalSwiping === true) {
      _.touchObject.swipeLength = verticalSwipeLength;
    }
    swipeDirection = _.swipeDirection();
    if (event.originalEvent !== undefined && _.touchObject.swipeLength > 4) {
      _.swiping = true;
      event.preventDefault();
    }
    positionOffset = (_.options.rtl === false ? 1 : -1) * (_.touchObject.curX > _.touchObject.startX ? 1 : -1);
    if (_.options.verticalSwiping === true) {
      positionOffset = _.touchObject.curY > _.touchObject.startY ? 1 : -1;
    }
    swipeLength = _.touchObject.swipeLength;
    _.touchObject.edgeHit = false;
    if (_.options.infinite === false) {
      if (_.currentSlide === 0 && swipeDirection === 'right' || _.currentSlide >= _.getDotCount() && swipeDirection === 'left') {
        swipeLength = _.touchObject.swipeLength * _.options.edgeFriction;
        _.touchObject.edgeHit = true;
      }
    }
    if (_.options.vertical === false) {
      _.swipeLeft = curLeft + swipeLength * positionOffset;
    } else {
      _.swipeLeft = curLeft + swipeLength * (_.$list.height() / _.listWidth) * positionOffset;
    }
    if (_.options.verticalSwiping === true) {
      _.swipeLeft = curLeft + swipeLength * positionOffset;
    }
    if (_.options.fade === true || _.options.touchMove === false) {
      return false;
    }
    if (_.animating === true) {
      _.swipeLeft = null;
      return false;
    }
    _.setCSS(_.swipeLeft);
  };
  Slick.prototype.swipeStart = function (event) {
    var _ = this,
      touches;
    _.interrupted = true;
    if (_.touchObject.fingerCount !== 1 || _.slideCount <= _.options.slidesToShow) {
      _.touchObject = {};
      return false;
    }
    if (event.originalEvent !== undefined && event.originalEvent.touches !== undefined) {
      touches = event.originalEvent.touches[0];
    }
    _.touchObject.startX = _.touchObject.curX = touches !== undefined ? touches.pageX : event.clientX;
    _.touchObject.startY = _.touchObject.curY = touches !== undefined ? touches.pageY : event.clientY;
    _.dragging = true;
  };
  Slick.prototype.unfilterSlides = Slick.prototype.slickUnfilter = function () {
    var _ = this;
    if (_.$slidesCache !== null) {
      _.unload();
      _.$slideTrack.children(this.options.slide).detach();
      _.$slidesCache.appendTo(_.$slideTrack);
      _.reinit();
    }
  };
  Slick.prototype.unload = function () {
    var _ = this;
    $('.slick-cloned', _.$slider).remove();
    if (_.$dots) {
      _.$dots.remove();
    }
    if (_.$prevArrow && _.htmlExpr.test(_.options.prevArrow)) {
      _.$prevArrow.remove();
    }
    if (_.$nextArrow && _.htmlExpr.test(_.options.nextArrow)) {
      _.$nextArrow.remove();
    }
    _.$slides.removeClass('slick-slide slick-active slick-visible slick-current').attr('aria-hidden', 'true').css('width', '');
  };
  Slick.prototype.unslick = function (fromBreakpoint) {
    var _ = this;
    _.$slider.trigger('unslick', [_, fromBreakpoint]);
    _.destroy();
  };
  Slick.prototype.updateArrows = function () {
    var _ = this,
      centerOffset;
    centerOffset = Math.floor(_.options.slidesToShow / 2);
    if (_.options.arrows === true && _.slideCount > _.options.slidesToShow && !_.options.infinite) {
      _.$prevArrow.removeClass('slick-disabled').attr('aria-disabled', 'false');
      _.$nextArrow.removeClass('slick-disabled').attr('aria-disabled', 'false');
      if (_.currentSlide === 0) {
        _.$prevArrow.addClass('slick-disabled').attr('aria-disabled', 'true');
        _.$nextArrow.removeClass('slick-disabled').attr('aria-disabled', 'false');
      } else if (_.currentSlide >= _.slideCount - _.options.slidesToShow && _.options.centerMode === false) {
        _.$nextArrow.addClass('slick-disabled').attr('aria-disabled', 'true');
        _.$prevArrow.removeClass('slick-disabled').attr('aria-disabled', 'false');
      } else if (_.currentSlide >= _.slideCount - 1 && _.options.centerMode === true) {
        _.$nextArrow.addClass('slick-disabled').attr('aria-disabled', 'true');
        _.$prevArrow.removeClass('slick-disabled').attr('aria-disabled', 'false');
      }
    }
  };
  Slick.prototype.updateDots = function () {
    var _ = this;
    if (_.$dots !== null) {
      _.$dots.find('li').removeClass('slick-active').end();
      _.$dots.find('li').eq(Math.floor(_.currentSlide / _.options.slidesToScroll)).addClass('slick-active');
    }
  };
  Slick.prototype.visibility = function () {
    var _ = this;
    if (_.options.autoplay) {
      if (document[_.hidden]) {
        _.interrupted = true;
      } else {
        _.interrupted = false;
      }
    }
  };
  $.fn.slick = function () {
    var _ = this,
      opt = arguments[0],
      args = Array.prototype.slice.call(arguments, 1),
      l = _.length,
      i,
      ret;
    for (i = 0; i < l; i++) {
      if (_typeof(opt) == 'object' || typeof opt == 'undefined') _[i].slick = new Slick(_[i], opt);else ret = _[i].slick[opt].apply(_[i].slick, args);
      if (typeof ret != 'undefined') return ret;
    }
    return _;
  };
});

/***/ }),
/* 13 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = addToBag;
/* harmony export (immutable) */ __webpack_exports__["b"] = addBuyNowProduct;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_modules_add_to_bag__ = __webpack_require__(6);


var trackDonde = function trackDonde() {
  if (typeof trackAddToCartVisualNav === 'function') {
    trackAddToCartVisualNav();
  }
};
var logEngagement = function logEngagement() {
  var fromSearch = window.location.search.indexOf("sr=true") > 0; // Inserted in SearchController
  var module = fromSearch ? "mobile_search" : "mobile_pdp";
  __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.ajax({
    type: 'POST',
    data: __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.param({
      url: window.location.href,
      module: module,
      action: "add_to_cart"
    }),
    url: '/r/ajax/LogEngagement.jsp'
  });
};
var proceed = function proceed(code, size, showJustAdded) {
  if (showJustAdded) {
    if (__WEBPACK_IMPORTED_MODULE_0_jquery___default()("#notification_wrap_mpdp").length) {
      var data = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.param({
        code: code,
        size: size
      });
      __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.get("/r/mobile/myrevolve/ajax/AddToBagPopup.jsp", data, function (markup) {
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#notification_wrap_mpdp").html(markup);
        __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.modal({
          open: "product-added-confirmation",
          triggerOpen: true,
          triggerElement: '#add-to-bag-btn',
          onOpen: function onOpen() {
            if (rcProps.abtests.personalizedPla) {
              var _window$stickyATB;
              (_window$stickyATB = window.stickyATB) === null || _window$stickyATB === void 0 || _window$stickyATB.block();
            }
          },
          onClose: function onClose() {
            if (rcProps.abtests.personalizedPla) {
              var _window$stickyATB2;
              (_window$stickyATB2 = window.stickyATB) === null || _window$stickyATB2 === void 0 || _window$stickyATB2.unblock();
            }
          }
        });
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#product-added-confirmation").find('.js-horizontal-scroll').horizontalScroll();
      });
    } else if (__WEBPACK_IMPORTED_MODULE_0_jquery___default()("#product-added-confirmation").length) {
      __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.modal({
        open: "product-added-confirmation",
        triggerOpen: true
      });
    } else {
      var param = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.param({
        code: code,
        d: window.rcProps.department
      });
      __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.modal({
        url: "/r/mobile/dialog/AddToBagPopup.jsp",
        type: window.rcProps.addToBagModalType || null,
        data: param,
        triggerOpen: true,
        onComplete: function onComplete() {
          __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#add-to-bag-popup-dialog").find(".view-bag-btn").click(function (e) {
            window.location = "/r/mobile/ShoppingBag.jsp";
          });
          __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#add-to-bag-popup-dialog").find(".continue-shopping-btn").click(function (e) {
            __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.modal.close();
          });
        }
      });
    }
  }
  __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.ajax({
    type: "POST",
    url: "/r/mobile/AjaxUserShoppingBag.jsp",
    success: function success(response) {
      var responseObj = eval('(' + response + ')');
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#shopping_bag_count").html(responseObj);
    }
  });
};
function getSubscriptionInterval() {
  var subscriptionInterval = 0;
  var $subscriptionSelect = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#subscription-freq-select');
  if ($subscriptionSelect.is(':visible')) {
    subscriptionInterval = $subscriptionSelect.find('option:selected').val();
  }
  return subscriptionInterval;
}
function addToBag(productcode, size, optCallback) {
  var data = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var pdpData = window.rcProps.pdp || {};
  var $fittingRoomSize = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#fittingRoomSize');
  var $fittingRoomMobile = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#fittingRoomMobile');
  var fittingRoomSizeVal = $fittingRoomSize.length > 0 ? $fittingRoomSize.find(":selected").val() : '';
  if (fittingRoomSizeVal && fittingRoomSizeVal.trim().length) {
    if ($fittingRoomMobile.length) {
      $fittingRoomMobile.hide();
    }
    $fittingRoomSize.val('');
  }
  var $assignedDefectItemSerialNumber = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#assignedSellableDefectItemSerialNumber');
  var defectItemSerialNumber = $assignedDefectItemSerialNumber.length ? $assignedDefectItemSerialNumber.val() : '';
  try {
    insertFacebookAddToCart(null, productcode, pdpData.retailPrice, size);
  } catch (e) {
    console.log(e);
  }
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_modules_add_to_bag__["a" /* addToBagWithData */])({
    colorSelect: productcode,
    sizeSelect: size,
    subscriptionInterval: getSubscriptionInterval(),
    fitItemSizes: fittingRoomSizeVal,
    count: 1,
    serialNumber: defectItemSerialNumber
  }, {
    success: function success() {
      __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.when(insertPageTrackForMobileWithData({
        addToCartFlag: true,
        isSubscription: getSubscriptionInterval() > 0,
        productCode: productcode
      }), logEngagement(), trackDonde()).done(function () {
        proceed(productcode, size, __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.isEmptyObject(data) || data.showJustAdded);
      });
      // add inventory disclaimer to ITEMS ADDED TO BAG popup
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#inventory-disclaimer-bag').html(__WEBPACK_IMPORTED_MODULE_0_jquery___default()("select#size").data("inventoryDisclaimer"));
    },
    done: function done(obj) {
      // start GA add to cart
      var gaProduct = {};
      gaProduct.code = '' + productcode + '';
      gaProduct.name = pdpData.productName;
      gaProduct.category = pdpData.categoryName;
      gaProduct.brand = pdpData.brandName;
      gaProduct.variant = size;
      gaProduct.price = pdpData.price;
      gaProduct.quantity = 1;
      gaAddToCartActionProduct('add', gaProduct);
      // end GA add to cart

      if (typeof addToCartPinterest === 'function') {
        addToCartPinterest(productcode, pdpData.price, 1);
      }
      if (typeof addToCartReddit === 'function') {
        var cartItems = new Array();
        {
          var cartItem = {};
          cartItem.productCode = productcode;
          cartItem.productName = pdpData.productName;
          cartItem.productCategory = pdpData.categoryName;
          cartItems.push(cartItem);
        }
        addToCartReddit(cartItems, pdpData.price, pdpData.id, pdpData.name, pdpData.categoryName);
      }
      if (typeof spanglePixelAddToCart === 'function') {
        spanglePixelAddToCart(productcode, pdpData.price, 1);
      }
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#product-data-container .price__sale, #product-data-container .price__retail").html(obj.msg5);
      if (obj.msg6 !== "hideOriginalPrice") {
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#addToBagSalePriceDiv").removeClass("u-hide");
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#addToBagStandardPriceDiv").addClass("u-hide");
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#product-data-container .price__retail").html(obj.msg6);
      } else {
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#addToBagSalePriceDiv").addClass("u-hide");
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#addToBagStandardPriceDiv").removeClass("u-hide");
      }
      if (obj.msg26) {
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#threshhold-add-to-bag').replaceWith(obj.msg26);
      }
      if (obj.msg9 !== "") {
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#preOrderMessage").html(obj.msg9).removeClass("u-hide");
        if (obj.msg27) {
          __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#preOrderMessage").removeClass("notification__description");
        } else {
          __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#preOrderMessage").addClass("notification__description");
        }
      } else {
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#preOrderMessage").addClass("u-hide");
      }
      if (typeof brazeAddToCart === 'function') {
        var canonicalLink = document.querySelector('link[rel="canonical"]');
        var pdpUrl = canonicalLink ? canonicalLink.href : null;
        var itemInformation = {
          code: productcode,
          name: obj.msg31,
          src: obj.msg2,
          srcset: obj.msg26,
          designer: obj.msg3,
          designerHref: obj.msg4,
          price: obj.msg5,
          origPrice: obj.msg6,
          disclaimer: obj.msg9,
          invAlert: obj.msg12,
          color: obj.msg10,
          cartTotal: obj.msg11,
          cartSize: obj.msg13,
          addlItemsText: obj.msg14,
          categoryName: obj.msg16,
          cartItemsCount: obj.msg22,
          size: obj.msg23,
          itemQtyInCart: obj.msg24,
          isPreOrder: obj.msg27,
          currency: obj.msg28,
          department: obj.msg29,
          cat1: obj.msg30
        };
        brazeAddToCart('add', itemInformation.code, itemInformation.name, itemInformation.size, itemInformation.src, pdpUrl, itemInformation.price, itemInformation.currency, itemInformation.department, itemInformation.color, itemInformation.brandName, itemInformation.categoryName, itemInformation.cat1);
      }
      if (typeof optCallback == 'function') {
        optCallback();
      }
    }
  });
}
function addBuyNowProduct(code, size, fittingRoomSize, buyNowButton) {
  var rcProps = window.rcProps || {};
  var forceBuyNowExpress = window.location.search.indexOf('forceBNE') >= 0;
  var paymentMethod = buyNowButton ? __WEBPACK_IMPORTED_MODULE_0_jquery___default()(buyNowButton).data('bnPaymentMethod') : '';
  __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.ajax({
    type: 'POST',
    url: "/r/ajax/BuyNow.jsp?itemsrc=pdp".concat(forceBuyNowExpress ? '&forceBNE=true' : ''),
    data: __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.param({
      bnCode: code,
      bnSize: size,
      bnPaymentMethod: paymentMethod,
      subscriptionInterval: getSubscriptionInterval(),
      d: rcProps.department,
      sectionUrl: rcProps.sectionUrl,
      fittingRoomSize: fittingRoomSize
    }),
    success: function success(obj) {
      var rtn = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.parseJSON(obj);
      //trigger fo optimzely
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).trigger('productBuyNow');
      if (rtn && rtn.success) {
        if (rtn.refreshPage) {
          var searchParams = new URLSearchParams(window.location.search);
          var addParameter = searchParams && searchParams.has('bnRefresh') || window.location.search.indexOf('bnRefresh') < 0;
          window.location.href = window.location.href + (addParameter ? '&bnRefresh=true' : '');
          return;
        }
        if (typeof iPinYouBuyNow === 'function') {
          iPinYouBuyNow(code);
        }
        gaCheckout(1, 'SIGNIN');
        var buyNowRedirect = '/r/mobile/LoginCheckout.jsp?bn=true';
        var _paymentMethod = buyNowButton ? __WEBPACK_IMPORTED_MODULE_0_jquery___default()(buyNowButton).data('bnPaymentMethod') : '';
        var callback = function callback() {
          // Has to be a callback to ensure tracking fires correctly
          window.location = buyNowRedirect + (!rtn.canPlaceOrder ? '&onAdd=true' : '');
        };
        gaAddToCartActionWithAjax('add', code, size, 1);
        __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.when(insertPageTrackForMobileWithData({
          addToCartFlag: true,
          productCode: code,
          isBuyNow: true,
          isApplePay: _paymentMethod === 'ApplePay',
          isSubscription: getSubscriptionInterval() > 0
        }), logEngagement(), trackDonde()).done(callback);
        if (typeof insertCriteoAddToCart === 'function') {
          insertCriteoAddToCart(code);
        }
        if (typeof insertRTBHouseAddToCart === 'function') {
          insertRTBHouseAddToCart(code);
        }
      }
    }
  });
}

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!function(e,t){if(true)!(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports], __WEBPACK_AMD_DEFINE_FACTORY__ = (t),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));else if("undefined"!=typeof exports)t(exports);else{var o={};t(o),e.bodyScrollLock=o}}(this,function(exports){"use strict";function i(e){if(Array.isArray(e)){for(var t=0,o=Array(e.length);t<e.length;t++)o[t]=e[t];return o}return Array.from(e)}Object.defineProperty(exports,"__esModule",{value:!0});var l=!1;if("undefined"!=typeof window){var e={get passive(){l=!0}};window.addEventListener("testPassive",null,e),window.removeEventListener("testPassive",null,e)}function d(t){return u.some(function(e){return!(!e.options.allowTouchMove||!e.options.allowTouchMove(t))})}function c(e){var t=e||window.event;return!!d(t.target)||(1<t.touches.length||(t.preventDefault&&t.preventDefault(),!1))}function o(){setTimeout(function(){void 0!==m&&(document.body.style.paddingRight=m,m=void 0),void 0!==f&&(document.body.style.overflow=f,f=void 0)})}var a="undefined"!=typeof window&&window.navigator&&window.navigator.platform&&(/iP(ad|hone|od)/.test(window.navigator.platform)||"MacIntel"===window.navigator.platform&&1<window.navigator.maxTouchPoints),u=[],s=!1,v=-1,f=void 0,m=void 0;exports.disableBodyScroll=function(r,e){if(a){if(!r)return void console.error("disableBodyScroll unsuccessful - targetElement must be provided when calling disableBodyScroll on IOS devices.");if(r&&!u.some(function(e){return e.targetElement===r})){var t={targetElement:r,options:e||{}};u=[].concat(i(u),[t]),r.ontouchstart=function(e){1===e.targetTouches.length&&(v=e.targetTouches[0].clientY)},r.ontouchmove=function(e){var t,o,n,i;1===e.targetTouches.length&&(o=r,i=(t=e).targetTouches[0].clientY-v,d(t.target)||(o&&0===o.scrollTop&&0<i||(n=o)&&n.scrollHeight-n.scrollTop<=n.clientHeight&&i<0?c(t):t.stopPropagation()))},s||(document.addEventListener("touchmove",c,l?{passive:!1}:void 0),s=!0)}}else{n=e,setTimeout(function(){if(void 0===m){var e=!!n&&!0===n.reserveScrollBarGap,t=window.innerWidth-document.documentElement.clientWidth;e&&0<t&&(m=document.body.style.paddingRight,document.body.style.paddingRight=t+"px")}void 0===f&&(f=document.body.style.overflow,document.body.style.overflow="hidden")});var o={targetElement:r,options:e||{}};u=[].concat(i(u),[o])}var n},exports.clearAllBodyScrollLocks=function(){a?(u.forEach(function(e){e.targetElement.ontouchstart=null,e.targetElement.ontouchmove=null}),s&&(document.removeEventListener("touchmove",c,l?{passive:!1}:void 0),s=!1),u=[],v=-1):(o(),u=[])},exports.enableBodyScroll=function(t){if(a){if(!t)return void console.error("enableBodyScroll unsuccessful - targetElement must be provided when calling enableBodyScroll on IOS devices.");t.ontouchstart=null,t.ontouchmove=null,u=u.filter(function(e){return e.targetElement!==t}),s&&0===u.length&&(document.removeEventListener("touchmove",c,l?{passive:!1}:void 0),s=!1)}else(u=u.filter(function(e){return e.targetElement!==t})).length||o()}});


/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

var debounce = __webpack_require__(55),
    isObject = __webpack_require__(7);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a throttled function that only invokes `func` at most once per
 * every `wait` milliseconds. The throttled function comes with a `cancel`
 * method to cancel delayed `func` invocations and a `flush` method to
 * immediately invoke them. Provide `options` to indicate whether `func`
 * should be invoked on the leading and/or trailing edge of the `wait`
 * timeout. The `func` is invoked with the last arguments provided to the
 * throttled function. Subsequent calls to the throttled function return the
 * result of the last `func` invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the throttled function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.throttle` and `_.debounce`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to throttle.
 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=true]
 *  Specify invoking on the leading edge of the timeout.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new throttled function.
 * @example
 *
 * // Avoid excessively updating the position while scrolling.
 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
 *
 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
 * jQuery(element).on('click', throttled);
 *
 * // Cancel the trailing throttled invocation.
 * jQuery(window).on('popstate', throttled.cancel);
 */
function throttle(func, wait, options) {
  var leading = true,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  if (isObject(options)) {
    leading = 'leading' in options ? !!options.leading : leading;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }
  return debounce(func, wait, {
    'leading': leading,
    'maxWait': wait,
    'trailing': trailing
  });
}

module.exports = throttle;


/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(29),
    getRawTag = __webpack_require__(418),
    objectToString = __webpack_require__(448);

/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString(value);
}

module.exports = baseGetTag;


/***/ }),
/* 17 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return EVENTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return TYPES; });
/* unused harmony export default */
/* unused harmony export defaultUpdateOptions */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return createJQueryPlugin; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_property__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_property___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_property__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_es6_symbol__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_es6_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_es6_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_register_jquery_plugin__ = __webpack_require__(1);
function _toArray(r) { return _arrayWithHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
/**
 * Responsible initiating form field behaviors and sending events down to any
 * behaviors or extended functionality.
 * @module formFieldBehavior
 */




/**
 * Defines default options for form field behaviors
 * @type {Object}
 */
var FORM_FIELD_BEHAVIOR_OPTIONS = {
  labelElement: 'label',
  fieldElements: ['input', 'select', 'textarea'],
  behaviors: []
};

/**
 * Defines the different types of supported events.
 * @type {Object}
 */
var EVENTS = {
  FOCUS: 'focus',
  BLUR: 'blur',
  INVALID: 'invalid',
  INPUT: 'input',
  CHANGE: 'change',
  LOAD: 'load',
  // This is a nonstandard event, but it does provide clarity when an element
  // was no longer but in its current state it is valid
  VALID: 'valid'
};

/**
 * Defines the types associated to the elements within form field behaviors. It
 * uses Symbol as the value so that unique values can be used without caring
 * about conflicts values. Think of this similar to an Enum or an IOTA.
 * @enum
 * @type {Object}
 */
var TYPES = {
  CONTAINER: __WEBPACK_IMPORTED_MODULE_1_es6_symbol___default()('container'),
  LABEL: __WEBPACK_IMPORTED_MODULE_1_es6_symbol___default()('label'),
  FIELD: __WEBPACK_IMPORTED_MODULE_1_es6_symbol___default()('field')
};

/**
 * Creates a FIELD based on the block and optionally supplied element.
 * @private
 * @param {Symbol} type - Uniquely identify a type of FIELD
 * @param {HTMLElement} container - Contains the child elements
 * @param {string} block - The block name
 * @param {string|null} [element=null] - The element name
 * @returns {Object} The name and node representing the FIELD.
 */
var createField = function createField(type, container, block) {
  var element = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
  if (element) {
    var name = "".concat(block, "__").concat(element);
    return {
      type: type,
      name: name,
      node: container.querySelector(".".concat(name))
    };
  }
  return {
    type: type,
    name: block,
    node: container
  };
};

/**
 * Negotiates and resolves the form FIELD within the CONTAINER. There are a
 * number of possible element names that can be used, so this will ensure that
 * the supported element names correlate to what is in the DOM.
 * @private
 * @param {HTMLElement} container - Contains the form FIELD element
 * @param {string} block - The block name
 * @param {Array} fieldElements = Possible elements names
 * @returns {Object} The name and node representing the form FIELD.
 */
var getFormField = function getFormField(container, block, fieldElements) {
  var _fieldElements$map$fi = fieldElements.map(function (element) {
      return createField(TYPES.FIELD, container, block, element);
    }).filter(function (_ref) {
      var node = _ref.node;
      return node;
    }),
    _fieldElements$map$fi2 = _toArray(_fieldElements$map$fi),
    field = _fieldElements$map$fi2[0],
    otherFields = _arrayLikeToArray(_fieldElements$map$fi2).slice(1);
  if (otherFields.length) {
    throw new Error('Form field behaviors only supports one field in a container');
  }
  if (!field) {
    throw new Error('No form field node found in form field behaviors');
  }
  return field;
};

/**
 * Provides additional data that can be used from the consumer side of the
 * form field behavior. Think of this as extra data that isn't part of the
 * event.
 * @private
 * @param {HTMLElement} fieldElement - The form field element
 * @returns {Object} Data to be passed along to the event.
 */
var buildAdditionalData = function buildAdditionalData(fieldElement) {
  var _ref2 = __WEBPACK_IMPORTED_MODULE_0_lodash_property___default()('form.dataset')(fieldElement) || {},
    validateOnlyOnSubmit = _ref2.validateOnlyOnSubmit;
  return {
    validateOnlyOnSubmit: !!validateOnlyOnSubmit
  };
};

/**
 * Creates an event listener and passes back all the necessary properties
 * needed for clean up.
 * @private
 * @param {string} eventName - The name of the event
 * @param {HTMLElement} node - Element receiving the event
 * @param {Array} behaviors - The listeners or behaviors provided from the outside
 * @param {Function} [fn=e => e] - Allow for internal hooking in of the callback
 * @returns {Object} Properties containing event information
 */
var addListener = function addListener(eventName, node, behaviors) {
  var fn = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : function (e) {
    return e;
  };
  var handler;
  var data = buildAdditionalData(node);
  node.addEventListener(eventName, handler = function handler(e) {
    fn(e);
    behaviors.forEach(function (listener) {
      return listener && listener(eventName, e, data);
    });
  });
  return {
    node: node,
    eventName: eventName,
    handler: handler
  };
};

/**
 * Removes all events applied to an instance of form field behaviors.
 * @private
 * @param {Object} listeners - Info about each element
 */
var _removeListeners = function removeListeners(listeners) {
  listeners.forEach(function (listener) {
    if (!listener) {
      return;
    }
    var node = listener.node,
      eventName = listener.eventName,
      handler = listener.handler;
    node.removeEventListener(eventName, handler);
  });
};

/**
 * Fires off a load event denoting that the element has loaded.
 * @private
 * @param {HTMLElement} fieldNode - The element receiving the event
 */
var fireLoadEvent = function fireLoadEvent(fieldNode) {
  var evt = new CustomEvent(EVENTS.LOAD);
  fieldNode.dispatchEvent(evt);
};

/**
 * Responsible for handling any select specific events.
 * @param {HTMLElement} fieldNode - Element receiving the event
 * @param {Array} listeners - Called on when event has been fired off
 * @returns {Function|null} Event handler or null depending on if the event
 * will be fired off
 */
var addChangeListener = function addChangeListener(fieldNode, listeners) {
  if (fieldNode.tagName.toLowerCase() === 'select') {
    return addListener(EVENTS.CHANGE, fieldNode, listeners);
  }
  return null;
};

/**
 * Responsible for setting up any behavior that needs to hook into form field
 * behaviors. The goal of this work is to:
 *
 * - Offload responsibility of the interaction so any form field behavior
 *   functionality can scale horizontally.
 * - Decrease the amount of event bound to the DOM by calling on the listener
 *   provided by the behavior.
 * - Consolidate all events for ease of clean up.
 *
 * As part of the setup, a number of requirements are needed for a form field
 * behavior include:
 *
 * - A CONTAINER element (the one passed in)
 * - A LABEL element
 * - Some kinda of form FIELD element
 *
 * Once all the requirements have been met, form field behaviors will interact
 * with "behaviors", which serve the following purposes:
 *
 * - Accept the output of elements
 * - Respond to any events dictated by form field behaviors by forwarding along
 *   the event name followed by the event on the form field
 *
 * To do so, a behavior is a function where the returned function acts as the
 * responder. In it's simplest form, a behavior is a function that returns a
 * function, where the first function passes along all the "nodes" or elements
 * defined in TYPES and the second function (or inner function) it used for
 * listening to/responding to events.
 *
 * @example
 * const myBehavior = (blockElement, labelElement, fieldFormElement) => (type, evt) => {
 *   switch(type) {
 *     case 'FOCUS':
 *       blockElement.classList.add('i-do-focus-things');
 *     case 'BLUR':
 *       blockElement.classList.remove('i-do-focus-things');
 *       blockElement.classList.add('i-do-blur-things');
 *   };
 * };
 *
 * formFieldBehaviors($el, 'some-block', {
 *   behaviors: [myBehavior]
 * });
 *
 * @see TYPES
 * @see FORM_FIELD_BEHAVIOR_OPTIONS
 * @param {HTMLElement} container - The element containing the LABEL and FIELD
 * @param {string} block - Name of top level block
 * @param {string} labelElement - Name of label element associated with the block
 * @param {Object} options - Options used for overriding
 * @returns {Object} Properties used for interacting after the initial call
 */
function formFieldBehaviors(container, block) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var _Object$assign = Object.assign({}, FORM_FIELD_BEHAVIOR_OPTIONS, options),
    labelElement = _Object$assign.labelElement,
    fieldElements = _Object$assign.fieldElements,
    behaviors = _Object$assign.behaviors,
    _Object$assign$deregi = _Object$assign.deregister,
    deregister = _Object$assign$deregi === void 0 ? function () {} : _Object$assign$deregi;
  var formField = getFormField(container, block, fieldElements);
  var label = createField(TYPES.LABEL, container, block, labelElement);
  if (!label.node) {
    throw new Error("No field found in a form field behavior for ".concat(label.name));
  }
  var elements = [createField(TYPES.CONTAINER, container, block), label, formField];
  var FOCUS = EVENTS.FOCUS,
    BLUR = EVENTS.BLUR,
    INVALID = EVENTS.INVALID,
    INPUT = EVENTS.INPUT,
    LOAD = EVENTS.LOAD,
    VALID = EVENTS.VALID;
  var listeners = behaviors.map(function (behavior) {
    return behavior.apply(void 0, elements);
  });
  var fieldNode = formField.node;
  var focusListener = addListener(FOCUS, fieldNode, listeners, function (_ref3) {
    var target = _ref3.target;
    return target.setCustomValidity('');
  });
  var blurListener = addListener(BLUR, fieldNode, listeners);
  var invalidListener = addListener(INVALID, fieldNode, listeners);
  var inputListener = addListener(INPUT, fieldNode, listeners);
  var loadListener = addListener(LOAD, fieldNode, listeners);
  var changeListener = addChangeListener(fieldNode, listeners);
  var validListener = addListener(VALID, fieldNode, listeners);
  var eventListeners = [focusListener, blurListener, invalidListener, inputListener, loadListener, changeListener, validListener];

  // At this point all the necessary elements are in the DOM so we communicate
  // to any subscribers that the form field behavior functionality has loaded.
  fireLoadEvent(fieldNode);
  return {
    removeListeners: function removeListeners() {
      deregister();
      _removeListeners(eventListeners);
    }
  };
}

/**
 * Responsible for providing default implementaiton of update options.
 * @param {HTMLElement} el - Element receiving form field behaviors
 * @param {Object} options - Configurable options
 */
var defaultUpdateOptions = function defaultUpdateOptions(el, options) {
  return options;
};

/**
 * Responsible for bootstrapping together jQuery plugin at runtime.
 * @param {string} block - Name of block being referenced
 * @param {Array} behaviors - Any implemented behaviors.
 * @param {*} updateOptions - Called on prior to make modifications to options
 * or element
 * @returns {Function} Called on when plugin is called on
 */
var bootstrapJQueryPlugin = function bootstrapJQueryPlugin(block, behaviors, updateOptions) {
  return function (el) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var _ref4 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : __WEBPACK_IMPORTED_MODULE_2__lib_register_jquery_plugin__["b" /* noopActions */],
      deregister = _ref4.deregister;
    var _options$behaviors = options.behaviors,
      pluginBehaviors = _options$behaviors === void 0 ? [] : _options$behaviors;
    var combinedBehaviors = behaviors.concat(pluginBehaviors);
    var opts = Object.assign({
      formFieldBehaviors: formFieldBehaviors,
      behaviors: combinedBehaviors,
      deregister: deregister
    }, options);
    var formFieldBehaviorsFn = opts.formFieldBehaviors;
    var nextOptions = updateOptions(el, opts);
    return formFieldBehaviorsFn(el, block, nextOptions);
  };
};

/**
 * Responsible for creating a jQuery plugin from a form field behaviors
 * instance. Think of this has a jQuery plugin adapter for form field behaviors.
 * @param {string} pluginName - Name of plugin to create
 * @param {string} block - Name of block being referenced
 * @param {Array} behaviors - Any implemented behaviors.
 * @param {Function} [updateOptions=defaultUpdateOptions] - Called on so that any
 * dynamic options can be set at runtime.
 */
var createJQueryPlugin = function createJQueryPlugin(pluginName, block, behaviors) {
  var updateOptions = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : defaultUpdateOptions;
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__lib_register_jquery_plugin__["a" /* default */])(pluginName, bootstrapJQueryPlugin(block, behaviors, updateOptions));
};

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

var assignValue = __webpack_require__(76),
    baseAssignValue = __webpack_require__(77);

/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */
function copyObject(source, props, object, customizer) {
  var isNew = !object;
  object || (object = {});

  var index = -1,
      length = props.length;

  while (++index < length) {
    var key = props[index];

    var newValue = customizer
      ? customizer(object[key], source[key], key, object, source)
      : undefined;

    if (newValue === undefined) {
      newValue = source[key];
    }
    if (isNew) {
      baseAssignValue(object, key, newValue);
    } else {
      assignValue(object, key, newValue);
    }
  }
  return object;
}

module.exports = copyObject;


/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsNative = __webpack_require__(377),
    getValue = __webpack_require__(419);

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

module.exports = getNative;


/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

var arrayLikeKeys = __webpack_require__(130),
    baseKeys = __webpack_require__(380),
    isArrayLike = __webpack_require__(25);

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

module.exports = keys;


/***/ }),
/* 21 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export SELECTORS */
/* harmony export (immutable) */ __webpack_exports__["a"] = manageRefineMenu;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__modules_revieve_try_on__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modules_social_proof__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modules_global_log_engagement__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__size_selection__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__modules_side_panel_init__ = __webpack_require__(34);
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }






var SELECTORS = {
  sortBy: '#sortby',
  clearFilter: '#clear_filters',
  applyFilter: '#apply_filters',
  filterClickable: '.plp-filter-clickable',
  catFilter: '#category',
  departmentFilter: '#department',
  checkboxFilter: '.js-checkbox-filter',
  sidebarClose: '.js-side-panel-close',
  refineButton: '#refineBtn',
  sortRefineButton: '#sortRefineBtn',
  // AB test, misnomer since now only refine but not changing to reduce regressions
  plpNavDropdown: '#plpNavDropdown'
};
var addtionalFilterArray = ['benefits', 'benefits_hair', 'coverage', 'finish', 'skin_type', 'key_ingredient', 'formulation', 'frame_type', 'lens_detail', 'face_shape', 'sunglasses_fit', 'stretch'];
var filterNames = ['designer', 'category', 'size', 'color', 'price', 'heel', 'length', 'sleeve', 'rise', 'fragrance', 'length_rise', 'benefits', 'benefits_hair', 'coverage', 'finish', 'skin_type', 'key_ingredient', 'formulation', 'frame_type', 'lens_detail', 'face_shape', 'sunglasses_fit', 'stretch', 'sustainability', 'condition']; // including addtionalFilterArray
// Map the filter names to the URL parameter names to the JS object keys
var filterNamesToUrlParamsMap = {
  designer: 'designers',
  size: 'sizes',
  color: 'colors',
  price: 'prices',
  heel: 'heels',
  length: 'lengths',
  sleeve: 'sleeves',
  rise: 'rises',
  fragrance: 'fragrances',
  condition: 'conditions'
};
var checkboxFilterNamesToForceFalseValue = ['in_stock', 'preorder'];
var checkboxFilterNames = ['sustainability'].concat(checkboxFilterNamesToForceFalseValue);

// Having these names in a JS object makes lookups faster than a nested loop
var checkboxFiltersForcedFalseObj = checkboxFilterNamesToForceFalseValue.reduce(function (result, item, index) {
  result[item] = true;
  return result;
}, {});
var filtersAppliedDelimiter = '-';
var filtersParamName = 'filters';
var atStartRegex = new RegExp('^' + filtersAppliedDelimiter);
var doubleRegex = new RegExp(filtersAppliedDelimiter + filtersAppliedDelimiter);
var atEndRegex = new RegExp(filtersAppliedDelimiter + '$');
var REFINE_MENU_MODULE = 'Refine Dropdown';
var SMART_FILTER_PARAM = 'sf';
var DELIMITER = "-";
__WEBPACK_IMPORTED_MODULE_0_jquery___default()(function () {
  window.onpopstate = function (event) {
    var updatedNewURl = location.href + location.search;
    var visualNavPageNum = 1;
    if (typeof window.getVisualNavPageNumFromUrl == "function") {
      visualNavPageNum = window.getVisualNavPageNumFromUrl();
    }
    if (window.rcProps.isSmartFiltersPage) {
      var selectedFilters = new Set();
      var searchParams = new URLSearchParams(location.search);
      searchParams.forEach(function (value, key) {
        if (key === SMART_FILTER_PARAM) {
          selectedFilters.add(value);
        }
      });
      var $filters = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#smart-filters-form input[type="checkbox"]');
      $filters.prop('disabled', false).prop('checked', false).each(function () {
        var $this = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this);
        if (selectedFilters.has("".concat($this.prop('name')).concat(DELIMITER).concat($this.prop('value')))) {
          $this.prop('checked', true);
        }
      });
      updateValidSmartFilters();
      updateSmartFiltersCount();
    }
    updateContent(updatedNewURl, visualNavPageNum);
  };
  updatePagination(location.href + location.search);
  updateDropdownNavURLsOnLoad();
  updateSmartFiltersCount();
  if (window.rcProps.isSmartFiltersPage) {
    var $originalSearchTerm = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#original-search-term');
    if ($originalSearchTerm.length) {
      var correctedSearchTerm = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#smart_search_term').val();
      var originalSearchTerm = $originalSearchTerm.text();
      window.history.replaceState(null, document.title, window.location.href.replace('search=' + encodeURIComponent(originalSearchTerm), 'search=' + correctedSearchTerm));
    }
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).on('openSmartFilters', function () {
      if (getSmartFilters()) {
        updateValidSmartFilters();
      }
    });
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#reset-smart-filters').on('click', function () {
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-smart-filter').prop('disabled', false).prop('checked', false);
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__modules_global_log_engagement__["a" /* logEngagement */])(window.location.href, 'smart_filters', 'start over');
      submitSmartFilters();
    });
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#submit-smart-filters').on('click', function () {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__modules_global_log_engagement__["a" /* logEngagement */])(window.location.href, 'smart_filters', 'apply filters');
      submitSmartFilters();
    });
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#smart-filters-form input').on('change', function () {
      updateValidSmartFilters();
      var $this = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this);
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__modules_global_log_engagement__["b" /* logEngagementWithDetails */])(window.location.href, 'smart_filter', $this.is(':checked') ? 'select' : 'deselect', $this.attr('id'));
    });
  }
  function updateValidSmartFilters() {
    var data = getSmartFilters();
    if (data) {
      var ajaxUrl = appendQuery(removeURLParameter(window.location.href, SMART_FILTER_PARAM), data).replace(/.*\?/, "".concat(window.rcProps.smartFiltersCheckHref, "?"));
      __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.get(ajaxUrl).done(function (result) {
        var validFilters = Object.keys(result).reduce(function (set, filterType) {
          var filterNames = result[filterType];
          var _iterator = _createForOfIteratorHelper(filterNames),
            _step;
          try {
            for (_iterator.s(); !(_step = _iterator.n()).done;) {
              var filterName = _step.value;
              set.add("".concat(filterType, "_").concat(filterName));
            }
          } catch (err) {
            _iterator.e(err);
          } finally {
            _iterator.f();
          }
          return set;
        }, new Set());
        var selectedCategories = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-smart-filter:checked').toArray().reduce(function (set, el) {
          set.add(__WEBPACK_IMPORTED_MODULE_0_jquery___default()(el).attr('name'));
          return set;
        }, new Set());
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-smart-filter').each(function () {
          var $el = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this);
          $el.prop('disabled', !($el.is(':checked') || validFilters.has($el.attr('id')) || selectedCategories.has($el.attr('name'))));
        });
      });
    } else {
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-smart-filter').each(function () {
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).prop('disabled', false);
      });
    }
  }
});
window.manageRefineMenuViaAjax = function () {
  manageRefineMenu();
};
function manageRefineMenu() {
  var isSearch = isSearchPage();
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()(SELECTORS.checkboxFilter).change(function () {
    loadBrandsURL(this);
  });
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()(SELECTORS.clearFilter).click(function (event) {
    event.preventDefault();
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#refine-filters select').each(function () {
      if (__WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).attr('id') === 'newarrivals') {
        return;
      }
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).prop('selectedIndex', -1);
      setCount(this, true);
    });
    var curDep = getQueryParamValues(window.location.href, 'd')[0];
    setFilterOptionSelectedByValue(__WEBPACK_IMPORTED_MODULE_0_jquery___default()('#department'), curDep);
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#benefits, #benefits_hair, #coverage, #finish, #skin_type, #key_ingredient, ' + '#formulation, #frame_type, #lens_detail, #face_shape, #sunglasses_fit').each(function () {
      var $this = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this);
      if ($this.hasClass('select_all')) {
        // View All can change based on Java code
        $this.prop('selectedIndex', 0);
      }
    });
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()(".js-checkbox-filter:not(#in-stock-filter)").prop('checked', false).trigger("change");

    // $(SELECTORS.applyFilter).click();
    loadBrandsURL(this);
  });
  var sortBySelector = SELECTORS.sortBy;
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()(sortBySelector).off().on('change', function () {
    // $(SELECTORS.applyFilter).click();
    loadBrandsURL(this, true);
  });
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()(SELECTORS.catFilter).change(function () {
    // $(SELECTORS.applyFilter).click();
    loadBrandsURL(this);
  });
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()(SELECTORS.departmentFilter).change(function () {
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#alldesigners, #allcolors, #allprices, #heel, #length, #sleeve, #rise, #fragrance, #allsizes, #category, #searchcategory, #searchdesigner').prop('selectedIndex', 0);
    if (!isPersonalShop() && !isFavoritePage()) {
      var dep = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).val();
      var search = getQueryParamValues(window.location.href, 'search')[0];
      loadSearchFilterOptions(dep, search);
    }
  });
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()(SELECTORS.filterClickable).off().on("click", function (e) {
    e.preventDefault();
    loadBrandsURL(this);
  });
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#alldesigners, #allcolors, #allprices, #heel, #length, #sleeve, #rise, #fragrance, #allsizes, ' + '#benefits, #benefits_hair, #coverage, #finish, #skin_type, #key_ingredient, #formulation, ' + '#length_rise, ' + '#frame_type, #lens_detail, #face_shape, #sunglasses_fit, #stretch, #condition').change(function (e) {
    var $el = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this);
    var refineValue = $el.val();
    if (refineValue && !refineValue[0] && refineValue.length > 1) {
      $el.find('.select_all').removeAttr('selected').prop("selected", false);
    }
    loadBrandsURL(this, true, true);
  });
  //some filters specifically in search page and new page
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#allcategories, #category, #department, #searchcategory, #searchdesigner').change(function (e) {
    var $el = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this);
    var refineValue = $el.val();
    if (window.rcProps.isSmartFiltersPage && $el.attr('id') === SELECTORS.departmentFilter.replace('#', '')) {
      var urlParams = getUrlParams(window.location.href, true);
      var url = removeFilterParams(urlParams);
      refineValue = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('input[name="department"]:checked').val();
      window.location.href = url + (url.indexOf("?") > 0 ? "&" : "?") + "d=" + refineValue;
    }
    if (refineValue && !refineValue[0] && refineValue.length > 1) {
      $el.find('.select_all').removeAttr('selected').prop("selected", false);
    }
    loadBrandsURL(this);
    // reset the side panel on department change since there will be a different set of filters (e.g., designers)
    if ($el.attr('id') === 'department' && (isPersonalShop() || isFavoritePage())) {
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#done_filters').click();
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__modules_side_panel_init__["b" /* resetSidePanel */])();
    }
  });
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#newarrivals').change(function (e) {
    location.href = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).find('input[name="newDate"]:checked').data('url');
  });
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#refine-filters select').on('change', function () {
    setCount(this, false);
  });
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#done_filters').click(function (e) {
    if (!isSearch && window.rcProps.sidebarHref || isSearch && window.rcProps.search.sidebarHref) {
      // URL is changed by loadBrandsURL so just refresh page
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()(SELECTORS.sidebarClose).click();
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()(SELECTORS.sortRefineButton).length && __WEBPACK_IMPORTED_MODULE_0_jquery___default()(SELECTORS.sortRefineButton).attr('aria-expanded', false);
    } else {
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()(SELECTORS.refineButton).click();
    }
  });
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()(SELECTORS.refineButton).on('click', function () {
    if (__WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).hasClass('is-active')) {
      window.logEngagement(window.location.href, REFINE_MENU_MODULE, 'Click');
    }
  });
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()(SELECTORS.sortBy).on('click', function () {
    if (window.rcProps.plpStickyNav === true) {
      if (__WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).parents('.is-scrolled').length > 0) {
        window.logEngagementWithDetails(window.location.href, 'Sort By Dropdown', 'Click', "Plp StickyNav : fixed in scroll");
      } else {
        window.logEngagementWithDetails(window.location.href, 'Sort By Dropdown', 'Click', "Plp StickyNav : initial position");
      }
    } else {
      window.logEngagement(window.location.href, 'Sort By Dropdown', 'Click');
    }
  });
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()(SELECTORS.sortRefineButton).on('click', function () {
    if (window.rcProps.plpStickyNav === true) {
      if (__WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).parents('.is-scrolled').length > 0) {
        window.logEngagementWithDetails(window.location.href, 'Refine Sidebar', 'Click', "Plp StickyNav : fixed in scroll");
      } else {
        window.logEngagementWithDetails(window.location.href, 'Refine Sidebar', 'Click', "Plp StickyNav : initial position");
      }
    } else {
      window.logEngagement(window.location.href, 'Refine Sidebar', 'Click');
    }
  });
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()(SELECTORS.plpNavDropdown).on('click', function () {
    if (window.rcProps.plpStickyNav === true) {
      if (__WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).parents('.is-scrolled').length > 0) {
        window.logEngagementWithDetails(window.location.href, 'Nav Dropdown', 'Click', "Plp StickyNav : fixed in scroll");
      } else {
        window.logEngagementWithDetails(window.location.href, 'Nav Dropdown', 'Click', "Plp StickyNav : initial position");
      }
    } else {
      window.logEngagement(window.location.href, 'Nav Dropdown', 'Click');
    }
  });
}
function setCount(elem, clear) {
  if (clear) {
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()(elem).parent('label').find('.filter__item-count').text('');
    return false;
  }
  var $elem = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(elem); // select
  var $count = $elem.parent('label').find('.filter__item-count');
  var numSelectedOptions = $elem.val().length; // selects values amount - might need
  if (numSelectedOptions > 0) {
    $count.text("(".concat(numSelectedOptions, ")"));
  } else {
    $count.text('');
  }
}
function setFilterOptionSelectedByValue(filterElement, value) {
  if (value && filterElement.find('option[value="' + value + '"]').length > 0) {
    filterElement.val(value);
  }
}
function loadSearchFilterOptions(department, search) {
  __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.ajax({
    url: "/r/ajax/SearchFiltersOptions.jsp",
    dataType: "json",
    data: {
      "d": department,
      "search": search
    }
  }).done(function (data) {
    if (data.success) {
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#searchcategory, #searchdesigner').children().remove();
      __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.each(data.categories, function (i, optionData) {
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#searchcategory').append(__WEBPACK_IMPORTED_MODULE_0_jquery___default()('<option>').text(optionData.name).attr('value', optionData.value));
      });
      __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.each(data.designers, function (i, optionData) {
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#searchdesigner').append(__WEBPACK_IMPORTED_MODULE_0_jquery___default()('<option>').text(optionData.name).attr('value', optionData.value));
      });
    }
  });
}
function getSingleItemOption(element) {
  if (element && element.length > 0) {
    return element.val();
  } else {
    return '';
  }
}
function getMultiItemOptions(element, dataNameForOption) {
  var isSearch = isSearchPage();
  if (element && element.length > 0) {
    if (!isSearch && window.rcProps.sidebarHref || isSearch && window.rcProps.search.sidebarHref) {
      // Using checkboxes instead of <option> elements
      var checkedValues = [];
      element.find('input[type="checkbox"]:checked').each(function () {
        if (!dataNameForOption || __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).data('name') === dataNameForOption) {
          checkedValues.push(this.value);
        }
      });
      return checkedValues;
    } else {
      // Remove empty values (i.e., the "All" value) if there are other values
      // Customer will have to clear all filters or de-select filters to get back the "All" value
      var options = element.val();
      if (options && options.length > 1) {
        var rtn = [];
        for (var i = 0; i < options.length; i++) {
          if (options[i] !== '' && (!dataNameForOption || element.find("option[value=\"".concat(options[i], "\"]")).data('name') === dataNameForOption)) {
            rtn.push(options[i]);
          }
        }
        options = rtn;
      } else if (dataNameForOption && element.find('option:selected').data('name') !== dataNameForOption) {
        return [];
      }
      return options;
    }
  } else {
    return [''];
  }
}
function getQueryParamValues(url, param) {
  var result = [];
  if (url) {
    var paramsAndValues = url.slice(url.indexOf('?') + 1).split('&');
    for (var i = 0; i < paramsAndValues.length; i++) {
      if (paramsAndValues[i]) {
        var paramAndValue = paramsAndValues[i].split('=');
        if (2 == paramAndValue.length && param == paramAndValue[0] && paramAndValue[1]) {
          // Inverse of $.param, which is used in getFilterParams
          var value = decodeURIComponent(paramAndValue[1].replace(/\+/g, ' '));
          result.push(value);
        }
      }
    }
  }
  return result;
}
window.dynamicallyEnableDisableFilters = function (filterMenuList) {
  if (!filterMenuList) return -1;
  var isSearch = isSearchPage();
  for (var j = 0; j < filterMenuList.length; j++) {
    var filterMenu = filterMenuList[j];
    if (!filterMenu || !filterMenu.idForHTML || !filterMenu.filterMenuList) continue;
    var filterId = filterMenu.idForHTML;
    var isSelected = false;
    for (var i = 0; i < filterMenu.filterMenuList.length; i++) {
      var filterObj = filterMenu.filterMenuList[i];
      if (!filterObj) continue;
      if (filterObj.category === "sustainability") {
        updatePillarNavigation(filterObj);
      } else {
        var option = !isSearch && window.rcProps.sidebarHref || isSearch && window.rcProps.search.sidebarHref // If the sidebar UI AB test wins rename `option` to `input`
        ? __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#".concat(filterId, " input[value=\"").concat(filterObj.value, "\"]")) : __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#' + filterId + ' option[value="' + filterObj.value + '"]');
        if (option.length) {
          var propToCheck = !isSearch && window.rcProps.sidebarHref || isSearch && window.rcProps.search.sidebarHref ? 'checked' : 'selected';
          if (filterObj.disabled && option.prop(propToCheck)) {
            option.prop(propToCheck, false);
            option.trigger("change");
            return;
          } else {
            option.prop("disabled", filterObj.disabled);
            option.prop(propToCheck, filterObj.selected);
            if (filterObj.selected == true) {
              isSelected = true;
            }
          }
        }
        if (!isSearch && !window.rcProps.sidebarHref || isSearch && !window.rcProps.search.sidebarHref) {
          if (!isSelected) {
            var selectAllOption = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#' + filterId + ' .select_all');
            if (selectAllOption.length) {
              selectAllOption.prop('selected', true);
            }
          }
        }
      }
    }
  }
};
function updatePillarNavigation(filterObj) {
  if (filterObj.idForHTML) {
    var filter = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#' + filterObj.idForHTML);
    if (filter) {
      filter.prop('disabled', filterObj.disabled);
      var siblings = filter.siblings('label');
      var label = siblings && siblings.length > 0 ? __WEBPACK_IMPORTED_MODULE_0_jquery___default()(siblings[0]) : null;
      if (label) {
        if (filterObj.disabled) {
          label.addClass('sustainable__filter--disabled');
        } else {
          label.removeClass('sustainable__filter--disabled');
        }
      }
    }
  }
}
window.reloadBindJs = function () {
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()(SELECTORS.filterClickable).off().on('click', function (e) {
    e.preventDefault();
    loadBrandsURL(this);
  });
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()(SELECTORS.sortBy).off().on('change', function () {
    loadBrandsURL(this);
  });
  if (window.bindHeartItems) {
    window.bindHeartItems();
  }
  if (window.bindPlpSwatchJs) {
    window.bindPlpSwatchJs();
  }
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-lazy-image').lazy().lazy({
    effect: 'fadeIn',
    effectTime: 300,
    threshold: 900
  });
  if (typeof window.initColorSwatches == 'function') {
    window.initColorSwatches();
  }
  if (typeof window.loadShopMoreSection == 'function') {
    window.loadShopMoreSection();
  }
  if (typeof window.bindSimilarItemsExpansion == 'function') {
    window.bindSimilarItemsExpansion();
  }
  if (typeof window.loadPagination == 'function') {
    window.loadPagination();
  }
  if (typeof window.favoriteDesignerTrigger == 'function') {
    window.favoriteDesignerTrigger();
  }
  if (typeof window.bindPersonalShop === 'function') {
    window.bindPersonalShop();
  }
  if (__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-horizontal-scroll').length) {
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-horizontal-scroll').horizontalScroll();
  }
  if (window.rcProps.revieveEventEnabled) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__modules_revieve_try_on__["b" /* revieveTryOn */])({
      isPlp: true,
      checkAvailability: true
    });
  }
  if (window.rcProps.zeligWidgetLoaded) {
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-zelig-try-on').removeClass('u-hide');
  }
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-lazy-video').each(function () {
    this.play();
  });

  // loading yotpo star widget
  if (typeof yotpoWidgetsContainer !== 'undefined') {
    yotpoWidgetsContainer.initWidgets();
  }
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('[id$="-fav-select-size"]').each(function () {
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).sizeSelection();
  });
};
function ContentUpdate(pdpUrl, visualNavPageNum, isPagination) {
  var _$$val, _window$rcProps, _window$rcProps2;
  var canceled = false;
  var selectedDept = (_$$val = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('input[name="department"]:checked').val()) === null || _$$val === void 0 ? void 0 : _$$val.toLowerCase();
  var isMenSelected = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#isMen').val() === 'true' || isPersonalShop() && ((_window$rcProps = window.rcProps) === null || _window$rcProps === void 0 ? void 0 : _window$rcProps.isMen) || selectedDept === 'mens' // personal shop
  || isFavoritePage() && ((_window$rcProps2 = window.rcProps) === null || _window$rcProps2 === void 0 ? void 0 : _window$rcProps2.isMen); // my favorite
  var isKidSelected = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#isKid').val() === 'true';
  var department = 'Womens';
  var isMen = false;
  if (isMenSelected) {
    department = 'Mens';
    isMen = true;
  } else if (isKidSelected) {
    department = 'Kids';
  }
  var url = pdpUrl + "&d=" + department;
  var data = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.param({
    url: url,
    isMen: isMen
  });
  this.go = function () {
    if (!visualNavPageNum) {
      visualNavPageNum = 1;
    }
    var $loadVisualNav = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#loadVisNav');
    if ($loadVisualNav.length && $loadVisualNav.val() === 'true' && typeof window.doVisualSearch == 'function') {
      window.doVisualSearch(visualNavPageNum, function (filterMenuList) {
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#clear_filters').show();
        dynamicallyEnableDisableFilters(filterMenuList);
        reloadBindJs();
      });
    } else {
      __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.ajax({
        url: '/content/products/filtered-plp-contents/',
        data: data,
        dataType: 'json',
        type: 'POST',
        success: function success(data) {
          if (!canceled) {
            var $plp_product_contents_container = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#plp-products-contents');
            var $plp_editorial_cta_contrainer = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#plp-editorial-cta-wrapper-ajax');
            var $plp_pagination_container = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#plp-pagination-wrapper-ajax');
            var $plp_count = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#plp-item-count');
            var $showProductsCount = __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#showing-items-count");
            var $showPageCount = __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#total_pages");
            var $js_plp_count = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-plp-item-count');
            var $logo = window.rcProps.logoId ? __WEBPACK_IMPORTED_MODULE_0_jquery___default()(window.rcProps.logoId) : null;
            $plp_product_contents_container.html(data.plpMarkup);
            $plp_editorial_cta_contrainer.html(data.editorialCtaMarkup);
            if (data.paginationMarkup) {
              $plp_pagination_container.html(data.paginationMarkup);
            }
            if (data.productCount) {
              // formatted using the same JS snippet as on R Main
              $plp_count.html(data.productCount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","));
              if ($js_plp_count) {
                $js_plp_count.html($plp_count.html());
              }
            }
            if (data.pagetCount && $showPageCount) {
              $showPageCount.html(data.pageCount.toString());
            }
            if ($showProductsCount) {
              var productsCount = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-plp-prod-wrapper').find('li.js-plp-container').length;
              $showProductsCount.html(productsCount);
            }
            if ($logo && $logo.length && data.logoMarkup) {
              $logo.replaceWith(data.logoMarkup);
            }
            if (__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-view-more-btn').length > 0) {
              if (data.pageCount <= 1) {
                __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-view-more-btn').hide();
              } else {
                __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-view-more-btn').show();
              }
            }
            if (isPagination) {
              __WEBPACK_IMPORTED_MODULE_0_jquery___default()('html, body').scrollTop(0);
            }
            __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#clear_filters').show();
            dynamicallyEnableDisableFilters(data.filterMenuList);
            if (data.pillarFilters) {
              updatePillarNavigations(data.pillarFilters);
            }
            reloadBindJs();
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__modules_social_proof__["a" /* renderPlpSocialProof */])(__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-plp-container').toArray().map(function (el) {
              return __WEBPACK_IMPORTED_MODULE_0_jquery___default()(el).prop('id');
            }));
            updatePagination(location.href + location.search);
            insertPageTrackForMobile(false, null, null, null, false, false, false, true);
          } else {
            console.log("cancelled: " + pdpUrl);
          }
        },
        error: function error() {
          console.log("PLP filters ajax failed");
          window.location.assign(pdpUrl);
        }
      });
    }
    return this;
  };
  this.cancel = function () {
    canceled = true;
  };
}

//Closure and Currying
var updateContent = function () {
  var pending = null;
  return function (pdpUrl, visualNavPageNum, isPagination) {
    if (pending) {
      pending.cancel();
      pending = null;
    }
    pending = new ContentUpdate(pdpUrl, visualNavPageNum, isPagination).go();
    return pending;
  };
}();
function getUrlParams(currentUrl, excludeSortBy) {
  var urlParams = {
    path: currentUrl,
    catFilter: __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#category').val(),
    designers: __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#alldesigners').length ? getMultiItemOptions(__WEBPACK_IMPORTED_MODULE_0_jquery___default()('#alldesigners')) : __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#searchdesigner').length ? getSingleItemOption(__WEBPACK_IMPORTED_MODULE_0_jquery___default()('#searchdesigner')) : getQueryParamValues(window.location.href, 'designer'),
    sizes: getMultiItemOptions(__WEBPACK_IMPORTED_MODULE_0_jquery___default()('#allsizes')),
    colors: getMultiItemOptions(__WEBPACK_IMPORTED_MODULE_0_jquery___default()('#allcolors')),
    prices: getMultiItemOptions(__WEBPACK_IMPORTED_MODULE_0_jquery___default()('#allprices')),
    heels: getMultiItemOptions(__WEBPACK_IMPORTED_MODULE_0_jquery___default()('#heel')),
    lengths: getMultiItemOptions(__WEBPACK_IMPORTED_MODULE_0_jquery___default()("#length")),
    sleeves: getMultiItemOptions(__WEBPACK_IMPORTED_MODULE_0_jquery___default()("#sleeve")),
    rises: getMultiItemOptions(__WEBPACK_IMPORTED_MODULE_0_jquery___default()("#rise")),
    fragrances: getMultiItemOptions(__WEBPACK_IMPORTED_MODULE_0_jquery___default()("#fragrance")),
    conditions: getMultiItemOptions(__WEBPACK_IMPORTED_MODULE_0_jquery___default()("#condition")),
    featuredCodes: getQueryParamValues(currentUrl, 'featuredCodes'),
    arrivalDate: __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#newarrivals').length > 0 ? __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#newarrivals input[name="newDate"]:checked').val() : '',
    pageNum: parseInt(__WEBPACK_IMPORTED_MODULE_0_jquery___default()('#pageNum_param').val()),
    department: window.rcProps.search.sidebarHref ? __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#department input:checked').val() : getSingleItemOption(__WEBPACK_IMPORTED_MODULE_0_jquery___default()('#department')),
    searchcategory: getSingleItemOption(__WEBPACK_IMPORTED_MODULE_0_jquery___default()('#searchcategory'))
  };

  // combined filter for length and rise
  if (__WEBPACK_IMPORTED_MODULE_0_jquery___default()('#length_rise').length) {
    urlParams.lengths = getMultiItemOptions(__WEBPACK_IMPORTED_MODULE_0_jquery___default()('#length_rise'), 'length');
    urlParams.rises = getMultiItemOptions(__WEBPACK_IMPORTED_MODULE_0_jquery___default()('#length_rise'), 'rise');
  }
  if (window.rcProps.search.sidebarHref) {
    urlParams.category = getMultiItemOptions(__WEBPACK_IMPORTED_MODULE_0_jquery___default()('#allcategories'));
  }
  if (!excludeSortBy) {
    var isSearch = isSearchPage();
    var sortBySelector = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#sortby option:selected');
    if (sortBySelector.length) {
      urlParams.sortBy = sortBySelector.val();
    }
  }
  __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.each(addtionalFilterArray, function (index, value) {
    if (__WEBPACK_IMPORTED_MODULE_0_jquery___default()('#' + value).length > 0) {
      urlParams[value] = getMultiItemOptions(__WEBPACK_IMPORTED_MODULE_0_jquery___default()('#' + value));
    }
  });
  var filterInteractions = window.rcProps ? window.rcProps.filters_send_false : {};
  checkboxFilterNames.forEach(function (inputName) {
    urlParams[inputName] = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('input[name="' + inputName + '"]').toArray().filter(function (el) {
      var $el = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(el);
      if (!$el.is(':checked')) {
        return true;
      }
      if (checkboxFiltersForcedFalseObj[inputName] !== undefined) {
        if (filterInteractions[inputName]) {
          return true;
        } else {
          // Some checkboxes need `false` to be sent to the server when they are unchecked
          // (e.g., in_stock) because they persist for the session
          return 'false';
        }
      }
    }).map(function (el) {
      var $el = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(el);
      return $el.is(':checked') ? $el.val() : 'false';
    });
  });
  return urlParams;
}
function isFavoritePage() {
  return window.location.href.indexOf('mr_favorites') > -1;
}
function isPersonalShop() {
  return window.location.href.indexOf('myfav/designers') > -1;
}
function isSearchPage() {
  return window.location.href.indexOf('SearchResult.jsp') > -1;
}
function isNewPage() {
  return __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#newarrivals').length > 0;
}
function isBiBestSellersPage() {
  return window.location.href.indexOf('/content/best-sellers/mobile/') > -1;
}
function loadBrandsURL(elem, resetToPageOne, appendParamsToDropdownNav) {
  if (elem === 'undefined') return;
  // ab3336 - trigger custom event when a filter is selected
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).trigger("filterSelected");
  var currentUrl = window.location.href;
  var sortByElementTriggeredChange = elem.id === 'sortby';
  if (sortByElementTriggeredChange) {
    currentUrl = removeURLParameter(currentUrl, "featuredCodes");
  } else {
    currentUrl = removeURLParameter(currentUrl, 'sortBy');
  }
  var urlParams = getUrlParams(currentUrl, !sortByElementTriggeredChange);
  var isNew = isNewPage();
  var selectFromCategory = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(elem).closest('div').prop('id') === 'plp_filter_dd';
  // category filters
  if (selectFromCategory) {
    urlParams.path = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(elem).data('caturl');
    resetFilters(urlParams);
  }

  // new arrival dates
  if (isNew && !selectFromCategory) {
    urlParams.path = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#newarrivals input[name="newDate"]:checked').data('url');
    urlParams.arrivalDate = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#newarrivals input[name="newDate"]:checked').val();
  }

  // pagination
  var isPagination = false;
  if (elem.id === 'prev_btn') {
    urlParams.pageNum = urlParams.pageNum - 1;
    isPagination = true;
  }
  if (elem.id === 'next_btn') {
    urlParams.pageNum = urlParams.pageNum + 1;
    isPagination = true;
  }
  if (__WEBPACK_IMPORTED_MODULE_0_jquery___default()(elem).hasClass("pagination__link")) {
    urlParams.pageNum = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(elem).data("pageNo");
    isPagination = true;
  }
  if (resetToPageOne) {
    urlParams.pageNum = 1;
  }
  var isFavorites = isFavoritePage();
  var newURL = '';
  var alreadyParams = urlParams.path && urlParams.path.indexOf("?") > -1;
  //var isPrettyURL = (urlParams.path.indexOf(".jsp") < 0);
  urlParams.path = removeFilterParams(urlParams);
  urlParams.path = removeParam(urlParams, "arrivalDate");
  if (alreadyParams) {
    newURL = urlParams.path + getFilterParams(urlParams);
  } else {
    newURL = urlParams.path + '?' + getFilterParams(urlParams);
  }

  // append arrival date for selected status
  if (isNew) newURL = newURL + "&arrivalDate=" + urlParams.arrivalDate;
  var loadVisualNav = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#loadVisNav');
  if (loadVisualNav.length && loadVisualNav.val() === 'true') {
    newURL = newURL + "&loadVisNav=true";
  }

  //update 'filters' param
  var filtersObj = updateUrlForFiltersParam(newURL);
  var useRefineSidebar = window.rcProps.sidebarHref || window.rcProps.search.sidebarHref;
  if (isBiBestSellersPage()
  // only reloading page if clearing filters for non-sidebar UI (i.e., group A for AB test)
  || !isPagination && (!filtersObj.isAddedFilter && !useRefineSidebar || !__WEBPACK_IMPORTED_MODULE_0_jquery___default()("#plp-products-contents").length)) {
    window.location.assign(filtersObj.url);
  } else {
    if (!selectFromCategory && !isPagination && !isNew && appendParamsToDropdownNav) {
      appendFilterParamsToDropdownNav(urlParams, filtersObj);
    }
    //remove hash and update main window url, but not redirect
    removeHash(filtersObj.url);
    updateContent(filtersObj.url, 1, isPagination);
    var filterCount = 0;
    for (var i = 0; i < filterNames.length; i++) {
      var filterNameValue = filterNames[i];
      var filterName = filterNameValue in filterNamesToUrlParamsMap ? filterNamesToUrlParamsMap[filterNameValue] : filterNameValue;
      if (urlParams[filterName] && urlParams[filterName].length > 0) {
        for (var j = 0; j < urlParams[filterName].length; j++) {
          if (!urlParams[filterName][j].match(/^\s*$/)) {
            // filter out whitespace values
            filterCount++;
          }
        }
      }
    }
    filterCount += __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-smart-filter:checked').length;
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-filter-count').text(filterCount > 0 ? '(' + filterCount + ')' : '');
  }
}
function keepFilters() {
  return window.rcProps && window.rcProps.keepRefineFilter;
}
function appendFilterParamsToDropdownNav(urlParams, filtersObj) {
  if (!keepFilters() || !filtersObj) {
    return;
  }
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-page-header__nav-list li.ui-list__item a').each(function () {
    var baseUrl = removeURLParameters(__WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).attr("href"), filterNames);
    var newUrl = replaceURLParameters(baseUrl, getFilterParams(urlParams));
    newUrl = clearQueryParameters(newUrl, {
      pageNum: true,
      filter: true,
      sortBy: true
    });
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).attr("href", filtersObj.filtersApplied ? replaceURLParameters(newUrl, "filters=" + filtersObj.filtersApplied) : clearQueryParameters(newUrl, {
      "filters": true
    }));
  });
}
function updatePagination(url) {
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.pagination__list .filters__pagination-item a').each(function () {
    var newUrl = clearQueryParameters(url, {
      pageNum: true
    });
    var page = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).data('pageNo');
    var query = 'pageNum=' + page;
    newUrl = newUrl + (newUrl.indexOf("?") > -1 ? "&" : "?") + query;
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).attr("href", newUrl);
  });
}
function updateDropdownNavURLsOnLoad() {
  if (!keepFilters()) {
    return;
  }
  if (__WEBPACK_IMPORTED_MODULE_0_jquery___default()('#clear_filters').css('display') !== 'none' && !isNewPage() && !isSearchPage() && !isFavoritePage() && !isPersonalShop()) {
    var currentUrl = window.location.href;
    var urlParams = getUrlParams(currentUrl);
    var filtersObj = updateUrlForFiltersParam(currentUrl);
    appendFilterParamsToDropdownNav(urlParams, filtersObj);
  }
}
function updateUrlForFiltersParam(url) {
  var filtersApplied = '';
  var urlArray = url.split("?");
  if (urlArray.length > 1) {
    filtersApplied = getFiltersApplied(urlArray[1]);
  } else {
    return url;
  }
  var filtersNotApplied = {};
  url = removeURLParameter(url, filtersParamName);
  var isAddedFilter = false;
  __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.each(filterNames, function (index, value) {
    if (url.indexOf(value + '=') >= 0 || url.indexOf(value + '%5B%5D=') >= 0) {
      isAddedFilter = true;
      if (filtersApplied.indexOf(value) < 0) {
        filtersApplied = addFilterApplied(filtersApplied, value);
      }
    } else {
      filtersNotApplied[value] = true;
    }
  });
  for (var filterType in filtersNotApplied) {
    filtersApplied = removeFilterApplied(filtersApplied, filterType);
  }
  if (filtersApplied) {
    url = replaceURLParameters(url, filtersParamName + '=' + filtersApplied);
  } else {
    url = clearQueryParameters(url, {
      filters: ''
    });
  }
  return {
    url: url,
    isAddedFilter: isAddedFilter,
    filtersApplied: filtersApplied
  };
}
function removeURLParameters(url, parameterNameList) {
  if (url && parameterNameList.length > 0) {
    parameterNameList.forEach(function (parameterName) {
      url = removeURLParameter(url, parameterName);
      url = removeURLParameter(url, parameterName + "[]");
    });
  }
  return url;
}
function clearQueryParameters(url, params) {
  for (var p in params) {
    url = removeURLParameter(url, p);
    url = removeURLParameter(url, p + "[]");
  }
  return url;
}
function appendQuery(url, query) {
  if ("" == query) {
    return url;
  }
  query = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('<div/>').html(query).text();
  return url + (url.indexOf("?") > -1 ? "&" : "?") + query;
}
function replaceURLParameters(url, parameterString) {
  if (!parameterString) return url;
  var parameters = parameterString.split('&');
  var rtn = url;
  var tmp = '';
  if (parameters) {
    for (var i = 0; i < parameters.length; i++) {
      var p = parameters[i];
      if (p) {
        var parameterPair = p.split('=');
        if (parameterPair && parameterPair.length == 2) {
          rtn = removeURLParameter(rtn, parameterPair[0]);
        }
        tmp = appendQuery(tmp, p);
      }
    }
    rtn = safeConcat(rtn, tmp);
  }
  return rtn;
}
function addFilterApplied(filtersAppliedDelimited, filterToAdd) {
  if (filtersAppliedDelimited.indexOf(filterToAdd) >= 0) return filtersAppliedDelimited;
  return (filtersAppliedDelimited && filtersAppliedDelimited.length > 0 ? filtersAppliedDelimited + filtersAppliedDelimiter : '') + filterToAdd;
}
function removeFilterApplied(filtersAppliedDelimited, filterToRemove) {
  if (filtersAppliedDelimited.indexOf(filterToRemove) == -1) return filtersAppliedDelimited;
  var regex = new RegExp(filterToRemove);
  return filtersAppliedDelimited.replace(regex, '').replace(doubleRegex, filtersAppliedDelimiter).replace(atStartRegex, '').replace(atEndRegex, '');
}
function getFiltersApplied(fullQueryString) {
  if (fullQueryString) {
    var qs = fullQueryString.split('&');
    if (qs) {
      for (var i = 0; i < qs.length; ++i) {
        var p = qs[i].split('=', 2);
        if (p[0] === 'filters') {
          if (p.length == 1) {
            return '';
          } else {
            return decodeURIComponent(p[1].replace(/\+/g, " ")).replace(/^=/, "");
          }
        }
      }
    }
  }
  return '';
}
function removeHash(url) {
  var scrollV,
    scrollH,
    loc = window.location;
  if ("pushState" in history) {
    var urlWithoutHash = url ? url.replace('#', '') : loc.href + loc.search; // Last ditch effort to remove hash
    history.pushState("", document.title, urlWithoutHash);
  } else {
    // Prevent scrolling by storing the page's current scroll offset
    scrollV = document.body.scrollTop;
    scrollH = document.body.scrollLeft;
    loc.hash = "";

    // Restore the scroll offset, should be flicker free
    document.body.scrollTop = scrollV;
    document.body.scrollLeft = scrollH;
  }
}
function resetFilters(urlParams) {
  urlParams.designers = [''];
  urlParams.sizes = [''];
  urlParams.colors = [''];
  urlParams.prices = [''];
  urlParams.heels = [''];
  urlParams.lengths = [''];
  urlParams.sleeves = [''];
  urlParams.rises = [''];
  urlParams.fragrances = [''];
  urlParams.conditions = [''];
  urlParams.featuredCodes = [''];
  urlParams.arrivalDate = '';
  urlParams.catFilter = '';
  urlParams.pageNum = 1;
  urlParams.searchcategory = '';
  __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.each(addtionalFilterArray, function (index, value) {
    if (__WEBPACK_IMPORTED_MODULE_0_jquery___default()('#' + value).length > 0) {
      urlParams[value] = [''];
    }
  });
  checkboxFilterNames.forEach(function (inputName) {
    urlParams[inputName] = [];
  });
}
function getFilterParams(urlParams) {
  var newURL = urlParams.sortBy ? '&sortBy=' + urlParams.sortBy : '';
  var i = 0;
  if (urlParams.designers && urlParams.designers[0]) {
    if (urlParams.designers.length === 1) newURL += '&' + __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.param({
      designer: urlParams.designers[0]
    });else newURL += '&' + __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.param({
      designer: urlParams.designers
    }, true);
  }
  if (urlParams.sizes && urlParams.sizes[0]) {
    newURL += '&' + __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.param({
      size: urlParams.sizes
    }, true);
  }
  if (urlParams.colors && urlParams.colors[0]) {
    newURL += '&' + __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.param({
      color: urlParams.colors
    }, true);
  }
  if (urlParams.prices && urlParams.prices[0]) {
    newURL += '&' + __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.param({
      price: urlParams.prices
    }, true);
  }
  if (urlParams.heels && urlParams.heels[0]) {
    newURL += '&' + __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.param({
      heel: urlParams.heels
    }, true);
  }
  if (urlParams.lengths && urlParams.lengths[0]) {
    newURL += '&' + __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.param({
      length: urlParams.lengths
    }, true);
  }
  if (urlParams.sleeves && urlParams.sleeves[0]) {
    newURL += '&' + __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.param({
      sleeve: urlParams.sleeves
    }, true);
  }
  if (urlParams.rises && urlParams.rises[0]) {
    newURL += '&' + __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.param({
      rise: urlParams.rises
    }, true);
  }
  if (urlParams.fragrances && urlParams.fragrances[0]) {
    newURL += '&' + __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.param({
      fragrance: urlParams.fragrances
    }, true);
  }
  if (urlParams.conditions && urlParams.conditions[0]) {
    newURL += '&' + __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.param({
      condition: urlParams.conditions
    }, true);
  }
  __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.each(addtionalFilterArray, function (index, value) {
    if (urlParams[value] && urlParams[value][0]) {
      var tempObj = {};
      tempObj[value] = urlParams[value];
      newURL += '&' + __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.param(tempObj);
    }
  });
  checkboxFilterNames.forEach(function (inputName) {
    if (urlParams[inputName]) {
      var obj = {};
      if (urlParams[inputName].length === 1 && typeof urlParams[inputName][0] != 'undefined') {
        obj[inputName] = urlParams[inputName][0];
        newURL += '&' + __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.param(obj);
      } else if (urlParams[inputName].length > 1) {
        obj[inputName] = urlParams[inputName];
        newURL += '&' + __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.param(obj, true);
      }
    }
  });
  if (urlParams.featuredCodes) {
    for (i = 0; i < urlParams.featuredCodes.length; i++) {
      if (urlParams.featuredCodes[i] != '') {
        newURL = newURL + '&featuredCodes=' + urlParams.featuredCodes[i];
      }
    }
  }
  if (urlParams.catFilter) {
    newURL = newURL + '&catFilter=' + urlParams.catFilter;
  }
  if (urlParams.category && urlParams.category[0]) {
    newURL += '&' + __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.param({
      category: urlParams.category
    }, true);
  }
  if (urlParams.department) {
    newURL = newURL + '&d=' + urlParams.department;
  }
  if (__WEBPACK_IMPORTED_MODULE_0_jquery___default()('#searchcategory').length && urlParams.searchcategory) {
    newURL = newURL + '&s=c&c=' + encodeURIComponent(urlParams.searchcategory);
  }
  if (urlParams.pageNum && urlParams.pageNum > 0) {
    newURL = newURL + '&pageNum=' + urlParams.pageNum;
  }
  return newURL;
}

// Prepare the path string.
// If '?' is not followed by '&' then replace it with with '?&'
function prepareForSafeRemove(path) {
  var rePrepare = /\?(?!&)/;
  path = path.replace(rePrepare, "?&");
  return path;
}

// Remove all occurrences of param and its values
function safeRemoveParam(path, param) {
  var reRemove = new RegExp("[&]+" + param + "=[^&\\b]*", "g");
  path = path.replace(reRemove, '');
  return path;
}

// Cleanup the path.
// Replace '?&' with '?
function cleanUpAfterSafeRemove(path) {
  var reCleanup = /\?&+/;
  path = path.replace(reCleanup, '?');
  var reCleanupMultiAmp = new RegExp("&{2,}", "g");
  path = path.replace(reCleanupMultiAmp, '&');
  return path;
}
function removeFilterParams(urlParams) {
  var resultPath = urlParams.path;
  resultPath = prepareForSafeRemove(resultPath);
  resultPath = safeRemoveParam(resultPath, "sortBy");
  resultPath = safeRemoveParam(resultPath, "designer");
  resultPath = safeRemoveParam(resultPath, "designer%5B%5D");
  resultPath = safeRemoveParam(resultPath, "size");
  resultPath = safeRemoveParam(resultPath, "size%5B%5D");
  resultPath = safeRemoveParam(resultPath, "color");
  resultPath = safeRemoveParam(resultPath, "color%5B%5D");
  resultPath = safeRemoveParam(resultPath, "price");
  resultPath = safeRemoveParam(resultPath, "price%5B%5D");
  resultPath = safeRemoveParam(resultPath, "heel");
  resultPath = safeRemoveParam(resultPath, "heel%5B%5D");
  resultPath = safeRemoveParam(resultPath, "length");
  resultPath = safeRemoveParam(resultPath, "length%5B%5D");
  resultPath = safeRemoveParam(resultPath, "sleeve");
  resultPath = safeRemoveParam(resultPath, "sleeve%5B%5D");
  resultPath = safeRemoveParam(resultPath, "rise");
  resultPath = safeRemoveParam(resultPath, "fragrance");
  resultPath = safeRemoveParam(resultPath, "rise%5B%5D");
  resultPath = safeRemoveParam(resultPath, "fragrance%5B%5D");
  resultPath = safeRemoveParam(resultPath, "condition");
  resultPath = safeRemoveParam(resultPath, "condition%5B%5D");
  resultPath = safeRemoveParam(resultPath, "featuredCodes");
  resultPath = safeRemoveParam(resultPath, "catFilter");
  resultPath = safeRemoveParam(resultPath, "pageNum");
  resultPath = safeRemoveParam(resultPath, "category");
  if (__WEBPACK_IMPORTED_MODULE_0_jquery___default()('#department').length) {
    // remove d path param only when department filter is applied
    // currently department filter is used on search result page only
    resultPath = safeRemoveParam(resultPath, "d");
  }
  if (__WEBPACK_IMPORTED_MODULE_0_jquery___default()('#searchcategory').length) {
    // remove s and c path params only when search category filter is applied
    resultPath = safeRemoveParam(resultPath, "s");
    resultPath = safeRemoveParam(resultPath, "c");
  }
  __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.each(addtionalFilterArray, function (index, value) {
    resultPath = safeRemoveParam(resultPath, value);
    resultPath = safeRemoveParam(resultPath, value + "%5B%5D");
  });
  checkboxFilterNames.forEach(function (inputName) {
    resultPath = safeRemoveParam(resultPath, inputName);
    resultPath = safeRemoveParam(resultPath, inputName + "%5B%5D");
  });
  resultPath = cleanUpAfterSafeRemove(resultPath);
  return resultPath;
}
function removeParam(urlParams, paramName) {
  var resultPath = urlParams.path;
  resultPath = prepareForSafeRemove(resultPath);
  resultPath = safeRemoveParam(resultPath, paramName);
  resultPath = cleanUpAfterSafeRemove(resultPath);
  return resultPath;
}
function removeURLParameter(url, parameter) {
  //prefer to use l.search if you have a location/link object
  var urlparts = url.split('?');
  if (urlparts.length >= 2) {
    var encodedPrefix = encodeURIComponent(parameter) + '=';
    var unencodedPrefix = parameter + '=';
    var pars = urlparts[1].split(/[&;]/g);

    //reverse iteration as may be destructive
    for (var i = pars.length; i-- > 0;) {
      //idiom for string.startsWith
      if (pars[i].lastIndexOf(encodedPrefix, 0) !== -1) {
        pars.splice(i, 1);
      } else if (pars[i].lastIndexOf(unencodedPrefix, 0) !== -1) {
        pars.splice(i, 1);
      }
    }
    url = urlparts[0] + (pars.length > 0 ? '?' + pars.join('&') : "");
    return url;
  } else {
    return url;
  }
}
function safeConcat(url, paramString) {
  var result = '';

  // get rid of the leading '?' or '&' characters
  paramString = removeLeadingChars(paramString);
  var endsWithAmpOrQuestion = /[\?&]$/;
  if (url.indexOf('?') > -1) {
    if (url.match(endsWithAmpOrQuestion)) {
      result = url + paramString;
    } else {
      result = url + '&' + paramString;
    }
  } else {
    result = url + '?' + paramString;
  }
  return result;
}

// Remove the leading '?' or '&' characters
function removeLeadingChars(paramString) {
  // remove RegExp
  var re = /^[?&]+/;
  return paramString.replace(re, '');
}
function submitSmartFilters() {
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-modal-close').trigger('mousedown');
  var data = getSmartFilters();
  var filtersToClear = {
    pageNum: true
  };
  filtersToClear[SMART_FILTER_PARAM] = true;
  var windowUrl = appendQuery(clearQueryParameters(window.location.href, filtersToClear), data);
  removeHash(windowUrl);
  updateContent(windowUrl, 1);
  updateSmartFiltersCount();
}
function getSmartFilters() {
  return __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#smart-filters-form').serializeArray().map(function (filter) {
    return "".concat(SMART_FILTER_PARAM, "=").concat(filter.name).concat(DELIMITER).concat(filter.value);
  }).join('&');
}
function updateSmartFiltersCount() {
  var numSelected = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#smart-filters input:checked').length;
  if (numSelected) {
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#smart-filters-count').text(" (".concat(numSelected, ")"));
  } else {
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#smart-filters-count').text("");
  }
}

/***/ }),
/* 22 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return revieveTryOn; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return revieveAddToBag; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styleguide_lib_merge_options__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_modules_add_to_bag__ = __webpack_require__(6);



var DEFAULTS = {};
var CONTAINER_CLASS = '.js-revieve-container';
var BUTTON_CLASS = '.js-revieve-try-on';
var revieveTryOn = function revieveTryOn(options) {
  var $el = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(BUTTON_CLASS);
  var opts = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_styleguide_lib_merge_options__["a" /* default */])(DEFAULTS, options, $el);
  if ($el.length) {
    window.activateRevieveFullLook(function () {
      try {
        if (opts.isPlp) {
          if (opts.checkAvailability) {
            var codes = [];
            __WEBPACK_IMPORTED_MODULE_0_jquery___default()('li.js-plp-container').each(function (index, element) {
              var $element = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(element);
              $element.attr('data-loader', 'tryOnLoader');
            });
            __WEBPACK_IMPORTED_MODULE_0_jquery___default()('li.js-plp-container').Lazy({
              tryOnLoader: function tryOnLoader(element, response) {
                var $element = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(element);
                var code = $element.attr('id');
                Revieve.API.liveAR.isTryOnAvailable({
                  product_id: code
                }, function (available) {
                  if (available) {
                    $element.find(CONTAINER_CLASS).removeClass('u-hide');
                    codes.push(code);
                  }
                });
              }
            });
            Revieve.API.liveAR.loadTryOnProducts(codes);
          }
        } else {
          Revieve.API.liveAR.isTryOnAvailable({
            product_id: opts.code
          }, function (available) {
            if (available) {
              __WEBPACK_IMPORTED_MODULE_0_jquery___default()(CONTAINER_CLASS).removeClass('u-hide');
            }
          });
        }
      } catch (ignored) {}
      setEventListeners();
    });
  }
};
var revieveAddToBag = function revieveAddToBag() {
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()(window).on('revieveAddToBag', function (e, data) {
    data.products.forEach(function (product) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_modules_add_to_bag__["a" /* addToBagWithData */])({
        colorSelect: product.id,
        sizeSelect: 'all',
        count: 1,
        sectionURL: data.sectionUrl,
        csrfHash: data.csrfHash,
        src: 'revieve_atc'
      }, {
        success: function success(obj) {
          // start GA add to cart
          gaAddToCartActionProduct('add', {
            code: '' + product.id + '',
            name: product.name,
            category: obj.msg16,
            brand: obj.msg3,
            variant: 'all',
            price: obj.msg15,
            quantity: 1
          });
          // end GA add to cart

          if (pushAddProductToCordial === 'function') {
            pushAddProductToCordial(product.name, product.id, obj.msg15, obj.msg3, obj.msg16, null, obj.msg28, 1, obj.msg29, obj.msg30);
          }
          if (insertFacebookAddToCart === 'function') {
            insertFacebookAddToCart(null, product.id, obj.msg15, 'all');
          }
          if (typeof addToCartPinterest === 'function') {
            addToCartPinterest(product.id, obj.msg15, 1);
          }
          if (typeof addToCartReddit === 'function') {
            var cartItems = [{
              productCode: product.id,
              productName: product.name,
              productCategory: obj.msg16
            }];
            addToCartReddit(cartItems, obj.msg15, product.id, product.name, obj.msg16);
          }
          if (typeof spanglePixelAddToCart === 'function') {
            spanglePixelAddToCart(product.id, obj.msg15, 1);
          }
          if (typeof insertPageTrackForMobileWithData === 'function') {
            insertPageTrackForMobileWithData({
              addToCartFlag: true,
              productCode: product.id,
              src: 'revieve_atc'
            });
          }
        }
      });
    });
  });
};
function setEventListeners() {
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).on('click', BUTTON_CLASS, function (e) {
    e.preventDefault();
    var productCode = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(e.target).data('code');
    if (window.rcProps.activeRevievePlugin === 'FULL_LOOK') {
      openPlugin(productCode);
    } else {
      window.activateRevieveFullLook(function () {
        openPlugin(productCode);
      });
    }
  });
}
function openPlugin(code) {
  Revieve.API.liveAR.addTryOnProduct(code);
  Revieve.API.show();
  // VTO stands for Virtual Try On
  logEngagement(window.location.href, 'VTO', 'Open');
}

/***/ }),
/* 23 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return renderPdpSocialProof; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return renderPlpSocialProof; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return renderCartSocialProof; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);

var DEFAULT_ANIMATE_PARAMS = {
  outCss: {
    opacity: 0
  },
  inCss: {
    opacity: 1
  },
  fade: 750,
  hold: 1500,
  keep: true
};
var PageType = Object.freeze({
  PDP: {
    name: 'PDP',
    getContainer: function getContainer(code) {
      return __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#detailsMarkup .sp-wrapper');
    },
    animateParams: {
      keep: false
    }
  },
  PLP: {
    name: 'PLP',
    getContainer: function getContainer(code) {
      return __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#".concat(code, " .sp-wrapper"));
    }
  },
  CART: {
    name: 'CART',
    getContainer: function getContainer(code) {
      return __WEBPACK_IMPORTED_MODULE_0_jquery___default()(".js-product-in-bag[data-code='".concat(code, "'] .sp-wrapper"));
    },
    title: false
  }
});
function render(pageType, codes) {
  var urlParams = new URLSearchParams(window.location.search);
  var forceParam = window.rcProps.socialProof.forceParam;
  __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.ajax({
    url: "".concat(window.rcProps.socialProof.href, "?").concat(forceParam, "=").concat(urlParams.get(forceParam) || ''),
    method: 'POST',
    data: JSON.stringify({
      type: pageType.name,
      codes: Array.isArray(codes) ? codes : [codes]
    }),
    dataType: 'json',
    contentType: 'application/json'
  }).done(function (result) {
    var animateParams = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.extend(DEFAULT_ANIMATE_PARAMS, pageType.animateParams);
    result.forEach(function (socialProof) {
      if (socialProof.productCode) {
        var promise = Promise.resolve();
        var _loop = function _loop() {
          var message = socialProof.messages[i];
          var $container = pageType.getContainer(socialProof.productCode).first();
          if ($container.length) {
            promise = promise.then(function () {
              return new Promise(function (resolve) {
                var $message = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(message.message).css(animateParams.outCss);
                if (pageType.title === false) {
                  $message.find('.sp-title').hide();
                }
                $container.append($message.animate(animateParams.inCss, animateParams.fade, function () {
                  if (!animateParams.keep) {
                    setTimeout(function () {
                      $message.css(animateParams.outCss);
                      setTimeout(function () {
                        $container.empty();
                        resolve();
                      }, animateParams.fade);
                    }, animateParams.hold);
                  }
                }));
              });
            });
          }
        };
        for (var i = 0; i < socialProof.messages.length; i++) {
          _loop();
        }
      }
    });
  }).fail(function (error) {
    console.error(error);
  });
}
var renderPdpSocialProof = function renderPdpSocialProof(codes) {
  return render(PageType.PDP, codes);
};
var renderPlpSocialProof = function renderPlpSocialProof(codes) {
  return render(PageType.PLP, codes);
};
var renderCartSocialProof = function renderCartSocialProof(codes) {
  return render(PageType.CART, codes);
};

/***/ }),
/* 24 */
/***/ (function(module, exports) {

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

module.exports = eq;


/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__(92),
    isLength = __webpack_require__(93);

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

module.exports = isArrayLike;


/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

var arrayLikeKeys = __webpack_require__(130),
    baseKeysIn = __webpack_require__(381),
    isArrayLike = __webpack_require__(25);

/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */
function keysIn(object) {
  return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
}

module.exports = keysIn;


/***/ }),
/* 27 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export TEMPLATE_REGULAR */
/* unused harmony export TEMPLATE_ON_SALE */
/* harmony export (immutable) */ __webpack_exports__["a"] = updatePrice;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_constants_pdp__ = __webpack_require__(36);
/**
 * Updates price displayed when stock id changes
 * @module modules/updatePrice
 */




/**
 * data attributes attached to the price element
 * used to explicitly declare template id's
 */
var TEMPLATE_REGULAR = 'template-regular';
var TEMPLATE_ON_SALE = 'template-on-sale';

/**
 * Update price based on selected value.
 * @param {HTMLElement} wrap - Product wrap
 * @param {Object} chosen - Object representing data from selected option of
 * select dropdown (or input for 1 size)
 */
function updatePrice(_ref) {
  var wrap = _ref.wrap,
    _ref$chosen = _ref.chosen,
    chosen = _ref$chosen === void 0 ? {} : _ref$chosen;
  var price = chosen.price,
    regularPrice = chosen.regularPrice,
    isOnSale = chosen.isOnSale,
    saleDiscountPriceFormatted = chosen.saleDiscountPriceFormatted;
  var priceFormatted = chosen.priceFormatted,
    regularPriceFormatted = chosen.regularPriceFormatted;
  var $assignedDefectItemPrice = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#assignedSellableDefectItemPrice');
  var $assignedDefectItemOriginPrice = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#assignedSellableDefectItemOriginPrice');
  var isAssignedDefectItemPage = $assignedDefectItemPrice.length && $assignedDefectItemPrice.val().length > 0 && $assignedDefectItemOriginPrice.length && $assignedDefectItemOriginPrice.val().length > 0;

  // get the price element
  var $priceEl = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(wrap).find(".".concat(__WEBPACK_IMPORTED_MODULE_1__lib_constants_pdp__["a" /* PRODUCT_BLOCK */], "__").concat(__WEBPACK_IMPORTED_MODULE_1__lib_constants_pdp__["b" /* PRICE_BLOCK */], ":not(.").concat(__WEBPACK_IMPORTED_MODULE_1__lib_constants_pdp__["a" /* PRODUCT_BLOCK */], "__").concat(__WEBPACK_IMPORTED_MODULE_1__lib_constants_pdp__["b" /* PRICE_BLOCK */], "-").concat(__WEBPACK_IMPORTED_MODULE_1__lib_constants_pdp__["c" /* RANGE_BLOCK */], ")"));
  if ($priceEl.data(__WEBPACK_IMPORTED_MODULE_1__lib_constants_pdp__["d" /* SKIP_PRICE_UPDATE */])) {
    return;
  }

  // get the template style from the price element
  var attr = isOnSale ? TEMPLATE_ON_SALE : TEMPLATE_REGULAR;
  if (isAssignedDefectItemPage) {
    attr = TEMPLATE_ON_SALE;
  }
  var templateId = $priceEl.data(attr);

  // get the template
  var template = document.getElementById(templateId);
  if (!template) {
    throw new Error('Price template not found');
  }

  // update price
  var templateContent = document.importNode(template.content, true);

  // if no price-formatted or regular-price-formatted data attributes defined
  if (!priceFormatted) {
    priceFormatted = price;
  }
  if (!regularPriceFormatted) {
    var currencySymbolEl = templateContent.querySelector('span') || {
      innerHTML: ''
    };
    regularPriceFormatted = currencySymbolEl.innerHTML + regularPrice;
  }
  var priceEl = templateContent.querySelector(".".concat(__WEBPACK_IMPORTED_MODULE_1__lib_constants_pdp__["e" /* REGULAR_PRICE_ELEMENT */]));
  if (priceEl) {
    priceEl.innerHTML = priceFormatted;
  }

  // update regular price, for on-sale items
  if (isOnSale || isAssignedDefectItemPage) {
    if (isAssignedDefectItemPage) {
      priceFormatted = $assignedDefectItemPrice.val();
      regularPriceFormatted = $assignedDefectItemOriginPrice.val();
    }
    var regularPriceEl = templateContent.querySelector(".".concat(__WEBPACK_IMPORTED_MODULE_1__lib_constants_pdp__["e" /* REGULAR_PRICE_ELEMENT */]));
    var salePriceEl = templateContent.querySelector(".".concat(__WEBPACK_IMPORTED_MODULE_1__lib_constants_pdp__["f" /* CURRENT_PRICE_ELEMENT */]));
    var salePriceDiscountEl = templateContent.querySelector(".".concat(__WEBPACK_IMPORTED_MODULE_1__lib_constants_pdp__["g" /* SALE_DISCOUNT_PRICE_ELEMENT */]));
    salePriceEl.innerHTML = priceFormatted;
    if (regularPriceEl) {
      regularPriceEl.innerHTML = regularPriceFormatted;
    }
    if (salePriceDiscountEl) {
      if (saleDiscountPriceFormatted) {
        salePriceDiscountEl.classList.remove('u-hide');
        var salePriceDiscountTextEl = salePriceDiscountEl.querySelector('strong');
        salePriceDiscountTextEl.innerHTML = saleDiscountPriceFormatted;
      } else {
        salePriceDiscountEl.classList.add('u-hide');
      }
    }
  }

  // inject template into price element
  $priceEl.html(templateContent);
}

/***/ }),
/* 28 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = setUpBisAndSo;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__add_to_bag__ = __webpack_require__(13);


function setUpBisAndSo() {
  if (!window.rcProps || !window.rcProps.pdp || !window.rcProps.pdp.isBisPage) return;
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('select[name="size"]').change(function (e) {
    // $('#so-email').focus();
    var el = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).find('option:selected');
    var $form = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).parents('form');
    var $emailField = $form.find('.js-email-div');
    var $phoneField = $form.find('.bis-phone-field');
    var $notifyMeElement = $form.find('.js-notify-me-element');
    var instock = el.data('instock');
    var preorder = el.data('preorder');
    var fwrdInstock = el.data('fwrd');
    var fwrdPreorder = el.data('fwrdPreorder');
    var eligibleForSpecialOrder = el.data('eligibleForSpecialOrder');
    var isSpecialOrderForm = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).attr('id') === 'so-size';
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.bis-notification').hide();
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.so-msg-bis-pending').addClass('u-hide');
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-bis-details').show();
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-so-details').show();
    $form.find('.js-bis_so-fwrd-link').hide();
    if (instock) {
      $form.find('.js-notification-instock').show();
      $form.find('.notify-me__cta button').hide();
      var $emailInput = $emailField.find('input');
      $emailField.hide();
      $phoneField.hide();
      $notifyMeElement.hide();
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#bis-email-opt-in').hide();
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#so-email').val('');
      $form.find('.notify-me__auto-order').hide();
      $form.find('.js-add-to-bag').show();
    } else if (fwrdInstock || fwrdPreorder) {
      setTimeout(function () {
        $form.find('.js-email-div').hide();
        $form.find('.notify-me__cta button').hide();
        $form.find('.notify-me__auto-order').hide();
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-bis-details').hide();
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-so-details').hide();
        if (fwrdPreorder) {
          __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.fwrd-preorder-cta').removeClass('u-hide');
          __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.fwrd-shop-cta').addClass('u-hide');
        } else {
          __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.fwrd-preorder-cta').addClass('u-hide');
          __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.fwrd-shop-cta').removeClass('u-hide');
        }
        $form.find('.js-bis_so-fwrd-link').show();
        $form.find('.js-notify-me').hide();
      }, "100");
    } else if (preorder) {
      $form.find('.js-notification-preorder').show();
      $form.find('.notify-me__cta button').hide();
      $emailField.show();
      $phoneField.show();
      $notifyMeElement.show();
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#bis-email-opt-in').show();
      $form.find('.notify-me__auto-order').show();
      $form.find('.js-notify-me').show();
    } else if (isSpecialOrderForm && !eligibleForSpecialOrder) {
      $form.find('.js-notification-unavailable').show();
      $form.find('.notify-me__cta button').hide();
      $emailField.show();
      $phoneField.show();
      $notifyMeElement.show();
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#bis-email-opt-in').show();
      $form.find('.notify-me__auto-order').show();
      $form.find('.js-special-order').show();
    } else {
      $form.find('.notify-me__cta button').hide();
      $emailField.show();
      $phoneField.show();
      $notifyMeElement.show();
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#bis-email-opt-in').show();
      $form.find('.notify-me__auto-order').show();
      if (isSpecialOrderForm) {
        $form.find('.js-special-order').show();
      } else {
        $form.find('.js-notify-me').show();
      }
    }
  });
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-bis_so-fwrd-btn').on('click', function (event) {
    event.preventDefault();
    var $this = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this);
    var sizeType = $this.data('sizeType');
    var selectedSize;
    if (sizeType == 'so') {
      // special order
      selectedSize = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#so-size');
    } else {
      selectedSize = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#bis-size'); //back in stock
    }
    if (selectedSize.length > 0) {
      var sizeValue = selectedSize.val();
      var productCode = $this.data('code');
      var baseURL = $this.data('href');
      var dynamicUrl = baseURL + '&size=' + sizeValue + '&code=' + productCode;
      window.open(dynamicUrl, '_blank');
    }
  });
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#nav-go-back-btn a, .confirmation__btn').click(function (e) {
    e.preventDefault();
    var code = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.notify-me__form').find(':input[name="code"]').val();
    var dept = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.notify-me__form').find(':input[name="dept"]').val();
    location.href = '/r/mobile/DisplayProduct.jsp?product=' + code + '&d=' + dept;
  });
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#notify-me-form').submit(function (e) {
    e.preventDefault();
    var $form = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this);
    var size = $form.find(':input[name="size"]').val();
    var email = $form.find(':input[name="email"]').val();
    var phone = $form.find(':input[name="bis_phone"]').val();
    var errors = false;
    if (size === '') {
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#bis-size-error').closest('.field').addClass('is-error');
      errors = true;
    } else {
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#bis-size-error').closest('.field').removeClass('is-error');
    }
    if (email === '') {
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#bis-email-error').closest('.field').addClass('is-error');
      errors = true;
    } else {
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#bis-email-error').closest('.field').removeClass('is-error');
    }
    if (errors === true && !isAddToBag($form)) {
      return false;
    }
    var code = $form.find(':input[name="size"] option:selected').data("code");
    if (isAddToBag($form)) {
      //do add to bag
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__add_to_bag__["a" /* addToBag */])(code, size);
    } else {
      //do notify me
      submitNotifyMe(code, size, email, phone, setNotifyMeButtonSent);
    }
  });
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#special-order-form').submit(function (e) {
    e.preventDefault();
    var $form = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#special-order-form');
    var size = $form.find(':input[name="size"]').val();
    var email = $form.find(':input[name="email"]').val();
    var phone = $form.find(':input[name="bis_phone"]').val();
    var errors = false;
    if (size === '') {
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#so-size-error').closest('.field').addClass('is-error');
      errors = true;
    } else {
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#so-size-error').closest('.field').removeClass('is-error');
    }
    if (email === '') {
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#so-email-error').closest('.field').addClass('is-error');
      errors = true;
    } else {
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#so-email-error').closest('.field').removeClass('is-error');
    }
    if (errors === true && !isAddToBag($form)) {
      return false;
    }
    var code = $form.find(':input[name="size"] option:selected').data("code");
    var autoOrder = $form.find('#so-auto-order').is(":checked");
    if (isAddToBag($form)) {
      //do add to bag
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__add_to_bag__["a" /* addToBag */])(code, size);
    } else if (isNotifyMe($form)) {
      //do notify me
      submitNotifyMe(code, size, email, phone, setNotifyMeButtonSent);
    } else {
      //do special order
      var notEligible = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-notification-unavailable').is(':visible');
      if (notEligible) {
        submitSpecialOrder(code, size, email, autoOrder, function () {
          submitNotifyMe(code, size, email, phone, function () {
            showSoConfirmation();
          });
        });
      } else {
        submitSpecialOrder(code, size, email, autoOrder, function (result) {
          result = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.parseJSON(result);
          if (result.success) {
            showSoConfirmation();
          } else if (result.duplicate) {
            __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.so-msg-bis-pending').removeClass('u-hide');
          } else {
            result.errorMsg = result.errorMsg || "Invalid Product";
            switch (result.errorMsg) {
              case "Invalid Product":
                __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.modal({
                  open: "invalid-product-so-modal",
                  triggerOpen: true,
                  type: "toast"
                });
                break;
              case "Discontinued Product":
                __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.modal({
                  open: "discontinued-product-so-modal",
                  triggerOpen: true,
                  type: "toast"
                });
                break;
              case "Preorder Exists":
                __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#preorder-exists-so-modal").data("size", size).data("code", code);
                __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.modal({
                  open: "preorder-exists-so-modal",
                  triggerOpen: true,
                  type: "toast"
                });
                break;
              case "Instock":
                __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#instock-so-modal").data("size", size).data("code", code);
                __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.modal({
                  open: "instock-so-modal",
                  triggerOpen: true,
                  type: "toast"
                });
                break;
            }
          }
        });
      }
    }
  });
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-so-atb').on('click', function () {
    var $modal = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).closest(".modal");
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__add_to_bag__["a" /* addToBag */])($modal.data("code"), $modal.data("size"));
  });
}
function isAddToBag(formObj) {
  return formObj.find('.js-add-to-bag').is(':visible');
}
function isNotifyMe(formObj) {
  return formObj.find('.js-notify-me').is(':visible');
}
function showSoConfirmation() {
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#main-div').hide();
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#so-confirmation').show();
  var soconfirmation = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#so-confirmation').detach();
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('body').append(soconfirmation);
  __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.modal.close();
  __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.modal({
    open: "so-confirmation",
    triggerOpen: true
  });
}
function setNotifyMeButtonSent() {
  var button = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(".js-notify-me");
  var isSent = button.data('sent');
  if (!isSent) {
    button.addClass('js-sent-active');
    button.removeClass('action-button--dark');
    button.find('.js-toggle-icon').removeClass('u-hide');
    button.find('.js-button-text-target').text('Sent');
    button.find('.u-screen-reader').text('Sent');
    button.data('sent', true);
  }
  setTimeout(function () {
    __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.modal.close();
  }, 1000);
}
function submitNotifyMe(code, size, email, phone, callback) {
  var data = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.param({
    size: size,
    email: email,
    phone: phone,
    code: code,
    isMobile: true
  });
  __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.post("/r/ajax/SubmitFindSizeInquiry.jsp", data, function (msg) {
    if (callback) {
      callback();
    }
  });
}
function submitSpecialOrder(code, size, email, autoOrder, callback) {
  var data = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.param({
    productCode: code,
    specialSizeValueField: size,
    userEmail: email,
    autoOrderValueField: autoOrder,
    isMobile: true
  });
  __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.post("/r/ajax/SubmitSpecialOrderInquiry.jsp", data, function (result) {
    if (callback) {
      callback(result);
    }
  });
}

/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(4);

/** Built-in value references. */
var Symbol = root.Symbol;

module.exports = Symbol;


/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

var baseRest = __webpack_require__(79),
    eq = __webpack_require__(24),
    isIterateeCall = __webpack_require__(86),
    keysIn = __webpack_require__(26);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Assigns own and inherited enumerable string keyed properties of source
 * objects to the destination object for all destination properties that
 * resolve to `undefined`. Source objects are applied from left to right.
 * Once a property is set, additional values of the same property are ignored.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @see _.defaultsDeep
 * @example
 *
 * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
 * // => { 'a': 1, 'b': 2 }
 */
var defaults = baseRest(function(object, sources) {
  object = Object(object);

  var index = -1;
  var length = sources.length;
  var guard = length > 2 ? sources[2] : undefined;

  if (guard && isIterateeCall(sources[0], sources[1], guard)) {
    length = 1;
  }

  while (++index < length) {
    var source = sources[index];
    var props = keysIn(source);
    var propsIndex = -1;
    var propsLength = props.length;

    while (++propsIndex < propsLength) {
      var key = props[propsIndex];
      var value = object[key];

      if (value === undefined ||
          (eq(value, objectProto[key]) && !hasOwnProperty.call(object, key))) {
        object[key] = source[key];
      }
    }
  }

  return object;
});

module.exports = defaults;


/***/ }),
/* 31 */
/***/ (function(module, exports) {

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

module.exports = identity;


/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

var baseToString = __webpack_require__(392);

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

module.exports = toString;


/***/ }),
/* 33 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return logEngagement; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return logEngagementWithDetails; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);


/**
 *
 * @param url
 * @param module
 * @param action
 * @param params - appends key-value pairs to URL as query parameters for tracking purposes.
 */
var logEngagement = function logEngagement(url, module, action, params) {
  if (params) {
    url += (url.indexOf('?') >= 0 ? '&' : '?') + __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.param(params);
  }
  __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.ajax({
    type: 'POST',
    data: __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.param({
      url: url,
      module: module,
      action: action
    }),
    url: '/r/ajax/LogEngagement.jsp'
  });
};

/**
 * Logs engagement to engagement_tracking with details column data
 * @param url - string
 * @param module - string
 * @param action - string
 * @param details - string
 */
var logEngagementWithDetails = function logEngagementWithDetails(url, module, action, details) {
  __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.ajax({
    type: 'POST',
    data: __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.param({
      url: url,
      module: module,
      action: action,
      details: details
    }),
    url: '/r/ajax/LogEngagement.jsp'
  });
};

/***/ }),
/* 34 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export initSidePanel */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return resetSidePanel; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__entry_points_plp_manage_refine_menu__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_styleguide_modules_product_filter_active_button__ = __webpack_require__(300);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_styleguide_modules_product_filter_search__ = __webpack_require__(302);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_styleguide_modules_product_filter_count__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_styleguide_modules_product_filter_clear_all__ = __webpack_require__(301);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__styleguide_src_assets_modules_side_panel__ = __webpack_require__(119);







var SELECTOR = '.js-side-panel-sort-filter';

// "init" at the start of the function is preferred but leaving at the end of the filename for organization purposes
var initSidePanel = function initSidePanel() {
  var sidePanelHref = window.rcProps.sidebarHref ? window.rcProps.sidebarHref : window.rcProps.search.sidebarHref;
  if (sidePanelHref) {
    var hrefEncoded = encodeURIComponent(window.location.href);
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()(SELECTOR).sidePanel({
      url: "".concat(sidePanelHref, "?url=").concat(hrefEncoded),
      onAjaxLoad: function onAjaxLoad() {
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-accordion-side-nav').accordion({
          onLoad: function onLoad() {
            __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.side-panel__panel').animate({
              scrollTop: 0
            }, 200);
          }
        });
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__entry_points_plp_manage_refine_menu__["a" /* default */])();
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-product-filter-clear-all').productFilterClearAll();
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-product-filter-search').productFilterSearch();
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-product-filter-active-button').productFilterActiveButton();
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-product-filter-count').productFilterCount();
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#side-panel__overlay, #done_filters').on('click', function () {
          if (__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-product-filter-clear-all').length) {
            __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-accordion-side-nav').accordion('closeAll');
          }
        });
      },
      returnFocus: '#sortRefineBtn'
    });
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()(SELECTOR).on('click', function () {
      logEngagement(window.location.href, 'Filter & Sort Side Panel', 'Click');
    });
    return true;
  } else {
    return false;
  }
};
var resetSidePanel = function resetSidePanel() {
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()(SELECTOR).off('click').removeData('sidePanel');
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#".concat(__WEBPACK_IMPORTED_MODULE_6__styleguide_src_assets_modules_side_panel__["a" /* SIDE_PANEL_HTML_ID */])).remove();
  initSidePanel();
};
/* harmony default export */ __webpack_exports__["a"] = (initSidePanel);

/***/ }),
/* 35 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return EVENTS; });
/* unused harmony export EVENT_NS */
/* unused harmony export VALIDATE_TRIGGER */
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_kebabCase__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_kebabCase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_kebabCase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_partial__ = __webpack_require__(484);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_partial___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_partial__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_get__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__form_error_scroller__ = __webpack_require__(259);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lib_register_jquery_plugin__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__validate_missing__ = __webpack_require__(268);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__validate_same_as__ = __webpack_require__(269);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__validate_email__ = __webpack_require__(266);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__validator_constants__ = __webpack_require__(63);
/* unused harmony reexport DEFAULT_MESSAGE */
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
/**
 * Responsible for performing form validation via the Constraint Validation API.
 * It provides both custom data attributes as well leverage any fields in a
 * given area (form or any container with elements) that are seen as invalid.
 * @module elements/fields/validator
 */











var PLUGIN_NAME = 'validator';
var placeholder = __WEBPACK_IMPORTED_MODULE_2_lodash_partial___default.a.placeholder;

/**
 * Defines default options for a validator.
 * @type {Object}
 */
var VALIDATOR_OPTIONS = {
  /**
   * Allows for a form to be validated only upon submission.
   */
  validateOnlyOnSubmit: false,
  /**
   * Called when a submission is valid
   * @param {Array} validElements - An array of valid HTML elements
   */
  successCallback: function successCallback(validElements) {
    return validElements;
  },
  /**
   * Called when a submission was unsuccessful
   * @param {Array} invalidElements - An array of invalid HTML elements
   */
  errorCallback: function errorCallback(invalidElements) {
    return invalidElements;
  },
  /**
   * Provides baseline implementation of where/how the page should scroll to
   * when an error has been found.
   * @param {number} x - The x coordinate to scroll to
   * @param {number} y - The y coordinate to scroll to
   */
  scrollTrigger: function scrollTrigger(x, y) {
    return window.scrollTo(x, y);
  },
  /**
   * Allows for custom scrolling when an error occurs.
   */
  useCustomFormErrorScroll: __WEBPACK_IMPORTED_MODULE_4__form_error_scroller__["a" /* default */]
};

/**
 * Defines all validator related events.
 * @type {Object}
 */
var EVENTS = {
  INVALID_SCROLL_POSITION: 'validator:invalid-scroll-position',
  VALIDATOR_SUBMIT: 'validator:submit',
  VALIDATOR_SUCCESS: 'validator:success',
  VALIDATOR_ERROR: 'validator:error',
  VALIDATOR_POST_SUCCESS: 'validator:post-success',
  VALIDATOR_POST_ERROR: 'validator:post-error'
};
var EVENT_NS = 'validator';

/**
 * Defines the data attribute for triggering an element.
 * @type {string}
 */
var VALIDATE_TRIGGER = 'data-validate-trigger';

/**
 * Defines a number of custom data attributes used for validating.
 * @private
 * @type {Object}
 */
var validators = {
  /**
   * Ensures that an element is not empty. This is different from a required
   * attribute as the validation occurs on submit by the validator verses
   * natively in the browser.
   *
   * @example
   * <form>
   *   <input type="text" data-validate-not-empty="true" />
   *   <button>Submit</button>
   * </form>
   *
   * @param {jQuery} $el - Elements checked to be not empty
   * @returns {string} Value used for setting custom validity
   */
  validateNotEmpty: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__validate_missing__["a" /* makeValidateMissing */])('validateNotEmpty'),
  /**
   * Ensures that an element has a value or that is required. This is different
   * from a required attribute as the validation occurs on submit by the
   * validator verses natively in the browser.
   *
   * @example
   * <form>
   *   <input type="text" data-validate-required="true" />
   *   <button>Submit</button>
   * </form>
   *
   * @param {jQuery} $el - Elements checked to be required or have a value
   * @returns {string} Value used for setting custom validity
   */
  validateRequired: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__validate_missing__["a" /* makeValidateMissing */])('validateRequired'),
  /**
   * Ensure that an element value is not set to the provided value. When it has
   * been set to the value provided, the element will be set as invalid.
   *
   * @example
   * <form>
   *   <input type="text" data-validate-not="walter" />
   *   <button>Submit</button>
   * </form>
   *
   * @param {jQuery} $el - Elements checked to be not empty
   * @param {string} dataVal - Elements checked to be not empty
   * @returns {string} Value used for setting custom validity
   */
  validateNot: function validateNot($el, dataVal) {
    if ($el.val() === dataVal) {
      return $el.data('errorMessage') || __WEBPACK_IMPORTED_MODULE_9__validator_constants__["a" /* DEFAULT_MESSAGE */];
    }
    return '';
  },
  validateEmail: __WEBPACK_IMPORTED_MODULE_8__validate_email__["a" /* validateEmail */],
  validateSameAs: __WEBPACK_IMPORTED_MODULE_7__validate_same_as__["a" /* validateSameAs */]
};
var createEvent = function createEvent(name) {
  return "".concat(name, ".").concat(EVENT_NS);
};

/**
 * Simple helper that will determine the top position of an element on the page.
 * @private
 * @param {HTMLElement} el - Element under question to find top position
 * @returns {number} The total distance from the top for an element
 */
var getTop = function getTop(el) {
  var bodyTop = document.body.getBoundingClientRect().top;
  var elTop = el.getBoundingClientRect().top;
  return elTop - bodyTop;
};

/**
 * Figures out the highest elements found in the DOM based on an array of HTML
 * elements.
 * @private
 * @param {Array} invalidElements - A list of HTML elements
 * @returns {HTMLElement} Highest HTML element on the page
 */
var findHighestEl = function findHighestEl(invalidElements) {
  var _invalidElements = _slicedToArray(invalidElements, 1),
    initial = _invalidElements[0];
  return invalidElements.reduce(function (prev, curr) {
    return getTop(curr) < getTop(prev) ? curr : prev;
  }, initial);
};

/**
 * Determines where in the form to scroll to when an error has been found, so
 * that the user has some context about what in the form has been filled in
 * incorrectly.
 * @private
 * @param {Array} invalidElements - A list of invalid elements
 * @param {Function} scrollTrigger - Called on to determine where to scroll to.
 */
var setInvalidScrollPosition = function setInvalidScrollPosition(invalidElements, scrollTrigger) {
  var highestEl = findHighestEl(invalidElements);
  var yAxis = getTop(highestEl);
  var isDelegatedScroll = false;
  var dict = {
    detail: {
      highestEl: highestEl,
      setElement: function setElement(el) {
        yAxis = getTop(el);
      },
      setPosition: function setPosition(pos) {
        yAxis = window.scrollY + pos;
      },
      setRawPosition: function setRawPosition(pos) {
        yAxis = pos;
      },
      delegateScroll: function delegateScroll(fn) {
        fn(highestEl);
        isDelegatedScroll = true;
      }
    }
  };
  var evt = new CustomEvent(EVENTS.INVALID_SCROLL_POSITION, dict);
  highestEl.dispatchEvent(evt);
  if (!isDelegatedScroll) {
    scrollTrigger(0, yAxis);
  }
};

/**
 * Validates for form field based on whether it contains a custom data
 * attribute as specified by any validators. It's purpose is to set the proper
 * validity if the field's requirements haven't been met. It will return true
 * if the element was found invalid.
 * @private
 * @see validators
 * @param {HTMLSelectElement|HTMLInputElement} el - Form element
 * @returns {boolean|undefined} Determines if element is invalid
 */
var validateField = function validateField(el) {
  var $el = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(el);
  if ($el.is(':hidden')) {
    return false;
  }
  var dataAttrs = $el.data();
  var validatorList = Object.keys(validators);
  for (var i = 0, len = validatorList.length; i < len; i += 1) {
    var name = validatorList[i];
    var dataVal = dataAttrs[name];
    if (!!dataVal && !!validators[name]) {
      var message = validators[name]($el, dataVal, dataAttrs);
      if (message) {
        $el.attr('aria-invalid', true);
        el.setCustomValidity(message);
        return true;
      }
      $el.attr('aria-invalid', false);
      el.setCustomValidity('');
    }
  }
  return false;
};

/**
 * Helper that determines all the elements that contain data validator
 * attributes and applies a function to interact with each element.
 * @private
 * @param {jQuery} $wrapper - Container for the form elements
 * @param {Function} fn - Called and passed along a form element
 */
var forEachFormField = function forEachFormField($wrapper, fn) {
  var dataSelector = Object.keys(validators).map(function (name) {
    return "[data-".concat(__WEBPACK_IMPORTED_MODULE_1_lodash_kebabCase___default()(name), "]");
  }).join(',');
  $wrapper.find(dataSelector).each(function iterateElement() {
    fn(this);
  });
};

/**
 * Responsible for queries invalid elements in a container.
 * @param {jQuery} $wrapper - Container with form elements
 * @returns {Array} List of invalid elements
 */
var getInvalidElementList = function getInvalidElementList($wrapper) {
  return $wrapper.find(':invalid').not(':hidden,fieldset').toArray();
};

/**
 * Responsible for queries valid elements in a container.
 * @param {jQuery} $wrapper - Container with form elements
 * @returns {Array} List of valid elements
 */
var getValidElementList = function getValidElementList($wrapper) {
  var $validEls = $wrapper.find(':valid');
  var els = $validEls.not('button,fieldset,input[type="submit"],input[type="radio"],input[type="checkbox"]').toArray();
  var checkedEls = $validEls.filter('input[type="radio"],input[type="checkbox"]').toArray();
  var validCheckedEls = checkedEls.reduce(function (acc, input) {
    var valid = __WEBPACK_IMPORTED_MODULE_3_lodash_get___default()(input, 'validity.valid');
    if (input.checked && valid) {
      return [].concat(_toConsumableArray(acc), [input]);
    }
    return acc;
  }, []);
  return els.concat(validCheckedEls);
};

/**
 * Responsible for verifying a set of elements.
 * @param {Array} elements - List of elements
 */
var verifyElementsValidity = function verifyElementsValidity(elements) {
  elements.forEach(function (el) {
    el.checkValidity();
  });
};

/**
 * Responsible for triggering a native CustomEvent so that native event
 * listeners ((add|remove)EventListener) and external listeners (such as jQuery)
 * can work in unison.
 * @param {jQuery} $el - Wrapper element
 * @param {string} evtName - Name of the event
 * @param {Object} detail - Custom data for the event
 */
var triggerEvent = function triggerEvent($el, evtName, detail) {
  var errorEvt = new CustomEvent(evtName, {
    detail: detail
  });
  $el[0].dispatchEvent(errorEvt);
};

/**
 * Retrieves a value for a form element. This can be different based on the
 * type of the element and conditions around it.
 * @param {jQuery} $el - Element looking for value
 */
var getFormFieldValue = function getFormFieldValue($el) {
  var type = $el.prop('type');
  if (type === 'radio') {
    return $el.is(':checked') ? $el.val() : null;
  }
  return $el.val();
};

/**
 * Responsible for taking a list of form elements and creating an object that
 * is keyed by the form element name and with a value of the form element.
 * @param {Array} elements - List of form elements
 * @returns {Object} Keyed form element name by value
 */
var createValuesMap = function createValuesMap(elements) {
  return elements.reduce(function (acc, el) {
    var $el = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(el);
    var name = $el.attr('name') || $el.attr('id');
    var value = getFormFieldValue($el);
    if (acc[name]) {
      var values = acc[name].values || [acc[name].value];
      var els = acc[name].els || [acc[name].el];
      var combinedEls = [].concat(_toConsumableArray(els), [el]);
      var combinedValues = [].concat(_toConsumableArray(values), [value]);
      return Object.assign({}, acc, _defineProperty({}, name, {
        values: combinedValues,
        els: combinedEls,
        $el: __WEBPACK_IMPORTED_MODULE_0_jquery___default()(combinedEls)
      }));
    }
    return Object.assign({}, acc, _defineProperty({}, name, {
      $el: $el,
      el: $el[0],
      value: value
    }));
  }, {});
};

/**
 * Responsible for detecting whether the submission failed or was successful
 * and run through the proper processing/notifying.
 * @param {jQuery} $wrapper - Wrapper element
 * @param {Function} successCallback - Fired off if submission was successful
 * @param {Function} errorCallback - Fired off if submissions was unsuccessful
 * @param {Function} useCustomFormErrorScroll - Called on when an error has
 * been found
 * @param {Function} scrollTrigger - Called on to go a position on the page
 * @param {boolean} disableErrorScroll - Disables a form error from scrolling
 * to the error on the screen.
 * @returns {Function} Called on when the submission should be finalized
 */
var processSubmission = function processSubmission($wrapper, successCallback, errorCallback, useCustomFormErrorScroll, scrollTrigger, disableErrorScroll) {
  return function (detail, _ref) {
    var success = _ref.success,
      error = _ref.error;
    var invalidElements = getInvalidElementList($wrapper);
    var validElements = getValidElementList($wrapper);
    var invalidValues = createValuesMap(invalidElements);
    var validValues = createValuesMap(validElements);
    var updatedDetail = Object.assign({}, detail, {
      invalidElements: invalidElements,
      invalidValues: invalidValues,
      validElements: validElements,
      validValues: validValues
    });
    verifyElementsValidity(invalidElements);
    if (!invalidElements.length) {
      successCallback(validElements);
      triggerEvent($wrapper, success, updatedDetail);
      return;
    }
    var shouldDisableErrorScroll = function shouldDisableErrorScroll() {
      return !disableErrorScroll && !$wrapper.data('validateDisableErrorScroll');
    };
    if (!useCustomFormErrorScroll($wrapper, scrollTrigger) && shouldDisableErrorScroll()) {
      setInvalidScrollPosition(invalidElements, scrollTrigger);
    }
    detail.srcEvent.preventDefault();
    errorCallback(invalidElements);
    triggerEvent($wrapper, error, updatedDetail);
  };
};

/**
 * Performs the submit handler used for verifying the fields within an element.
 * @private
 * @param {Event} evt - DOM event
 * @param {jQuery} $wrapper - The element containing form elements
 * @param {Function} successCallback - Fired off if submission was successful
 * @param {Function} errorCallback - Fired off if submissions was unsuccessful
 * @param {Function} useCustomFormErrorScroll - Called on when an error has
 * been found
 * @param {Function} scrollTrigger - Called on to go a position on the page
 * @param {boolean} disableErrorScroll - Disables a form error from scrolling
 * to the error on the screen.
 */
var submitHandler = function submitHandler(evt, $wrapper, successCallback, errorCallback, useCustomFormErrorScroll, scrollTrigger, disableErrorScroll) {
  forEachFormField($wrapper, validateField);
  var invalidElements = getInvalidElementList($wrapper);
  var validElements = getValidElementList($wrapper);
  verifyElementsValidity(invalidElements);
  var detail = {
    srcEvent: evt,
    validElements: validElements,
    validValues: createValuesMap(validElements),
    invalidElements: invalidElements,
    invalidValues: createValuesMap(invalidElements),
    pause: function pause() {
      evt.preventDefault();
    }
  };
  var processSubmissionFunc = processSubmission($wrapper, successCallback, errorCallback, useCustomFormErrorScroll, scrollTrigger, disableErrorScroll);
  detail = Object.assign({}, detail, {
    revalidate: function revalidate() {
      processSubmissionFunc(detail, {
        success: EVENTS.VALIDATOR_POST_SUCCESS,
        error: EVENTS.VALIDATOR_POST_ERROR
      });
    },
    proceed: function proceed() {
      processSubmissionFunc(detail, {
        success: EVENTS.VALIDATOR_POST_SUCCESS,
        error: EVENTS.VALIDATOR_POST_ERROR
      });
      var updatedInvalidElements = getInvalidElementList($wrapper);
      if (!updatedInvalidElements.length) {
        $wrapper[0].submit();
      }
    }
  });
  processSubmissionFunc(detail, {
    success: EVENTS.VALIDATOR_SUCCESS,
    error: EVENTS.VALIDATOR_ERROR
  });
  triggerEvent($wrapper, EVENTS.VALIDATOR_SUBMIT, Object.assign({}, detail, {
    hasErrors: !!invalidElements.length
  }));
};

/**
 * Responsible for allowing a single handler to be called on to avoid a handler
 * to be called on multiple times.
 * @param {Function} handler - Func to call on
 * @returns {Function} An event callback
 */
var makeSingleEventCall = function makeSingleEventCall(handler) {
  var called;
  return function (evt) {
    if (!called) {
      called = evt.type;
    }
    if (evt.type === called) {
      handler(evt);
    }
  };
};

/**
 * Based on the type of element, will apply an event listener whenever a value
 * has been finalized on the form element.
 * @private
 * @param {jQuery} $el - The form or container for form fields
 */
var listenForFieldChange = function listenForFieldChange($el) {
  forEachFormField($el, function (formField) {
    var $formField = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(formField);
    var callback = function callback() {
      validateField(formField);
      formField.checkValidity();
    };
    $formField.on(createEvent('blur'), callback);
    if (formField.tagName.toLowerCase() === 'select') {
      $formField.on(createEvent('change'), callback);
    }
  });
};

/**
 * Responsible for setting a form element to not have native form validation.
 * Ideally, we would want to use native form validation. However, native form
 * validation does not meet the product/design requirements so we need to have
 * custom functionality for form validation.
 *
 * Here are some of the major differences between native form validation and
 * product requirements:
 *
 * Native Form Validation
 * - When an error is found upon submitting a form, no submit event is fired
 *   off. It's almost as though the browser is calling event.stopPropagation().
 * - Upon submitting the form, the browser will fire off an invalid event on
 *   the first found form field error.
 * - The first found error will be in focus
 *
 * Product Requirements:
 * - All fields must be validated upon submitting a form
 * - There are custom page position rules based on how the form has been
 *   configured
 *
 * An important thing to note, by setting novalidate, the form submission will
 * not be validated by the browser. However, the validation of the individual
 * fields can be performed independently from the native form validation, which
 * allows for this custom validation to occur.
 * @param {jQuery} $el - The container or form being validated
 */
var setNovalidate = function setNovalidate($el) {
  var isForm = $el.prop('tagName').toLowerCase() === 'form';
  var hasValidateAttr = !!$el.data('validateNative');
  if (isForm && !hasValidateAttr) {
    $el.attr('novalidate', 'novalidate');
  }
};

/**
 * Validates fields within an element, most likely a form based on what is
 * passed in. The validation of fields is done by a couple of ways:
 *
 * 1. By using browser defaults around validity. For example, if a form element
 * is using a required attribute, has a type that uses built in validation, has
 * a patter attribute, or is controlling validity programmatically by
 * JavaScript.
 * 2. By leveraging data attributes that are coming from within. Think of these
 * attributes as additional configuration that extends the capabilities of
 * validation that isn't supported by the browser.
 * 3. A combination of two.
 *
 * Whether either of these conditions are met, they are finally triggered by
 * either a form submission or a click event applied to an element that
 * contains a data-validate-trigger attribute. This would allow for form
 * submissions to be applied to an element other than a input[type="submit"] or
 * button, in case it's needed. When any form elements are found invalid, a
 * pseudo class of invalid is set and can be styled by CSS.
 *
 * The goal of this work is to leverage as much from within the browser and
 * remove the need for as much custom work as possible.
 * @see validators
 * @see VALIDATOR_OPTIONS
 * @param {HTMLElement} el - An element containing fields used for validating
 * @param {Object} [options={}] - Options used for overriding
 */
function validator(el) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _ref2 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : __WEBPACK_IMPORTED_MODULE_5__lib_register_jquery_plugin__["b" /* noopActions */],
    deregister = _ref2.deregister;
  var $el = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(el);
  var $triggers = $el.find("[".concat(VALIDATE_TRIGGER, "]"));
  var _Object$assign3 = Object.assign({}, VALIDATOR_OPTIONS, options, $el.data()),
    validateOnlyOnSubmit = _Object$assign3.validateOnlyOnSubmit,
    successCallback = _Object$assign3.successCallback,
    errorCallback = _Object$assign3.errorCallback,
    scrollTrigger = _Object$assign3.scrollTrigger,
    useCustomFormErrorScroll = _Object$assign3.useCustomFormErrorScroll,
    disableErrorScroll = _Object$assign3.validateDisableErrorScroll;
  setNovalidate($el);
  var partialSubmitHandler = __WEBPACK_IMPORTED_MODULE_2_lodash_partial___default()(submitHandler, placeholder, $el, successCallback, errorCallback, useCustomFormErrorScroll, scrollTrigger, disableErrorScroll);
  var submitHandlerFunc = makeSingleEventCall(partialSubmitHandler);
  $el.on(createEvent('submit'), submitHandlerFunc);
  if ($triggers.length) {
    $triggers.on(createEvent('click'), submitHandlerFunc);
  }
  if (!validateOnlyOnSubmit) {
    listenForFieldChange($el);
  }
  return {
    destroy: function destroy() {
      $el.off(createEvent('submit'));
      $triggers.off(createEvent('click'));
      forEachFormField($el, function (formField) {
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()(formField).off(createEvent('blur')).off(createEvent('change'));
        var evt = new Event('valid');
        formField.dispatchEvent(evt);
        formField.setCustomValidity('');
        formField.checkValidity();
        deregister();
      });
    }
  };
}
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib_register_jquery_plugin__["a" /* default */])(PLUGIN_NAME, validator);

/***/ }),
/* 36 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PRODUCT_BLOCK; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return PRICE_BLOCK; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return RANGE_BLOCK; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return CURRENT_PRICE_ELEMENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return REGULAR_PRICE_ELEMENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return SALE_DISCOUNT_PRICE_ELEMENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return DELIVERY_DATE_BLOCK; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return STOCK_DATE_BLOCK; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return ADD_TO_LIST_BLOCK; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return SIZE_BLOCK_ELEMENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return PRICE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return REGULAR_PRICE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return PRICE_FORMATTED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return REGULAR_PRICE_FORMATTED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return SALE_DISCOUNT_PRICE_FORMATTED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return SKIP_PRICE_UPDATE; });
// BEM NAMES
var PRODUCT_BLOCK = 'product';
var PRICE_BLOCK = 'price';
var RANGE_BLOCK = 'range';
var CURRENT_PRICE_ELEMENT = "".concat(PRICE_BLOCK, "__sale");
var REGULAR_PRICE_ELEMENT = "".concat(PRICE_BLOCK, "__retail");
var SALE_DISCOUNT_PRICE_ELEMENT = "".concat(CURRENT_PRICE_ELEMENT, "__discount");
var DELIVERY_DATE_BLOCK = 'delivery-date';
var STOCK_DATE_BLOCK = 'stock-date';
var ADD_TO_LIST_BLOCK = 'add-to-list';
var SIZE_BLOCK_ELEMENT = "".concat(PRODUCT_BLOCK, "__size");

// DATA PROPERTY NAMES
var PRICE = 'price';
var REGULAR_PRICE = 'regular-price';
var PRICE_FORMATTED = 'price-formatted';
var REGULAR_PRICE_FORMATTED = 'regular-price-formatted';
var SALE_DISCOUNT_PRICE_FORMATTED = 'sale-discount-price-formatted';
var SKIP_PRICE_UPDATE = 'skipPriceUpdate';

/***/ }),
/* 37 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return updateChosenData; });
/* harmony export (immutable) */ __webpack_exports__["a"] = createProductData;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_constants_pdp__ = __webpack_require__(36);
/**
 * Creates an object including all relevant data for a product
 * Also allows for updates when a new option is chosen
 * @module lib/createProductData
 */



var PRICE_ATTR = "data-".concat(__WEBPACK_IMPORTED_MODULE_1__lib_constants_pdp__["h" /* PRICE */]);
var REGULAR_PRICE_ATTR = "data-".concat(__WEBPACK_IMPORTED_MODULE_1__lib_constants_pdp__["i" /* REGULAR_PRICE */]);
var PRICE_FORMATTED_ATTR = "data-".concat(__WEBPACK_IMPORTED_MODULE_1__lib_constants_pdp__["j" /* PRICE_FORMATTED */]);
var REGULAR_PRICE_FORMATTED_ATTR = "data-".concat(__WEBPACK_IMPORTED_MODULE_1__lib_constants_pdp__["k" /* REGULAR_PRICE_FORMATTED */]);

/**
 * @namespace
 * @property {String} wrapBlockClass - Class of wrap HTML Element
 */
var DEFAULT_OPTIONS = {
  wrapBlockClass: __WEBPACK_IMPORTED_MODULE_1__lib_constants_pdp__["a" /* PRODUCT_BLOCK */]
};

/**
 * Helper function to determine if an option has an attr
 * @private
 * @param {HTMLElement} option - The select option element
 * @param {String} attr - The attribute we're checking for
 */
var hasAttr = function hasAttr(option, attr) {
  return !!(option.getAttribute(attr) && option.getAttribute(attr) !== 'false');
};

/**
 * Helper function to determine if any options have an attr
 * @private
 * @param {NodeList} options - List of select options
 * @param {Function} comparison - Callback function to evaluate the comparison
 * @param {String} attr - The attribute we're comparing
 * @return {Boolean} Whether comparison was successful on any options
 */
var any = function any(options, comparison, attr) {
  var len = options.length;
  while (len) {
    len -= 1;
    var option = options[len];
    if (option.value !== 'unavailable' && comparison(option, attr)) {
      return true;
    }
  }
  return false;
};

/**
 * Helper function to determine if all options have an attr
 * @private
 * @param {NodeList} options - List of select options
 * @param {Function} comparison - Callback function to evaluate the comparison
 * @param {String} attr - The attribute we're comparing
 * @return {Boolean} Whether comparison was successful on all options
 */
var all = function all(options, comparison, attr) {
  var len = options.length;
  while (len) {
    len -= 1;
    var option = options[len];
    if (option.value !== 'unavailable' && !comparison(option, attr)) {
      return false;
    }
  }
  return true;
};

/**
 * Helper function to determine if option is on sale
 * @private
 * @param {HTMLElement} option - Option for which we're comparing price
 * @param {String} regularPrice - The item's regular price
 * @return {Boolean} Whether price is less than regualarPrice
 */
var isOnSale = function isOnSale(option, regularPrice) {
  var price = option.getAttribute(PRICE_ATTR);
  if (!price) {
    // Originally for ColorSwatch for beauty volume options, which only have formatted prices
    // presumably price <= regular price
    var priceFormatted = option.getAttribute(PRICE_FORMATTED_ATTR);
    var regularPriceFormatted = option.getAttribute(REGULAR_PRICE_FORMATTED_ATTR);
    if (priceFormatted && regularPriceFormatted) {
      return priceFormatted !== regularPriceFormatted;
    }
  }
  return parseFloat(price) < parseFloat(regularPrice);
};

/**
 * Helper function to get product data attributes
 * @private
 * @param {HTMLElement} option - The select option element
 * @param {String} attr - The attribute we're checking for
 * @return {String|Boolean} The attribute value (or existence)
 */
var getAttr = function getAttr(option, attr) {
  var val = option.getAttribute("data-".concat(attr)) || false;
  return val && val !== 'false' ? val === 'true' || val || true : false;
};
function getHTMLJSSaveId(value) {
  return value.toString().replace(/[\W_]+/g, '');
}

/**
 * Updates product data object whenever chosen option is changed
 * @param {Object} product - The product's data object
 * @param {HTMLElement} chosen - The chosen option
 */
var updateChosenData = function updateChosenData(product, chosen) {
  var price = getAttr(chosen, __WEBPACK_IMPORTED_MODULE_1__lib_constants_pdp__["h" /* PRICE */]);
  var regularPrice = getAttr(chosen, __WEBPACK_IMPORTED_MODULE_1__lib_constants_pdp__["i" /* REGULAR_PRICE */]) || price;
  var preorderChosen = getAttr(chosen, 'preorder');
  var oosChosen = getAttr(chosen, 'oos');
  var sizeChosen = chosen.value;
  Object.assign(product, {
    chosen: {
      el: chosen,
      'delivery-date': getAttr(chosen, 'delivery-date'),
      'defect-disclaimer': getAttr(chosen, 'defect-disclaimer'),
      'final-sale': getAttr(chosen, 'final-sale'),
      'one-left': getAttr(chosen, 'one-left'),
      'removed-item': getAttr(chosen, 'removed-item'),
      preorder: preorderChosen,
      oos: oosChosen,
      unavailable: getAttr(chosen, 'unavailable'),
      price: price,
      priceFormatted: getAttr(chosen, __WEBPACK_IMPORTED_MODULE_1__lib_constants_pdp__["j" /* PRICE_FORMATTED */]),
      regularPrice: regularPrice,
      regularPriceFormatted: getAttr(chosen, __WEBPACK_IMPORTED_MODULE_1__lib_constants_pdp__["k" /* REGULAR_PRICE_FORMATTED */]),
      saleDiscountPriceFormatted: getAttr(chosen, __WEBPACK_IMPORTED_MODULE_1__lib_constants_pdp__["l" /* SALE_DISCOUNT_PRICE_FORMATTED */]),
      isOnSale: isOnSale(chosen, regularPrice),
      value: chosen.value || '',
      'inventory-disclaimer': getAttr(chosen, 'inventory-disclaimer'),
      sellableDefectItemPrice: getAttr(chosen, 'sellable-defect-item-price'),
      sellableDefectItemLink: getAttr(chosen, 'sellable-defect-item-link'),
      fwrdInStock: getAttr(chosen, 'fwrd')
    }
  });
  if (document.getElementById('afterPayBox')) {
    if (preorderChosen || oosChosen) {
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#afterPayBox').hide();
    } else {
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#afterPayBox').show();
      if (sizeChosen !== '') {
        var afterPayMessageBySize = __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#afterPayBox".concat(getHTMLJSSaveId(sizeChosen)));
        if (afterPayMessageBySize.length) {
          __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.afterPayBoxMsg').hide();
          afterPayMessageBySize.show();
        }
      }
    }
  }
  if (document.getElementById('klarnaPayMsgOption')) {
    if (preorderChosen) {
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#klarnaPayMsgOption').hide();
    } else {
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#klarnaPayMsgOption').show();
      if (sizeChosen !== '') {
        var klarnaMessageBySize = __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#installmentPlanMsg".concat(getHTMLJSSaveId(sizeChosen)));
        if (klarnaMessageBySize.length) {
          __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.installmentPlanBoxMsg').hide();
          klarnaMessageBySize.show();
        }
      }
    }
  }
};

/**
 * Creates a javascript object containing product data
 * @param {jQuery|Element} sizeEl - The size element (select, input, etc)
 * @see DEFAULT_OPTIONS
 # @return {Object} Contains relevant data to a product
 */
function createProductData(sizeEl) {
  var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _Object$assign = Object.assign({}, DEFAULT_OPTIONS, opts),
    wrapBlockClass = _Object$assign.wrapBlockClass;
  var $wrap = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(sizeEl).closest(".".concat(wrapBlockClass));

  // whether input or select, find the chosen element
  var options = sizeEl.options,
    selectedIndex = sizeEl.selectedIndex;
  var chosen = options ? options[selectedIndex] : sizeEl;
  var defaultOption = options ? options[0] : chosen;
  // TODO: deprecate the usage of "regular-price" on the "default" option.
  // Instead, each option should include its own "regular-price".
  // Overall, we should get away from referring to the "default" option.
  var regularPrice = defaultOption.getAttribute(REGULAR_PRICE_ATTR) || defaultOption.getAttribute(PRICE_ATTR);

  // instantiate object, adding properties that apply to the whole dropdown
  var product = {
    // DOM references
    wrap: $wrap[0],
    wrapBlockClass: wrapBlockClass,
    sizeEl: sizeEl,
    // product info
    regularPrice: regularPrice,
    chosen: {},
    // useful booleans
    oneSize: options && options.length === 1,
    allInStock: options ? !any(options, hasAttr, 'data-oos') : !hasAttr(chosen, 'data-oos'),
    allPreorder: options ? all(options, hasAttr, 'data-preorder') : hasAttr(chosen, 'data-preorder'),
    allOnSale: options ? all(options, isOnSale, regularPrice) : isOnSale(chosen, regularPrice)
  };
  updateChosenData(product, chosen);
  return product;
}

/***/ }),
/* 38 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isNil__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isNil___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_isNil__);
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }

var exp = /\{\{\s*(.*?)\s*\}\}/g;
var filters = {
  pluralize: function pluralize(varName, filterValue, data) {
    var _filterValue$split = filterValue.split(','),
      _filterValue$split2 = _slicedToArray(_filterValue$split, 2),
      singular = _filterValue$split2[0],
      plural = _filterValue$split2[1];
    if (!plural) {
      return '';
    }
    var value = data[varName];
    if (__WEBPACK_IMPORTED_MODULE_0_lodash_isNil___default()(value)) {
      return '';
    }
    return +value === 1 ? singular : plural;
  }
};
var renderFilter = function renderFilter(templateVar, data) {
  // For the time being, does not support chaining unless needed
  var _ref = templateVar.match(/^([\w-]+)\|([^]+)$/) || [],
    _ref2 = _slicedToArray(_ref, 3),
    varName = _ref2[1],
    filterStr = _ref2[2];
  if (!varName) {
    return '';
  }
  var _ref3 = filterStr.match(/^([\w]+):"([^]+)"$/) || [],
    _ref4 = _slicedToArray(_ref3, 3),
    _ref4$ = _ref4[1],
    filterName = _ref4$ === void 0 ? '' : _ref4$,
    filterValue = _ref4[2];
  var filterFn = filters[filterName.toLowerCase()];
  if (!filterFn) {
    return '';
  }
  return filterFn(varName, filterValue, data);
};
var stache = function stache(template) {
  var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return template.replace(exp, function (match, submatch) {
    var filterValue = renderFilter(submatch, data);
    if (filterValue) {
      return filterValue;
    }
    var value = data[submatch];
    return !__WEBPACK_IMPORTED_MODULE_0_lodash_isNil___default()(value) ? value : '';
  });
};
/* harmony default export */ __webpack_exports__["a"] = (stache);

/***/ }),
/* 39 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export PLUGIN_NAME */
/* unused harmony export DEFAULTS */
/* harmony export (immutable) */ __webpack_exports__["a"] = modal;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_scriptjs__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_scriptjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_scriptjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_body_scroll_lock__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_body_scroll_lock___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_body_scroll_lock__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_props__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__keyboard__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lib_register_jquery_plugin__ = __webpack_require__(1);
/**
 * Handles all modals
 * @module modal
 */







var HAMMERJS_FALLBACK = 'https://ajax.googleapis.com/ajax/libs/hammerjs/2.0.8/hammer.min.js';

/**
 * AB840 for R Mobile Faster Modal
 */
var isFasterModal = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__lib_props__["a" /* get */])('rcProps.fasterModals', false);

/**
 * Makes a request for HammerJS.
 * @private
 * @return {Promise} Denotes when the request has been successfully executed
 */
var loadHammerJSFunc = function loadHammerJSFunc() {
  return new Promise(function (resolve) {
    __WEBPACK_IMPORTED_MODULE_1_scriptjs___default()(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__lib_props__["a" /* get */])('scripts.hammerJS', HAMMERJS_FALLBACK), function () {
      resolve(window.Hammer);
    });
  });
};
// Expose the function as a jQuery plugin for ease of use
var PLUGIN_NAME = 'modal';
var DEFAULTS = {
  url: '',
  type: '',
  open: null,
  data: '',
  animation: true,
  returnFocus: '',
  cache: true,
  closeButton: true,
  overlayClose: true,
  notificationDuration: 5000,
  triggerOpen: false,
  triggerElement: '',
  padding: true,
  video: false,
  addModifierClass: '',
  fullHeight: false,
  windowHeight: false,
  transparent: false,
  hasBodyScroll: true,
  onOpen: function onOpen() {},
  onComplete: function onComplete() {},
  onLoad: function onLoad() {},
  onCleanup: function onCleanup() {},
  onClose: function onClose() {},
  trapFocusFunc: __WEBPACK_IMPORTED_MODULE_4__keyboard__["a" /* default */].trapFocus.bind(__WEBPACK_IMPORTED_MODULE_4__keyboard__["a" /* default */]),
  releaseFocusFunc: __WEBPACK_IMPORTED_MODULE_4__keyboard__["a" /* default */].releaseFocus.bind(__WEBPACK_IMPORTED_MODULE_4__keyboard__["a" /* default */]),
  loadHammerJS: loadHammerJSFunc,
  srLinkText: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__lib_props__["a" /* get */])('rcProps.translations.openModalSRText', 'Opens in a modal window'),
  addScrollModifierClass: ''
};

/**
 * Check if options.url is define, if it is create an empty modal
 * for ajax content. Otherwise, assign with options.open or $el's data attribute
 * @return {jQuery} modal element
 */
var appendModal = function appendModal() {
  var $modalHTML = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('<div/>', {
    id: 'modal',
    "class": 'modal'
  });
  return $modalHTML;
};

/**
 * Set Aria
 * @param  {jQuery} $el - button /element that opens modal
 */
var setA11yAttr = function setA11yAttr() {
  var $el = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  $el.attr('aria-haspopup', 'dialog');
  if ($el.is('a')) {
    $el.attr('role', 'button');
  } else if ($el.is('button')) {
    $el.attr('type', 'button');
  }
};
/**
 * @param  {jQuery} $el - modal element
 */
var removeModalModifiers = function removeModalModifiers($el) {
  var classArray = Array.from($el[0].classList);
  var modifers = classArray.filter(function (modalClass) {
    return modalClass.includes('--');
  });
  modifers.forEach(function (modClass) {
    $el.removeClass(modClass);
  });
};
/**
 * Reset modal for next ajax loaded content
 */
var resetAjaxModal = function resetAjaxModal() {
  var $ajaxModal = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#modal');
  if ($ajaxModal.length) {
    removeModalModifiers($ajaxModal);
    $ajaxModal.find('.modal__content *:not(".modal__close, .modal__close *")').remove();
  }
};

/**
 * Get Modal
 * Target modal via options.open / data-open(legacy) / href(accessibility)
 * @param  {jQuery} $el - button /element that opens modal
 * @param  {Object} [options={}] - Any options provided upon initialization
 * @return {jQuery} modal element
 */
var getModal = function getModal($el) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var $modal;
  if (options.open) {
    $modal = __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#".concat(options.open));
  } else if (options.url || $el.data('url')) {
    if (__WEBPACK_IMPORTED_MODULE_0_jquery___default()('#modal').length) {
      $modal = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#modal');
    } else {
      $modal = appendModal();
    }
  } else if ($el.data('open')) {
    $modal = __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#".concat($el.data('open')));
  }
  return $modal;
};

/**
 * Merges together all the options and the various conditions in which they
 * can be set.
 * @param  {jQuery} $el - button /element that opens modal
 * @param  {Object} [options={}] - Any options provided upon initialization
 * @return {Object} Immutable version of the options
 */
var mergeOptions = function mergeOptions($el) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  // Assign $modal to modal element either by options {} or $el's data attribute
  var $modal = getModal($el, options);
  var opts = {};
  var modalData = !$modal ? {} : $modal.data();
  if (!$modal) return false;
  opts = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.extend({}, DEFAULTS, $el.data(), options);
  if (!options.url) {
    opts = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.extend({}, DEFAULTS, modalData, $el.data(), options);
  }
  return opts;
};

/**
 * Check if options.url is define, if it is create an empty modal
 * otherwise target options.open or $el's data attribute
 * @param  {jQuery} $el - button /element that opens modal
 * @param  {Object} [options={}] - Any options provided upon initialization
 * @return {jQuery} modal element
 */
var setModal = function setModal($el) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  // Assign $modal to modal element either by options {} or $el's data attribute
  var $modal = getModal($el, options);
  $modal.appendTo('body');
  return $modal;
};
/**
 * Appends a hidden progress bar to the overlay for ajax load feedback
 * @param  {jQuery} $overlay - modal overlay
 */
var appendLoadingBar = function appendLoadingBar($overlay) {
  if (!$overlay.children('.modal-overlay__progress-bar').length) {
    var ajaxLoadingMessage;
    try {
      ajaxLoadingMessage = window.rcProps.translations.ajaxLoadingMessage;
    } catch (e) {
      ajaxLoadingMessage = 'Content is loading';
    }
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()("<div class=\"modal-overlay__progress-bar modal-overlay__progress-bar--hidden progress-bar progress-bar--center\" tabindex=\"-1\">\n        <div class=\"u-screen-reader\">\n            ".concat(ajaxLoadingMessage, "\n        </div>\n     </div>")).appendTo($overlay);
  }
};
/**
 * @return {jQuery} modal overlay element
 */
var appendModalOverlay = function appendModalOverlay(options) {
  if (!__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.modal-overlay').length) {
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()('<div class="modal-overlay"></div>').appendTo('body');
  }
  if (!options.animation) {
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.modal-overlay').addClass('modal-overlay--no-animation');
  }
  return __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.modal-overlay');
};
/**
 * Check if options.url is define, if it is create an empty modal
 * otherwise target options.open or $el's data attribute
 * @param  {jQuery} $el - modal element
 * @param  {Object} [options={}] - Any options provided upon initialization
 * @return {jQuery} modal content element
 */
var wrapModalContent = function wrapModalContent($el) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var isProductAddedConfirmation = $el.attr('id') === 'product-added-confirmation';
  if (!$el.find('.modal__content').length) {
    if (isProductAddedConfirmation) {
      $el.wrapInner('<div role="dialog" tabindex="-1" class="modal__content u-padding-rl--none"></div>');
    } else {
      $el.wrapInner('<div role="dialog" tabindex="-1" class="modal__content"></div>');
    }
  }
  if (!options.padding) {
    $el.find('.modal__content').addClass('u-padding-a--none');
  }
  if (!options.animation) {
    $el.find('.modal__content').addClass('modal__content--no-animation');
  }
  if (options.video) {
    $el.find('.modal__content').addClass('modal__content--video');
  }
  if (options.fullHeight) {
    $el.find('.modal__content').addClass('modal__content--full-height');
  }

  // used when you need to have the modal full window height
  if (options.windowHeight) {
    $el.find('.modal__content').addClass('u-height--full u-max-height--full');
    setTimeout(function () {
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#modal').addClass('u-padding-a--none');
    });
  }
  return $el.find('.modal__content');
};
/**
 * Adjust and set classes and options for appropriate modal type
 * @param  {jQuery} $el - modal element
 * @param  {string} type - modifier
 */
var addModalModifiers = function addModalModifiers($el, type, classModifier) {
  var modalTypeClass = "modal--".concat(type);
  if (type) {
    $el.addClass(modalTypeClass);
  }
  if (classModifier) {
    $el.addClass(classModifier);
  }
};
/**
 * Adjust and set classes and options for appropriate modal type
 * @param  {jQuery} $el - modal element
 * @param  {Object} [options={}] - Any options provided upon initialization
 * @return {Object} Immutable modal settings
 */
var adjustToModalType = function adjustToModalType($el) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var typeAdjust = {
    pageScroll: false,
    overlay: true
  };
  addModalModifiers($el, options.type, options.addModifierClass);
  switch (options.type) {
    case 'notification':
    case 'notification-bubble':
    case 'toast-notification':
    case 'toast-notification--bubble':
      typeAdjust = {
        pageScroll: true,
        overlay: false
      };
      break;
    case 'toast':
      typeAdjust = {
        pageScroll: false,
        overlay: true
      };
      break;
    default:
  }
  return typeAdjust;
};
/**
 * Remove active class on elements
 * @param  {rest}
 */
var removeActiveClass = function removeActiveClass() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }
  args.forEach(function ($el) {
    $el.removeClass('is-active');
  });
};
/**
 * Ensure one modal is open at a time
 * @param  {jQuery} $modal
 * @param  {jQuery} $overlay
 */
var closeAllModals = function closeAllModals() {
  clearTimeout(window.modalCloseTimeout);
  resetAjaxModal();
  removeActiveClass(__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.modal-overlay'), __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.modal'));
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('html').removeClass('html--modal-overflow-hidden');
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('body').removeClass('body--modal-overflow-hidden').css({
    overflow: 'auto'
  });
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_body_scroll_lock__["clearAllBodyScrollLocks"])();
};
/**
 * Add active class on elements
 * @param  {rest}
 */
var addActiveClass = function addActiveClass() {
  for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    args[_key2] = arguments[_key2];
  }
  args.forEach(function ($el) {
    $el.addClass('is-active');
  });
};
/**
 * Callback after css animation
 * @param {jQuery} $el - css animated element
 */
var afterAnimation = function afterAnimation($el, cb) {
  cb();
};
/**
 * Return to last focusable element
 * @param  {jQuery} $content
 * @param  {Object} [options={}] - Any options provided upon initialization
 */
var returnToLastFocus = function returnToLastFocus($content) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  if (options.returnFocus) {
    options.releaseFocusFunc($content, __WEBPACK_IMPORTED_MODULE_0_jquery___default()(options.returnFocus));
  } else {
    options.releaseFocusFunc($content, __WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).data('lastFocus'));
  }
};
/**
 * Handles the click event to close the modal
 * @param  {event} event
 * @param  {jQuery} $el - button /element that opens modal
 * @param  {jQuery} $modal
 * @param  {jQuery} $content
 * @param  {jQuery} $overlay
 * @param  {Object} [typeAdjust={}] - Modal Settings define by modal type
 * @param  {Object} [options={}] - Any options provided upon initialization
 */
var closeModal = function closeModal(evt, $el, $modal, $content, $overlay, typeAdjust) {
  var options = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : {};
  clearTimeout(window.modalCloseTimeout);
  if (evt) {
    evt.preventDefault();
  }
  if (typeAdjust.overlay) {
    removeActiveClass($overlay);
  }
  removeActiveClass($modal);
  $content.removeClass('modal__content--video');
  options.onCleanup({
    target: $el,
    options: options
  });
  afterAnimation($content, function () {
    if (!typeAdjust.pageScroll) {
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()('body').removeClass('body--modal-overflow-hidden').css({
        overflow: 'auto'
      });
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()('html').removeClass('html--modal-overflow-hidden');
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_body_scroll_lock__["clearAllBodyScrollLocks"])();
      // AB553 start
      var querySelector = '.ab553__visual-modal:not(.ab553__processing-modal)';
      var $visualModal = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(querySelector);
      if ($visualModal.length && $visualModal.hasClass('is-active')) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_body_scroll_lock__["disableBodyScroll"])($visualModal);
      }
      // AB553 end
    }
    options.onClose({
      target: $el,
      options: options
    });
    if (options.url) {
      resetAjaxModal();
    }
    returnToLastFocus($content, options);
  });

  // to ensure the event isn't get bound multiple times
  $content.off('mousedown.modal');
  if (options.overlayClose) {
    // to ensure the event isn't get bound multiple times
    $modal.off('mousedown');
    $content.attr('aria-modal', false);
  }
};
/**
 * Set timeout for notification modal
 * @param  {jQuery} $el
 * @param  {jQuery} $modal
 * @param  {jQuery} $content
 * @param  {jQuery} $overlay
 * @param  {Object} [typeAdjust={}] - Modal Settings define by modal type
 */
var setNotificationDuration = function setNotificationDuration($el, $modal, $content, $overlay, typeAdjust, options) {
  var minDuration = options.notificationDuration;
  window.modalCloseTimeout = setTimeout(function () {
    closeModal(false, $el, $modal, $content, $overlay, typeAdjust, options);
  }, minDuration);
};
/**
 * Add aria-labelledby to modal content for accessible
 * audible title that corresponds with modal's heading
 * @param  {jQuery} $content
 */
var addHedAria = function addHedAria($content) {
  var $modalHed = __WEBPACK_IMPORTED_MODULE_0_jquery___default()($content.find('.modal__hed'));
  if (!$content.find('.modal__hed').length) {
    $modalHed = $content.find('.modal__focus-element');
  }
  if ($modalHed.length && !$modalHed.attr('id')) {
    var modalHedID = "modal-hed-".concat(Math.ceil(Math.random() * 10000000000));
    $content.attr('aria-labelledby', modalHedID);
    $content.attr('aria-modal', true);
    $modalHed.attr('id', modalHedID).attr('tabindex', '-1');
  }
};
/**
 * Save last focus element that's not inside modal
 * @param  {jQuery} $el - last focusable element
 */
var saveLastFocus = function saveLastFocus($el) {
  if (!$el.parents('.modal__content').length) {
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).data('lastFocus', $el);
  }
};

/**
 * Give each <a> a unique href value, in order to avoid users hearing
 * "visited" on links they've yet to visit.
 * @param  {jQuery} $modal
 */
var uniqueCloseHref = function uniqueCloseHref($modal) {
  $modal.find('.js-modal-close').each(function (_, el) {
    var $closeLink = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(el);
    if ($closeLink.is('a')) {
      $closeLink.attr('href', "#modal-uid-".concat(Math.ceil(Math.random() * 10000000000)));
    }
  });
};
/**
 * Swaps data-lazy src/srcset attributes to trigger deferred image loads
 * @param  {jQuery} $el - container element to search for lazy images
 */
var lazyLoadImages = function lazyLoadImages($el) {
  var $lazyImages = $el.find('img[data-lazy]');
  $lazyImages.each(function (_, img) {
    var $lazyImage = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(img);
    var imageSource = $lazyImage.attr('src');
    var dataSource = $lazyImage.data('lazy');
    var dataSrcset = $lazyImage.data('srcset');
    if (imageSource !== dataSource) {
      $lazyImage.attr('src', dataSource); // Update the src to the real image URL
    }
    if (dataSrcset) {
      $lazyImage.attr('srcset', dataSrcset); // Update the srcset attribute if present
    }
  });
};

/**
 * Open modal
 * @param  {jQuery} $el - button /element that opens modal
 * @param  {jQuery} $modal
 * @param  {jQuery} $content
 * @param  {jQuery} $overlay
 * @param  {Object} [typeAdjust={}] - Modal Settings define by modal type
 * @param  {Object} [options={}] - Any options provided upon initialization
 */
var openModal = function openModal($el, $modal, $content, $overlay, typeAdjust) {
  var options = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.modal-overlay__progress-bar').addClass('modal-overlay__progress-bar--hidden');
  options.onOpen({
    target: $el,
    options: options
  });
  addActiveClass($modal);
  addHedAria($content);
  saveLastFocus($el);
  uniqueCloseHref($modal);
  $content.scrollTop(0);
  lazyLoadImages($content);
  if (typeAdjust.overlay) {
    addActiveClass($overlay);
  }
  if (!typeAdjust.pageScroll) {
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()('body').addClass('body--modal-overflow-hidden');
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()('html').addClass('html--modal-overflow-hidden');
    if (options.hasBodyScroll) {
      var scrollLockOptions = {
        allowTouchMove: function allowTouchMove(el) {
          var node = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(el);
          while (node.length && !node.is(document.body)) {
            if (node.hasClass('horizontal-scroll')) {
              return true;
            }
            node = node.parent();
          }
          return false;
        }
      };
      if (options.type === 'toast') {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_body_scroll_lock__["disableBodyScroll"])($modal.find('.modal__scroll')[0], scrollLockOptions);
      } else {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_body_scroll_lock__["disableBodyScroll"])($content[0], scrollLockOptions);
      }
    }
  }
  if (options.type === 'notification') {
    options.loadHammerJS().then(function (Hammer) {
      var hammertime = new Hammer($content[0]);
      hammertime.get('swipe').set({
        direction: Hammer.DIRECTION_VERTICAL
      });
      hammertime.on('swipeup', function (evt) {
        return closeModal(evt, $el, $modal, $content, $overlay, typeAdjust, options);
      });
      if ($content.find('.js-close-link--notification').length < 1) {
        $content.append("\n          <div class=\"js-close-link--notification u-center u-margin-t--sm\">\n            <button class=\"js-modal-close link u-color--white u-text--lg\" type=\"button\">close <span class=\"u-screen-reader\">notification modal</span></button>\n          </div>\n        ");
      }
      setNotificationDuration($el, $modal, $content, $overlay, typeAdjust, options);
    });
  }
  if (options.type === 'toast-notification' || options.type === 'toast-notification--bubble') {
    setNotificationDuration($el, $modal, $content, $overlay, typeAdjust, options);
  }

  // Shift and trap focus to modal after animation
  afterAnimation($content, function () {
    options.trapFocusFunc($content);
    if ($content.find('.modal__hed').length) {
      $content.find('.modal__hed').focus();
    } else {
      $content.find('.modal__focus-element').focus();
    }
    options.onComplete({
      target: $el,
      options: options,
      content: $content
    });
  });
};
/**
 * @param  {jQuery} evt - key event
 * @param  {jQuery} $el - button /element that opens modal
 * @param  {jQuery} $modal
 * @param  {jQuery} $content
 * @param  {jQuery} $overlay
 * @param  {Object} [typeAdjust={}] - Modal Settings define by modal type
 * @param  {Object} [options={}] - Any options provided upon initialization
 */
var escapeModal = function escapeModal(evt, $el, $modal, $content, $overlay, typeAdjust, options) {
  if (__WEBPACK_IMPORTED_MODULE_4__keyboard__["a" /* default */].parseKey(evt) === __WEBPACK_IMPORTED_MODULE_4__keyboard__["a" /* default */].keys.ESCAPE) {
    closeModal(evt, $el, $modal, $content, $overlay, typeAdjust, options);
  }
};
/**
 * @param  {jQuery} evt - key event
 * @param  {jQuery} $el - button /element that opens modal
 * @param  {jQuery} $modal
 * @param  {jQuery} $content
 * @param  {jQuery} $overlay
 * @param  {Object} [typeAdjust={}] - Modal Settings define by modal type
 * @param  {Object} [options={}] - Any options provided upon initialization
 */
var keyboardCloseModal = function keyboardCloseModal(evt, $el, $modal, $content, $overlay, typeAdjust, options) {
  if (__WEBPACK_IMPORTED_MODULE_4__keyboard__["a" /* default */].parseKey(evt) === __WEBPACK_IMPORTED_MODULE_4__keyboard__["a" /* default */].keys.ENTER) {
    closeModal(evt, $el, $modal, $content, $overlay, typeAdjust, options);
  }
};
/**
 * Handles the click event when modal trigger/ button is clicked
 * @param  {jQuery} $el - control
 * @param  {jQuery} $modal
 * @param  {jQuery} $content
 * @param  {jQuery} $overlay
 * @param  {Object} [options={}] - Any options provided upon initialization
 * @param  {event} evt
 */
var openModalEventHandler = function openModalEventHandler($el, $modal, $content, $overlay) {
  var options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
  var evt = arguments.length > 5 ? arguments[5] : undefined;
  var typeAdjust = adjustToModalType($modal, options);
  if (evt) {
    evt.preventDefault();
  }
  closeAllModals();
  $content
  // To ensure the event isn't get bound multiple times
  .off('keydown.modalEscape')
  // escape event to close modal
  .on('keydown.modalEscape', function (event) {
    return escapeModal(event, $el, $modal, $content, $overlay, typeAdjust, options);
  }).data('modalEscape', true)
  // Add listener to modal close button keyboard users hitting the enter key for a11y
  .on('keydown.modalClose', '.js-modal-close', function (event) {
    return keyboardCloseModal(event, $el, $modal, $content, $overlay, typeAdjust, options);
  }).data('modalEscape', true)
  // Add listener modal content for modalCloseClass to close modal
  .on('mousedown.modal', '.js-modal-close', function (event) {
    return closeModal(event, $el, $modal, $content, $overlay, typeAdjust, options);
  })
  // Prevents href getting added to end of URL
  .on('click.modal', '.js-modal-close', function (event) {
    return event.preventDefault();
  })
  // Stop the clicks from bubbling up
  .on('mousedown.modal', function (event) {
    return event.stopPropagation();
  });
  if (options.overlayClose) {
    $modal
    // Add listener to outside of the modal if set true
    .on('mousedown.modal', function (event) {
      return closeModal(event, $el, $modal, $content, $overlay, typeAdjust, options);
    });
  } else {
    $modal
    // Remove listener to outside of the modal if set false
    .off('mousedown.modal');
  }

  // If url is passed then attempt to load ajax.
  if (options.url) {
    var showProgressBar = setTimeout(function () {
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.modal-overlay__progress-bar').removeClass('modal-overlay__progress-bar--hidden');
    }, isFasterModal ? 500 : 0);
    options.onLoad({
      target: $el,
      options: options
    });
    addModalModifiers($modal, options.type, options.addModifierClass);
    if (options.type !== 'notification' && options.type !== 'notification-bubble' && options.type !== 'toast-notification') {
      addActiveClass($overlay);
    }
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.modal-overlay__progress-bar').focus();
    __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.ajax({
      url: options.url,
      method: 'POST',
      cache: options.cache,
      data: options.data,
      timeout: 60000
    }).fail(function (jqXHR) {
      $content.prepend("<h3 class=\"modal__hed\">".concat(jqXHR.statusText, "</h3>"));
      openModal($el, $modal, $content, $overlay, typeAdjust, options);
    }).done(function (content) {
      $content.prepend(content);
      if (options.type === 'toast' && $content.find('.modal__scroll').length === 0) {
        setTimeout(function () {
          var scrollContent = "<div class='modal__scroll'></div>";
          if (options.addScrollModifierClass) {
            scrollContent = "<div class='modal__scroll ".concat(options.addScrollModifierClass, "'></div>");
          }
          $content.wrapInner(scrollContent);
          var modalClose = $content.find('.modal__close');
          modalClose.remove();
          $content.append(modalClose);
        });
      }
      if (isFasterModal) {
        clearTimeout(showProgressBar);
      }
      openModal($el, $modal, $content, $overlay, typeAdjust, options);
    });
    // Not dynamic, open inline modal instead.
  } else {
    openModal($el, $modal, $content, $overlay, typeAdjust, options);
  }

  // if bg needs to be transparent
  if (options.transparent) {
    $content.addClass('modal__content--bg-transparent');
  }
};
/**
 * Applies any sort of event handlers for the modal.
 * @param  {jQuery} $el - button /element that opens modal
 * @param  {jQuery} $modal
 * @param  {jQuery} $content
 * @param  {jQuery} $overlay
 * @param  {Object} [options={}] - Any options provided upon initialization
 */
var setEventListeners = function setEventListeners($el, $modal, $content, $overlay) {
  var options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
  // Add escape key down feature
  // Add listener to button to open modal
  if (!options.triggerOpen) {
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()($el).on('click.modal', function (evt) {
      return openModalEventHandler($el, $modal, $content, $overlay, options, evt);
    });
  }
};
/**
 * Remove any sort of event handlers for the modal.
 * @param  {jQuery} $el - button /element that opens modal
 * @param  {jQuery} $modal
 * @param  {jQuery} $content
 */
var removeEventListeners = function removeEventListeners($el, $modal, $content) {
  $el.off('click.modal');
  $content.off('mousedown.modal').off('keydown.modalEscape');
  $modal.off('mousedown.modal');
};
/**
 * If triggerOpen option is set true open modal
 * @param  {jQuery} $modal
 * @param  {jQuery} $content
 * @param  {jQuery} $overlay
 * @param  {Object} [options={}] - Any options provided upon initialization
 */
var checkTriggerOpen = function checkTriggerOpen($el, $modal, $content, $overlay) {
  var options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
  if (options.triggerOpen) {
    openModalEventHandler($el, $modal, $content, $overlay, options, false);
  }
};
/**
 * @param  {jQuery} $el - button /element that opens modal
 * @param  {jQuery} $modal
 * @param  {jQuery} $content
 * @param  {Object} [options={}] - Any options provided upon initialization
 * @param  {Function} deregister - teardown method from register jquery plugin
 */
var _destroy = function destroy($el, $modal, $content) {
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var deregister = arguments.length > 4 ? arguments[4] : undefined;
  removeEventListeners($el, $modal, $content);
  removeActiveClass(__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.modal-overlay'), __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.modal'));
  removeModalModifiers($modal);
  deregister();
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('body').removeClass('body--modal-overflow-hidden');
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('html').removeClass('html--modal-overflow-hidden');
  if (options.url) {
    $modal.remove();
  }
};
/**
 * Add close button to modal content
 * @param  {jQuery} $content
 * @param  {Object} [options={}] - Any options provided upon initialization
 */
var addCloseButton = function addCloseButton($content) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  // Always remove first — prevents duplicate close buttons when a modal opens another modal
  $content.find('.modal__close').remove();
  if (!options.closeButton || options.type === 'notification') return;
  var isToast = options.type === 'toast';
  var btnClass = isToast ? 'js-modal-close modal__close' : 'btn btn--circle btn--white js-modal-close modal__close';
  $content.append("\n    <button class=\"".concat(btnClass, "\" type=\"button\">\n      <span class=\"icon icon--x\">\n        <svg viewBox=\"0 0 16 16\" aria-hidden=\"true\" focusable=\"false\" role=\"presentation\">\n          <path d=\"M9.06 8l2.72-2.72A.75.75 0 0 0 10.72 4.22L8 6.94 5.28 4.22A.75.75 0 0 0 4.22 5.28L6.94 8l-2.72 2.72A.75.75 0 1 0 5.28 11.78L8 9.06l2.72 2.72a.75.75 0 0 0 1.061-1.061z\"/>\n        </svg>\n        <div class=\"u-screen-reader\">Close Modal</div>\n      </span>\n    </button>\n  "));
};
var setA11y = function setA11y($el, opts) {
  setA11yAttr($el);
  if (!$el.find('.u-screen-reader').length) {
    $el.append("<span class=\"u-screen-reader\">".concat(opts.srLinkText, "</span>"));
  }
};
/**
 * Initializes modal.
 * @param {HTMLElement} el - button /element that opens modal
 * @param {Object} options - Options used for wiring up the modal
 * @param {Object} deregister - Performs a deregisteration on the plugin
 * @see DEFAULTS
 */
function modal(el) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : __WEBPACK_IMPORTED_MODULE_5__lib_register_jquery_plugin__["b" /* noopActions */],
    deregister = _ref.deregister;
  var $el = options.triggerElement ? __WEBPACK_IMPORTED_MODULE_0_jquery___default()(options.triggerElement) : __WEBPACK_IMPORTED_MODULE_0_jquery___default()(el);
  var opts = mergeOptions($el, options);
  if (opts) {
    var $modal = setModal($el, opts);
    var $overlay = appendModalOverlay(opts);
    var $content = wrapModalContent($modal, opts);
    setA11y($el, opts);
    appendLoadingBar($overlay);
    setEventListeners($el, $modal, $content, $overlay, opts, deregister);
    addCloseButton($content, opts);
    checkTriggerOpen($el, $modal, $content, $overlay, opts, deregister);
    return {
      destroy: function destroy() {
        return _destroy($el, $modal, $content, opts, deregister);
      }
    };
  }
  return true;
}
/**
 * Utility Function for Modal
 * @param  {Object} [options={}] - Any options provided upon initialization
 */
__WEBPACK_IMPORTED_MODULE_0_jquery___default.a.modal = function (options) {
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('<div/>').modal(options);
};
/**
 * Utility Function for Closing Modal
 */
__WEBPACK_IMPORTED_MODULE_0_jquery___default.a.modal.close = function () {
  closeAllModals();
};
/**
 * Utility Function for accessibility
 */
__WEBPACK_IMPORTED_MODULE_0_jquery___default.a.modal.a11y = function () {
  var $els = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-modal-utility');
  var options = {
    srLinkText: DEFAULTS.srLinkText
  };
  $els.each(function (_, el) {
    setA11y(__WEBPACK_IMPORTED_MODULE_0_jquery___default()(el), options);
  });
};
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib_register_jquery_plugin__["a" /* default */])(PLUGIN_NAME, modal);

/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isValue         = __webpack_require__(173)
  , isPlainFunction = __webpack_require__(499)
  , assign          = __webpack_require__(333)
  , normalizeOpts   = __webpack_require__(339)
  , contains        = __webpack_require__(341);

var d = (module.exports = function (dscr, value/*, options*/) {
	var c, e, w, options, desc;
	if (arguments.length < 2 || typeof dscr !== "string") {
		options = value;
		value = dscr;
		dscr = null;
	} else {
		options = arguments[2];
	}
	if (isValue(dscr)) {
		c = contains.call(dscr, "c");
		e = contains.call(dscr, "e");
		w = contains.call(dscr, "w");
	} else {
		c = w = true;
		e = false;
	}

	desc = { value: value, configurable: c, enumerable: e, writable: w };
	return !options ? desc : assign(normalizeOpts(options), desc);
});

d.gs = function (dscr, get, set/*, options*/) {
	var c, e, options, desc;
	if (typeof dscr !== "string") {
		options = set;
		set = get;
		get = dscr;
		dscr = null;
	} else {
		options = arguments[3];
	}
	if (!isValue(get)) {
		get = undefined;
	} else if (!isPlainFunction(get)) {
		options = get;
		get = set = undefined;
	} else if (!isValue(set)) {
		set = undefined;
	} else if (!isPlainFunction(set)) {
		options = set;
		set = undefined;
	}
	if (isValue(dscr)) {
		c = contains.call(dscr, "c");
		e = contains.call(dscr, "e");
	} else {
		c = true;
		e = false;
	}

	desc = { get: get, set: set, configurable: c, enumerable: e };
	return !options ? desc : assign(normalizeOpts(options), desc);
};


/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = __webpack_require__(351)() ? globalThis : __webpack_require__(350);


/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

var listCacheClear = __webpack_require__(433),
    listCacheDelete = __webpack_require__(434),
    listCacheGet = __webpack_require__(435),
    listCacheHas = __webpack_require__(436),
    listCacheSet = __webpack_require__(437);

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

module.exports = ListCache;


/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(42),
    stackClear = __webpack_require__(454),
    stackDelete = __webpack_require__(455),
    stackGet = __webpack_require__(456),
    stackHas = __webpack_require__(457),
    stackSet = __webpack_require__(458);

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  var data = this.__data__ = new ListCache(entries);
  this.size = data.size;
}

// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;

module.exports = Stack;


/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

var eq = __webpack_require__(24);

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

module.exports = assocIndexOf;


/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(7);

/** Built-in value references. */
var objectCreate = Object.create;

/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */
var baseCreate = (function() {
  function object() {}
  return function(proto) {
    if (!isObject(proto)) {
      return {};
    }
    if (objectCreate) {
      return objectCreate(proto);
    }
    object.prototype = proto;
    var result = new object;
    object.prototype = undefined;
    return result;
  };
}());

module.exports = baseCreate;


/***/ }),
/* 46 */
/***/ (function(module, exports) {

/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */
function copyArray(source, array) {
  var index = -1,
      length = source.length;

  array || (array = Array(length));
  while (++index < length) {
    array[index] = source[index];
  }
  return array;
}

module.exports = copyArray;


/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

var baseCreate = __webpack_require__(45),
    isObject = __webpack_require__(7);

/**
 * Creates a function that produces an instance of `Ctor` regardless of
 * whether it was invoked as part of a `new` expression or by `call` or `apply`.
 *
 * @private
 * @param {Function} Ctor The constructor to wrap.
 * @returns {Function} Returns the new wrapped function.
 */
function createCtor(Ctor) {
  return function() {
    // Use a `switch` statement to work with class constructors. See
    // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
    // for more details.
    var args = arguments;
    switch (args.length) {
      case 0: return new Ctor;
      case 1: return new Ctor(args[0]);
      case 2: return new Ctor(args[0], args[1]);
      case 3: return new Ctor(args[0], args[1], args[2]);
      case 4: return new Ctor(args[0], args[1], args[2], args[3]);
      case 5: return new Ctor(args[0], args[1], args[2], args[3], args[4]);
      case 6: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
      case 7: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
    }
    var thisBinding = baseCreate(Ctor.prototype),
        result = Ctor.apply(thisBinding, args);

    // Mimic the constructor's `return` behavior.
    // See https://es5.github.io/#x13.2.2 for more details.
    return isObject(result) ? result : thisBinding;
  };
}

module.exports = createCtor;


/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

var isKeyable = __webpack_require__(430);

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

module.exports = getMapData;


/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

var DataView = __webpack_require__(355),
    Map = __webpack_require__(73),
    Promise = __webpack_require__(357),
    Set = __webpack_require__(124),
    WeakMap = __webpack_require__(127),
    baseGetTag = __webpack_require__(16),
    toSource = __webpack_require__(167);

/** `Object#toString` result references. */
var mapTag = '[object Map]',
    objectTag = '[object Object]',
    promiseTag = '[object Promise]',
    setTag = '[object Set]',
    weakMapTag = '[object WeakMap]';

var dataViewTag = '[object DataView]';

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = toSource(DataView),
    mapCtorString = toSource(Map),
    promiseCtorString = toSource(Promise),
    setCtorString = toSource(Set),
    weakMapCtorString = toSource(WeakMap);

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
    (Map && getTag(new Map) != mapTag) ||
    (Promise && getTag(Promise.resolve()) != promiseTag) ||
    (Set && getTag(new Set) != setTag) ||
    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
  getTag = function(value) {
    var result = baseGetTag(value),
        Ctor = result == objectTag ? value.constructor : undefined,
        ctorString = Ctor ? toSource(Ctor) : '';

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag;
        case mapCtorString: return mapTag;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag;
        case weakMapCtorString: return weakMapTag;
      }
    }
    return result;
  };
}

module.exports = getTag;


/***/ }),
/* 50 */
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  var type = typeof value;
  length = length == null ? MAX_SAFE_INTEGER : length;

  return !!length &&
    (type == 'number' ||
      (type != 'symbol' && reIsUint.test(value))) &&
        (value > -1 && value % 1 == 0 && value < length);
}

module.exports = isIndex;


/***/ }),
/* 51 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

module.exports = isPrototype;


/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(19);

/* Built-in method references that are verified to be native. */
var nativeCreate = getNative(Object, 'create');

module.exports = nativeCreate;


/***/ }),
/* 53 */
/***/ (function(module, exports) {

/** Used as the internal argument placeholder. */
var PLACEHOLDER = '__lodash_placeholder__';

/**
 * Replaces all `placeholder` elements in `array` with an internal placeholder
 * and returns an array of their indexes.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {*} placeholder The placeholder to replace.
 * @returns {Array} Returns the new array of placeholder indexes.
 */
function replaceHolders(array, placeholder) {
  var index = -1,
      length = array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (value === placeholder || value === PLACEHOLDER) {
      array[index] = PLACEHOLDER;
      result[resIndex++] = index;
    }
  }
  return result;
}

module.exports = replaceHolders;


/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

var isSymbol = __webpack_require__(57);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
  if (typeof value == 'string' || isSymbol(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = toKey;


/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(7),
    now = __webpack_require__(483),
    toNumber = __webpack_require__(172);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = toNumber(wait) || 0;
  if (isObject(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        timeWaiting = wait - timeSinceLastCall;

    return maxing
      ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
      : timeWaiting;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
  }

  function timerExpired() {
    var time = now();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now());
  }

  function debounced() {
    var time = now(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        clearTimeout(timerId);
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

module.exports = debounce;


/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(4),
    stubFalse = __webpack_require__(486);

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse;

module.exports = isBuffer;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(101)(module)))

/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(16),
    isObjectLike = __webpack_require__(10);

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && baseGetTag(value) == symbolTag);
}

module.exports = isSymbol;


/***/ }),
/* 58 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is `undefined`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
 * @example
 *
 * _.isUndefined(void 0);
 * // => true
 *
 * _.isUndefined(null);
 * // => false
 */
function isUndefined(value) {
  return value === undefined;
}

module.exports = isUndefined;


/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

var baseProperty = __webpack_require__(386),
    basePropertyDeep = __webpack_require__(387),
    isKey = __webpack_require__(87),
    toKey = __webpack_require__(54);

/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */
function property(path) {
  return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
}

module.exports = property;


/***/ }),
/* 60 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);

function initColorSwatches() {
  var productData = {}; // populated via ajax below.
  var codes = []; // List of product codes for which to retrieve data.
  var department = window.rcProps.department || "F"; // Default to women's. Set later when we find out for sure.
  var layoutChangeHandlers = [];
  var $loadDonde = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#loadDnde');
  window.bindPlpSwatchJs = function (addLayoutChangeHandler) {
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()(".js-plp-container").each(function () {
      var $div = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this);
      var $swatchContainer = $div.find('.js-plp-swatches');
      if ($swatchContainer.length) {
        createSwatchDropDown($div.find(".js-plp-swatches"));
      }
      createSwatchClickHandlers(__WEBPACK_IMPORTED_MODULE_0_jquery___default()(this));
      if (addLayoutChangeHandler) {
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()(window).on("layout-change", onLayoutChange);
      }
    });
  };
  bindPlpSwatchJs(true);
  window.getColorSwatchDataByAjax = function () {
    __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.ajax({
      url: "/r/ajax/GetSwatchData.jsp",
      dataType: "json",
      method: "POST",
      data: {
        product: codes,
        d: department,
        mobile: true
      },
      success: function success(json) {
        productData = json;
      }
    });
  };
  if ($loadDonde.length === 0 || $loadDonde.val() != 'true') {
    getColorSwatchDataByAjax();
  }

  // columnView.js fires a custom event when it changes the layout.
  function onLayoutChange(event) {
    // This doesn't need to be synchronous. Let the event handler return
    // to re-flowing the page.
    window.setTimeout(function () {
      layoutChangeHandlers.forEach(function (f) {
        try {
          f(event);
        } catch (e) {
          console.log(e);
        }
      });
    }, 1);
  }
  function createSwatchClickHandlers($div) {
    var $heart = $div.find('.fav-item');
    var $qv = $div.find(".js-plp-quickview");
    var $img = $div.find(".js-plp-image"); // *Seems to be the only one... need to add class.
    var $name = $div.find(".js-plp-name");
    var $brand = $div.find(".js-plp-brand");
    var $price = $div.find(".js-plp-price");
    var $link = $div.find(".js-plp-pdp-link");
    var $retail = $div.find(".js-plp-price-retail");
    var $swatches = $div.find(".js-plp-swatch");
    var $similaritemslink = $div.find(".js-plp-similar-items-link");
    $swatches.each(function () {
      var code = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).data("code");
      department = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).data("department") || department; // Just stomp on the value. Last one wins.
      codes.push(code);
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).click(function () {
        $swatches.removeClass("is-toggled"); // desktop
        $swatches.removeClass("plp_active_color "); // mobile
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).addClass("is-toggled"); // desktop
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).addClass("plp_active_color"); // mobile
        if (code in productData) {
          var prod = productData[code];
          $img.attr("src", prod.imgPlp);
          if (prod.imgSrcSet) {
            $img.attr("srcset", prod.imgSrcSet);
          }
          $name.html(prod.name);
          $brand.html(prod.brand);
          if (prod.priceMin && prod.priceMax) {
            $div.find('.js-plp-prices-div').html("\n                            <span class=\"js-plp-price price__retail\">".concat(prod.priceMin, "</span>\n                            -\n                            <span class=\"js-plp-price price__retail\">").concat(prod.priceMax, "</span>\n\t\t\t\t\t\t"));
          } else if (prod.priceMarkup) {
            $div.find('.js-plp-prices-div').html(prod.priceMarkup);
          } else {
            $div.find('.js-plp-prices-div').html("\n                            <div class=\"price\">\n                                <span class=\"js-plp-price price__retail\">".concat(prod.price, "</span>\n                                ").concat(prod.retailPrice && "<span class=\"price__value--plp\">(".concat(prod.retailPrice, ")</span>"), "\n                            </div>\n                        "));
          }
          $link.prop("href", prod.url);
          $qv.attr("data-code", code); // Updates parameter value to Quick View code.

          $similaritemslink.data("pcode", code);

          //update heart status
          $heart.attr("data-pcode", code);
          $heart.toggleClass("favorite-button--active", prod.isFavorite);
        }
      });
    });
    $heart.click(function (e) {
      e.preventDefault();
      var code = this.getAttribute("data-pcode");
      if (productData[code]) {
        productData[code].isFavorite = !productData[code].isFavorite;
      }
    });
    window.updateSwatchHeart = function (code, heartStatus) {
      if (productData[code]) {
        productData[code].isFavorite = heartStatus;
      }
    };
  }
  function createSwatchDropDown($container) {
    var visible;
    var expanded;
    function toggleSwatches() {
      visible ? hide() : show();
    }
    function hide() {
      $up.hide();
      $down.show();
      visible = false;
    }
    function show() {
      $down.hide();
      $up.show();
      visible = true;
    }
    function init() {
      $container.css("height", ""); // Let the element expand/contract to its natural height.
      var containerWidth = $container.width();
      var numWide = Math.floor(containerWidth / swatchWidth);
      if (numWide >= numSwatches) {
        $toggle.hide();
      } else {
        $toggle.show();
        expanded = $container.height();
        $up.hide();
        $down.show();
        $container.height(contracted);
        visible = false;
      }
    }
    if ($container.find(".js-plp-swatch").length > 1) {
      visible = false;
      var $swatches = $container.find(".js-plp-swatch");
      var $toggle = $container.find(".js-swatch-toggle-container");
      var $down = $toggle.find(".js-swatch-toggle-down");
      var $up = $toggle.find(".js-swatch-toggle-up");
      var numSwatches = $swatches.length;

      // Keep some dimensions handy.
      // We can't reliably determine the height of a single row of swatches, since we'd need to take into account
      // padding, margins, etc. $.position() is likewise unreliable since it returns a position relative to the
      // nearest offsetParent, which depends on CSS properties and might not be the actual parent. So we take a
      // good guess: we know how many rows there are, and we figure they're probably devided more-or-less evenly.
      var swatchWidth = $swatches.outerWidth() + Math.max(parseInt($swatches.css("margin-right")), parseInt($swatches.css("margin-left")));
      var swatchHeight = $swatches.outerHeight() + Math.max(parseInt($swatches.css("margin-top")), parseInt($swatches.css("margin-bottom")));
      var numRows = Math.floor($container.height() / swatchHeight);
      expanded = 0;
      var contracted = Math.ceil($container.outerHeight() / numRows);
      layoutChangeHandlers.push(init);
      init();
      $down.click(toggleSwatches);
      $up.click(toggleSwatches);
      hide();
    }
  }
}
;
/* harmony default export */ __webpack_exports__["a"] = (initColorSwatches);

/***/ }),
/* 61 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return revieveMakeupAdvisor; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);

var revieveMakeupAdvisor = function revieveMakeupAdvisor() {
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-makeup-advisor').on('click', function () {
    if (window.rcProps.activeRevievePlugin === 'MAKEUP_ADVISOR' || window.rcProps.activeRevievePlugin === 'FOUNDATION_FINDER') {
      openPlugin();
    } else {
      window.activateRevieveMakeupAdvisor(openPlugin);
    }
  });
};
function openPlugin() {
  Revieve.API.show();
  logEngagement(window.location.href, window.rcProps.activeRevievePlugin, 'Open');
}

/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(setImmediate) {var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
/*!
 * typeahead.js 0.11.1
 * https://github.com/twitter/typeahead.js
 * Copyright 2013-2015 Twitter, Inc. and other contributors; Licensed MIT
 */

// Applied pull request 1542: https://github.com/twitter/typeahead.js/pull/1542/commits/a9e6cec997c413146f81fd4e98107785be5c35e1
// Minified using: http://www.minifier.com/

(function (root, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0)], __WEBPACK_AMD_DEFINE_RESULT__ = function (a0) {
      return root["Bloodhound"] = factory(a0);
    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if ((typeof exports === "undefined" ? "undefined" : _typeof(exports)) === "object") {
    module.exports = factory(require("jquery"));
  } else {
    root["Bloodhound"] = factory(jQuery);
  }
})(this, function ($) {
  var _ = function () {
    "use strict";

    return {
      isMsie: function isMsie() {
        return /(msie|trident)/i.test(navigator.userAgent) ? navigator.userAgent.match(/(msie |rv:)(\d+(.\d+)?)/i)[2] : false;
      },
      isBlankString: function isBlankString(str) {
        return !str || /^\s*$/.test(str);
      },
      escapeRegExChars: function escapeRegExChars(str) {
        return str.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&");
      },
      isString: function isString(obj) {
        return typeof obj === "string";
      },
      isNumber: function isNumber(obj) {
        return typeof obj === "number";
      },
      isArray: $.isArray,
      isFunction: $.isFunction,
      isObject: $.isPlainObject,
      isUndefined: function isUndefined(obj) {
        return typeof obj === "undefined";
      },
      isElement: function isElement(obj) {
        return !!(obj && obj.nodeType === 1);
      },
      isJQuery: function isJQuery(obj) {
        return obj instanceof $;
      },
      toStr: function toStr(s) {
        return _.isUndefined(s) || s === null ? "" : s + "";
      },
      bind: $.proxy,
      each: function each(collection, cb) {
        $.each(collection, reverseArgs);
        function reverseArgs(index, value) {
          return cb(value, index);
        }
      },
      map: $.map,
      filter: $.grep,
      every: function every(obj, test) {
        var result = true;
        if (!obj) {
          return result;
        }
        $.each(obj, function (key, val) {
          if (!(result = test.call(null, val, key, obj))) {
            return false;
          }
        });
        return !!result;
      },
      some: function some(obj, test) {
        var result = false;
        if (!obj) {
          return result;
        }
        $.each(obj, function (key, val) {
          if (result = test.call(null, val, key, obj)) {
            return false;
          }
        });
        return !!result;
      },
      mixin: $.extend,
      identity: function identity(x) {
        return x;
      },
      clone: function clone(obj) {
        return $.extend(true, {}, obj);
      },
      getIdGenerator: function getIdGenerator() {
        var counter = 0;
        return function () {
          return counter++;
        };
      },
      templatify: function templatify(obj) {
        return $.isFunction(obj) ? obj : template;
        function template() {
          return String(obj);
        }
      },
      defer: function defer(fn) {
        setTimeout(fn, 0);
      },
      debounce: function debounce(func, wait, immediate) {
        var timeout, result;
        return function () {
          var context = this,
            args = arguments,
            later,
            callNow;
          later = function later() {
            timeout = null;
            if (!immediate) {
              result = func.apply(context, args);
            }
          };
          callNow = immediate && !timeout;
          clearTimeout(timeout);
          timeout = setTimeout(later, wait);
          if (callNow) {
            result = func.apply(context, args);
          }
          return result;
        };
      },
      throttle: function throttle(func, wait) {
        var context, args, timeout, result, previous, later;
        previous = 0;
        later = function later() {
          previous = new Date();
          timeout = null;
          result = func.apply(context, args);
        };
        return function () {
          var now = new Date(),
            remaining = wait - (now - previous);
          context = this;
          args = arguments;
          if (remaining <= 0) {
            clearTimeout(timeout);
            timeout = null;
            previous = now;
            result = func.apply(context, args);
          } else if (!timeout) {
            timeout = setTimeout(later, remaining);
          }
          return result;
        };
      },
      stringify: function stringify(val) {
        return _.isString(val) ? val : JSON.stringify(val);
      },
      noop: function noop() {}
    };
  }();
  var VERSION = "0.11.1";
  var tokenizers = function () {
    "use strict";

    return {
      nonword: nonword,
      whitespace: whitespace,
      obj: {
        nonword: getObjTokenizer(nonword),
        whitespace: getObjTokenizer(whitespace)
      }
    };
    function whitespace(str) {
      str = _.toStr(str);
      return str ? str.split(/\s+/) : [];
    }
    function nonword(str) {
      str = _.toStr(str);
      return str ? str.split(/\W+/) : [];
    }
    function getObjTokenizer(tokenizer) {
      return function setKey(keys) {
        keys = _.isArray(keys) ? keys : [].slice.call(arguments, 0);
        return function tokenize(o) {
          var tokens = [];
          _.each(keys, function (k) {
            tokens = tokens.concat(tokenizer(_.toStr(o[k])));
          });
          return tokens;
        };
      };
    }
  }();
  var LruCache = function () {
    "use strict";

    function LruCache(maxSize) {
      this.maxSize = _.isNumber(maxSize) ? maxSize : 100;
      this.reset();
      if (this.maxSize <= 0) {
        this.set = this.get = $.noop;
      }
    }
    _.mixin(LruCache.prototype, {
      set: function set(key, val) {
        var tailItem = this.list.tail,
          node;
        if (this.size >= this.maxSize) {
          this.list.remove(tailItem);
          delete this.hash[tailItem.key];
          this.size--;
        }
        if (node = this.hash[key]) {
          node.val = val;
          this.list.moveToFront(node);
        } else {
          node = new Node(key, val);
          this.list.add(node);
          this.hash[key] = node;
          this.size++;
        }
      },
      get: function get(key) {
        var node = this.hash[key];
        if (node) {
          this.list.moveToFront(node);
          return node.val;
        }
      },
      reset: function reset() {
        this.size = 0;
        this.hash = {};
        this.list = new List();
      }
    });
    function List() {
      this.head = this.tail = null;
    }
    _.mixin(List.prototype, {
      add: function add(node) {
        if (this.head) {
          node.next = this.head;
          this.head.prev = node;
        }
        this.head = node;
        this.tail = this.tail || node;
      },
      remove: function remove(node) {
        node.prev ? node.prev.next = node.next : this.head = node.next;
        node.next ? node.next.prev = node.prev : this.tail = node.prev;
      },
      moveToFront: function moveToFront(node) {
        this.remove(node);
        this.add(node);
      }
    });
    function Node(key, val) {
      this.key = key;
      this.val = val;
      this.prev = this.next = null;
    }
    return LruCache;
  }();
  var PersistentStorage = function () {
    "use strict";

    var LOCAL_STORAGE;
    try {
      LOCAL_STORAGE = window.localStorage;
      LOCAL_STORAGE.setItem("~~~", "!");
      LOCAL_STORAGE.removeItem("~~~");
    } catch (err) {
      LOCAL_STORAGE = null;
    }
    function PersistentStorage(namespace, override) {
      this.prefix = ["__", namespace, "__"].join("");
      this.ttlKey = "__ttl__";
      this.keyMatcher = new RegExp("^" + _.escapeRegExChars(this.prefix));
      this.ls = override || LOCAL_STORAGE;
      !this.ls && this._noop();
    }
    _.mixin(PersistentStorage.prototype, {
      _prefix: function _prefix(key) {
        return this.prefix + key;
      },
      _ttlKey: function _ttlKey(key) {
        return this._prefix(key) + this.ttlKey;
      },
      _noop: function _noop() {
        this.get = this.set = this.remove = this.clear = this.isExpired = _.noop;
      },
      _safeSet: function _safeSet(key, val) {
        try {
          this.ls.setItem(key, val);
        } catch (err) {
          if (err.name === "QuotaExceededError") {
            this.clear();
            this._noop();
          }
        }
      },
      get: function get(key) {
        if (this.isExpired(key)) {
          this.remove(key);
        }
        return decode(this.ls.getItem(this._prefix(key)));
      },
      set: function set(key, val, ttl) {
        if (_.isNumber(ttl)) {
          this._safeSet(this._ttlKey(key), encode(now() + ttl));
        } else {
          this.ls.removeItem(this._ttlKey(key));
        }
        return this._safeSet(this._prefix(key), encode(val));
      },
      remove: function remove(key) {
        this.ls.removeItem(this._ttlKey(key));
        this.ls.removeItem(this._prefix(key));
        return this;
      },
      clear: function clear() {
        var i,
          keys = gatherMatchingKeys(this.keyMatcher);
        for (i = keys.length; i--;) {
          this.remove(keys[i]);
        }
        return this;
      },
      isExpired: function isExpired(key) {
        var ttl = decode(this.ls.getItem(this._ttlKey(key)));
        return _.isNumber(ttl) && now() > ttl ? true : false;
      }
    });
    return PersistentStorage;
    function now() {
      return new Date().getTime();
    }
    function encode(val) {
      return JSON.stringify(_.isUndefined(val) ? null : val);
    }
    function decode(val) {
      return $.parseJSON(val);
    }
    function gatherMatchingKeys(keyMatcher) {
      var i,
        key,
        keys = [],
        len = LOCAL_STORAGE.length;
      for (i = 0; i < len; i++) {
        if ((key = LOCAL_STORAGE.key(i)).match(keyMatcher)) {
          keys.push(key.replace(keyMatcher, ""));
        }
      }
      return keys;
    }
  }();
  var Transport = function () {
    "use strict";

    var pendingRequestsCount = 0,
      pendingRequests = {},
      maxPendingRequests = 6,
      sharedCache = new LruCache(10);
    function Transport(o) {
      o = o || {};
      this.cancelled = false;
      this.lastReq = null;
      this._send = o.transport;
      this._get = o.limiter ? o.limiter(this._get) : this._get;
      this._cache = o.cache === false ? new LruCache(0) : sharedCache;
    }
    Transport.setMaxPendingRequests = function setMaxPendingRequests(num) {
      maxPendingRequests = num;
    };
    Transport.resetCache = function resetCache() {
      sharedCache.reset();
    };
    _.mixin(Transport.prototype, {
      _fingerprint: function fingerprint(o) {
        o = o || {};
        return o.url + o.type + $.param(o.data || {});
      },
      _get: function _get(o, cb) {
        var that = this,
          fingerprint,
          jqXhr;
        fingerprint = this._fingerprint(o);
        if (this.cancelled || fingerprint !== this.lastReq) {
          return;
        }
        if (jqXhr = pendingRequests[fingerprint]) {
          jqXhr.done(done).fail(fail);
        } else if (pendingRequestsCount < maxPendingRequests) {
          pendingRequestsCount++;
          pendingRequests[fingerprint] = this._send(o).done(done).fail(fail).always(always);
        } else {
          this.onDeckRequestArgs = [].slice.call(arguments, 0);
        }
        function done(resp) {
          cb(null, resp);
          that._cache.set(fingerprint, resp);
        }
        function fail() {
          cb(true);
        }
        function always() {
          pendingRequestsCount--;
          delete pendingRequests[fingerprint];
          if (that.onDeckRequestArgs) {
            that._get.apply(that, that.onDeckRequestArgs);
            that.onDeckRequestArgs = null;
          }
        }
      },
      get: function get(o, cb) {
        var resp, fingerprint;
        cb = cb || $.noop;
        o = _.isString(o) ? {
          url: o
        } : o || {};
        fingerprint = this._fingerprint(o);
        this.cancelled = false;
        this.lastReq = fingerprint;
        if (resp = this._cache.get(fingerprint)) {
          cb(null, resp);
        } else {
          this._get(o, cb);
        }
      },
      cancel: function cancel() {
        this.cancelled = true;
      }
    });
    return Transport;
  }();
  var SearchIndex = window.SearchIndex = function () {
    "use strict";

    var CHILDREN = "c",
      IDS = "i";
    function SearchIndex(o) {
      o = o || {};
      if (!o.datumTokenizer || !o.queryTokenizer) {
        $.error("datumTokenizer and queryTokenizer are both required");
      }
      this.identify = o.identify || _.stringify;
      this.datumTokenizer = o.datumTokenizer;
      this.queryTokenizer = o.queryTokenizer;
      this.reset();
    }
    _.mixin(SearchIndex.prototype, {
      bootstrap: function bootstrap(o) {
        this.datums = o.datums;
        this.trie = o.trie;
      },
      add: function add(data) {
        var that = this;
        data = _.isArray(data) ? data : [data];
        _.each(data, function (datum) {
          var id, tokens;
          that.datums[id = that.identify(datum)] = datum;
          tokens = normalizeTokens(that.datumTokenizer(datum));
          _.each(tokens, function (token) {
            var node, chars, ch;
            node = that.trie;
            chars = token.split("");
            while (ch = chars.shift()) {
              node = node[CHILDREN][ch] || (node[CHILDREN][ch] = newNode());
              node[IDS].push(id);
            }
          });
        });
      },
      get: function get(ids) {
        var that = this;
        return _.map(ids, function (id) {
          return that.datums[id];
        });
      },
      search: function search(query) {
        var that = this,
          tokens,
          matches;
        tokens = normalizeTokens(this.queryTokenizer(query));
        _.each(tokens, function (token) {
          var node, chars, ch, ids;
          if (matches && matches.length === 0) {
            return false;
          }
          node = that.trie;
          chars = token.split("");
          while (node && (ch = chars.shift())) {
            node = node[CHILDREN][ch];
          }
          if (node && chars.length === 0) {
            ids = node[IDS].slice(0);
            matches = matches ? getIntersection(matches, ids) : ids;
          } else {
            matches = [];
            return false;
          }
        });
        return matches ? _.map(unique(matches), function (id) {
          return that.datums[id];
        }) : [];
      },
      all: function all() {
        var values = [];
        for (var key in this.datums) {
          values.push(this.datums[key]);
        }
        return values;
      },
      reset: function reset() {
        this.datums = {};
        this.trie = newNode();
      },
      serialize: function serialize() {
        return {
          datums: this.datums,
          trie: this.trie
        };
      }
    });
    return SearchIndex;
    function normalizeTokens(tokens) {
      tokens = _.filter(tokens, function (token) {
        return !!token;
      });
      tokens = _.map(tokens, function (token) {
        return token.toLowerCase();
      });
      return tokens;
    }
    function newNode() {
      var node = {};
      node[IDS] = [];
      node[CHILDREN] = {};
      return node;
    }
    function unique(array) {
      var seen = {},
        uniques = [];
      for (var i = 0, len = array.length; i < len; i++) {
        if (!seen[array[i]]) {
          seen[array[i]] = true;
          uniques.push(array[i]);
        }
      }
      return uniques;
    }
    function getIntersection(arrayA, arrayB) {
      var ai = 0,
        bi = 0,
        intersection = [];
      arrayA = arrayA.sort();
      arrayB = arrayB.sort();
      var lenArrayA = arrayA.length,
        lenArrayB = arrayB.length;
      while (ai < lenArrayA && bi < lenArrayB) {
        if (arrayA[ai] < arrayB[bi]) {
          ai++;
        } else if (arrayA[ai] > arrayB[bi]) {
          bi++;
        } else {
          intersection.push(arrayA[ai]);
          ai++;
          bi++;
        }
      }
      return intersection;
    }
  }();
  var Prefetch = function () {
    "use strict";

    var keys;
    keys = {
      data: "data",
      protocol: "protocol",
      thumbprint: "thumbprint"
    };
    function Prefetch(o) {
      this.url = o.url;
      this.ttl = o.ttl;
      this.cache = o.cache;
      this.prepare = o.prepare;
      this.transform = o.transform;
      this.transport = o.transport;
      this.thumbprint = o.thumbprint;
      this.storage = new PersistentStorage(o.cacheKey);
    }
    _.mixin(Prefetch.prototype, {
      _settings: function settings() {
        return {
          url: this.url,
          type: "GET",
          dataType: "json"
        };
      },
      store: function store(data) {
        if (!this.cache) {
          return;
        }
        this.storage.set(keys.data, data, this.ttl);
        this.storage.set(keys.protocol, location.protocol, this.ttl);
        this.storage.set(keys.thumbprint, this.thumbprint, this.ttl);
      },
      fromCache: function fromCache() {
        var stored = {},
          isExpired;
        if (!this.cache) {
          return null;
        }
        stored.data = this.storage.get(keys.data);
        stored.protocol = this.storage.get(keys.protocol);
        stored.thumbprint = this.storage.get(keys.thumbprint);
        isExpired = stored.thumbprint !== this.thumbprint || stored.protocol !== location.protocol;
        return stored.data && !isExpired ? stored.data : null;
      },
      fromNetwork: function fromNetwork(cb) {
        var that = this,
          settings;
        if (!cb) {
          return;
        }
        settings = this.prepare(this._settings());
        this.transport(settings).fail(onError).done(onResponse);
        function onError() {
          cb(true);
        }
        function onResponse(resp) {
          cb(null, that.transform(resp));
        }
      },
      clear: function clear() {
        this.storage.clear();
        return this;
      }
    });
    return Prefetch;
  }();
  var Remote = function () {
    "use strict";

    function Remote(o) {
      this.url = o.url;
      this.prepare = o.prepare;
      this.transform = o.transform;
      this.transport = new Transport({
        cache: o.cache,
        limiter: o.limiter,
        transport: o.transport
      });
    }
    _.mixin(Remote.prototype, {
      _settings: function settings() {
        return {
          url: this.url,
          type: "GET",
          dataType: "json"
        };
      },
      get: function get(query, cb) {
        var that = this,
          settings;
        if (!cb) {
          return;
        }
        query = query || "";
        settings = this.prepare(query, this._settings());
        return this.transport.get(settings, onResponse);
        function onResponse(err, resp) {
          err ? cb([]) : cb(that.transform(resp));
        }
      },
      cancelLastRequest: function cancelLastRequest() {
        this.transport.cancel();
      }
    });
    return Remote;
  }();
  var oParser = function () {
    "use strict";

    return function parse(o) {
      var defaults, sorter;
      defaults = {
        initialize: true,
        identify: _.stringify,
        datumTokenizer: null,
        queryTokenizer: null,
        sufficient: 5,
        sorter: null,
        local: [],
        prefetch: null,
        remote: null
      };
      o = _.mixin(defaults, o || {});
      !o.datumTokenizer && $.error("datumTokenizer is required");
      !o.queryTokenizer && $.error("queryTokenizer is required");
      sorter = o.sorter;
      o.sorter = sorter ? function (x) {
        return x.sort(sorter);
      } : _.identity;
      o.local = _.isFunction(o.local) ? o.local() : o.local;
      o.prefetch = parsePrefetch(o.prefetch);
      o.remote = parseRemote(o.remote);
      return o;
    };
    function parsePrefetch(o) {
      var defaults;
      if (!o) {
        return null;
      }
      defaults = {
        url: null,
        ttl: 24 * 60 * 60 * 1e3,
        cache: true,
        cacheKey: null,
        thumbprint: "",
        prepare: _.identity,
        transform: _.identity,
        transport: null
      };
      o = _.isString(o) ? {
        url: o
      } : o;
      o = _.mixin(defaults, o);
      !o.url && $.error("prefetch requires url to be set");
      o.transform = o.filter || o.transform;
      o.cacheKey = o.cacheKey || o.url;
      o.thumbprint = VERSION + o.thumbprint;
      o.transport = o.transport ? callbackToDeferred(o.transport) : $.ajax;
      return o;
    }
    function parseRemote(o) {
      var defaults;
      if (!o) {
        return;
      }
      defaults = {
        url: null,
        cache: true,
        prepare: null,
        replace: null,
        wildcard: null,
        limiter: null,
        rateLimitBy: "debounce",
        rateLimitWait: 300,
        transform: _.identity,
        transport: null
      };
      o = _.isString(o) ? {
        url: o
      } : o;
      o = _.mixin(defaults, o);
      !o.url && $.error("remote requires url to be set");
      o.transform = o.filter || o.transform;
      o.prepare = toRemotePrepare(o);
      o.limiter = toLimiter(o);
      o.transport = o.transport ? callbackToDeferred(o.transport) : $.ajax;
      delete o.replace;
      delete o.wildcard;
      delete o.rateLimitBy;
      delete o.rateLimitWait;
      return o;
    }
    function toRemotePrepare(o) {
      var prepare, replace, wildcard;
      prepare = o.prepare;
      replace = o.replace;
      wildcard = o.wildcard;
      if (prepare) {
        return prepare;
      }
      if (replace) {
        prepare = prepareByReplace;
      } else if (o.wildcard) {
        prepare = prepareByWildcard;
      } else {
        prepare = idenityPrepare;
      }
      return prepare;
      function prepareByReplace(query, settings) {
        settings.url = replace(settings.url, query);
        return settings;
      }
      function prepareByWildcard(query, settings) {
        settings.url = settings.url.replace(wildcard, encodeURIComponent(query));
        return settings;
      }
      function idenityPrepare(query, settings) {
        return settings;
      }
    }
    function toLimiter(o) {
      var limiter, method, wait;
      limiter = o.limiter;
      method = o.rateLimitBy;
      wait = o.rateLimitWait;
      if (!limiter) {
        limiter = /^throttle$/i.test(method) ? throttle(wait) : debounce(wait);
      }
      return limiter;
      function debounce(wait) {
        return function debounce(fn) {
          return _.debounce(fn, wait);
        };
      }
      function throttle(wait) {
        return function throttle(fn) {
          return _.throttle(fn, wait);
        };
      }
    }
    function callbackToDeferred(fn) {
      return function wrapper(o) {
        var deferred = $.Deferred();
        fn(o, onSuccess, onError);
        return deferred;
        function onSuccess(resp) {
          _.defer(function () {
            deferred.resolve(resp);
          });
        }
        function onError(err) {
          _.defer(function () {
            deferred.reject(err);
          });
        }
      };
    }
  }();
  var Bloodhound = function () {
    "use strict";

    var old;
    old = window && window.Bloodhound;
    function Bloodhound(o) {
      o = oParser(o);
      this.sorter = o.sorter;
      this.identify = o.identify;
      this.sufficient = o.sufficient;
      this.local = o.local;
      this.remote = o.remote ? new Remote(o.remote) : null;
      this.prefetch = o.prefetch ? new Prefetch(o.prefetch) : null;
      this.index = new SearchIndex({
        identify: this.identify,
        datumTokenizer: o.datumTokenizer,
        queryTokenizer: o.queryTokenizer
      });
      o.initialize !== false && this.initialize();
    }
    Bloodhound.noConflict = function noConflict() {
      window && (window.Bloodhound = old);
      return Bloodhound;
    };
    Bloodhound.tokenizers = tokenizers;
    _.mixin(Bloodhound.prototype, {
      __ttAdapter: function ttAdapter() {
        var that = this;
        return this.remote ? withAsync : withoutAsync;
        function withAsync(query, sync, async) {
          return that.search(query, sync, async);
        }
        function withoutAsync(query, sync) {
          return that.search(query, sync);
        }
      },
      _loadPrefetch: function loadPrefetch() {
        var that = this,
          deferred,
          serialized;
        deferred = $.Deferred();
        if (!this.prefetch) {
          deferred.resolve();
        } else if (serialized = this.prefetch.fromCache()) {
          this.index.bootstrap(serialized);
          deferred.resolve();
        } else {
          this.prefetch.fromNetwork(done);
        }
        return deferred.promise();
        function done(err, data) {
          if (err) {
            return deferred.reject();
          }
          that.add(data);
          that.prefetch.store(that.index.serialize());
          deferred.resolve();
        }
      },
      _initialize: function initialize() {
        var that = this,
          deferred;
        this.clear();
        (this.initPromise = this._loadPrefetch()).done(addLocalToIndex);
        return this.initPromise;
        function addLocalToIndex() {
          that.add(that.local);
        }
      },
      initialize: function initialize(force) {
        return !this.initPromise || force ? this._initialize() : this.initPromise;
      },
      add: function add(data) {
        this.index.add(data);
        return this;
      },
      get: function get(ids) {
        ids = _.isArray(ids) ? ids : [].slice.call(arguments);
        return this.index.get(ids);
      },
      search: function search(query, sync, async) {
        var that = this,
          local;
        local = this.sorter(this.index.search(query));
        sync(this.remote ? local.slice() : local);
        if (this.remote && local.length < this.sufficient) {
          this.remote.get(query, processRemote);
        } else if (this.remote) {
          this.remote.cancelLastRequest();
        }
        return this;
        function processRemote(remote) {
          var nonDuplicates = [];
          _.each(remote, function (r) {
            !_.some(local, function (l) {
              return that.identify(r) === that.identify(l);
            }) && nonDuplicates.push(r);
          });
          async && async(nonDuplicates);
        }
      },
      all: function all() {
        return this.index.all();
      },
      clear: function clear() {
        this.index.reset();
        return this;
      },
      clearPrefetchCache: function clearPrefetchCache() {
        this.prefetch && this.prefetch.clear();
        return this;
      },
      clearRemoteCache: function clearRemoteCache() {
        Transport.resetCache();
        return this;
      },
      ttAdapter: function ttAdapter() {
        return this.__ttAdapter();
      }
    });
    return Bloodhound;
  }();
  return Bloodhound;
});
(function (root, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0)], __WEBPACK_AMD_DEFINE_RESULT__ = function (a0) {
      return factory(a0);
    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if ((typeof exports === "undefined" ? "undefined" : _typeof(exports)) === "object") {
    module.exports = factory(require("jquery"));
  } else {
    factory(jQuery);
  }
})(this, function ($) {
  var _ = function () {
    "use strict";

    return {
      isMsie: function isMsie() {
        return /(msie|trident)/i.test(navigator.userAgent) ? navigator.userAgent.match(/(msie |rv:)(\d+(.\d+)?)/i)[2] : false;
      },
      isBlankString: function isBlankString(str) {
        return !str || /^\s*$/.test(str);
      },
      escapeRegExChars: function escapeRegExChars(str) {
        return str.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&");
      },
      isString: function isString(obj) {
        return typeof obj === "string";
      },
      isNumber: function isNumber(obj) {
        return typeof obj === "number";
      },
      isArray: $.isArray,
      isFunction: $.isFunction,
      isObject: $.isPlainObject,
      isUndefined: function isUndefined(obj) {
        return typeof obj === "undefined";
      },
      isElement: function isElement(obj) {
        return !!(obj && obj.nodeType === 1);
      },
      isJQuery: function isJQuery(obj) {
        return obj instanceof $;
      },
      toStr: function toStr(s) {
        return _.isUndefined(s) || s === null ? "" : s + "";
      },
      bind: $.proxy,
      each: function each(collection, cb) {
        $.each(collection, reverseArgs);
        function reverseArgs(index, value) {
          return cb(value, index);
        }
      },
      map: $.map,
      filter: $.grep,
      every: function every(obj, test) {
        var result = true;
        if (!obj) {
          return result;
        }
        $.each(obj, function (key, val) {
          if (!(result = test.call(null, val, key, obj))) {
            return false;
          }
        });
        return !!result;
      },
      some: function some(obj, test) {
        var result = false;
        if (!obj) {
          return result;
        }
        $.each(obj, function (key, val) {
          if (result = test.call(null, val, key, obj)) {
            return false;
          }
        });
        return !!result;
      },
      mixin: $.extend,
      identity: function identity(x) {
        return x;
      },
      clone: function clone(obj) {
        return $.extend(true, {}, obj);
      },
      getIdGenerator: function getIdGenerator() {
        var counter = 0;
        return function () {
          return counter++;
        };
      },
      templatify: function templatify(obj) {
        return $.isFunction(obj) ? obj : template;
        function template() {
          return String(obj);
        }
      },
      defer: function defer(fn) {
        setTimeout(fn, 0);
      },
      debounce: function debounce(func, wait, immediate) {
        var timeout, result;
        return function () {
          var context = this,
            args = arguments,
            later,
            callNow;
          later = function later() {
            timeout = null;
            if (!immediate) {
              result = func.apply(context, args);
            }
          };
          callNow = immediate && !timeout;
          clearTimeout(timeout);
          timeout = setTimeout(later, wait);
          if (callNow) {
            result = func.apply(context, args);
          }
          return result;
        };
      },
      throttle: function throttle(func, wait) {
        var context, args, timeout, result, previous, later;
        previous = 0;
        later = function later() {
          previous = new Date();
          timeout = null;
          result = func.apply(context, args);
        };
        return function () {
          var now = new Date(),
            remaining = wait - (now - previous);
          context = this;
          args = arguments;
          if (remaining <= 0) {
            clearTimeout(timeout);
            timeout = null;
            previous = now;
            result = func.apply(context, args);
          } else if (!timeout) {
            timeout = setTimeout(later, remaining);
          }
          return result;
        };
      },
      stringify: function stringify(val) {
        return _.isString(val) ? val : JSON.stringify(val);
      },
      noop: function noop() {}
    };
  }();
  var WWW = function () {
    "use strict";

    var defaultClassNames = {
      wrapper: "twitter-typeahead",
      input: "tt-input",
      hint: "tt-hint",
      menu: "tt-menu",
      dataset: "tt-dataset",
      suggestion: "tt-suggestion",
      selectable: "tt-selectable",
      empty: "tt-empty",
      open: "tt-open",
      cursor: "tt-cursor",
      highlight: "tt-highlight"
    };
    return build;
    function build(o) {
      var www, classes;
      classes = _.mixin({}, defaultClassNames, o);
      www = {
        css: buildCss(),
        classes: classes,
        html: buildHtml(classes),
        selectors: buildSelectors(classes)
      };
      return {
        css: www.css,
        html: www.html,
        classes: www.classes,
        selectors: www.selectors,
        mixin: function mixin(o) {
          _.mixin(o, www);
        }
      };
    }
    function buildHtml(c) {
      return {
        wrapper: '<span class="' + c.wrapper + '"></span>',
        menu: '<div class="' + c.menu + '"></div>'
      };
    }
    function buildSelectors(classes) {
      var selectors = {};
      _.each(classes, function (v, k) {
        selectors[k] = "." + v;
      });
      return selectors;
    }
    function buildCss() {
      var css = {
        wrapper: {
          position: "relative",
          display: "inline-block"
        },
        hint: {
          position: "absolute",
          top: "0",
          left: "0",
          borderColor: "transparent",
          boxShadow: "none",
          opacity: "1"
        },
        input: {
          position: "relative",
          verticalAlign: "top",
          backgroundColor: "transparent"
        },
        inputWithNoHint: {
          position: "relative",
          verticalAlign: "top"
        },
        menu: {
          //position: "absolute",
          position: "relative",
          top: "100%",
          left: "0",
          zIndex: "100"
          // display: "none"
        },
        ltr: {
          left: "0",
          right: "auto"
        },
        rtl: {
          left: "auto",
          right: " 0"
        }
      };
      if (_.isMsie()) {
        _.mixin(css.input, {
          backgroundImage: "url(data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7)"
        });
      }
      return css;
    }
  }();
  var EventBus = function () {
    "use strict";

    var namespace, deprecationMap;
    namespace = "typeahead:";
    deprecationMap = {
      render: "rendered",
      cursorchange: "cursorchanged",
      select: "selected",
      autocomplete: "autocompleted"
    };
    function EventBus(o) {
      if (!o || !o.el) {
        $.error("EventBus initialized without el");
      }
      this.$el = $(o.el);
    }
    _.mixin(EventBus.prototype, {
      _trigger: function _trigger(type, args) {
        var $e;
        $e = $.Event(namespace + type);
        (args = args || []).unshift($e);
        this.$el.trigger.apply(this.$el, args);
        return $e;
      },
      before: function before(type) {
        var args, $e;
        args = [].slice.call(arguments, 1);
        $e = this._trigger("before" + type, args);
        return $e.isDefaultPrevented();
      },
      trigger: function trigger(type) {
        var deprecatedType;
        this._trigger(type, [].slice.call(arguments, 1));
        if (deprecatedType = deprecationMap[type]) {
          this._trigger(deprecatedType, [].slice.call(arguments, 1));
        }
      }
    });
    return EventBus;
  }();
  var EventEmitter = function () {
    "use strict";

    var splitter = /\s+/,
      nextTick = getNextTick();
    return {
      onSync: onSync,
      onAsync: onAsync,
      off: off,
      trigger: trigger
    };
    function on(method, types, cb, context) {
      var type;
      if (!cb) {
        return this;
      }
      types = types.split(splitter);
      cb = context ? bindContext(cb, context) : cb;
      this._callbacks = this._callbacks || {};
      while (type = types.shift()) {
        this._callbacks[type] = this._callbacks[type] || {
          sync: [],
          async: []
        };
        this._callbacks[type][method].push(cb);
      }
      return this;
    }
    function onAsync(types, cb, context) {
      return on.call(this, "async", types, cb, context);
    }
    function onSync(types, cb, context) {
      return on.call(this, "sync", types, cb, context);
    }
    function off(types) {
      var type;
      if (!this._callbacks) {
        return this;
      }
      types = types.split(splitter);
      while (type = types.shift()) {
        delete this._callbacks[type];
      }
      return this;
    }
    function trigger(types) {
      var type, callbacks, args, syncFlush, asyncFlush;
      if (!this._callbacks) {
        return this;
      }
      types = types.split(splitter);
      args = [].slice.call(arguments, 1);
      while ((type = types.shift()) && (callbacks = this._callbacks[type])) {
        syncFlush = getFlush(callbacks.sync, this, [type].concat(args));
        asyncFlush = getFlush(callbacks.async, this, [type].concat(args));
        syncFlush() && nextTick(asyncFlush);
      }
      return this;
    }
    function getFlush(callbacks, context, args) {
      return flush;
      function flush() {
        var cancelled;
        for (var i = 0, len = callbacks.length; !cancelled && i < len; i += 1) {
          cancelled = callbacks[i].apply(context, args) === false;
        }
        return !cancelled;
      }
    }
    function getNextTick() {
      var nextTickFn;
      if (window.setImmediate) {
        nextTickFn = function nextTickSetImmediate(fn) {
          setImmediate(function () {
            fn();
          });
        };
      } else {
        nextTickFn = function nextTickSetTimeout(fn) {
          setTimeout(function () {
            fn();
          }, 0);
        };
      }
      return nextTickFn;
    }
    function bindContext(fn, context) {
      return fn.bind ? fn.bind(context) : function () {
        fn.apply(context, [].slice.call(arguments, 0));
      };
    }
  }();
  var highlight = function (doc) {
    "use strict";

    var defaults = {
      node: null,
      pattern: null,
      tagName: "strong",
      className: null,
      wordsOnly: false,
      caseSensitive: false
    };
    return function hightlight(o) {
      var regex;
      o = _.mixin({}, defaults, o);
      if (!o.node || !o.pattern) {
        return;
      }
      o.pattern = _.isArray(o.pattern) ? o.pattern : [o.pattern];
      regex = getRegex(o.pattern, o.caseSensitive, o.wordsOnly);
      traverse(o.node, hightlightTextNode);
      function hightlightTextNode(textNode) {
        var match, patternNode, wrapperNode;
        if (match = regex.exec(textNode.data)) {
          wrapperNode = doc.createElement(o.tagName);
          o.className && (wrapperNode.className = o.className);
          patternNode = textNode.splitText(match.index);
          patternNode.splitText(match[0].length);
          wrapperNode.appendChild(patternNode.cloneNode(true));
          textNode.parentNode.replaceChild(wrapperNode, patternNode);
        }
        return !!match;
      }
      function traverse(el, hightlightTextNode) {
        var childNode,
          TEXT_NODE_TYPE = 3;
        for (var i = 0; i < el.childNodes.length; i++) {
          childNode = el.childNodes[i];
          if (childNode.nodeType === TEXT_NODE_TYPE) {
            i += hightlightTextNode(childNode) ? 1 : 0;
          } else {
            traverse(childNode, hightlightTextNode);
          }
        }
      }
    };
    function getRegex(patterns, caseSensitive, wordsOnly) {
      var escapedPatterns = [],
        regexStr;
      for (var i = 0, len = patterns.length; i < len; i++) {
        escapedPatterns.push(_.escapeRegExChars(patterns[i]));
      }
      regexStr = wordsOnly ? "\\b(" + escapedPatterns.join("|") + ")\\b" : "(" + escapedPatterns.join("|") + ")";
      return caseSensitive ? new RegExp(regexStr) : new RegExp(regexStr, "i");
    }
  }(window.document);
  var Input = function () {
    "use strict";

    var specialKeyCodeMap;
    specialKeyCodeMap = {
      9: "tab",
      27: "esc",
      37: "left",
      39: "right",
      13: "enter",
      38: "up",
      40: "down"
    };
    function Input(o, www) {
      o = o || {};
      if (!o.input) {
        $.error("input is missing");
      }
      www.mixin(this);
      this.$hint = $(o.hint);
      this.$input = $(o.input);
      this.query = this.$input.val();
      this.queryWhenFocused = this.hasFocus() ? this.query : null;
      this.$overflowHelper = buildOverflowHelper(this.$input);
      this._checkLanguageDirection();
      if (this.$hint.length === 0) {
        this.setHint = this.getHint = this.clearHint = this.clearHintIfInvalid = _.noop;
      }
    }
    Input.normalizeQuery = function (str) {
      return _.toStr(str).replace(/^\s*/g, "").replace(/\s{2,}/g, " ");
    };
    _.mixin(Input.prototype, EventEmitter, {
      _onBlur: function onBlur() {
        this.resetInputValue();
        this.trigger("blurred");
      },
      _onFocus: function onFocus() {
        this.queryWhenFocused = this.query;
        this.trigger("focused");
      },
      _onKeydown: function onKeydown($e) {
        var keyName = specialKeyCodeMap[$e.which || $e.keyCode];
        this._managePreventDefault(keyName, $e);
        if (keyName && this._shouldTrigger(keyName, $e)) {
          this.trigger(keyName + "Keyed", $e);
        }
      },
      _onInput: function onInput() {
        this._setQuery(this.getInputValue());
        this.clearHintIfInvalid();
        this._checkLanguageDirection();
      },
      _managePreventDefault: function managePreventDefault(keyName, $e) {
        var preventDefault;
        switch (keyName) {
          case "up":
          case "down":
            preventDefault = !withModifier($e);
            break;
          default:
            preventDefault = false;
        }
        preventDefault && $e.preventDefault();
      },
      _shouldTrigger: function shouldTrigger(keyName, $e) {
        var trigger;
        switch (keyName) {
          case "tab":
            trigger = !withModifier($e);
            break;
          default:
            trigger = true;
        }
        return trigger;
      },
      _checkLanguageDirection: function checkLanguageDirection() {
        var dir = (this.$input.css("direction") || "ltr").toLowerCase();
        if (this.dir !== dir) {
          this.dir = dir;
          this.$hint.attr("dir", dir);
          this.trigger("langDirChanged", dir);
        }
      },
      _setQuery: function setQuery(val, silent) {
        var areEquivalent, hasDifferentWhitespace;
        areEquivalent = areQueriesEquivalent(val, this.query);
        hasDifferentWhitespace = areEquivalent ? this.query.length !== val.length : false;
        this.query = val;
        if (!silent && !areEquivalent) {
          this.trigger("queryChanged", this.query);
        } else if (!silent && hasDifferentWhitespace) {
          this.trigger("whitespaceChanged", this.query);
        }
      },
      bind: function bind() {
        var that = this,
          onBlur,
          onFocus,
          onKeydown,
          onInput;
        onBlur = _.bind(this._onBlur, this);
        onFocus = _.bind(this._onFocus, this);
        onKeydown = _.bind(this._onKeydown, this);
        onInput = _.bind(this._onInput, this);
        this.$input.on("blur.tt", onBlur).on("focus.tt", onFocus).on("keydown.tt", onKeydown);
        if (!_.isMsie() || _.isMsie() > 9) {
          this.$input.on("input.tt", onInput);
        } else {
          this.$input.on("keydown.tt keypress.tt cut.tt paste.tt", function ($e) {
            if (specialKeyCodeMap[$e.which || $e.keyCode]) {
              return;
            }
            _.defer(_.bind(that._onInput, that, $e));
          });
        }
        return this;
      },
      focus: function focus() {
        this.$input.focus();
      },
      blur: function blur() {
        this.$input.blur();
      },
      getLangDir: function getLangDir() {
        return this.dir;
      },
      getQuery: function getQuery() {
        return this.query || "";
      },
      setQuery: function setQuery(val, silent) {
        this.setInputValue(val);
        this._setQuery(val, silent);
      },
      hasQueryChangedSinceLastFocus: function hasQueryChangedSinceLastFocus() {
        return this.query !== this.queryWhenFocused;
      },
      getInputValue: function getInputValue() {
        return this.$input.val();
      },
      setInputValue: function setInputValue(value) {
        this.$input.val(value);
        this.clearHintIfInvalid();
        this._checkLanguageDirection();
      },
      resetInputValue: function resetInputValue() {
        this.setInputValue(this.query);
      },
      getHint: function getHint() {
        return this.$hint.val();
      },
      setHint: function setHint(value) {
        this.$hint.val(value);
      },
      clearHint: function clearHint() {
        this.setHint("");
      },
      clearHintIfInvalid: function clearHintIfInvalid() {
        var val, hint, valIsPrefixOfHint, isValid;
        val = this.getInputValue();
        hint = this.getHint();
        valIsPrefixOfHint = val !== hint && hint.indexOf(val) === 0;
        isValid = val !== "" && valIsPrefixOfHint && !this.hasOverflow();
        !isValid && this.clearHint();
      },
      hasFocus: function hasFocus() {
        return this.$input.is(":focus");
      },
      hasOverflow: function hasOverflow() {
        var constraint = this.$input.width() - 2;
        this.$overflowHelper.text(this.getInputValue());
        return this.$overflowHelper.width() >= constraint;
      },
      isCursorAtEnd: function isCursorAtEnd() {
        var valueLength, selectionStart, range;
        valueLength = this.$input.val().length;
        selectionStart = this.$input[0].selectionStart;
        if (_.isNumber(selectionStart)) {
          return selectionStart === valueLength;
        } else if (document.selection) {
          range = document.selection.createRange();
          range.moveStart("character", -valueLength);
          return valueLength === range.text.length;
        }
        return true;
      },
      destroy: function destroy() {
        this.$hint.off(".tt");
        this.$input.off(".tt");
        this.$overflowHelper.remove();
        this.$hint = this.$input = this.$overflowHelper = $("<div>");
      }
    });
    return Input;
    function buildOverflowHelper($input) {
      return $('<pre aria-hidden="true"></pre>').css({
        position: "absolute",
        visibility: "hidden",
        whiteSpace: "pre",
        fontFamily: $input.css("font-family"),
        fontSize: $input.css("font-size"),
        fontStyle: $input.css("font-style"),
        fontVariant: $input.css("font-variant"),
        fontWeight: $input.css("font-weight"),
        wordSpacing: $input.css("word-spacing"),
        letterSpacing: $input.css("letter-spacing"),
        textIndent: $input.css("text-indent"),
        textRendering: $input.css("text-rendering"),
        textTransform: $input.css("text-transform")
      }).insertAfter($input);
    }
    function areQueriesEquivalent(a, b) {
      return Input.normalizeQuery(a) === Input.normalizeQuery(b);
    }
    function withModifier($e) {
      return $e.altKey || $e.ctrlKey || $e.metaKey || $e.shiftKey;
    }
  }();
  var Dataset = function () {
    "use strict";

    var keys, nameGenerator;
    keys = {
      val: "tt-selectable-display",
      obj: "tt-selectable-object"
    };
    nameGenerator = _.getIdGenerator();
    function Dataset(o, www) {
      o = o || {};
      o.templates = o.templates || {};
      o.templates.notFound = o.templates.notFound || o.templates.empty;
      if (!o.source) {
        $.error("missing source");
      }
      if (!o.node) {
        $.error("missing node");
      }
      if (o.name && !isValidName(o.name)) {
        $.error("invalid dataset name:" + o.name);
      }
      www.mixin(this);
      this.highlight = !!o.highlight;
      this.name = o.name || nameGenerator();
      this.a11y = o.a11y;
      this.limit = o.limit || 5;
      this.displayFn = getDisplayFn(o.display || o.displayKey);
      this.templates = getTemplates(o.templates, this.displayFn);
      this.source = o.source.__ttAdapter ? o.source.__ttAdapter() : o.source;
      this.async = _.isUndefined(o.async) ? this.source.length > 2 : !!o.async;
      this._resetLastSuggestion();
      this.$el = $(o.node).addClass(this.classes.dataset).addClass(this.classes.dataset + "-" + this.name);
    }
    Dataset.extractData = function extractData(el) {
      var $el = $(el);
      if ($el.data(keys.obj)) {
        return {
          val: $el.data(keys.val) || "",
          obj: $el.data(keys.obj) || null
        };
      }
      return null;
    };
    _.mixin(Dataset.prototype, EventEmitter, {
      _overwrite: function overwrite(query, suggestions) {
        suggestions = suggestions || [];
        if (suggestions.length) {
          this._renderSuggestions(query, suggestions);
        } else if (this.async && this.templates.pending) {
          this._renderPending(query);
        } else if (!this.async && this.templates.notFound) {
          this._renderNotFound(query);
        } else {
          this._empty();
        }
        this.trigger("rendered", this.name, suggestions, false);
      },
      _append: function append(query, suggestions) {
        suggestions = suggestions || [];
        if (suggestions.length && this.$lastSuggestion.length) {
          this._appendSuggestions(query, suggestions);
        } else if (suggestions.length) {
          this._renderSuggestions(query, suggestions);
        } else if (!this.$lastSuggestion.length && this.templates.notFound) {
          this._renderNotFound(query);
        }
        this.trigger("rendered", this.name, suggestions, true);
      },
      _renderSuggestions: function renderSuggestions(query, suggestions) {
        var $fragment;
        $fragment = this._getSuggestionsFragment(query, suggestions);
        this.$lastSuggestion = $fragment.children().last();
        this.$el.html($fragment).prepend(this._getHeader(query, suggestions)).append(this._getFooter(query, suggestions));
      },
      _appendSuggestions: function appendSuggestions(query, suggestions) {
        var $fragment, $lastSuggestion;
        $fragment = this._getSuggestionsFragment(query, suggestions);
        $lastSuggestion = $fragment.children().last();
        this.$lastSuggestion.after($fragment);
        this.$lastSuggestion = $lastSuggestion;
      },
      _renderPending: function renderPending(query) {
        var template = this.templates.pending;
        this._resetLastSuggestion();
        template && this.$el.html(template({
          query: query,
          dataset: this.name
        }));
      },
      _renderNotFound: function renderNotFound(query) {
        var template = this.templates.notFound;
        this._resetLastSuggestion();
        template && this.$el.html(template({
          query: query,
          dataset: this.name
        }));
      },
      _empty: function empty() {
        this.$el.empty();
        this._resetLastSuggestion();
      },
      _getSuggestionsFragment: function getSuggestionsFragment(query, suggestions) {
        var that = this,
          fragment;
        fragment = document.createDocumentFragment();
        _.each(suggestions, function getSuggestionNode(suggestion) {
          var $el, context;
          context = that._injectQuery(query, suggestion);
          $el = $(that.templates.suggestion(context)).data(keys.obj, suggestion).data(keys.val, that.displayFn(suggestion)).addClass(that.classes.suggestion + " " + that.classes.selectable);
          fragment.appendChild($el[0]);
        });
        this.highlight && highlight({
          className: this.classes.highlight,
          node: fragment,
          pattern: query
        });
        return $(fragment);
      },
      _getFooter: function getFooter(query, suggestions) {
        return this.templates.footer ? this.templates.footer({
          query: query,
          suggestions: suggestions,
          dataset: this.name
        }) : null;
      },
      _getHeader: function getHeader(query, suggestions) {
        return this.templates.header ? this.templates.header({
          query: query,
          suggestions: suggestions,
          dataset: this.name
        }) : null;
      },
      _resetLastSuggestion: function resetLastSuggestion() {
        this.$lastSuggestion = $();
      },
      _injectQuery: function injectQuery(query, obj) {
        return _.isObject(obj) ? _.mixin({
          _query: query
        }, obj) : obj;
      },
      update: function update(query) {
        var that = this,
          canceled = false,
          syncCalled = false,
          rendered = 0;
        this.cancel();
        this.cancel = function cancel() {
          canceled = true;
          that.cancel = $.noop;
          that.async && that.trigger("asyncCanceled", query);
        };
        this.source(query, sync, async);
        !syncCalled && sync([]);
        function sync(suggestions) {
          if (syncCalled) {
            return;
          }
          syncCalled = true;
          suggestions = (suggestions || []).slice(0, that.limit);
          rendered = suggestions.length;
          that._overwrite(query, suggestions);
          if (rendered < that.limit && that.async) {
            that.trigger("asyncRequested", query);
          }
        }
        function async(suggestions) {
          suggestions = suggestions || [];
          if (!canceled && rendered < that.limit) {
            that.cancel = $.noop;
            var top = Math.max(0, that.limit - rendered);
            top = Math.min(top, suggestions.length);
            rendered += suggestions.length;
            that._append(query, suggestions.slice(0, top));
            that.async && that.trigger("asyncReceived", query);
          }
        }
      },
      cancel: $.noop,
      clear: function clear() {
        this._empty();
        this.cancel();
        this.trigger("cleared");
      },
      isEmpty: function isEmpty() {
        return this.$el.is(":empty");
      },
      destroy: function destroy() {
        this.$el = $("<div>");
      }
    });
    return Dataset;
    function getDisplayFn(display) {
      display = display || _.stringify;
      return _.isFunction(display) ? display : displayFn;
      function displayFn(obj) {
        return obj[display];
      }
    }
    function getTemplates(templates, displayFn) {
      return {
        notFound: templates.notFound && _.templatify(templates.notFound),
        pending: templates.pending && _.templatify(templates.pending),
        header: templates.header && _.templatify(templates.header),
        footer: templates.footer && _.templatify(templates.footer),
        suggestion: templates.suggestion || suggestionTemplate
      };
      function suggestionTemplate(context) {
        return $("<div>").text(displayFn(context));
      }
    }
    function isValidName(str) {
      return /^[_a-zA-Z0-9-]+$/.test(str);
    }
  }();
  var Menu = function () {
    "use strict";

    function Menu(o, www) {
      var that = this;
      o = o || {};
      if (!o.node) {
        $.error("node is required");
      }
      www.mixin(this);
      this.$node = $(o.node);
      this.query = null;
      this.datasets = _.map(o.datasets, initializeDataset);
      function initializeDataset(oDataset) {
        var node = that.$node.find(oDataset.node).first();
        oDataset.node = node.length ? node : $("<ul class=\"ui-list\">").appendTo(that.$node);
        return new Dataset(oDataset, www);
      }
    }
    _.mixin(Menu.prototype, EventEmitter, {
      _onSelectableClick: function onSelectableClick($e) {
        this.trigger("selectableClicked", $($e.currentTarget));
      },
      _onRendered: function onRendered(type, dataset, suggestions, async) {
        this.$node.toggleClass(this.classes.empty, this._allDatasetsEmpty());
        this.trigger("datasetRendered", dataset, suggestions, async);
      },
      _onCleared: function onCleared() {
        this.$node.toggleClass(this.classes.empty, this._allDatasetsEmpty());
        this.trigger("datasetCleared");
      },
      _propagate: function propagate() {
        this.trigger.apply(this, arguments);
      },
      _allDatasetsEmpty: function allDatasetsEmpty() {
        return _.every(this.datasets, isDatasetEmpty);
        function isDatasetEmpty(dataset) {
          return dataset.isEmpty();
        }
      },
      _getSelectables: function getSelectables() {
        return this.$node.find(this.selectors.selectable);
      },
      _removeCursor: function _removeCursor() {
        var $selectable = this.getActiveSelectable();
        $selectable && $selectable.removeClass(this.classes.cursor);
      },
      _ensureVisible: function ensureVisible($el) {
        var elTop, elBottom, nodeScrollTop, nodeHeight;
        elTop = $el.position().top;
        elBottom = elTop + $el.outerHeight(true);
        nodeScrollTop = this.$node.scrollTop();
        nodeHeight = this.$node.height() + parseInt(this.$node.css("paddingTop"), 10) + parseInt(this.$node.css("paddingBottom"), 10);
        if (elTop < 0) {
          this.$node.scrollTop(nodeScrollTop + elTop);
        } else if (nodeHeight < elBottom) {
          this.$node.scrollTop(nodeScrollTop + (elBottom - nodeHeight));
        }
      },
      bind: function bind() {
        var that = this,
          onSelectableClick;
        onSelectableClick = _.bind(this._onSelectableClick, this);
        this.$node.on("click.tt", this.selectors.selectable, onSelectableClick);
        _.each(this.datasets, function (dataset) {
          dataset.onSync("asyncRequested", that._propagate, that).onSync("asyncCanceled", that._propagate, that).onSync("asyncReceived", that._propagate, that).onSync("rendered", that._onRendered, that).onSync("cleared", that._onCleared, that);
        });
        return this;
      },
      isOpen: function isOpen() {
        return this.$node.hasClass(this.classes.open);
      },
      open: function open() {
        this.$node.addClass(this.classes.open);
      },
      close: function close() {
        this.$node.removeClass(this.classes.open);
        this._removeCursor();
      },
      setLanguageDirection: function setLanguageDirection(dir) {
        this.$node.attr("dir", dir);
      },
      selectableRelativeToCursor: function selectableRelativeToCursor(delta) {
        var $selectables, $oldCursor, oldIndex, newIndex;
        $oldCursor = this.getActiveSelectable();
        $selectables = this._getSelectables();
        oldIndex = $oldCursor ? $selectables.index($oldCursor) : -1;
        newIndex = oldIndex + delta;
        newIndex = (newIndex + 1) % ($selectables.length + 1) - 1;
        newIndex = newIndex < -1 ? $selectables.length - 1 : newIndex;
        return newIndex === -1 ? null : $selectables.eq(newIndex);
      },
      setCursor: function setCursor($selectable) {
        this._removeCursor();
        if ($selectable = $selectable && $selectable.first()) {
          $selectable.addClass(this.classes.cursor);
          this._ensureVisible($selectable);
        }
      },
      getSelectableData: function getSelectableData($el) {
        return $el && $el.length ? Dataset.extractData($el) : null;
      },
      getActiveSelectable: function getActiveSelectable() {
        var $selectable = this._getSelectables().filter(this.selectors.cursor).first();
        return $selectable.length ? $selectable : null;
      },
      getTopSelectable: function getTopSelectable() {
        var $selectable = this._getSelectables().first();
        return $selectable.length ? $selectable : null;
      },
      update: function update(query) {
        var isValidUpdate = query !== this.query;
        if (isValidUpdate) {
          this.query = query;
          _.each(this.datasets, updateDataset);
        }
        return isValidUpdate;
        function updateDataset(dataset) {
          dataset.update(query);
        }
      },
      empty: function empty() {
        _.each(this.datasets, clearDataset);
        this.query = null;
        this.$node.addClass(this.classes.empty);
        function clearDataset(dataset) {
          dataset.clear();
        }
      },
      destroy: function destroy() {
        this.$node.off(".tt");
        this.$node = $("<div>");
        _.each(this.datasets, destroyDataset);
        function destroyDataset(dataset) {
          dataset.destroy();
        }
      }
    });
    return Menu;
  }();
  var DefaultMenu = function () {
    "use strict";

    var s = Menu.prototype;
    function DefaultMenu() {
      Menu.apply(this, [].slice.call(arguments, 0));
    }
    _.mixin(DefaultMenu.prototype, Menu.prototype, {
      open: function open() {
        !this._allDatasetsEmpty() && this._show();
        return s.open.apply(this, [].slice.call(arguments, 0));
      },
      close: function close() {
        if (this.datasets[0].a11y == false) {
          this._hide();
          return s.close.apply(this, [].slice.call(arguments, 0));
        }
      },
      _onRendered: function onRendered() {
        if (this._allDatasetsEmpty()) {
          this._hide();
        } else {
          this.isOpen() && this._show();
        }
        return s._onRendered.apply(this, [].slice.call(arguments, 0));
      },
      _onCleared: function onCleared() {
        if (this._allDatasetsEmpty()) {
          this._hide();
        } else {
          this.isOpen() && this._show();
        }
        return s._onCleared.apply(this, [].slice.call(arguments, 0));
      },
      setLanguageDirection: function setLanguageDirection(dir) {
        this.$node.css(dir === "ltr" ? this.css.ltr : this.css.rtl);
        return s.setLanguageDirection.apply(this, [].slice.call(arguments, 0));
      },
      _hide: function hide() {
        this.$node.hide();
      },
      _show: function show() {
        this.$node.css("display", "inline-block");
      }
    });
    return DefaultMenu;
  }();
  var Typeahead = function () {
    "use strict";

    function Typeahead(o, www) {
      var onFocused, onBlurred, onEnterKeyed, onTabKeyed, onEscKeyed, onUpKeyed, onDownKeyed, onLeftKeyed, onRightKeyed, onQueryChanged, onWhitespaceChanged;
      o = o || {};
      if (!o.input) {
        $.error("missing input");
      }
      if (!o.menu) {
        $.error("missing menu");
      }
      if (!o.eventBus) {
        $.error("missing event bus");
      }
      www.mixin(this);
      this.eventBus = o.eventBus;
      this.minLength = _.isNumber(o.minLength) ? o.minLength : 1;
      this.input = o.input;
      this.menu = o.menu;
      this.enabled = true;
      this.active = false;
      this.input.hasFocus() && this.activate();
      this.dir = this.input.getLangDir();
      this._hacks();
      this.menu.bind().onSync("selectableClicked", this._onSelectableClicked, this).onSync("asyncRequested", this._onAsyncRequested, this).onSync("asyncCanceled", this._onAsyncCanceled, this).onSync("asyncReceived", this._onAsyncReceived, this).onSync("datasetRendered", this._onDatasetRendered, this).onSync("datasetCleared", this._onDatasetCleared, this);
      onFocused = c(this, "activate", "open", "_onFocused");
      onBlurred = c(this, "deactivate", "_onBlurred");
      onEnterKeyed = c(this, "isActive", "isOpen", "_onEnterKeyed");
      onTabKeyed = c(this, "isActive", "isOpen", "_onTabKeyed");
      onEscKeyed = c(this, "isActive", "_onEscKeyed");
      onUpKeyed = c(this, "isActive", "open", "_onUpKeyed");
      onDownKeyed = c(this, "isActive", "open", "_onDownKeyed");
      onLeftKeyed = c(this, "isActive", "isOpen", "_onLeftKeyed");
      onRightKeyed = c(this, "isActive", "isOpen", "_onRightKeyed");
      onQueryChanged = c(this, "_openIfActive", "_onQueryChanged");
      onWhitespaceChanged = c(this, "_openIfActive", "_onWhitespaceChanged");
      this.input.bind().onSync("focused", onFocused, this).onSync("blurred", onBlurred, this).onSync("enterKeyed", onEnterKeyed, this).onSync("tabKeyed", onTabKeyed, this).onSync("escKeyed", onEscKeyed, this).onSync("upKeyed", onUpKeyed, this).onSync("downKeyed", onDownKeyed, this).onSync("leftKeyed", onLeftKeyed, this).onSync("rightKeyed", onRightKeyed, this).onSync("queryChanged", onQueryChanged, this).onSync("whitespaceChanged", onWhitespaceChanged, this).onSync("langDirChanged", this._onLangDirChanged, this);
    }
    _.mixin(Typeahead.prototype, {
      _hacks: function hacks() {
        var $input, $menu;
        $input = this.input.$input || $("<div>");
        $menu = this.menu.$node || $("<div>");
        $input.on("blur.tt", function ($e) {
          var active, isActive, hasActive;
          active = document.activeElement;
          isActive = $menu.is(active);
          hasActive = $menu.has(active).length > 0;
          if (_.isMsie() && (isActive || hasActive)) {
            $e.preventDefault();
            $e.stopImmediatePropagation();
            _.defer(function () {
              $input.focus();
            });
          }
        });
        $menu.on("mousedown.tt", function ($e) {
          $e.preventDefault();
        });
      },
      _onSelectableClicked: function onSelectableClicked(type, $el) {
        this.select($el);
      },
      _onDatasetCleared: function onDatasetCleared() {
        this._updateHint();
      },
      _onDatasetRendered: function onDatasetRendered(type, dataset, suggestions, async) {
        this._updateHint();
        this.eventBus.trigger("render", suggestions, async, dataset);
      },
      _onAsyncRequested: function onAsyncRequested(type, dataset, query) {
        this.eventBus.trigger("asyncrequest", query, dataset);
      },
      _onAsyncCanceled: function onAsyncCanceled(type, dataset, query) {
        this.eventBus.trigger("asynccancel", query, dataset);
      },
      _onAsyncReceived: function onAsyncReceived(type, dataset, query) {
        this.eventBus.trigger("asyncreceive", query, dataset);
      },
      _onFocused: function onFocused() {
        this._minLengthMet() && this.menu.update(this.input.getQuery());
      },
      _onBlurred: function onBlurred() {
        if (this.input.hasQueryChangedSinceLastFocus()) {
          this.eventBus.trigger("change", this.input.getQuery());
        }
      },
      _onEnterKeyed: function onEnterKeyed(type, $e) {
        var $selectable;
        if ($selectable = this.menu.getActiveSelectable()) {
          this.select($selectable) && $e.preventDefault();
        }
      },
      _onTabKeyed: function onTabKeyed(type, $e) {
        var $selectable;
        if ($selectable = this.menu.getActiveSelectable()) {
          this.select($selectable) && $e.preventDefault();
        } else if ($selectable = this.menu.getTopSelectable()) {
          this.autocomplete($selectable) && $e.preventDefault();
        }
      },
      _onEscKeyed: function onEscKeyed() {
        this.close();
      },
      _onUpKeyed: function onUpKeyed() {
        this.moveCursor(-1);
      },
      _onDownKeyed: function onDownKeyed() {
        this.moveCursor(+1);
      },
      _onLeftKeyed: function onLeftKeyed() {
        if (this.dir === "rtl" && this.input.isCursorAtEnd()) {
          this.autocomplete(this.menu.getTopSelectable());
        }
      },
      _onRightKeyed: function onRightKeyed() {
        if (this.dir === "ltr" && this.input.isCursorAtEnd()) {
          this.autocomplete(this.menu.getTopSelectable());
        }
      },
      _onQueryChanged: function onQueryChanged(e, query) {
        this._minLengthMet(query) ? this.menu.update(query) : this.menu.empty();
      },
      _onWhitespaceChanged: function onWhitespaceChanged() {
        this._updateHint();
      },
      _onLangDirChanged: function onLangDirChanged(e, dir) {
        if (this.dir !== dir) {
          this.dir = dir;
          this.menu.setLanguageDirection(dir);
        }
      },
      _openIfActive: function openIfActive() {
        this.isActive() && this.open();
      },
      _minLengthMet: function minLengthMet(query) {
        query = _.isString(query) ? query : this.input.getQuery() || "";
        return query.length >= this.minLength;
      },
      _updateHint: function updateHint() {
        var $selectable, data, val, query, escapedQuery, frontMatchRegEx, match;
        $selectable = this.menu.getTopSelectable();
        data = this.menu.getSelectableData($selectable);
        val = this.input.getInputValue();
        if (data && !_.isBlankString(val) && !this.input.hasOverflow()) {
          query = Input.normalizeQuery(val);
          escapedQuery = _.escapeRegExChars(query);
          frontMatchRegEx = new RegExp("^(?:" + escapedQuery + ")(.+$)", "i");
          match = frontMatchRegEx.exec(data.val);
          match && this.input.setHint(val + match[1]);
        } else {
          this.input.clearHint();
        }
      },
      isEnabled: function isEnabled() {
        return this.enabled;
      },
      enable: function enable() {
        this.enabled = true;
      },
      disable: function disable() {
        this.enabled = false;
      },
      isActive: function isActive() {
        return this.active;
      },
      activate: function activate() {
        if (this.isActive()) {
          return true;
        } else if (!this.isEnabled() || this.eventBus.before("active")) {
          return false;
        } else {
          this.active = true;
          this.eventBus.trigger("active");
          return true;
        }
      },
      deactivate: function deactivate() {
        if (!this.isActive()) {
          return true;
        } else if (this.eventBus.before("idle")) {
          return false;
        } else {
          this.active = false;
          this.close();
          this.eventBus.trigger("idle");
          return true;
        }
      },
      isOpen: function isOpen() {
        return this.menu.isOpen();
      },
      open: function open() {
        if (!this.isOpen() && !this.eventBus.before("open")) {
          this.menu.open();
          this._updateHint();
          this.eventBus.trigger("open");
        }
        return this.isOpen();
      },
      close: function close() {
        if (this.isOpen() && !this.eventBus.before("close")) {
          this.menu.close();
          this.input.clearHint();
          this.input.resetInputValue();
          this.eventBus.trigger("close");
        }
        return !this.isOpen();
      },
      setVal: function setVal(val) {
        this.input.setQuery(_.toStr(val));
      },
      getVal: function getVal() {
        return this.input.getQuery();
      },
      select: function select($selectable) {
        var data = this.menu.getSelectableData($selectable);
        if (data && !this.eventBus.before("select", data.obj)) {
          this.input.setQuery(data.val, true);
          this.eventBus.trigger("select", data.obj);
          this.close();
          return true;
        }
        return false;
      },
      autocomplete: function autocomplete($selectable) {
        var query, data, isValid;
        query = this.input.getQuery();
        data = this.menu.getSelectableData($selectable);
        isValid = data && query !== data.val;
        if (isValid && !this.eventBus.before("autocomplete", data.obj)) {
          this.input.setQuery(data.val);
          this.eventBus.trigger("autocomplete", data.obj);
          return true;
        }
        return false;
      },
      moveCursor: function moveCursor(delta) {
        var query, $candidate, data, payload, cancelMove;
        query = this.input.getQuery();
        $candidate = this.menu.selectableRelativeToCursor(delta);
        data = this.menu.getSelectableData($candidate);
        payload = data ? data.obj : null;
        cancelMove = this._minLengthMet() && this.menu.update(query);
        if (!cancelMove && !this.eventBus.before("cursorchange", payload)) {
          this.menu.setCursor($candidate);
          if (data) {
            this.input.setInputValue(data.val);
          } else {
            this.input.resetInputValue();
            this._updateHint();
          }
          this.eventBus.trigger("cursorchange", payload);
          return true;
        }
        return false;
      },
      destroy: function destroy() {
        this.input.destroy();
        this.menu.destroy();
      }
    });
    return Typeahead;
    function c(ctx) {
      var methods = [].slice.call(arguments, 1);
      return function () {
        var args = [].slice.call(arguments);
        _.each(methods, function (method) {
          return ctx[method].apply(ctx, args);
        });
      };
    }
  }();
  (function () {
    "use strict";

    var old, keys, methods;
    old = $.fn.typeahead;
    keys = {
      www: "tt-www",
      attrs: "tt-attrs",
      typeahead: "tt-typeahead"
    };
    methods = {
      initialize: function initialize(o, datasets) {
        var www;
        datasets = _.isArray(datasets) ? datasets : [].slice.call(arguments, 1);
        o = o || {};
        www = WWW(o.classNames);
        return this.each(attach);
        function attach() {
          var $input, $wrapper, $hint, $menu, defaultHint, defaultMenu, eventBus, input, menu, typeahead, MenuConstructor;
          _.each(datasets, function (d) {
            d.highlight = !!o.highlight;
          });
          $input = $(this);
          $wrapper = $(www.html.wrapper);
          $hint = $elOrNull(o.hint);
          $menu = $elOrNull(o.menu);
          defaultHint = o.hint !== false && !$hint;
          defaultMenu = o.menu !== false && !$menu;
          defaultHint && ($hint = buildHintFromInput($input, www));
          defaultMenu && ($menu = $(www.html.menu).css(www.css.menu));
          $hint && $hint.val("");
          $input = prepInput($input, www);
          if (defaultHint || defaultMenu) {
            $wrapper.css(www.css.wrapper);
            $input.css(defaultHint ? www.css.input : www.css.inputWithNoHint);
            $input.wrap($wrapper).parent().prepend(defaultHint ? $hint : null).append(defaultMenu ? $menu : null);
          }
          MenuConstructor = defaultMenu ? DefaultMenu : Menu;
          eventBus = new EventBus({
            el: $input
          });
          input = new Input({
            hint: $hint,
            input: $input
          }, www);
          menu = new MenuConstructor({
            node: $menu,
            datasets: datasets
          }, www);
          typeahead = new Typeahead({
            input: input,
            menu: menu,
            eventBus: eventBus,
            minLength: o.minLength
          }, www);
          $input.data(keys.www, www);
          $input.data(keys.typeahead, typeahead);
        }
      },
      isEnabled: function isEnabled() {
        var enabled;
        ttEach(this.first(), function (t) {
          enabled = t.isEnabled();
        });
        return enabled;
      },
      enable: function enable() {
        ttEach(this, function (t) {
          t.enable();
        });
        return this;
      },
      disable: function disable() {
        ttEach(this, function (t) {
          t.disable();
        });
        return this;
      },
      isActive: function isActive() {
        var active;
        ttEach(this.first(), function (t) {
          active = t.isActive();
        });
        return active;
      },
      activate: function activate() {
        ttEach(this, function (t) {
          t.activate();
        });
        return this;
      },
      deactivate: function deactivate() {
        ttEach(this, function (t) {
          t.deactivate();
        });
        return this;
      },
      isOpen: function isOpen() {
        var open;
        ttEach(this.first(), function (t) {
          open = t.isOpen();
        });
        return open;
      },
      open: function open() {
        ttEach(this, function (t) {
          t.open();
        });
        return this;
      },
      close: function close() {
        ttEach(this, function (t) {
          t.close();
        });
        return this;
      },
      select: function select(el) {
        var success = false,
          $el = $(el);
        ttEach(this.first(), function (t) {
          success = t.select($el);
        });
        return success;
      },
      autocomplete: function autocomplete(el) {
        var success = false,
          $el = $(el);
        ttEach(this.first(), function (t) {
          success = t.autocomplete($el);
        });
        return success;
      },
      moveCursor: function moveCursoe(delta) {
        var success = false;
        ttEach(this.first(), function (t) {
          success = t.moveCursor(delta);
        });
        return success;
      },
      val: function val(newVal) {
        var query;
        if (!arguments.length) {
          ttEach(this.first(), function (t) {
            query = t.getVal();
          });
          return query;
        } else {
          ttEach(this, function (t) {
            t.setVal(newVal);
          });
          return this;
        }
      },
      destroy: function destroy() {
        ttEach(this, function (typeahead, $input) {
          revert($input);
          typeahead.destroy();
        });
        return this;
      }
    };
    $.fn.typeahead = function (method) {
      if (methods[method]) {
        return methods[method].apply(this, [].slice.call(arguments, 1));
      } else {
        return methods.initialize.apply(this, arguments);
      }
    };
    $.fn.typeahead.noConflict = function noConflict() {
      $.fn.typeahead = old;
      return this;
    };
    function ttEach($els, fn) {
      $els.each(function () {
        var $input = $(this),
          typeahead;
        (typeahead = $input.data(keys.typeahead)) && fn(typeahead, $input);
      });
    }
    function buildHintFromInput($input, www) {
      return $input.clone().addClass(www.classes.hint).removeData().css(www.css.hint).css(getBackgroundStyles($input)).prop("readonly", true).removeAttr("id name placeholder required").attr({
        autocomplete: "off",
        spellcheck: "false",
        tabindex: -1
      });
    }
    function prepInput($input, www) {
      $input.data(keys.attrs, {
        dir: $input.attr("dir"),
        autocomplete: $input.attr("autocomplete"),
        spellcheck: $input.attr("spellcheck"),
        style: $input.attr("style")
      });
      $input.addClass(www.classes.input).attr({
        autocomplete: "off",
        spellcheck: false
      });
      try {
        !$input.attr("dir") && $input.attr("dir", "auto");
      } catch (e) {}
      return $input;
    }
    function getBackgroundStyles($el) {
      return {
        backgroundAttachment: $el.css("background-attachment"),
        backgroundClip: $el.css("background-clip"),
        backgroundColor: $el.css("background-color"),
        backgroundImage: $el.css("background-image"),
        backgroundOrigin: $el.css("background-origin"),
        backgroundPosition: $el.css("background-position"),
        backgroundRepeat: $el.css("background-repeat"),
        backgroundSize: $el.css("background-size")
      };
    }
    function revert($input) {
      var www, $wrapper;
      www = $input.data(keys.www);
      $wrapper = $input.parent().filter(www.selectors.wrapper);
      _.each($input.data(keys.attrs), function (val, key) {
        _.isUndefined(val) ? $input.removeAttr(key) : $input.attr(key, val);
      });
      $input.removeData(keys.typeahead).removeData(keys.www).removeData(keys.attr).removeClass(www.classes.input);
      if ($wrapper.length) {
        $input.detach().insertAfter($wrapper);
        $wrapper.remove();
      }
    }
    function $elOrNull(obj) {
      var isValid, $el;
      isValid = _.isJQuery(obj) || _.isElement(obj);
      $el = isValid ? $(obj).first() : [];
      return $el.length ? $el : null;
    }
  })();
});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(496).setImmediate))

/***/ }),
/* 63 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DEFAULT_MESSAGE; });
/* eslint import/prefer-default-export: 0 */

/**
 * Defines default value for when a field is invalid
 * @type string
 */
var DEFAULT_MESSAGE = 'Valid entry required';

/***/ }),
/* 64 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_times__ = __webpack_require__(487);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_times___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_times__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_random__ = __webpack_require__(485);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_random___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_random__);



/**
 * Responsible for generating a random set of characters
 * @param {Object} options - Configurable options for generating a random string
 * @param {string} [options.prefix=''] - Prefix added to random characters
 * @param {string} [options.length=30] - The amount of characters
 * @returns {string} A set of randomly generated characters
 */
var generateRandom = function generateRandom() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _options$prefix = options.prefix,
    prefix = _options$prefix === void 0 ? '' : _options$prefix,
    _options$length = options.length,
    length = _options$length === void 0 ? 30 : _options$length;
  var chars = __WEBPACK_IMPORTED_MODULE_0_lodash_times___default()(length, function () {
    return __WEBPACK_IMPORTED_MODULE_1_lodash_random___default()(35).toString(36);
  }).join('');
  return prefix ? "".concat(prefix, "-").concat(chars) : chars;
};
/* harmony default export */ __webpack_exports__["a"] = (generateRandom);

/***/ }),
/* 65 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export DATA_ATTR */
/* harmony export (immutable) */ __webpack_exports__["a"] = redirectHref;
/**
 * Redirects user to new page when selecting an option with data attribute
 * @module lib/redirectHref
 */

var DATA_ATTR = 'data-href';
var DEFAULT_OPTIONS = {
  redirectFunc: function redirectFunc(href) {
    document.location.href = href;
  }
};

/**
 * Function to redirect user based on data attribute.
 * @param {HTMLElement} el - The selected option
 */
function redirectHref(el) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _Object$assign = Object.assign({}, DEFAULT_OPTIONS, options),
    redirectFunc = _Object$assign.redirectFunc;
  var href = el.getAttribute(DATA_ATTR);
  if (href) {
    redirectFunc(href);
  }
}

/***/ }),
/* 66 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export EL_CLASS */
/* harmony export (immutable) */ __webpack_exports__["a"] = updateDefectDisclaimer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/**
 * Updates 'defect-disclaimer' text to reflect size chosen
 * @module updateDefectDisclaimer
 */


var EL_CLASS = 'defect-disclaimer';

/**
 * Initializes 'defect disclaimer' text changes.
 * @param {HTMLElement} wrap - The closest wrap from the select
 * @param {Object} chosen - Information on the selected size
 * @return {jQuery} defect-disclaimer element
 */
function updateDefectDisclaimer(_ref) {
  var wrap = _ref.wrap,
    _ref$chosen = _ref.chosen,
    chosen = _ref$chosen === void 0 ? {} : _ref$chosen;
  var defectDisclaimer = chosen['defect-disclaimer'];
  var $el = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(wrap).find(".".concat(EL_CLASS));
  if (defectDisclaimer) {
    $el.html("".concat(defectDisclaimer));
  } else {
    $el.empty();
  }
  return $el;
}

/***/ }),
/* 67 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export EL_CLASS */
/* unused harmony export LABEL_DATA_ATTR */
/* harmony export (immutable) */ __webpack_exports__["a"] = updateDeliveryDate;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/**
 * Updates 'delivery-date' text to reflect size chosen
 * @module updateDeliveryDate
 */


var EL_CLASS = 'delivery-date';
var LABEL_DATA_ATTR = 'label';

/**
 * Initializes 'estimated delivery' text changes.
 * @param {HTMLElement} wrap - The closest wrap from the select
 * @param {Object} chosen - Information on the selected size
 * @return {jQuery} delivery-date element
 */
function updateDeliveryDate(_ref) {
  var wrap = _ref.wrap,
    _ref$chosen = _ref.chosen,
    chosen = _ref$chosen === void 0 ? {} : _ref$chosen;
  var deliveryDate = chosen['delivery-date'];
  var $el = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(wrap).find(".".concat(EL_CLASS));
  var label = $el.data(LABEL_DATA_ATTR);
  if (deliveryDate) {
    $el.html("".concat(label, " ").concat(deliveryDate));
  } else {
    $el.empty();
  }
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-free-shipping').toggle(!chosen['final-sale']);
  return $el;
}

/***/ }),
/* 68 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export TEMPLATE_PREFIX */
/* unused harmony export EL_CLASS */
/* harmony export (immutable) */ __webpack_exports__["a"] = updateCTA;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_get_template_html_by_id__ = __webpack_require__(112);
/**
 * Updates CTA when stock id changes
 * @module modules/updateCTA
 */




/**
 * Element class name
 * @type {string}
 */
var TEMPLATE_PREFIX = 'cta-buttons';

/**
 * Prefix used on the template's id
 * @type {string}
 */
var EL_CLASS = 'cta';

/**
 * Choose the CTA based on attributes.
 * @private
 * @param {object} data - Product data object
 * @param {object} data.chosen - Selected product size, including relevant data
 * @param {boolean} chosen.oos - Whether the chosen size is out of stock
 * @param {boolean} chosen.preorder - Whether the chosen size is preorder only
 * @param {boolean} data.allOnSale - Whether all sizes are on sale
 * @return {string} Selected Id
 */
function getId(_ref) {
  var _ref$chosen = _ref.chosen,
    chosen = _ref$chosen === void 0 ? {} : _ref$chosen,
    allOnSale = _ref.allOnSale;
  var oos = chosen.oos,
    preorder = chosen.preorder,
    fwrdInStock = chosen.fwrdInStock;
  if (oos && fwrdInStock) {
    return 'fwrd-in-stock';
  }
  if (oos && !fwrdInStock) {
    return allOnSale ? 'notify-me' : 'notify-me-special';
  }
  if (preorder) {
    return 'preorder-cart';
  }
  return 'add-to-bag';
}

/**
 * Default options for updateCTA
 * @prop {Function} getId - function to return the CTA id
 * @prop {Function} getTemplate - function to return the template
 */
var DEFAULT_OPTIONS = {
  getId: getId,
  getTemplate: __WEBPACK_IMPORTED_MODULE_1__lib_get_template_html_by_id__["a" /* default */]
};

/**
 * Update CTA based on selected value.
 * @param {object} data - Product data object
 * @param {HTMLElement} data.wrap - The .product wrap
 * @param {string} data.wrapBlockClass - Class of wrap HTML Element
 * @param {boolean} data.allOnSale - Whether all sizes are on sale
 * @see DEFAULT_OPTIONS
 * @return {jQuery} Updated element
 */
function updateCTA(data) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var wrap = data.wrap,
    wrapBlockClass = data.wrapBlockClass;
  var _$$extend = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.extend({}, DEFAULT_OPTIONS, options),
    getIdFunc = _$$extend.getId,
    getTemplateFunc = _$$extend.getTemplate;

  // find the element
  var $el = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(wrap).find(".".concat(wrapBlockClass, "__").concat(EL_CLASS, ":not([data-type=\"subscription\"]):not([data-type=\"bobs-watches\"])"));
  if (!$el.length) {
    return false;
    // throw new Error(`Element not found: .${wrapBlockClass}__${EL_CLASS}`);
  }

  // get the proper html
  var id = getIdFunc(data);
  var html = id ? getTemplateFunc("".concat(TEMPLATE_PREFIX, ".").concat(id)) : '';

  // update the element
  $el.html(html);
  return $el;
}

/***/ }),
/* 69 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export PLUGIN_NAME */
/* unused harmony export DEFAULTS */
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styleguide_lib_merge_options__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_register_jquery_plugin__ = __webpack_require__(1);
/**
 * Toggle Text on click
 * @module toggleText
 */




var PLUGIN_NAME = 'productFilterCount';
var DEFAULTS = {};
var countChecked = function countChecked($checkboxes) {
  return $checkboxes.filter(':checked').length;
};
var renderCount = function renderCount($checkboxes, $count) {
  var count = countChecked($checkboxes);
  $count.text("(".concat(count, ")"));
  if (count === 0) $count.text('');
};
var onChangeListener = function onChangeListener($checkboxes, $count) {
  return $checkboxes.on('change', function () {
    return renderCount($checkboxes, $count);
  });
};

/**
 * Initializes productFilterCount.
 * @param {HTMLElement} container - filter container
 * @param {Object} options - Options used for wiring up the plugin
 * @see DEFAULTS
 */
function productFilterCount(container) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var $container = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(container);
  var opts = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_styleguide_lib_merge_options__["a" /* default */])(DEFAULTS, options, $container);
  var $count = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(opts.filterCount);
  var $checkboxes = $container.find('input[type="checkbox"]');
  renderCount($checkboxes, $count);
  onChangeListener($checkboxes, $count);
}
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__lib_register_jquery_plugin__["a" /* default */])(PLUGIN_NAME, productFilterCount);

/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _undefined = __webpack_require__(332)(); // Support ES3 engines

module.exports = function (val) { return val !== _undefined && val !== null; };


/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
 * jquery.mask.js
 * @version: v1.14.16
 * @author: Igor Escobar
 *
 * Created by Igor Escobar on 2012-03-10. Please report any bug at github.com/igorescobar/jQuery-Mask-Plugin
 *
 * Copyright (c) 2012 Igor Escobar http://igorescobar.com
 *
 * The MIT License (http://www.opensource.org/licenses/mit-license.php)
 *
 * Permission is hereby granted, free of charge, to any person
 * obtaining a copy of this software and associated documentation
 * files (the "Software"), to deal in the Software without
 * restriction, including without limitation the rights to use,
 * copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the
 * Software is furnished to do so, subject to the following
 * conditions:
 *
 * The above copyright notice and this permission notice shall be
 * included in all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
 * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES
 * OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
 * NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT
 * HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY,
 * WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING
 * FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR
 * OTHER DEALINGS IN THE SOFTWARE.
 */

/* jshint laxbreak: true */
/* jshint maxcomplexity:17 */
/* global define */

// UMD (Universal Module Definition) patterns for JavaScript modules that work everywhere.
// https://github.com/umdjs/umd/blob/master/templates/jqueryPlugin.js
(function (factory, jQuery, Zepto) {

    if (true) {
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof exports === 'object' && typeof Meteor === 'undefined') {
        module.exports = factory(require('jquery'));
    } else {
        factory(jQuery || Zepto);
    }

}(function ($) {
    'use strict';

    var Mask = function (el, mask, options) {

        var p = {
            invalid: [],
            getCaret: function () {
                try {
                    var sel,
                        pos = 0,
                        ctrl = el.get(0),
                        dSel = document.selection,
                        cSelStart = ctrl.selectionStart;

                    // IE Support
                    if (dSel && navigator.appVersion.indexOf('MSIE 10') === -1) {
                        sel = dSel.createRange();
                        sel.moveStart('character', -p.val().length);
                        pos = sel.text.length;
                    }
                    // Firefox support
                    else if (cSelStart || cSelStart === '0') {
                        pos = cSelStart;
                    }

                    return pos;
                } catch (e) {}
            },
            setCaret: function(pos) {
                try {
                    if (el.is(':focus')) {
                        var range, ctrl = el.get(0);

                        // Firefox, WebKit, etc..
                        if (ctrl.setSelectionRange) {
                            ctrl.setSelectionRange(pos, pos);
                        } else { // IE
                            range = ctrl.createTextRange();
                            range.collapse(true);
                            range.moveEnd('character', pos);
                            range.moveStart('character', pos);
                            range.select();
                        }
                    }
                } catch (e) {}
            },
            events: function() {
                el
                .on('keydown.mask', function(e) {
                    el.data('mask-keycode', e.keyCode || e.which);
                    el.data('mask-previus-value', el.val());
                    el.data('mask-previus-caret-pos', p.getCaret());
                    p.maskDigitPosMapOld = p.maskDigitPosMap;
                })
                .on($.jMaskGlobals.useInput ? 'input.mask' : 'keyup.mask', p.behaviour)
                .on('paste.mask drop.mask', function() {
                    setTimeout(function() {
                        el.keydown().keyup();
                    }, 100);
                })
                .on('change.mask', function(){
                    el.data('changed', true);
                })
                .on('blur.mask', function(){
                    if (oldValue !== p.val() && !el.data('changed')) {
                        el.trigger('change');
                    }
                    el.data('changed', false);
                })
                // it's very important that this callback remains in this position
                // otherwhise oldValue it's going to work buggy
                .on('blur.mask', function() {
                    oldValue = p.val();
                })
                // select all text on focus
                .on('focus.mask', function (e) {
                    if (options.selectOnFocus === true) {
                        $(e.target).select();
                    }
                })
                // clear the value if it not complete the mask
                .on('focusout.mask', function() {
                    if (options.clearIfNotMatch && !regexMask.test(p.val())) {
                       p.val('');
                   }
                });
            },
            getRegexMask: function() {
                var maskChunks = [], translation, pattern, optional, recursive, oRecursive, r;

                for (var i = 0; i < mask.length; i++) {
                    translation = jMask.translation[mask.charAt(i)];

                    if (translation) {

                        pattern = translation.pattern.toString().replace(/.{1}$|^.{1}/g, '');
                        optional = translation.optional;
                        recursive = translation.recursive;

                        if (recursive) {
                            maskChunks.push(mask.charAt(i));
                            oRecursive = {digit: mask.charAt(i), pattern: pattern};
                        } else {
                            maskChunks.push(!optional && !recursive ? pattern : (pattern + '?'));
                        }

                    } else {
                        maskChunks.push(mask.charAt(i).replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&'));
                    }
                }

                r = maskChunks.join('');

                if (oRecursive) {
                    r = r.replace(new RegExp('(' + oRecursive.digit + '(.*' + oRecursive.digit + ')?)'), '($1)?')
                         .replace(new RegExp(oRecursive.digit, 'g'), oRecursive.pattern);
                }

                return new RegExp(r);
            },
            destroyEvents: function() {
                el.off(['input', 'keydown', 'keyup', 'paste', 'drop', 'blur', 'focusout', ''].join('.mask '));
            },
            val: function(v) {
                var isInput = el.is('input'),
                    method = isInput ? 'val' : 'text',
                    r;

                if (arguments.length > 0) {
                    if (el[method]() !== v) {
                        el[method](v);
                    }
                    r = el;
                } else {
                    r = el[method]();
                }

                return r;
            },
            calculateCaretPosition: function(oldVal) {
                var newVal = p.getMasked(),
                    caretPosNew = p.getCaret();
                if (oldVal !== newVal) {
                    var caretPosOld = el.data('mask-previus-caret-pos') || 0,
                        newValL = newVal.length,
                        oldValL = oldVal.length,
                        maskDigitsBeforeCaret = 0,
                        maskDigitsAfterCaret = 0,
                        maskDigitsBeforeCaretAll = 0,
                        maskDigitsBeforeCaretAllOld = 0,
                        i = 0;

                    for (i = caretPosNew; i < newValL; i++) {
                        if (!p.maskDigitPosMap[i]) {
                            break;
                        }
                        maskDigitsAfterCaret++;
                    }

                    for (i = caretPosNew - 1; i >= 0; i--) {
                        if (!p.maskDigitPosMap[i]) {
                            break;
                        }
                        maskDigitsBeforeCaret++;
                    }

                    for (i = caretPosNew - 1; i >= 0; i--) {
                        if (p.maskDigitPosMap[i]) {
                            maskDigitsBeforeCaretAll++;
                        }
                    }

                    for (i = caretPosOld - 1; i >= 0; i--) {
                        if (p.maskDigitPosMapOld[i]) {
                            maskDigitsBeforeCaretAllOld++;
                        }
                    }

                    // if the cursor is at the end keep it there
                    if (caretPosNew > oldValL) {
                      caretPosNew = newValL * 10;
                    } else if (caretPosOld >= caretPosNew && caretPosOld !== oldValL) {
                        if (!p.maskDigitPosMapOld[caretPosNew])  {
                          var caretPos = caretPosNew;
                          caretPosNew -= maskDigitsBeforeCaretAllOld - maskDigitsBeforeCaretAll;
                          caretPosNew -= maskDigitsBeforeCaret;
                          if (p.maskDigitPosMap[caretPosNew])  {
                            caretPosNew = caretPos;
                          }
                        }
                    }
                    else if (caretPosNew > caretPosOld) {
                        caretPosNew += maskDigitsBeforeCaretAll - maskDigitsBeforeCaretAllOld;
                        caretPosNew += maskDigitsAfterCaret;
                    }
                }
                return caretPosNew;
            },
            behaviour: function(e) {
                e = e || window.event;
                p.invalid = [];

                var keyCode = el.data('mask-keycode');

                if ($.inArray(keyCode, jMask.byPassKeys) === -1) {
                    var newVal = p.getMasked(),
                        caretPos = p.getCaret(),
                        oldVal = el.data('mask-previus-value') || '';

                    // this is a compensation to devices/browsers that don't compensate
                    // caret positioning the right way
                    setTimeout(function() {
                      p.setCaret(p.calculateCaretPosition(oldVal));
                    }, $.jMaskGlobals.keyStrokeCompensation);

                    p.val(newVal);
                    p.setCaret(caretPos);
                    return p.callbacks(e);
                }
            },
            getMasked: function(skipMaskChars, val) {
                var buf = [],
                    value = val === undefined ? p.val() : val + '',
                    m = 0, maskLen = mask.length,
                    v = 0, valLen = value.length,
                    offset = 1, addMethod = 'push',
                    resetPos = -1,
                    maskDigitCount = 0,
                    maskDigitPosArr = [],
                    lastMaskChar,
                    check;

                if (options.reverse) {
                    addMethod = 'unshift';
                    offset = -1;
                    lastMaskChar = 0;
                    m = maskLen - 1;
                    v = valLen - 1;
                    check = function () {
                        return m > -1 && v > -1;
                    };
                } else {
                    lastMaskChar = maskLen - 1;
                    check = function () {
                        return m < maskLen && v < valLen;
                    };
                }

                var lastUntranslatedMaskChar;
                while (check()) {
                    var maskDigit = mask.charAt(m),
                        valDigit = value.charAt(v),
                        translation = jMask.translation[maskDigit];

                    if (translation) {
                        if (valDigit.match(translation.pattern)) {
                            buf[addMethod](valDigit);
                             if (translation.recursive) {
                                if (resetPos === -1) {
                                    resetPos = m;
                                } else if (m === lastMaskChar && m !== resetPos) {
                                    m = resetPos - offset;
                                }

                                if (lastMaskChar === resetPos) {
                                    m -= offset;
                                }
                            }
                            m += offset;
                        } else if (valDigit === lastUntranslatedMaskChar) {
                            // matched the last untranslated (raw) mask character that we encountered
                            // likely an insert offset the mask character from the last entry; fall
                            // through and only increment v
                            maskDigitCount--;
                            lastUntranslatedMaskChar = undefined;
                        } else if (translation.optional) {
                            m += offset;
                            v -= offset;
                        } else if (translation.fallback) {
                            buf[addMethod](translation.fallback);
                            m += offset;
                            v -= offset;
                        } else {
                          p.invalid.push({p: v, v: valDigit, e: translation.pattern});
                        }
                        v += offset;
                    } else {
                        if (!skipMaskChars) {
                            buf[addMethod](maskDigit);
                        }

                        if (valDigit === maskDigit) {
                            maskDigitPosArr.push(v);
                            v += offset;
                        } else {
                            lastUntranslatedMaskChar = maskDigit;
                            maskDigitPosArr.push(v + maskDigitCount);
                            maskDigitCount++;
                        }

                        m += offset;
                    }
                }

                var lastMaskCharDigit = mask.charAt(lastMaskChar);
                if (maskLen === valLen + 1 && !jMask.translation[lastMaskCharDigit]) {
                    buf.push(lastMaskCharDigit);
                }

                var newVal = buf.join('');
                p.mapMaskdigitPositions(newVal, maskDigitPosArr, valLen);
                return newVal;
            },
            mapMaskdigitPositions: function(newVal, maskDigitPosArr, valLen) {
              var maskDiff = options.reverse ? newVal.length - valLen : 0;
              p.maskDigitPosMap = {};
              for (var i = 0; i < maskDigitPosArr.length; i++) {
                p.maskDigitPosMap[maskDigitPosArr[i] + maskDiff] = 1;
              }
            },
            callbacks: function (e) {
                var val = p.val(),
                    changed = val !== oldValue,
                    defaultArgs = [val, e, el, options],
                    callback = function(name, criteria, args) {
                        if (typeof options[name] === 'function' && criteria) {
                            options[name].apply(this, args);
                        }
                    };

                callback('onChange', changed === true, defaultArgs);
                callback('onKeyPress', changed === true, defaultArgs);
                callback('onComplete', val.length === mask.length, defaultArgs);
                callback('onInvalid', p.invalid.length > 0, [val, e, el, p.invalid, options]);
            }
        };

        el = $(el);
        var jMask = this, oldValue = p.val(), regexMask;

        mask = typeof mask === 'function' ? mask(p.val(), undefined, el,  options) : mask;

        // public methods
        jMask.mask = mask;
        jMask.options = options;
        jMask.remove = function() {
            var caret = p.getCaret();
            if (jMask.options.placeholder) {
                el.removeAttr('placeholder');
            }
            if (el.data('mask-maxlength')) {
                el.removeAttr('maxlength');
            }
            p.destroyEvents();
            p.val(jMask.getCleanVal());
            p.setCaret(caret);
            return el;
        };

        // get value without mask
        jMask.getCleanVal = function() {
           return p.getMasked(true);
        };

        // get masked value without the value being in the input or element
        jMask.getMaskedVal = function(val) {
           return p.getMasked(false, val);
        };

       jMask.init = function(onlyMask) {
            onlyMask = onlyMask || false;
            options = options || {};

            jMask.clearIfNotMatch  = $.jMaskGlobals.clearIfNotMatch;
            jMask.byPassKeys       = $.jMaskGlobals.byPassKeys;
            jMask.translation      = $.extend({}, $.jMaskGlobals.translation, options.translation);

            jMask = $.extend(true, {}, jMask, options);

            regexMask = p.getRegexMask();

            if (onlyMask) {
                p.events();
                p.val(p.getMasked());
            } else {
                if (options.placeholder) {
                    el.attr('placeholder' , options.placeholder);
                }

                // this is necessary, otherwise if the user submit the form
                // and then press the "back" button, the autocomplete will erase
                // the data. Works fine on IE9+, FF, Opera, Safari.
                if (el.data('mask')) {
                  el.attr('autocomplete', 'off');
                }

                // detect if is necessary let the user type freely.
                // for is a lot faster than forEach.
                for (var i = 0, maxlength = true; i < mask.length; i++) {
                    var translation = jMask.translation[mask.charAt(i)];
                    if (translation && translation.recursive) {
                        maxlength = false;
                        break;
                    }
                }

                if (maxlength) {
                    el.attr('maxlength', mask.length).data('mask-maxlength', true);
                }

                p.destroyEvents();
                p.events();

                var caret = p.getCaret();
                p.val(p.getMasked());
                p.setCaret(caret);
            }
        };

        jMask.init(!el.is('input'));
    };

    $.maskWatchers = {};
    var HTMLAttributes = function () {
        var input = $(this),
            options = {},
            prefix = 'data-mask-',
            mask = input.attr('data-mask');

        if (input.attr(prefix + 'reverse')) {
            options.reverse = true;
        }

        if (input.attr(prefix + 'clearifnotmatch')) {
            options.clearIfNotMatch = true;
        }

        if (input.attr(prefix + 'selectonfocus') === 'true') {
           options.selectOnFocus = true;
        }

        if (notSameMaskObject(input, mask, options)) {
            return input.data('mask', new Mask(this, mask, options));
        }
    },
    notSameMaskObject = function(field, mask, options) {
        options = options || {};
        var maskObject = $(field).data('mask'),
            stringify = JSON.stringify,
            value = $(field).val() || $(field).text();
        try {
            if (typeof mask === 'function') {
                mask = mask(value);
            }
            return typeof maskObject !== 'object' || stringify(maskObject.options) !== stringify(options) || maskObject.mask !== mask;
        } catch (e) {}
    },
    eventSupported = function(eventName) {
        var el = document.createElement('div'), isSupported;

        eventName = 'on' + eventName;
        isSupported = (eventName in el);

        if ( !isSupported ) {
            el.setAttribute(eventName, 'return;');
            isSupported = typeof el[eventName] === 'function';
        }
        el = null;

        return isSupported;
    };

    $.fn.mask = function(mask, options) {
        options = options || {};
        var selector = this.selector,
            globals = $.jMaskGlobals,
            interval = globals.watchInterval,
            watchInputs = options.watchInputs || globals.watchInputs,
            maskFunction = function() {
                if (notSameMaskObject(this, mask, options)) {
                    return $(this).data('mask', new Mask(this, mask, options));
                }
            };

        $(this).each(maskFunction);

        if (selector && selector !== '' && watchInputs) {
            clearInterval($.maskWatchers[selector]);
            $.maskWatchers[selector] = setInterval(function(){
                $(document).find(selector).each(maskFunction);
            }, interval);
        }
        return this;
    };

    $.fn.masked = function(val) {
        return this.data('mask').getMaskedVal(val);
    };

    $.fn.unmask = function() {
        clearInterval($.maskWatchers[this.selector]);
        delete $.maskWatchers[this.selector];
        return this.each(function() {
            var dataMask = $(this).data('mask');
            if (dataMask) {
                dataMask.remove().removeData('mask');
            }
        });
    };

    $.fn.cleanVal = function() {
        return this.data('mask').getCleanVal();
    };

    $.applyDataMask = function(selector) {
        selector = selector || $.jMaskGlobals.maskElements;
        var $selector = (selector instanceof $) ? selector : $(selector);
        $selector.filter($.jMaskGlobals.dataMaskAttr).each(HTMLAttributes);
    };

    var globals = {
        maskElements: 'input,td,span,div',
        dataMaskAttr: '*[data-mask]',
        dataMask: true,
        watchInterval: 300,
        watchInputs: true,
        keyStrokeCompensation: 10,
        // old versions of chrome dont work great with input event
        useInput: !/Chrome\/[2-4][0-9]|SamsungBrowser/.test(window.navigator.userAgent) && eventSupported('input'),
        watchDataMask: false,
        byPassKeys: [9, 16, 17, 18, 36, 37, 38, 39, 40, 91],
        translation: {
            '0': {pattern: /\d/},
            '9': {pattern: /\d/, optional: true},
            '#': {pattern: /\d/, recursive: true},
            'A': {pattern: /[a-zA-Z0-9]/},
            'S': {pattern: /[a-zA-Z]/}
        }
    };

    $.jMaskGlobals = $.jMaskGlobals || {};
    globals = $.jMaskGlobals = $.extend(true, {}, globals, $.jMaskGlobals);

    // looking for inputs with data-mask attribute
    if (globals.dataMask) {
        $.applyDataMask();
    }

    setInterval(function() {
        if ($.jMaskGlobals.watchDataMask) {
            $.applyDataMask();
        }
    }, globals.watchInterval);
}, window.jQuery, window.Zepto));


/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

var baseCreate = __webpack_require__(45),
    baseLodash = __webpack_require__(78);

/** Used as references for the maximum length and index of an array. */
var MAX_ARRAY_LENGTH = 4294967295;

/**
 * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
 *
 * @private
 * @constructor
 * @param {*} value The value to wrap.
 */
function LazyWrapper(value) {
  this.__wrapped__ = value;
  this.__actions__ = [];
  this.__dir__ = 1;
  this.__filtered__ = false;
  this.__iteratees__ = [];
  this.__takeCount__ = MAX_ARRAY_LENGTH;
  this.__views__ = [];
}

// Ensure `LazyWrapper` is an instance of `baseLodash`.
LazyWrapper.prototype = baseCreate(baseLodash.prototype);
LazyWrapper.prototype.constructor = LazyWrapper;

module.exports = LazyWrapper;


/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(19),
    root = __webpack_require__(4);

/* Built-in method references that are verified to be native. */
var Map = getNative(root, 'Map');

module.exports = Map;


/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

var mapCacheClear = __webpack_require__(438),
    mapCacheDelete = __webpack_require__(439),
    mapCacheGet = __webpack_require__(440),
    mapCacheHas = __webpack_require__(441),
    mapCacheSet = __webpack_require__(442);

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

module.exports = MapCache;


/***/ }),
/* 75 */
/***/ (function(module, exports) {

/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */
function apply(func, thisArg, args) {
  switch (args.length) {
    case 0: return func.call(thisArg);
    case 1: return func.call(thisArg, args[0]);
    case 2: return func.call(thisArg, args[0], args[1]);
    case 3: return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}

module.exports = apply;


/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

var baseAssignValue = __webpack_require__(77),
    eq = __webpack_require__(24);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
      (value === undefined && !(key in object))) {
    baseAssignValue(object, key, value);
  }
}

module.exports = assignValue;


/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

var defineProperty = __webpack_require__(149);

/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function baseAssignValue(object, key, value) {
  if (key == '__proto__' && defineProperty) {
    defineProperty(object, key, {
      'configurable': true,
      'enumerable': true,
      'value': value,
      'writable': true
    });
  } else {
    object[key] = value;
  }
}

module.exports = baseAssignValue;


/***/ }),
/* 78 */
/***/ (function(module, exports) {

/**
 * The function whose prototype chain sequence wrappers inherit from.
 *
 * @private
 */
function baseLodash() {
  // No operation performed.
}

module.exports = baseLodash;


/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

var identity = __webpack_require__(31),
    overRest = __webpack_require__(449),
    setToString = __webpack_require__(164);

/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */
function baseRest(func, start) {
  return setToString(overRest(func, start, identity), func + '');
}

module.exports = baseRest;


/***/ }),
/* 80 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

module.exports = baseUnary;


/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

var Uint8Array = __webpack_require__(126);

/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */
function cloneArrayBuffer(arrayBuffer) {
  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
  new Uint8Array(result).set(new Uint8Array(arrayBuffer));
  return result;
}

module.exports = cloneArrayBuffer;


/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

var baseRest = __webpack_require__(79),
    isIterateeCall = __webpack_require__(86);

/**
 * Creates a function like `_.assign`.
 *
 * @private
 * @param {Function} assigner The function to assign values.
 * @returns {Function} Returns the new assigner function.
 */
function createAssigner(assigner) {
  return baseRest(function(object, sources) {
    var index = -1,
        length = sources.length,
        customizer = length > 1 ? sources[length - 1] : undefined,
        guard = length > 2 ? sources[2] : undefined;

    customizer = (assigner.length > 3 && typeof customizer == 'function')
      ? (length--, customizer)
      : undefined;

    if (guard && isIterateeCall(sources[0], sources[1], guard)) {
      customizer = length < 3 ? undefined : customizer;
      length = 1;
    }
    object = Object(object);
    while (++index < length) {
      var source = sources[index];
      if (source) {
        assigner(object, source, index, customizer);
      }
    }
    return object;
  });
}

module.exports = createAssigner;


/***/ }),
/* 83 */
/***/ (function(module, exports) {

/**
 * Gets the argument placeholder value for `func`.
 *
 * @private
 * @param {Function} func The function to inspect.
 * @returns {*} Returns the placeholder value.
 */
function getHolder(func) {
  var object = func;
  return object.placeholder;
}

module.exports = getHolder;


/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

var overArg = __webpack_require__(161);

/** Built-in value references. */
var getPrototype = overArg(Object.getPrototypeOf, Object);

module.exports = getPrototype;


/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

var arrayFilter = __webpack_require__(358),
    stubArray = __webpack_require__(170);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
  if (object == null) {
    return [];
  }
  object = Object(object);
  return arrayFilter(nativeGetSymbols(object), function(symbol) {
    return propertyIsEnumerable.call(object, symbol);
  });
};

module.exports = getSymbols;


/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

var eq = __webpack_require__(24),
    isArrayLike = __webpack_require__(25),
    isIndex = __webpack_require__(50),
    isObject = __webpack_require__(7);

/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */
function isIterateeCall(value, index, object) {
  if (!isObject(object)) {
    return false;
  }
  var type = typeof index;
  if (type == 'number'
        ? (isArrayLike(object) && isIndex(index, object.length))
        : (type == 'string' && index in object)
      ) {
    return eq(object[index], value);
  }
  return false;
}

module.exports = isIterateeCall;


/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

var isArray = __webpack_require__(9),
    isSymbol = __webpack_require__(57);

/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/;

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey(value, object) {
  if (isArray(value)) {
    return false;
  }
  var type = typeof value;
  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
      value == null || isSymbol(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
    (object != null && value in Object(object));
}

module.exports = isKey;


/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var freeGlobal = __webpack_require__(151);

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && freeGlobal.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    // Use `util.types` for Node.js 10+.
    var types = freeModule && freeModule.require && freeModule.require('util').types;

    if (types) {
      return types;
    }

    // Legacy `process.binding('util')` for Node.js < 10.
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}());

module.exports = nodeUtil;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(101)(module)))

/***/ }),
/* 89 */
/***/ (function(module, exports) {

/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */
function setToArray(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = value;
  });
  return result;
}

module.exports = setToArray;


/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

var createFind = __webpack_require__(408),
    findIndex = __webpack_require__(168);

/**
 * Iterates over elements of `collection`, returning the first element
 * `predicate` returns truthy for. The predicate is invoked with three
 * arguments: (value, index|key, collection).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=0] The index to search from.
 * @returns {*} Returns the matched element, else `undefined`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'age': 36, 'active': true },
 *   { 'user': 'fred',    'age': 40, 'active': false },
 *   { 'user': 'pebbles', 'age': 1,  'active': true }
 * ];
 *
 * _.find(users, function(o) { return o.age < 40; });
 * // => object for 'barney'
 *
 * // The `_.matches` iteratee shorthand.
 * _.find(users, { 'age': 1, 'active': true });
 * // => object for 'pebbles'
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.find(users, ['active', false]);
 * // => object for 'fred'
 *
 * // The `_.property` iteratee shorthand.
 * _.find(users, 'active');
 * // => object for 'barney'
 */
var find = createFind(findIndex);

module.exports = find;


/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsArguments = __webpack_require__(372),
    isObjectLike = __webpack_require__(10);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
    !propertyIsEnumerable.call(value, 'callee');
};

module.exports = isArguments;


/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(16),
    isObject = __webpack_require__(7);

/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!isObject(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

module.exports = isFunction;


/***/ }),
/* 93 */
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

module.exports = isLength;


/***/ }),
/* 94 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is `null` or `undefined`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
 * @example
 *
 * _.isNil(null);
 * // => true
 *
 * _.isNil(void 0);
 * // => true
 *
 * _.isNil(NaN);
 * // => false
 */
function isNil(value) {
  return value == null;
}

module.exports = isNil;


/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsTypedArray = __webpack_require__(379),
    baseUnary = __webpack_require__(80),
    nodeUtil = __webpack_require__(88);

/* Node.js helper references. */
var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

module.exports = isTypedArray;


/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

var createCompounder = __webpack_require__(146);

/**
 * Converts `string` to
 * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the kebab cased string.
 * @example
 *
 * _.kebabCase('Foo Bar');
 * // => 'foo-bar'
 *
 * _.kebabCase('fooBar');
 * // => 'foo-bar'
 *
 * _.kebabCase('__FOO_BAR__');
 * // => 'foo-bar'
 */
var kebabCase = createCompounder(function(result, word, index) {
  return result + (index ? '-' : '') + word.toLowerCase();
});

module.exports = kebabCase;


/***/ }),
/* 97 */
/***/ (function(module, exports) {

/**
 * This method returns `undefined`.
 *
 * @static
 * @memberOf _
 * @since 2.3.0
 * @category Util
 * @example
 *
 * _.times(2, _.noop);
 * // => [undefined, undefined]
 */
function noop() {
  // No operation performed.
}

module.exports = noop;


/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

var toFinite = __webpack_require__(171);

/**
 * Converts `value` to an integer.
 *
 * **Note:** This method is loosely based on
 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted integer.
 * @example
 *
 * _.toInteger(3.2);
 * // => 3
 *
 * _.toInteger(Number.MIN_VALUE);
 * // => 0
 *
 * _.toInteger(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toInteger('3.2');
 * // => 3
 */
function toInteger(value) {
  var result = toFinite(value),
      remainder = result % 1;

  return result === result ? (remainder ? result - remainder : result) : 0;
}

module.exports = toInteger;


/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
  * $script.js JS loader & dependency manager
  * https://github.com/ded/script.js
  * (c) Dustin Diaz 2014 | License MIT
  */

(function (name, definition) {
  if (typeof module != 'undefined' && module.exports) module.exports = definition()
  else if (true) !(__WEBPACK_AMD_DEFINE_FACTORY__ = (definition),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
  else this[name] = definition()
})('$script', function () {
  var doc = document
    , head = doc.getElementsByTagName('head')[0]
    , s = 'string'
    , f = false
    , push = 'push'
    , readyState = 'readyState'
    , onreadystatechange = 'onreadystatechange'
    , list = {}
    , ids = {}
    , delay = {}
    , scripts = {}
    , scriptpath
    , urlArgs

  function every(ar, fn) {
    for (var i = 0, j = ar.length; i < j; ++i) if (!fn(ar[i])) return f
    return 1
  }
  function each(ar, fn) {
    every(ar, function (el) {
      fn(el)
      return 1
    })
  }

  function $script(paths, idOrDone, optDone) {
    paths = paths[push] ? paths : [paths]
    var idOrDoneIsDone = idOrDone && idOrDone.call
      , done = idOrDoneIsDone ? idOrDone : optDone
      , id = idOrDoneIsDone ? paths.join('') : idOrDone
      , queue = paths.length
    function loopFn(item) {
      return item.call ? item() : list[item]
    }
    function callback() {
      if (!--queue) {
        list[id] = 1
        done && done()
        for (var dset in delay) {
          every(dset.split('|'), loopFn) && !each(delay[dset], loopFn) && (delay[dset] = [])
        }
      }
    }
    setTimeout(function () {
      each(paths, function loading(path, force) {
        if (path === null) return callback()
        
        if (!force && !/^https?:\/\//.test(path) && scriptpath) {
          path = (path.indexOf('.js') === -1) ? scriptpath + path + '.js' : scriptpath + path;
        }
        
        if (scripts[path]) {
          if (id) ids[id] = 1
          return (scripts[path] == 2) ? callback() : setTimeout(function () { loading(path, true) }, 0)
        }

        scripts[path] = 1
        if (id) ids[id] = 1
        create(path, callback)
      })
    }, 0)
    return $script
  }

  function create(path, fn) {
    var el = doc.createElement('script'), loaded
    el.onload = el.onerror = el[onreadystatechange] = function () {
      if ((el[readyState] && !(/^c|loade/.test(el[readyState]))) || loaded) return;
      el.onload = el[onreadystatechange] = null
      loaded = 1
      scripts[path] = 2
      fn()
    }
    el.async = 1
    el.src = urlArgs ? path + (path.indexOf('?') === -1 ? '?' : '&') + urlArgs : path;
    head.insertBefore(el, head.lastChild)
  }

  $script.get = create

  $script.order = function (scripts, id, done) {
    (function callback(s) {
      s = scripts.shift()
      !scripts.length ? $script(s, id, done) : $script(s, callback)
    }())
  }

  $script.path = function (p) {
    scriptpath = p
  }
  $script.urlArgs = function (str) {
    urlArgs = str;
  }
  $script.ready = function (deps, ready, req) {
    deps = deps[push] ? deps : [deps]
    var missing = [];
    !each(deps, function (dep) {
      list[dep] || missing[push](dep);
    }) && every(deps, function (dep) {return list[dep]}) ?
      ready() : !function (key) {
      delay[key] = delay[key] || []
      delay[key][push](ready)
      req && req(missing)
    }(deps.join('|'))
    return $script
  }

  $script.done = function (idOrDone) {
    $script([null], idOrDone)
  }

  return $script
});


/***/ }),
/* 100 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 101 */
/***/ (function(module, exports) {

module.exports = function(module) {
	if(!module.webpackPolyfill) {
		module.deprecate = function() {};
		module.paths = [];
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 102 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export PLUGIN_NAME */
/* unused harmony export SS_TRIGGER_CLASS */
/* unused harmony export DEFAULTS */
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styleguide_lib_register_jquery_plugin__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_styleguide_lib_merge_options__ = __webpack_require__(2);
/**
 * Handles the plp lazy loading and back button functionality
 * Lazy loads the images once window loads.
 * Fixes the correct page position if going back to plp.
 * @module sizeSelection
 */




var PLUGIN_NAME = 'sizeSelection';
var SS_TRIGGER_CLASS = '.js-select-size-trigger';
var DEFAULTS = {
  sessionName: '',
  loadAfterCallback: function loadAfterCallback() {}
};
var showConfirmation = function showConfirmation(opts, hasError) {
  var saveSizeConfirmPath = opts.saveSizeConfirmPath;
  __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.modal({
    url: "".concat(saveSizeConfirmPath).concat(hasError),
    triggerOpen: true,
    type: 'notification'
  });
};
var updateSizeToDb = function updateSizeToDb($el, opts, sizeValue) {
  if (sizeValue) {
    var updateSizePath = opts.updateSizePath,
      code = opts.code;
    __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.ajax({
      url: "".concat(updateSizePath).concat(sizeValue),
      type: "POST",
      success: function success(ret) {
        if (ret.success) {
          var $preorderCta = __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#preorder-cta-".concat(code));
          var $addToBagCta = __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#add-to-bag-cta-".concat(code));
          var $addToBagBtn = __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#add-to-bag-".concat(code));
          var $outOfStockBtn = __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#outOfStock_".concat(code));
          if ($outOfStockBtn.length) {
            $addToBagBtn.show();
            $outOfStockBtn.remove();
          }
          if (ret.isPreorder) {
            $preorderCta.show();
            $addToBagCta.hide();
          } else {
            $preorderCta.hide();
            $addToBagCta.show();
          }
          showConfirmation(opts, false);
          if (typeof logEngagementWithDetails === "function") {
            logEngagementWithDetails(window.location.href, 'favorites save your size', 'SaveSize', "size=".concat(sizeValue, ", code=").concat(code));
          }
        }
      }
    });
  } else {
    showConfirmation(opts, true);
  }
};
var setUpdateSizeListener = function setUpdateSizeListener($el, $saveSizeTrigger, opts) {
  var $form = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.modal--toast-sizes').last().find('.js-fav-size-form');
  if (!$form.length) return;
  var $radios = $form.find('input[name="fav-size-selection"]');
  var $buttons = $form.find('.js-size-submit');
  var hideAllButtons = function hideAllButtons() {
    $buttons.hide().attr({
      'aria-hidden': 'true',
      tabindex: '-1'
    });
  };
  var showButtonFor = function showButtonFor(id) {
    $form.find("label[for=\"".concat(id, "\"]")).next('.js-size-submit').show().attr({
      'aria-hidden': 'false',
      tabindex: '0'
    });
  };
  $radios.on('change', function () {
    hideAllButtons();
    showButtonFor(this.id);
  });
  $form.on('submit', function (evt) {
    evt.preventDefault();
    var $checked = $radios.filter(':checked').first();
    if (!$checked.length) {
      $radios.not(':disabled').first().trigger('focus');
      return;
    }
    var sizeSelected = $checked.val();
    var isOneLeft = $checked.data('isOneLeft');
    var code = opts.code,
      addToBag = opts.addToBag,
      updateSizePath = opts.updateSizePath,
      hideCopy = opts.hideCopy;
    var hideClass = hideCopy ? 'class="u-hide"' : '';
    $saveSizeTrigger.html("<span id=\"".concat(code, "-fav-size-value\" data-size=\"").concat(sizeSelected, "\" ").concat(hideClass, ">Size: ").concat(sizeSelected, "</span>"));
    var $soldOut = $el.find('.js-saved-size-sold-out');
    var $oneLeft = $el.find('.js-saved-size-one-left');
    if ($soldOut.length) {
      $soldOut.hide();
    }
    if (isOneLeft !== undefined && $oneLeft.length) {
      if (isOneLeft) {
        $oneLeft.show();
      } else {
        $oneLeft.hide();
      }
    }
    if (updateSizePath) {
      updateSizeToDb($el, opts, sizeSelected);
    }
    if (addToBag === 'true' || addToBag === true) {
      var $addToBag = __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#add-to-bag-".concat(code));
      if ($addToBag.length) {
        $addToBag.data('size', sizeSelected);
        $addToBag.click();
      }
    }
  });
};
var getSizes = function getSizes($el, $saveSizeTrigger, opts) {
  opts.addToBag = $el.data('addToBag');
  var sizePath = window.rcProps.sizeMarkupUri + '?code=' + $el.data('code');
  $el.data('addToBag', 'false');
  __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.modal({
    url: sizePath,
    triggerOpen: true,
    type: "toast",
    addModifierClass: 'modal--toast-sizes',
    overlayClose: false,
    returnFocus: $el.find('.js-select-size-trigger'),
    onComplete: function onComplete() {
      setUpdateSizeListener($el, $saveSizeTrigger, opts);
      if (typeof window.bindSizeGuideEvent() === 'function') {
        window.bindSizeGuideEvent();
      }
    }
  });
  if (typeof window.showBisOrSo !== "function") {
    window.showBisOrSo = function (code) {
      __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.modal({
        url: window.rcProps.backInStockSpecialOrderHref + "&code=" + code,
        type: "full",
        open: null,
        cache: false,
        overlayClose: true,
        triggerOpen: true,
        returnFocus: $el.find('.js-select-size-trigger'),
        onComplete: function onComplete() {
          __WEBPACK_IMPORTED_MODULE_0_jquery___default()(".js-tabs").tabs();
          setupBisAndSo();
        }
      });
    };
  }
};

/**
 * Applies any sort of event handlers for the switchClass.
 * @param  {jQuery} $el - link
 * @param  {Object} [options={}] - Any options provided upon initialization
 */
var setEventListeners = function setEventListeners($el, $saveSizeTrigger, opts) {
  $saveSizeTrigger.on('click', function (evt) {
    evt.preventDefault();
    getSizes($el, $saveSizeTrigger, opts);
  });
};

/**
 * Initializes sizeSelection.
 * @param {jQuery} el - targeting the element of the plp list
 * @param {Object} options - Options used for wiring up the sizeSelection
 * @see DEFAULTS
 */
function sizeSelection(el) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var $el = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(el);
  var opts = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_styleguide_lib_merge_options__["a" /* default */])(DEFAULTS, options, $el);
  var $saveSizeTrigger = $el.find(SS_TRIGGER_CLASS);
  setEventListeners($el, $saveSizeTrigger, opts);
}
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_styleguide_lib_register_jquery_plugin__["a" /* default */])(PLUGIN_NAME, sizeSelection);

/***/ }),
/* 103 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["preloadColorMarkup"] = preloadColorMarkup;
/* harmony export (immutable) */ __webpack_exports__["loadColorMarkup"] = loadColorMarkup;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }

var AJAX_MARKUP_BASE_PATH = '/content/product/getMarkup/mobile';
function preloadColorMarkup($colorOptions) {
  window.rcProps = window.rcProps || {};
  window.rcProps.colorSwatchMarkup = window.rcProps.colorSwatchMarkup || {};
  var promise = Promise.resolve();
  var codes = $colorOptions.toArray().map(function (el) {
    var $el = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(el);
    var useAjax = $el.data('useAjax');
    return (typeof useAjax === 'undefined' || useAjax) && !$el.is(':selected') ? $el.data("code") : '';
  }).filter(function (code) {
    return !!code;
  });
  if (codes === undefined || codes.length === 0) {
    return;
  }
  loadColorMarkup(codes);
}
function loadColorMarkup(codes) {
  var codePromise = new Promise(function (resolve) {
    __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.post(AJAX_MARKUP_BASE_PATH, __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.param({
      codes: codes,
      d: window.rcProps.pdp.department
    }), function (result) {
      for (var code in result) {
        window.rcProps.colorSwatchMarkup[code] = result[code];
      }
    }).always(function () {
      resolve();
    });
  });
  var _iterator = _createForOfIteratorHelper(codes),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var code = _step.value;
      window.rcProps.colorSwatchMarkup[code] = codePromise;
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  return codePromise;
}

/***/ }),
/* 104 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);

function scrollToTop() {
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('body,html').animate({
    scrollTop: 0
  }, 'fast');
}
/* harmony default export */ __webpack_exports__["a"] = (function () {
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#js-revolve-me-carousel').on('click', 'button', function (e) {
    e.preventDefault();
    var id = e.currentTarget.getAttribute('data-revolveme-id');
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-revolve-me-popup-content').load('/r/mobile/SocialEntry.jsp?id=' + id + '&showImg=true&from=hp', function () {
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()(".js-page-content").hide();
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()(".js-revolve-me-popup").show();
      // $('#caption_'+id).dotdotdot();
      scrollToTop();
    });
  });
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.close-revolveme-popup').on('click', function (e) {
    e.preventDefault();
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()(".js-revolve-me-popup").hide();
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()(".js-page-content").show();
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()("window").resize();
  });
});
;

/***/ }),
/* 105 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);

/* harmony default export */ __webpack_exports__["a"] = (function (id, speed) {
  speed = speed || 'fast';
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()(document.getElementById(id)).slideToggle(speed);
});
;

/***/ }),
/* 106 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export LOGOUT_URL */
/* unused harmony export METHOD */
/* harmony export (immutable) */ __webpack_exports__["a"] = logout;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_defaults__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_defaults___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_defaults__);


var LOGOUT_URL = '/r/ajax/SignOut.jsp?mobile=true';
var METHOD = 'POST';
function logout(options) {
  try {
    if (typeof crdl != 'undefined' && crdl != null) {
      crdl('forget');
    }
  } catch (e) {
    console.log(e);
  }
  options = options || {};
  __WEBPACK_IMPORTED_MODULE_1_lodash_defaults___default()(options, {
    reloadFunc: function reloadFunc() {
      window.location.reload();
    }
  });
  return __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.ajax({
    type: METHOD,
    url: LOGOUT_URL
  }).then(function (data) {
    var obj = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.parseJSON(data);
    if (obj.success) {
      sessionStorage.removeItem('womens-data'); //clear nav cache
      sessionStorage.removeItem('mens-data');
      options.reloadFunc();
    }
  });
}

/***/ }),
/* 107 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export LOAD */
/* unused harmony export BLUR */
/* unused harmony export FOCUS */
/* unused harmony export INVALID */
/* unused harmony export INPUT */
/* unused harmony export CHANGE */
/* unused harmony export VALID */
/* unused harmony export CONTAINER */
/* unused harmony export INVALID_SCROLL_POSITION */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_es6_symbol__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_es6_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_es6_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_get__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_isNumber__ = __webpack_require__(478);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_isNumber___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_isNumber__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__form_field_behaviors__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__validator__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__lib_random__ = __webpack_require__(64);
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
/**
 * Responsible for rendering an error within a form field behavior.
 * @module elements/fields/floatingError
 */







var LOAD = __WEBPACK_IMPORTED_MODULE_4__form_field_behaviors__["c" /* EVENTS */].LOAD,
  BLUR = __WEBPACK_IMPORTED_MODULE_4__form_field_behaviors__["c" /* EVENTS */].BLUR,
  FOCUS = __WEBPACK_IMPORTED_MODULE_4__form_field_behaviors__["c" /* EVENTS */].FOCUS,
  INVALID = __WEBPACK_IMPORTED_MODULE_4__form_field_behaviors__["c" /* EVENTS */].INVALID,
  INPUT = __WEBPACK_IMPORTED_MODULE_4__form_field_behaviors__["c" /* EVENTS */].INPUT,
  CHANGE = __WEBPACK_IMPORTED_MODULE_4__form_field_behaviors__["c" /* EVENTS */].CHANGE,
  VALID = __WEBPACK_IMPORTED_MODULE_4__form_field_behaviors__["c" /* EVENTS */].VALID;

var CONTAINER = __WEBPACK_IMPORTED_MODULE_4__form_field_behaviors__["b" /* TYPES */].CONTAINER,
  FIELD = __WEBPACK_IMPORTED_MODULE_4__form_field_behaviors__["b" /* TYPES */].FIELD;

var INVALID_SCROLL_POSITION = __WEBPACK_IMPORTED_MODULE_5__validator__["a" /* EVENTS */].INVALID_SCROLL_POSITION;

var FLOATING_ERROR_OPTIONS = {
  floatingErrorContainerClassName: 'floating-label--floating-error',
  floatingErrorElement: 'p',
  floatingErrorClassName: 'floating-error'
};
var KEY = __WEBPACK_IMPORTED_MODULE_1_es6_symbol___default()('error-el');
/**
 * Creates an error element to later on be appended to the DOM.
 * @private
 * @param {string} errorElement - Name of error element to create the element
 * @param {string} className - Optional class name applied when error is present
 * @param {string} message - Message used when an error has occurred
 * @returns {Element} An element containing the floating error
 */
var createErrorEl = function createErrorEl(errorElement, id, className, message) {
  var el = document.createElement(errorElement);
  if (className) {
    el.classList.add(className);
  }
  el.id = id;
  el.textContent = " ".concat(message);
  el.prepend(__WEBPACK_IMPORTED_MODULE_0_jquery___default()("\n    <span class=\"icon icon--xs icon--exclamation-point\">\n        <svg viewBox=\"0 0 16 16\" aria-hidden=\"true\" focusable=\"false\">\n          <path d=\"M8 0C3.6 0 0 3.6 0 8s3.6 8 8 8 8-3.6 8-8-3.6-8-8-8zm0 15.2A7.17 7.17 0 0 1 .8 8 7.17 7.17 0 0 1 8 .8 7.17 7.17 0 0 1 15.2 8 7.17 7.17 0 0 1 8 15.2zm0-5.6c.4 0 .6-.3.6-.7l.3-4.3c0-.4-.4-.7-.8-.7s-1 .2-1 .7l.3 4.3c0 .4.2.7.6.7z\"/><circle cx=\"8\" cy=\"11.3\" r=\".9\"/>\n        </svg>\n    </span>\n  ")[0]);
  return el;
};
/**
 * Renders an error element into the DOM.
 * @private
 * @param {HTMLElement} container - The container with the label/form field
 * @param {string} errorElement - Name of error element to create the element
 * @param {string} className - Optional class name applied when error is present
 * @param {string} message - Message used when an error has occurred
 * @returns {HTMLElement} - The error element
 */
var renderErrorEl = function renderErrorEl(container, errorElement, id, className, message) {
  var errorEl = createErrorEl(errorElement, id, className, message);
  container.appendChild(errorEl);
  return errorEl;
};
/**
 * Responsible for removing an error element if it exists.
 * @private
 * @param {HTMLElement} container - The container with the label/form field
 * @param {HTMLElement} errorElement - Element containing the error
 * @param {Map} state - Contains state info around error
 * @param {string} className - className interacting with container
 */
var removeErrorEl = function removeErrorEl(container, errorElement, state, className) {
  if (errorElement) {
    container.classList.remove(className);
    if (errorElement.parentNode) {
      errorElement.parentNode.removeChild(errorElement);
      state["delete"](KEY);
    }
  }
};
/**
 * Sets up a listener for when an invalid formField has been found so it can
 * set the position of where to scroll to in the DOM.
 * @private
 * @param {HTMLElement} formField - The form field element
 */
var listenForInvalid = function listenForInvalid(formField) {
  formField.addEventListener(INVALID_SCROLL_POSITION, function (_ref) {
    var delegateScroll = _ref.detail.delegateScroll;
    delegateScroll(function (highestEl) {
      highestEl.scrollIntoView({
        block: 'center'
      });
    });
  });
};
/**
 * Responsibility for resolving a field id for the purpose of uniquely
 * identifying an aria-describedby.
 * @param {HTMLElement} el - Form element receiving error
 * @returns {string} The id assigned to the field if one doesn't exist
 */
var resolveFieldId = function resolveFieldId(el) {
  var ariaIdAttr = 'aria-describedby';
  var existingId = el.getAttribute(ariaIdAttr);
  if (existingId) {
    return existingId;
  }
  var elements = __WEBPACK_IMPORTED_MODULE_2_lodash_get___default()(el, 'form.elements', []);
  var index = Array.from(elements).findIndex(function (formEl) {
    return formEl === el;
  });
  var suffix = __WEBPACK_IMPORTED_MODULE_3_lodash_isNumber___default()(index) ? index : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib_random__["a" /* default */])();
  var id = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib_random__["a" /* default */])({
    prefix: "err-".concat(suffix)
  });
  el.setAttribute(ariaIdAttr, id);
  return id;
};
/**
 * Responds to any errors that occur on a form field by rendering a
 * "floating error" or an error that accompanies the field in question.
 * @private
 * @param {string} type - Type of event
 * @param {HTMLElement} target - Element receiving the event
 * @param {HTMLElement} container - The container with the label/form field
 * @param {Map} state - Acts as a state container
 * @param {boolean} validateOnlyOnSubmit - Instructs to only validate on submit
 * @param {string} containerClassName - Class name appended to the container if
 * an error occurs
 * @param {string} errorElement - Name of error element to create the element
 * @param {string} className - Optional class name applied when error is present
 * @param {string} message - Message used when an error has occurred
 */
var respond = function respond(type, target, container, state, validateOnlyOnSubmit, _ref2) {
  var containerClassName = _ref2.floatingErrorContainerClassName,
    errorElement = _ref2.floatingErrorElement,
    className = _ref2.floatingErrorClassName,
    _ref2$floatingErrorMe = _ref2.floatingErrorMessage,
    message = _ref2$floatingErrorMe === void 0 ? '' : _ref2$floatingErrorMe;
  var errorEl = state.get(KEY);
  var errorMessage = message || target.validationMessage;
  var fieldId;
  switch (type) {
    case INPUT:
      // The error message should stick around when the user focuses on the
      // element. However, when the user interacts with the element, we want to
      // remove the error, if it exists. Therefore the error message will be
      // announced to the user upon focusing without the need of having to
      // accounce every time the element has been interacted with if it's
      // considered invalid.
      if (state.get(KEY)) {
        removeErrorEl(container, errorEl, state, containerClassName);
      }
      break;
    case LOAD:
    case BLUR:
    case CHANGE:
      if (!validateOnlyOnSubmit) {
        // Assume there is no error for a clean slate
        removeErrorEl(container, errorEl, state, containerClassName);
        // This may feel redundant since there's a chance the form element
        // may already have an error. However, in the case where the blur
        // event only occurs or where the floating error is the only listener,
        // then this is necessary. Otherwise, it is redundant, but it doesn't
        // hurt anything or have any performance issues to reset the validity.
        if (container.querySelector(':invalid') === target) {
          target.setCustomValidity(errorMessage);
        }
        target.checkValidity();
      }
      break;
    case VALID:
      removeErrorEl(container, errorEl, state, containerClassName);
      break;
    case INVALID:
      removeErrorEl(container, errorEl, state, containerClassName);
      // Supercedes the applied validity for one that may be more relevant
      // to the field.
      target.setCustomValidity(errorMessage);
      container.classList.add(containerClassName);
      fieldId = resolveFieldId(target);
      state.set(KEY, renderErrorEl(container, errorElement, fieldId, className, errorMessage));
      break;
    default:
      break;
  }
};
/**
 * Responsible for rendering an error message when an error occurs on a form
 * field. To avoid any weirdness with CSS positioning, the error message is
 * rendered to the screen around the field or floats hence a floating error.
 *
 * In order to activate this functionality, the container must contain the
 * following data attribute:
 *
 * - data-floating-error-message
 *
 * Other options include:
 *
 * - `data-floating-error-element`: The name of the element used for the floating
 *   error. Defaults to a `p` (for paragraph).
 * - `data-floating-error-class-name`: An additional className added to the
 *   floating error message element. Defaults to `''`.
 * - `data-floating-container-class-name`: A className applied to the container
 *   container when the floating error is shown. Defaults to `floating-label--floating-error`.
 *
 * @example
 * <div class="floating-label" data-floating-error-message="Hey dummy!">
 *  <label for="dude" class="floating-label__label">Something</label>
 *  <input
 *    required
 *    id="dude"
 *    type="text"
 *    class="floating-label__input"
 *    placeholder="Enter something">
 * </div>
 * @see FLOATING_ERROR_OPTIONS
 * @param {Object} options - Configurable options
 * @returns {Function} Used to setup and respond to events from the form field
 * behavior
 */
var floatingError = function floatingError() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return function () {
    for (var _len = arguments.length, nodes = new Array(_len), _key = 0; _key < _len; _key++) {
      nodes[_key] = arguments[_key];
    }
    var _nodes$filter = nodes.filter(function (_ref3) {
        var type = _ref3.type;
        return type === CONTAINER;
      }),
      _nodes$filter2 = _slicedToArray(_nodes$filter, 1),
      container = _nodes$filter2[0].node;
    var _nodes$filter3 = nodes.filter(function (_ref4) {
        var type = _ref4.type;
        return type === FIELD;
      }),
      _nodes$filter4 = _slicedToArray(_nodes$filter3, 1),
      formField = _nodes$filter4[0].node;
    var opts = Object.assign({}, FLOATING_ERROR_OPTIONS, options, __WEBPACK_IMPORTED_MODULE_0_jquery___default()(container).data());
    var state = new Map();
    if (container.dataset.disableFloatingError) {
      return function () {};
    }
    listenForInvalid(formField, state);
    return function (type, _ref5, _ref6) {
      var target = _ref5.target;
      var validateOnlyOnSubmit = _ref6.validateOnlyOnSubmit;
      return respond(type, target, container, state, validateOnlyOnSubmit, opts);
    };
  };
};
/* harmony default export */ __webpack_exports__["a"] = (floatingError);

/***/ }),
/* 108 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export iconList */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__form_field_behaviors__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__iconify_setup__ = __webpack_require__(109);
/* unused harmony reexport TYPES */
/* unused harmony reexport EVENTS */
/* unused harmony reexport VISIBLE_CLASS_NAME */
/* unused harmony reexport ICON_CLASS_NAME */
/**
 * Responsible for covering icon related behavior within a form field behavior.
 * @module elements/fields/iconifyBehaviors
 */




var CLEARED_TYPES = ['text', 'email'];

/**
 * Defines available icons for iconify behaviors.
 * @type {Object}
 */
var iconList = [{
  name: 'invalid',
  iconId: 'exclamation-point',
  svg: function svg(text) {
    return "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\"><title>".concat(text, "</title><path d=\"M8 2a6.02 6.02 0 0 0-6 6 6.02 6.02 0 0 0 6 6 6.02 6.02 0 0 0 6-6 6.02 6.02 0 0 0-6-6zm2.8 7.7c.3.3.3.8 0 1.1s-.8.3-1.1 0L8 9.1l-1.7 1.7c-.3.3-.8.3-1.1 0-.2-.3-.2-.8 0-1.1L7 8 5.2 6.3C5 6 5 5.5 5.2 5.2c.3-.3.8-.3 1.1 0L8 6.9l1.7-1.7c.3-.3.8-.3 1.1 0s.3.8 0 1.1L9.1 8l1.7 1.7z\"/></svg>");
  }
}, {
  name: 'valid',
  iconId: 'check-mark',
  svg: function svg(text) {
    return "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\"><title>".concat(text, "</title><path d=\"M8 2a6.02 6.02 0 0 0-6 6 6.02 6.02 0 0 0 6 6 6.02 6.02 0 0 0 6-6 6.02 6.02 0 0 0-6-6zm2.8 7.7c.3.3.3.8 0 1.1s-.8.3-1.1 0L8 9.1l-1.7 1.7c-.3.3-.8.3-1.1 0-.2-.3-.2-.8 0-1.1L7 8 5.2 6.3C5 6 5 5.5 5.2 5.2c.3-.3.8-.3 1.1 0L8 6.9l1.7-1.7c.3-.3.8-.3 1.1 0s.3.8 0 1.1L9.1 8l1.7 1.7z\"/></svg>");
  }
}, {
  name: 'clear',
  iconId: 'clear',
  svg: function svg(text) {
    return "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\"><title>".concat(text, "</title><path d=\"M8 2a6.02 6.02 0 0 0-6 6 6.02 6.02 0 0 0 6 6 6.02 6.02 0 0 0 6-6 6.02 6.02 0 0 0-6-6zm2.8 7.7c.3.3.3.8 0 1.1s-.8.3-1.1 0L8 9.1l-1.7 1.7c-.3.3-.8.3-1.1 0-.2-.3-.2-.8 0-1.1L7 8 5.2 6.3C5 6 5 5.5 5.2 5.2c.3-.3.8-.3 1.1 0L8 6.9l1.7-1.7c.3-.3.8-.3 1.1 0s.3.8 0 1.1L9.1 8l1.7 1.7z\"/></svg>");
  },
  rule: function rule(_ref) {
    var type = _ref.formField.type;
    return CLEARED_TYPES.indexOf(type) > -1;
  }
}];

/**
 * Responsible for clearing out the value of a form field.
 * @private
 * @param {HTMLFormElement} formField - The form element in the container
 */
var clearValue = function clearValue(formField) {
  /* eslint-disable no-param-reassign */
  // This is here to remove the placeholder which is visible
  // between the blur and focus event.
  var placeholder = formField.placeholder;
  formField.placeholder = '';
  formField.focus();
  formField.value = '';
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()(formField).trigger('input');
  formField.focus();
  formField.placeholder = placeholder;
  /* eslint-enable no-param-reassign */
};

/**
 * Responsible for exposing methods used for clearing a form field based on
 * when events are fired off. For example, `attach` would be fired off during
 * focus, where `detach` would be fired off during blur. The tricky bit here
 * is using an event that won't trigger the blur event, hence why mousedown or
 * the preferred touchend event to ensure this event happens without disrupting
 * the blur event.
 *
 * There is a cleaner version here that uses touchend that minimizes a good
 * deal of this code and it's cleaner. However, in the interest of someone
 * saying, "This is broken" because they aren't on a mobile/touch device.
 * Therefore mousedown is used to ensure clear occurs before the blur event
 * can take affect.
 * @private
 * @param {HTMLElement} clearIcon
 * @returns {Object} Contains methods used for coordinating of clearing a field
 */
var coordinateClearEvents = function coordinateClearEvents(clearIcon) {
  var evtName = 'mousedown';
  var handler;
  var shouldClearForm;
  return {
    attach: function attach() {
      clearIcon.addEventListener(evtName, handler = function handler() {
        shouldClearForm = true;
      });
    },
    detach: function detach(formField) {
      if (shouldClearForm) {
        clearValue(formField);
        clearIcon.removeEventListener(evtName, handler);
        shouldClearForm = false;
      }
    }
  };
};

/**
 * hides all icons by removing the visibility className.
 * @private
 * @param {HTMLElement} container - The icon container
 */
var hideAll = function hideAll(container) {
  Array.from(container.querySelectorAll(".".concat(__WEBPACK_IMPORTED_MODULE_2__iconify_setup__["a" /* ICON_CLASS_NAME */]))).forEach(function (el) {
    el.classList.remove(__WEBPACK_IMPORTED_MODULE_2__iconify_setup__["b" /* VISIBLE_CLASS_NAME */]);
  });
};

/**
 * Responsible for showing the clear icon and hiding the rest of the icons.
 * @private
 * @param {HTMLElement} container - The icon container
 * @param {HTMLFormElement} target - The form field in the container
 * @param {HTMLElement} clearIcon - The clear icon element
 * @param {boolean} clearShown - Whether the clear icon has been shown
 * @returns {boolean|undefined} Determines whether the clear icon was shown,
 * otherwise returns undefined.
 */
var editable = function editable(container, target, clearIcon, clearShown) {
  if (clearShown && target.value) {
    return true;
  }
  hideAll(container);
  if (clearIcon && target.value) {
    clearIcon.classList.add(__WEBPACK_IMPORTED_MODULE_2__iconify_setup__["b" /* VISIBLE_CLASS_NAME */]);
    return true;
  }
  return false;
};

/**
 * Responsible for firing off a set of rules when the field has been completed.
 * This would happen when the field has initially loaded or on blur.
 * @private
 * @param {HTMLElement} iconContainer - The icon container
 * @param {HTMLElement} container - The element containing the label/form field
 * @param {HTMLFormElement} formField - The form element in the conatiner
 * @param {HTMLElement} invalidIcon - The invalid icon element
 * @param {HTMLElement} validIcon - The valid icon element
 * @param {boolean} shouldValidate - Instructs to only validate on submit
 */
var completed = function completed(iconContainer, container, formField, invalidIcon, validIcon, shouldValidate) {
  hideAll(iconContainer);
  if (shouldValidate) {
    if (invalidIcon && container.querySelector(':invalid') === formField) {
      invalidIcon.classList.add(__WEBPACK_IMPORTED_MODULE_2__iconify_setup__["b" /* VISIBLE_CLASS_NAME */]);
    } else if (validIcon && formField.value) {
      validIcon.classList.add(__WEBPACK_IMPORTED_MODULE_2__iconify_setup__["b" /* VISIBLE_CLASS_NAME */]);
    }
  }
};

/**
 * Runs logic based on when an invalid event has been fired off.
 * @private
 * @param {HTMLElement} iconContainer - The icon container
 * @param {HTMLElement} invalidIcon - The invalid icon element
 */
var invalidated = function invalidated(iconContainer, invalidIcon) {
  hideAll(iconContainer);
  if (invalidIcon) {
    invalidIcon.classList.add(__WEBPACK_IMPORTED_MODULE_2__iconify_setup__["b" /* VISIBLE_CLASS_NAME */]);
  }
};

/**
 * Responds to the event received from the form field behavior. The logic for
 * this is as follows:
 *
 * - focus: check to see if the clear icon should be shown
 * - input: show the clear icon if it already isn't shown
 * - blur: remove clear icon, show valid or invalid icon based on the state
 * formField of the form field
 * - invalid: show the invalid icon
 *
 * There are other optimizations taken for performance, but you get the idea.
 * @private
 * @param {HTMLElement} iconContainer - The icon container
 * @param {HTMLElement} container - The element containing the label/form field
 * @param {HTMLFormElement} formField - The form field
 * @param {Object} icons - Contains icon elements keyed by icon
 * @returns {Function} The inner function called on by form field behavior
 */
var respond = function respond(iconContainer, container, formField, icons) {
  var clearShown = false;
  var clearIcon = icons.clear,
    invalidIcon = icons.invalid,
    validIcon = icons.valid;
  var FOCUS = __WEBPACK_IMPORTED_MODULE_1__form_field_behaviors__["c" /* EVENTS */].FOCUS,
    BLUR = __WEBPACK_IMPORTED_MODULE_1__form_field_behaviors__["c" /* EVENTS */].BLUR,
    INVALID = __WEBPACK_IMPORTED_MODULE_1__form_field_behaviors__["c" /* EVENTS */].INVALID,
    INPUT = __WEBPACK_IMPORTED_MODULE_1__form_field_behaviors__["c" /* EVENTS */].INPUT;
  // By going one level higher in scope, we can control the state of the clear
  // icon in terms of when it was bound and when it needs to be unbound.
  var coordinate = coordinateClearEvents(clearIcon);

  // At this point, the page has loaded without any events so there's a chance
  // a field could already have values. Therefore, apply any completed
  // behaviors, i.e. invalid or valid.
  completed(iconContainer, container, formField, invalidIcon, validIcon, true);
  return function (type) {
    var _ = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var _ref2 = arguments.length > 2 ? arguments[2] : undefined,
      validateOnlyOnSubmit = _ref2.validateOnlyOnSubmit;
    switch (type) {
      case FOCUS:
        // Attaches clear events upon focus since it's the first time the field
        // has been interacted with. This will apply any event handlers used
        // for clearing the field.
        coordinate.attach(formField, function () {
          clearShown = false;
        });

        // Checks to see if we are in an edited state when the focus event
        // occurs. We don't about the return value because the input event
        // manages that portion of the lifecycle.
        editable(iconContainer, formField, clearIcon, clearShown);
        break;
      case INPUT:
        // At this point, the user is inputting values into the field. We call
        // on editable, so that we know how to treat the clear icon, i.e. should
        // it be shown or hidden. By returning back clearShown, we can cache
        // the state and limit the amount of DOM manipulation upon interaction.
        clearShown = editable(iconContainer, formField, clearIcon, clearShown);
        break;
      case BLUR:
        // At this point, the user is done with the field. We reset anything
        // that has state, i.e. clearShown and any event handlers. We also
        // apply the final completed state to the form, i.e. invalid or valid.
        clearShown = false;
        // Release the clear related events from memory.
        coordinate.detach(formField);
        completed(iconContainer, container, formField, invalidIcon, validIcon, !validateOnlyOnSubmit);
        break;
      case INVALID:
        invalidated(iconContainer, invalidIcon);
        break;
      default:
        break;
    }
  };
};

/**
 * Responsible for rendering out icons that will be used for a form field
 * behavior. The rendering is happening internally for a number of reasons:
 *
 * - Minimize the payload in the HTML (that is, if this was coming from there)
 * - Keep configuring from a consumer side as simple as possible.
 * - Since the icons are dependent on JavaScript, inlining them within allows
 *   for the HTML to operate in isolation with little external factors
 *
 * It's also responsible for doing the following:
 *
 * - Showing the correct icon based on the state of the input
 * - Attach/detach any events applied to the icon
 *
 * As for usage, iconify looks for data attributes denoting the different icons
 * to render where the value is used to populate the title of the SVG for
 * i18n/accessibility purposes. Here are the support data attributes:
 *
 * - data-iconify-clear
 * - data-iconify-invalid
 * - data-iconify-valid
 *
 * Any of these options can be used at different times. Therefore, if only clear
 * should be used, then only configure data-iconify-clear and nothing else.
 * Here's an example of the expected markup:
 *
 * @example
 * <div
 *     class="floating-label"
 *     data-iconify-clear="Clear"
 *     data-iconify-invalid="Invalid"
 *     data-iconify-valid="Valid">
 *   <label for="the-dude" class="floating-label__label">The Dude</label>
 *   <input id="the-dude" class="floating-label__input">
 * </div>
 *
 * @param {Object} options - Configurable options
 * @returns {Function} Used to setup and respond to events from the form field
 * behavior
 */
var iconify = function iconify() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return function () {
    for (var _len = arguments.length, nodes = new Array(_len), _key = 0; _key < _len; _key++) {
      nodes[_key] = arguments[_key];
    }
    var _setup = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__iconify_setup__["c" /* default */])(iconList, nodes, options),
      container = _setup.container,
      formField = _setup.formField,
      iconContainer = _setup.iconContainer,
      iconNodes = _setup.iconNodes;
    if (iconNodes) {
      return respond(iconContainer, container, formField, iconNodes);
    }
    return function () {};
  };
};
/* harmony default export */ __webpack_exports__["a"] = (iconify);

/***/ }),
/* 109 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export CONTAINER_CLASS_NAME */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ICON_CLASS_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return VISIBLE_CLASS_NAME; });
/* unused harmony export HIDDEN_CLASS_NAME */
/* unused harmony export appendIconContainer */
/* harmony export (immutable) */ __webpack_exports__["c"] = setupIconify;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_camelCase__ = __webpack_require__(469);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_camelCase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_camelCase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__form_field_behaviors__ = __webpack_require__(17);
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * Responsible for doing the baseline setup for an iconify form field behavior.
 * @module iconifySetup
 */



/**
 * Defines default configuration for iconify.
 * @type {Object}
 */
var DEFAULT_ICONIFY_OPTIONS = {
  prefix: 'iconify',
  containerClassName: 'floating-label__iconify',
  containerModifier: '',
  containerElementName: 'div'
};

/**
 * CSS className used for the container.
 * @type {string}
 */
var CONTAINER_CLASS_NAME = 'iconify';

/**
 * CSS className for an icon element.
 * @type {string}
 */
var ICON_CLASS_NAME = "".concat(CONTAINER_CLASS_NAME, "__icon");

/**
 * CSS className for a visible modifier.
 * @type {string}
 */
var VISIBLE_CLASS_NAME = "".concat(CONTAINER_CLASS_NAME, "__icon--visible");

/**
 * CSS className for a hidden modifier.
 * @type {string}
 */
var HIDDEN_CLASS_NAME = "".concat(CONTAINER_CLASS_NAME, "__icon--hidden");

/**
 * Obtains all the available icons based on how the data-iconify-* attributes
 * have been configured.
 * @private
 * @param {Array} acceptedIcons - List of icons with affiliated data
 * @param {Object} dataset - Data attributes on the container
 * @param {string} prefix - Prepended name applied to the data attributes
 * @param {Object} fieldInfo - Map of elements related to the field
 * @returns {Array} All available icons based on name, text, and the unique ID
 */
var getAvailableIcons = function getAvailableIcons(acceptedIcons, dataset, prefix, fieldInfo) {
  return acceptedIcons.map(function (_ref) {
    var name = _ref.name,
      iconId = _ref.iconId,
      rule = _ref.rule,
      svg = _ref.svg;
    return {
      name: name,
      iconId: iconId,
      rule: rule,
      svg: svg,
      text: dataset[__WEBPACK_IMPORTED_MODULE_0_lodash_camelCase___default()("".concat(prefix, "-").concat(name))]
    };
  }).filter(function (_ref2) {
    var text = _ref2.text,
      rule = _ref2.rule;
    if (rule && !rule(fieldInfo)) {
      return false;
    }
    return !!text;
  });
};

/**
 * Creates the icon container with the selected icons.
 * @private
 * @param {Object} icons - Set of icons that will be rendered
 * @param {string} containerClassName - CSS className for the icon container
 * @param {string} iconClassName - CSS className applied to a single icon
 * @param {string} hiddenClassName - CSS className used to hide an icon
 * @returns {string} String representation of rendered icons
 */
var renderIcons = function renderIcons(_ref3) {
  var icons = _ref3.icons,
    containerClassName = _ref3.containerClassName,
    iconClassName = _ref3.iconClassName,
    hiddenClassName = _ref3.hiddenClassName;
  return "\n  <div class=\"".concat(containerClassName, "\">\n    ").concat(icons.map(function (_ref4) {
    var iconId = _ref4.iconId,
      svg = _ref4.svg,
      text = _ref4.text;
    return "\n      <span class=\"".concat(iconClassName, " ").concat(hiddenClassName, " icon ").concat(iconClassName, "--").concat(iconId, "\">\n        ").concat(svg(text), "\n      </span>\n    ");
  }).join(''), "\n  </div>\n");
};

/**
 * Append the icon container to the DOM.
 * @private
 * @param {HTMLElement} container - Contains the label/form field
 * @param {Object} icons - Set of icons that will be rendered
 * @param {string} elementName - Name of the element for the appended element
 * @param {string} className - CSS className for the appended element
 * @param {string} modifier - Optional BEM Modifier appended to the container
 * @returns {Element} The icon container
 */
var appendIconContainer = function appendIconContainer(container, icons, elementName, className, modifier) {
  var iconContainer = document.createElement(elementName);
  iconContainer.classList.add(className);
  if (modifier) {
    iconContainer.classList.add("".concat(className, "--").concat(modifier));
  }
  iconContainer.innerHTML = renderIcons({
    icons: icons,
    containerClassName: CONTAINER_CLASS_NAME,
    iconClassName: ICON_CLASS_NAME,
    hiddenClassName: HIDDEN_CLASS_NAME
  });
  container.appendChild(iconContainer);
  return iconContainer;
};

/**
 * Looks for all icon related nodes and creates an object based on the name of
 * the icon. This will allow for the consumers of this code to easily reference
 * icons based on what has been passed in by the consumers.
 * @private
 * @param {HTMLElement} iconContainer - Element with icon container
 * @param {Array} icons - Reference to passed in icons from consumer
 * @returns {Object} Contains icons keyed by icon name with icon HTML element
 */
var findIconNodes = function findIconNodes(iconContainer, icons) {
  return icons.reduce(function (acc, _ref5) {
    var name = _ref5.name,
      iconId = _ref5.iconId;
    return Object.assign({}, acc, _defineProperty({}, name, iconContainer.querySelector(".".concat(ICON_CLASS_NAME, "--").concat(iconId))));
  }, {});
};

/**
 * Responsible for taking a list of icons, HTML elements, and options with the
 * intention of rendering a icon contains and the icons that have been passed
 * in. This is a common piece of functionality that covers a couple of different
 * iconify form field behavior scenarios. The goal here is to ensure iconify
 * form field behaviors can focus on their functionality without having to
 * worry about doing this type of setup and expose all the available elements
 * created so they can be leveraged by the consumers.
 * @see DEFAULT_ICONIFY_OPTIONS
 * @param {Array} possibleIcons - Icons that might be available
 * @param {Array} nodes - All form field behavior related elements
 * @param {Object} options - Used for overriding any options
 * @returns {Object} HTML elements pertaining to the icons being rendered
 */
function setupIconify(possibleIcons, nodes) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var _Object$assign2 = Object.assign({}, DEFAULT_ICONIFY_OPTIONS, options),
    prefix = _Object$assign2.prefix,
    className = _Object$assign2.containerClassName,
    modifier = _Object$assign2.containerModifier,
    elementName = _Object$assign2.containerElementName;
  var _nodes$filter = nodes.filter(function (_ref6) {
      var type = _ref6.type;
      return __WEBPACK_IMPORTED_MODULE_1__form_field_behaviors__["b" /* TYPES */].CONTAINER === type;
    }),
    _nodes$filter2 = _slicedToArray(_nodes$filter, 1),
    container = _nodes$filter2[0].node;
  var _nodes$filter3 = nodes.filter(function (_ref7) {
      var type = _ref7.type;
      return __WEBPACK_IMPORTED_MODULE_1__form_field_behaviors__["b" /* TYPES */].FIELD === type;
    }),
    _nodes$filter4 = _slicedToArray(_nodes$filter3, 1),
    formField = _nodes$filter4[0].node;
  var fieldInfo = {
    formField: formField,
    container: container
  };
  var availableIcons = getAvailableIcons(possibleIcons, container.dataset, prefix, fieldInfo);
  if (!availableIcons.length) {
    return {};
  }
  var iconContainer = appendIconContainer(container, availableIcons, elementName, className, modifier);
  var iconNodes = findIconNodes(iconContainer, availableIcons);
  return {
    container: container,
    formField: formField,
    iconContainer: iconContainer,
    iconNodes: iconNodes
  };
}

/***/ }),
/* 110 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__form_field_behaviors__ = __webpack_require__(17);
/* unused harmony reexport EVENTS */
/* unused harmony reexport TYPES */
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
/**
 * Responsible for applying classes in the form of modifiers to form field
 * behaviors based on the current state, i.e. filled, invalid, selected, and
 * so on.
 * @module elements/fields/stateModifiers
 */



/**
 * Defines default options for state modifiers
 * @type {Object}
 */
var DEFAULT_STATE_MODIFIERS = {
  filledModifier: 'filled',
  invalidModifier: 'invalid',
  selectedModifier: 'selected',
  suppressErrorModifier: 'suppress-error'
};

/**
 * Adds modifier CSS class names to any of the elements.
 * @private
 * @param {Array} nodes - An array of objects containing a name and element
 * @param {...string} modifiers - Modifier names
 */
var addClassNames = function addClassNames(nodes) {
  for (var _len = arguments.length, modifiers = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    modifiers[_key - 1] = arguments[_key];
  }
  nodes.forEach(function (_ref) {
    var name = _ref.name,
      node = _ref.node;
    modifiers.forEach(function (modifierName) {
      node.classList.add("".concat(name, "--").concat(modifierName));
    });
  });
};

/**
 * Removes modifier CSS class names to any of the elements.
 * @private
 * @param {Array} nodes - An array of objects containing a name and element
 * @param {...string} modifiers - Modifier names
 */
var removeClassNames = function removeClassNames(nodes) {
  for (var _len2 = arguments.length, modifiers = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
    modifiers[_key2 - 1] = arguments[_key2];
  }
  nodes.forEach(function (_ref2) {
    var name = _ref2.name,
      node = _ref2.node;
    modifiers.forEach(function (modifierName) {
      node.classList.remove("".concat(name, "--").concat(modifierName));
    });
  });
};

/**
 * Ran whenever a FIELD is in a completed state, i.e. when the page first loads
 * or when a blur event occurred.
 * @private
 * @param {Array} nodes - An array of objects containing a name and element
 * @param {HTMLElement} target - The element receiving the event
 * @param {boolean} shouldApplyInvalid - Allow for applying invalid modifiers
 * @param {string} selected - The selected modifier value
 * @param {string} filled - The filled modifier value
 * @param {string} invalid - The invalid modifier value
 * @param {string} suppressError - The suppress error modifier value
 */
var completed = function completed(nodes, target, shouldApplyInvalid, _ref3) {
  var selected = _ref3.selected,
    filled = _ref3.filled,
    invalid = _ref3.invalid,
    suppressError = _ref3.suppressError;
  var _nodes$filter = nodes.filter(function (_ref4) {
      var type = _ref4.type;
      return type === __WEBPACK_IMPORTED_MODULE_0__form_field_behaviors__["b" /* TYPES */].CONTAINER;
    }),
    _nodes$filter2 = _slicedToArray(_nodes$filter, 1),
    container = _nodes$filter2[0].node;
  removeClassNames(nodes, selected, filled, invalid, suppressError);

  // Denotes that within a container a field has an error
  if (container.querySelector(':invalid') === target) {
    // Make sure to apply an invalid error if instructed to apply an invalid
    // modifier
    if (shouldApplyInvalid) {
      addClassNames(nodes, invalid);
    } else {
      // Otherwise, we are looking to suppress an error. Since the browser has
      // built in invalidity, we apply this class to ensure that the default
      // browser invalid behavior gets overridden.
      addClassNames(nodes, suppressError);
    }
  }
  if (target.value) {
    addClassNames(nodes, filled);
  }
};

/**
 * Responds to any event based on the type of event.
 * @private
 * @param {string} type - The type of event, i.e. focus, blur
 * @param {HTMLElement} target - The element receiving the event
 * @param {Array} nodes - An array of objects containing a name and element
 * @param {boolean} validateOnlyOnSubmit - Instructs to only validate on submit
 * @param {Object} modifiers - Contains modifier names
 */
var respond = function respond(type, target, nodes, _ref5, modifiers) {
  var validateOnlyOnSubmit = _ref5.validateOnlyOnSubmit;
  var FOCUS = __WEBPACK_IMPORTED_MODULE_0__form_field_behaviors__["c" /* EVENTS */].FOCUS,
    BLUR = __WEBPACK_IMPORTED_MODULE_0__form_field_behaviors__["c" /* EVENTS */].BLUR,
    INVALID = __WEBPACK_IMPORTED_MODULE_0__form_field_behaviors__["c" /* EVENTS */].INVALID,
    CHANGE = __WEBPACK_IMPORTED_MODULE_0__form_field_behaviors__["c" /* EVENTS */].CHANGE,
    VALID = __WEBPACK_IMPORTED_MODULE_0__form_field_behaviors__["c" /* EVENTS */].VALID;
  var selected = modifiers.selected,
    filled = modifiers.filled,
    invalid = modifiers.invalid,
    suppressError = modifiers.suppressError;
  switch (type) {
    case FOCUS:
    case VALID:
      addClassNames(nodes, selected);
      removeClassNames(nodes, filled, invalid, suppressError);
      break;
    case BLUR:
    case CHANGE:
      completed(nodes, target, !validateOnlyOnSubmit, modifiers);
      break;
    case INVALID:
      removeClassNames(nodes, suppressError);
      addClassNames(nodes, invalid);
      break;
    default:
      break;
  }
};

/**
 * Responsible for initializing state modifiers. More specifically, it'll apply
 * any modifiers (i.e. CSS class names in form of BEM) when the page first
 * loads. For example, when a page initially loads and an element is invalid,
 * it'll apply any modifiers. It'll do the same when responding to events based
 * on user interaction.
 * @private
 * @see DEFAULT_STATE_MODIFIERS
 * @param {Array} nodes - An array of objects containing a name and element
 * @param {Object} options - Options initially passed in
 * @returns {Function} - Used for firing off events
 */
var initialize = function initialize(nodes) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _Object$assign = Object.assign({}, DEFAULT_STATE_MODIFIERS, options),
    filled = _Object$assign.filledModifier,
    invalid = _Object$assign.invalidModifier,
    selected = _Object$assign.selectedModifier,
    suppressError = _Object$assign.suppressErrorModifier;
  var modifiers = {
    filled: filled,
    invalid: invalid,
    selected: selected,
    suppressError: suppressError
  };
  var _nodes$filter3 = nodes.filter(function (_ref6) {
      var type = _ref6.type;
      return type === __WEBPACK_IMPORTED_MODULE_0__form_field_behaviors__["b" /* TYPES */].FIELD;
    }),
    _nodes$filter4 = _slicedToArray(_nodes$filter3, 1),
    formField = _nodes$filter4[0].node;
  completed(nodes, formField, true, modifiers);
  return function (type, _ref7, data) {
    var target = _ref7.target;
    return respond(type, target, nodes, data, modifiers);
  };
};

/**
 * Provides modifiers, i.e. CSS class names in the form of BEM to a block and
 * two child block elements. These elements are coming from the nodes.
 * @see DEFAULT_STATE_MODIFIERS
 * @param options
 */
var stateModifiers = function stateModifiers() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return function () {
    for (var _len3 = arguments.length, nodes = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      nodes[_key3] = arguments[_key3];
    }
    return initialize(nodes, options);
  };
};
/* harmony default export */ __webpack_exports__["a"] = (stateModifiers);

/***/ }),
/* 111 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export PLUGIN_NAME */
/* unused harmony export ACTIVE_CLASS */
/* unused harmony export VISUAL_HIDDEN_CLASS */
/* unused harmony export MODAL_CLASS */
/* unused harmony export EVENT_NAME */
/* harmony export (immutable) */ __webpack_exports__["a"] = toggleFavorite;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__modules_modal__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modules_notification_popup__ = __webpack_require__(297);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_register_jquery_plugin__ = __webpack_require__(1);
/**
 * Toggles the 'active' class modifier on favorite buttons when clicking
 * @module toggleFavorite
 */





var PLUGIN_NAME = 'toggleFavorite';
var ACTIVE_CLASS = 'favorite-button--active';
var VISUAL_HIDDEN_CLASS = 'u-screen-reader';
var MODAL_CLASS = 'modal';
var EVENT_NAME = 'favorite';

/**
 * Defines sensible defaults for toggle favorite.
 * @type {Object}
 */
var TOGGLE_FAVORITE_OPTIONS = {
  modal: __WEBPACK_IMPORTED_MODULE_1__modules_modal__["a" /* default */],
  notificationPopup: __WEBPACK_IMPORTED_MODULE_2__modules_notification_popup__["a" /* default */],
  container: document.body
};
function getActiveClass() {
  return window.rcProps && window.rcProps.favoriteActiveClass || ACTIVE_CLASS;
}

/**
 * Central place to see if a specific element has been favorited.
 * @private
 * @param {jQuery} $el - Container for the favorite button
 * @returns {boolean} Whether the item has been favorited
 */
var isFavorited = function isFavorited($el) {
  return $el.hasClass(getActiveClass());
};

/**
 * Shows the appropriate favorite related message for screen readers.
 * @private
 * @param {jQuery} $el - Container for the favorite button
 * @param {boolean} hasFavorite - Whether it has been favorited
 */
var showMessage = function showMessage($el, hasFavorite) {
  var message = $el.data('favoriteMessage');
  if (hasFavorite) {
    message = $el.data('unfavoriteMessage');
  }
  $el.find(".".concat(VISUAL_HIDDEN_CLASS)).text(message);
};

/**
 * Responsible for showing the notification based on whether the item has been
 * favorited.
 * @private
 * @param {jQuery} $el - Container for the favorite button
 * @param {boolean} hasFavorite - Whether it has been favorited
 * @param {Object} options - Configuration options
 */
var showNotification = function showNotification($el, hasFavorite, _ref) {
  var notificationFunc = _ref.notificationPopup,
    container = _ref.container;
  var message = $el.data('unfavoriteNotification');
  if (hasFavorite) {
    message = $el.data('favoriteNotification');
  }
  notificationFunc({
    message: message,
    container: container
  });
};

/**
 * Responsible for initializing any visual hidden text related to the state of
 * the favorite button.
 * @private
 * @param {jQuery} $el - Container for the favorite button
 */
var initializeVisualHidden = function initializeVisualHidden($el) {
  var hasFavorite = isFavorited($el);
  var el = document.createElement('span');
  el.className = VISUAL_HIDDEN_CLASS;
  $el.prepend(el);
  showMessage($el, hasFavorite);
};

/**
 * Responsible for dispatching a favorited event.
 * @private
 * @param {HTMLElement} el - Element triggering event
 * @param {boolean} favorited - Whether the element was favorited
 */
var dispatchFavoriteEvent = function dispatchFavoriteEvent(el, favorited, callback) {
  var evt = new CustomEvent(EVENT_NAME, {
    detail: {
      favorited: favorited,
      callback: callback
    }
  });
  el.dispatchEvent(evt);
};

/**
 * Toggle the favorited state
 * @private
 * @param {jQuery} $el - Element to toggle
 * @param {Object} opts - Configurable options
 */
var toggleActive = function toggleActive($el, opts) {
  var code = $el.data('code');
  var productSize = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#tr_top_heart_mhp_count').data('count');
  var activeClass = getActiveClass();
  var hasFavorite = !isFavorited($el);
  if (code) {
    if (window.rcProps.isGuest && !(window.rcProps.hearts.enabledforGuest && productSize <= window.rcProps.hearts.maxCountGuest)) {
      var refUrl = encodeURIComponent(window.location.pathname + window.location.search);
      __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.modal({
        url: '/content/favorites/fav-max-popup-markup',
        triggerOpen: true,
        onOpen: function onOpen() {
          __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#fav-create-link').attr('href', "/r/mobile/LoginPage.jsp?favcode=".concat(code, "&ref=").concat(refUrl));
        }
      });
      return;
    } else if (!window.rcProps.isGuest && productSize > 1999) {
      __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.modal({
        url: '/content/favorites/fav-max-popup-markup',
        triggerOpen: true
      });
      return;
    }
    dispatchFavoriteEvent($el[0], hasFavorite, function () {
      $el.toggleClass(activeClass);
      if ($el.attr('id') === 'product-zoom-favorite') {
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-fav-button').toggleClass(activeClass);
      }
      showMessage($el, hasFavorite);
      showNotification($el, hasFavorite, opts);
    });
  } else {
    $el.toggleClass(activeClass);
    showMessage($el, hasFavorite);
    showNotification($el, hasFavorite, opts);
    dispatchFavoriteEvent($el[0], hasFavorite);
  }
  if (opts && typeof opts.logFavoriteClick === 'function') {
    opts.logFavoriteClick(hasFavorite);
  }
};

/**
 * Sets up click event toggle for favorite heart button.
 * @private
 * @see TOGGLE_FAVORITE_OPTIONS
 * @param {HTMLElement} el - Elements matching the selector (likely .favorite-button)
 * @param {Object} options - Configurable options
 */
function toggleFavorite(el) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var $el = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(el);
  var opts = Object.assign({}, TOGGLE_FAVORITE_OPTIONS, options);
  initializeVisualHidden($el);
  $el.on('click', function () {
    return toggleActive($el, opts);
  });
}

// Expose the function as a jQuery plugin for ease of use
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__lib_register_jquery_plugin__["a" /* default */])(PLUGIN_NAME, toggleFavorite);

/***/ }),
/* 112 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getTemplateHTMLById;
/**
 * Get the Template based on the chosen CTA
 * @module getTemplateHTMLById
 * @param {string} id - template id
 */
function getTemplateHTMLById(id) {
  var template = document.getElementById(id);
  if (!template) {
    throw new Error("Template not found: ".concat(id));
  }
  return document.importNode(template.content, true);
}

/***/ }),
/* 113 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export PLUGIN_NAME */
/* unused harmony export DEFAULTS */
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_register_jquery_plugin__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_merge_options__ = __webpack_require__(2);
/**
 * Custom Video Player Module (mobile)
 * @module customVideoPlayer
 */




var PLUGIN_NAME = 'customVideoPlayer';
var DEFAULTS = {
  videoMuted: true,
  hideMute: false,
  $originalTrigger: __WEBPACK_IMPORTED_MODULE_0_jquery___default()(),
  titleClass: 'floating-video__title',
  captionClass: 'floating-video__caption'
};
function formatTime(seconds) {
  var minutes = Math.floor(seconds / 60);
  var secs = Math.floor(seconds % 60);
  return "".concat(minutes, ":").concat(secs < 10 ? '0' : '').concat(secs);
}
function enterFullScreen(playerContainer) {
  if (playerContainer.requestFullscreen) {
    playerContainer.requestFullscreen();
  } else if (playerContainer.mozRequestFullScreen) {
    playerContainer.mozRequestFullScreen();
  } else if (playerContainer.webkitRequestFullscreen) {
    playerContainer.webkitRequestFullscreen();
  } else if (playerContainer.msRequestFullscreen) {
    playerContainer.msRequestFullscreen();
  }
}
function isVideoPlaying(videoElement) {
  return !videoElement.paused && !videoElement.ended;
}
var createVideoWrapper = function createVideoWrapper() {
  return __WEBPACK_IMPORTED_MODULE_0_jquery___default()('<div class="custom-video__container"></div>');
};
var createVideoControls = function createVideoControls(_ref, title, caption) {
  var hideMute = _ref.hideMute;
  return "\n    <div class=\"js-floating-video-controls custom-video__controls\">\n      <div class=\"js-custom-video__play custom-video__play\">\n        <span class=\"icon icon--play\" style=\"width:84px;height:84px;display: none\">\n          <svg xmlns=\"http://www.w3.org/2000/svg\" version=\"1.1\" viewBox=\"0 0 38 38\">\n            <circle cx=\"19\" cy=\"19\" r=\"8.5\" fill=\"#fff\" stroke=\"#f5f5f5\" />\n            <path d=\"M16,22c0,.4.5.7.9.5l6.1-3c.4-.2.4-.9,0-1.1l-6.1-3c-.4-.2-.9,0-.9.5v6.1Z\" fill=\"#3b3b3b\" />\n          </svg>\n        </span>\n        <span class=\"icon icon--pause\" style=\"width:40px;height:40px;\">\n          <svg xmlns=\"http://www.w3.org/2000/svg\" version=\"1.1\" viewBox=\"0 0 32 32\">\n            <path fill=\"#f5f5f5\" d=\"M5.5,28h6.9V4h-6.9v24ZM19.2,4v24h6.9V4h-6.9Z\" />\n          </svg>\n        </span>\n      </div>\n      <div class=\"custom-video__bottom-controls\">\n        <div class=\"custom-video__bottom-controls-container\">\n          ".concat(title && caption ? "<div class=\"js-custom-video__caption\">\n              <div class=\"u-flex\" style=\"justify-content: space-between;\">\n                <div><strong class=\"u-text--md\">".concat(title, "</strong></div>\n                <button class=\"custom-video__caption-button\">\n                  <span class=\"icon icon--arrow-up u-color--white\">\n                    <svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" aria-hidden=\"true\" focusable=\"false\" role=\"presentation\">\n                      <path d=\"M11.25 10.5a.748.748 0 0 1-.55-.24L8 7.352 5.3 10.26a.75.75 0 0 1-1.1-1.02l3.25-3.5a.774.774 0 0 1 1.1 0l3.25 3.5a.75.75 0 0 1-.55 1.26z\"/>\n                    </svg>\n                  </span>\n                </button>\n              </div>\n              <p>").concat(caption, "</p>\n          </div>") : '', "\n          <div class=\"custom-video__bottom-controls-wrap\">\n            <div class=\"js-custom-video__current-time-container custom-video__current-time-container\">\n                <span class=\"js-custom-video__current-time custom-video__current-time\">0:00</span> / <span\n                  class=\"js-custom-video__total-time\">0:00</span>\n            </div>\n            <div class=\"u-flex\" style=\"align-items: center;\">\n              <div style=\"flex-grow:1;\">\n                <div class=\"js-custom-video__progress-bar-container custom-video__progress-bar-container\">\n                  <div class=\"js-custom-video__progress-bar custom-video__progress-bar\">\n                    <div class=\"js-custom-video__progress custom-video__progress\"></div>\n                    <div class=\"js-custom-video__thumb custom-video__thumb\"></div>\n                  </div>\n                </div>\n              </div>\n              <div class=\"u-flex\">\n                <div class=\"js-custom-video__fullscreen custom-video__fullscreen\">\n                  <span class=\"icon icon--fullscreen icon--md\">\n                    <svg xmlns=\"http://www.w3.org/2000/svg\" version=\"1.1\" viewBox=\"0 0 24 24\">\n                      <path\n                        d=\"M6,19c-.3,0-.5,0-.7-.3-.2-.2-.3-.4-.3-.7v-3c0-.3,0-.5.3-.7.2-.2.4-.3.7-.3s.5,0,.7.3c.2.2.3.4.3.7v2h2c.3,0,.5,0,.7.3.2.2.3.4.3.7s0,.5-.3.7c-.2.2-.4.3-.7.3h-3ZM6,10c-.3,0-.5,0-.7-.3-.2-.2-.3-.4-.3-.7v-3c0-.3,0-.5.3-.7.2-.2.4-.3.7-.3h3c.3,0,.5,0,.7.3.2.2.3.4.3.7s0,.5-.3.7c-.2.2-.4.3-.7.3h-2v2c0,.3,0,.5-.3.7-.2.2-.4.3-.7.3ZM15,19c-.3,0-.5,0-.7-.3-.2-.2-.3-.4-.3-.7s0-.5.3-.7c.2-.2.4-.3.7-.3h2v-2c0-.3,0-.5.3-.7.2-.2.4-.3.7-.3s.5,0,.7.3c.2.2.3.4.3.7v3c0,.3,0,.5-.3.7-.2.2-.4.3-.7.3h-3ZM18,10c-.3,0-.5,0-.7-.3-.2-.2-.3-.4-.3-.7v-2h-2c-.3,0-.5,0-.7-.3-.2-.2-.3-.4-.3-.7s0-.5.3-.7c.2-.2.4-.3.7-.3h3c.3,0,.5,0,.7.3.2.2.3.4.3.7v3c0,.3,0,.5-.3.7-.2.2-.4.3-.7.3Z\" />\n                    </svg>\n                  </span>\n                </div>\n                ").concat(hideMute ? "<div class=\"js-custom-video__mute\">\n                    <span class=\"icon icon--unmute icon--md\">\n                      <svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\">\n                        <path\n                          d=\"M14.2,6.4c.2-.3.6-.5.9-.3,2.3,1.1,3.9,3.3,3.9,5.9s-1.6,4.8-3.9,5.9c-.3.2-.8,0-.9-.3-.2-.3,0-.7.3-.9,1.8-.9,3.1-2.7,3.1-4.7s-1.3-3.9-3.1-4.7c-.3-.2-.5-.6-.3-.9Z\" />\n                        <path\n                          d=\"M7.8,9.3h-1.4c-.8,0-1.4.6-1.4,1.3v2.6c0,.7.6,1.3,1.4,1.3h1.4l3.1,2.4c.5.4,1.1,0,1.1-.5V7.5c0-.6-.7-.9-1.1-.5l-3.1,2.4Z\" />\n                        <path\n                          d=\"M15.4,9.6c-.2-.3-.7-.4-1-.1-.3.2-.4.6-.1.9.3.4.6,1,.6,1.6s-.2,1.1-.6,1.6c-.2.3-.2.7.1.9.3.2.7.2,1-.1.5-.7.8-1.5.8-2.4s-.3-1.7-.8-2.4Z\" />\n                      </svg>\n                    </span>\n                    <span class=\"icon icon--mute icon--md\" style=\"display: none\">\n                      <svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\">\n                        <path\n                          d=\"M17.6128 18.7968L15.9153 17.0792C15.7449 17.1777 15.5745 17.273 15.4042 17.3651C15.2338 17.4577 15.0574 17.5409 14.8748 17.6148C14.6315 17.7133 14.4063 17.6825 14.1995 17.5224C13.9926 17.3624 13.8892 17.1407 13.8892 16.8575C13.8892 16.7221 13.9288 16.6021 14.0082 16.4977C14.087 16.3928 14.1873 16.3157 14.309 16.2665C14.4063 16.2296 14.5008 16.1894 14.5923 16.1461C14.6833 16.1032 14.7714 16.0572 14.8566 16.0079L12.4289 13.5515V15.6016C12.4289 15.934 12.2798 16.1648 11.9814 16.2938C11.6835 16.4234 11.4189 16.3712 11.1877 16.1372L8.77836 13.6992H6.58801C6.38114 13.6992 6.20786 13.6283 6.06816 13.4864C5.92798 13.3451 5.85789 13.1697 5.85789 12.9604V10.0053C5.85789 9.79595 5.92798 9.62037 6.06816 9.47852C6.20786 9.33717 6.38114 9.26649 6.58801 9.26649H8.19426L5.20078 6.23747C5.06693 6.10202 5 5.92964 5 5.72032C5 5.51099 5.06693 5.33861 5.20078 5.20317C5.33464 5.06772 5.505 5 5.71186 5C5.91873 5 6.08909 5.06772 6.22295 5.20317L18.6349 17.7625C18.7688 17.898 18.8357 18.0704 18.8357 18.2797C18.8357 18.489 18.7688 18.6614 18.6349 18.7968C18.5011 18.9323 18.3307 19 18.1239 19C17.917 19 17.7466 18.9323 17.6128 18.7968ZM14.8748 5.31398C16.116 5.81882 17.1139 6.62533 17.8683 7.73351C18.6228 8.84169 19 10.0853 19 11.4644C19 12.117 18.9119 12.7449 18.7357 13.3483C18.559 13.9516 18.3064 14.5119 17.9778 15.029L16.9192 13.9578C17.126 13.5761 17.2813 13.1759 17.385 12.7573C17.4882 12.3386 17.5398 11.9077 17.5398 11.4644C17.5398 10.3808 17.2448 9.40809 16.6549 8.54617C16.0644 7.68426 15.2825 7.05629 14.309 6.66227C14.1751 6.61302 14.0717 6.53298 13.9987 6.42216C13.9257 6.31135 13.8892 6.18821 13.8892 6.05277C13.8892 5.78188 13.9926 5.5664 14.1995 5.40633C14.4063 5.24626 14.6315 5.21548 14.8748 5.31398ZM15.5319 12.5541L13.8892 10.8918V8.49077C14.4611 8.76165 14.9084 9.16799 15.2311 9.70976C15.5534 10.2515 15.7145 10.8426 15.7145 11.4829C15.7145 11.6675 15.6994 11.8493 15.6692 12.0281C15.6385 12.2064 15.5928 12.3817 15.5319 12.5541ZM12.4289 9.41425L10.5306 7.4934L11.1877 6.8285C11.4189 6.59455 11.6835 6.54209 11.9814 6.67113C12.2798 6.80067 12.4289 7.03166 12.4289 7.36412V9.41425Z\" />\n                      </svg>\n                    </span>\n                  </div>" : '', "\n              </div>\n            </div>\n          </div>\n        </div>\n      </div>\n    </div>\n");
};
var applyVideoSkin = function applyVideoSkin($video, options) {
  var videoWrapper = createVideoWrapper();
  $video.wrap(videoWrapper);
  var $videoWrapper = $video.parent();
  var $titleHidden = options.$originalTrigger.find(".".concat(options.titleClass));
  var $captionHidden = options.$originalTrigger.find(".".concat(options.captionClass));
  var controlsHtml = createVideoControls(options, $titleHidden.text(), $captionHidden.text());
  var $videoControls = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(controlsHtml);
  $videoWrapper.prepend($videoControls);
  var $playPauseButton = $videoWrapper.find('.js-custom-video__play');
  var $muteButton = $videoWrapper.find('.js-custom-video__mute');
  var $captionButton = $videoWrapper.find('.js-custom-video__caption');
  var $currentTimeContainer = $videoWrapper.find('.js-custom-video__current-time-container');
  var $currentTimeDisplay = $videoWrapper.find('.js-custom-video__current-time');
  var $totalTimeDisplay = $videoWrapper.find('.js-custom-video__total-time');
  var $progressBarContainer = $videoWrapper.find('.js-custom-video__progress-bar-container');
  var $progressBar = $videoWrapper.find('.js-custom-video__progress-bar');
  var $progress = $videoWrapper.find('.js-custom-video__progress');
  var $thumb = $videoWrapper.find('.js-custom-video__thumb');
  var $fullscreenIcon = $videoWrapper.find('.js-custom-video__fullscreen');
  var $muteIcon = $videoWrapper.find('.icon--mute');
  var $unmuteIcon = $videoWrapper.find('.icon--unmute');
  var $playIcon = $videoWrapper.find('.icon--play');
  var $pauseIcon = $videoWrapper.find('.icon--pause');
  var video = $video[0];
  var videoMuted = options.videoMuted;
  var hideControlsTimer;
  var showPlayerControls = function showPlayerControls() {
    $videoWrapper.addClass('custom-video__container--controls-visible');
  };
  var scheduleHidePlayerControls = function scheduleHidePlayerControls() {
    clearTimeout(hideControlsTimer);
    hideControlsTimer = window.setTimeout(function () {
      $videoWrapper.removeClass('custom-video__container--controls-visible');
    }, 2500);
  };
  if (!videoMuted) {
    switchMuteIcon();
  }
  $captionButton.on('click', function () {
    $captionButton.toggleClass('expanded');
    $videoWrapper.toggleClass('custom-video__controls-caption--expanded');
  });
  var playPromise = video.play();
  if (playPromise !== undefined) {
    playPromise["catch"](function () {});
  }
  showPlayerControls();
  video.volume = 1;
  video.removeAttribute('controls');
  $playPauseButton.on('click', function () {
    if (isVideoPlaying(video)) {
      video.pause();
    } else {
      video.play();
    }
  });
  $videoWrapper.on('click.controlsVisibility', function () {
    showPlayerControls();
    if (isVideoPlaying(video)) {
      scheduleHidePlayerControls();
    }
  });
  $video.on('play', function () {
    $playIcon.hide();
    $pauseIcon.show();
    scheduleHidePlayerControls();
  });
  $video.on('pause', function () {
    $playIcon.show();
    $pauseIcon.hide();
    clearTimeout(hideControlsTimer);
    showPlayerControls();
  });
  video.onloadedmetadata = function () {
    $totalTimeDisplay.text(formatTime(video.duration));
  };
  video.ontimeupdate = function () {
    $currentTimeDisplay.text(formatTime(video.currentTime));
    updateProgressBar();
  };
  $progressBarContainer.on('mousedown.customVideoPlayer touchstart.customVideoPlayer', function (e) {
    updateCurrentTime(e.type === 'touchstart' ? e.originalEvent.touches[0] : e);
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).on('mousemove.customVideoPlayer touchmove.customVideoPlayer', function (ev) {
      updateCurrentTime(ev.type === 'touchmove' ? ev.originalEvent.touches[0] : ev);
    });
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).on('mouseup.customVideoPlayer touchend.customVideoPlayer', function () {
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).off('mousemove.customVideoPlayer touchmove.customVideoPlayer');
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).off('mouseup.customVideoPlayer touchend.customVideoPlayer');
      window.setTimeout(function () {
        return $currentTimeContainer.removeClass('show');
      }, 1000);
    });
  });
  $progressBarContainer.on('mouseenter', function () {
    $currentTimeContainer.addClass('show');
  });
  $progressBarContainer.on('mouseleave', function () {
    $currentTimeContainer.removeClass('show');
  });
  function updateCurrentTime(e) {
    if (e.stopPropagation) {
      e.stopPropagation();
    }
    var offsetX = (e.pageX !== undefined ? e.pageX : e.clientX) - $progressBar.offset().left;
    var width = $progressBar.width();
    var clickPosition = Math.max(0, Math.min(offsetX / width, 1));
    video.currentTime = clickPosition * video.duration;
    updateProgressBar();
    $currentTimeDisplay.text(formatTime(video.currentTime));
  }
  function updateProgressBar() {
    var progressPercentage = video.currentTime / video.duration * 100;
    $progress.css('width', "".concat(progressPercentage, "%"));
    var thumbPosition = progressPercentage / 100 * $progressBar.width();
    $thumb.css('left', "".concat(thumbPosition, "px"));
  }
  $muteButton.on('click', function () {
    switchMuteIcon();
  });
  function switchMuteIcon() {
    video.muted = !video.muted;
    if (video.muted) {
      $muteIcon.show();
      $unmuteIcon.hide();
    } else {
      $muteIcon.hide();
      $unmuteIcon.show();
    }
  }
  switchMuteIcon();
  $fullscreenIcon.on('click', function () {
    if (document.fullscreenElement) {
      document.exitFullscreen();
    } else {
      enterFullScreen($videoWrapper[0]);
      $videoWrapper.addClass('is-fullscreen');
    }
  });
  document.addEventListener('fullscreenchange', function () {
    if (!document.fullscreenElement) {
      $videoWrapper.removeClass('is-fullscreen');
    }
  });
};
function customVideoPlayer(el) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var $video = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(el);
  var opts = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__lib_merge_options__["a" /* default */])(DEFAULTS, options, $video);
  applyVideoSkin($video, opts);
  return {};
}
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__lib_register_jquery_plugin__["a" /* default */])(PLUGIN_NAME, customVideoPlayer);

/***/ }),
/* 114 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export PLUGIN_NAME */
/* unused harmony export DEFAULTS */
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_debounce__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_debounce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_debounce__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_throttle__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_throttle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_throttle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_props__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__keyboard__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lib_register_jquery_plugin__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__lib_merge_options__ = __webpack_require__(2);







var PLUGIN_NAME = 'horizontalScroll';
var DEFAULTS = {
  type: '',
  stacked: false,
  verticalLazy: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__lib_props__["a" /* get */])('rcProps.abTests.ab776', false),
  preserveScrollPosition: false,
  preserveScrollKey: ''
};
var BASE_SELECTOR = '.horizontal-scroll';
var WRAPPER_SELECTOR = "".concat(BASE_SELECTOR, "__wrapper");
var SLIDES_SELECTOR = "".concat(BASE_SELECTOR, "__item");
var SCROLL_POSITION_STORAGE_PREFIX = 'horizontalScroll_pos_';
var $window = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(window);
var isRTL = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('html').attr('dir') === 'rtl';

/**
 * Checks if the container is in the window viewport, preventing lazy image load
 * when section is below the fold
 * @param {jQuery} $el - The horizontal scroll container
 */
var isContainerInWindowViewport = function isContainerInWindowViewport($el) {
  var rect = $el[0].getBoundingClientRect();
  return rect.top < window.innerHeight && rect.bottom > 0;
};
var isInViewport = function isInViewport($img, $container) {
  // Cache the container properties once, assuming they don't change often.
  var containerOffset = $container.offset();
  var containerWidth = $container.outerWidth();
  var containerHeight = $container.height();

  // Get the image's position and size.
  var imgOffset = $img.offset();
  var imgWidth = $img.outerWidth();
  var imgHeight = $img.outerHeight();

  // Calculate image boundaries
  var imgTop = imgOffset.top;
  var imgBottom = imgTop + imgHeight;
  var imgLeft = imgOffset.left;
  var imgRight = imgLeft + imgWidth;

  // Calculate container boundaries
  var vpTop = containerOffset.top;
  var vpBottom = vpTop + containerHeight;
  var vpLeft = containerOffset.left;
  var vpRight = vpLeft + containerWidth;

  // Check if the image is within the container's viewport
  return imgBottom > vpTop && imgTop < vpBottom && imgLeft < vpRight && imgRight > vpLeft;
};

/**
 * Indicates whether element is within horizontal viewport.
 * @param  {HTMLElement} slide  The DOM element of the slide.
 * @return {boolean}  Whether the element is within the horizontal viewport.
 */
function isInHorizontalViewport(slide) {
  var rect = slide.getBoundingClientRect();
  var FULL_TOLERANCE = 1;
  var BUFFER = 20;
  return {
    fullyInViewport: rect.left >= 0 && rect.right <= window.innerWidth + FULL_TOLERANCE,
    partiallyInViewport: rect.right > BUFFER && rect.left < window.innerWidth - BUFFER
  };
}
var addButtonsToWrapper = function addButtonsToWrapper($el) {
  var previousButtonHTML = isRTL ? "\n    <button aria-label=\"previous page\" class=\"previous\">\n        <span class=\"btn btn--circle\">\n          <span class=\"icon icon--sm icon--arrow-right\">\n              <svg viewBox=\"0 0 16 16\" aria-hidden=\"true\" focusable=\"false\" role=\"presentation\">\n                  <path d=\"M6.25 12a.75.75 0 0 1-.51-1.3L8.648 8 5.74 5.3A.75.75 0 1 1 6.76 4.2l3.5 3.25a.75.75 0 0 1 0 1.1l-3.5 3.25a.749.749 0 0 1-.51.2z\"/>\n              </svg>\n          </span>\n        </span>\n      </button>\n    " : "\n  <button aria-label=\"previous page\" class=\"previous\">\n    <span class=\"btn btn--circle\">\n          <span class=\"icon icon--sm icon--arrow-left\">\n        <svg viewBox=\"0 0 16 16\" aria-hidden=\"true\" focusable=\"false\" role=\"presentation\">\n                  <path d=\"M9.75 12a.749.749 0 0 1-.51-.2l-3.5-3.25a.75.75 0 0 1 0-1.1l3.5-3.25a.75.75 0 0 1 1.02 1.1L7.352 8l2.908 2.7a.75.75 0 0 1-.51 1.3z\"/>\n        </svg>\n      </span>\n    </span>\n  </button>\n";
  var nextButtonHTML = isRTL ? "\n    <button aria-label=\"next page\" class=\"next\">\n        <span class=\"btn btn--circle\">\n          <span class=\"icon icon--sm icon--arrow-left\">\n              <svg viewBox=\"0 0 16 16\" aria-hidden=\"true\" focusable=\"false\" role=\"presentation\">\n                  <path d=\"M9.75 12a.749.749 0 0 1-.51-.2l-3.5-3.25a.75.75 0 0 1 0-1.1l3.5-3.25a.75.75 0 0 1 1.02 1.1L7.352 8l2.908 2.7a.75.75 0 0 1-.51 1.3z\"/>\n              </svg>\n          </span>\n        </span>\n      </button>\n    " : "\n    <button aria-label=\"next page\" class=\"next\">\n        <span class=\"btn btn--circle\">\n          <span class=\"icon icon--sm icon--arrow-right\">\n              <svg viewBox=\"0 0 16 16\" aria-hidden=\"true\" focusable=\"false\" role=\"presentation\">\n                  <path d=\"M6.25 12a.75.75 0 0 1-.51-1.3L8.648 8 5.74 5.3A.75.75 0 1 1 6.76 4.2l3.5 3.25a.75.75 0 0 1 0 1.1l-3.5 3.25a.749.749 0 0 1-.51.2z\"/>\n              </svg>\n          </span>\n        </span>\n      </button>\n    ";
  if (isRTL) {
    $el.after(nextButtonHTML);
    $el.before(previousButtonHTML);
  } else {
    $el.before(previousButtonHTML);
    $el.after(nextButtonHTML);
  }
};
var wrapHorizontalScrollContent = function wrapHorizontalScrollContent($el) {
  $el.wrap('<div class="horizontal-scroll__wrapper" aria-label="Carousel" role="region" />');
  addButtonsToWrapper($el);
};
var FOCUSABLE_SELECTOR = 'a, button, input, select, [tabindex]';

/**
 * Removes focusable children from the tab order for partially visible slides.
 * The slide remains clickable but keyboard navigation is restricted.
 *
 * @param {jQuery} $slide
 * @return {void}
 */
var disableFocus = function disableFocus($slide) {
  $slide.find(FOCUSABLE_SELECTOR).attr('tabindex', '-1');
};

/**
 * Restores focusable children to the tab order when a slide becomes fully visible.
 *
 * @param {jQuery} $slide
 * @return {void}
 */
var enableFocus = function enableFocus($slide) {
  $slide.find(FOCUSABLE_SELECTOR).removeAttr('tabindex');
};

/**
 * Updates the inert and aria-hidden attributes for each slide based on viewport visibility.
 *
 * Three statuses:
 *   - full    → fully interactive, in tab order
 *   - partial → clickable (no inert), but aria-hidden and tabindex="-1" on children
 *   - hidden  → inert + aria-hidden (no interaction at all)
 *
 * Skips updates when the slide status has not changed since the last scroll tick.
 *
 * @return {void}
 */
var updateSlideState = function updateSlideState($el) {
  var $slides = $el.find(SLIDES_SELECTOR);
  if (!$slides.length) return;
  $slides.each(function (_index, slide) {
    var _isInHorizontalViewpo = isInHorizontalViewport(slide),
      fullyInViewport = _isInHorizontalViewpo.fullyInViewport,
      partiallyInViewport = _isInHorizontalViewpo.partiallyInViewport;
    var $slide = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(slide);
    var status = 'hidden';
    if (fullyInViewport) status = 'full';else if (partiallyInViewport) status = 'partial';
    if ($slide.data('hs-status') === status) return;
    $slide.data('hs-status', status);
    if (status === 'full') {
      $slide.removeAttr('inert').removeAttr('aria-hidden');
      enableFocus($slide);
    } else if (status === 'partial') {
      $slide.removeAttr('inert').attr('aria-hidden', 'true');
      disableFocus($slide);
    } else {
      $slide.attr('inert', '').attr('aria-hidden', 'true');
    }
  });
};
/**
 * Calculate combined width of all slides, whether stacked or not.
 * @param {jQuery} $slides  The slides
 * @param {Object} opts Options
 * @return {void}
 */
var calculateTotalScrollableWidth = function calculateTotalScrollableWidth($slides, opts) {
  if (opts.stacked) {
    // If stacked, calculate based on number of columns per row
    var firstSlideWidth = $slides.first().outerWidth(true);
    var visibleRows = Math.floor($slides.parent().outerHeight() / $slides.first().outerHeight(true));
    var columnsPerRow = Math.ceil($slides.length / visibleRows);
    return firstSlideWidth * columnsPerRow;
  }

  // If unstacked, sum up total slides width
  return $slides.toArray().reduce(function (totalWidth, slide) {
    return totalWidth + __WEBPACK_IMPORTED_MODULE_0_jquery___default()(slide).outerWidth(true);
  }, 0);
};
/**
 * Updates enabled/disabled state of buttons based on current slider position.
 * @return {void}
 */
var updateButtonState = function updateButtonState($el, opts) {
  var $slides = $el.find("".concat(BASE_SELECTOR, "__item"));
  var $prev = $el.closest(WRAPPER_SELECTOR).find('.previous');
  var $next = $el.closest(WRAPPER_SELECTOR).find('.next');

  // Calculate container width and total slides width
  var containerWidth = $el.outerWidth();
  var totalScrollableWidth = calculateTotalScrollableWidth($slides, opts);

  // Calculate current scroll position and determine boundaries
  var currentScrollLeft = $el.scrollLeft();
  var lastSlideOffset = totalScrollableWidth - containerWidth;
  if (isRTL) {
    // In RTL, scrollLeft is negative as you scroll leftwards,
    // so the "end" is the most negative value
    var mostNegativeScrollLeft = -totalScrollableWidth + containerWidth;

    // Determine whether on first or last slide in RTL mode
    // Near zero in RTL mode means visual start
    var onFirstSlide = currentScrollLeft >= -1;
    // Near max negative value means visual end
    var onLastSlide = currentScrollLeft <= mostNegativeScrollLeft + 1;

    // Finally, update button state for RTL
    $prev.prop('disabled', onFirstSlide);
    $prev.attr('aria-hidden', onFirstSlide);
    $next.prop('disabled', onLastSlide);
    $next.attr('aria-hidden', onLastSlide);
  } else {
    // Determine whether on first or last slide in LTR mode
    var _onFirstSlide = currentScrollLeft <= 0;
    var _onLastSlide = currentScrollLeft >= lastSlideOffset;

    // Finally, update button state for LTR
    $prev.prop('disabled', _onFirstSlide);
    $prev.attr('aria-hidden', _onFirstSlide);
    $next.prop('disabled', _onLastSlide);
    $next.attr('aria-hidden', _onLastSlide);
  }
};

/**
 * Checks if the image is in the viewport and loads it if necessary
 * @param {jQuery} $lazyImage - jQuery wrapped image element with 'data-lazy' attribute
 * @param {Object} windowRect - Object containing viewport boundaries
 * @param {number} windowRect.top - Viewport's top position (window.scrollY)
 * @param {number} windowRect.bottom - Viewport's bottom position (scrollY + innerHeight)
 * @param {number} windowRect.left - Viewport's left position (window.scrollX)
 * @param {number} windowRect.right - Viewport's right position (scrollX + innerWidth)
 */
var loadImageIfInWindowViewport = function loadImageIfInWindowViewport($lazyImage, windowRect) {
  // Get the image's position and size
  var imgTop = $lazyImage.offset().top;
  var imgBottom = imgTop + $lazyImage.outerHeight();
  var imgLeft = $lazyImage.offset().left;
  var imgRight = imgLeft + $lazyImage.outerWidth();

  // Check if the image is within the viewport
  var isInVerticalViewport = imgBottom > windowRect.top && imgTop < windowRect.bottom;
  var isInHorizontalView = imgRight > windowRect.left && imgLeft < windowRect.right;

  // If the image is in the viewport and not loaded yet, load it
  if (isInVerticalViewport && isInHorizontalView) {
    $lazyImage.attr('src', $lazyImage.attr('data-lazy'));
    if ($lazyImage.attr('data-srcset')) {
      $lazyImage.attr('srcset', $lazyImage.attr('data-srcset'));
    }
    $lazyImage.addClass('loaded');
  }
};
var showImage = function showImage($el, opts, key) {
  if (!isContainerInWindowViewport($el)) return;
  var $lazyImages = $el.find('img[data-lazy]').not('.loaded');
  if ($lazyImages.length === 0) {
    $window.off("scroll.horizontalScroll-".concat(key));
    $el.off("scroll.horizontalScroll-".concat(key));
  }
  if (opts.verticalLazy) {
    // Calculate the viewport boundaries
    var windowRect = {
      top: window.scrollY,
      bottom: window.scrollY + window.innerHeight,
      left: window.scrollX,
      right: window.scrollX + window.innerWidth
    };
    $lazyImages.each(function eachLazyImageInWindow() {
      var $lazyImage = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this);
      loadImageIfInWindowViewport($lazyImage, windowRect);
    });
  } else {
    $lazyImages.each(function eachLazyImage() {
      var $lazyImage = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this);
      if (isInViewport($lazyImage, $el)) {
        $lazyImage.attr('src', $lazyImage.attr('data-lazy'));
        if ($lazyImage.attr('data-srcset')) {
          $lazyImage.attr('srcset', $lazyImage.attr('data-srcset'));
        }
        $lazyImage.addClass('loaded');
      }
    });
  }
};
var getScrollStorageKey = function getScrollStorageKey(opts) {
  return "".concat(SCROLL_POSITION_STORAGE_PREFIX).concat(opts.preserveScrollKey || window.location.pathname);
};
var saveScrollPosition = function saveScrollPosition($el, opts) {
  try {
    sessionStorage.setItem(getScrollStorageKey(opts), $el.scrollLeft());
  } catch (e) {/* sessionStorage unavailable */}
};
var restoreScrollPosition = function restoreScrollPosition($el, opts) {
  try {
    var saved = sessionStorage.getItem(getScrollStorageKey(opts));
    if (saved !== null) {
      $el.scrollLeft(parseInt(saved, 10));
      updateButtonState($el, opts);
      updateSlideState($el);
    }
  } catch (e) {/* sessionStorage unavailable */}
};
var onWindowScroll = function onWindowScroll($el, opts, key) {
  $window.on("scroll.horizontalScroll-".concat(key), __WEBPACK_IMPORTED_MODULE_2_lodash_throttle___default()(function () {
    return showImage($el, opts, key);
  }, 200));
};
/**
 * Animates the horizontal scroll to specified index.
 * @param  {number} index  The slide index to which to move.
 * @return {void}
 */
var moveSlider = function moveSlider(index, $el, $slides, opts) {
  var isWithinBounds = index >= 0 && index < $slides.length;
  if (isWithinBounds) {
    // Calculate new scroll position based on slide width
    var slideWidth = $slides.eq(index).outerWidth(true);
    var scrollDirection = isRTL ? -1 : 1;
    var scrollPosition = slideWidth * index * scrollDirection;
    updateButtonState($el, opts);
    $el.animate({
      scrollLeft: scrollPosition
    }, 'fast', function () {
      // After scroll animation is complete, update index and set focus on the first focusable
      // element inside the visible slide
      $el.data('currentSlideIndex', index);
      updateSlideState($el);
      var $visibleSlide = $slides.eq(index);
      $visibleSlide.find('a, button, input, [tabindex="0"]').first().focus();
    });
  }
};
/**
 * Gets index of currently visible slide.
 * @return {number}  Index of currently visible slide.
 */
var getCurrentSlideIndex = function getCurrentSlideIndex($el) {
  // If in-memory data has an index, use it. If not, use fallback code.
  var index = $el.data('currentSlideIndex');
  if (typeof index === 'number') return index;
  var currentIndex = 0;
  var $slides = $el.find("".concat(BASE_SELECTOR, "__item"));
  $slides.each(function checkInView(viewIndex) {
    var viewportStatus = isInHorizontalViewport(this);
    if (viewportStatus.fullyInViewport) {
      currentIndex = viewIndex;
      return false;
    }
    return true;
  });
  return currentIndex;
};

/**
 * Moves slider depending on keyboard input.
 * @return {void}
 */
var handleButtonPress = function handleButtonPress(event, $el, $buttons, opts) {
  var $slides = $el.find("".concat(BASE_SELECTOR, "__item"));
  var key = __WEBPACK_IMPORTED_MODULE_4__keyboard__["a" /* default */].parseKey(event);
  if (key === 'ENTER' || key === 'SPACE' || event.type === 'click') {
    event.preventDefault();
    var $button = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(event.target);
    var currentIndex = getCurrentSlideIndex($el);
    var targetIndex;
    if (isRTL) {
      var hasPreviousClass = $button.hasClass('previous');
      if (hasPreviousClass) {
        targetIndex = Math.max(currentIndex - 1, 0);
      } else {
        targetIndex = Math.min(currentIndex + 1, $slides.length - 1);
      }
    } else {
      var _hasPreviousClass = $button.hasClass('previous');
      if (_hasPreviousClass) {
        targetIndex = currentIndex - 1;
      } else {
        targetIndex = currentIndex + 1;
      }
    }
    moveSlider(targetIndex, $el, $slides, opts);
  }
};
var onKeyDown = function onKeyDown($el, $a11yButtons, opts) {
  return $a11yButtons.on('keydown', function (evt) {
    return handleButtonPress(evt, $el, $a11yButtons, opts);
  });
};
var onClick = function onClick($el, $a11yButtons, opts) {
  return $a11yButtons.on('click', function (evt) {
    return handleButtonPress(evt, $el, $a11yButtons, opts);
  });
};
var onButtonFocus = function onButtonFocus($a11yButtons) {
  $a11yButtons.on('focus', function removeAriaHidden() {
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).attr('aria-hidden', false);
  });
};
var onButtonBlur = function onButtonBlur($a11yButtons) {
  $a11yButtons.on('blur', function addAriaHidden() {
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).attr('aria-hidden', true);
  });
};
var scrollTrackingEvent = function scrollTrackingEvent($el, opts) {
  return function () {
    var $image = $el.find('img');
    var imageIndexes = [];
    $image.each(function eachImage() {
      var $thisImage = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this);
      var imageIndex = $thisImage.closest('.horizontal-scroll__item').index();
      if (isInViewport($thisImage, $el)) {
        imageIndexes.push(imageIndex + 1);
      }
    });
    var carouselEvent = new CustomEvent('carouselChange');
    carouselEvent.tracking = {
      type: opts.type,
      currentSlide: imageIndexes[imageIndexes.length - 1],
      pageUrl: window.location.href,
      pageTitle: document.title,
      element: $el
    };
    window.dispatchEvent(carouselEvent);
  };
};
var onHorizontalScroll = function onHorizontalScroll($el, key, opts) {
  var trackingScroll = scrollTrackingEvent($el, opts);
  // event listener handles the displaying of images
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()($el).on("scroll.horizontalScroll-".concat(key), __WEBPACK_IMPORTED_MODULE_2_lodash_throttle___default()(function () {
    return showImage($el, opts, key);
  }, 200));
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()($el).on("scroll.horizontalScrollState-".concat(key), __WEBPACK_IMPORTED_MODULE_2_lodash_throttle___default()(function () {
    updateSlideState($el);
    updateButtonState($el, opts);
  }, 200));
  // event listener used to track marketing tracking numbers when the users scrolls.
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()($el).on("scroll.horizontalEventScroll-".concat(key), __WEBPACK_IMPORTED_MODULE_1_lodash_debounce___default()(trackingScroll, 500));
  // persist scroll position for back navigation
  if (opts.preserveScrollPosition) {
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()($el).on("scroll.horizontalScrollPosition-".concat(key), __WEBPACK_IMPORTED_MODULE_1_lodash_debounce___default()(function () {
      return saveScrollPosition($el, opts);
    }, 200));
  }
};
var addAccessibleCarousel = function addAccessibleCarousel($el, opts) {
  $el.data('currentSlideIndex', 0);
  wrapHorizontalScrollContent($el);
  updateSlideState($el);
  updateButtonState($el, opts);
};
var addEventListeners = function addEventListeners($el, key, opts) {
  var $a11yButtons = $el.closest(WRAPPER_SELECTOR).find('> button');
  onWindowScroll($el, opts, key);
  onHorizontalScroll($el, key, opts);
  onKeyDown($el, $a11yButtons, opts);
  onClick($el, $a11yButtons, opts);
  onButtonFocus($a11yButtons);
  onButtonBlur($a11yButtons);
};
var init = function init($el, opts) {
  // key - creates unique name for the event namespace, so it can be later disabled
  var key = "key-".concat(Math.ceil(Math.random() * 10000000000));
  $el.find('img[data-lazy]').addClass('horizontal-scroll__lazy-image');
  addAccessibleCarousel($el, opts);
  addEventListeners($el, key, opts);
  showImage($el, opts, key);
  if (opts.preserveScrollPosition) {
    restoreScrollPosition($el, opts);
    // save position when a nav link is clicked so the destination page can share it
    $el.on("click.horizontalScrollPosition-".concat(key), 'a', function () {
      return saveScrollPosition($el, opts);
    });
  }
};
function horizontalScroll(el) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var $el = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(el);
  var opts = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib_merge_options__["a" /* default */])(DEFAULTS, options, $el);
  var _showImages = init($el, opts);
  return {
    showImages: function showImages() {
      return _showImages();
    }
  };
}
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib_register_jquery_plugin__["a" /* default */])(PLUGIN_NAME, horizontalScroll);

/***/ }),
/* 115 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return BLOCK_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ImageCarousel; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_isUndefined__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_isUndefined___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_isUndefined__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__slick_arrow__ = __webpack_require__(314);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__slick_accessible__ = __webpack_require__(312);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lib_register_jquery_plugin__ = __webpack_require__(1);
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }






var BLOCK_NAME = 'image-carousel';

// When the slide is changing
function playPauseVideo(slick, control) {
  var currentSlide = slick.find('.slick-current');
  var slideType = currentSlide.find('.slick-slideshow__slide').data('media');
  var player = currentSlide.find('iframe').get(0) || currentSlide.find('video').get(0);
  if (slideType !== 'video' && slideType !== 'youtube') return;
  if (player !== null) {
    if (control === 'play') {
      player.play();
    } else {
      player.pause();
    }
  }
}
function renderVideoMarkup($slide, videoURL, posterURL) {
  var $anchor = $slide.find('a');
  var $video = $slide.find('video');
  if ($video.length === 0) {
    $video = __WEBPACK_IMPORTED_MODULE_0_jquery___default()("<video autoplay muted loop='loop' playsinline style=\"width: 68%;margin-left: auto;margin-right: auto;\" poster='".concat(posterURL, "'>\n      <source src='").concat(videoURL, "'>\n    </video>\n    "));
    if ($anchor.length > 0) {
      $anchor.append($video);
    } else {
      $slide.append($video);
    }
  }
  return $video;
}
function addMuteButton($slide, $video) {
  var video = $video[0];
  var muteButtonClass = 'js-video-mute-btn';
  var $muteButton = $video.find(".".concat(muteButtonClass));
  if ($muteButton.length > 0 || $slide.data('video-sound') === false) return;
  $muteButton = __WEBPACK_IMPORTED_MODULE_0_jquery___default()("\n    <button class='".concat(muteButtonClass, " u-color--white' style='position:absolute;bottom: 10px;right: 10px;background:transparent; padding: 10px;'>\n      <span class='js-mute-off icon icon--search icon--sm' style='display:none;'><svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 17.14 16'><path d='M17.13 7.69c-.03-.73-.14-1.43-.34-2.11-.17-.58-.4-1.13-.68-1.65 0-.01-.01-.02-.02-.04-.03-.06-.07-.12-.1-.18l-.18-.3c-.05-.07-.09-.14-.14-.21a8.468 8.468 0 0 0-3.9-3.12.832.832 0 0 0-.88.12c-.27.21-.4.48-.4.83 0 .17.05.33.14.48.1.14.23.25.4.31 1.27.51 2.29 1.32 3.06 2.43.28.4.51.82.68 1.26.23.58.38 1.19.44 1.83v.07c0 .05 0 .09.01.14v.92c0 .05 0 .09-.01.14v.07c-.06.64-.21 1.25-.44 1.83-.18.44-.41.86-.68 1.26-.24.35-.51.68-.81.97-.45.45-.97.82-1.54 1.13-.23.12-.47.23-.71.33-.17.06-.31.17-.4.31-.02.03-.03.06-.05.09v.02s0 .02-.01.03c-.05.1-.07.21-.07.32 0 .34.15.65.41.84.27.21.56.25.88.12.13-.05.27-.11.39-.17.34-.15.66-.32.96-.51.54-.34 1.04-.73 1.49-1.17.38-.38.73-.8 1.05-1.26.05-.07.09-.14.14-.21l.18-.3c.04-.06.07-.12.1-.18 0-.01.01-.02.02-.04.28-.52.51-1.07.68-1.65.2-.68.31-1.38.34-2.11v-.64Z' /><path d='M12.22 10.26c.17-.29.31-.58.41-.89.07-.21.13-.42.16-.63.04-.23.06-.46.06-.7v-.06c0-.24-.02-.47-.06-.7-.1-.54-.29-1.05-.57-1.52-.42-.7-1-1.22-1.75-1.57v7.65c.75-.35 1.33-.87 1.75-1.57ZM7.99 1.83c-.39-.17-.73-.1-1.04.2L4.76 4.22l-.95.95H.95c-.27 0-.5.09-.68.27S0 5.85 0 6.12v3.81c0 .27.09.5.27.68s.41.27.68.27h2.86l3.14 3.14c.3.3.65.37 1.04.2.39-.16.58-.46.58-.88V2.73c0-.43-.19-.73-.58-.89Z' /></svg></span>\n      <span class='js-mute-on icon icon--search icon--sm'><svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 17.17 16'><path d='M17.16 7.7c-.03-.73-.14-1.43-.34-2.11-.17-.58-.4-1.13-.68-1.65 0-.01-.01-.02-.02-.04-.03-.06-.07-.12-.1-.18l-.18-.3c-.05-.07-.09-.14-.14-.21A8.528 8.528 0 0 0 11.79.08a.83.83 0 0 0-.88.12c-.27.21-.4.48-.4.83 0 .17.05.33.14.48.1.14.23.25.4.31 1.27.51 2.29 1.32 3.07 2.43.28.4.51.82.68 1.26.23.58.38 1.19.44 1.83v.07c0 .05 0 .09.01.14v.92c0 .05 0 .09-.01.14v.07c-.06.64-.21 1.25-.44 1.83-.06.15-.14.3-.21.45L16 12.37l.03-.06c.04-.06.07-.12.1-.18 0-.01.01-.02.02-.04.28-.52.51-1.07.68-1.65.2-.68.31-1.38.34-2.11v-.64h-.01ZM12.81 8.75c.04-.23.06-.46.06-.7v-.06c0-.24-.02-.47-.06-.7-.1-.54-.29-1.05-.57-1.52-.42-.7-1-1.22-1.75-1.57v2.68l2.23 2.23c.03-.12.07-.24.09-.36ZM8.59 2.73c0-.43-.19-.73-.58-.89-.39-.18-.73-.11-1.04.19l-.66.66 2.28 2.28V2.73ZM1.76.32C1.37-.07.74-.07.35.32s-.39 1.02 0 1.42l3.44 3.44H.95c-.27 0-.5.09-.68.27-.18.18-.27.41-.27.68v3.82c0 .27.09.5.27.68s.41.27.68.27h2.87l3.15 3.15c.3.3.65.37 1.04.2.39-.16.58-.46.58-.88V9.98l5.73 5.73c.2.2.45.29.71.29s.51-.1.71-.29c.39-.39.39-1.03 0-1.42L1.76.32Z' /></svg></span>\n    </button>\n  "));
  var muteOn = $muteButton.find('.js-mute-on');
  var muteOff = $muteButton.find('.js-mute-off');
  $slide.append($muteButton);
  $muteButton.on('click', function () {
    if (video.muted) {
      video.muted = false;
      muteOn.hide();
      muteOff.show();
    } else {
      video.muted = true;
      muteOn.show();
      muteOff.hide();
    }
  });
}
function handleVideo($videoSlides) {
  __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.each($videoSlides, function (i, slide) {
    var $slide = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(slide);
    var videoURL = $slide.data('video');
    var posterURL = $slide.data('video-poster');
    var videoType;
    if (videoURL.toLowerCase().endsWith('.mp4')) {
      videoType = 'video';
    } else {
      videoType = 'unknown';
    }
    $slide.attr('data-media', videoType);
    var $video = renderVideoMarkup($slide, videoURL, posterURL);
    addMuteButton($slide, $video);
  });
}

/**
 * Wires up slick slider and provides hooks such that the internal can talk to
 * external functionality.
 */
var ImageCarousel = /*#__PURE__*/function () {
  /**
   * @constructor
   * @param {HTMLElement|string} el - Element (or a selector) containing the slider
   * @param {Object} options - Any additional options based along to the slider
   */
  function ImageCarousel(el) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    _classCallCheck(this, ImageCarousel);
    var $el = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(el);
    var _$el$data = $el.data(),
      nextArrowTitle = _$el$data.nextArrowTitle,
      previousArrowTitle = _$el$data.previousArrowTitle;
    var $videoSlides = $el.find('[data-video]');
    handleVideo($videoSlides);

    // Initialize
    $el.on('init', function (slick) {
      var $slick = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(slick.currentTarget);
      setTimeout(function () {
        return playPauseVideo($slick, 'play');
      }, 1000);
      var expectedMedia = [];
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#detailsMarkup .image-carousel .slick-slide').each(function findImages() {
        if (!__WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).hasClass('slick-cloned')) {
          var $img = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).find('img');
          var imageSrc = $img.attr('src');
          var videoSrc = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).find('[data-video]').data('video');
          if (imageSrc) {
            expectedMedia.push(imageSrc);
          } else if (videoSrc) {
            expectedMedia.push(videoSrc);
          }
        }
      });
      expectedMedia.forEach(function (value, index) {
        // if slide is video type, change the pagination to
        // show the play button instead of the default circle
        if (value.toLowerCase().endsWith('.mp4')) {
          __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.image-carousel__dots li').eq(index).children('.image-carousel__dot-button').addClass('image-carousel__dot-button--vid');
        }
      });
    });
    $el.on('beforeChange', function (event, slick) {
      var $slick = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(slick.$slider);
      playPauseVideo($slick, 'pause');
    });
    $el.on('afterChange', function (event, slick) {
      var $slick = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(slick.$slider);
      playPauseVideo($slick, 'play');
    });
    this.num = 0;
    this.$el = $el.slickAccessible(__WEBPACK_IMPORTED_MODULE_0_jquery___default.a.extend({
      lazyLoad: 'ondemand',
      dots: true,
      dotsClass: "".concat(BLOCK_NAME, "__dots"),
      appendDots: __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.product__image--dots-container').eq(0),
      infinite: true,
      nextArrow: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__slick_arrow__["a" /* default */])('next', nextArrowTitle, 'arrow-right'),
      prevArrow: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__slick_arrow__["a" /* default */])('previous', previousArrowTitle, 'arrow-left'),
      rtl: __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(window, 'rcProps.isRtl', false),
      touchThreshold: 20,
      accessibility: true
    }, options));
  }

  /**
   * Sets the active slider number for later use.
   * @param {number} currentNum - The number of the active slide
   */
  return _createClass(ImageCarousel, [{
    key: "setSlideNumber",
    value: function setSlideNumber(currentNum) {
      this.num = currentNum;
    }

    /**
     * Transitions or goes to the slide number based on the current state.
     */
  }, {
    key: "transitionSlide",
    value: function transitionSlide() {
      if (!__WEBPACK_IMPORTED_MODULE_2_lodash_isUndefined___default()(this.num)) {
        this.$el.slick('slickGoTo', this.num, false);
      }
    }
  }]);
}();

__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib_register_jquery_plugin__["a" /* default */])('imageCarousel', function (el, opts) {
  return new ImageCarousel(el, opts);
});

/***/ }),
/* 116 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__keyboard__ = __webpack_require__(3);


/*

Creates no focus on click events, but focuses when tabs

*/

var $html = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('html');
var focusClass = 'no-focus';
var focusActiveClass = 'focus-active';
/**
 * Tab Event
 * @param  {jQuery} html - html element
 * @param  {event} evt - key event
 */
var tabEventHandler = function tabEventHandler(html, evt) {
  if (__WEBPACK_IMPORTED_MODULE_1__keyboard__["a" /* default */].parseKey(evt) === 'TAB' || __WEBPACK_IMPORTED_MODULE_1__keyboard__["a" /* default */].parseKey(evt) === 'SHIFT_TAB') {
    html.removeClass(focusClass);
    html.addClass(focusActiveClass);
  }
};
var clickEventHandler = function clickEventHandler(html) {
  html.addClass(focusClass);
  html.removeClass(focusActiveClass);
};
var noFocus = function noFocus() {
  $html.addClass(focusClass);
  $html.on('mousedown.noFocus', function (evt) {
    return clickEventHandler($html, evt);
  });
  $html.on('keyup.noFocus', function (evt) {
    return tabEventHandler($html, evt);
  });
};
/* harmony default export */ __webpack_exports__["a"] = (noFocus);

/***/ }),
/* 117 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export EL_CLASS */
/* unused harmony export TEMPLATE_PREFIX */
/* harmony export (immutable) */ __webpack_exports__["a"] = showNotification;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_constants_pdp__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_get_template_html_by_id__ = __webpack_require__(112);
/**
 * Responsible for showing a product notification.
 * @module modules/productNotificationShow
 */




/**
 * Element class name
 * @type {string}
 */
var EL_CLASS = 'notification';

/**
 * Prefix used on the template's id
 * @type {string}
 */
var TEMPLATE_PREFIX = 'product-notifications';

/**
 * Choose the CTA based on attributes.
 * @private
 * @param {object} data - Product data object
 * @param {object} data.chosen - Selected product size, including relevant data
 * @return {string} Selected Id
 */
function getId(_ref) {
  var chosen = _ref.chosen;
  if (chosen['defect-disclaimer'] && !chosen['final-sale']) {
    return 'defect-not-final-sale';
  } else if (chosen['defect-disclaimer']) {
    return 'defect';
  } else if (chosen['final-sale']) {
    return 'final-sale';
  } else if (chosen.preorder) {
    return 'preorder';
  } else if (chosen['one-left']) {
    return 'one-left';
  } else if (chosen['sample-defect']) {
    return 'sample-defect';
  } else if (chosen['removed-item']) {
    return 'removed-item';
  }
  return '';
}

/**
 * Toggles Show/Hide for Delivery date
 * @private
 * @param {string} notification - selected notification
 */
function toggleDelivery(notification) {
  var $deliveryEl = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(".".concat(__WEBPACK_IMPORTED_MODULE_1__lib_constants_pdp__["a" /* PRODUCT_BLOCK */], "__").concat(__WEBPACK_IMPORTED_MODULE_1__lib_constants_pdp__["n" /* DELIVERY_DATE_BLOCK */]));
  var $stockEl = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(".".concat(__WEBPACK_IMPORTED_MODULE_1__lib_constants_pdp__["a" /* PRODUCT_BLOCK */], "__").concat(__WEBPACK_IMPORTED_MODULE_1__lib_constants_pdp__["o" /* STOCK_DATE_BLOCK */]));
  if (notification === 'preorder') {
    $deliveryEl.hide();
    $stockEl.show();
  } else {
    $deliveryEl.show();
    $stockEl.hide();
  }
}

/**
 * AB Test 1490
 * Toggles Show/Hide for List Link
 * @private
 * @param {string} notification - selected notification
 */
function toggleAddToList(notification) {
  var $myListLink = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(".".concat(__WEBPACK_IMPORTED_MODULE_1__lib_constants_pdp__["a" /* PRODUCT_BLOCK */], "__").concat(__WEBPACK_IMPORTED_MODULE_1__lib_constants_pdp__["p" /* ADD_TO_LIST_BLOCK */]));
  var hasAddMyListLink = $myListLink.length;
  if (hasAddMyListLink) {
    if (notification === 'preorder') {
      $myListLink.hide();
    } else {
      $myListLink.show();
    }
  }
}

/**
 * Default options for updateCTA
 * @type {object}
 * @prop {Function} getId - function to return the CTA id
 * @prop {Function} getTemplate - function to return the template
 */
var DEFAULT_OPTIONS = {
  getId: getId,
  getTemplate: __WEBPACK_IMPORTED_MODULE_2__lib_get_template_html_by_id__["a" /* default */]
};

/**
 * Show notification based on chosen option.
 * @param {object} data - Product data object
 * @param {HTMLElement} data.wrap - The .product wrap
 * @param {string} data.wrapBlockClass - Class of wrap HTML Element
 * @param {boolean} data.allOnSale - Whether all sizes are on sale
 * @see DEFAULT_OPTIONS
 * @return {jQuery} Updated element
 */
function showNotification(data) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var wrap = data.wrap,
    wrapBlockClass = data.wrapBlockClass;
  var _$$extend = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.extend({}, DEFAULT_OPTIONS, options),
    getIdFunc = _$$extend.getId,
    getTemplateFunc = _$$extend.getTemplate;

  // find the element
  var $el = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(wrap).find(".".concat(wrapBlockClass, "__").concat(EL_CLASS));
  if (!$el.length) {
    throw new Error("Element not found: .".concat(wrapBlockClass, "__").concat(EL_CLASS));
  }

  // get the proper html
  var id = getIdFunc(data);
  var html = id ? getTemplateFunc("".concat(TEMPLATE_PREFIX, ".").concat(id)) : '';
  if (data.chosen['inventory-disclaimer'] && html) {
    var disclaimerEl = html.querySelector('.inventory-disclaimer');
    if (disclaimerEl) {
      disclaimerEl.innerHTML = data.chosen['inventory-disclaimer'];
    }
  }
  // update the element
  $el.html(html);
  if (id !== 'one-left' && id !== 'preorder' && data.chosen['one-left']) {
    var oneLeftId = 'one-left';
    var oneLeftHtml = getTemplateFunc("".concat(TEMPLATE_PREFIX, ".").concat(oneLeftId));
    $el.append(oneLeftHtml);
  }
  if (id !== 'removed-item' && data.chosen['removed-item']) {
    var removedItemId = 'removed-item';
    var removedItemHtml = getTemplateFunc("".concat(TEMPLATE_PREFIX, ".").concat(removedItemId));
    $el.append(removedItemHtml);
  }
  if (id === 'final-sale' && data.chosen.preorder) {
    var preorderId = 'preorder';
    var preorderHtml = getTemplateFunc("".concat(TEMPLATE_PREFIX, ".").concat(preorderId));
    $el.append(preorderHtml);
    toggleDelivery(preorderId);
    toggleAddToList(preorderId);
  } else {
    toggleDelivery(id);
    toggleAddToList(id);
  }
  return $el;
}

/***/ }),
/* 118 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export VALUE */
/* unused harmony export UNAVAILABLE_ATTR */
/* unused harmony export HREF_ATTR */
/* unused harmony export SPECIAL_ORDER */
/* unused harmony export BACK_IN_STOCK */
/* unused harmony export CANT_FIND_YOUR_SIZE */
/* harmony export (immutable) */ __webpack_exports__["a"] = updateUnavailable;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/**
 * Updates the "unavailable" option href
 * @module modules/linkUnavailable
 */



/**
 * Value of the new option
 */
var VALUE = 'unavailable';

/**
 * Name of attribute used to declare the new option's text
 */
var UNAVAILABLE_ATTR = 'unavailable-text';

/**
 * Name of attribute containing the option's href
 */
var HREF_ATTR = 'href';

/**
 * Possible HREF's for the unavailable link
 */
var SPECIAL_ORDER = './special-order.html';
var BACK_IN_STOCK = './back-in-stock.html';
var CANT_FIND_YOUR_SIZE = './cant-find-your-size.html';

/**
 * HTML template containing the option
 * @private
 */
var template = function template(_ref) {
  var text = _ref.text,
    href = _ref.href;
  return "<option value=\"".concat(VALUE, "\" data-").concat(HREF_ATTR, "=\"").concat(href, "\">").concat(text, "</option>");
};

/**
 * Gets the proper href for the conditions
 * @private
 * @param {Object} data - Object representing product info
 * @return {String} The href to add to the option
 */
var getHref = function getHref(data) {
  var chosen = data.chosen,
    oneSize = data.oneSize,
    allInStock = data.allInStock;
  var isOnSale = chosen.isOnSale;

  // no link for only one size
  if (oneSize) {
    return '';
  }

  // when all sizes are in stock
  if (allInStock) {
    return isOnSale ? '' : SPECIAL_ORDER;
  }

  // default href based on whether all sizes are on sale
  return isOnSale ? BACK_IN_STOCK : CANT_FIND_YOUR_SIZE;
};

/**
 * Updates unavailable option
 * @param {Object} data - Object representing product info
 */
function updateUnavailable(data) {
  var sizeEl = data.sizeEl;
  var $sizeEl = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(sizeEl);

  // STOP if no unavailable attr
  var text = $sizeEl.data(UNAVAILABLE_ATTR);
  if (!text) {
    return;
  }

  // remove unavailable
  $sizeEl.find("option[value=\"".concat(VALUE, "\"]")).remove();

  // add unavailable with proper data-href
  var href = getHref(data);
  if (href) {
    sizeEl.insertAdjacentHTML('beforeend', template({
      text: text,
      href: href
    }));
  }
}

/***/ }),
/* 119 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export PLUGIN_NAME */
/* unused harmony export DEFAULTS */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SIDE_PANEL_HTML_ID; });
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_body_scroll_lock__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_body_scroll_lock___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_body_scroll_lock__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_styleguide_lib_merge_options__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_props__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__keyboard__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lib_register_jquery_plugin__ = __webpack_require__(1);
/**
 * Handles side panel
 * @module side-panel
 */







var PLUGIN_NAME = 'sidePanel';
var DEFAULTS = {
  url: '',
  onAjaxLoad: function onAjaxLoad() {},
  loadingText: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__lib_props__["a" /* get */])('rcProps.translations.sidePanel.loadingText', 'One moment please...'),
  loadingTextSR: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__lib_props__["a" /* get */])('rcProps.translations.sidePanel.loadingTextSR', 'Content is Loading'),
  returnFocus: '',
  trapFocusFunc: __WEBPACK_IMPORTED_MODULE_4__keyboard__["a" /* default */].trapFocus.bind(__WEBPACK_IMPORTED_MODULE_4__keyboard__["a" /* default */]),
  releaseFocusFunc: __WEBPACK_IMPORTED_MODULE_4__keyboard__["a" /* default */].releaseFocus.bind(__WEBPACK_IMPORTED_MODULE_4__keyboard__["a" /* default */]),
  openFilter: '' // AB937 - filter category to open
};
var SIDE_PANEL_HTML_ID = 'side-panel';

// AB937
// Opens the filter category in the side panel
var triggerOpenFilter = function triggerOpenFilter(filterCategoryName) {
  var $filterCategoryContent = __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#all".concat(filterCategoryName));
  var $filterButton = $filterCategoryContent.prev('button.accordion__label');
  $filterButton.trigger('click').trigger('focus');
};
var openSidePanelFocus = function openSidePanelFocus($el, opts) {
  if ($el.hasClass('side-panel--open')) {
    // Look for anchors, buttons, and elements with tabindex not set to -1
    var $firstElementToFocus = $el.find('button, a, [tabindex]:not([tabindex="-1"])').first();
    $firstElementToFocus[0].focus();
    opts.trapFocusFunc($el);
  }
};
var closeSidePanelFocus = function closeSidePanelFocus(opts) {
  opts.releaseFocusFunc(__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.side-panel'), __WEBPACK_IMPORTED_MODULE_0_jquery___default()(opts.returnFocus));
};
var closePanel = function closePanel($panel, $container, opts) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_body_scroll_lock__["clearAllBodyScrollLocks"])($panel[0]);
  $container.removeClass('side-panel--open');
  if (__WEBPACK_IMPORTED_MODULE_0_jquery___default()('#sortRefineBtn').length) {
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#sortRefineBtn').attr('aria-expanded', false);
    closeSidePanelFocus(opts);
  }
};
var getLoadingMessage = function getLoadingMessage(_ref) {
  var loadingText = _ref.loadingText,
    loadingTextSR = _ref.loadingTextSR;
  return __WEBPACK_IMPORTED_MODULE_0_jquery___default()("\n    <div class=\"nav__loading-screen u-center u-text--lg\">\n        <p class=\"u-margin-b--md\">".concat(loadingText, "</p>\n        <div class=\"progress-bar progress-bar--dark u-margin--center\">\n            <div class=\"u-screen-reader\">\n                ").concat(loadingTextSR, "\n            </div>\n        </div>\n    </div>\n"));
};
var inStockToggle = function inStockToggle() {
  // $($panel)
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).on('change', '#in-stock-ready-to-ship', function () {
    var isChecked = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).prop('checked');
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).attr('aria-checked', String(isChecked));
    if (isChecked) {
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).attr('checked', 'checked');
    } else {
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).removeAttr('checked');
    }
  });
};
var generateSidePanel = function generateSidePanel(opts) {
  var $container = __WEBPACK_IMPORTED_MODULE_0_jquery___default()("<div class=\"side-panel\" id=\"".concat(SIDE_PANEL_HTML_ID, "\" role=\"dialog\" aria-modal=\"true\" aria-labelledby=\"sortRefineBtn\" />"));
  var $overlay = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('<div class="side-panel__overlay" id="side-panel__overlay" />');
  var $panel = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('<div class="side-panel__panel" />');
  var $loadingMessage = getLoadingMessage(opts);
  $panel.append($loadingMessage);
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('body').append($container);
  $container.append($overlay);
  $container.append($panel);
  // AJAX
  __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.ajax({
    method: 'GET',
    url: opts.url
  }).done(function (content) {
    $panel.html(content);
    inStockToggle($panel);
    var $closeButtons = $panel.find('[side-panel-close]');
    $closeButtons.on('click', function () {
      return closePanel($panel, $container, opts);
    });
    opts.onAjaxLoad();
  });
};

/**
 * Initializes side panel.
 * @param {HTMLElement} el - button /element that opens side panel
 * @param {Object} options - Options used for wiring up the side panel
 * @see DEFAULTS
 */
function sidePanel(el) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var $button = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(el);
  var opts = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_styleguide_lib_merge_options__["a" /* default */])(DEFAULTS, options, $button);
  var openFilter = opts.openFilter;
  var $existingPanel = __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#".concat(SIDE_PANEL_HTML_ID));
  if ($existingPanel.length === 0) {
    generateSidePanel(opts);
  }
  var $overlay = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#side-panel__overlay');
  var $panel = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#side-panel__panel');
  var $container = $existingPanel.length > 0 ? $existingPanel : __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#".concat(SIDE_PANEL_HTML_ID)); // Re-select in case it was re-generated

  $overlay.on('click', function () {
    return closePanel($panel, $container, opts);
  });
  $button.on('click', function () {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_body_scroll_lock__["disableBodyScroll"])($panel[0]);
    $container.addClass('side-panel--open');
    $button.attr('aria-expanded', true);
    if (openFilter.length) {
      // AB937 - check if filter category is specified
      triggerOpenFilter(openFilter);
    }
    setTimeout(function () {
      openSidePanelFocus($container, opts);
    }, 400);
  });
}
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib_register_jquery_plugin__["a" /* default */])(PLUGIN_NAME, sidePanel);

/***/ }),
/* 120 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export DOT_CLASS */
/* harmony export (immutable) */ __webpack_exports__["a"] = customPaging;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);


/**
 * Defines the className of the dot button
 * @type {string}
 */
var DOT_CLASS = 'image-carousel__dot-button';

/**
 * Allows us to customize the "dot buttons"
 * @param {jQuery} $slides - slick slides (from slick)
 * @param {number} i - iterator, used to select current slide from $slides
 * @see DEFAULT_OPTIONS
 * @return {jQuery} "dot button"
 */
function customPaging(_ref, i) {
  var _this = this;
  var $slides = _ref.$slides;
  // try to get the slide's id to use in the link's href
  var id = $slides[i].id || '';
  var $button;
  if (id !== '') {
    $button = __WEBPACK_IMPORTED_MODULE_0_jquery___default()("<button data-focus-to=\"#".concat(id, "\" class=\"").concat(DOT_CLASS, "\">Image ").concat(i + 1, "\n    <span class=\"image-carousel__dots-active-text\">, currently selected</span>\n  </button>"));
  } else {
    $button = __WEBPACK_IMPORTED_MODULE_0_jquery___default()("<button class=\"".concat(DOT_CLASS, "\">Image ").concat(i + 1, "\n    <span class=\"image-carousel__dots-active-text\">, currently selected</span>\n  </button>"));
  }
  return $button.on('click', function (e) {
    e.preventDefault();
    var focusId = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(_this).data('focusTo');
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()(focusId).trigger('focus');
  });
}

/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = __webpack_require__(344)()
	? __webpack_require__(41).Symbol
	: __webpack_require__(349);


/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isSymbol = __webpack_require__(345);

module.exports = function (value) {
	if (!isSymbol(value)) throw new TypeError(value + " is not a symbol");
	return value;
};


/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

var baseCreate = __webpack_require__(45),
    baseLodash = __webpack_require__(78);

/**
 * The base constructor for creating `lodash` wrapper objects.
 *
 * @private
 * @param {*} value The value to wrap.
 * @param {boolean} [chainAll] Enable explicit method chain sequences.
 */
function LodashWrapper(value, chainAll) {
  this.__wrapped__ = value;
  this.__actions__ = [];
  this.__chain__ = !!chainAll;
  this.__index__ = 0;
  this.__values__ = undefined;
}

LodashWrapper.prototype = baseCreate(baseLodash.prototype);
LodashWrapper.prototype.constructor = LodashWrapper;

module.exports = LodashWrapper;


/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(19),
    root = __webpack_require__(4);

/* Built-in method references that are verified to be native. */
var Set = getNative(root, 'Set');

module.exports = Set;


/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

var MapCache = __webpack_require__(74),
    setCacheAdd = __webpack_require__(452),
    setCacheHas = __webpack_require__(453);

/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */
function SetCache(values) {
  var index = -1,
      length = values == null ? 0 : values.length;

  this.__data__ = new MapCache;
  while (++index < length) {
    this.add(values[index]);
  }
}

// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;

module.exports = SetCache;


/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(4);

/** Built-in value references. */
var Uint8Array = root.Uint8Array;

module.exports = Uint8Array;


/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(19),
    root = __webpack_require__(4);

/* Built-in method references that are verified to be native. */
var WeakMap = getNative(root, 'WeakMap');

module.exports = WeakMap;


/***/ }),
/* 128 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */
function arrayEach(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (iteratee(array[index], index, array) === false) {
      break;
    }
  }
  return array;
}

module.exports = arrayEach;


/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

var baseIndexOf = __webpack_require__(371);

/**
 * A specialized version of `_.includes` for arrays without support for
 * specifying an index to search from.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */
function arrayIncludes(array, value) {
  var length = array == null ? 0 : array.length;
  return !!length && baseIndexOf(array, value, 0) > -1;
}

module.exports = arrayIncludes;


/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

var baseTimes = __webpack_require__(139),
    isArguments = __webpack_require__(91),
    isArray = __webpack_require__(9),
    isBuffer = __webpack_require__(56),
    isIndex = __webpack_require__(50),
    isTypedArray = __webpack_require__(95);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  var isArr = isArray(value),
      isArg = !isArr && isArguments(value),
      isBuff = !isArr && !isArg && isBuffer(value),
      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? baseTimes(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (
           // Safari 9 has enumerable `arguments.length` in strict mode.
           key == 'length' ||
           // Node.js 0.10 has enumerable non-index properties on buffers.
           (isBuff && (key == 'offset' || key == 'parent')) ||
           // PhantomJS 2 has enumerable non-index properties on typed arrays.
           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
           // Skip index properties.
           isIndex(key, length)
        ))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = arrayLikeKeys;


/***/ }),
/* 131 */
/***/ (function(module, exports) {

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

module.exports = arrayPush;


/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

var baseAssignValue = __webpack_require__(77),
    eq = __webpack_require__(24);

/**
 * This function is like `assignValue` except that it doesn't assign
 * `undefined` values.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignMergeValue(object, key, value) {
  if ((value !== undefined && !eq(object[key], value)) ||
      (value === undefined && !(key in object))) {
    baseAssignValue(object, key, value);
  }
}

module.exports = assignMergeValue;


/***/ }),
/* 133 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseFindIndex(array, predicate, fromIndex, fromRight) {
  var length = array.length,
      index = fromIndex + (fromRight ? 1 : -1);

  while ((fromRight ? index-- : ++index < length)) {
    if (predicate(array[index], index, array)) {
      return index;
    }
  }
  return -1;
}

module.exports = baseFindIndex;


/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

var castPath = __webpack_require__(141),
    toKey = __webpack_require__(54);

/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */
function baseGet(object, path) {
  path = castPath(path, object);

  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[toKey(path[index++])];
  }
  return (index && index == length) ? object : undefined;
}

module.exports = baseGet;


/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

var arrayPush = __webpack_require__(131),
    isArray = __webpack_require__(9);

/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}

module.exports = baseGetAllKeys;


/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqualDeep = __webpack_require__(373),
    isObjectLike = __webpack_require__(10);

/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */
function baseIsEqual(value, other, bitmask, customizer, stack) {
  if (value === other) {
    return true;
  }
  if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
    return value !== value && other !== other;
  }
  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
}

module.exports = baseIsEqual;


/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

var baseMatches = __webpack_require__(382),
    baseMatchesProperty = __webpack_require__(383),
    identity = __webpack_require__(31),
    isArray = __webpack_require__(9),
    property = __webpack_require__(59);

/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */
function baseIteratee(value) {
  // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
  // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
  if (typeof value == 'function') {
    return value;
  }
  if (value == null) {
    return identity;
  }
  if (typeof value == 'object') {
    return isArray(value)
      ? baseMatchesProperty(value[0], value[1])
      : baseMatches(value);
  }
  return property(value);
}

module.exports = baseIteratee;


/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

var identity = __webpack_require__(31),
    metaMap = __webpack_require__(160);

/**
 * The base implementation of `setData` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to associate metadata with.
 * @param {*} data The metadata.
 * @returns {Function} Returns `func`.
 */
var baseSetData = !metaMap ? identity : function(func, data) {
  metaMap.set(func, data);
  return func;
};

module.exports = baseSetData;


/***/ }),
/* 139 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

module.exports = baseTimes;


/***/ }),
/* 140 */
/***/ (function(module, exports) {

/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function cacheHas(cache, key) {
  return cache.has(key);
}

module.exports = cacheHas;


/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

var isArray = __webpack_require__(9),
    isKey = __webpack_require__(87),
    stringToPath = __webpack_require__(461),
    toString = __webpack_require__(32);

/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */
function castPath(value, object) {
  if (isArray(value)) {
    return value;
  }
  return isKey(value, object) ? [value] : stringToPath(toString(value));
}

module.exports = castPath;


/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(4);

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined,
    allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;

/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */
function cloneBuffer(buffer, isDeep) {
  if (isDeep) {
    return buffer.slice();
  }
  var length = buffer.length,
      result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

  buffer.copy(result);
  return result;
}

module.exports = cloneBuffer;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(101)(module)))

/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

var cloneArrayBuffer = __webpack_require__(81);

/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */
function cloneTypedArray(typedArray, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}

module.exports = cloneTypedArray;


/***/ }),
/* 144 */
/***/ (function(module, exports) {

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * Creates an array that is the composition of partially applied arguments,
 * placeholders, and provided arguments into a single array of arguments.
 *
 * @private
 * @param {Array} args The provided arguments.
 * @param {Array} partials The arguments to prepend to those provided.
 * @param {Array} holders The `partials` placeholder indexes.
 * @params {boolean} [isCurried] Specify composing for a curried function.
 * @returns {Array} Returns the new array of composed arguments.
 */
function composeArgs(args, partials, holders, isCurried) {
  var argsIndex = -1,
      argsLength = args.length,
      holdersLength = holders.length,
      leftIndex = -1,
      leftLength = partials.length,
      rangeLength = nativeMax(argsLength - holdersLength, 0),
      result = Array(leftLength + rangeLength),
      isUncurried = !isCurried;

  while (++leftIndex < leftLength) {
    result[leftIndex] = partials[leftIndex];
  }
  while (++argsIndex < holdersLength) {
    if (isUncurried || argsIndex < argsLength) {
      result[holders[argsIndex]] = args[argsIndex];
    }
  }
  while (rangeLength--) {
    result[leftIndex++] = args[argsIndex++];
  }
  return result;
}

module.exports = composeArgs;


/***/ }),
/* 145 */
/***/ (function(module, exports) {

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * This function is like `composeArgs` except that the arguments composition
 * is tailored for `_.partialRight`.
 *
 * @private
 * @param {Array} args The provided arguments.
 * @param {Array} partials The arguments to append to those provided.
 * @param {Array} holders The `partials` placeholder indexes.
 * @params {boolean} [isCurried] Specify composing for a curried function.
 * @returns {Array} Returns the new array of composed arguments.
 */
function composeArgsRight(args, partials, holders, isCurried) {
  var argsIndex = -1,
      argsLength = args.length,
      holdersIndex = -1,
      holdersLength = holders.length,
      rightIndex = -1,
      rightLength = partials.length,
      rangeLength = nativeMax(argsLength - holdersLength, 0),
      result = Array(rangeLength + rightLength),
      isUncurried = !isCurried;

  while (++argsIndex < rangeLength) {
    result[argsIndex] = args[argsIndex];
  }
  var offset = argsIndex;
  while (++rightIndex < rightLength) {
    result[offset + rightIndex] = partials[rightIndex];
  }
  while (++holdersIndex < holdersLength) {
    if (isUncurried || argsIndex < argsLength) {
      result[offset + holders[holdersIndex]] = args[argsIndex++];
    }
  }
  return result;
}

module.exports = composeArgsRight;


/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

var arrayReduce = __webpack_require__(361),
    deburr = __webpack_require__(473),
    words = __webpack_require__(491);

/** Used to compose unicode capture groups. */
var rsApos = "['\u2019]";

/** Used to match apostrophes. */
var reApos = RegExp(rsApos, 'g');

/**
 * Creates a function like `_.camelCase`.
 *
 * @private
 * @param {Function} callback The function to combine each word.
 * @returns {Function} Returns the new compounder function.
 */
function createCompounder(callback) {
  return function(string) {
    return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
  };
}

module.exports = createCompounder;


/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

var composeArgs = __webpack_require__(144),
    composeArgsRight = __webpack_require__(145),
    countHolders = __webpack_require__(403),
    createCtor = __webpack_require__(47),
    createRecurry = __webpack_require__(148),
    getHolder = __webpack_require__(83),
    reorder = __webpack_require__(451),
    replaceHolders = __webpack_require__(53),
    root = __webpack_require__(4);

/** Used to compose bitmasks for function metadata. */
var WRAP_BIND_FLAG = 1,
    WRAP_BIND_KEY_FLAG = 2,
    WRAP_CURRY_FLAG = 8,
    WRAP_CURRY_RIGHT_FLAG = 16,
    WRAP_ARY_FLAG = 128,
    WRAP_FLIP_FLAG = 512;

/**
 * Creates a function that wraps `func` to invoke it with optional `this`
 * binding of `thisArg`, partial application, and currying.
 *
 * @private
 * @param {Function|string} func The function or method name to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {*} [thisArg] The `this` binding of `func`.
 * @param {Array} [partials] The arguments to prepend to those provided to
 *  the new function.
 * @param {Array} [holders] The `partials` placeholder indexes.
 * @param {Array} [partialsRight] The arguments to append to those provided
 *  to the new function.
 * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
 * @param {Array} [argPos] The argument positions of the new function.
 * @param {number} [ary] The arity cap of `func`.
 * @param {number} [arity] The arity of `func`.
 * @returns {Function} Returns the new wrapped function.
 */
function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
  var isAry = bitmask & WRAP_ARY_FLAG,
      isBind = bitmask & WRAP_BIND_FLAG,
      isBindKey = bitmask & WRAP_BIND_KEY_FLAG,
      isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG),
      isFlip = bitmask & WRAP_FLIP_FLAG,
      Ctor = isBindKey ? undefined : createCtor(func);

  function wrapper() {
    var length = arguments.length,
        args = Array(length),
        index = length;

    while (index--) {
      args[index] = arguments[index];
    }
    if (isCurried) {
      var placeholder = getHolder(wrapper),
          holdersCount = countHolders(args, placeholder);
    }
    if (partials) {
      args = composeArgs(args, partials, holders, isCurried);
    }
    if (partialsRight) {
      args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
    }
    length -= holdersCount;
    if (isCurried && length < arity) {
      var newHolders = replaceHolders(args, placeholder);
      return createRecurry(
        func, bitmask, createHybrid, wrapper.placeholder, thisArg,
        args, newHolders, argPos, ary, arity - length
      );
    }
    var thisBinding = isBind ? thisArg : this,
        fn = isBindKey ? thisBinding[func] : func;

    length = args.length;
    if (argPos) {
      args = reorder(args, argPos);
    } else if (isFlip && length > 1) {
      args.reverse();
    }
    if (isAry && ary < length) {
      args.length = ary;
    }
    if (this && this !== root && this instanceof wrapper) {
      fn = Ctor || createCtor(fn);
    }
    return fn.apply(thisBinding, args);
  }
  return wrapper;
}

module.exports = createHybrid;


/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

var isLaziable = __webpack_require__(431),
    setData = __webpack_require__(163),
    setWrapToString = __webpack_require__(165);

/** Used to compose bitmasks for function metadata. */
var WRAP_BIND_FLAG = 1,
    WRAP_BIND_KEY_FLAG = 2,
    WRAP_CURRY_BOUND_FLAG = 4,
    WRAP_CURRY_FLAG = 8,
    WRAP_PARTIAL_FLAG = 32,
    WRAP_PARTIAL_RIGHT_FLAG = 64;

/**
 * Creates a function that wraps `func` to continue currying.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {Function} wrapFunc The function to create the `func` wrapper.
 * @param {*} placeholder The placeholder value.
 * @param {*} [thisArg] The `this` binding of `func`.
 * @param {Array} [partials] The arguments to prepend to those provided to
 *  the new function.
 * @param {Array} [holders] The `partials` placeholder indexes.
 * @param {Array} [argPos] The argument positions of the new function.
 * @param {number} [ary] The arity cap of `func`.
 * @param {number} [arity] The arity of `func`.
 * @returns {Function} Returns the new wrapped function.
 */
function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
  var isCurry = bitmask & WRAP_CURRY_FLAG,
      newHolders = isCurry ? holders : undefined,
      newHoldersRight = isCurry ? undefined : holders,
      newPartials = isCurry ? partials : undefined,
      newPartialsRight = isCurry ? undefined : partials;

  bitmask |= (isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG);
  bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);

  if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) {
    bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
  }
  var newData = [
    func, bitmask, thisArg, newPartials, newHolders, newPartialsRight,
    newHoldersRight, argPos, ary, arity
  ];

  var result = wrapFunc.apply(undefined, newData);
  if (isLaziable(func)) {
    setData(result, newData);
  }
  result.placeholder = placeholder;
  return setWrapToString(result, func, bitmask);
}

module.exports = createRecurry;


/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(19);

var defineProperty = (function() {
  try {
    var func = getNative(Object, 'defineProperty');
    func({}, '', {});
    return func;
  } catch (e) {}
}());

module.exports = defineProperty;


/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

var SetCache = __webpack_require__(125),
    arraySome = __webpack_require__(362),
    cacheHas = __webpack_require__(140);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */
function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      arrLength = array.length,
      othLength = other.length;

  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  }
  // Check that cyclic values are equal.
  var arrStacked = stack.get(array);
  var othStacked = stack.get(other);
  if (arrStacked && othStacked) {
    return arrStacked == other && othStacked == array;
  }
  var index = -1,
      result = true,
      seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

  stack.set(array, other);
  stack.set(other, array);

  // Ignore non-index properties.
  while (++index < arrLength) {
    var arrValue = array[index],
        othValue = other[index];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, arrValue, index, other, array, stack)
        : customizer(arrValue, othValue, index, array, other, stack);
    }
    if (compared !== undefined) {
      if (compared) {
        continue;
      }
      result = false;
      break;
    }
    // Recursively compare arrays (susceptible to call stack limits).
    if (seen) {
      if (!arraySome(other, function(othValue, othIndex) {
            if (!cacheHas(seen, othIndex) &&
                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
              return seen.push(othIndex);
            }
          })) {
        result = false;
        break;
      }
    } else if (!(
          arrValue === othValue ||
            equalFunc(arrValue, othValue, bitmask, customizer, stack)
        )) {
      result = false;
      break;
    }
  }
  stack['delete'](array);
  stack['delete'](other);
  return result;
}

module.exports = equalArrays;


/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

module.exports = freeGlobal;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(100)))

/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetAllKeys = __webpack_require__(135),
    getSymbols = __webpack_require__(85),
    keys = __webpack_require__(20);

/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeys(object) {
  return baseGetAllKeys(object, keys, getSymbols);
}

module.exports = getAllKeys;


/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

var metaMap = __webpack_require__(160),
    noop = __webpack_require__(97);

/**
 * Gets metadata for `func`.
 *
 * @private
 * @param {Function} func The function to query.
 * @returns {*} Returns the metadata for `func`.
 */
var getData = !metaMap ? noop : function(func) {
  return metaMap.get(func);
};

module.exports = getData;


/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

var arrayPush = __webpack_require__(131),
    getPrototype = __webpack_require__(84),
    getSymbols = __webpack_require__(85),
    stubArray = __webpack_require__(170);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own and inherited enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
  var result = [];
  while (object) {
    arrayPush(result, getSymbols(object));
    object = getPrototype(object);
  }
  return result;
};

module.exports = getSymbolsIn;


/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

var castPath = __webpack_require__(141),
    isArguments = __webpack_require__(91),
    isArray = __webpack_require__(9),
    isIndex = __webpack_require__(50),
    isLength = __webpack_require__(93),
    toKey = __webpack_require__(54);

/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */
function hasPath(object, path, hasFunc) {
  path = castPath(path, object);

  var index = -1,
      length = path.length,
      result = false;

  while (++index < length) {
    var key = toKey(path[index]);
    if (!(result = object != null && hasFunc(object, key))) {
      break;
    }
    object = object[key];
  }
  if (result || ++index != length) {
    return result;
  }
  length = object == null ? 0 : object.length;
  return !!length && isLength(length) && isIndex(key, length) &&
    (isArray(object) || isArguments(object));
}

module.exports = hasPath;


/***/ }),
/* 156 */
/***/ (function(module, exports) {

/** Used to compose unicode character classes. */
var rsAstralRange = '\\ud800-\\udfff',
    rsComboMarksRange = '\\u0300-\\u036f',
    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
    rsComboSymbolsRange = '\\u20d0-\\u20ff',
    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
    rsVarRange = '\\ufe0e\\ufe0f';

/** Used to compose unicode capture groups. */
var rsZWJ = '\\u200d';

/** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboRange + rsVarRange + ']');

/**
 * Checks if `string` contains Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a symbol is found, else `false`.
 */
function hasUnicode(string) {
  return reHasUnicode.test(string);
}

module.exports = hasUnicode;


/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

var baseCreate = __webpack_require__(45),
    getPrototype = __webpack_require__(84),
    isPrototype = __webpack_require__(51);

/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneObject(object) {
  return (typeof object.constructor == 'function' && !isPrototype(object))
    ? baseCreate(getPrototype(object))
    : {};
}

module.exports = initCloneObject;


/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(7);

/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */
function isStrictComparable(value) {
  return value === value && !isObject(value);
}

module.exports = isStrictComparable;


/***/ }),
/* 159 */
/***/ (function(module, exports) {

/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function matchesStrictComparable(key, srcValue) {
  return function(object) {
    if (object == null) {
      return false;
    }
    return object[key] === srcValue &&
      (srcValue !== undefined || (key in Object(object)));
  };
}

module.exports = matchesStrictComparable;


/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

var WeakMap = __webpack_require__(127);

/** Used to store function metadata. */
var metaMap = WeakMap && new WeakMap;

module.exports = metaMap;


/***/ }),
/* 161 */
/***/ (function(module, exports) {

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

module.exports = overArg;


/***/ }),
/* 162 */
/***/ (function(module, exports) {

/**
 * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function safeGet(object, key) {
  if (key === 'constructor' && typeof object[key] === 'function') {
    return;
  }

  if (key == '__proto__') {
    return;
  }

  return object[key];
}

module.exports = safeGet;


/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

var baseSetData = __webpack_require__(138),
    shortOut = __webpack_require__(166);

/**
 * Sets metadata for `func`.
 *
 * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
 * period of time, it will trip its breaker and transition to an identity
 * function to avoid garbage collection pauses in V8. See
 * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
 * for more details.
 *
 * @private
 * @param {Function} func The function to associate metadata with.
 * @param {*} data The metadata.
 * @returns {Function} Returns `func`.
 */
var setData = shortOut(baseSetData);

module.exports = setData;


/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

var baseSetToString = __webpack_require__(390),
    shortOut = __webpack_require__(166);

/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var setToString = shortOut(baseSetToString);

module.exports = setToString;


/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

var getWrapDetails = __webpack_require__(420),
    insertWrapDetails = __webpack_require__(429),
    setToString = __webpack_require__(164),
    updateWrapDetails = __webpack_require__(465);

/**
 * Sets the `toString` method of `wrapper` to mimic the source of `reference`
 * with wrapper details in a comment at the top of the source body.
 *
 * @private
 * @param {Function} wrapper The function to modify.
 * @param {Function} reference The reference function.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @returns {Function} Returns `wrapper`.
 */
function setWrapToString(wrapper, reference, bitmask) {
  var source = (reference + '');
  return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
}

module.exports = setWrapToString;


/***/ }),
/* 166 */
/***/ (function(module, exports) {

/** Used to detect hot functions by number of calls within a span of milliseconds. */
var HOT_COUNT = 800,
    HOT_SPAN = 16;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeNow = Date.now;

/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */
function shortOut(func) {
  var count = 0,
      lastCalled = 0;

  return function() {
    var stamp = nativeNow(),
        remaining = HOT_SPAN - (stamp - lastCalled);

    lastCalled = stamp;
    if (remaining > 0) {
      if (++count >= HOT_COUNT) {
        return arguments[0];
      }
    } else {
      count = 0;
    }
    return func.apply(undefined, arguments);
  };
}

module.exports = shortOut;


/***/ }),
/* 167 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var funcProto = Function.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

module.exports = toSource;


/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

var baseFindIndex = __webpack_require__(133),
    baseIteratee = __webpack_require__(137),
    toInteger = __webpack_require__(98);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * This method is like `_.find` except that it returns the index of the first
 * element `predicate` returns truthy for instead of the element itself.
 *
 * @static
 * @memberOf _
 * @since 1.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=0] The index to search from.
 * @returns {number} Returns the index of the found element, else `-1`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'active': false },
 *   { 'user': 'fred',    'active': false },
 *   { 'user': 'pebbles', 'active': true }
 * ];
 *
 * _.findIndex(users, function(o) { return o.user == 'barney'; });
 * // => 0
 *
 * // The `_.matches` iteratee shorthand.
 * _.findIndex(users, { 'user': 'fred', 'active': false });
 * // => 1
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.findIndex(users, ['active', false]);
 * // => 0
 *
 * // The `_.property` iteratee shorthand.
 * _.findIndex(users, 'active');
 * // => 2
 */
function findIndex(array, predicate, fromIndex) {
  var length = array == null ? 0 : array.length;
  if (!length) {
    return -1;
  }
  var index = fromIndex == null ? 0 : toInteger(fromIndex);
  if (index < 0) {
    index = nativeMax(length + index, 0);
  }
  return baseFindIndex(array, baseIteratee(predicate, 3), index);
}

module.exports = findIndex;


/***/ }),
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(16),
    isArray = __webpack_require__(9),
    isObjectLike = __webpack_require__(10);

/** `Object#toString` result references. */
var stringTag = '[object String]';

/**
 * Checks if `value` is classified as a `String` primitive or object.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a string, else `false`.
 * @example
 *
 * _.isString('abc');
 * // => true
 *
 * _.isString(1);
 * // => false
 */
function isString(value) {
  return typeof value == 'string' ||
    (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
}

module.exports = isString;


/***/ }),
/* 170 */
/***/ (function(module, exports) {

/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray() {
  return [];
}

module.exports = stubArray;


/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

var toNumber = __webpack_require__(172);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0,
    MAX_INTEGER = 1.7976931348623157e+308;

/**
 * Converts `value` to a finite number.
 *
 * @static
 * @memberOf _
 * @since 4.12.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted number.
 * @example
 *
 * _.toFinite(3.2);
 * // => 3.2
 *
 * _.toFinite(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toFinite(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toFinite('3.2');
 * // => 3.2
 */
function toFinite(value) {
  if (!value) {
    return value === 0 ? value : 0;
  }
  value = toNumber(value);
  if (value === INFINITY || value === -INFINITY) {
    var sign = (value < 0 ? -1 : 1);
    return sign * MAX_INTEGER;
  }
  return value === value ? value : 0;
}

module.exports = toFinite;


/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

var baseTrim = __webpack_require__(393),
    isObject = __webpack_require__(7),
    isSymbol = __webpack_require__(57);

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = baseTrim(value);
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = toNumber;


/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ES3 safe
var _undefined = void 0;

module.exports = function (value) { return value !== _undefined && value !== null; };


/***/ }),
/* 174 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_modules_smart_banner__ = __webpack_require__(245);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_modules_email_sign_up__ = __webpack_require__(238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__fixed_corner__ = __webpack_require__(210);




function emailSignUp() {
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#email_signup_form').on('submit', __WEBPACK_IMPORTED_MODULE_2_modules_email_sign_up__["a" /* default */].eventHandler);
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#email-signup-target').on('click', __WEBPACK_IMPORTED_MODULE_2_modules_email_sign_up__["a" /* default */].eventHandler);
}
function initModalEventListeners() {
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-view-country-preferences').click(function (e) {
    e.preventDefault();
    var url = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).data("ajaxUrl");
    __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.modal({
      url: url,
      type: 'full',
      triggerOpen: true,
      returnFocus: '.js-view-country-preferences'
    });
  });
}
__WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).ready(function () {
  // Don't show smart banner on mobile
  if (__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.co_rev_logo').length === 0 && __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.checkout-header__nav-container').length === 0) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_modules_smart_banner__["a" /* default */])({
      title: 'REVOLVEClothing',
      author: 'Eminent, Inc.',
      appendToSelector: '#home',
      icon: '//is4.revolveassets.com/r/i/logo-mobile.png'
    });
  }
  emailSignUp();
  initModalEventListeners();
});

/***/ }),
/* 175 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_get__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_modules_lazyload_image__ = __webpack_require__(241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_styleguide_modules_slick_carousel__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_styleguide_modules_slick_carousel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_styleguide_modules_slick_carousel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_modules_input_suggestion__ = __webpack_require__(240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_web_vitals__ = __webpack_require__(504);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_modules_shop_the_look__ = __webpack_require__(244);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__directives__ = __webpack_require__(209);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__directives___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__directives__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_modules_state_search__ = __webpack_require__(246);
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }








var updateClsCookieObject = function updateClsCookieObject(key, prop) {
  try {
    var banner = JSON.parse(getCookie('cls') || "{}");
    banner[key] = prop;
    setCookie('cls', JSON.stringify(banner), 2);
  } catch (error) {
    console.log(error);
  }
};
var addToGlobal = function addToGlobal() {
  for (var _len = arguments.length, propTuple = new Array(_len), _key = 0; _key < _len; _key++) {
    propTuple[_key] = arguments[_key];
  }
  propTuple.forEach(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
      name = _ref2[0],
      value = _ref2[1];
    window[name] = value;
  });
};
addToGlobal(['getLCP', __WEBPACK_IMPORTED_MODULE_4_web_vitals__["a" /* getLCP */]], ['getCLS', __WEBPACK_IMPORTED_MODULE_4_web_vitals__["b" /* getCLS */]], ['onINP', __WEBPACK_IMPORTED_MODULE_4_web_vitals__["c" /* onINP */]], ['updateClsCookieObject', updateClsCookieObject]);
$(document).ready(function () {
  $('.typeahead_il').inputSuggestion();
  $('.typeahead_kw').inputSuggestion();
  initSideNavigation();
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_modules_shop_the_look__["a" /* default */])();
  $('.js-state-search').stateSearch();
});
function initSideNavigation() {
  if ($('#richnav-wrapper').length) {
    $.ajax({
      type: "GET",
      url: '/r/mobile/sidebarNav.jsp?refURL=' + window.rcProps.loginURL,
      success: function success(html) {
        $('#richnav-wrapper').empty().append(html);
        $('#js-rich-nav').richNav();
        $('.js-accordion').accordion();
        $('.js-switch-class').switchClass();
      }
    });
  }
}

/**
 *
 * @param url
 * @param module
 * @param action
 * @param params - appends key-value pairs to URL as query parameters for tracking purposes.
 * @returns {string}
 */
window.logEngagement = function logEngagement(url, module, action, params) {
  if (params) {
    url += (url.indexOf('?') >= 0 ? '&' : '?') + $.param(params);
  }
  $.ajax({
    type: 'POST',
    data: $.param({
      url: url,
      module: module,
      action: action
    }),
    url: '/r/ajax/LogEngagement.jsp'
  });
};

/**
 * Logs engagement to engagement_tracking with details column data
 * @param url - string
 * @param module - string
 * @param action - string
 * @param details - string
 */
window.logEngagementWithDetails = function logEngagementWithDetails(url, module, action, details) {
  $.ajax({
    type: 'POST',
    data: $.param({
      url: url,
      module: module,
      action: action,
      details: details
    }),
    url: '/r/ajax/LogEngagement.jsp'
  });
};

/**
 * Logs engagement to engagement_tracking with details column data
 * @param url - string
 * @param module - string
 * @param action - string
 * @param details - string
 * @param params - appends key-value pairs to URL as query parameters for tracking purposes.
 */
window.logEngagementWithDetailsAndParams = function logEngagementWithDetailsAndParams(url, module, action, details, params) {
  if (params) {
    url += (url.indexOf('?') >= 0 ? '&' : '?') + $.param(params);
  }
  $.ajax({
    type: 'POST',
    data: $.param({
      url: url,
      module: module,
      action: action,
      details: details
    }),
    url: '/r/ajax/LogEngagement.jsp'
  });
};

// Global Lodash
window.lodash = {
  get: __WEBPACK_IMPORTED_MODULE_0_lodash_get___default.a
};

/***/ }),
/* 176 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_modules_toggle_visibility__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__header_logout__ = __webpack_require__(211);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_modules_logout__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_modules_search__ = __webpack_require__(243);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_modules_revolve_me_popup__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_modules_heart_product__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__load_favorite_count__ = __webpack_require__(212);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__load_shopping_bag_count__ = __webpack_require__(213);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_modules_page_constrain__ = __webpack_require__(242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_modules_fixed_overlay__ = __webpack_require__(239);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_styleguide_modules_slick_carousel__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_styleguide_modules_slick_carousel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_styleguide_modules_slick_carousel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_modules_validate_zip_code__ = __webpack_require__(247);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_body_scroll_lock__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_body_scroll_lock___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_body_scroll_lock__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_cropperjs__ = __webpack_require__(331);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_cropperjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_cropperjs__);
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _wrapNativeSuper(t) { var r = "function" == typeof Map ? new Map() : void 0; return _wrapNativeSuper = function _wrapNativeSuper(t) { if (null === t || !_isNativeFunction(t)) return t; if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function"); if (void 0 !== r) { if (r.has(t)) return r.get(t); r.set(t, Wrapper); } function Wrapper() { return _construct(t, arguments, _getPrototypeOf(this).constructor); } return Wrapper.prototype = Object.create(t.prototype, { constructor: { value: Wrapper, enumerable: !1, writable: !0, configurable: !0 } }), _setPrototypeOf(Wrapper, t); }, _wrapNativeSuper(t); }
function _construct(t, e, r) { if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments); var o = [null]; o.push.apply(o, e); var p = new (t.bind.apply(t, o))(); return r && _setPrototypeOf(p, r.prototype), p; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _isNativeFunction(t) { try { return -1 !== Function.toString.call(t).indexOf("[native code]"); } catch (n) { return "function" == typeof t; } }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }















function fixedOverlay() {
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-fixed-overlay').fixedOverlay();
}
function categoryNav() {
  var $pageHeaderOverlay = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(".js-page-header-categories-overlay");
  var $pageHeaderTitle = __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#nav-categories");
  $pageHeaderOverlay.on("click", function () {
    $pageHeaderTitle.click();
  });
}
function clickToLogoutFromHeader() {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__header_logout__["a" /* default */])('#js-header-logout');
}
function toggleRevolveMenu() {
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#tr-burger-icon').on('click', function (e) {
    e.preventDefault();
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_modules_toggle_visibility__["a" /* default */])('js-top-navigation');
  });
}
function initSearch() {
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#tr_top_search_btn, #js-site-search-close').on('click', function (e) {
    e.preventDefault();
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_modules_toggle_visibility__["a" /* default */])('js-site-search');
  });
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()(".js-site-search__textbox").removeClass('site-search__textbox--preload');
  __WEBPACK_IMPORTED_MODULE_4_modules_search__["a" /* default */].init();
  // return new Search('#search_term');
}
function loadFavPopups() {
  var $favoritePopupDiv = __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#myFavLimitPopupWrapper");
  if ($favoritePopupDiv.length) {
    __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.ajax({
      type: 'GET',
      url: '/content/favorites/fav-max-popup-markup',
      success: function success(data) {
        $favoritePopupDiv.empty().append(data);
      },
      failure: function failure() {}
    });
  }
}
function toggleFeaturedShopsMenu() {
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#js-featured-menu-button').on('click', function (e) {
    e.preventDefault();
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).toggleClass('is-active');
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_modules_toggle_visibility__["a" /* default */])('featured-shops-list');
  });
}
function validateZipCode(selector) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12_modules_validate_zip_code__["a" /* default */])(selector);
}
window.initMobileHp = function () {
  window.resetLazyLoad();
  // setupHomeSlideshow();
  toggleFeaturedShopsMenu();
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_modules_revolve_me_popup__["a" /* default */])();
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-lazyload-image').lazyLoadImage();
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-featured-slides').slick({
    arrows: false,
    infinite: false,
    mobileFirst: true,
    slidesToShow: 1.5,
    slidesToScroll: 1,
    lazyLoad: 'progressive',
    accessibility: false,
    touchThreshold: 20
  });
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-toggle-display').toggleDisplay();
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-category-menu').categoryMenu();
};
function initMobileSiteHeader() {
  __WEBPACK_IMPORTED_MODULE_7__load_favorite_count__["a" /* default */].then(function (data) {
    var favoritesTotal = data.total > 99 ? "99+" : data.total;
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#tr_top_heart_mhp_count').empty().append(favoritesTotal);
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#tr_top_heart_mhp_count').attr('data-count', data.total);
    if (data.total === 0) {
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.fav-count--ab').hide();
    } else {
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.fav-count--ab').show();
    }
    var labelText = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#tr_top_heart_mhp').attr('aria-label');
    if (typeof labelText !== 'undefined') {
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#tr_top_heart_mhp').attr('aria-label', labelText.replace('{0}', data.total));
    }
  });
  __WEBPACK_IMPORTED_MODULE_8__load_shopping_bag_count__["a" /* default */].then(function (data) {
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#shopping_bag_count').empty().append(data.itemCount);
    if (data.itemCount === 0) {
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.bag-count--ab').hide();
    } else {
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.bag-count--ab').show();
    }
    var labelText = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#tr_top_bag_mhp').attr('aria-label');
    if (typeof labelText !== 'undefined') {
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#tr_top_bag_mhp').attr('aria-label', labelText.replace('{0}', data.itemCount));
    }
  });
}
var MAX_IMAGE_SEARCH_EDGE = 1024;
var IMAGE_SEARCH_JPEG_QUALITY = 0.8;
var IMAGE_SEARCH_DEFAULT_POLL_TIMEOUT_SECONDS = 20;
var MAX_SEARCH_IMAGE_UPLOAD_BYTES = 5 * 1024 * 1024; // 5MB
var MAX_IMAGE_URL_FETCH_BYTES = 10 * 1024 * 1024; // 10MB, to prevent fetching excessively large images from URL
var DEFAULT_IMAGE_SEARCH_FILE_NAME = 'image-search.jpg';
var MAX_ORIGINAL_FILE_NAME_LENGTH = 45;
var MAX_UPLOAD_IMAGE_RETRIES = 2;
var UPLOAD_IMAGE_RETRIES_DELAY_MS = 1000;
var MAX_STATUS_CHECK_RETRIES = 1;
var STATUS_CHECK_RETRY_DELAY_MS = 500;
var isImageSearchRunning = false;
var isImagePreparing = false;
var cropImageObjectUrl = null;
var ImageSearchErrorCode = Object.freeze({
  UNKNOWN: 100,
  // validation
  INVALID_IMAGE: 101,
  INVALID_IMAGE_DIMENSION: 102,
  IMAGE_TOO_LARGE: 103,
  // processing
  IMAGE_READ_FAILED: 104,
  IMAGE_ENCODE_FAILED: 105,
  CANVAS_NOT_SUPPORTED: 106,
  // upload
  UPLOAD_FAILED: 201,
  MISSING_EVENT_ID: 202,
  // polling
  STATUS_CHECK_FAILED: 301,
  INVALID_JSON_RESPONSE: 302,
  INVALID_RETRY_VALUE: 303,
  INVALID_RETRY_NON_POSITIVE: 304,
  TIMEOUT: 305,
  // url
  INVALID_URL: 401,
  URL_FETCH_FAILED: 402,
  URL_NOT_IMAGE: 403
});
var ImageSearchError = /*#__PURE__*/function (_Error) {
  function ImageSearchError(code, message, details) {
    var _this;
    _classCallCheck(this, ImageSearchError);
    _this = _callSuper(this, ImageSearchError, [message || "Image search failed, error=".concat(code)]);
    _this.code = code;
    _this.details = details;
    _this.name = 'ImageSearchError';
    return _this;
  }
  _inherits(ImageSearchError, _Error);
  return _createClass(ImageSearchError);
}(/*#__PURE__*/_wrapNativeSuper(Error));
function getImageSearchErrorMessage(err) {
  var code = err && err.code ? err.code : ImageSearchErrorCode.UNKNOWN;
  return "Image search failed, error=".concat(code);
}
function showImageSearchError(message, details) {
  var finalMessage = message || "Image search failed, error=".concat(ImageSearchErrorCode.UNKNOWN);
  if (details) {
    finalMessage += "\nDetails: ".concat(details);
  }
  alert(finalMessage);
}

// sleep during image search polling interval
function imageSearchSleep(ms) {
  return new Promise(function (resolve) {
    setTimeout(resolve, ms);
  });
}

// Decode a File/Blob into something canvas.drawImage() can use.
// Prefer createImageBitmap for performance; fall back to <img> for compatibility.
function loadImageBitmapOrFallback(_x) {
  return _loadImageBitmapOrFallback.apply(this, arguments);
}
/*
 * Preprocess image before upload:
 * - resize the longest edge to <= 1024px
 * - preserve aspect ratio
 * - re-encode as JPEG quality 0.8
 * - strip EXIF metadata by redrawing via canvas
 * - reject if processed file is still > 5MB
 */
function _loadImageBitmapOrFallback() {
  _loadImageBitmapOrFallback = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(sourceFileOrBlob) {
    var objectUrl, _t5;
    return _regenerator().w(function (_context4) {
      while (1) switch (_context4.p = _context4.n) {
        case 0:
          if (!window.createImageBitmap) {
            _context4.n = 4;
            break;
          }
          _context4.p = 1;
          _context4.n = 2;
          return createImageBitmap(sourceFileOrBlob);
        case 2:
          return _context4.a(2, _context4.v);
        case 3:
          _context4.p = 3;
          _t5 = _context4.v;
          throw new ImageSearchError(ImageSearchErrorCode.IMAGE_READ_FAILED, null, 'createImageBitmap failed');
        case 4:
          objectUrl = URL.createObjectURL(sourceFileOrBlob);
          return _context4.a(2, new Promise(function (resolve, reject) {
            var image = new Image();
            function cleanup() {
              image.onload = null;
              image.onerror = null;
              URL.revokeObjectURL(objectUrl);
            }
            image.onload = function () {
              cleanup();
              resolve(image);
            };
            image.onerror = function () {
              cleanup();
              reject(new ImageSearchError(ImageSearchErrorCode.IMAGE_READ_FAILED, null, 'image load failed'));
            };
            image.src = objectUrl;
          }));
      }
    }, _callee4, null, [[1, 3]]);
  }));
  return _loadImageBitmapOrFallback.apply(this, arguments);
}
function prepareImageForUpload(_x2, _x3) {
  return _prepareImageForUpload.apply(this, arguments);
}
function _prepareImageForUpload() {
  _prepareImageForUpload = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5(sourceFileOrBlob, onErrorMessage) {
    var showMessage, img, width, height, longestEdge, scale, canvas, ctx, jpegBlob, _t6, _t7, _t8;
    return _regenerator().w(function (_context5) {
      while (1) switch (_context5.p = _context5.n) {
        case 0:
          showMessage = function _showMessage(msg) {
            if (typeof onErrorMessage === 'function') {
              onErrorMessage(msg);
            } else {
              console.log(msg);
            }
          };
          if (!(!sourceFileOrBlob || !sourceFileOrBlob.type || !sourceFileOrBlob.type.startsWith('image/'))) {
            _context5.n = 1;
            break;
          }
          showMessage('Please choose a valid image.');
          return _context5.a(2, null);
        case 1:
          img = null;
          _context5.p = 2;
          _context5.n = 3;
          return loadImageBitmapOrFallback(sourceFileOrBlob);
        case 3:
          img = _context5.v;
          width = img.width;
          height = img.height;
          if (!(!width || !height)) {
            _context5.n = 4;
            break;
          }
          showMessage('Invalid image dimensions.');
          return _context5.a(2, null);
        case 4:
          longestEdge = Math.max(width, height);
          if (longestEdge > MAX_IMAGE_SEARCH_EDGE) {
            scale = MAX_IMAGE_SEARCH_EDGE / longestEdge;
            width = Math.max(1, Math.round(width * scale));
            height = Math.max(1, Math.round(height * scale));
          }
          canvas = document.createElement('canvas');
          canvas.width = width;
          canvas.height = height;
          ctx = canvas.getContext('2d');
          if (ctx) {
            _context5.n = 5;
            break;
          }
          showMessage('Browser does not support image processing.');
          return _context5.a(2, null);
        case 5:
          _context5.p = 5;
          ctx.drawImage(img, 0, 0, width, height);
          _context5.n = 7;
          break;
        case 6:
          _context5.p = 6;
          _t6 = _context5.v;
          showMessage("Image search failed, error=".concat(ImageSearchErrorCode.IMAGE_READ_FAILED));
          return _context5.a(2, null);
        case 7:
          _context5.p = 7;
          _context5.n = 8;
          return new Promise(function (resolve, reject) {
            try {
              canvas.toBlob(function (blob) {
                if (!blob) {
                  reject(new ImageSearchError(ImageSearchErrorCode.IMAGE_ENCODE_FAILED, null, 'canvas.toBlob returned null'));
                  return;
                }
                resolve(blob);
              }, 'image/jpeg', IMAGE_SEARCH_JPEG_QUALITY);
            } catch (err) {
              reject(new ImageSearchError(ImageSearchErrorCode.IMAGE_ENCODE_FAILED, null, 'canvas.toBlob threw exception'));
            }
          });
        case 8:
          jpegBlob = _context5.v;
          _context5.n = 10;
          break;
        case 9:
          _context5.p = 9;
          _t7 = _context5.v;
          showMessage(_t7 && _t7.message ? _t7.message : "Image search failed, error=".concat(ImageSearchErrorCode.IMAGE_ENCODE_FAILED));
          return _context5.a(2, null);
        case 10:
          if (!(jpegBlob.size > MAX_SEARCH_IMAGE_UPLOAD_BYTES)) {
            _context5.n = 11;
            break;
          }
          showMessage('Image is still larger than 5MB after processing. Please choose a smaller image.');
          return _context5.a(2, null);
        case 11:
          return _context5.a(2, jpegBlob);
        case 12:
          _context5.p = 12;
          _t8 = _context5.v;
          showMessage(_t8 && _t8.message ? _t8.message : "Image search failed, error=".concat(ImageSearchErrorCode.IMAGE_READ_FAILED));
          return _context5.a(2, null);
        case 13:
          _context5.p = 13;
          if (img && typeof img.close === 'function') {
            try {
              img.close();
            } catch (e) {
              // no-op
            }
          }
          return _context5.f(13);
        case 14:
          return _context5.a(2);
      }
    }, _callee5, null, [[7, 9], [5, 6], [2, 12, 13, 14]]);
  }));
  return _prepareImageForUpload.apply(this, arguments);
}
function setupImageForCropping(_x4, _x5) {
  return _setupImageForCropping.apply(this, arguments);
}
function _setupImageForCropping() {
  _setupImageForCropping = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6(jpegBlob, onErrorMessage) {
    var showMessage, loadImage, cropLoadingImg, cropImg, _t9;
    return _regenerator().w(function (_context6) {
      while (1) switch (_context6.p = _context6.n) {
        case 0:
          showMessage = function _showMessage2(msg) {
            if (typeof onErrorMessage === 'function') {
              onErrorMessage(msg);
            } else {
              console.log(msg);
            }
          };
          if (jpegBlob) {
            _context6.n = 1;
            break;
          }
          return _context6.a(2, false);
        case 1:
          _context6.p = 1;
          loadImage = function loadImage(img, url) {
            return new Promise(function (resolve, reject) {
              img.onload = function () {
                img.onload = null;
                img.onerror = null;
                resolve();
              };
              img.onerror = function () {
                img.onload = null;
                img.onerror = null;
                reject(new ImageSearchError(ImageSearchErrorCode.IMAGE_READ_FAILED, null, 'crop image load failed'));
              };
              img.src = url;
            });
          };
          cropLoadingImg = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#crop-loading-img')[0];
          cropImg = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#js-visual-search-image')[0];
          if (cropImg) {
            _context6.n = 2;
            break;
          }
          showMessage('Image processing failed. Please try another image.');
          return _context6.a(2, false);
        case 2:
          // Clean up previous crop image URL before creating a new one.
          if (cropImageObjectUrl) {
            URL.revokeObjectURL(cropImageObjectUrl);
            cropImageObjectUrl = null;
          }
          cropImageObjectUrl = URL.createObjectURL(jpegBlob);
          _context6.n = 3;
          return Promise.all([cropLoadingImg ? loadImage(cropLoadingImg, cropImageObjectUrl) : Promise.resolve(), cropImg ? loadImage(cropImg, cropImageObjectUrl) : Promise.resolve()]);
        case 3:
          return _context6.a(2, true);
        case 4:
          _context6.p = 4;
          _t9 = _context6.v;
          showMessage('Image processing failed. Please try another image.');
          return _context6.a(2, false);
      }
    }, _callee6, null, [[1, 4]]);
  }));
  return _setupImageForCropping.apply(this, arguments);
}
function buildImageSearchFormData(file, originalFileName) {
  var formData = new FormData();
  formData.append('image', file, file.name || DEFAULT_IMAGE_SEARCH_FILE_NAME);
  if (originalFileName) {
    formData.append('originalFileName', originalFileName);
  }
  return formData;
}
function uploadPreparedImage(_x6, _x7) {
  return _uploadPreparedImage.apply(this, arguments);
} // Poll backend for image search status.
// Backend may either:
// 1) keep returning retryAfterSeconds, or
// 2) return a redirectUrl when search results are ready.
function _uploadPreparedImage() {
  _uploadPreparedImage = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7(file, originalFileName) {
    var attempt, response, _t0, _t1;
    return _regenerator().w(function (_context7) {
      while (1) switch (_context7.p = _context7.n) {
        case 0:
          attempt = 0;
        case 1:
          if (!(attempt <= MAX_UPLOAD_IMAGE_RETRIES)) {
            _context7.n = 12;
            break;
          }
          response = void 0;
          _context7.p = 2;
          _context7.n = 3;
          return fetch('/content/image-search/upload', {
            method: 'POST',
            body: buildImageSearchFormData(file, originalFileName)
          });
        case 3:
          response = _context7.v;
          _context7.n = 7;
          break;
        case 4:
          _context7.p = 4;
          _t0 = _context7.v;
          if (!(attempt < MAX_UPLOAD_IMAGE_RETRIES)) {
            _context7.n = 6;
            break;
          }
          _context7.n = 5;
          return imageSearchSleep(UPLOAD_IMAGE_RETRIES_DELAY_MS * (attempt + 1));
        case 5:
          return _context7.a(3, 11);
        case 6:
          throw new ImageSearchError(ImageSearchErrorCode.UPLOAD_FAILED, null, "fetch failed after ".concat(MAX_UPLOAD_IMAGE_RETRIES + 1, " attempts, name=").concat(_t0 && _t0.name, ", message=").concat(_t0 && _t0.message, ", online=").concat(navigator.onLine));
        case 7:
          if (response.ok) {
            _context7.n = 8;
            break;
          }
          throw new ImageSearchError(ImageSearchErrorCode.UPLOAD_FAILED, null, "status=".concat(response.status));
        case 8:
          _context7.p = 8;
          _context7.n = 9;
          return response.json();
        case 9:
          return _context7.a(2, _context7.v);
        case 10:
          _context7.p = 10;
          _t1 = _context7.v;
          throw new ImageSearchError(ImageSearchErrorCode.INVALID_JSON_RESPONSE, null, 'Invalid JSON in upload response');
        case 11:
          attempt++;
          _context7.n = 1;
          break;
        case 12:
          return _context7.a(2);
      }
    }, _callee7, null, [[8, 10], [2, 4]]);
  }));
  return _uploadPreparedImage.apply(this, arguments);
}
function checkImageSearchStatus(_x8) {
  return _checkImageSearchStatus.apply(this, arguments);
}
function _checkImageSearchStatus() {
  _checkImageSearchStatus = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee8(eventId) {
    var attempt, res, _t10, _t11;
    return _regenerator().w(function (_context8) {
      while (1) switch (_context8.p = _context8.n) {
        case 0:
          attempt = 0;
        case 1:
          if (!(attempt <= MAX_STATUS_CHECK_RETRIES)) {
            _context8.n = 12;
            break;
          }
          res = void 0;
          _context8.p = 2;
          _context8.n = 3;
          return fetch('/content/image-search/check-status?eventId=' + encodeURIComponent(eventId), {
            cache: 'no-store'
          });
        case 3:
          res = _context8.v;
          _context8.n = 7;
          break;
        case 4:
          _context8.p = 4;
          _t10 = _context8.v;
          if (!(attempt < MAX_STATUS_CHECK_RETRIES)) {
            _context8.n = 6;
            break;
          }
          _context8.n = 5;
          return imageSearchSleep(STATUS_CHECK_RETRY_DELAY_MS);
        case 5:
          return _context8.a(3, 11);
        case 6:
          throw new ImageSearchError(ImageSearchErrorCode.STATUS_CHECK_FAILED, null, "fetch failed after ".concat(MAX_STATUS_CHECK_RETRIES + 1, " attempts, name=").concat(_t10 && _t10.name, ", message=").concat(_t10 && _t10.message, ", online=").concat(navigator.onLine));
        case 7:
          if (res.ok) {
            _context8.n = 8;
            break;
          }
          throw new ImageSearchError(ImageSearchErrorCode.STATUS_CHECK_FAILED, null, "status=".concat(res.status));
        case 8:
          _context8.p = 8;
          _context8.n = 9;
          return res.json();
        case 9:
          return _context8.a(2, _context8.v);
        case 10:
          _context8.p = 10;
          _t11 = _context8.v;
          throw new ImageSearchError(ImageSearchErrorCode.INVALID_JSON_RESPONSE, null, 'Invalid JSON in check-status response');
        case 11:
          attempt++;
          _context8.n = 1;
          break;
        case 12:
          return _context8.a(2);
      }
    }, _callee8, null, [[8, 10], [2, 4]]);
  }));
  return _checkImageSearchStatus.apply(this, arguments);
}
function normalizeRetryAfterSeconds(value) {
  var normalized = typeof value === 'string' ? Number(__WEBPACK_IMPORTED_MODULE_0_jquery___default.a.trim(value)) : value;
  if (typeof normalized !== 'number' || isNaN(normalized)) {
    throw new ImageSearchError(ImageSearchErrorCode.INVALID_RETRY_VALUE, null, "waitSeconds=".concat(value));
  }
  if (normalized <= 0) {
    throw new ImageSearchError(ImageSearchErrorCode.INVALID_RETRY_NON_POSITIVE, null, "waitSeconds=".concat(value));
  }
  return normalized;
}

// Keep polling until backend returns redirectUrl, an error occurs, or timeout is reached.
function pollImageSearchResult(_x9) {
  return _pollImageSearchResult.apply(this, arguments);
} // Shared entry point after image has already been preprocessed.
// Upload -> show loading modal -> poll until redirect or timeout.
function _pollImageSearchResult() {
  _pollImageSearchResult = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee9(uploadResponse) {
    var eventId, timeoutSeconds, retryAfterSeconds, effectiveTimeout, deadline, waitSeconds, remainingMs, checkResponse;
    return _regenerator().w(function (_context9) {
      while (1) switch (_context9.n) {
        case 0:
          eventId = uploadResponse && uploadResponse.eventId;
          timeoutSeconds = uploadResponse && uploadResponse.timeout;
          retryAfterSeconds = uploadResponse && uploadResponse.retryAfterSeconds;
          if (eventId) {
            _context9.n = 1;
            break;
          }
          throw new ImageSearchError(ImageSearchErrorCode.MISSING_EVENT_ID, null, 'No event id in polling image.');
        case 1:
          effectiveTimeout = typeof timeoutSeconds === 'number' && timeoutSeconds > 0 ? timeoutSeconds : IMAGE_SEARCH_DEFAULT_POLL_TIMEOUT_SECONDS;
          deadline = Date.now() + effectiveTimeout * 1000;
        case 2:
          if (false) {
            _context9.n = 9;
            break;
          }
          if (!(Date.now() > deadline)) {
            _context9.n = 3;
            break;
          }
          return _context9.a(2, {
            timedOut: true
          });
        case 3:
          waitSeconds = retryAfterSeconds == null ? 3 : normalizeRetryAfterSeconds(retryAfterSeconds);
          remainingMs = deadline - Date.now();
          if (!(remainingMs <= 0)) {
            _context9.n = 4;
            break;
          }
          return _context9.a(2, {
            timedOut: true
          });
        case 4:
          _context9.n = 5;
          return imageSearchSleep(Math.min(waitSeconds * 1000, remainingMs));
        case 5:
          _context9.n = 6;
          return checkImageSearchStatus(eventId);
        case 6:
          checkResponse = _context9.v;
          if (!(checkResponse && checkResponse.redirectUrl)) {
            _context9.n = 7;
            break;
          }
          return _context9.a(2, checkResponse);
        case 7:
          if (!(checkResponse && checkResponse.errorMessage)) {
            _context9.n = 8;
            break;
          }
          throw new ImageSearchError(ImageSearchErrorCode.STATUS_CHECK_FAILED, null, "backendError=".concat(checkResponse.errorMessage));
        case 8:
          retryAfterSeconds = checkResponse && checkResponse.retryAfterSeconds != null ? checkResponse.retryAfterSeconds : waitSeconds;
          _context9.n = 2;
          break;
        case 9:
          return _context9.a(2);
      }
    }, _callee9);
  }));
  return _pollImageSearchResult.apply(this, arguments);
}
function startImageSearch(_x0, _x1, _x10) {
  return _startImageSearch.apply(this, arguments);
} // Show the processed image in loading modal before polling starts.
function _startImageSearch() {
  _startImageSearch = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee0(processedFile, onError, originalFileName) {
    var previewUrl, uploadResponse, errorDetails, finalResponse, _t12;
    return _regenerator().w(function (_context0) {
      while (1) switch (_context0.p = _context0.n) {
        case 0:
          if (!isImageSearchRunning) {
            _context0.n = 1;
            break;
          }
          return _context0.a(2);
        case 1:
          isImageSearchRunning = true;
          previewUrl = null;
          _context0.p = 2;
          _context0.n = 3;
          return uploadPreparedImage(processedFile, originalFileName);
        case 3:
          uploadResponse = _context0.v;
          if (!(!uploadResponse || !uploadResponse.eventId)) {
            _context0.n = 4;
            break;
          }
          errorDetails = !uploadResponse ? 'no uploadResponse' : 'no event id';
          onError("Image search failed, error=".concat(ImageSearchErrorCode.UPLOAD_FAILED), errorDetails);
          return _context0.a(2);
        case 4:
          previewUrl = setLoadingModalImage(processedFile);
          __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.modal.close();
          openImageSearchLoadingModal();
          _context0.n = 5;
          return pollImageSearchResult(uploadResponse);
        case 5:
          finalResponse = _context0.v;
          if (!(finalResponse && finalResponse.redirectUrl)) {
            _context0.n = 6;
            break;
          }
          clearLoadingModalImage(previewUrl);
          window.location.href = finalResponse.redirectUrl;
          return _context0.a(2);
        case 6:
          __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.modal.close();
          clearLoadingModalImage(previewUrl);
          if (!(finalResponse && finalResponse.timedOut)) {
            _context0.n = 7;
            break;
          }
          onError("Image search failed, error=".concat(ImageSearchErrorCode.TIMEOUT));
          return _context0.a(2);
        case 7:
          onError("Image search failed, error=".concat(ImageSearchErrorCode.UNKNOWN));
          _context0.n = 9;
          break;
        case 8:
          _context0.p = 8;
          _t12 = _context0.v;
          __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.modal.close();
          clearLoadingModalImage(previewUrl);
          console.error('Image search failed:', _t12);
          onError(getImageSearchErrorMessage(_t12), _t12 && _t12.details);
        case 9:
          _context0.p = 9;
          isImageSearchRunning = false;
          return _context0.f(9);
        case 10:
          return _context0.a(2);
      }
    }, _callee0, null, [[2, 8, 9, 10]]);
  }));
  return _startImageSearch.apply(this, arguments);
}
function setLoadingModalImage(file) {
  var $img = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#loading-modal-image');
  if (!$img.length || !file) {
    return null;
  }
  // This is not internet URL, but setup img blob URL in browser internal memory
  var previewUrl = URL.createObjectURL(file);
  $img.attr('src', previewUrl);
  return previewUrl;
}
function clearLoadingModalImage(previewUrl) {
  if (previewUrl) {
    try {
      URL.revokeObjectURL(previewUrl);
    } catch (e) {
      // no-op
    }
  }
  var $img = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#loading-modal-image');
  if ($img.length) {
    $img.attr('src', '');
  }
}
function openImageSearchLoadingModal() {
  __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.modal({
    open: 'image-search-loading-modal',
    type: 'full',
    triggerOpen: true,
    closeButton: false,
    addModifierClass: 'ab553__processing-modal',
    onClose: function onClose() {
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.form-search-overlay').show();
      var $searchResults = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.site-search__results');
      if ($searchResults.length) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13_body_scroll_lock__["disableBodyScroll"])($searchResults[0]);
      }
      window.scrollTo(0, 0);
    },
    onComplete: function onComplete() {
      var $status = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.ab553__processing-status');
      setTimeout(function () {
        $status.text('searching...');
      }, 2000);
    }
  });
}
function imageSearchEngagementTracking(isUrlFetch, error) {
  if (typeof isUrlFetch !== 'boolean') {
    console.warn('imageSearchEngagementTracking: isUrlFetch must be a boolean');
    return;
  }
  var trackingData = _objectSpread({
    url: window.location.href,
    isUrlFetch: isUrlFetch
  }, error && {
    error: error instanceof Error ? error.message : "".concat(error)
  });
  __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.ajax({
    type: 'GET',
    url: '/content/image-search/engagement-tracking',
    data: trackingData,
    timeout: 5000,
    error: function error(jqXHR, textStatus, errorThrown) {
      console.warn('imageSearchEngagementTracking: request failed', {
        textStatus: textStatus,
        errorThrown: errorThrown
      });
    }
  });
}
function extractFileNameFromUrl(url) {
  try {
    var pathname = new URL(url).pathname;
    var name = pathname.split('/').pop();
    name = name.split('?')[0].split('#')[0];
    name = decodeURIComponent(name);
    if (!name || name.trim() === '') {
      return DEFAULT_IMAGE_SEARCH_FILE_NAME;
    }
    return name;
  } catch (_unused) {
    return DEFAULT_IMAGE_SEARCH_FILE_NAME;
  }
}
function sanitizeOriginalFileName(name) {
  if (typeof name !== 'string' || !name.trim()) {
    return DEFAULT_IMAGE_SEARCH_FILE_NAME;
  }
  name = name.trim().replace(/[\r\n\t]/g, ' ');
  if (!name) {
    return DEFAULT_IMAGE_SEARCH_FILE_NAME;
  }
  if (name.length <= MAX_ORIGINAL_FILE_NAME_LENGTH) {
    return name;
  }
  var dotIndex = name.lastIndexOf('.');
  var hasExt = dotIndex > 0 && dotIndex < name.length - 1;
  var ext = hasExt ? name.substring(dotIndex) : '';
  var allowedNameLength = MAX_ORIGINAL_FILE_NAME_LENGTH - ext.length;
  if (allowedNameLength <= 0) {
    return name.substring(0, MAX_ORIGINAL_FILE_NAME_LENGTH);
  }
  return name.substring(0, allowedNameLength) + ext;
}
__WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).ready(function () {
  clickToLogoutFromHeader();
  initSearch();
  initMobileSiteHeader();
  toggleRevolveMenu();
  //toggleDisplay();
  categoryNav();
  fixedOverlay();
  loadFavPopups();
  window.headerLogOut = __WEBPACK_IMPORTED_MODULE_3_modules_logout__["a" /* default */];
  if (__WEBPACK_IMPORTED_MODULE_0_jquery___default()('#tryonlpProducts').length) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_modules_heart_product__["a" /* default */])('#tryonlpProducts', '.fav-item');
  }

  // clearSearchCookiesFromHeader();
  // initMobileMenu();
  window.validateZipCode = validateZipCode;
  window.submitHeart = function (paramtype, paramvalue, action, psize, sectionUrl) {
    //this method is used by /r/dialog/ShoppingBagLimit.jsp
    __WEBPACK_IMPORTED_MODULE_6_modules_heart_product__["a" /* default */].submitHeart(paramtype, paramvalue, action, psize, sectionUrl, function () {
      var favBtnOnPDP = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-fav-button');
      if (favBtnOnPDP.length > 0 && !favBtnOnPDP.hasClass('favorite-button--active')) {
        favBtnOnPDP.addClass('favorite-button--active');
      }
      if (window.rcProps && typeof window.rcProps.ReCAPTCHARestore == 'function') {
        window.rcProps.ReCAPTCHARestore();
        window.rcProps.ReCAPTCHARestore = "";
      }
      if (__WEBPACK_IMPORTED_MODULE_0_jquery___default()('#move-to-fav-notification-modal').length > 0) {
        __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.ajax({
          type: 'GET',
          url: '/content/favorites/moveToFav',
          success: function success(data) {
            __WEBPACK_IMPORTED_MODULE_0_jquery___default()('body').append(data);
            __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.modal({
              triggerOpen: true,
              open: "move-to-fav-notification-modal"
            });
          },
          failure: function failure() {}
        });
      } else {
        __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.modal.close();
      }
    });
  };
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()(".js-close-banner").click(function () {
    __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.post("/r/ajax/SetRevolveSessionParam.jsp", __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.param({
      "key": "rglobalbannerdismiss",
      "value": "disableglobalbanner"
    }), function () {});
  });
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#iphoneRestrictionsAnchor').click(function (e) {
    e.preventDefault();
    __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.modal({
      url: "/content/favorites/mobile/appRestrictionPopup",
      type: "toast",
      triggerOpen: true,
      returnFocus: "#iphoneRestrictionsAnchor"
    });
  });

  // AB553 Mock Content Start

  if (__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.ab553').length) {
    var disableCroppedSubmitButton = function disableCroppedSubmitButton($button) {
      $button.addClass('disabled').css('pointer-events', 'none').attr('aria-disabled', 'true');
    };
    var enableCroppedSubmitButton = function enableCroppedSubmitButton($button) {
      $button.removeClass('disabled').css('pointer-events', 'initial').attr('aria-disabled', 'false');
    };
    var startCropImage = function startCropImage(originalFileName) {
      __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.modal({
        open: 'crop-module-loading-modal',
        type: 'full',
        triggerOpen: true,
        closeButton: false,
        addModifierClass: 'ab553__processing-modal',
        onClose: function onClose() {
          window.VisualSearchCropper.destroy();
          __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.form-search-overlay').show();
          var $searchResults = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.site-search__results');
          if ($searchResults.length) {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13_body_scroll_lock__["disableBodyScroll"])($searchResults[0]);
          }
          window.scrollTo(0, 0);
        },
        onComplete: function onComplete() {
          var image = document.getElementById('js-visual-search-image');
          var $status = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#image-search-crop-processing-status');
          var $cropSubmit = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#js-visual-search-crop-submit');
          var $cropError = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#crop-img-error');
          var $cropImage = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#crop-module-loading-modal .crop-image');
          $cropError.text('').hide();

          // Reset previous crop image size. The modal DOM is reused after cancel.
          $cropImage.removeClass('crop-image--tall').css({
            width: '',
            height: '',
            position: '',
            opacity: ''
          });
          disableCroppedSubmitButton($cropSubmit);
          $status.text('loading...');
          if (!image) return;
          function setDynamicCropHeight(imageEl) {
            var $cropImage = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#crop-module-loading-modal .crop-image');
            if (!$cropImage.length || !imageEl.naturalWidth || !imageEl.naturalHeight) {
              return;
            }
            var maxWidth = Math.min(window.innerWidth * 0.82, 700);
            var maxHeight = window.innerHeight * 0.65;
            var scale = Math.min(maxWidth / imageEl.naturalWidth, maxHeight / imageEl.naturalHeight);
            $cropImage.width(Math.round(imageEl.naturalWidth * scale)).height(Math.round(imageEl.naturalHeight * scale)).toggleClass('crop-image--tall', maxHeight / imageEl.naturalHeight < maxWidth / imageEl.naturalWidth);
          }
          if (image.complete && image.naturalHeight !== 0) {
            setDynamicCropHeight(image);
            window.VisualSearchCropper.init(image);
          } else {
            image.onload = function () {
              setDynamicCropHeight(image);
              window.VisualSearchCropper.init(image);
            };
          }
          $cropSubmit.off('click').on('click', /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
            var blob, _t, _t2;
            return _regenerator().w(function (_context) {
              while (1) switch (_context.p = _context.n) {
                case 0:
                  disableCroppedSubmitButton($cropSubmit);
                  blob = null;
                  _context.p = 1;
                  _context.n = 2;
                  return window.VisualSearchCropper.getBlob();
                case 2:
                  blob = _context.v;
                  _context.n = 4;
                  break;
                case 3:
                  _context.p = 3;
                  _t = _context.v;
                  console.error('Failed to get cropped image:', _t);
                case 4:
                  if (blob) {
                    _context.n = 5;
                    break;
                  }
                  $cropError.text('Failed to get cropped image. Please try again.').show();
                  // allow retry if crop failed
                  enableCroppedSubmitButton($cropSubmit);
                  return _context.a(2);
                case 5:
                  _context.p = 5;
                  _context.n = 6;
                  return startImageSearch(blob, showImageSearchError, originalFileName);
                case 6:
                  _context.n = 8;
                  break;
                case 7:
                  _context.p = 7;
                  _t2 = _context.v;
                  console.error('Image upload failed:', _t2);
                  showImageSearchError(getImageSearchErrorMessage(_t2), _t2 && _t2.details);
                  enableCroppedSubmitButton($cropSubmit);
                case 8:
                  return _context.a(2);
              }
            }, _callee, null, [[5, 7], [1, 3]]);
          })));
        }
      });
    }; // AB553 New Mock Content End
    var isValidUrl = function isValidUrl(str) {
      try {
        var url = new URL(str);
        return ['http:', 'https:'].includes(url.protocol) && url.hostname;
      } catch (e) {
        return false;
      }
    }; // image url upload
    window.addEventListener('pagehide', function () {
      // Handle iOS/Safari bfcache (e.g. back swipe).
      // When the page is restored from bfcache, previous modal/cropper state may persist.
      // Clean up before page is cached to avoid stale UI/state issues.
      // This is registered once at the top level to avoid duplicate listeners.
      __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.modal.close();
      if (window.VisualSearchCropper) {
        window.VisualSearchCropper.destroy();
      }
    });
    // AB553 New Mock Content Start
    // Keep cropper state private and avoid leaking variables globally.
    (function () {
      var cropper = null;
      function initVisualSearchCropper(imageEl) {
        if (!imageEl) return;
        if (cropper) {
          cropper.destroy();
          cropper = null;
        }
        window.VisualSearchCropper._currentBlob = null;
        cropper = new __WEBPACK_IMPORTED_MODULE_14_cropperjs___default.a(imageEl, {
          center: false,
          dashed: false,
          guides: false,
          responsive: true,
          rotatable: false,
          scalable: false,
          viewMode: 1,
          zoomable: false,
          zoomOnWheel: false,
          ready: function ready() {
            var $loader = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#crop-module-loading-modal .ab553__is-processing');
            var $cropImage = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#crop-module-loading-modal .crop-image');
            var $cropSubmit = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#js-visual-search-crop-submit');
            $loader.addClass('u-hide');
            $cropImage.css({
              position: 'initial',
              opacity: 'initial'
            });
            enableCroppedSubmitButton($cropSubmit);
            getCroppedBlob().then(function (blob) {
              window.VisualSearchCropper._currentBlob = blob;
            })["catch"](function (err) {
              console.error('Failed to get cropped image:', err);
            });
          },
          cropmove: function cropmove(e) {
            var action = e.detail && e.detail.action;
            var cropperEl = cropper && cropper.cropper;
            if (!cropperEl) {
              return;
            }
            if (action === 'ne') {
              var point = cropperEl.querySelector('.cropper-point.point-ne');
              if (point) {
                point.classList.add('is-engaged');
              }
            } else if (action === 'sw') {
              var _point = cropperEl.querySelector('.cropper-point.point-sw');
              if (_point) {
                _point.classList.add('is-engaged');
              }
            }
          },
          cropend: function cropend() {
            var cropperEl = cropper && cropper.cropper;
            if (cropperEl) {
              var nePoint = cropperEl.querySelector('.cropper-point.point-ne');
              var swPoint = cropperEl.querySelector('.cropper-point.point-sw');
              if (nePoint) {
                nePoint.classList.remove('is-engaged');
              }
              if (swPoint) {
                swPoint.classList.remove('is-engaged');
              }
            }
            getCroppedBlob().then(function (blob) {
              if (blob) {
                window.VisualSearchCropper._currentBlob = blob;
              }
            })["catch"](function (err) {
              console.error('Failed to get cropped image:', err);
            });
          }
        });
        return cropper;
      }
      function getCroppedBlob() {
        if (!cropper) {
          return Promise.resolve(null);
        }
        var canvas = cropper.getCroppedCanvas({
          maxWidth: MAX_IMAGE_SEARCH_EDGE,
          maxHeight: MAX_IMAGE_SEARCH_EDGE,
          imageSmoothingEnabled: true,
          imageSmoothingQuality: 'high'
        });
        if (!canvas) {
          return Promise.resolve(null);
        }
        return new Promise(function (resolve, reject) {
          canvas.toBlob(function (blob) {
            if (!blob) {
              reject(new ImageSearchError(ImageSearchErrorCode.IMAGE_ENCODE_FAILED, null, 'crop canvas.toBlob returned null'));
              return;
            }
            resolve(blob);
          }, 'image/jpeg', IMAGE_SEARCH_JPEG_QUALITY);
        });
      }
      function destroyCropper() {
        if (cropper) {
          cropper.destroy();
          cropper = null;
        }
        if (cropImageObjectUrl) {
          URL.revokeObjectURL(cropImageObjectUrl);
          cropImageObjectUrl = null;
        }
        window.VisualSearchCropper._currentBlob = null;
      }
      window.VisualSearchCropper = {
        init: initVisualSearchCropper,
        getBlob: getCroppedBlob,
        destroy: destroyCropper
      };
    })();
    var $visualSearchButton = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-image-search-btn');
    $visualSearchButton.on('click', function () {
      __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.modal({
        open: 'image-search-modal',
        type: 'toast',
        closeButton: true,
        triggerOpen: true,
        triggerElement: $visualSearchButton,
        addModifierClass: 'ab553__visual-modal',
        onClose: function onClose() {
          var $formSearchOverlay = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.form-search-overlay');
          var $searchResults = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.site-search__results');
          $formSearchOverlay.show();
          if ($searchResults.length) {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13_body_scroll_lock__["disableBodyScroll"])($searchResults[0]);
          }
          window.scrollTo(0, 0);
        },
        onComplete: function onComplete() {
          var $fileInputUpload = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#visual-search-photo-upload');
          var $uploadButton = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#visual-search-upload-button');
          var $pastePhotoButton = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#visual-search-paste-photo-button');
          var $photoURLCancelButton = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#visual-search-photo-url-cancel-button');
          var $buttonGroup = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.ab553__visual-modal-buttongroup');
          var $pastePhotoForm = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.ab553__visual-modal-url-form');
          var $formSearchOverlay = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.form-search-overlay');
          var $imageUrlFeedback = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#image-url-feedback');
          var $selectImageFeedback = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#select-image-feedback');
          var $imageUrlInput = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#visual-search-photo-url-input');

          // Reset UI state
          $pastePhotoForm.hide();
          $buttonGroup.show();
          $imageUrlInput.val('');
          $imageUrlInput.closest('.field').removeClass('is-error');
          $imageUrlFeedback.text('').hide();
          $selectImageFeedback.text('').hide();
          $formSearchOverlay.hide();
          $uploadButton.off('click').on('click', function () {
            $fileInputUpload.click();
          });
          $pastePhotoButton.off('click').on('click', function () {
            $buttonGroup.hide();
            $pastePhotoForm.show();
          });
          $photoURLCancelButton.off('click').on('click', function () {
            $pastePhotoForm.hide();
            $buttonGroup.show();
            $imageUrlInput.val('');
          });
        }
      });
    });

    // local image file upload
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#visual-search-photo-upload').on('change', /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
      var $feedback, input, file, processedFile, cropImageReady, originalFileName, _t3;
      return _regenerator().w(function (_context2) {
        while (1) switch (_context2.p = _context2.n) {
          case 0:
            $feedback = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#select-image-feedback');
            input = this;
            file = input.files && input.files[0];
            _context2.p = 1;
            if (file) {
              _context2.n = 2;
              break;
            }
            $feedback.text('Please select a valid image').show();
            return _context2.a(2);
          case 2:
            if (!(isImagePreparing || isImageSearchRunning)) {
              _context2.n = 3;
              break;
            }
            $feedback.text('Image search is already in progress.').show();
            return _context2.a(2);
          case 3:
            isImagePreparing = true;
            $feedback.hide();
            _context2.n = 4;
            return prepareImageForUpload(file, function (msg) {
              $feedback.text(msg).show();
            });
          case 4:
            processedFile = _context2.v;
            if (processedFile) {
              _context2.n = 5;
              break;
            }
            return _context2.a(2);
          case 5:
            _context2.n = 6;
            return setupImageForCropping(processedFile, function (msg) {
              $feedback.text(msg).show();
            });
          case 6:
            cropImageReady = _context2.v;
            if (cropImageReady) {
              imageSearchEngagementTracking(false);
              originalFileName = sanitizeOriginalFileName(file.name);
              startCropImage(originalFileName);
            }
            _context2.n = 8;
            break;
          case 7:
            _context2.p = 7;
            _t3 = _context2.v;
            console.error('Image upload failed:', _t3);
            $feedback.text('Image upload failed.').show();
            showImageSearchError(getImageSearchErrorMessage(_t3), _t3 && _t3.details);
            imageSearchEngagementTracking(false, _t3);
          case 8:
            _context2.p = 8;
            __WEBPACK_IMPORTED_MODULE_0_jquery___default()(input).val('');
            isImagePreparing = false;
            return _context2.f(8);
          case 9:
            return _context2.a(2);
        }
      }, _callee2, this, [[1, 7, 8, 9]]);
    })));
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.ab553__visual-modal-url-form').on('submit', /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(e) {
        var $input, $field, $feedback, imageUrl, unsupportedUrlMessage, controller, timer, imageResponse, contentType, contentLength, blob, processedFile, cropImageReady, extractedFileNameFromUrl, originalFileName, _t4;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.p = _context3.n) {
            case 0:
              e.preventDefault();
              $input = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#visual-search-photo-url-input');
              $field = $input.closest('.field');
              $feedback = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#image-url-feedback');
              imageUrl = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.trim($input.val());
              $field.removeClass('is-error');
              $feedback.hide();
              if (!(!imageUrl || !isValidUrl(imageUrl))) {
                _context3.n = 1;
                break;
              }
              $input.closest('.field').addClass('is-error');
              $feedback.text('Please enter a valid public URL').show();
              return _context3.a(2);
            case 1:
              if (!(isImagePreparing || isImageSearchRunning)) {
                _context3.n = 2;
                break;
              }
              $feedback.text('Image search is already in progress.').show();
              return _context3.a(2);
            case 2:
              isImagePreparing = true;
              unsupportedUrlMessage = "This image URL is not supported. Please download it first and upload it using the 'Upload From Device' option instead.";
              _context3.p = 3;
              controller = new AbortController();
              timer = setTimeout(function () {
                return controller.abort();
              }, 10000);
              _context3.p = 4;
              _context3.n = 5;
              return fetch(imageUrl, {
                signal: controller.signal
              });
            case 5:
              imageResponse = _context3.v;
            case 6:
              _context3.p = 6;
              clearTimeout(timer);
              return _context3.f(6);
            case 7:
              if (imageResponse.ok) {
                _context3.n = 8;
                break;
              }
              $field.addClass('is-error');
              $feedback.text(unsupportedUrlMessage).show();
              return _context3.a(2);
            case 8:
              contentType = imageResponse.headers.get('content-type') || '';
              if (contentType.startsWith('image/')) {
                _context3.n = 9;
                break;
              }
              $field.addClass('is-error');
              $feedback.text('The provided URL does not point to a valid image.').show();
              return _context3.a(2);
            case 9:
              contentLength = imageResponse.headers.get('content-length');
              if (!(contentLength && parseInt(contentLength, 10) > MAX_IMAGE_URL_FETCH_BYTES)) {
                _context3.n = 10;
                break;
              }
              $field.addClass('is-error');
              $feedback.text('Image is too large. Please choose a smaller image.').show();
              return _context3.a(2);
            case 10:
              _context3.n = 11;
              return imageResponse.blob();
            case 11:
              blob = _context3.v;
              if (!(blob.size > MAX_IMAGE_URL_FETCH_BYTES)) {
                _context3.n = 12;
                break;
              }
              $field.addClass('is-error');
              $feedback.text('Image is too large. Please choose a smaller image.').show();
              return _context3.a(2);
            case 12:
              _context3.n = 13;
              return prepareImageForUpload(blob, function (msg) {
                $feedback.text(msg).show();
              });
            case 13:
              processedFile = _context3.v;
              if (processedFile) {
                _context3.n = 14;
                break;
              }
              return _context3.a(2);
            case 14:
              _context3.n = 15;
              return setupImageForCropping(processedFile, function (msg) {
                $feedback.text(msg).show();
              });
            case 15:
              cropImageReady = _context3.v;
              if (cropImageReady) {
                imageSearchEngagementTracking(true);
                extractedFileNameFromUrl = extractFileNameFromUrl(imageUrl);
                originalFileName = sanitizeOriginalFileName(extractedFileNameFromUrl);
                startCropImage(originalFileName);
              }
              _context3.n = 17;
              break;
            case 16:
              _context3.p = 16;
              _t4 = _context3.v;
              console.error('Image URL upload failed:', _t4);
              $field.addClass('is-error');
              if (_t4 && _t4.name === 'AbortError') {
                $feedback.text('Request timed out. Please try again.').show();
              } else {
                $feedback.text(unsupportedUrlMessage).show();
              }
              imageSearchEngagementTracking(true, _t4);
            case 17:
              _context3.p = 17;
              isImagePreparing = false;
              return _context3.f(17);
            case 18:
              return _context3.a(2);
          }
        }, _callee3, null, [[4,, 6, 7], [3, 16, 17, 18]]);
      }));
      return function (_x11) {
        return _ref3.apply(this, arguments);
      };
    }());
  }
  // AB553 Mock Content End
});

/***/ }),
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);

__WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).ready(function () {
  var loyaltywelcomemodalIsOpen = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#loyalty-invitation-modal').length > 0;
  if (loyaltywelcomemodalIsOpen) {
    triggerLoyaltyWelcomePopup();
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#loyalty-invitation-terms').prop('checked', true);
  }
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#loyalty-invitation-terms').click(function () {
    if (!__WEBPACK_IMPORTED_MODULE_0_jquery___default()('#loyalty-invitation-terms').is(':checked')) {
      markErrorLoyaltyOptIn();
    } else {
      unMarkErrorLoyaltyOptIn();
    }
  });
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#loyalty_join_button').click(function () {
    loyaltyoptIn();
  });
});
function triggerLoyaltyWelcomePopup() {
  __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.modal({
    open: "loyalty-invitation-modal",
    triggerOpen: true
  });
}
function closeInvitationPopup() {
  __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.modal.close();
}
function loyaltyoptIn() {
  if (!__WEBPACK_IMPORTED_MODULE_0_jquery___default()('#loyalty-invitation-terms').is(':checked')) {
    return;
  }
  var email = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#loyalty-invitation-email').val();
  var data = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.param({
    cID: __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#loyalty-invitation-cid').val(),
    loyaltyUserStatusId: __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#loyalty-invitation-user-id').val()
  });
  __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.ajax({
    url: '/content/loyalty-club/internal-opt-in',
    data: data,
    type: 'POST',
    dataType: 'json',
    success: function success(rtn) {
      if (rtn.success) {
        closeInvitationPopup();
      } else {
        var errorClasses = 'is-error';
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#loyalty-invitation-email-field').addClass(errorClasses);
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#loyalty-invitation-email').value(email);
      }
    }
  });
}
function markErrorLoyaltyOptIn() {
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#loyalty-invitation-terms').addClass('is-error');
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#loyalty-invitation-terms-label').addClass('link--error u-color--error');
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#loyalty-invitation-opt-in-error').slideDown();
}
function unMarkErrorLoyaltyOptIn() {
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#loyalty-invitation-terms').removeClass('is-error');
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#loyalty-invitation-terms-label').removeClass('link--error u-color--error');
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#loyalty-invitation-opt-in-error').slideUp();
}

/***/ }),
/* 198 */
/***/ (function(module, exports) {

window.ntfInit = ntfInit;
window.emailSignUpM_New = emailSignUpM_New;
function ntfInit(cookieName, sectionURL, department, subscribeSource) {
  //cookieName = <%=NewToFileUtils.NAME_COOKIE_NTF_NO_RIBBON%>
  //sectionURL = <%=p.sectionUrl%>
  //department = <%=ntf_department%>
  if (!window.rcProps || !window.rcProps.ntf) {
    return;
  }
  if ($('#ntf-toast-mobile').length === 0 && $('#ambassador-share-link').length === 0) {
    $('.fixed-bottom').addClass("u-width--auto");
    $('.fixed-bottom__flex').addClass("u-margin-l--none");
  }
  $('.fixed-bottom').removeClass('u-hide');
  var ntfData = window.rcProps.ntf;
  function parseRtn(rtn) {
    return JSON && JSON.parse(rtn) || $.parseJSON(rtn);
  }
  $("#email_signup_form").find("input").on('change keyup paste', function () {
    $(this).removeClass("error");
    $(this).attr("placeholder", "");
  });
  $(document).on("click", ".js-ntf-restriction-modal", function () {
    $.modal({
      url: "/content/homepage/ntfDialog/NTF_TOAST_RESTRICTION",
      type: "toast",
      triggerOpen: true,
      onClose: function onClose() {
        loadNtfPopups("NTF_TOAST_NEW");
      }
    });
  });
  $("#ntf-toast-mobile-close").on("click", function () {
    setCookie(cookieName, true, 1);
    $('.fixed-bottom').addClass("u-width--auto");
    $('.fixed-bottom__flex').addClass("u-margin-l--none");
  });
  $("#ntf-email-address_container").focus(function () {
    $("#ntf_email_wrapper").removeClass("is-error");
    $("#email-error-feedback_rev_mobile").text("").hide();
  });

  // for mock purposes, updating flow of footer sign up form
  window.ntfToastFormSubmit = function (event) {
    event.preventDefault();
    $("#ntf_email_wrapper").removeClass("is-error");
    $("#email-error-feedback_rev_mobile").text("").hide();
    var input = $("#ntf-email-address");
    var value = input.val();
    // checks if email exists
    if (value == '') {
      markFooterEmailFieldAsError(ntfData.missingEmailMessage);
    } else if (!validateEmail(value)) {
      markFooterEmailFieldAsError(ntfData.invalidEmailMessage);
    } else {
      var params = {};
      params['emailAddress'] = input.val();
      params['sectionURL'] = sectionURL;
      params['subscriptionGender'] = department;
      if (subscribeSource && subscribeSource.length > 0) {
        params['subscribeSource'] = subscribeSource;
      }
      if (window.rcProps.ga4TagID) {
        if (typeof gtag === 'undefined') {
          var _gtag = function _gtag() {
            dataLayer.push(arguments);
          };
          window.dataLayer = window.dataLayer || [];
          _gtag('js', new Date());
          _gtag('config', window.rcProps.ga4TagID);
          _gtag('event', 'get_coupon', {
            'coupon_name': 'get 10% off',
            'sent_to': window.rcProps.ga4TagID
          });
        }
      }
      $.ajax({
        url: '/r/ajax/NtfDialogSubmit.jsp',
        data: params,
        contentType: 'application/x-www-form-urlencoded; charset=UTF-8',
        type: "POST",
        cache: false,
        success: function success(msg) {
          var msgJson = JSON.parse(msg);
          var result = msgJson[ntfData.keySubmitResult];
          var promoCode = msgJson[ntfData.keySubmitPromoCode];
          var isIneligibleEmail;
          if (result == ntfData.submitIneligible) {
            // testcancel@revolvemail.com
            isIneligibleEmail = true;
            $("#ntf-toast-mobile").hide();
            $("#ntfUserEmailExisting").html(input.val());
            loadNtfPopups("NTF_TOAST_EXISTING");
            setCookie("ntfUserInelligible", true, 365);
            setCookie(cookieName, true, 365);
          } else if (result == ntfData.submitIneligiblePurchased) {
            // testcancel@revolvemail.com
            isIneligibleEmail = true;
            $("#ntf-toast-mobile").hide();
            $("#ntfUserEmailExisting").html(input.val());
            loadNtfPopups("NTF_TOAST_EXISTING");
            setCookie("ntfUserInelligiblePurchased", true, 365);
            setCookie(cookieName, true, 365);
          } else if (result == ntfData.submitNewCode || result == ntfData.submitCodexists || result == ntfData.submitNewCodeSms) {
            // trigger event on form success
            $("#ntf-toast-mobile").hide();
            var additionalData = {};
            additionalData.email = input.val();
            additionalData.promoCode = promoCode;
            if (result == ntfData.submitNewCodeSms) {
              loadNtfPopups("NTF_TOAST_STEP2");
            } else {
              loadNtfPopups("NTF_TOAST_NEW", additionalData);
            }
            setCookie("ntfUserInelligibleSuccess", true, 365);
            setCookie(cookieName, true, 365);
          } else if (result == ntfData.submitInvalid || result == ntfData.submitInvalidHighIPActivity) {
            if (result != ntfData.submitInvalidHighIPActivity) {
              markFooterEmailFieldAsError(ntfData.invalidEmailMessage);
            } else {
              markFooterEmailFieldAsError(ntfData.highIPUsageMessage);
            }
          } else {
            console.log("Possible programming error: result not recognized, result[" + result + "], promoCode[" + promoCode + "]");
          }
        }
      });
    }
  };
}
// for mock purposes, updating flow of footer sign up form
function emailSignUpM_New(event, department, sectionURL, cookieName, subscribeOnly) {
  event.preventDefault();
  var $triggerElement = $(event.currentTarget);
  $triggerElement.prop('disabled', true);
  var input = $('#email_signup_form--input');
  if (subscribeOnly) {
    input = $('#email_signup_form--input_subscribe');
  }
  var value = input.val();
  if (value == '') {
    // checks error for input field
    // back end to update error state
    input.val("");
    input.attr("placeholder", "Invalid email. Please try again");
    input.addClass("error");
    $triggerElement.prop('disabled', false);
  } else if (subscribeOnly) {
    var emailForm = $("#email_signup__form_subscribe");
    var _params = {};
    _params['email'] = value;
    _params['gender'] = department;
    _params['sectionURL'] = sectionURL;
    _params['mobile'] = 'true';
    $.get("/r/ajax/SignUpForNewsletter.jsp", _params, function (r) {
      var msg = $.parseJSON(r);
      if (msg.success) {
        emailForm.find("span").eq(0).show();
        emailForm.find("input").hide();
        emailForm.find("span").eq(1).hide();
        location.href = "/r/mobile/email/subscribe_landing_m.jsp?email=" + value;
      } else {
        input = emailForm.find("input");
        input.val("");
        input.attr("placeholder", msg.msg0);
        input.addClass("error");
      }
    });
  } else {
    var params = {};
    params['emailAddress'] = input.val();
    params['sectionURL'] = sectionURL;
    params['subscriptionGender'] = department;
    $.ajax({
      url: '/r/ajax/NtfDialogSubmit.jsp',
      data: params,
      contentType: 'application/x-www-form-urlencoded; charset=UTF-8',
      type: "POST",
      cache: false,
      success: function success(msg) {
        var msgJson = JSON.parse(msg);
        var result = msgJson[ntfData.keySubmitResult];
        var promoCode = msgJson[ntfData.keySubmitPromoCode];
        var isIneligibleEmail;
        if (result == ntfData.submitIneligible) {
          // testcancel@revolvemail.com
          isIneligibleEmail = true;
          $("#ntf-toast-mobile").hide();
          $("#ntfUserEmailExisting").html(input.val());
          loadNtfPopups("NTF_TOAST_EXISTING", undefined, $triggerElement);
          setCookie("ntfUserInelligible", true, 365);
          setCookie(cookieName, true, 365);
        } else if (result == ntfData.submitIneligiblePurchased) {
          // testcancel@revolvemail.com
          isIneligibleEmail = true;
          $("#ntf-toast-mobile").hide();
          var data = {
            "email": input.val()
          };
          loadNtfPopups("NTF_TOAST_EXISTING", data, $triggerElement);
          setCookie("ntfUserInelligiblePurchased", true, 365);
          setCookie(cookieName, true, 365);
        } else if (result == ntfData.submitNewCode || result == ntfData.submitCodexists || result == ntfData.submitNewCodeSms) {
          // trigger event on form success
          $("#ntf-toast-mobile").hide();
          $("#ntfUserEmail").html(input.val());
          $("#personalizeProfileMobileNtf").attr("href", "/r/mobile/email/subscribe_landing_m.jsp?email=" + input.val() + "&homePage=true");
          $(".ntfCouponCode").html(promoCode);
          var data = {
            "promoCode": promoCode,
            "email": input.val()
          };
          if (result == ntfData.submitCodexists) {
            loadNtfPopups("NTF_TOAST_EXISTING", data, $triggerElement);
          } else {
            loadNtfPopups("NTF_TOAST_NEW", data, $triggerElement);
          }
          if (result == ntfData.submitNewCodeSms) {
            loadNtfPopups("NTF_TOAST_STEP2");
          } else {
            loadNtfPopups("NTF_TOAST_NEW", additionalData);
          }
          setCookie("ntfUserInelligibleSuccess", true, 365);
          setCookie(cookieName, true, 365);
          logEngagement(window.location.href, "revolve_global_footer", "email_signup_to_redeem_the_10%_off_coupon", params);
        } else if (result == ntfData.submitInvalid || result == ntfData.submitInvalidHighIPActivity) {
          if (result != ntfData.submitInvalidHighIPActivity) {
            input.val("");
            input.attr("placeholder", "Invalid email. Please try again");
          } else {
            pleaseTryAgainLaterFooter();
          }
          $triggerElement.prop('disabled', false);
        } else {
          $triggerElement.prop('disabled', false);
          console.log("Possible programming error: result not recognized, result[" + result + "], promoCode[" + promoCode + "]");
        }
      }
    });
  }
  if (window.rcProps.ga4TagID) {
    if (typeof gtag === 'undefined') {
      var _gtag2 = function _gtag2() {
        dataLayer.push(arguments);
      };
      window.dataLayer = window.dataLayer || [];
      _gtag2('js', new Date());
      _gtag2('config', window.rcProps.ga4TagID);
    }
    if (typeof gtag !== 'undefined') {
      gtag('event', 'newsletter_signup', {
        'send_to': window.rcProps.ga4TagID
      });
    }
  }
}
function validateEmail(email) {
  var emailRegEx = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
  return emailRegEx.test(email);
}
function pleaseTryAgainLaterFooter() {
  $("#email_signup_form--input").val("");
  $("#email_signup_form--input").attr("placeholder", "Too many requests. Please try tomorrow ");
}
function markFooterEmailFieldAsError(errorMessage) {
  $("#email-error-feedback_rev_mobile").text(errorMessage).show();
  $("#ntf_email_wrapper").addClass("is-error");
}

/***/ }),
/* 199 */
/***/ (function(module, exports) {

var engagementTrackingAction = 'product rec engagement';
$(document).ready(function () {
  $(window).on('carouselChange', function (e) {
    handleCarouselEngagement(e);
  });
  $(window).on('beforeunload', function () {
    endEngagement();
  });
  $(document).on('click', 'a.product-recs__link', function () {
    var activeCarousel = $(this).closest("section.product-recs");
    if (activeCarousel.hasClass("eng-tracking-on")) {
      activeCarousel.removeClass('eng-tracking-on');
      var data = {
        leftclick: activeCarousel.data("eng-left-click"),
        rightclick: activeCarousel.data("eng-right-click"),
        slideclick: $(this).data('slide-index') + 1
      };
      logEngagementWithDetails(window.location.href, activeCarousel.data("type"), engagementTrackingAction, JSON.stringify(data));
      activeCarousel.unbind('touchend');
    } else {
      activeCarousel.find('a.product-recs__link').each(function (index) {
        $(this).data('slide-index', index);
      });
      if ($('section.eng-tracking-on').length) {
        // slide clicked of the carousal which was not currently being tracked, so end tracking of the tracked carousal first.
        endEngagement();
      }
      var type = $($(this).closest('div[data-type]')).attr('data-type');
      var _data = {
        leftclick: 0,
        rightclick: 0,
        slideclick: $(this).data('slide-index') + 1
      };
      logEngagementWithDetails(window.location.href, type, engagementTrackingAction, JSON.stringify(_data));
    }
    clearTimeout(window.carouselEngagementTracker);
    window.carouselEngagementTracker = null;
  });
});
function endEngagement() {
  var activeCarousel = $('section.eng-tracking-on');
  clearTimeout(window.carouselEngagementTracker);
  window.carouselEngagementTracker = null;
  if (activeCarousel.length) {
    activeCarousel.removeClass('eng-tracking-on');
    var data = {
      leftclick: activeCarousel.data('eng-left-click'),
      rightclick: activeCarousel.data('eng-right-click')
    };
    activeCarousel.unbind('touchend');
    logEngagementWithDetails(activeCarousel.data("pageUrl"), activeCarousel.data("type"), engagementTrackingAction, JSON.stringify(data));
  }
}
function handleCarouselEngagement(e) {
  var startEngagement = function startEngagement() {
    var activeCarousel = $(e.originalEvent.tracking.element).closest("section.product-recs");
    activeCarousel.addClass("eng-tracking-on");
    activeCarousel.data("pageUrl", e.originalEvent.tracking.pageUrl);
    activeCarousel.data("type", e.originalEvent.tracking.type);
    activeCarousel.data("eng-left-click", 0);
    activeCarousel.data("eng-right-click", 1);
    activeCarousel.data("currentSlide", e.originalEvent.tracking.currentSlide);
    activeCarousel.find('a.product-recs__link').each(function (index) {
      $(this).data('slide-index', index);
    });
  };
  var resetEngagement = function resetEngagement() {
    endEngagement();
    startEngagement();
  };
  var continueEngagement = function continueEngagement() {
    var activeCarousel = $('section.eng-tracking-on');
    clearTimeout(window.carouselEngagementTracker);
    window.carouselEngagementTracker = null;
    var lastSlide = activeCarousel.data("currentSlide");
    if (lastSlide < e.originalEvent.tracking.currentSlide) {
      var rightClickCount = activeCarousel.data('eng-right-click');
      activeCarousel.data('eng-right-click', rightClickCount + 1);
    } else {
      var leftClickCount = activeCarousel.data('eng-left-click');
      activeCarousel.data('eng-left-click', leftClickCount + 1);
    }
    activeCarousel.data("currentSlide", e.originalEvent.tracking.currentSlide);
    window.carouselEngagementTracker = setTimeout(function () {
      endEngagement();
    }, 5000);
  };
  if ($('section.eng-tracking-on').length) {
    var activeCarousel = $(e.originalEvent.tracking.element).closest('section.product-recs');
    if (activeCarousel.hasClass('eng-tracking-on')) {
      continueEngagement();
    } else {
      resetEngagement();
    }
  } else {
    startEngagement();
  }
}

/***/ }),
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_lib__ = __webpack_require__(271);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__base_base__ = __webpack_require__(250);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__elements_elements__ = __webpack_require__(252);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__modules_modules__ = __webpack_require__(296);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__main_scss__ = __webpack_require__(352);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__main_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__main_scss__);






__WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).ready(function () {
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-image-carousel--rtl').slick({
    arrows: false,
    dots: true,
    slidesToShow: 1,
    lazyLoad: 'progressive',
    rtl: true,
    touchThreshold: 20
  });
});

/***/ }),
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */
/***/ (function(module, exports) {

function setUpSingleCarouselDirective() {
  var language = $('html').attr('lang');
  var rtlBool = language === 'ar';
  $('.js-directive-single-slide').each(function (i, item) {
    var $item = $(item);
    var $carousel = $item.find('.js-directive-carousel');
    $carousel.slick({
      lazyLoad: 'anticipated',
      slidesToShow: 1,
      slidesToScroll: 1,
      prevArrow: $item.find('.js-prev'),
      nextArrow: $item.find('.js-next'),
      rtl: rtlBool,
      touchThreshold: 20
    });
  });
}
$(function () {
  setUpSingleCarouselDirective();
});

/***/ }),
/* 210 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styleguide_lib_props__ = __webpack_require__(11);


var $window = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(window);
var $fixedModule = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(".js-fixed-corner");
var fixedOffClass = "fixed-corner--off";
var fixedOffHpClass = "fixed-corner--hp-off";
var hasAboutTheBrand = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#js-btt-fixed-target').length;
var $footerSurvey = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-footer-survey');
var hasFooterSurvey = $footerSurvey.length;
var bottomPaddingWhenScrolling = 30; // if this number is adjusted then the CSS `bottom` needs to match this number

// AB341
// This AB Tests puts the fixed corner element inside of the bottom section of the footer. Since it's position will be
// fixed to that footer element once you reach the bottom of the page.
var AB341 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_styleguide_lib_props__["a" /* get */])('rcProps.abTests.ab341', false);
var $footerBottomSection = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#js-footer-bottom-section');
if (AB341) {
  $fixedModule.attr('data-ab341', true);
  $footerBottomSection.append(__WEBPACK_IMPORTED_MODULE_0_jquery___default()(".js-fixed-corner")).css({
    'position': 'relative'
  });
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#country-prefs-footer').parent().attr('data-ab341-country-pref', true);
}
function fixedCorner() {
  //append ntf banner to footers wrapping div
  $fixedModule.append(__WEBPACK_IMPORTED_MODULE_0_jquery___default()("iframe#attentive_creative"));
  if ($fixedModule.length === 0) return;
  $window.on("scroll resize", function () {
    var docHeight = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).height();
    var windowHeight = window.screen.height;
    var scrollPosY = $window.scrollTop(); // scroll position from top of view
    var footerHeight = __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#site-footer").outerHeight(true);
    var footerHeightWOSurvey = AB341 ? $footerBottomSection.outerHeight(true) : __WEBPACK_IMPORTED_MODULE_0_jquery___default()(".site-footer").outerHeight(true);
    var footerScrollSurveyPosY = docHeight - footerHeightWOSurvey - windowHeight + bottomPaddingWhenScrolling;
    footerScrollSurveyPosY = AB341 ? footerScrollSurveyPosY + $fixedModule.outerHeight() + 27 + 16 : footerScrollSurveyPosY;
    var hasCookieBanner = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.cookies-banner').length;
    footerScrollSurveyPosY = hasCookieBanner ? footerScrollSurveyPosY - 16 : footerScrollSurveyPosY;
    if (hasFooterSurvey) {
      var designerScrollPosY = docHeight - footerHeight - windowHeight;
      designerScrollPosY = hasCookieBanner ? designerScrollPosY - 16 : designerScrollPozsY;
      var surveyHeight = -1 * $footerSurvey.height() - 16;
      var scrollAboveFooter = scrollPosY >= designerScrollPosY;
      handlePosition($fixedModule, scrollAboveFooter, hasCookieBanner, surveyHeight);

      // any other page with back to top
    } else {
      var _scrollAboveFooter = scrollPosY >= footerScrollSurveyPosY;
      handlePosition($fixedModule, _scrollAboveFooter, hasCookieBanner);
    }
  });

  // because footer is ab testing, we're updating margin on "About the brand" module
  if (__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.site-footer__spacing').length && hasAboutTheBrand) {
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#js-btt-fixed-target').css('margin-bottom', 0);
  }
}
function handlePosition($fixedModule, scrollAboveFooterContent, hasCookieBanner, newTopValue) {
  // if scroll position is above the footer fix to page
  if (scrollAboveFooterContent) {
    $fixedModule.removeClass(fixedOffHpClass);
    $fixedModule.addClass(fixedOffClass);
    if (newTopValue) {
      $fixedModule.css({
        top: newTopValue
      });
    }
    if (hasCookieBanner) {
      $fixedModule.css({
        bottom: ''
      });
    }
    // else position it absolute above the footer
  } else {
    $fixedModule.removeClass(fixedOffClass);
    $fixedModule.addClass(fixedOffHpClass);
    if (newTopValue) {
      $fixedModule.css({
        top: ''
      });
    }
    if (hasCookieBanner) {
      $fixedModule.css({
        bottom: 32
      });
    }
  }
}

// Scroll to top function
function scrollToTop() {
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()("html, body").animate({
    scrollTop: 0
  }, 300);
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()("html, body").find('#tr-burger-icon').focus();
}

// Handles back to top functionality and visibility
function backToTop() {
  var $backToTop = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(".back-to-top");
  //AB Test 721
  var backToTopFixed = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.nav__link--btt');
  //AB Test 721
  if (backToTopFixed.length) {
    backToTopFixed.on("click", function () {
      scrollToTop();
    });
  }

  // Check if back to top button exist
  if ($backToTop.length === 0) return;

  // Add click event to scroll to top of page
  $backToTop.on("click", function () {
    scrollToTop();
  });

  // Show $backToTop after scrolling 150px down page
  $window.on('scroll', function () {
    var scrollPos = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).scrollTop();
    if (scrollPos > 150) {
      $backToTop.css('visibility', 'visible');
    } else {
      $backToTop.css('visibility', 'hidden');
    }
  });
}

// checks toast email address
function toastEmailCheck() {
  var input = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#ntf-email-address');
  var value = input.val();
  // checks if email exists
  if (value == 'test@revolve.com') {
    __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.modal({
      open: "ntf-toast--existing",
      triggerOpen: true,
      type: "toast"
    });
  } else if (value == 'new@revolve.com') {
    // checks new email
    __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.modal({
      open: "ntf-toast--new",
      triggerOpen: true,
      type: "toast"
    });
  } else {
    // checks error for input field
    // back end to update error state
    input.closest('.field').addClass('is-error');
  }
}

// NTF mobile toast function
function toast() {
  var toast = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.fixed-toast');
  var close = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.fixed-toast--close');
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()(close).on('click', function () {
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()(toast).hide();
  });

  // email sign up form
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.ntf-toast--form').on('submit', function (event) {
    event.preventDefault();
    toastEmailCheck();
  });
}

// For pages with no scrolling - to reset live chat to correct fixed corner class
function removeHpOffForNoScroll() {
  var pageHasVerticalScroll = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).height() > $window.height();
  var noScrollLC = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-no-scroll-live-chat').length > 0;
  var fixedCorner = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-fixed-corner.fixed-bottom');
  var hpOffClass = 'fixed-corner--hp-off';
  var offClass = 'fixed-corner--off';
  if (!pageHasVerticalScroll && fixedCorner.length > 0 || noScrollLC && fixedCorner.length > 0) {
    fixedCorner.removeClass(hpOffClass);
    fixedCorner.addClass(offClass);
  }

  // Function to handle tab switch from inactive to active subscriptions tab to reset the fixed-corner class for Replenish & Save page if customer has active or inactive subscriptions
  function handleTabSwitch(tabName) {
    if (tabName === 'active-subscriptions') {
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()(fixedCorner).removeClass(hpOffClass);
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()(fixedCorner).addClass(offClass);
    } else if (tabName === 'inactive-subscriptions') {
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()(fixedCorner).removeClass(offClass);
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()(fixedCorner).addClass(hpOffClass);
    }
  }
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.tabs__nav .tabs__link').on('click', function (e) {
    e.preventDefault();
    var tabName = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).attr('href').substring(1);
    handleTabSwitch(tabName);
  });
}
__WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).ready(function () {
  fixedCorner();
  backToTop();
  toast();
  removeHpOffForNoScroll();
});

/***/ }),
/* 211 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_modules_logout__ = __webpack_require__(106);


/* harmony default export */ __webpack_exports__["a"] = (function (selector) {
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()(selector).on('click', function (e) {
    e.preventDefault();
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_modules_logout__["a" /* default */])();
  });
});
;

/***/ }),
/* 212 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);

function loadFavoriteCount() {
  return new Promise(function (resolve, reject) {
    __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.ajax({
      type: 'GET',
      url: '/content/favorites/count',
      success: function success(data) {
        resolve(data);
      },
      failure: function failure() {},
      error: function error(_error) {
        reject(_error);
      }
    });
  });
}
/* harmony default export */ __webpack_exports__["a"] = (loadFavoriteCount());

/***/ }),
/* 213 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);

function loadShoppingBagCount() {
  return new Promise(function (resolve, reject) {
    __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.ajax({
      type: 'GET',
      url: '/content/shoppingbag/getMinibagMarkup',
      success: function success(data) {
        resolve(data);
      },
      failure: function failure() {},
      error: function error(_error) {
        reject(_error);
      }
    });
  });
}
/* harmony default export */ __webpack_exports__["a"] = (loadShoppingBagCount());

/***/ }),
/* 214 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styleguide_styleguide__ = __webpack_require__(203);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__header__ = __webpack_require__(176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__footer__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__global__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_modules_loyalty__ = __webpack_require__(197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_modules_ntf__ = __webpack_require__(198);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_modules_ntf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_modules_ntf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_modules_product_rec_tracking__ = __webpack_require__(199);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_modules_product_rec_tracking___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_modules_product_rec_tracking__);








__WEBPACK_IMPORTED_MODULE_0_jquery___default()(window).on('load', function () {
  window.windowIsLoaded = true;
});

/***/ }),
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__global_log_engagement__ = __webpack_require__(33);
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }

document.addEventListener('DOMContentLoaded', function () {
  initDynamicSearchInputs();
});
$('.js-clear-search').on('click', function () {
  $('.ab854__search__textbox').val('');
  $(this).hide();
});
$(document).on('openSmartFilters', function (e) {
  $.modal({
    open: 'smart-filters',
    type: 'full',
    triggerOpen: true,
    // triggerElement: $(this),
    onComplete: function () {
      var init = false;
      return function () {
        if (init) {
          return;
        }
        initStickyCloseButtonObserver();
        init = true;
      };
    }(),
    onClose: function onClose() {
      var $form = $('#smart-filters-form');
      var fieldsetId = $form.data('fieldsetId');
      if (fieldsetId) {
        var $fieldset = $("#".concat(fieldsetId));
        var originalIndex = $fieldset.data('index');
        if (originalIndex) {
          $('fieldset', $form).eq(originalIndex - 1).after($fieldset);
        }
      }
      $form.data('fieldsetId', '');
    }
  });
});
$(function () {
  $('.js-smart-filter-question').on('click', function () {
    var $this = $(this);
    var fieldsetId = $this.data('fieldsetId');
    $('#smart-filters-form').data('fieldsetId', fieldsetId).prepend($("#".concat(fieldsetId)));
    $(document).trigger('openSmartFilters');
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__global_log_engagement__["b" /* logEngagementWithDetails */])(window.location.href, 'smart_filter_pill', 'click', $this.data('category'));
  });
});
function initStickyCloseButtonObserver() {
  var trigger = document.querySelector('.js-sticky-trigger');
  var topFixed = document.querySelector('.js-top-fixed');
  var closeButton = topFixed === null || topFixed === void 0 ? void 0 : topFixed.querySelector('.js-modal-close');
  if (!trigger || !topFixed || !closeButton) return;
  var observer = new IntersectionObserver(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 1),
      entry = _ref2[0];
    if (!entry.isIntersecting) {
      topFixed.classList.add('ab854__top-button--fixed');
      closeButton.classList.remove('u-margin-b--xl');
    } else {
      topFixed.classList.remove('ab854__top-button--fixed');
      closeButton.classList.add('u-margin-b--xl');
    }
  }, {
    root: null,
    threshold: 0
  });
  observer.observe(trigger);
}
function initDynamicSearchInputs() {
  var inputs = document.querySelectorAll('input.ab854__search__textbox');
  inputs.forEach(function (input) {
    if (input.dataset.dynamicBound) return;
    input.dataset.dynamicBound = 'true';
    var wrapper = input.closest('.ab854__search');
    input.addEventListener('focus', function handleFocus(event) {
      var originalInput = event.target;
      var wrapper = originalInput.closest('.ab854__search');
      var originalHeight = originalInput.offsetHeight;
      var iconSpan = wrapper.querySelector('span');
      var iconPaddingTop = iconSpan ? Math.max(0, (originalHeight - iconSpan.offsetHeight) / 2) : 0;

      // Create a wrapper for textarea + clear button
      var container = document.createElement('div');
      container.style.position = 'relative';
      container.style.flex = '1';
      container.style.minWidth = '0';

      // Create textarea
      var textarea = document.createElement('textarea');
      textarea.className = originalInput.className;
      textarea.name = originalInput.name;
      textarea.value = originalInput.value;
      textarea.placeholder = originalInput.placeholder;
      textarea.setAttribute('rows', '1');
      textarea.style.overflow = 'hidden';
      textarea.style.whiteSpace = 'normal';
      textarea.style.boxSizing = 'border-box';
      textarea.style.width = '100%';
      textarea.style.paddingRight = '2.5rem'; // Make space for the button
      textarea.style.height = originalHeight + 'px';

      // Create clear button
      var clearBtn = document.createElement('button');
      clearBtn.setAttribute('type', 'button');
      clearBtn.className = 'ab854__clear-search';
      clearBtn.innerHTML = '&times;';
      clearBtn.style.position = 'absolute';
      clearBtn.style.right = '0.6rem';
      clearBtn.style.top = originalHeight / 2 + 'px';
      clearBtn.style.transform = 'translateY(-50%)';
      clearBtn.style.background = 'transparent';
      clearBtn.style.border = 'none';
      clearBtn.style.fontSize = '1.5rem';
      clearBtn.style.color = '#333';
      clearBtn.style.cursor = 'pointer';
      clearBtn.style.lineHeight = '1';
      clearBtn.style.padding = '0';
      clearBtn.addEventListener('mousedown', function (e) {
        // Prevent textarea from losing focus before click logic runs
        e.preventDefault();
      });
      clearBtn.addEventListener('click', function (e) {
        e.preventDefault();
        textarea.value = '';
        textarea.style.height = 'auto';
        textarea.style.height = Math.max(textarea.scrollHeight, originalHeight) + 'px';
        textarea.focus(); // re-focus to keep textarea active
      });
      container.appendChild(textarea);
      container.appendChild(clearBtn);
      wrapper.replaceChild(container, originalInput);

      // Switch to top-aligned layout so icons stay pinned to the first line of
      // text as the textarea grows beyond a single line
      wrapper.style.alignItems = 'flex-start';
      if (iconSpan) iconSpan.style.paddingTop = iconPaddingTop + 'px';
      textarea.focus();

      // Handle pre-filled content that may require more than one line
      requestAnimationFrame(function () {
        textarea.style.height = 'auto';
        textarea.style.height = Math.max(textarea.scrollHeight, originalHeight) + 'px';
      });
      textarea.addEventListener('keydown', function (e) {
        if (e.key === 'Enter') {
          e.preventDefault();
          textarea.closest('form').requestSubmit();
        }
      });
      textarea.addEventListener('input', function () {
        textarea.style.height = 'auto';
        textarea.style.height = Math.max(textarea.scrollHeight, originalHeight) + 'px';
      });
      textarea.addEventListener('blur', function () {
        wrapper.style.alignItems = '';
        if (iconSpan) iconSpan.style.paddingTop = '';
        var newInput = document.createElement('input');
        newInput.type = 'text';
        newInput.className = textarea.className;
        newInput.name = textarea.name;
        newInput.value = textarea.value;
        newInput.placeholder = textarea.placeholder;
        newInput.dataset.dynamicBound = 'true';
        wrapper.replaceChild(newInput, container);
        newInput.addEventListener('focus', handleFocus);
      });
    });
  });
}
window.selectedFilterIdsMobile = new Set();
var smartFiltersQuestionIdMobile = null;

// Move a matching fieldset to the top of the modal question container
function reorderSmartFilterFieldsetsMobile($container, questionId) {
  if (!questionId) return;
  var $target = $container.find("fieldset[data-question-id=\"".concat(questionId, "\"]")).first();
  if (!$target.length) return;
  $target.prependTo($container);
}

// When user taps a question pill on PLP, open modal and reorder to that question
$(document).on('click', '.js-smart-filter-question-mock', function (e) {
  e.preventDefault();
  smartFiltersQuestionIdMobile = $(this).data('question-id') || null;

  // Reuse existing modal open path
  $('.smart-filters-mock').trigger('click');
});
$('.smart-filters-mock').on('click', function () {
  $.modal({
    url: 'smartFiltersModalMobile.html',
    type: 'full',
    triggerOpen: true,
    triggerElement: $('.smart-filters-trigger'),
    onComplete: function onComplete() {
      initStickyCloseButtonObserver();
      $.ajax({
        url: 'smartFilterModalQuestionsMobile.html',
        success: function success(response) {
          var _document$querySelect;
          var $questionContainer = $('.generated__questions');
          $questionContainer.append(response);
          $('.loading').hide();
          if (smartFiltersQuestionIdMobile) {
            reorderSmartFilterFieldsetsMobile($questionContainer, smartFiltersQuestionIdMobile);
            smartFiltersQuestionIdMobile = null;
          }
          $questionContainer.find('input[type="checkbox"]').each(function () {
            if (selectedFilterIdsMobile.has(this.id)) {
              this.checked = true;
            }
          });
          initDynamicSearchInputs();

          //Update button count + store selections on Apply
          (_document$querySelect = document.querySelector('.submit-questions')) === null || _document$querySelect === void 0 || _document$querySelect.addEventListener('click', function () {
            var checkedInputs = $questionContainer.find('input[type="checkbox"]:checked');
            selectedFilterIdsMobile = new Set();
            checkedInputs.each(function () {
              selectedFilterIdsMobile.add(this.id);
            });
            var checkedCount = checkedInputs.length;
            var $smartFiltersBtn = $('.smart-filters-trigger');
            $smartFiltersBtn.text(checkedCount > 0 ? "Filters (".concat(checkedCount, ")") : 'Filter');
          });
        }
      });
    }
  });
});

/***/ }),
/* 238 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = emailSignUp;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);

var SELECTORS = {
  container: '#email_signup_form'
};
var CLASS_NAMES = {
  error: 'error'
};
var METHOD = 'GET';
var PATH = '/r/ajax/SignUpForNewsletter.jsp';
__WEBPACK_IMPORTED_MODULE_0_jquery___default.a.extend(emailSignUp, {
  METHOD: METHOD,
  PATH: PATH,
  eventHandler: eventHandler,
  SELECTORS: SELECTORS,
  CLASS_NAMES: CLASS_NAMES
});
function emailSignUp() {
  var $emailForm = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(SELECTORS.container);
  var $emailInput = $emailForm.find("input");
  var email = $emailInput.val();
  var gender = $emailForm.data("gender");
  $emailInput.removeClass(CLASS_NAMES.error);
  if (email.indexOf("@") != -1) {
    return __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.get(PATH, {
      "email": email,
      "gender": gender
    }, function (r) {
      var msg = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.parseJSON(r);
      if (msg.success) {
        $emailForm.find("span").eq(0).show();
        $emailForm.find("input").hide();
        $emailForm.find("span").eq(1).hide();
        if (msg.cID) window.open("/r/mobile/email/subscribe_landing_m.jsp?cID=" + msg.cID + "&homePage=true");else window.open("/r/mobile/email/subscribe_landing_m.jsp?email=" + email + "&homePage=true");
      } else {
        displayError($emailInput, msg.msg0);
      }
    });
  } else {
    displayError($emailInput, 'Invalid email. Please try again');
    return __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.Deferred().reject(new Error('Invalid email'));
  }
}
function eventHandler(event) {
  event.preventDefault();
  emailSignUp();
}
function displayError($input, errorMsg) {
  $input.attr("placeholder", errorMsg).addClass(CLASS_NAMES.error).val("");
}

/***/ }),
/* 239 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export PLUGIN_NAME */
/* unused harmony export CLICK_EVENT */
/* unused harmony export DEFAULTS */
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styleguide_lib_register_jquery_plugin__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_styleguide_lib_merge_options__ = __webpack_require__(2);
/**
 * Creates a Slide up/down of Content
 * @module fixedOverlay
 */




var PLUGIN_NAME = 'fixedOverlay';
var CLICK_EVENT = 'click';
var DEFAULTS = {};

/**
 * Initializes an fixedOverlay based on provided parameters.
 * @param {HTMLElement} el - An element containing the elements for the
 * fixedOverlay
 * @param {Object} options - Options used for wiring up the fixedOverlay
 * @see DEFAULTS
 */

//export default function fixedOverlay(el, options = {}) {
function fixedOverlay(el) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var $el = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(el);
  var opts = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_styleguide_lib_merge_options__["a" /* default */])(DEFAULTS, options, $el);
  applyEventHandlers($el, opts);
}

/**
 * Applies any sort of event handlers for the fixedOverlay.
 * @param {jQuery} $el - Containing the elements for the fixedOverlay
 * @param {Object} options - Options used for wiring up the fixedOverlay
 * @see DEFAULTS
 */

var applyEventHandlers = function applyEventHandlers($el, opts) {
  opts = opts || {};

  //.js-fixed-overlay
  $el.on(CLICK_EVENT, function (evt) {
    showOverlay(evt, $el, opts);
  });

  //.js-fixed-overlay-close
  $el.next('.fixed-overlay__scroll').find('.js-fixed-overlay-close').on(CLICK_EVENT, function () {
    closeOverlay();
  });
};

/**
 * Handles the click event when a label has been iteracted with.
 * @param {jQuery.Event} evt - A jQuery event
 * @param {HTMLElement} currentTarget - The current target interacted with
 * @param {jQuery} $el - Containing the elements for the fixedOverlay
 * @param {Object} opts - Options passed along from initialization
 */

//Activate SlideUp Event
function showOverlay(e, $el) {
  var fixedOverlayScroll = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.fixed-overlay__scroll');
  var $elOverlayScroll = $el.siblings('.fixed-overlay__scroll');

  //Remove the ability to scroll main content while overlay is present
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('body').css({
    'overflow-y': 'hidden'
  });
  fixedOverlayScroll.removeClass('fixed-overlay__scroll--active');
  $elOverlayScroll.addClass('fixed-overlay__scroll--active');
}

//Activate SlideDown Event
function closeOverlay() {
  var fixedOverlayScroll = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.fixed-overlay__scroll');

  //Add back the ability to scroll main content when overlay is closed
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('body').css({
    'overflow-y': 'auto'
  });
  fixedOverlayScroll.removeClass('fixed-overlay__scroll--active');
}
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_styleguide_lib_register_jquery_plugin__["a" /* default */])(PLUGIN_NAME, fixedOverlay);

/***/ }),
/* 240 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export PLUGIN_NAME */
/* unused harmony export FOCUS_EVENT */
/* unused harmony export DEFAULTS */
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styleguide_lib_register_jquery_plugin__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_styleguide_lib_merge_options__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vendor_typeahead__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vendor_typeahead___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vendor_typeahead__);



 // Load typeahead jQuery plugin

var PLUGIN_NAME = 'inputSuggestion';
var FOCUS_EVENT = 'focus';
var DEFAULTS = {};
var states = ['Alabama', 'Alaska', 'Arizona', 'Arkansas', 'California', 'Colorado', 'Connecticut', 'Delaware', 'Florida', 'Georgia', 'Hawaii', 'Idaho', 'Illinois', 'Indiana', 'Iowa', 'Kansas', 'Kentucky', 'Louisiana', 'Maine', 'Maryland', 'Massachusetts', 'Michigan', 'Minnesota', 'Mississippi', 'Missouri', 'Montana', 'Nebraska', 'Nevada', 'New Hampshire', 'New Jersey', 'New Mexico', 'New York', 'North Carolina', 'North Dakota', 'Ohio', 'Oklahoma', 'Oregon', 'Pennsylvania', 'Rhode Island', 'South Carolina', 'South Dakota', 'Tennessee', 'Texas', 'Utah', 'Vermont', 'Virginia', 'Washington', 'West Virginia', 'Wisconsin', 'Wyoming'];
var states = new __WEBPACK_IMPORTED_MODULE_3_vendor_typeahead___default.a({
  datumTokenizer: __WEBPACK_IMPORTED_MODULE_3_vendor_typeahead___default.a.tokenizers.whitespace,
  queryTokenizer: __WEBPACK_IMPORTED_MODULE_3_vendor_typeahead___default.a.tokenizers.whitespace,
  // `states` is an array of state names defined in "The Basics"
  local: states
});
var cities_kw = new __WEBPACK_IMPORTED_MODULE_3_vendor_typeahead___default.a({
  datumTokenizer: __WEBPACK_IMPORTED_MODULE_3_vendor_typeahead___default.a.tokenizers.whitespace,
  queryTokenizer: __WEBPACK_IMPORTED_MODULE_3_vendor_typeahead___default.a.tokenizers.whitespace,
  prefetch: {
    url: '/r_c5e9d7052a36ab7c7c9f78b83ae37039badec36a/js/checkout/cities_kw.json',
    cache: false
  }
});
var cities_il = new __WEBPACK_IMPORTED_MODULE_3_vendor_typeahead___default.a({
  datumTokenizer: __WEBPACK_IMPORTED_MODULE_3_vendor_typeahead___default.a.tokenizers.whitespace,
  queryTokenizer: __WEBPACK_IMPORTED_MODULE_3_vendor_typeahead___default.a.tokenizers.whitespace,
  prefetch: '/r/js/checkout/cities_il.json'
});
var itemClickHandler = function itemClickHandler($el) {
  var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var dataSource = states;
  var dataName = 'states';
  if (__WEBPACK_IMPORTED_MODULE_0_jquery___default()($el).hasClass('typeahead_il')) {
    dataSource = cities_il;
    dataName = 'cities';
  } else if (__WEBPACK_IMPORTED_MODULE_0_jquery___default()($el).hasClass('typeahead_kw')) {
    dataSource = cities_kw;
    dataName = 'cities';
  }
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()($el).typeahead({
    hint: true,
    highlight: false,
    minLength: 1
  }, {
    name: dataName,
    source: dataSource
  });
};

/**
 * Applies any sort of event handlers for the toggleContent.
 * @private
 * @param {jQuery} $el - Containing the elements for the toggleContent
 * @param {Object} options - Options used for wiring up the toggleContent
 * @see DEFAULTS
 */
// const applyEventHandlers = ($el, opts = {}) => {
//   $el
//     .on(FOCUS_EVENT, evt => itemClickHandler(evt, $el, opts));
// };

/**
 * Initializes an toggleContent based on provided parameters.
 * @param {HTMLElement} el - An element containing the elements for the
 * toggleContent
 * @param {Object} options - Options used for wiring up the toggleContent
 * @see DEFAULTS
 */
function inputSuggestion(el) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var $el = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(el);
  var opts = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_styleguide_lib_merge_options__["a" /* default */])(DEFAULTS, options, $el);
  itemClickHandler($el, opts);
}

// Expose the function as a jQuery plugin for ease of use
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_styleguide_lib_register_jquery_plugin__["a" /* default */])(PLUGIN_NAME, inputSuggestion);

/***/ }),
/* 241 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export PLUGIN_NAME */
/* unused harmony export SCROLL_EVENT */
/* unused harmony export DEFAULTS */
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_throttle__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_throttle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_throttle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_styleguide_lib_register_jquery_plugin__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_styleguide_lib_merge_options__ = __webpack_require__(2);
/**
 * Responsible for lazy loading images in the DOM
 * @module lazyLoadImage
 */





var PLUGIN_NAME = 'lazyLoadImage';
var SCROLL_EVENT = 'scroll.lazyloadimage';
var DEFAULTS = {};
var $WINDOW = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(window);

/**
 * Handles the scroll event.
 * @param {jQuery} $el - Containing the elements for the lazyLoadImage
 * @param {Object} opts - Options passed along from initialization
 */
function loadImage($el, opts) {
  if ($el.attr('data-lazy-triggered-img') === 'false') {
    var imagePosition = $el.offset().top;
    var windowBottomPosition = $WINDOW.scrollTop() + $WINDOW.innerHeight();
    ;
    var imageSrc = $el.attr('data-lazy-img');
    if (windowBottomPosition >= imagePosition) {
      $el.attr('src', imageSrc);
      $el.attr('data-lazy-triggered-img', true);
    }
  }
}

/**
 * Applies any sort of event handlers for lazyLoadImage.
 * @param {jQuery} $el - Containing the elements for the lazyLoadImage
 * @param {Object} options - Options used for wiring up the lazyLoadImage
 * @see DEFAULTS
 */
function applyEventHandlers($el, opts) {
  $WINDOW.on(SCROLL_EVENT, __WEBPACK_IMPORTED_MODULE_1_lodash_throttle___default()(function () {
    loadImage($el, opts);
  }, 100));
}

/**
 * Initializes lazyLoadImage based on provided parameters.
 * @param {HTMLElement} el - An element containing the elements for the lazyLoadImage
 * @param {Object} options - Options used for wiring up the lazyLoadImage
 * @see DEFAULTS
 */
function lazyLoadImage(el) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var $el = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(el);
  var opts = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_styleguide_lib_merge_options__["a" /* default */])(DEFAULTS, options, $el);
  $el.attr('data-lazy-triggered-img', false);
  applyEventHandlers($el, opts);
}
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_styleguide_lib_register_jquery_plugin__["a" /* default */])(PLUGIN_NAME, lazyLoadImage);

/***/ }),
/* 242 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
// Toggle Page Overflow / Constraints

__WEBPACK_IMPORTED_MODULE_0_jquery___default()(function () {
  function toggleConstrainPage() {
    var $bodyAndHtml = __WEBPACK_IMPORTED_MODULE_0_jquery___default()("html, body");
    var constrainClass = "page-constrain";
    if (!$bodyAndHtml.hasClass(constrainClass)) {
      $bodyAndHtml.addClass(constrainClass);
    } else {
      $bodyAndHtml.removeClass(constrainClass);
    }
  }
  function removeConstrainPage() {
    var $bodyAndHtml = __WEBPACK_IMPORTED_MODULE_0_jquery___default()("html, body");
    var constrainClass = "page-constrain";
    $bodyAndHtml.removeClass(constrainClass);
  }
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()(".js-constrain-page").on("click", toggleConstrainPage);
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).on("toggleConstrainPage", toggleConstrainPage);
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).on("removeConstrainPage", removeConstrainPage);
});

/***/ }),
/* 243 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vendor_typeahead__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vendor_typeahead___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vendor_typeahead__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mustache__ = __webpack_require__(493);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mustache___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_mustache__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_styleguide_modules_keyboard__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_body_scroll_lock__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_body_scroll_lock___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_body_scroll_lock__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__modules_abtest_smart_filters__ = __webpack_require__(237);

 // Load typeahead jQuery plugin




var rcProps = window.rcProps;
var $backButton;
var backButtonPresent;
/* harmony default export */ __webpack_exports__["a"] = ((function () {
  function initTypeahead() {
    // Products
    var products = new __WEBPACK_IMPORTED_MODULE_1_vendor_typeahead___default.a({
      datumTokenizer: __WEBPACK_IMPORTED_MODULE_1_vendor_typeahead___default.a.tokenizers.obj.whitespace('productName'),
      queryTokenizer: __WEBPACK_IMPORTED_MODULE_1_vendor_typeahead___default.a.tokenizers.whitespace,
      remote: {
        url: '/r/ajax/VisualSearch.jsp?q=%QUERY&d=' + rcProps.get('department'),
        wildcard: '%QUERY'
      }
    });

    // Text Suggestions
    var textSuggestions = new __WEBPACK_IMPORTED_MODULE_1_vendor_typeahead___default.a({
      datumTokenizer: __WEBPACK_IMPORTED_MODULE_1_vendor_typeahead___default.a.tokenizers.obj.whitespace('searchTerm'),
      queryTokenizer: __WEBPACK_IMPORTED_MODULE_1_vendor_typeahead___default.a.tokenizers.whitespace,
      remote: {
        url: '/r/ajax/TextSuggestions.jsp?q=%QUERY&d=' + rcProps.get('department'),
        wildcard: '%QUERY'
      }
    });
    $backButton = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#nav-go-back-btn');
    backButtonPresent = $backButton.is(':visible');
    var recentSearchCount = 0;
    __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.get(window.rcProps.search.recentSearchHref).done(function (recentSearchJson) {
      if (Array.isArray(recentSearchJson)) {
        var $ul = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('<ul class="ui-list n-block-grid--2-textSuggestions">');
        recentSearchJson.splice(0, rcProps.get('search.recentSearchLimit')).forEach(function (recentSearch) {
          $ul.append(__WEBPACK_IMPORTED_MODULE_2_mustache___default.a.render(rcProps.get('search.recentSearchTemplate'), {
            searchText: recentSearch.searchText,
            href: recentSearch.href
          }));
          recentSearchCount++;
        });
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#recent-searched-viewed').css({
          'position': 'relative',
          'top': '100%',
          'left': '0px',
          'z-index': '100',
          'width': '100%',
          'display': 'inline-block'
        }).append($ul);
      }
    });

    // Sets up the 'search' button to toggle the search area and set focus.
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#tr_top_search_btn').click(function () {
      var $this = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this);
      var $toggleEl = __WEBPACK_IMPORTED_MODULE_0_jquery___default()($this.attr('data-toggle'));
      var $input = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-site-search__textbox');
      var $focusInput = $input.is(':visible');
      $toggleEl.slideToggle();

      // On open
      if ($focusInput) {
        $input.focus();
        if (backButtonPresent) {
          $backButton.hide();
        }
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-horizontal-scroll').horizontalScroll();
        setTimeout(function () {
          __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-search-horizontal-scroll').horizontalScroll('showImages');
        });
      }
      logEngagement('search_engagement');
    });
    var sources = [{
      hint: false,
      highlight: true,
      minLength: rcProps.get('search.minLengthBeforeSuggesting'),
      classNames: {
        menu: 'site-search__results',
        highlight: 'site-search__highlight',
        dataset: 'g n-block-grid--2'
      }
    }, {
      name: 'textSuggestions',
      display: function display(obj) {
        return obj.suggestion;
      },
      source: textSuggestions,
      templates: {
        suggestion: function () {
          var template = rcProps.get('search.text.templates.line');
          return function (data) {
            var gender = (data.gender || '').toLowerCase();
            return __WEBPACK_IMPORTED_MODULE_2_mustache___default.a.render(template, {
              suggestion: data.suggestion,
              isBrand: data.termType === 'Brand',
              isWomens: gender === 'womens',
              isMens: gender === 'mens',
              isKids: gender === 'kids'
            });
          };
        }()
      },
      limit: recentSearchCount === 0 ? rcProps.get('search.text.defaultCount') : rcProps.get('search.text.limit') - Math.min(recentSearchCount, rcProps.get('search.recentSearchLimit'))
    }];

    //separate func for finding search product headers
    function switchInnerProductRecsHed() {
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()(function () {
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.site-search__results > .ui-list.horizontal-scroll.u-flex > .product-recs__hed').each(function () {
          __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).parent().before(this);
        });
      });
    }
    function checkRecsScrollPos() {
      var recScrollPosInterval = setInterval(function () {
        var $recsScroll = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.site-search__results').find('.horizontal-scroll');
        if ($recsScroll.scrollLeft() === 0 && __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.site-search__results').css('display') != 'none') {
          clearInterval(recScrollPosInterval);
        }
        $recsScroll.scrollLeft(0, 0);
      }, 1);
    }
    if (rcProps.get('search.showVisualSuggestions')) {
      sources.push({
        name: 'products',
        display: 'productName',
        source: products,
        templates: {
          header: function header(data) {
            if (data && data.query && data.query.length >= rcProps.get('search.visual.minLengthBeforeSearching')) {
              switchInnerProductRecsHed();
              __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#js-search-hed-target').first().remove();
              checkRecsScrollPos();
              return rcProps.get('search.visual.templates.headerRelated');
            } else {
              switchInnerProductRecsHed();
              __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#js-search-hed-target').first().remove();
              checkRecsScrollPos();
              return rcProps.get('search.visual.templates.headerRecent');
            }
          },
          suggestion: function () {
            var template = rcProps.get('search.visual.templates.line');
            return function (data) {
              return __WEBPACK_IMPORTED_MODULE_2_mustache___default.a.render(template, data);
            };
          }()
        },
        limit: rcProps.get('search.visual.limit')
      });
    }

    // Creates typeahead feature on search box.
    var textbox = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-site-search__textbox');
    textbox.typeahead.apply(textbox, sources).on('typeahead:select', function (event, suggestion) {
      logEngagement('click_search_suggestion_' + (suggestion.termType || 'search'));
      var redirectUrl;
      if ('productURL' in suggestion) {
        redirectUrl = suggestion.productURL;
        // window.location.href = suggestion.productURL;
      } else if ('suggestionUrl' in suggestion) {
        redirectUrl = suggestion.suggestionUrl;
        // window.location.href = suggestion.suggestionUrl;
      } else {
        //call to SearchController will handle inserting recent search to redis
        window.location.href = '/content/s/ct?type=' + suggestion.typeShortCode + '&q=' + suggestion.searchTerm + '&s=' + suggestion.suggestion + '&d=' + rcProps.get('department');
      }
      insertSuggestedText(suggestion.suggestion, function () {
        window.location.href = redirectUrl;
      });
    });

    // Stacked Search Suggestion Layout
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.tt-dropdown-menu').addClass('site-search__predictions').css({
      'left': '',
      'z-index': '',
      'right': ''
    });
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.twitter-typeahead').addClass('site-search__typeahead form-search__input').css({
      display: 'inline-block'
    });
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.tt-dataset-textSuggestions').addClass('site-search__suggestions');
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.tt-dataset-products').addClass('g').addClass('n-block-grid--2');
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.site-search__results ul').first().removeClass('g n-block-grid--2');
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.site-search__results ul').next().removeClass('g n-block-grid--2 n-block-grid--2-products').addClass('horizontal-scroll u-flex form-search__scroll');
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.site-search__results').appendTo('.form-search__wrap');
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.tt-highlight').addClass('site-search__highlight');
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.tt-dataset-products').addClass('predict-related');
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.site-search__results').insertAfter('.twitter-typeahead');
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.site-search__results').css({
      width: '100%'
    });
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#recent-searched-viewed').insertAfter('.site-search__results > .n-block-grid--2-textSuggestions');

    // AB-553 start
    if (__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.ab553').length) {
      var $searchField = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.form-search__input');
      $searchField.append("\n\t\t\t<div class=\"form-search__controls\">\n                                <button id=\"x_clear\" type=\"reset\"\n                                        class=\"form-search__x js-toggle-form-search-x is-active\">\n                                            <span class=\"icon icon--clear icon--sm\">\n                                                <svg viewBox=\"0 0 16 16\" aria-hidden=\"true\" focusable=\"false\"\n                                                     role=\"presentation\">\n                                                    <path d=\"M8 2a6.02 6.02 0 0 0-6 6 6.02 6.02 0 0 0 6 6 6.02 6.02 0 0 0 6-6 6.02 6.02 0 0 0-6-6zm2.8 7.7c.3.3.3.8 0 1.1s-.8.3-1.1 0L8 9.1l-1.7 1.7c-.3.3-.8.3-1.1 0-.2-.3-.2-.8 0-1.1L7 8 5.2 6.3C5 6 5 5.5 5.2 5.2c.3-.3.8-.3 1.1 0L8 6.9l1.7-1.7c.3-.3.8-.3 1.1 0s.3.8 0 1.1L9.1 8l1.7 1.7z\"/>\n                                                </svg>\n                                            </span>\n                                    <span class=\"u-screen-reader\">clear search</span>\n                                </button>\n                                <button id=\"visual-search-button\" class=\"js-modal form-search__visual js-image-search-btn\" type=\"button\">\n                                <span class=\"icon\">\n                                    <svg xmlns=\"http://www.w3.org/2000/svg\" data-name=\"Layer 1\" viewBox=\"0 0 26 24\" aria-hidden=\"true\" focusable=\"false\" role=\"presentation\">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<path d=\"M22.25 3.2h-3.13C17.93 1.29 15.82 0 13.4 0h-.8c-2.42 0-4.53 1.29-5.72 3.2H3.75C1.68 3.2 0 4.88 0 6.95v13.3C0 22.32 1.68 24 3.75 24h18.5c2.07 0 3.75-1.68 3.75-3.75V6.95c0-2.07-1.68-3.75-3.75-3.75m0 19.3H3.75c-1.24 0-2.25-1.01-2.25-2.25V6.95c0-1.24 1.01-2.25 2.25-2.25h3.99l.21-.4c.88-1.67 2.63-2.8 4.64-2.8h.8c2.01 0 3.76 1.13 4.64 2.8l.21.4h3.99c1.24 0 2.25 1.01 2.25 2.25v13.3c0 1.24-1.01 2.25-2.25 2.25Z\"/>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<path d=\"M13 19.1c-3.5 0-6.35-2.85-6.35-6.35S9.5 6.4 13 6.4s6.35 2.85 6.35 6.35S16.5 19.1 13 19.1m0-11.2c-2.67 0-4.85 2.18-4.85 4.85S10.33 17.6 13 17.6s4.85-2.18 4.85-4.85S15.67 7.9 13 7.9\"/>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</svg>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<span class=\"u-screen-reader\">Visual search</span>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</span>\n                                </button>\n                            </div>\n\t\t\t");
    }
    // AB-553 end
  }
  __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.fn.changeElementType = function (newType) {
    var attrs = {};
    __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.each(this[0].attributes, function (idx, attr) {
      attrs[attr.nodeName] = attr.nodeValue;
    });
    this.replaceWith(function () {
      return __WEBPACK_IMPORTED_MODULE_0_jquery___default()('<' + newType + '/>', attrs).append(__WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).contents());
    });
  };
  function logEngagement(action) {
    console.log('logEngagement("' + action + '")');
    __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.ajax({
      type: 'POST',
      data: __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.param({
        url: window.location.href,
        module: 'mobile_search',
        action: action
      }),
      url: '/r/ajax/LogEngagement.jsp'
    });
  }
  function insertSuggestedText(suggestedText, callback) {
    __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.ajax({
      type: 'POST',
      data: __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.param({
        searchText: suggestedText
      }),
      url: '/r/ajax/InsertRecentSearch.jsp',
      complete: function complete() {
        if (typeof callback == 'function') {
          callback();
        }
      }
    });
  }
  function initEventHandlers() {
    // get vars
    var $favoritesBtn = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#tr_top_heart_mhp');
    var $cartBtn = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#tr_top_bag_mhp');
    var $searchBtn = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#tr_top_search_btn');
    var $revolveLogo = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#rev-logo');
    var $backToNav = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.form-search__back');
    var $clearSearchBtn = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-toggle-form-search-x');
    var $searchForm = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-search-form');
    var $searchFormBlock = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-search-form-block');
    var $recentSearchedViewed = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#recent-searched-viewed');
    var $burgerMenu = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#tr-burger-icon');
    var $searchInput = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-site-search__textbox');
    var $submitSearch = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.form-search__submit');
    var $searchResults = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.site-search__results');
    var $headerHeight = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('header').height();
    var $searchHorizontalScroll = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.ui-list.horizontal-scroll.u-flex');
    var AB_CLASS_SELECTOR = '.ab553';
    var AB_553_ACTIVE = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(AB_CLASS_SELECTOR).length;
    var $visualSearchButton = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-image-search-btn');

    //register clicks and toggle classes

    __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.tt-input').on('typeahead:asyncreceive', function (ev, suggestion) {
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#ariaSearchContainer').empty();
      var totalResults = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.site-search__results ul li').length;
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#ariaSearchContainer').append(totalResults + ' results are available');
    });
    //search initialized
    function triggerSearch() {
      var $siteHeader = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.site-header');
      var $searchFormContianer = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-search-form-block');
      var searchFormActive = $searchForm.hasClass('is-displayed');
      $siteHeader.css('padding-bottom', '0');
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.form-search__wrap').appendTo('body');
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.form-search__wrap').show();
      if (!searchFormActive) {
        $searchForm.addClass('is-displayed');
        $backToNav.addClass('is-active');
        $siteHeader.addClass('search-is-active');
        if (__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.form-search__scroll').length > 0) {
          __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.form-search__scroll').addClass('form-search__scroll--active');
        }
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()("<div class='form-search-overlay'></div>").appendTo('body').on('click', function () {
          endSearch();
        });
        $searchForm.attr('toggle-body-lock', 'true');
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_body_scroll_lock__["disableBodyScroll"])(__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.site-search__results')[0]);
      }
      $burgerMenu.hide();
      $revolveLogo.hide();
      $searchBtn.hide();
      $favoritesBtn.hide();
      $cartBtn.hide();
      $searchForm.show();
      $searchInput.focus();
      $searchFormBlock.attr('aria-modal', 'true');
      __WEBPACK_IMPORTED_MODULE_3_styleguide_modules_keyboard__["a" /* default */].trapFocus($searchFormContianer);
    }

    // submit or back to navigation
    function endSearch() {
      var searchFormActive = $searchForm.hasClass('is-displayed');
      var $searchFormContianer = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-search-form-block');
      var $siteHeader = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.site-header');
      if (searchFormActive) {
        $searchForm.removeClass('is-displayed');
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.form-search__wrap').hide();
        $backToNav.removeClass('is-active');
        $siteHeader.css('padding-bottom', '');
        $siteHeader.removeClass('search-is-active');
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.form-search-overlay').remove();
        $searchForm.attr('toggle-body-lock', '');
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_body_scroll_lock__["enableBodyScroll"])(__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.site-search__results')[0]);
      }
      $searchForm.hide();
      $revolveLogo.show();
      $searchBtn.show();
      $favoritesBtn.show();
      $cartBtn.show();
      $searchFormBlock.attr('aria-modal', 'false');
      __WEBPACK_IMPORTED_MODULE_3_styleguide_modules_keyboard__["a" /* default */].releaseFocus($searchFormContianer);
      if (backButtonPresent) {
        $backButton.show();
      } else {
        $burgerMenu.show();
      }
      $searchBtn.trigger('focus');
      if (AB_553_ACTIVE) {
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()('body').css('overflow', '');
      }
    }
    //clear typed characters
    function clearSearch() {
      $searchInput.typeahead('val', '');
      $searchInput.focus();
      $searchResults.hide();
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.site-search__results').find('.n-block-grid--2-textSuggestions').html(''); // try to clear search suggestions
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.site-search__results > .ui-list.horizontal-scroll.u-flex').scrollLeft(0, 0);
    }
    $searchBtn.on('click', function (event) {
      triggerSearch(event);
    });
    $clearSearchBtn.on('click', function () {
      clearSearch();
      $searchForm.removeClass('form-search--full');
      if (AB_553_ACTIVE) {
        $visualSearchButton.removeClass('u-hide');
      }
    });
    $submitSearch.on('click', function () {
      endSearch();
    });
    $backToNav.on('click', function () {
      endSearch();
    });
    $searchInput.on('focus', function () {
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).val('');
    });
    $searchInput.on('input', function () {
      if (__WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).val().length > 0) {
        $searchForm.addClass('form-search--full');
        if (AB_553_ACTIVE) {
          $visualSearchButton.addClass('u-hide');
        }
      } else {
        $searchForm.removeClass('form-search--full');
        if (AB_553_ACTIVE) {
          $visualSearchButton.removeClass('u-hide');
        }
      }
    });
  }
  return {
    init: function init() {
      if (!__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-site-search__textbox').length) {
        return;
      }
      initTypeahead();
      initEventHandlers();
    }
  };
})());

/***/ }),
/* 244 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = shopTheLook;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__entry_points_pdp_add_to_bag__ = __webpack_require__(13);


/**
 * Toggles the visibility of an element and updates its aria-hidden attribute.
 * 
 * @param {string} selector - The jQuery selector for the element to toggle.
 * @param {boolean} show - Whether to show or hide the element.
 */
var toggleVisibility = function toggleVisibility(selector, show) {
  $(selector).toggle(show).attr('aria-hidden', !show);
};

/**
* Handles the click event for the back button in the qv modal.
* 
* @param {string} sizesContent - The selector for the sizes content element.
*/
var handleBackButtonClick = function handleBackButtonClick(sizesContent) {
  toggleVisibility('.js-shop-the-look-carousel', true);
  toggleVisibility('.js-shop-the-look-sizes', false);
  toggleVisibility(sizesContent, false);
};

/**
* Handles the form submission for adding a product size to the bag.
* 
* @param {Event} e - The form submission event.
* @param {string} productSizes - The name attribute of the product sizes input elements.
* @returns {boolean} - False if the form submission should be prevented.
*/
var handleFormSubmit = function handleFormSubmit(e, productSizes) {
  if (e) {
    e.preventDefault();
  }
  var $selectedSize = $("input[name='" + productSizes + "']:checked");
  var $errorContainer = $('.js-shop-the-look-error');
  var sizeVal = $selectedSize.val();
  if (!sizeVal) {
    $errorContainer.show().trigger('focus');
    $("input[name='".concat(productSizes, "']")).on('click', function () {
      $errorContainer.hide();
    });
    return false;
  }
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__entry_points_pdp_add_to_bag__["a" /* addToBag */])($selectedSize.data('code'), sizeVal);
};

/**
* Handles the click event for the add-to-bag button, showing the appropriate sizes content.
* 
* @param {jQuery} addToBagProduct - The jQuery object for the add-to-bag button.
*/
var handleAddToBagClick = function handleAddToBagClick(addToBagProduct) {
  var sizesContent = "#".concat(addToBagProduct.data('sizeContent'));
  var productSizes = addToBagProduct.data('sizes');
  if ($("input[name='" + productSizes + "']:checked").length) {
    handleFormSubmit(null, productSizes);
  } else {
    toggleVisibility('.js-shop-the-look-carousel', false);
    toggleVisibility('.js-shop-the-look-sizes', true);
    toggleVisibility(sizesContent, true);
    $('.js-shop-the-look-back').on('click', function () {
      return handleBackButtonClick(sizesContent);
    });
    $('#shop-the-look-size-atb').on('submit', function (e) {
      return handleFormSubmit(e, productSizes);
    });
  }
};

/**
* Initializes and opens the qv modal, setting up event handlers.
*/
var openModal = function openModal(triggerElement) {
  var paramsData = {
    qvId: triggerElement.data("qvId")
  };
  var navSrc = triggerElement.data("navsrc");
  if (navSrc && navSrc.length > 0) {
    paramsData['navsrc'] = navSrc;
  }
  if (window.rcProps.isApp) {
    window.location.href = "".concat(window.rcProps.shopTheLookModalHref, "?qvId=").concat(paramsData.qvId, "&navSrc=").concat(paramsData.navsrc);
  } else {
    $.modal({
      data: paramsData,
      url: window.rcProps.shopTheLookModalHref,
      triggerOpen: true,
      addModifierClass: 'modal--toast-no-padding-x',
      type: 'toast',
      triggerElement: triggerElement,
      hasBodyScroll: false,
      onComplete: function onComplete() {
        $('.js-horizontal-scroll').horizontalScroll();
        $('.js-qv-multi-add').on('click', function (evt) {
          var addToBagProduct = $(evt.currentTarget);
          handleAddToBagClick(addToBagProduct);
        });
      }
    });
  }
};

/**
* Sets up the click event listener to open the qv modal.
* 
* @param {jQuery} $el - The jQuery object for the modal trigger element.
*/
var setEventListeners = function setEventListeners($el) {
  $el.on('click', function (e) {
    var triggerElement = $(e.currentTarget);
    console.log('triggerElement', triggerElement);
    openModal(triggerElement);
  });
};

/**
* Initializes the Quick View Multi-Products modal and sets up event listeners.
*/
function shopTheLook() {
  var $el = $('.js-shop-the-look');
  if ($el.length) {
    setEventListeners($el);
  }
}

/***/ }),
/* 245 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vendor_jquery_smartbanner__ = __webpack_require__(248);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vendor_jquery_smartbanner___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__vendor_jquery_smartbanner__);


/* harmony default export */ __webpack_exports__["a"] = (function (localOptions) {
  var defaultOptions = {
    appendToSelector: '#home'
  };
  var globalOptions = window.rcProps && window.rcProps.smartBanner || {};
  localOptions = localOptions || {};
  return __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.smartbanner(__WEBPACK_IMPORTED_MODULE_0_jquery___default.a.extend(true, defaultOptions, globalOptions, localOptions));
});
;

/***/ }),
/* 246 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export PLUGIN_NAME */
/* unused harmony export DEFAULTS */
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styleguide_lib_register_jquery_plugin__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_styleguide_lib_merge_options__ = __webpack_require__(2);
// Import necessary dependencies




// require('../vendor/typeahead');

// Define plugin name and default options
var PLUGIN_NAME = 'stateSearch';
var DEFAULTS = {
  shippingZipCode: ""
};

// List of states and their respective zip codes (for demonstration purposes)
var states = ['Alabama', 'Alaska', 'Arizona', 'Arkansas', 'California, 90703', 'Colorado', 'Connecticut', 'Delaware', 'Florida', 'Georgia', 'Hawaii', 'Idaho', 'Illinois', 'Indiana', 'Iowa', 'Kansas', 'Kentucky', 'Louisiana', 'Maine', 'Maryland', 'Massachusetts', 'Michigan', 'Minnesota', 'Mississippi', 'Missouri', 'Montana', 'Nebraska', 'Nevada', 'New Hampshire', 'New Jersey', 'New Mexico', 'New York', 'North Carolina', 'North Dakota', 'Ohio', 'Oklahoma', 'Oregon', 'Pennsylvania', 'Rhode Island', 'South Carolina', 'South Dakota', 'Tennessee', 'Texas', 'Utah', 'Vermont', 'Virginia', 'Washington', 'West Virginia', 'Wisconsin', 'Wyoming'];

/**
 * Extracts the zip code from a given suggestion string.
 * @param {string} suggestion - The selected state and zip code suggestion.
 * @returns {string} - Extracted zip code value.
 */
var getZipCodeValue = function getZipCodeValue(suggestion) {
  var values = suggestion.split(",");
  var lastValue = values[values.length - 1].trim(); // Get and trim the last element
  return lastValue;
};

/**
 * Fills the zip code input field based on the selected suggestion.
 * @param {string} suggestion - The selected state and zip code suggestion.
 * @param {Object} opts - Options object containing the zip code input field ID.
 */
var fillZipCode = function fillZipCode(suggestion, opts) {
  var zipCodeInput = opts.zipCodeInput;
  var $shippingZipCodeInput = __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#".concat(zipCodeInput));
  var zipCode = getZipCodeValue(suggestion);
  $shippingZipCodeInput.val(zipCode);
};

/**
 * Creates a substring matcher for the typeahead functionality.
 * @param {Array<string>} strs - List of strings to match against.
 * @returns {function} - A function that returns matches for a given query.
 */
var substringMatcher = function substringMatcher(strs) {
  return function findMatches(query, callback) {
    var matches = [];
    var substrRegex = new RegExp(query, 'i'); // Case-insensitive regex for matching

    // Find all strings containing the query
    __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.each(strs, function (i, str) {
      if (substrRegex.test(str)) {
        matches.push(str);
      }
    });
    callback(matches); // Return matches via the callback
  };
};

/**
 * Initializes the typeahead functionality on a given element.
 * @param {jQuery} $el - The jQuery-wrapped element to initialize the typeahead on.
 * @param {Object} opts - Options object containing configurations.
 */
var initializeTypeahead = function initializeTypeahead($el, opts) {
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()(".js-state-search").typeahead({
    hint: true,
    highlight: true,
    minLength: 1
  }, {
    name: 'states',
    source: substringMatcher(states),
    a11y: false
  });

  // Bind the select event to populate the zip code field
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-state-search').on('typeahead:select', function (ev, suggestion) {
    fillZipCode(suggestion, opts);
  });
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-state-search').on('typeahead:autocomplete', function (ev, suggestion) {
    fillZipCode(suggestion, opts);
  });
};

/**
 * Main function to initialize the state search plugin.
 * @param {HTMLElement} el - The container element for the plugin.
 * @param {Object} options - Configuration options for the plugin.
 */
function stateSearch(el, options) {
  var $el = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(el); // Convert the element to a jQuery object
  var opts = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_styleguide_lib_merge_options__["a" /* default */])(DEFAULTS, options, $el); // Merge default and provided options
  initializeTypeahead($el, opts); // Initialize the typeahead functionality
}

// Register the plugin with jQuery
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_styleguide_lib_register_jquery_plugin__["a" /* default */])(PLUGIN_NAME, stateSearch);

/***/ }),
/* 247 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);

var ERROR_CLASS = 'is-error';
var ARIA_INVALID = 'aria-invalid';
/* harmony default export */ __webpack_exports__["a"] = (function (selector) {
  var zipField = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(selector);
  var isValid = true;
  if (zipField.length > 0) {
    var zipCode = zipField.val();
    var valid = /^[0-9]{5}(?:-[0-9]{4})?$/.test(zipCode);
    if (!valid) {
      zipField.closest('.field').addClass(ERROR_CLASS);
      zipField.attr(ARIA_INVALID, true);
      isValid = false;
    } else {
      zipField.closest('.field').removeClass(ERROR_CLASS);
      zipField.attr(ARIA_INVALID, false);
    }
  }
  return isValid;
});
;

/***/ }),
/* 248 */
/***/ (function(module, exports) {

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
//
// jQuery Smart Banner
// Copyright (c) 2012 Arnold Daniels <arnold@jasny.net>
// Based on 'jQuery Smart Web App Banner' by Kurt Zenisek @ kzeni.com
//
!function ($) {
  var SmartBanner = function SmartBanner(options) {
    this.origHtmlMargin = parseFloat($('html').css('margin-top')); // Get the original margin-top of the HTML element so we can take that into account
    this.options = $.extend({}, $.smartbanner.defaults, options);
    var standalone = navigator.standalone // Check if it's already a standalone web app or running within a webui view of an app (not mobile safari)
      ,
      UA = navigator.userAgent;

    // Detect banner type (iOS or Android)
    if (this.options.force) {
      this.type = this.options.force;
    } else if (UA.match(/Windows Phone 8/i) != null && UA.match(/Touch/i) !== null) {
      this.type = 'windows';
    } else if (UA.match(/iPhone|iPod/i) != null || UA.match(/iPad/) && this.options.iOSUniversalApp) {
      if (UA.match(/Safari/i) != null && (UA.match(/CriOS/i) != null || window.Number(UA.substr(UA.indexOf('OS ') + 3, 3).replace('_', '.')) < 6)) this.type = 'ios'; // Check webview and native smart banner support (iOS 6+)
    } else if (UA.match(/\bSilk\/(.*\bMobile Safari\b)?/) || UA.match(/\bKF\w/) || UA.match('Kindle Fire')) {
      this.type = 'kindle';
    } else if (UA.match(/Android/i) != null) {
      this.type = 'android';
    }

    // Don't show banner if device isn't iOS or Android, website is loaded in app or user dismissed banner
    if (!this.type || standalone) {
      //|| this.getCookie('sb-closed') || this.getCookie('sb-installed')
      return;
    }

    // Calculate scale
    this.scale = this.options.scale == 'auto' ? $(window).width() / window.screen.width : this.options.scale;
    if (this.scale < 1) this.scale = 1;

    // Get info from meta data
    var meta = $(this.type == 'android' ? 'meta[name="google-play-app"]' : this.type == 'ios' ? 'meta[name="apple-itunes-app"]' : this.type == 'kindle' ? 'meta[name="kindle-fire-app"]' : 'meta[name="msApplication-ID"]');
    if (meta.length == 0) return;

    // For Windows Store apps, get the PackageFamilyName for protocol launch
    if (this.type == 'windows') {
      this.appId = $('meta[name="msApplication-PackageFamilyName"]').attr('content');
    } else {
      // Try to pull the appId out of the meta tag and store the result
      var parsedMetaContent = /app-id=([^\s,]+)/.exec(meta.attr('content'));
      if (parsedMetaContent) {
        this.appId = parsedMetaContent[1];
      } else {
        return;
      }
    }
    this.title = this.options.title ? this.options.title : meta.data('title') || $('title').text().replace(/\s*[|\-·].*$/, '');
    this.author = this.options.author ? this.options.author : meta.data('author') || ($('meta[name="author"]').length ? $('meta[name="author"]').attr('content') : window.location.hostname);
    this.iconUrl = meta.data('icon-url');
    this.price = meta.data('price');

    // Set default onInstall callback if not set in options
    if (typeof this.options.onInstall === 'function') {
      this.options.onInstall = this.options.onInstall;
    } else {
      this.options.onInstall = function () {};
    }

    // Set default onClose callback if not set in options
    if (typeof this.options.onClose === 'function') {
      this.options.onClose = this.options.onClose;
    } else {
      this.options.onClose = function () {};
    }

    // Create banner
    this.create();
    this.show();
    this.listen();
  };
  SmartBanner.prototype = {
    constructor: SmartBanner,
    create: function create() {
      var iconURL,
        link = this.options.url ? this.options.url : (this.type == 'windows' ? 'ms-windows-store:navigate?appid=' : this.type == 'android' ? 'market://details?id=' : this.type == 'kindle' ? 'amzn://apps/android?asin=' : 'https://itunes.apple.com/' + this.options.appStoreLanguage + '/app/id') + this.appId,
        price = this.price || this.options.price,
        inStore = price ? price + ' - ' + (this.type == 'android' ? this.options.inGooglePlay : this.type == 'kindle' ? this.options.inAmazonAppStore : this.type == 'ios' ? this.options.inAppStore : this.options.inWindowsStore) : '',
        gloss = this.options.iconGloss === null ? this.type == 'ios' : this.options.iconGloss;
      if (this.type == 'android' && this.options.GooglePlayParams) {
        link = link + '&referrer=' + this.options.GooglePlayParams;
      }
      var banner = '<div id="smartbanner" class="' + this.type + '"><div class="sb-container"><a href="#" class="sb-close">&times;</a><span class="sb-icon"></span><div class="sb-info"><strong>' + this.title + '</strong><span>' + this.author + '</span><span>' + inStore + '</span></div><a href="' + link + '" class="sb-button"><span>' + this.options.button + '</span></a></div></div>';
      this.options.layer ? $(this.options.appendToSelector).append(banner) : $(this.options.appendToSelector).prepend(banner);
      if (this.options.icon) {
        iconURL = this.options.icon;
      } else if (this.iconUrl) {
        iconURL = this.iconUrl;
      } else if ($('link[rel="apple-touch-icon-precomposed"]').length > 0) {
        iconURL = $('link[rel="apple-touch-icon-precomposed"]').attr('href');
        if (this.options.iconGloss === null) gloss = false;
      } else if ($('link[rel="apple-touch-icon"]').length > 0) {
        iconURL = $('link[rel="apple-touch-icon"]').attr('href');
      } else if ($('meta[name="msApplication-TileImage"]').length > 0) {
        iconURL = $('meta[name="msApplication-TileImage"]').attr('content');
      } else if ($('meta[name="msapplication-TileImage"]').length > 0) {
        /* redundant because ms docs show two case usages */
        iconURL = $('meta[name="msapplication-TileImage"]').attr('content');
      }
      if (iconURL) {
        $('#smartbanner .sb-icon').css('background-image', 'url(' + iconURL + ')');
        if (gloss) $('#smartbanner .sb-icon').addClass('gloss');
      } else {
        $('#smartbanner').addClass('no-icon');
      }
      this.bannerHeight = $('#smartbanner').outerHeight() + 2;
      if (this.scale > 1) {
        $('#smartbanner').css('top', parseFloat($('#smartbanner').css('top')) * this.scale).css('height', parseFloat($('#smartbanner').css('height')) * this.scale).hide();
        $('#smartbanner .sb-container').css('-webkit-transform', 'scale(' + this.scale + ')').css('-msie-transform', 'scale(' + this.scale + ')').css('-moz-transform', 'scale(' + this.scale + ')').css('width', $(window).width() / this.scale);
      }
      $('#smartbanner').css('position', this.options.layer ? 'absolute' : 'static');
    },
    listen: function listen() {
      $('#smartbanner .sb-close').on('click', $.proxy(this.close, this));
      $('#smartbanner .sb-button').on('click', $.proxy(this.install, this));
    },
    show: function show(callback) {
      var banner = $('#smartbanner');
      banner.stop();
      if (this.options.layer) {
        banner.animate({
          top: 0,
          display: 'block'
        }, this.options.speedIn).addClass('shown').show();
        $(this.pushSelector).animate({
          paddingTop: this.origHtmlMargin + this.bannerHeight * this.scale
        }, this.options.speedIn, 'swing', callback);
      } else {
        if ($.support.transition) {
          banner.animate({
            top: 0
          }, this.options.speedIn).addClass('shown');
          var transitionCallback = function transitionCallback() {
            $('html').removeClass('sb-animation');
            if (callback) {
              callback();
            }
          };
          $(this.pushSelector).addClass('sb-animation').one($.support.transition.end, transitionCallback).emulateTransitionEnd(this.options.speedIn).css('margin-top', this.origHtmlMargin + this.bannerHeight * this.scale);
        } else {
          banner.slideDown(this.options.speedIn).addClass('shown');
        }
      }
    },
    hide: function hide(callback) {
      var banner = $('#smartbanner');
      banner.stop();
      if (this.options.layer) {
        banner.animate({
          top: -1 * this.bannerHeight * this.scale,
          display: 'block'
        }, this.options.speedIn).removeClass('shown');
        $(this.pushSelector).animate({
          paddingTop: this.origHtmlMargin
        }, this.options.speedIn, 'swing', callback);
      } else {
        if ($.support.transition) {
          if (this.type !== 'android') banner.css('top', -1 * this.bannerHeight * this.scale).removeClass('shown');else banner.css({
            display: 'none'
          }).removeClass('shown');
          var transitionCallback = function transitionCallback() {
            $('html').removeClass('sb-animation');
            if (callback) {
              callback();
            }
          };
          $(this.pushSelector).addClass('sb-animation').one($.support.transition.end, transitionCallback).emulateTransitionEnd(this.options.speedOut).css('margin-top', this.origHtmlMargin);
        } else {
          banner.slideUp(this.options.speedOut).removeClass('shown');
        }
      }
    },
    close: function close(e) {
      e.preventDefault();
      $("#smartbanner").slideUp();
      //this.hide();
      this.setCookie('sb-closed', 'true', this.options.daysHidden);
      this.options.onClose(e);
    },
    install: function install(e) {
      if (this.options.hideOnInstall) {
        this.hide();
      }
      this.setCookie('sb-installed', 'true', this.options.daysReminder);
      this.options.onInstall(e);
    },
    setCookie: function setCookie(name, value, exdays) {
      var exdate = new Date();
      exdate.setDate(exdate.getDate() + exdays);
      value = encodeURI(value) + (exdays == null ? '' : '; expires=' + exdate.toUTCString());
      document.cookie = name + '=' + value + '; path=/;';
    },
    getCookie: function getCookie(name) {
      var i,
        x,
        y,
        ARRcookies = document.cookie.split(";");
      for (i = 0; i < ARRcookies.length; i++) {
        x = ARRcookies[i].substr(0, ARRcookies[i].indexOf("="));
        y = ARRcookies[i].substr(ARRcookies[i].indexOf("=") + 1);
        x = x.replace(/^\s+|\s+$/g, "");
        if (x == name) {
          return decodeURI(y);
        }
      }
      return null;
    }

    // Demo only
    ,
    switchType: function switchType() {
      var that = this;
      this.hide(function () {
        that.type = that.type == 'android' ? 'ios' : 'android';
        var meta = $(that.type == 'android' ? 'meta[name="google-play-app"]' : 'meta[name="apple-itunes-app"]').attr('content');
        that.appId = /app-id=([^\s,]+)/.exec(meta)[1];
        $('#smartbanner').detach();
        that.create();
        that.show();
      });
    }
  };
  $.smartbanner = function (option) {
    var $window = $(window),
      data = $window.data('smartbanner'),
      options = _typeof(option) == 'object' && option;
    if (!data) $window.data('smartbanner', data = new SmartBanner(options));
    if (typeof option == 'string') data[option]();
  };

  // override these globally if you like (they are all optional)
  $.smartbanner.defaults = {
    title: null,
    // What the title of the app should be in the banner (defaults to <title>)
    author: null,
    // What the author of the app should be in the banner (defaults to <meta name="author"> or hostname)
    price: 'FREE',
    // Price of the app
    appStoreLanguage: 'us',
    // Language code for App Store
    inAppStore: 'On the App Store',
    // Text of price for iOS
    inGooglePlay: 'In Google Play',
    // Text of price for Android
    inAmazonAppStore: 'In the Amazon Appstore',
    inWindowsStore: 'In the Windows Store',
    //Text of price for Windows
    GooglePlayParams: null,
    // Aditional parameters for the market
    icon: null,
    // The URL of the icon (defaults to <meta name="apple-touch-icon">)
    iconGloss: null,
    // Force gloss effect for iOS even for precomposed
    button: 'Install',
    // Text for the install button
    url: null,
    // The URL for the button. Keep null if you want the button to link to the app store.
    scale: 'auto',
    // Scale based on viewport size (set to 1 to disable)
    speedIn: 300,
    // Show animation speed of the banner
    speedOut: 400,
    // Close animation speed of the banner
    daysHidden: 15,
    // Duration to hide the banner after being closed (0 = always show banner)
    daysReminder: 90,
    // Duration to hide the banner after "VIEW" is clicked *separate from when the close button is clicked* (0 = always show banner)
    force: null,
    // Choose 'ios', 'android' or 'windows'. Don't do a browser check, just always show this banner
    hideOnInstall: true,
    // Hide the banner after "VIEW" is clicked.
    layer: false,
    // Display as overlay layer or slide down the page
    iOSUniversalApp: true,
    // If the iOS App is a universal app for both iPad and iPhone, display Smart Banner to iPad users, too.
    appendToSelector: 'body',
    //Append the banner to a specific selector
    pushSelector: 'html' // What element is going to push the site content down; this is where the banner append animation will start.
  };
  $.smartbanner.Constructor = SmartBanner;

  // ============================================================
  // Bootstrap transition
  // Copyright 2011-2014 Twitter, Inc.
  // Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)

  function transitionEnd() {
    var el = document.createElement('smartbanner');
    var transEndEventNames = {
      WebkitTransition: 'webkitTransitionEnd',
      MozTransition: 'transitionend',
      OTransition: 'oTransitionEnd otransitionend',
      transition: 'transitionend'
    };
    for (var name in transEndEventNames) {
      if (el.style[name] !== undefined) {
        return {
          end: transEndEventNames[name]
        };
      }
    }
    return false; // explicit for ie8 (  ._.)
  }
  if ($.support.transition !== undefined) return; // Prevent conflict with Twitter Bootstrap

  // http://blog.alexmaccaw.com/css-transitions
  $.fn.emulateTransitionEnd = function (duration) {
    var called = false,
      $el = this;
    $(this).one($.support.transition.end, function () {
      called = true;
    });
    var callback = function callback() {
      if (!called) $($el).trigger($.support.transition.end);
    };
    setTimeout(callback, duration);
    return this;
  };
  $(function () {
    $.support.transition = transitionEnd();
  });
  // ============================================================
}(window.jQuery);

/***/ }),
/* 249 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);

__WEBPACK_IMPORTED_MODULE_0_jquery___default()(function () {
  // Only run if it's the A/B test's results page
  if (__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.ab553').length && __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#visual-search-cards').length) {
    window.rcProps = window.rcProps || {};
    var response = window.rcProps.imageSearchResult || {};
    var selectedSegmentId = Number(window.rcProps.imageSearchSegmentId) || 0;
    var imageSearchBaseUrlBySegmentId = window.rcProps.imageSearchBaseUrlBySegmentId;

    /**
     * CARD_W / CARD_H are the rendered dimensions of each card.
     * These dimensions are lifted directly from the Figma spec.
     */
    var CARD_W = 60;
    var CARD_H = 72;
    var activeSegmentId = null;
    var $cardsContainer = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#visual-search-cards');

    /**
     * Returns the CSS width, height, and transform needed to zoom and
     * pan a source <img> so that the bbox region fills the card.
     *
     * @param {Array}  bbox   [x1, y1, x2, y2] in source image pixels
     * @param {number} imageW Natural width of the source image
     * @param {number} imageH Natural height of the source image
     * @param {number} cardW  Rendered card width in px
     * @param {number} cardH  Rendered card height in px
     * @returns {Object}      { width, height, transform } as CSS strings
     */
    var getBboxStyles = function getBboxStyles(bbox, imageW, imageH, cardW, cardH) {
      var x1 = bbox[0];
      var y1 = bbox[1];
      var x2 = bbox[2];
      var y2 = bbox[3];

      // How large is the region in the source image?
      var regionW = x2 - x1;
      var regionH = y2 - y1;

      // How much do we scale up the full image so this region fills the card?
      // Math.max = cover behaviour: the tighter axis drives the scale,
      // the other axis may overflow slightly — hidden by overflow: hidden.
      var scaleX = cardW / regionW;
      var scaleY = cardH / regionH;
      var scale = Math.max(scaleX, scaleY);

      // Full image rendered dimensions at this scale
      var renderedW = imageW * scale;
      var renderedH = imageH * scale;

      // Slide the image so the bbox region is centred in the card window.
      // -(x1 * scale) aligns the region's left edge to the card's left edge,
      // then we add half the leftover to centre it horizontally (and same for Y).
      var offsetX = -(x1 * scale) + (cardW - regionW * scale) / 2;
      var offsetY = -(y1 * scale) + (cardH - regionH * scale) / 2;
      return {
        width: "".concat(renderedW, "px"),
        height: "".concat(renderedH, "px"),
        transform: "translate(".concat(offsetX, "px, ").concat(offsetY, "px)")
      };
    };
    var buildCardInner = function buildCardInner(imageUrl, imgStyles) {
      var alt = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
      var $img = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('<img>', {
        "class": 'visual-search-results__card-img',
        src: imageUrl,
        alt: alt
      }).css({
        width: imgStyles.width,
        height: imgStyles.height,
        transform: imgStyles.transform
      });
      return __WEBPACK_IMPORTED_MODULE_0_jquery___default()('<div>', {
        "class": 'visual-search-results__card-inner'
      }).append($img);
    };
    var handleCardClick = function handleCardClick($clicked) {
      activeSegmentId = $clicked.data('segmentid');
      $cardsContainer.find('button.visual-search-results__card').each(function forEachCard() {
        var isActive = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).data('segmentid') === activeSegmentId;
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).toggleClass('visual-search-results__card--active', isActive).attr('aria-pressed', String(isActive));
      });
    };
    var renderCards = function renderCards(data) {
      var imageUrl = data.imageUrl,
        imageW = data.imageW,
        imageH = data.imageH,
        _data$segments = data.segments,
        segments = _data$segments === void 0 ? [] : _data$segments;
      $cardsContainer.empty();
      __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.each(segments, function (i, segment) {
        var styles = getBboxStyles(segment.bbox, imageW, imageH, CARD_W, CARD_H);
        var $btn = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('<button>', {
          "class": 'visual-search-results__card',
          type: 'button',
          'aria-label': "Filter by ".concat(segment.segmentName),
          'aria-pressed': 'false',
          'data-segmentid': segment.id,
          'data-segment': segment.segmentName,
          'data-category': segment.category,
          'data-descriptions': JSON.stringify(segment.descriptions)
        }).append(buildCardInner(imageUrl, styles, segment.segmentName));
        $cardsContainer.append($btn);
      });
      var $matchedBtn = $cardsContainer.find('button.visual-search-results__card').filter(function filterMatched() {
        return __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).data('segmentid') === selectedSegmentId;
      }).first();

      // selected segment or default the first card per design spec
      var $defaultBtn = $cardsContainer.find('button.visual-search-results__card').first();
      var $targetBtn = $matchedBtn.length ? $matchedBtn : $defaultBtn;
      handleCardClick($targetBtn);
    };
    $cardsContainer.on('click', 'button.visual-search-results__card', function onCardClick() {
      var $clicked = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this);
      handleCardClick($clicked);
      var segmentId = Number($clicked.data('segmentid')) || 0;
      var redirectUrl = "".concat(imageSearchBaseUrlBySegmentId).concat(segmentId);
      window.location.href = redirectUrl;
    });

    // Preload the image to determine its natural dimensions before rendering cards
    var img = new Image();
    img.onload = function loadImage() {
      response.imageW = img.naturalWidth;
      response.imageH = img.naturalHeight;
      renderCards(response);
    };
    img.src = response.imageUrl;
  }
});

/***/ }),
/* 250 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__load_image__ = __webpack_require__(251);


__WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).ready(function () {
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('body').attr('ontouchstart', '');
});
__WEBPACK_IMPORTED_MODULE_0_jquery___default()(window).on('load', function () {
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-lazy-instant').loadImage();
});

/***/ }),
/* 251 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export PLUGIN_NAME */
/* unused harmony export DEFAULT_OPTIONS */
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_register_jquery_plugin__ = __webpack_require__(1);
/**
 * Loads image by replacing the src with data attr
 * @module load-image
 */


var PLUGIN_NAME = 'loadImage';
var DEFAULT_OPTIONS = {
  attr: 'data-src'
};

/**
 * Initial function to load image
 * @param {HTMLElement} image - Image to update
 */
function loadImage(image) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _Object$assign = Object.assign({}, DEFAULT_OPTIONS, options),
    attr = _Object$assign.attr;
  var src = image.getAttribute(attr);
  if (src) {
    image.setAttribute('src', src);
  }
  return image;
}

// Expose the function as a jQuery plugin for ease of use
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__lib_register_jquery_plugin__["a" /* default */])(PLUGIN_NAME, loadImage);

/***/ }),
/* 252 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__toggle_favorite__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__fields_validator__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__fields_invalidate__ = __webpack_require__(262);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__fields_error_summary__ = __webpack_require__(255);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__fields_form_field__ = __webpack_require__(260);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__fields_validate_field__ = __webpack_require__(267);







__WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).ready(function () {
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-fav-button').toggleFavorite({
    container: document.body
  });
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()(document.querySelectorAll('[data-validate]')).validator().errorSummary();
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()(document.body).formField();
});

/***/ }),
/* 253 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export CHARACTER_COUNTER_OPTIONS */
/* unused harmony export BLOCK */
/* unused harmony export COUNT_ELEMENT */
/* unused harmony export COUNT_BLOCK_ELEMENT */
/* unused harmony export COUNT_BLOCK_ERROR */
/* unused harmony export COUNT_BLOCK_ELEMENT_ERROR */
/* unused harmony export WRAPPER_SELECTOR */
/* unused harmony export COUNT_SELECTOR */
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_register_jquery_plugin__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_random__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_stache__ = __webpack_require__(38);
/**
 * Responsible for displaying available characters in a textarea and limiting
 * the amount that can be submitted.
 * @module elements/fields/characterCounter
 */




/**
 * Defines the default options for the a character counter
 * @type {Object}
 */
var CHARACTER_COUNTER_OPTIONS = {
  fieldSelector: 'textarea',
  insertPosition: 'afterbegin',
  a11yCounterTemplate: '{{remaining}} {{remaining|pluralize:"character,characters"}} remaining'
};

/**
 * Defines the block name for the element injected into the DOM.
 * @type {string}
 */
var BLOCK = 'character-counter';

/**
 * Defines the count element injected into the DOM.
 * @type {string}
 */
var COUNT_ELEMENT = 'count';

/**
 * Defines the name of the block and count element.
 * @type {string}
 */
var COUNT_BLOCK_ELEMENT = "".concat(BLOCK, "__").concat(COUNT_ELEMENT);

/**
 * Defines an error block.
 * @type {string}
 */
var COUNT_BLOCK_ERROR = "".concat(BLOCK, "--invalid");

/**
 * Defines an error block element combo.
 * @type {string}
 */
var COUNT_BLOCK_ELEMENT_ERROR = "".concat(COUNT_BLOCK_ELEMENT, "--invalid");

/**
 * Defines the block selector
 * @type {string}
 */
var WRAPPER_SELECTOR = ".".concat(BLOCK);

/**
 * Defines the count block element selector
 * @type {string}
 */
var COUNT_SELECTOR = ".".concat(COUNT_BLOCK_ELEMENT);

/**
 * Updates an element with the text count in the textarea.
 * @param {HTMLElement} countEl - Element being updated
 * @returns {Function} When the event is fired off
 */
var makeUpdateCount = function makeUpdateCount(countEl, a11yCountEl, getA11yCounter) {
  return function (e) {
    var length = e.target.value.length;
    // eslint-disable-next-line no-param-reassign
    countEl.innerText = length;
    // eslint-disable-next-line no-param-reassign
    a11yCountEl.innerText = getA11yCounter(length);
  };
};

/**
 * Responsible for making a set of elements valid.
 * @param {HTMLElement} wrapper - Container of character count
 * @param {HTMLElement} count - Element containing the count
 * @returns {Function} When the event is fired off
 */
var makeValid = function makeValid(wrapper, count) {
  return function () {
    wrapper.classList.remove(COUNT_BLOCK_ERROR);
    count.classList.remove(COUNT_BLOCK_ELEMENT_ERROR);
  };
};

/**
 * Responsible for making a set of elements invalid.
 * @param {HTMLElement} wrapper - Container of character count
 * @param {HTMLElement} count - Element containing the count
 */
var makeInvalid = function makeInvalid(wrapper, count) {
  return function () {
    wrapper.classList.add(COUNT_BLOCK_ERROR);
    count.classList.add(COUNT_BLOCK_ELEMENT_ERROR);
  };
};

/**
 * Creates the character counter markup used to keep track of character
 * counting.
 * @private
 * @param  {string} count - The amount of characters in the field
 * @param  {string} maxLength - The maximum length for the field
 * @param  {string} [className=''] - Additional className
 * @return {string} Fully formed HTML
 */
var createCharacterCounterComponent = function createCharacterCounterComponent(_ref) {
  var count = _ref.count,
    maxLength = _ref.maxLength,
    id = _ref.id,
    a11yText = _ref.a11yText,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className;
  return "\n  <span class=\"".concat(BLOCK, " ").concat(className, "\">\n    <span id=\"").concat(id, "\" aria-live=\"polite\" class=\"u-screen-reader\">").concat(a11yText, "</span>\n    <span class=\"").concat(COUNT_BLOCK_ELEMENT, "\">").concat(count, "</span>\n    / ").concat(maxLength, "\n  </span>\n");
};

/**
 * Responsible for setup and eventually rendering a11y counter text.
 * @param {string} template - Template string
 * @param {number} length - The max characters allowed in the textarea
 * @return {Function} When called renders template
 */
var makeGetA11yCounter = function makeGetA11yCounter(template, length) {
  return function (count) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__lib_stache__["a" /* default */])(template, {
      remaining: length - count
    });
  };
};

/**
 * Responsible for either getting a field id if one does not already exist.
 * @param {HTMLElement} field - The field in question
 * @returns {string} A field id
 */
var resolveFieldId = function resolveFieldId(field) {
  var ariaAttr = 'aria-describedby';
  var describedBy = field.getAttribute(ariaAttr);
  if (describedBy) {
    return describedBy;
  }
  var id = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__lib_random__["a" /* default */])({
    prefix: 'character-counter'
  });
  field.setAttribute(ariaAttr, id);
  return id;
};

/**
 * Responsible for providing feedback to the user with the amount of characters
 * entered alongside the amount allowed. This is achieved by the following:
 *
 * - Read in the maxlength attribute (if not provided, throws an error since
 *   without it we don't know what to do)
 * - create some HTML that illustrates how many characters are in a given area,
 *   along with the maximum amount of characters
 *
 * From the DOM side, this can take in optional parameters in the form of
 * data attributes:
 *
 * - data-character-counter-add-class-name: allows for a custom class name to
 *   be added to the feedback mechanism created within.
 * - data-character-insert-position: the insert position based the element
 *   passed in using the position values found on insertAdjacentHTML. If this
 *   doesn't exist, it'll use the one provided on wiring, and then fallback to
 *   afterbegin.
 *
 * This happens when the field (an input or textarea) first loads as well as
 * when the user starts entering in characters. Here's an example of markup
 * using all options:
 *
 * @example
 * <div class="things"
 *      data-character-counter-add-class-name="yo-dawg"
 *      data-character-counter-insert-position="beforebegin">
 *   <textarea maxlength="100"></textarea>
 * </div>
 *
 * which will yield:
 *
 * @example
 * <div class="things"
 *      data-character-counter-add-class-name="yo-dawg"
 *      data-character-counter-insert-position="beforebegin">
 *   <span class="character-counter yo-dawg">
 *     <span class="character-counter__count">0</span> / 200
 *   </span>
 *   <textarea maxlength="100"></textarea>
 * </div>
 *
 * @param {HTMLElement} el - Contains the form field
 * @param {Object} options - Configurable options
 */
function characterCounter(el) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _ref2 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : __WEBPACK_IMPORTED_MODULE_0__lib_register_jquery_plugin__["b" /* noopActions */],
    deregister = _ref2.deregister;
  // The jQuery lookup is for PhantomJS because it's lame and doesn't know how
  // to read from el.dataset because it sucks at life. There, I said it.
  var _Object$assign = Object.assign({}, CHARACTER_COUNTER_OPTIONS, options, el.dataset),
    fieldSelector = _Object$assign.fieldSelector,
    insertPosition = _Object$assign.insertPosition,
    _Object$assign$charac = _Object$assign.characterCounterAddClassName,
    className = _Object$assign$charac === void 0 ? '' : _Object$assign$charac,
    dataAttrInsertPosition = _Object$assign.characterCounterInsertPosition,
    a11yCounterTemplate = _Object$assign.a11yCounterTemplate;
  var field = el.querySelector(fieldSelector);
  var maxLength = field.maxLength;
  var getA11yCounter = makeGetA11yCounter(a11yCounterTemplate, +maxLength);
  if (maxLength < 0) {
    throw new Error("Character counter requires a max length on ".concat(fieldSelector));
  }
  var fieldId = resolveFieldId(field);
  el.insertAdjacentHTML(dataAttrInsertPosition || insertPosition, createCharacterCounterComponent({
    className: className,
    count: field.value.length,
    maxLength: maxLength,
    a11yText: getA11yCounter(field.value.length),
    id: fieldId
  }));
  var wrapperEl = el.querySelector(WRAPPER_SELECTOR);
  var countEl = el.querySelector(COUNT_SELECTOR);
  var a11yCountEl = el.querySelector("#".concat(fieldId));
  var listeners = [{
    evt: 'input',
    handler: makeUpdateCount(countEl, a11yCountEl, getA11yCounter)
  }, {
    evt: 'focus',
    handler: makeValid(wrapperEl, countEl)
  }, {
    evt: 'invalid',
    handler: makeInvalid(wrapperEl, countEl)
  }];
  listeners.forEach(function (_ref3) {
    var evt = _ref3.evt,
      handler = _ref3.handler;
    field.addEventListener(evt, handler);
  });
  return {
    refreshCounter: function refreshCounter() {
      var event = new Event('input');
      field.dispatchEvent(event);
    },
    removeListeners: function removeListeners() {
      deregister();
      listeners.forEach(function (_ref4) {
        var evt = _ref4.evt,
          handler = _ref4.handler;
        field.removeEventListener(evt, handler);
      });
    }
  };
}
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__lib_register_jquery_plugin__["a" /* default */])('characterCounter', characterCounter);

/***/ }),
/* 254 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export DEFAULT_TEMPLATES */
/* unused harmony export EVENTS */
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_stache__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_register_jquery_plugin__ = __webpack_require__(1);
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * Generically handles various error states around a field
 * @module elements/fields/entry-error
 */






/**
 * Templates used as an absolute fallback
 * @typedef {Object} EntryErrorDefaultTemplates
 * @property {string} requiredTemplate - Template for required error message
 * @property {string} invalidTemplate - Template for invalid error message
 */
var DEFAULT_TEMPLATES = {
  requiredTemplate: 'valid entry required',
  invalidTemplate: 'enter a valid entry'
};
/**
 * Configurable options entry error
 * @typedef {Object} EntryErrorOptions
 * @property {string} label - Label or name of the field
 * @property {string} requiredAttr - Attribute used for indicating field
 * is required
 * @property {string} entryErrorRequiredMessage - Overrides the default
 * required error message
 * @property {string} entryErrorInvalidMessage - Overrides the default
 * required invalid message
 * @property {string} requiredTemplate - Template used for the required error
 * message
 * @property {string} invalidTemplate - Template used for the invalid error
 * message
 * @property {string} selectRequiredTemplate - Template used for the required
 * error message for a select element
 */
/**
 * @type EntryErrorOptions
 */
var DEFAULT_ERROR_LABEL_OPTIONS = {
  label: null,
  requiredAttr: 'data-validate-not-empty',
  entryErrorRequiredMessage: '',
  entryErrorInvalidMessage: '',
  requiredTemplate: '{{label}} entry required',
  invalidTemplate: 'enter a valid {{label}}',
  selectRequiredTemplate: '{{label}} selection required'
};
var EVENT_NS = '.entry-label';
var ELEMENT_ERROR_TEMPLATES = {
  select: 'selectRequiredTemplate'
};
/**
 * Responsible for taking event names and appending a namespace
 * @param {Object} events - Key/value mapping of events
 * @returns {Object} Applicable events containing a namespace
 */
var appendNamespaceToEvents = function appendNamespaceToEvents(events) {
  return Object.keys(events).reduce(function (acc, name) {
    return Object.assign({}, acc, _defineProperty({}, name, events[name] + EVENT_NS));
  }, {});
};
var EVENTS = {
  INVALID: 'invalid',
  BLUR: 'blur',
  CHANGE: 'change',
  INPUT: 'input'
};
var _appendNamespaceToEve = appendNamespaceToEvents(EVENTS),
  INVALID = _appendNamespaceToEve.INVALID,
  BLUR = _appendNamespaceToEve.BLUR,
  CHANGE = _appendNamespaceToEve.CHANGE,
  INPUT = _appendNamespaceToEve.INPUT;

/**
 * Performs any sort of clean up
 * @param {jQuery} $el - Form field
 * @param {Function} deregister - Internally removes the plugin from the
 * registery
 */
var destroy = function destroy($el, deregister) {
  return function () {
    $el.off(EVENT_NS);
    deregister();
  };
};

/**
 * Responsible for resetting an error on a field
 * @param {HTMLElement} el - Form field
 */
var resetField = function resetField(el) {
  el.setCustomValidity('');
  el.setAttribute('aria-invalid', false);
};

/**
 * Responsible for resetting an error on a field based on an event
 * @param {jQuery.Event} e - A dom event
 */
var resetFieldFromEvent = function resetFieldFromEvent(e) {
  resetField(e.target);
};

/**
 * Responsible creating the ability to set an error message
 * @param {jQuery} $el - Form field
 * @param {string} requiredMessage - Error message when a field is required
 * @param {string} invalidMessage - Error message when a field is invalid
 * @returns {Function} Called on to set a possible error message
 */
var makeSetMessage = function makeSetMessage($el, requiredMessage, invalidMessage) {
  return function () {
    var el = $el[0];
    if (!$el.val()) {
      $el.attr('aria-invalid', true);
      el.setCustomValidity(requiredMessage);
      return;
    }
    if ($el.data('entryErrorDisableInvalid')) {
      $el.attr('aria-invalid', false);
      return;
    }
    if ($el.is(':invalid')) {
      $el.attr('aria-invalid', true);
      el.setCustomValidity(invalidMessage);
      return;
    }
    resetField(el);
  };
};

/**
 * Responsible for applying an error if applicable
 * @param {jQuery} $el - Form field
 * @param {Function} setMessage - If applicable sets an error message
 */
var makeApplyError = function makeApplyError($el, setMessage) {
  return function () {
    var el = $el[0];
    var _get = __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(el, 'form.dataset'),
      validateOnlyOnSubmit = _get.validateOnlyOnSubmit;
    if (validateOnlyOnSubmit) {
      return;
    }
    setMessage();
    el.checkValidity();
  };
};
/**
 * Responsible obtaining an error message
 * @param {string} custom - A custom error message
 * @param {string} template - Template used for the error message
 * @param {Object} data - Data used for the error message template
 */
var getMessage = function getMessage(custom, template, data) {
  return custom || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__lib_stache__["a" /* default */])(template, data);
};
/**
 * Determines which template or message should be used from most specific to
 * most general based on a number of configured values.
 * @param {string|undefined} label - Name associated to field
 * @param {string|undefined} errorMessage - Message passed in on a field level
 * @param {string} errorType - Type of error
 * @returns {string} Template or message
 */
var getTemplate = function getTemplate(label, errorMessage, errorType) {
  var template = DEFAULT_ERROR_LABEL_OPTIONS[errorType];
  var defaultMessage = DEFAULT_TEMPLATES[errorType];
  // This means the error message was provided on a field level, so that wins
  // over any other option.
  if (errorMessage) {
    return errorMessage;
  }
  // By default, a label is required since the default template is dependent
  // on the dynamic value of the label. There is a chance that the template
  // could still be undefined since the template can be undefined. In those
  // cases, just use the default template. This should at least indicate
  // something is broken without seeing template variables.
  if (label) {
    return template;
  }
  // If no label is provided, we cannot use the template, so fallback to the
  // default message as the lowest common denominator.
  return defaultMessage;
};
/**
 * Responsible for determining whether an element level required template is
 * needed. This comes as a request where based on an element, a different
 * required message can be used, which adds more complexity but does meet the
 * request.
 * @param {string} nodeName - Element name
 * @param {string} defaultRequiredTemplate - Default template when a field level
 * template cannot be found.
 * @param {EntryErrorOptions} options - Configurable options
 * @returns {string} Template to use when a field specific template is needed
 */
var getElementLevelTemplate = function getElementLevelTemplate(nodeName, defaultRequiredTemplate, options) {
  var elementLevelTemplate = ELEMENT_ERROR_TEMPLATES[nodeName];
  if (elementLevelTemplate) {
    return options[elementLevelTemplate] || defaultRequiredTemplate;
  }
  return defaultRequiredTemplate;
};
/**
 * Responsible for handling errors in a standardized way. In particular, it'll
 * create consistent error handling based on the type of errors.
 * @param {HTMLElement} el - Element with error in question
 * @param {EntryErrorOptions} options - Configurable options
 * @param {Object} actions - Actions to be called on
 * @return {Object} Methods attached to an entry error
 */
function entryError(el) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : __WEBPACK_IMPORTED_MODULE_3__lib_register_jquery_plugin__["b" /* noopActions */],
    deregister = _ref.deregister;
  var $el = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(el);
  var opts = Object.assign({}, DEFAULT_ERROR_LABEL_OPTIONS, options, el.dataset);
  var label = opts.label,
    requiredAttr = opts.requiredAttr,
    requiredTemplateOption = opts.requiredTemplate,
    invalidTemplateOption = opts.invalidTemplate,
    customRequiredMessage = opts.entryErrorRequiredMessage,
    customInvalidMessage = opts.entryErrorInvalidMessage;
  var nodeName = $el.prop('nodeName').toLowerCase();
  var requiredFieldTemplate = getElementLevelTemplate(nodeName, requiredTemplateOption, opts);
  var requiredTemplate = getTemplate(label, requiredFieldTemplate, 'requiredTemplate');
  var invalidTemplate = getTemplate(label, invalidTemplateOption, 'invalidTemplate');
  var requiredMessage = getMessage(customRequiredMessage, requiredTemplate, {
    label: label
  });
  var invalidMessage = getMessage(customInvalidMessage, invalidTemplate, {
    label: label
  });
  var setMessage = makeSetMessage($el, requiredMessage, invalidMessage);
  var applyError = makeApplyError($el, setMessage);
  $el.attr(requiredAttr, true).attr('aria-required', true).on(BLUR, applyError).on(INVALID, setMessage).on(INPUT, resetFieldFromEvent);
  if (nodeName === 'select') {
    $el.on(CHANGE, applyError);
  }
  return {
    destroy: destroy($el, deregister)
  };
}
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__lib_register_jquery_plugin__["a" /* default */])('entryError', entryError);

/***/ }),
/* 255 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export CLASS_NAMES */
/* unused harmony export EVENTS */
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_find__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_find___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_find__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_kebabCase__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_kebabCase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_kebabCase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__validator__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib_register_jquery_plugin__ = __webpack_require__(1);
/* unused harmony reexport VALIDATOR_EVENTS */
/**
 * Renders an error summary of all form errors in a centralized location.
 * @module elements/fields/error-summary
 */






var VALIDATOR_SUCCESS = __WEBPACK_IMPORTED_MODULE_3__validator__["a" /* EVENTS */].VALIDATOR_SUCCESS,
  VALIDATOR_ERROR = __WEBPACK_IMPORTED_MODULE_3__validator__["a" /* EVENTS */].VALIDATOR_ERROR,
  VALIDATOR_POST_ERROR = __WEBPACK_IMPORTED_MODULE_3__validator__["a" /* EVENTS */].VALIDATOR_POST_ERROR;

var ERROR_SUMMARY_OPTIONS = {
  errorSummaryTitle: '',
  // TODO: See if there is a preferred value here for something more generic
  fieldGroupSelectors: ['.field-group'],
  messageDataAttrs: ['floatingErrorMessage', 'errorMessage'],
  errorPrefix: 'Error:',
  formFieldSelectors: 'input,textarea,select',
  errorContainerClassName: 'error-summary-container',
  createErrorId: function createErrorId(id) {
    return "".concat(Math.random().toString(36).slice(2), "-").concat(id);
  },
  scrollToFn: function scrollToFn() {
    return window.scrollTo(0, 0);
  }
};
var CLASS_NAMES = {
  TITLE: 'error-summary__title',
  SUMMARY_LINK: 'error-summary__link'
};
var EVENTS = {
  CLEAR: 'error-summary:clear'
};
var CLEAR = EVENTS.CLEAR;
var EVENT_NS = '.error-summary';

/**
 * Responsible for creating an error summary template/HTML.
 * @param {Object} data - Data used for creating the template
 * @returns {string} Represents rendered HTML
 */
var errorSummaryTemplate = function errorSummaryTemplate(_ref) {
  var errorPrefix = _ref.errorPrefix,
    title = _ref.title,
    invalidFields = _ref.invalidFields;
  return "\n  <div class=\"error-summary\">\n    <div class=\"error-summary__content\">\n      <h3 class=\"".concat(CLASS_NAMES.TITLE, "\" tabIndex=\"-1\">").concat(title, "</h3>\n      <ul class=\"error-summary__list\">\n        ").concat(invalidFields.map(function (_ref2) {
    var errorMessage = _ref2.errorMessage,
      label = _ref2.label,
      errorItemId = _ref2.errorItemId;
    return "\n          <li class=\"error-summary__item\n            <span class=\"u-screen-reader\">".concat(errorPrefix, " </span>\n            <span class=\"icon icon--xs icon--exclamation-point\">\n              <svg viewBox=\"0 0 16 16\" aria-hidden=\"true\" focusable=\"false\">\n                <path d=\"M8 0C3.6 0 0 3.6 0 8s3.6 8 8 8 8-3.6 8-8-3.6-8-8-8zm0 15.2A7.17 7.17 0 0 1 .8 8 7.17 7.17 0 0 1 8 .8 7.17 7.17 0 0 1 15.2 8 7.17 7.17 0 0 1 8 15.2zm0-5.6c.4 0 .6-.3.6-.7l.3-4.3c0-.4-.4-.7-.8-.7s-1 .2-1 .7l.3 4.3c0 .4.2.7.6.7z\"/><circle cx=\"8\" cy=\"11.3\" r=\".9\"/>\n              </svg>\n            </span>\n            <a href=\"#").concat(errorItemId, "\" class=\"").concat(CLASS_NAMES.SUMMARY_LINK, "\">\n              ").concat(label ? "".concat(label, ": ") : '').concat(errorMessage, "\n            </a>\n          </li>\n        ");
  }).join(''), "\n      </ul>\n    </div>\n  </div>\n");
};

/**
 * Responsible for adding an error container to the DOM.
 * @param {jQuery} $el - The container element
 * @param {string} className - Name of class for the prepended element
 * @returns {jQuery} The error container element
 */
var createErrorContainer = function createErrorContainer($el, className) {
  return __WEBPACK_IMPORTED_MODULE_0_jquery___default()("<div class=\"".concat(className, "\"/>")).prependTo($el);
};

/**
 * Responsible for clearing out the error container.
 * @param {jQuery} $errorContainer - Element containing the error summary
 * @returns {Function} Clears out the error container when called on
 */
var removeErrorSummary = function removeErrorSummary($errorContainer) {
  return function () {
    $errorContainer.empty();
  };
};

/**
 * Responsible for rendering the error summary and all the details around the
 * errors.
 * @param {string} title - Title for the error summary
 * @param {jQuery} $errorContainer - Contains the error summary
 * @param {Map} fieldErrorMap - Map of field errors
 * @param {Function} scrollToFn - Handles where to scroll to when the error
 * summary has been shown
 * @return {Function} Called on by an event
 */
var makeShowErrorSummary = function makeShowErrorSummary(errorPrefix, title, $errorContainer, fieldErrorMap, scrollToFn) {
  return function (evt) {
    removeErrorSummary($errorContainer)();
    var invalidElements = evt.detail.invalidElements;
    var invalidFields = invalidElements.reduce(function (acc, invalidElement) {
      var fieldError = fieldErrorMap.get(invalidElement);
      var errorMessage = invalidElement.validationMessage;
      var label = invalidElement.dataset.label;
      if (fieldError) {
        return acc.concat(Object.assign({}, fieldError, {
          errorMessage: errorMessage,
          label: label
        }));
      }
      return acc;
    }, []);
    var markup = errorSummaryTemplate({
      errorPrefix: errorPrefix,
      title: title,
      invalidFields: invalidFields
    });
    $errorContainer.html(markup).find(".".concat(CLASS_NAMES.TITLE)).focus();
    scrollToFn();
  };
};

/**
 * Responsible for scrolling to a field in the DOM.
 * @param {Map} fieldErrorMap - Map of field errors
 */
var scrollToField = function scrollToField(fieldErrorMap) {
  return function (evt) {
    evt.preventDefault();
    var targetErrorSummaryId = evt.currentTarget.getAttribute('href').substr(1);
    var fieldErrorValues = Array.from(fieldErrorMap.values());
    var _find = __WEBPACK_IMPORTED_MODULE_1_lodash_find___default()(fieldErrorValues, function (_ref3) {
        var errorItemId = _ref3.errorItemId;
        return errorItemId === targetErrorSummaryId;
      }),
      $formField = _find.$formField,
      $fieldContainer = _find.$fieldContainer;
    $formField.focus();
    // This is using the defaults but more information on this can be found here:
    // https://developer.mozilla.org/en-US/docs/Web/API/Element/scrollIntoView#Parameters
    $fieldContainer[0].scrollIntoView({
      block: 'center'
    });
  };
};

/**
 * Responsible for cleaning up or tearing down error summary.
 * @param {jQuery} $el = The container element
 * @param {jQuery} $errorContainer - An error container
 * @param {Function} deregister - Unregisters the plugin
 */
var _destroy = function destroy($el, $errorContainer, deregister) {
  $el.off(EVENT_NS);
  $errorContainer.remove();
  deregister();
};

/**
 * Responsible for formatting data attributes into a proper jQuery selector.
 * @param {Array} dataAttrs - List of possible data attributes
 * @returns {string} Data attributes in the form of selectors
 */
var createDataSelectors = function createDataSelectors(dataAttrs) {
  return dataAttrs.map(function (attr) {
    return "[data-".concat(__WEBPACK_IMPORTED_MODULE_2_lodash_kebabCase___default()(attr), "]");
  }).join(',');
};

/**
 * Responsible for creating a consolidated place for a form error item,
 * containing all the necessary information needed for a form error item.
 * @param {string} formSelectors - Represents form field selectors
 * @param {Function} createErrorId - Creates a unique ID
 * @returns {Function} Called on to create a field error item
 */
var createFieldErrorItem = function createFieldErrorItem(formSelectors, createErrorId) {
  return function (map, fieldContainer, id) {
    var formField = fieldContainer;
    var $fieldContainer = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(fieldContainer);
    var $innerFormField = $fieldContainer.find(formSelectors);
    if ($innerFormField.length) {
      formField = $innerFormField[0];
    }
    var $formField = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(formField);
    var errorItemId = createErrorId(id);
    var info = {
      errorItemId: errorItemId,
      $fieldContainer: $fieldContainer,
      $formField: $formField
    };

    // This exists so that a container with a form field supercedes a form field
    // that is the same as the container. This would occur when both the
    // container and field are seen as separate elements. Since the container
    // with the form field is the desired result, make sure that wins over when
    // a form field is the same as the container.
    if (map.has(formField) && formField === $fieldContainer[0]) {
      return map;
    }
    return map.set(formField, info);
  };
};

/**
 * Responsible for creating a map of elements which can be used for looking up
 * errors when a form has submitted.
 * @param {jQuery} $el - Container element
 * @param {Array} fieldGroupSelectors - Potential field selectors
 * @param {Array} dataAttrs - Data attributes used for error messages
 * @param {string} formSelectors - Possible form elements that can be queried
 * @param {Function} createErrorId - Creates a unique for each field
 * @returns {Map} Contains all possible fields which may have any sort of error
 * messaging
 */
var createFieldErrorMap = function createFieldErrorMap($el, fieldGroupSelectors, dataAttrs, formSelectors, createErrorId) {
  var fieldSelectors = fieldGroupSelectors.concat(formSelectors, createDataSelectors(dataAttrs)).join(',');
  return $el.find(fieldSelectors).toArray().reduce(createFieldErrorItem(formSelectors, createErrorId), new Map());
};

/**
 * Responsible for displaying an error summary that contains error information
 * upon submitting the form.
 * @param {HTMLElement} el - Element containing form field elements
 * @param {Object} options - Configurable options
 * @param {Object} actions - Actions to be called on
 * @return {Object} Methods attached to an error summary
 */
function errorSummary(el) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _ref4 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : __WEBPACK_IMPORTED_MODULE_4__lib_register_jquery_plugin__["b" /* noopActions */],
    deregister = _ref4.deregister;
  var $el = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(el);
  var $errorContainer = __WEBPACK_IMPORTED_MODULE_0_jquery___default()();
  var _Object$assign = Object.assign({}, ERROR_SUMMARY_OPTIONS, options, $el.data()),
    formSelectors = _Object$assign.formFieldSelectors,
    dataAttrs = _Object$assign.messageDataAttrs,
    errorContainerClassName = _Object$assign.errorContainerClassName,
    createErrorId = _Object$assign.createErrorId,
    errorPrefix = _Object$assign.errorPrefix,
    fieldGroupSelectors = _Object$assign.fieldGroupSelectors,
    scrollToFn = _Object$assign.scrollToFn;
  var title = el.dataset.errorSummaryTitle;
  if (title) {
    $el.data('validateDisableErrorScroll', true);
    var fieldErrorMap = createFieldErrorMap($el, fieldGroupSelectors, dataAttrs, formSelectors, createErrorId);
    $errorContainer = createErrorContainer($el, errorContainerClassName);
    $errorContainer.on('click', ".".concat(CLASS_NAMES.SUMMARY_LINK), scrollToField(fieldErrorMap));
    var showErrorSummary = makeShowErrorSummary(errorPrefix, title, $errorContainer, fieldErrorMap, scrollToFn);
    $el.on(CLEAR + EVENT_NS, removeErrorSummary($errorContainer)).on(VALIDATOR_ERROR + EVENT_NS, showErrorSummary).on(VALIDATOR_POST_ERROR + EVENT_NS, showErrorSummary).on(VALIDATOR_SUCCESS + EVENT_NS, removeErrorSummary($errorContainer));
  }
  return {
    destroy: function destroy() {
      return _destroy($el, $errorContainer, deregister);
    }
  };
}
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib_register_jquery_plugin__["a" /* default */])('errorSummary', errorSummary);

/***/ }),
/* 256 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_register_jquery_plugin__ = __webpack_require__(1);
/**
 * Responsible for creating a container around a field of elements with the
 * intention of applying a single error message.
 * @module elements/fields/field-container
 */


var FIELD_CONTAINER_DEFAULTS = {
  errorMessage: '',
  blockName: 'fixed-label',
  labelElement: 'label',
  errorElement: 'error',
  labelErrorModifier: 'invalid'
};
var NS = 'field-container';

/**
 * Responsible for creating an error element.
 * @param {string} className - Class name of the container
 * @param {Object} data - Any data for the element
 */
var createErrorElement = function createErrorElement(className, _ref) {
  var message = _ref.message;
  return "<p class=\"".concat(className, "\">").concat(message, "</p>");
};

/**
 * Responsible managing an error around a container of elements.
 * @param {HTMLElement} el - Acts as the container
 * @param {Object} options - Configurable options
 */
function fieldContainer(el) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _ref2 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : __WEBPACK_IMPORTED_MODULE_1__lib_register_jquery_plugin__["b" /* noopActions */],
    deregister = _ref2.deregister;
  var $el = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(el);
  var _Object$assign = Object.assign({}, FIELD_CONTAINER_DEFAULTS, options, $el.data()),
    errorMessage = _Object$assign.errorMessage,
    blockName = _Object$assign.blockName,
    labelElement = _Object$assign.labelElement,
    errorElement = _Object$assign.errorElement,
    labelErrorModifier = _Object$assign.labelErrorModifier;
  var errorClassName = "".concat(blockName, "__").concat(errorElement);
  var errorSelector = ".".concat(errorClassName);
  var label = "".concat(blockName, "__").concat(labelElement);
  var labelError = "".concat(blockName, "__").concat(labelElement, "--").concat(labelErrorModifier);
  $el
  // Since we are providing our own way of handling the error message, just in
  // case a floating error message is applied, do not use it in favor of our
  // custom way of handling an error
  .attr('data-disable-floating-error', true).on("mirror-field:error.".concat(NS), function (e) {
    var validationMessage = e.detail.validationMessage;
    $el.find(".".concat(label)).addClass(labelError);
    var $error = $el.find(errorSelector);
    var message = errorMessage || validationMessage;
    if ($error.length) {
      $error.text(message);
    } else {
      $el.append(createErrorElement(errorClassName, {
        message: message
      }));
    }
  }).on("mirror-field:reset.".concat(NS), function () {
    $el.find(".".concat(label)).removeClass(labelError);
    $el.find(errorSelector).remove();
  });
  return {
    removeListeners: function removeListeners() {
      deregister();
      $el.off(".".concat(NS));
    }
  };
}
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__lib_register_jquery_plugin__["a" /* default */])('fieldLabelContainer', fieldContainer);

/***/ }),
/* 257 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export CLEAR_ICON_ATTR */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_get__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__form_field_behaviors__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__state_modifiers__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__iconify_behaviors__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__floating_error__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__toggle_password__ = __webpack_require__(265);
/**
 * Responsible for combining all fixed label related behaviors and exposing it
 * as a jQuery plugin.
 * @module elements/fields/fixedLabelPlugin
 */






var CLEAR_ICON_ATTR = 'data-iconify-clear';
var BLOCK = 'fixed-label';
var getTogglePass = function getTogglePass(name) {
  return __WEBPACK_IMPORTED_MODULE_0_lodash_get___default()(window, ['rcProps', 'togglePassword', name]);
};
var BUILTIN_BEHAVIORS = [__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__state_modifiers__["a" /* default */])(), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__iconify_behaviors__["a" /* default */])({
  containerClassName: "".concat(BLOCK, "__iconify")
}), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__floating_error__["a" /* default */])({
  floatingErrorContainerClassName: "".concat(BLOCK, "--floating-error"),
  floatingErrorClassName: "".concat(BLOCK, "__error")
}), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__toggle_password__["a" /* default */])({
  actionClassName: "".concat(BLOCK, "__toggle-password"),
  fieldAttrs: {
    'data-iconify-disable-clear': true
  },
  showText: getTogglePass('showText'),
  hideText: getTogglePass('hideText'),
  a11yShowText: getTogglePass('a11yShowText'),
  a11yHideText: getTogglePass('a11yHideText')
})];
/* unused harmony default export */ var _unused_webpack_default_export = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__form_field_behaviors__["a" /* createJQueryPlugin */])('fixedLabel', BLOCK, BUILTIN_BEHAVIORS, function (el, options) {
  if (!el.dataset.iconifyDisableClear) {
    el.setAttribute(CLEAR_ICON_ATTR, 'Clear');
  }
  return Object.assign({}, options);
}));

/***/ }),
/* 258 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__form_field_behaviors__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__state_modifiers__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__iconify_behaviors__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__iconify_details__ = __webpack_require__(261);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__floating_error__ = __webpack_require__(107);
/**
 * Responsible for combining all floating label related callers and exposing it
 * as a jQuery plugin.
 * @module elements/fields/floatingLabelPlugin
 */






/**
 * Defines any built in callers for a floating label.
 * @type {Array}
 */
var BUILTIN_BEHAVIORS = [__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__state_modifiers__["a" /* default */])(), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__iconify_behaviors__["a" /* default */])(), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__iconify_details__["a" /* default */])(), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__floating_error__["a" /* default */])()];
/* unused harmony default export */ var _unused_webpack_default_export = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__form_field_behaviors__["a" /* createJQueryPlugin */])('floatingLabel', 'floating-label', BUILTIN_BEHAVIORS));

/***/ }),
/* 259 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ERROR_SECTION_CLASS_NAME */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isUndefined__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isUndefined___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_isUndefined__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_jquery__);
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
/**
 * Responsible for scrolling to a specific position when a form error submission
 * has occurred on a form validator.
 * @module elements/fields/formErrorScroller
 */


var ERROR_SECTION_CLASS_NAME = 'validator-error-section';

/**
 * Determines the scroll position based on the passed in configuration.
 * @private
 * @param {number} scrollPosition - Where in the page to scroll to.
 * @param {string} scrollSelector - A selector within the wrapper.
 * @returns {number|undefined} Where to scroll to when an error occurs.
 */
var resolveFormScrollPosition = function resolveFormScrollPosition(scrollPosition, scrollSelector) {
  var $scroll = __WEBPACK_IMPORTED_MODULE_1_jquery___default()(scrollSelector);
  if ($scroll.length) {
    return $scroll.scrollTop();
  }
  return scrollPosition;
};

/**
 * Determines the insertion position of where the error message should be
 * located within the wrapper.
 * @private
 * @param {jQuery} $wrapper - The wrapper containing the form fields
 * @param {string} insertErrorBefore - The selector used for inserting before an
 * element
 * @param {string} insertErrorAfter - The selector used for inserting after an
 * element
 * @returns {Object} The position and jQuery object where to insert the error
 */
var resolveFormErrorInsertPosition = function resolveFormErrorInsertPosition($wrapper, insertErrorBefore, insertErrorAfter) {
  var errorInsertPositions = [{
    position: 'before',
    selector: insertErrorBefore
  }, {
    position: 'after',
    selector: insertErrorAfter
  }];
  var _errorInsertPositions = errorInsertPositions.map(function (_ref) {
      var position = _ref.position,
        selector = _ref.selector;
      return {
        position: position,
        $el: $wrapper.find(selector)
      };
    }).filter(function (_ref2) {
      var $el = _ref2.$el;
      return $el.length;
    }),
    _errorInsertPositions2 = _slicedToArray(_errorInsertPositions, 1),
    _errorInsertPositions3 = _errorInsertPositions2[0],
    obj = _errorInsertPositions3 === void 0 ? {} : _errorInsertPositions3;
  return obj;
};

/**
 * Renders an error section.
 * @private
 * @param {string} errorMessage - The error message
 * @returns {string} Rendered error section.
 */
var renderErrorSection = function renderErrorSection(_ref3) {
  var errorMessage = _ref3.errorMessage;
  return "\n  <div class=\"form-section ".concat(ERROR_SECTION_CLASS_NAME, "\">\n    <p class=\"form-section__error embedded-error\">").concat(errorMessage, "</p>\n  </div>\n");
};

/**
 * Handles scrolling to a specific position based on what has been provided
 * by the caller. This happens on a form level and provides the flexibility of
 * where the error should be rendered, where the page should scroll to, and the
 * message to use. If any one of these properties is missing, it will not be
 * used. Here are the available options:
 *
 * - data-validate-error-message: the error message
 * - data-validate-scroll-to-position: y-axis to scroll to
 * - data-validate-scroll-to-selector: the top part of the selector to scroll to
 * - data-validate-insert-error-before: a selector within the form where the
 *   error should be injected to before
 * - data-validate-insert-error-after: a selector within the form where the
 *   error should be injected to after
 *
 * scroll-to-position supersedes scroll-to-selector and insert-error-before will
 * supersede insert-error-after.
 *
 * Here's some example markup used for configuration purposes:
 *
 * @example
 * <form
 *   data-validate-error-message="some message"
 *   data-validate-scroll-to-position="0"
 *   data-validate-error-before=".title">
 *   <h1 class="title">I am a title</h1>
 *   <input type="text" name="name">
 *   <input type="submit" value="Submit">
 * </form>
 * @param {jQuery} $wrapper - The wrapper containing the elements
 * @param {Function} scrollTrigger - Function used for scrolling to x/y
 * coordinates.
 * @param {Object} options - Configurable options
 * @returns {boolean} Whether a scroll error has been captured.
 */
var formErrorScroller = function formErrorScroller($wrapper, scrollTrigger) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var _Object$assign = Object.assign({}, options, $wrapper.data()),
    errorMessage = _Object$assign.validateErrorMessage,
    scrollPosition = _Object$assign.validateScrollToPosition,
    scrollSelector = _Object$assign.validateScrollToSelector,
    insertErrorBefore = _Object$assign.validateInsertErrorBefore,
    insertErrorAfter = _Object$assign.validateInsertErrorAfter;
  // Nuke any existing sections to remove duplicate error messages.
  $wrapper.find(".".concat(ERROR_SECTION_CLASS_NAME)).remove();
  var position = resolveFormScrollPosition(scrollPosition, scrollSelector);
  var _resolveFormErrorInse = resolveFormErrorInsertPosition($wrapper, insertErrorBefore, insertErrorAfter),
    insertPosition = _resolveFormErrorInse.position,
    $error = _resolveFormErrorInse.$el;

  // If at least one criteria is not met, don't render the message since all
  // are required for this purpose, but no crazy failures occur if this isn't
  // call on, i.e. it's an enhancement, not core functionality.
  if (!__WEBPACK_IMPORTED_MODULE_0_lodash_isUndefined___default()(position) && $error && errorMessage) {
    // Since this is within our control, dynamically call on jQuery method for
    // insertion.
    $error[insertPosition](renderErrorSection({
      errorMessage: errorMessage
    }));
    scrollTrigger(0, position);
    return true;
  }
  return false;
};
/* harmony default export */ __webpack_exports__["a"] = (formErrorScroller);

/***/ }),
/* 260 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_register_jquery_plugin__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__field_container__ = __webpack_require__(256);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__character_counter__ = __webpack_require__(253);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__floating_label_plugin__ = __webpack_require__(258);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__fixed_label_plugin__ = __webpack_require__(257);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__entry_error__ = __webpack_require__(254);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__radio_group_validator__ = __webpack_require__(264);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__mirror_field__ = __webpack_require__(263);











// Does the initial setup so that the mirrorField jQuery plugin is available
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__mirror_field__["a" /* default */])();
var makeGetContainer = function makeGetContainer($container) {
  return function ($els) {
    if ($container && $container.length) {
      return $container.find($els);
    }
    return $els;
  };
};
function formField(el) {
  var _options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : __WEBPACK_IMPORTED_MODULE_2__lib_register_jquery_plugin__["b" /* noopActions */],
    deregister = _ref.deregister;
  var $el = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(el);
  var $entryErrors = $el.find('[data-entry-error]:visible').entryError({
    requiredTemplate: __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(window, 'rcProps.entryError.requiredTemplate', ''),
    invalidTemplate: __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(window, 'rcProps.entryError.invalidTemplate', '')
  });
  var $floatingLabels = $el.find('.floating-label:visible').floatingLabel();
  var $fixedLabels = $el.find('.fixed-label:visible').fixedLabel();
  var $fieldLabelContainers = $el.find(document.getElementsByClassName('fixed-label--container')).fieldLabelContainer();
  var $characterCounters = $el.find(document.getElementsByClassName('character-counter-field')).characterCounter();
  var $characterCountersInput = $el.find(document.getElementsByClassName('character-counter-input')).characterCounter({
    fieldSelector: 'input'
  });
  var $mirrorFields = $el.find(document.querySelectorAll('[data-mirror-field-name]')).mirrorField();
  var $validateRadioGroups = $el.find(document.getElementsByClassName('validate-radio-group')).radioGroupValidator({
    errorClassName: 'form-section__error',
    errorTemplate: __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(window, 'rcProps.validateRadioGroup.errorTemplate')
  });
  return {
    teardown: function teardown() {
      var teardownOptions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var $container = teardownOptions.$container;
      // If a container has been provided, this means that the intention is
      // to keep around some of the instances. Therefore, if we intended to
      // teardown all instances but it had previously been torn down, then
      // an error would be thrown accidentally when it wasn't the intention.
      if (!$container) {
        deregister();
      }
      var getContainer = makeGetContainer($el.find($container));
      getContainer($floatingLabels).floatingLabel('removeListeners');
      getContainer($fixedLabels).fixedLabel('removeListeners');
      getContainer($entryErrors).entryError('destroy');
      getContainer($fieldLabelContainers).fieldLabelContainer('removeListeners');
      getContainer($characterCounters).characterCounter('removeListeners');
      getContainer($characterCountersInput).characterCounter('removeListeners');
      getContainer($mirrorFields).mirrorField('destroy');
      getContainer($validateRadioGroups).radioGroupValidator('removeListeners');
    }
  };
}
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__lib_register_jquery_plugin__["a" /* default */])('formField', formField);

/***/ }),
/* 261 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export iconList */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__modules_modal__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__iconify_setup__ = __webpack_require__(109);
/* unused harmony reexport VISIBLE_CLASS_NAME */
/**
 * Responsible for using the details behavior within a floating label.
 * @module elements/fields/iconifyDetails
 */




/**
 * Contains the list of icons associated with a more details iconify floating
 * label.
 * @type {Object}
 */
var iconList = [{
  name: 'details',
  iconId: 'details',
  svg: function svg(text) {
    return "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\"><title>".concat(text, "</title><<path d=\"M8 0a8 8 0 1 0 8 8 8 8 0 0 0-8-8zm0 15.25A7.25 7.25 0 1 1 15.25 8 7.258 7.258 0 0 1 8 15.25zm-.064-4.797a.797.797 0 0 0-.579.23.763.763 0 0 0-.236.568.743.743 0 0 0 .244.592.843.843 0 0 0 .571.212.814.814 0 0 0 .557-.214.748.748 0 0 0 .241-.589.787.787 0 0 0-.798-.798zm2.42-5.442a2.227 2.227 0 0 0-.919-.78 3.125 3.125 0 0 0-1.371-.286 3 3 0 0 0-1.462.343 2.515 2.515 0 0 0-.954.865 1.937 1.937 0 0 0-.327 1.031.647.647 0 0 0 .206.458.68.68 0 0 0 .506.212q.5 0 .7-.605a2.37 2.37 0 0 1 .471-.876 1.138 1.138 0 0 1 .868-.297 1.165 1.165 0 0 1 .822.295.947.947 0 0 1 .319.723.821.821 0 0 1-.104.407 1.534 1.534 0 0 1-.257.34q-.153.153-.495.453a8.484 8.484 0 0 0-.622.592 1.899 1.899 0 0 0-.509 1.358.715.715 0 0 0 .19.541.652.652 0 0 0 .469.182.596.596 0 0 0 .637-.557q.06-.263.088-.367a1.105 1.105 0 0 1 .083-.209 1.185 1.185 0 0 1 .163-.23 3.712 3.712 0 0 1 .292-.292q.66-.6.913-.838a2.446 2.446 0 0 0 .439-.592 1.655 1.655 0 0 0 .185-.798 1.913 1.913 0 0 0-.324-1.071z\"/></svg>");
  }
}];

/**
 * Defines configurable options
 * @type {Object}
 */
var DEFAULT_MORE_DETAILS = {
  modal: __WEBPACK_IMPORTED_MODULE_0__modules_modal__["a" /* default */]
};

/**
 * Responsible for showing a more details icons within a floating element. Once
 * the icon has been interacted with, it will show a modal. This is different
 * than an iconify-behaviors as this work doesn't need to hook into the
 * floating label events cycle, but rather utilizes the same setup, therefore
 * allowing us to reuse things such as setting up icons and the applicable
 * elements used in a floating label.
 *
 * To configure this work, make sure the following data attributes have been
 * provided:
 *
 * - data-iconify-more-details: contains the title for the icon used for i18n
 *   and accessibility
 * - data-open: an ID to a modal
 *
 * Since this work will leverage the modal, any modal related data attributes
 * can be applied here. Here's an example in HTML to wire this dude up:
 *
 * @example
 * <div
 *     class="floating-label"
 *     data-iconify-more-details="More Details"
 *     data-open="modal-example">
 *   <label for="the-dude" class="floating-label__label">The Dude</label>
 *   <input id="the-dude" class="floating-label__input">
 * </div>
 *
 * <div id="modal-example" class="modal u-center" data-type="default-modal">
 *   <p>modal content goes here</p>
 * </div>
 *
 * @param {Object} options - Configurable options
 * @returns {Function} Initialization of iconify more details
 */
var iconifyMoreDetails = function iconifyMoreDetails() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return function () {
    var opts = Object.assign({}, DEFAULT_MORE_DETAILS, options);
    var modalFunc = opts.modal;
    for (var _len = arguments.length, nodes = new Array(_len), _key = 0; _key < _len; _key++) {
      nodes[_key] = arguments[_key];
    }
    var _setup = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__iconify_setup__["c" /* default */])(iconList, nodes, opts),
      container = _setup.container,
      iconNodes = _setup.iconNodes;
    if (!iconNodes) {
      return;
    }
    var detailsIcon = iconNodes.details;
    detailsIcon.classList.add(__WEBPACK_IMPORTED_MODULE_1__iconify_setup__["b" /* VISIBLE_CLASS_NAME */]);
    detailsIcon.addEventListener('click', function () {
      modalFunc(container, {
        triggerOpen: true
      });
    });
  };
};
/* harmony default export */ __webpack_exports__["a"] = (iconifyMoreDetails);

/***/ }),
/* 262 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_register_jquery_plugin__ = __webpack_require__(1);
/**
 * Responsible for applying an error to a form field.
 * @module elements/fields/validator
 */


var DEFAULT_INVALIDATE_OPTIONS = {
  formFieldSelectors: 'input,textarea,select',
  message: 'Received an error'
};

/**
 * Responsible for setting an element as being invalid.
 * @example
 * $('.some-selector').invalidate({
 *   message: 'oh noes??!?! what happened??!?!?1?!',
 * });
 *
 * @param {HTMLElement} el - An element, presumably a form element
 * @param {Object} options - Configurable options
 */
function invalidate(el) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var $el = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(el);
  var _Object$assign = Object.assign({}, DEFAULT_INVALIDATE_OPTIONS, options),
    formFieldSelectors = _Object$assign.formFieldSelectors,
    message = _Object$assign.message;
  if ($el.is(formFieldSelectors)) {
    el.setCustomValidity(message);
    el.checkValidity();
    return;
  }
  var $formField = $el.find(formFieldSelectors);
  if ($formField.length) {
    var formField = $formField[0];
    // Grab the first one in the case where there could be more than one, i.e.
    // checkboxes or radios.
    // TODO: See if this needs to be more comprehensive
    formField.setCustomValidity(message);
    formField.checkValidity();
  }
}
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__lib_register_jquery_plugin__["a" /* default */])('invalidate', invalidate, {
  cache: false
});

/***/ }),
/* 263 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export EVENT_NAMESPACE */
/* unused harmony export EVENTS */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_register_jquery_plugin__ = __webpack_require__(1);
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
/**
 * Responsible for creating a group out of a set of fields and when one of those
 * fields is invalid, all are marked as invalid.
 * @module elements/fields/mirror-field
 */

// UNCOMMENT THIS CODE IF BLUR SHOULD BE SUPPORTED
// import find from 'lodash/find';

var EVENT_NAMESPACE = 'mirror-field';
var EVENTS = {
  VALID: 'valid',
  INVALID: 'invalid',
  FOCUS: 'focus',
  ERROR: 'mirror-field:error',
  RESET: 'mirror-field:reset'
  // UNCOMMENT THIS CODE IF BLUR SHOULD BE SUPPORTED
  // BLUR: 'blur',
  // CHANGE: 'change',
};
var FORM_FIELDS = 'input,textarea,select';

/**
 * Creates an event name with a namespace.
 * @param {string} name - Name of the event
 * @returns {string} Event with namespace
 */
var createEventName = function createEventName(name) {
  return "".concat(EVENTS[name.toUpperCase()], ".").concat(EVENT_NAMESPACE);
};

/**
 * Responsible for finding fields based on a group name.
 * @param {Object} fieldMappings - All available field mappings keyed by group
 * name
 * @param {jQuery} $el - Used for looking up the group
 * @returns {Array} All elements within a group
 */
var getFieldList = function getFieldList(fieldMappings, $el) {
  var name = $el.data('mirrorFieldName');
  var fieldList = fieldMappings[name];
  if (fieldList) {
    return fieldList;
  }
  return [];
};

/**
 * Responsible for appending a field to a group.
 * @param {Object} fieldMappings - All available field mappings keyed by group
 * name
 * @param {jQuery} $el - Element being added to group
 * @returns {Object} - Updated field mappings
 */
var updateFieldMappings = function updateFieldMappings(fieldMappings, $el) {
  var name = $el.data('mirrorFieldName');
  var fieldList = getFieldList(fieldMappings, $el);
  var updatedFieldList = fieldList.length ? [].concat(_toConsumableArray(fieldList), [$el]) : [$el];
  return Object.assign({}, fieldMappings, _defineProperty({}, name, updatedFieldList));
};

/**
 * Responsible for receiving a field that is an error and then making all
 * fields associated with the error element invalid.
 * @param {Object} fieldMappings - All available field mappings keyed by group
 * name
 * @param {jQuery} $el - Field applied with error
 */
var _applyError = function applyError(fieldMappings, $el) {
  var fieldList = getFieldList(fieldMappings, $el);
  var updatedFieldList = fieldList.filter(function ($field) {
    return !$field.is($el);
  });
  var validationMessage = $el.prop('validationMessage');
  updatedFieldList.forEach(function ($field) {
    var field = $field[0];
    if ($field.is(FORM_FIELDS)) {
      var eventName = createEventName(EVENTS.INVALID);
      // Remove event so that it doesn't recursively call itself until the
      // call stack goes KABOOM
      $field.off(eventName);
      field.setCustomValidity(validationMessage);
      field.checkValidity();
      // Now that the element has been invalidated, rebind the event for the
      // next invalid event listener.
      $field.on(eventName, function () {
        return _applyError(fieldMappings, $field);
      });
    }
    var errorEvt = new CustomEvent(EVENTS.ERROR, {
      detail: {
        $field: $field,
        validationMessage: validationMessage,
        $source: $el
      }
    });
    field.dispatchEvent(errorEvt);
  });
};

/**
 * Responsible for resetting an error on a subset of mirror fields.
 * @param {Object} fieldMappings - All available field mappings keyed by group
 * name
 * @param {jQuery} $el - Field getting error reset
 */
var resetError = function resetError(fieldMappings, $el) {
  var fieldList = getFieldList(fieldMappings, $el);
  fieldList.forEach(function ($field) {
    var field = $field[0];
    if ($field.is(FORM_FIELDS)) {
      field.setCustomValidity('');
      field.checkValidity();
      // Only make this available to fields since it plays off of the invalid
      // event which exists in the browser. Technically the invalid event can
      // be fired off on a non-form element, but according to the spec, it's
      // supposed to fire off on a submittable element.
      // https://developer.mozilla.org/en-US/docs/Web/Events/invalid
      var validEvt = new CustomEvent(EVENTS.VALID);
      field.dispatchEvent(validEvt);
    }
    var resetEvt = new CustomEvent(EVENTS.RESET, {
      detail: {
        $field: $field,
        $source: $el
      }
    });
    field.dispatchEvent(resetEvt);
  });
};

// UNCOMMENT THIS CODE IF BLUR SHOULD BE SUPPORTED
// const checkForError = (fieldMappings, $el) => {
//   const $activeElement = $(document.activeElement);
//   const fieldList = getFieldList(fieldMappings, $el);
//   const activeElementInList = find(fieldList, $field => $field.is($activeElement));
//   const el = $el[0];

//   if (activeElementInList && $el.is(FORM_FIELDS) && !el.validity.valid) {
//     return;
//   }

//   fieldList.forEach(($field) => {
//     $field.trigger('validator:validate');
//   });

//   const $error = find(fieldList, ($field) => {
//     if (!$field.is(FORM_FIELDS)) {
//       return false;
//     }

//     const field = $field[0];
//     field.checkValidity();
//     const validity = $field.prop('validity');
//     return !validity.valid;
//   });

//   if ($error) {
//     fieldList.forEach(($field) => {
//       if ($field.is(FORM_FIELDS)) {
//         const field = $field[0];
//         field.setCustomValidity($error.prop('validationMessage'));
//         field.checkValidity();
//       }
//     });
//   } else {
//     fieldList.forEach(($field) => {
//       if ($field.is(FORM_FIELDS)) {
//         const field = $field[0];
//         field.setCustomValidity('');
//         field.checkValidity();

//         const validEvt = new CustomEvent('valid');
//         field.dispatchEvent(validEvt);
//       }
//     });
//   }
// };

/**
 * Responsible for setting up mirror field groupings through exposing the
 * ability to register via a function or a jQuery plugin.
 * @return {Object} Available methods for interacting with mirror fields
 */
/* harmony default export */ __webpack_exports__["a"] = (function () {
  var fieldMappings = {};
  var register = function register(el) {
    var $el = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(el);
    var nextFieldMappings = updateFieldMappings(fieldMappings, $el);
    fieldMappings = nextFieldMappings;
    $el.on(createEventName('invalid'), function (_ref) {
      var target = _ref.target;
      return _applyError(fieldMappings, __WEBPACK_IMPORTED_MODULE_0_jquery___default()(target));
    }).on(createEventName('focus'), function (_ref2) {
      var target = _ref2.target;
      return resetError(fieldMappings, __WEBPACK_IMPORTED_MODULE_0_jquery___default()(target));
    });

    // UNCOMMENT THIS CODE IF BLUR SHOULD BE SUPPORTED
    // $el.on(createEventName('blur'), ({ target }) => checkForError(fieldMappings, $(target)))

    // UNCOMMENT THIS CODE IF BLUR SHOULD BE SUPPORTED
    // if ($el.prop('tagName').toLowerCase() === 'select') {
    //   $el.on(createEventName('change'), ({ target }) => checkForError(fieldMappings, $(target)));
    // }

    return {
      destroy: function destroy() {
        return $el.off(".".concat(EVENT_NAMESPACE));
      }
    };
  };
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__lib_register_jquery_plugin__["a" /* default */])('mirrorField', register);
  return {
    register: register
  };
});

/***/ }),
/* 264 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export EMBEDDED_ERROR_CLASS_NAME */
/* unused harmony export DEFAULT_ERROR_MESSAGE */
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_find__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_find___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_find__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_property__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_property___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_property__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_uniq__ = __webpack_require__(489);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_uniq___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_uniq__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib_register_jquery_plugin__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__validator__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__lib_stache__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__lib_random__ = __webpack_require__(64);
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * Responsible for applying validation upon a radio group so that it can hook
 * into Constraint Validation API.
 * @module radioGroupValidator
 */








var INPUT_GROUP_OPTIONS = {
  errorClassName: '',
  inputSelector: 'input',
  errorPosition: 'afterbegin',
  labelSelector: '.push-button',
  labelErrorClassName: 'push-button-error',
  errorTemplate: '',
  errorPrefix: 'Error:'
};
var createInputGroupOptions = function createInputGroupOptions() {
  return _objectSpread(_objectSpread({}, INPUT_GROUP_OPTIONS), {}, {
    errorIdentifiedBy: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__lib_random__["a" /* default */])({
      prefix: 'radio-group-validator-error'
    })
  });
};

/**
 * CSS class name used for embedding an error.
 * @type {string}
 */
var EMBEDDED_ERROR_CLASS_NAME = 'embedded-error';

/**
 * Default error message when one hasn't been provided.
 * @type {string}
 */
var DEFAULT_ERROR_MESSAGE = 'Please select an option';

/**
 * Responsible for taking any registered event listeners and releasing them
 * from memory.
 * @private
 * @param {HTMLInputElement} input - A radio input
 * @param {Array<Object>} listeners - event listeners to be removed
 */
var removeInputListeners = function removeInputListeners(input, listeners) {
  listeners.forEach(function (_ref) {
    var evt = _ref.evt,
      handler = _ref.handler;
    input.removeEventListener(evt, handler);
  });
};

/**
 * Responsible for removing the error message.
 * @private
 * @param {HTMLElement} wrap - Container element
 */
var removeError = function removeError(wrap) {
  var potentialErrors = [function () {
    return wrap.querySelector(".".concat(EMBEDDED_ERROR_CLASS_NAME));
  }, function () {
    var el = wrap.previousSibling;
    return el && el.classList.contains(EMBEDDED_ERROR_CLASS_NAME) && el;
  }, function () {
    var el = wrap.nextSibling;
    return el && el.classList.contains(EMBEDDED_ERROR_CLASS_NAME) && el;
  }];
  var errorElFn = potentialErrors.find(function (fn) {
    return fn();
  });
  if (errorElFn) {
    var errorEl = errorElFn();
    errorEl.parentNode.removeChild(errorEl);
    return;
  }
  throw new Error('No error element found in radio group validator');
};

/**
 * Responsible for building the element for the error.
 * @private
 * @param {string} errorClassName - CSS class name for the error
 * @param {string} errorMessage - The error message
 */
var renderError = function renderError(_ref2) {
  var errorClassName = _ref2.errorClassName,
    errorMessage = _ref2.errorMessage,
    errorPrefix = _ref2.errorPrefix,
    id = _ref2.id;
  var errorElement = "<p ".concat(id ? "id=\"".concat(id, "\"") : '', " class=\"").concat(errorClassName, " ").concat(EMBEDDED_ERROR_CLASS_NAME, "\"><span class=\"u-screen-reader\">").concat(errorPrefix, " </span><span class=\"icon icon--xs icon--exclamation-point\"><svg viewBox=\"0 0 16 16\" aria-hidden=\"true\" focusable=\"false\"><path d=\"M8 0C3.6 0 0 3.6 0 8s3.6 8 8 8 8-3.6 8-8-3.6-8-8-8zm0 15.2A7.17 7.17 0 0 1 .8 8 7.17 7.17 0 0 1 8 .8 7.17 7.17 0 0 1 15.2 8 7.17 7.17 0 0 1 8 15.2zm0-5.6c.4 0 .6-.3.6-.7l.3-4.3c0-.4-.4-.7-.8-.7s-1 .2-1 .7l.3 4.3c0 .4.2.7.6.7z\"/><circle cx=\"8\" cy=\"11.3\" r=\".9\"/></svg></span>").concat(errorMessage, "</p>");
  return errorElement;
};

/**
 * Responsible for figuring out where the error message should be rendered in
 * the DOM.
 * @private
 * @param {Object} dataset - dataset of an HTML
 * @returns {Object} The position and selector used for inserting the error
 */
var determineInsertSelector = function determineInsertSelector(dataset) {
  var insertBeforeSelector = dataset.radioGroupInsertErrorBefore,
    insertAfterSelector = dataset.radioGroupInsertErrorAfter;
  var selectors = [{
    position: 'beforebegin',
    insertSelector: insertBeforeSelector
  }, {
    position: 'afterend',
    insertSelector: insertAfterSelector
  }];
  return __WEBPACK_IMPORTED_MODULE_1_lodash_find___default()(selectors, function (_ref3) {
    var position = _ref3.position,
      insertSelector = _ref3.insertSelector;
    if (insertSelector) {
      return {
        position: position,
        insertSelector: insertSelector
      };
    }
    return false;
  }) || {};
};

/**
 * Responsible for retrieving an error message based on a number of rules from
 * most specific to least specific, in particular:
 *
 * - error message on the element
 * - template on an element
 * - template based on passed in options
 * - default error message as a catch all
 *
 * @param {string} errorMessage - Element error message
 * @param {string} template - Stache template for the error message
 * @param {Object} data - Data to be fed into stache template
 * @returns {string} An error message
 */
var getErrorMessage = function getErrorMessage(errorMessage, template, data) {
  if (errorMessage) {
    return errorMessage;
  }
  if (template) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib_stache__["a" /* default */])(template, data);
  }
  return DEFAULT_ERROR_MESSAGE;
};

/**
 * Finds the first input that contains a data-label.
 * @param {Array} inputs - List of input elements in the form of an array
 * @returns {string} First found label attribute
 */
var findLabelFromInputs = function findLabelFromInputs(inputs) {
  var getLabel = __WEBPACK_IMPORTED_MODULE_2_lodash_property___default()('dataset.label');
  var input = __WEBPACK_IMPORTED_MODULE_1_lodash_find___default()(inputs, getLabel);
  if (input) {
    return getLabel(input);
  }
  return '';
};

/**
 * Responsible for appending a new value to aria-labelledby that will be used
 * to communicate an error.
 * @param {HTMLElement} container - Element containing the radio group validator
 * @param {string} errorIdentifiedBy - Value used for aria-labelledby
 */
var applyLabelledByError = function applyLabelledByError(container, errorIdentifiedBy) {
  var existingLabelledBy = (container.getAttribute('aria-labelledby') || '').split(/(\s+)/).filter(function (val) {
    return val.trim().length;
  });
  var updatedLabelledBy = __WEBPACK_IMPORTED_MODULE_3_lodash_uniq___default()([].concat(_toConsumableArray(existingLabelledBy), [errorIdentifiedBy])).join(' ').trim();
  container.setAttribute('aria-labelledby', updatedLabelledBy);
};

/**
 * Responsible for marking a set of inputs as being aria valid or invalid.
 * @param {HTMLInputElement[]} inputs - Elements made valid or invalid
 * @param {boolean} val - Determines whether the elements should be invalid
 */
var applyAriaInvalid = function applyAriaInvalid(inputs, val) {
  inputs.forEach(function (input) {
    input.setAttribute('aria-invalid', val);
  });
};

/**
 * Responsible for seeing if any radio inputs are invalid and if so, to allow
 * for error messaging to be displayed. Once a change event has occurred, the
 * error goes away and will allow for any additional validation to be picked up
 * and allow the cycle to repeat itself.
 *
 * The error message and where it's located is configurable based on data
 * attributes on the element passed in. By default, if no position has been
 * provided, it'll write the error message as the first child of the wrap.
 * Here are the supported position values:
 *
 * - data-radio-group-insert-error-before
 * - data-radio-group-insert-error-after
 *
 * Where the value is a selector within the element passed in. Here's an
 * example:
 *
 * @example
 * <div data-radio-group-error-message="Yeah,well, that's just, like, your opinion, man"
 *      data-radio-group-insert-error-before=".title">
 *   <h2 class="title">I am a title or something</h2>
 *   <input type="radio" name="characters" value="dude" required>
 *   <input type="radio" name="characters" value="walter" required>
 *   <input type="radio" name="characters" value="donny" required>
 *   <button type="submit">Submit</button>
 * </div>
 *
 * @see INPUT_GROUP_OPTIONS
 * @param {HTMLElement} wrap - Element containing the inputs
 * @param {Object} options - Configurable options
 */
function radioGroupValidator(wrap) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _ref4 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : __WEBPACK_IMPORTED_MODULE_4__lib_register_jquery_plugin__["b" /* noopActions */],
    deregister = _ref4.deregister;
  var dataset = wrap.dataset;
  var _Object$assign = Object.assign({}, createInputGroupOptions(), options, dataset),
    inputSelector = _Object$assign.inputSelector,
    errorClassName = _Object$assign.errorClassName,
    errorPosition = _Object$assign.errorPosition,
    labelSelector = _Object$assign.labelSelector,
    labelErrorClassName = _Object$assign.labelErrorClassName,
    radioGroupErrorMessage = _Object$assign.radioGroupErrorMessage,
    errorTemplate = _Object$assign.errorTemplate,
    errorIdentifiedBy = _Object$assign.errorIdentifiedBy,
    errorPrefix = _Object$assign.errorPrefix;
  var _determineInsertSelec = determineInsertSelector(dataset),
    _determineInsertSelec2 = _determineInsertSelec.position,
    position = _determineInsertSelec2 === void 0 ? errorPosition : _determineInsertSelec2,
    insertSelector = _determineInsertSelec.insertSelector;
  var insertionEl = insertSelector ? wrap.querySelector(insertSelector) : wrap;
  var INVALID_SCROLL_POSITION = __WEBPACK_IMPORTED_MODULE_5__validator__["a" /* EVENTS */].INVALID_SCROLL_POSITION;
  var errorShown = false;
  var listeners = [];
  var inputs = Array.from(wrap.querySelectorAll(inputSelector));
  var $labels = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(wrap).find(labelSelector);
  var label = findLabelFromInputs(inputs);
  var errorMessage = getErrorMessage(radioGroupErrorMessage, errorTemplate, {
    label: label
  });
  applyLabelledByError(wrap, errorIdentifiedBy);
  inputs.forEach(function (input) {
    var invalidHandler;
    var changeHandler;
    var positionHandler;
    input.addEventListener('invalid', invalidHandler = function invalidHandler() {
      if (!errorShown) {
        errorShown = true;
        insertionEl.insertAdjacentHTML(position, renderError({
          errorClassName: errorClassName,
          errorMessage: errorMessage,
          errorPrefix: errorPrefix,
          id: errorIdentifiedBy
        }));
        $labels.addClass(labelErrorClassName);
        inputs[0].setCustomValidity(errorMessage);
        applyAriaInvalid(inputs, true);
      }
    });
    input.addEventListener(INVALID_SCROLL_POSITION, positionHandler = function positionHandler(_ref5) {
      var setElement = _ref5.detail.setElement;
      setElement(wrap);
    });
    input.addEventListener('change', changeHandler = function changeHandler() {
      if (errorShown) {
        errorShown = false;
        removeError(wrap);
        removeInputListeners(input, listeners);
        $labels.removeClass(labelErrorClassName);
        inputs[0].setCustomValidity('');
        applyAriaInvalid(inputs, false);
      }
    });
    listeners = [].concat(_toConsumableArray(listeners), [{
      evt: 'invalid',
      handler: invalidHandler
    }, {
      evt: 'change',
      handler: changeHandler
    }, {
      evt: INVALID_SCROLL_POSITION,
      handler: positionHandler
    }]);
  });
  return {
    removeListeners: function removeListeners() {
      deregister();
      inputs.forEach(function (input) {
        listeners.forEach(function (_ref6) {
          var evt = _ref6.evt,
            handler = _ref6.handler;
          input.removeEventListener(evt, handler);
        });
      });
    }
  };
}
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib_register_jquery_plugin__["a" /* default */])('radioGroupValidator', radioGroupValidator);

/***/ }),
/* 265 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export NS */
/* unused harmony export TOGGLE_PASSWORD_CLASSNAME */
/* unused harmony export TOGGLE_PASSWORD_SELECTOR */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_noop__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_noop___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_noop__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_assignWith__ = __webpack_require__(468);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_assignWith___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_assignWith__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_isNil__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_isNil___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_isNil__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib_stache__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__form_field_behaviors__ = __webpack_require__(17);
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
/**
 * Responsible for toggling a field between being a password and plain text.
 * @module elements/fields/toggle-password
 */






var NS = 'toggle-password';
var TOGGLE_PASSWORD_CLASSNAME = 'toggle-password';
var TOGGLE_PASSWORD_SELECTOR = ".".concat(TOGGLE_PASSWORD_CLASSNAME);
var CONTAINER = __WEBPACK_IMPORTED_MODULE_5__form_field_behaviors__["b" /* TYPES */].CONTAINER,
  FIELD = __WEBPACK_IMPORTED_MODULE_5__form_field_behaviors__["b" /* TYPES */].FIELD;
var TOGGLE_PASSWORD_DEFAULTS = {
  fieldAttrs: {},
  showText: 'show',
  hideText: 'hide',
  a11yShowText: 'show {{label}} field entry',
  a11yHideText: 'hide {{label}} field entry',
  actionClassName: 'toggle-password'
};

/**
 * Default customizer used to determine which value to use for options.
 * @param {*} objValue - Value from target
 * @param {*} srcValue - Value from source
 * @returns {*} Value for key
 */
var defaultCustomizer = function defaultCustomizer(objValue, srcValue) {
  if (!__WEBPACK_IMPORTED_MODULE_3_lodash_isNil___default()(srcValue)) {
    return srcValue;
  }
  return objValue;
};

/**
 * Responsible for rendering and appending the show/hide toggling action.
 * @param {jQuery} $container - Where the toggler will be appended to
 * @param {jQuery} $formField - Form field element
 * @param {string} actionClassName - Class name applied to the toggler
 * @returns {jQuery} The toggler element
 */
var appendToggler = function appendToggler($container, $formField, actionClassName) {
  var formFieldId = $formField.attr('id');
  // start with hide so it forces it to show initially
  $container.append("\n    <a\n      data-toggle-password-state=\"hide\"\n      class=\"".concat(actionClassName, " ").concat(TOGGLE_PASSWORD_CLASSNAME, "\"\n      href=\"#").concat(!__WEBPACK_IMPORTED_MODULE_3_lodash_isNil___default()(formFieldId) ? formFieldId : '', "\">\n    </a>\n  "));
  return $container.find(TOGGLE_PASSWORD_SELECTOR);
};

/**
 * Responsible for updating the toggler based on the state of the toggler.
 * @param {Object} states - Map of the various toggling states
 * @param {jQuery} $formField - Form field element
 * @param {jQuery} $togglePassword - Toggle element
 * @param {Object} options - Configurable options
 */
var updateToggler = function updateToggler(states, $formField, $togglePassword) {
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var _options$templateData = options.templateData,
    templateData = _options$templateData === void 0 ? {} : _options$templateData;
  var currentState = $togglePassword.data('togglePasswordState');
  var nextStateObj = states[currentState];
  if (!nextStateObj) {
    throw new Error("No toggle password state found for ".concat(currentState));
  }
  var nextState = nextStateObj.state,
    nextText = nextStateObj.text,
    nextA11yText = nextStateObj.a11yText,
    nextType = nextStateObj.type;
  $togglePassword.data('togglePasswordState', nextState).attr('aria-label', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib_stache__["a" /* default */])(nextA11yText, templateData)).text(nextText);
  $formField.attr('type', nextType);
};

/**
 * Responsible for setting/wiring up toggle password functionality within a
 * form field behavior. In particular it'll allow for a show/hide toggling of a
 * password field with support around i18n and a11y.
 * @param {Object} [options={}] - Configurable options
 * @return {Function} Passed back the element belonging to the form field
 * behaviors
 */
var togglePassword = function togglePassword() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return function () {
    for (var _len = arguments.length, nodes = new Array(_len), _key = 0; _key < _len; _key++) {
      nodes[_key] = arguments[_key];
    }
    var _nodes$filter = nodes.filter(function (_ref) {
        var type = _ref.type;
        return type === CONTAINER;
      }),
      _nodes$filter2 = _slicedToArray(_nodes$filter, 1),
      container = _nodes$filter2[0].node;
    var _nodes$filter3 = nodes.filter(function (_ref2) {
        var type = _ref2.type;
        return type === FIELD;
      }),
      _nodes$filter4 = _slicedToArray(_nodes$filter3, 1),
      formField = _nodes$filter4[0].node;
    var $container = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(container);
    var $formField = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(formField);
    var label = $formField.data('label') || '';
    var _assignWith = __WEBPACK_IMPORTED_MODULE_2_lodash_assignWith___default()({}, TOGGLE_PASSWORD_DEFAULTS, options, $container.data(), defaultCustomizer),
      fieldAttrs = _assignWith.fieldAttrs,
      showText = _assignWith.showText,
      hideText = _assignWith.hideText,
      a11yShowText = _assignWith.a11yShowText,
      a11yHideText = _assignWith.a11yHideText,
      actionClassName = _assignWith.actionClassName;
    $container.attr(fieldAttrs);
    if (!$container.data('togglePassword') === true) {
      return __WEBPACK_IMPORTED_MODULE_1_lodash_noop___default.a;
    }
    if (formField.type !== 'password') {
      throw new Error('togglePassword requires a field to be password input');
    }
    var states = {
      show: {
        state: 'hide',
        text: hideText,
        a11yText: a11yHideText,
        type: 'text'
      },
      hide: {
        state: 'show',
        text: showText,
        a11yText: a11yShowText,
        type: 'password'
      }
    };
    var $togglePassword = appendToggler($container, $formField, actionClassName);
    updateToggler(states, $formField, $togglePassword, {
      templateData: {
        label: label
      }
    });
    $togglePassword.on("click.".concat(NS), function (e) {
      e.preventDefault();
      updateToggler(states, $formField, $togglePassword, {
        templateData: {
          label: label
        }
      });
    });
    return __WEBPACK_IMPORTED_MODULE_1_lodash_noop___default.a;
  };
};
/* harmony default export */ __webpack_exports__["a"] = (togglePassword);

/***/ }),
/* 266 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export NS */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return validateEmail; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_validator_lib_isFQDN__ = __webpack_require__(501);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_validator_lib_isFQDN___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_validator_lib_isFQDN__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_find__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_find___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_find__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_get__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_get__);
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
/**
 * Responsible for validating an email field with specific messaging based on
 * what is specifically incorrect with the field.
 * @module elements/fields/validate-email
 */

// import isEmail from 'validator/lib/isEmail';



var NS = 'validate-email';
var invalidMessaging = {
  i18nKey: 'isInvalid',
  message: 'Email is invalid'
};
var validationPriorities = [
// When the preceived username is a domain, i.e. an @ symbol is forgotten
{
  condition: function condition(username) {
    return __WEBPACK_IMPORTED_MODULE_1_validator_lib_isFQDN___default()(username);
  },
  i18nKey: 'requiresDomain',
  message: 'Email address needs an @'
},
// When no domain has been provided or a user has only entered a username
Object.assign({}, invalidMessaging, {
  condition: function condition(username, domain) {
    return !domain;
  }
}),
// When no TLD has been provided, i.e. foo@foo
{
  condition: function condition(username, domain) {
    var _domain$split = domain.split('.'),
      _domain$split2 = _slicedToArray(_domain$split, 2),
      tld = _domain$split2[1];
    return !__WEBPACK_IMPORTED_MODULE_1_validator_lib_isFQDN___default()(domain) && !tld;
  },
  i18nKey: 'requiresTLD',
  message: 'Email address needs a top level domain'
}

// Catch all for all usecases that do not meet the above criteria
// Object.assign({}, invalidMessaging, {
//   condition: (username, domain, email) => !isEmail(email),
// }),
];

/**
 * Responsible for making the source element either valid or invalid.
 * @param {jQuery} $el - Element with reference to target
 * @param {string} message - The error message
 */
var verifyError = function verifyError($el) {
  var message = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  var source = $el[0];
  source.setCustomValidity(message);
  source.checkValidity();
  if (!message) {
    var evt = new CustomEvent('valid');
    source.dispatchEvent(evt);
  }
};

/**
 * Responsible for running through messages with the intention of returning
 * which type of validation has been found.
 * @param {jQuery} $el - Elements checked to be a valid email
 * @param {Object} options - Configurable options
 * @returns {string} Value used for setting custom validity
 */
var validateEmail = function validateEmail($el) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var email = $el.val();
  // Make sure we have a value just in case the field is not required. That
  // can be handled by another validator.
  if (!email) {
    return '';
  }
  var _Object$assign = Object.assign({}, {
      global: window
    }, options),
    global = _Object$assign.global;
  var _email$split = email.split('@'),
    _email$split2 = _slicedToArray(_email$split, 2),
    username = _email$split2[0],
    _email$split2$ = _email$split2[1],
    domain = _email$split2$ === void 0 ? '' : _email$split2$;
  var validation = __WEBPACK_IMPORTED_MODULE_2_lodash_find___default()(validationPriorities, function (_ref) {
    var condition = _ref.condition;
    return condition(username, domain, email);
  });
  if (validation) {
    var i18nKey = validation.i18nKey,
      message = validation.message;
    return __WEBPACK_IMPORTED_MODULE_3_lodash_get___default()(global, ['rcProps', 'emailValidation', i18nKey], message);
  }
  return '';
};

/**
 * Responsible for applying email validation with specific error messages
 * based on a succession of validations.
 * @param {HTMLElement} el - Element receiving email validation
 * @param {Object} options - Configurable options
 */
/* unused harmony default export */ var _unused_webpack_default_export = (function (el) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var $el = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(el);
  $el.on("blur.".concat(NS), function () {
    var message = validateEmail($el, options);
    verifyError($el, message);
  });
});

/***/ }),
/* 267 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_isNil__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_isNil___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_isNil__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_register_jquery_plugin__ = __webpack_require__(1);
/**
 * Responsible for validating a field so that it simulates a user interacting
 * with a field.
 * @module elements/fields/validate-field
 */



var VALIDATE_FIELDS_DEFAULTS = {
  val: null,
  retainFocus: true
};
function validateField(el) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var $el = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(el);
  var _Object$assign = Object.assign({}, VALIDATE_FIELDS_DEFAULTS, options),
    val = _Object$assign.val,
    retainFocus = _Object$assign.retainFocus;
  var prevActiveElement = document.activeElement;
  if (!__WEBPACK_IMPORTED_MODULE_1_lodash_isNil___default()(val)) {
    $el.val(val);
  }
  $el.trigger('focus').trigger('blur');
  if (retainFocus) {
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()(prevActiveElement).trigger('focus');
  }
}
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__lib_register_jquery_plugin__["a" /* default */])('validate', validateField, {
  cache: false
});

/***/ }),
/* 268 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return makeValidateMissing; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_isString__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_isString___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_isString__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_kebabCase__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_kebabCase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_kebabCase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_get__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__validator_constants__ = __webpack_require__(63);
/* unused harmony reexport DEFAULT_MESSAGE */







/**
 * Ensures that an element is not missing a value. This is different from a
 * required attribute as the validation occurs on submit by the validator
 * verses natively in the browser.
 *
 * @param {string} dataAttr - The data attribute receiving the missing
 * validation
 * @returns {Function} Runs through the validation
 */
var makeValidateMissing = function makeValidateMissing() {
  var dataAttr = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'validateMissing';
  return function ($el) {
    var errorMessage = $el.data('errorMessage');
    var message = $el.data(dataAttr);
    var hasValue = !!$el.val();
    var type = $el.prop('type');
    if (type === 'radio') {
      var nameProp = $el.prop('name');
      var $inputs = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(document.getElementsByName(nameProp));
      var validElements = $inputs.filter(function (_, input) {
        return __WEBPACK_IMPORTED_MODULE_3_lodash_get___default()(input, 'validity.valid');
      });
      if (validElements.length !== $inputs.length) {
        return '';
      }
      var $checked = $inputs.filter(':checked');
      if ($checked.length) {
        return '';
      }
      hasValue = false;
      var validateSelector = "[data-".concat(__WEBPACK_IMPORTED_MODULE_2_lodash_kebabCase___default()(dataAttr), "]");
      var $customErrorMessages = $inputs.filter(validateSelector);
      if ($customErrorMessages.length) {
        message = $customErrorMessages.eq(0).data(dataAttr);
      }
      var $defaultErrorMessage = $inputs.filter('[data-error-message]');
      if ($defaultErrorMessage.length) {
        errorMessage = $defaultErrorMessage.eq(0).data('errorMessage');
      }
    }
    if (type === 'checkbox' && !$el.is(':checked')) {
      hasValue = false;
    }
    if (!hasValue) {
      if (__WEBPACK_IMPORTED_MODULE_1_lodash_isString___default()(message)) {
        return message;
      }
      return errorMessage || __WEBPACK_IMPORTED_MODULE_4__validator_constants__["a" /* DEFAULT_MESSAGE */];
    }
    return '';
  };
};

/***/ }),
/* 269 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export NS */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return validateSameAs; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__validator_constants__ = __webpack_require__(63);
/* unused harmony reexport DEFAULT_MESSAGE */
/**
 * Responsible making sure a source element value matches to a target element
 * value.
 * @module elements/fields/validate-same-as
 */



var NS = 'validate-same-as';

/**
 * Responsible for making the source element either valid or invalid.
 * @param {jQuery} $source - Element with reference to target
 * @param {string} message - The error message
 */
var verifyError = function verifyError($source) {
  var message = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  var source = $source[0];
  source.setCustomValidity(message);
  source.checkValidity();
  if (!message) {
    var evt = new CustomEvent('valid');
    source.dispatchEvent(evt);
  }
};

/**
 * Responsible for validating the source and target element values and determine
 * if an error has been found.
 * @param {jQuery} $source - Element with reference to target
 * @param {jQuery} $target - Target element
 * @returns {string} The error message
 */
var validateMatching = function validateMatching($source, $target) {
  var sourceValue = $source.val();
  var targetValue = $target.val();
  if (sourceValue !== targetValue) {
    return $source.data('errorMessage') || __WEBPACK_IMPORTED_MODULE_1__validator_constants__["a" /* DEFAULT_MESSAGE */];
  }
  return '';
};

/**
 * Responsible for matching the source value with the target value and makes
 * target element either valid or invalid.
 * @param {jQuery} $source - Element with reference to target
 * @param {jQuery} $target - Target element
 */
var matchesTarget = function matchesTarget($source, $target) {
  var message = validateMatching($source, $target);
  verifyError($source, message);
};

/**
 * Responsible for finding the target element.
 * @param {jQuery} $source - Element with reference to target
 * @returns {jQuery} The target element
 */
var getTarget = function getTarget($source) {
  var selector = $source.data('validateSameAs');
  var $form = __WEBPACK_IMPORTED_MODULE_0_jquery___default()($source.prop('form'));
  var $target = $form.find(selector);
  if (!$target.length) {
    throw new Error("No matching selector ".concat(selector, " found for same as"));
  }
  return $target;
};

/**
 * Used for hooking into a validator data attribute.
 * @param {jQuery} $source - Element with reference to target
 * @returns {string} Error message if an error is found
 */
var validateSameAs = function validateSameAs($source) {
  var $target = getTarget($source);
  $target.on("blur.".concat(NS), function () {
    return matchesTarget($source, $target);
  });
  return validateMatching($source, $target);
};

/**
 * Responsible for finding a target element and ensuring that both fields have
 * the same values.
 * @param {HTMLElement} source - Element with reference to target
 * @returns {Object} Additional methods attached validate same as
 */
/* unused harmony default export */ var _unused_webpack_default_export = (function (source) {
  var $source = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(source);
  var $target = getTarget($source);
  validateSameAs($source);
  $source.on("blur.".concat(NS), function () {
    var message = validateMatching($source, $target);
    verifyError($source, message);
  });
  return {
    teardown: function teardown() {
      $source.off(".".concat(NS));
      $target.off(".".concat(NS));
    }
  };
});

/***/ }),
/* 270 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = dataProps;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_merge__ = __webpack_require__(482);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_merge___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_merge__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_has__ = __webpack_require__(474);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_has___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_has__);
/**
 * Responsible for setting up data attributes that have required fields.
 * @module lib/dataProps
 */




/**
 * Provides a way of pulling in data attributes on an element, while providing
 * sensible defaults and required fields.
 * @param {HTMLElement|jQuery|string} el - The element containing the data attrs
 * @param {Object} [defaults={}] - Any applied default fields
 * @param {Array} [required=[]] - Represents any fields that are required
 * @return {Object} Data from the element and defaults
 */
function dataProps(el) {
  var defaults = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var required = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
  var data = __WEBPACK_IMPORTED_MODULE_1_lodash_merge___default()({}, defaults, __WEBPACK_IMPORTED_MODULE_0_jquery___default()(el).data());
  required.forEach(function (path) {
    if (!__WEBPACK_IMPORTED_MODULE_2_lodash_has___default()(data, path)) {
      throw new Error("".concat(path, " was not found as a data attr"));
    }
  });
  return data;
}

/***/ }),
/* 271 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_debounce__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_debounce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_debounce__);


window.jQuery = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a;
window.$ = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a;
window.debounce = __WEBPACK_IMPORTED_MODULE_1_lodash_debounce___default.a;
__WEBPACK_IMPORTED_MODULE_0_jquery___default()('document').ready(function () {});

/***/ }),
/* 272 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export PLUGIN_NAME */
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_register_jquery_plugin__ = __webpack_require__(1);
/**
 * Toggle classes
 * @module abControls
 */




// Expose the function as a jQuery plugin for ease of use
var PLUGIN_NAME = 'abControls';

/**
 * Applies any sort of event handlers for the abControls.
 * @param  {jQuery} $el - link
 * @param  {Object} [options={}] - Any options provided upon initialization
 */
var setEventListeners = function setEventListeners($el) {
  var activeClass = 'ab-controls--active';
  $el.find('.js-ab-controls-btn').on('click', function () {
    if ($el.hasClass(activeClass)) {
      $el.removeClass(activeClass);
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.ab-controls__wrapper').css('width', 'auto');
    } else {
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.ab-controls__wrapper').css('width', '100%');
      $el.addClass(activeClass);
    }
  });
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).on('mouseup.dropdown', function (e) {
    if (!$el.is(e.target) && $el.has(e.target).length === 0) {
      $el.removeClass(activeClass);
    }
  });
  $el.find('.js-ab-controls-close').on('click', function (e) {
    e.stopPropagation();
    $el.removeClass(activeClass);
  });
  $el.find('.js-ab-controls-remove').on('click', function (e) {
    e.preventDefault();
    $el.removeClass('ab-controls--show');
    localStorage.setItem('abControls', 'false');
  });
  $el.find('.ab-controls-clickable').on('click', function (e) {
    var element = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(e.target);
    var request = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.ajax({
      url: '/dbadmin/spring-controller/abtest/toggleABTestGroup',
      type: 'POST',
      data: element.data('value')
    });
    request.done(function () {
      window.location.reload(true);
    });
  });
};
/**
 * Initializes abControls.
 * @param {HTMLElement} el - link
 * @param {Object} options - Options used for wiring up the modal
 * @see DEFAULTS
 */
function abControls(el) {
  var $el = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(el);
  __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.ajax({
    url: '/dbadmin/spring-controller/abtest/abtest-widget',
    type: 'GET',
    data: {
      abtestids: $el.data('ids'),
      device: 'mobile'
    },
    success: function success(data) {
      $el.append(data);
      setEventListeners($el);
      if (localStorage.getItem('abControls') === 'false') {
        $el.removeClass('ab-controls--show');
      } else if (localStorage.getItem('abControls') === 'true' || localStorage.getItem('abControls') === null) {
        $el.addClass('ab-controls--show');
        localStorage.setItem('abControls', 'true');
      }
    }
  });
}
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__lib_register_jquery_plugin__["a" /* default */])(PLUGIN_NAME, abControls);

/***/ }),
/* 273 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* eslint-disable */

var SELECTORS = {
  FOLLOWED: {
    CONTAINER: '.cards--shops'
  },
  RECOMMENDED: {
    CONTAINER: '.recommended-shops'
  },
  CPL: {
    CONTAINER: '.action-button--shops-cpl'
  },
  HOT_LIST: {
    CONTAINER: '.hotlist-shops'
  }
};
function handleFollowButtonClick() {
  var $followButton = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this);
  if (!$followButton.hasClass(SELECTORS.RECOMMENDED.ACTIVE_CLASS)) {
    $followButton.toggleClass(SELECTORS.RECOMMENDED.ACTIVE_CLASS);
    $followButton.prop('disabled', true);
    var $returnFocus = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('[id*=recommended-shop-heading]:first .link');
    var data = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.param({
      cplId: $followButton.data('cpl-id'),
      shopId: $followButton.data('shop-id'),
      brand: $followButton.data('brand'),
      isMens: $followButton.data('is-mens'),
      operation: window.rcProps.myShops.myShopAddOperation
    });
    __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.ajax({
      url: window.rcProps.myShops.updateMyShopPath,
      type: 'post',
      data: data,
      success: function success() {
        __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.modal({
          open: "my-shop-add-confirm-modal",
          type: 'notification',
          triggerOpen: true,
          returnFocus: $returnFocus.length ? $returnFocus : '',
          closeButton: false
        });
        $followButton.closest('li').delay(800).remove();
        location.reload();
      }
    });
  }
}
function handleUnfollowButtonClick() {
  var $unfollowButton = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this);
  var data = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.param({
    cplId: $unfollowButton.data('cpl-id'),
    shopId: $unfollowButton.data('shop-id'),
    brand: $unfollowButton.data('brand'),
    isMens: $unfollowButton.data('is-mens'),
    operation: window.rcProps.myShops.myShopRemoveOperation
  });
  $unfollowButton.closest('li').delay(800).remove();
  __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.ajax({
    url: window.rcProps.myShops.updateMyShopPath,
    type: 'post',
    data: data,
    success: function success() {
      __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.modal({
        open: "my-shop-remove-confirm-modal",
        type: 'notification',
        triggerOpen: true,
        returnFocus: __WEBPACK_IMPORTED_MODULE_0_jquery___default()('[id*=my-shops-heading]:last .link'),
        closeButton: false
      });
      var totalShops = parseInt(__WEBPACK_IMPORTED_MODULE_0_jquery___default()('#shops-size').text()) - 1;
      if (totalShops >= 0) {
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#shops-size').text(totalShops);
      }
      var shopsSize = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.my-favorite-shop').length;
      var url = new URL(window.location.href);
      if (shopsSize < 1) {
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.pagination__wrap').hide();
        var pageNo = url.searchParams.get('pageNum');
        if (pageNo) {
          pageNo = parseInt(pageNo) - 1;
          if (pageNo <= 1) {
            url.searchParams["delete"]('pageNum');
          } else {
            url.searchParams.set('pageNum', pageNo);
          }
        }
      }
      window.location.href = url.href;
    }
  });
}
function addFollowButtonListener() {
  var $followButtons = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(SELECTORS.RECOMMENDED.HEART_ICON);
  $followButtons.each(function addFollow() {
    var $followButton = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this);
    $followButton.on('click', handleFollowButtonClick);
  });
}
function addUnfollowButtonListener() {
  var $unfollowButtons = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(SELECTORS.FOLLOWED.HEART_ICON);
  $unfollowButtons.each(function addUnfollow() {
    var $unfollowButton = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this);
    $unfollowButton.on('click', handleUnfollowButtonClick);
  });
}
function addHotlistHeartButtonListener() {
  var $heartButtons = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(SELECTORS.HOT_LIST.HEART_ICON);
  $heartButtons.each(function addUnfollow() {
    var $heartButton = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this);
    $heartButton.on('click', handleHeartButtonClick);
  });
}
function handleHeartButtonClick() {
  var $heartButton = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this);
  if (!$heartButton.hasClass(SELECTORS.RECOMMENDED.ACTIVE_CLASS)) {
    addHearted($heartButton);
  } else {
    removeHearted($heartButton);
  }
}
function addHearted($followButton) {
  var data = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.param({
    cplId: $followButton.data('cpl-id'),
    shopId: $followButton.data('shop-id'),
    brand: $followButton.data('brand'),
    isMens: $followButton.data('is-mens'),
    operation: window.rcProps.myShops.myShopAddOperation
  });
  if ($followButton.hasClass(SELECTORS.RECOMMENDED.ACTIVE_CLASS)) {
    return;
  }
  $followButton.toggleClass(SELECTORS.RECOMMENDED.ACTIVE_CLASS);
  __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.ajax({
    url: window.rcProps.myShops.updateMyShopPath,
    type: 'post',
    data: data,
    success: function success() {
      __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.modal({
        open: "my-shop-add-confirm-modal",
        type: 'notification',
        triggerOpen: true,
        closeButton: false,
        triggerElement: $followButton
      });
    }
  });
  $followButton.find('.js-hotlist-shops-fav-btn-sr').text($followButton.data('unfavorite-message'));
}
function removeHearted($unfollowButton) {
  var data = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.param({
    cplId: $unfollowButton.data('cpl-id'),
    shopId: $unfollowButton.data('shop-id'),
    brand: $unfollowButton.data('brand'),
    isMens: $unfollowButton.data('is-mens'),
    operation: window.rcProps.myShops.myShopRemoveOperation
  });
  if (!$unfollowButton.hasClass(SELECTORS.RECOMMENDED.ACTIVE_CLASS)) {
    return;
  }
  $unfollowButton.toggleClass(SELECTORS.RECOMMENDED.ACTIVE_CLASS);
  __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.ajax({
    url: window.rcProps.myShops.updateMyShopPath,
    type: 'post',
    data: data,
    success: function success() {
      __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.modal({
        open: "my-shop-remove-confirm-modal",
        type: 'notification',
        triggerOpen: true,
        closeButton: false,
        triggerElement: $unfollowButton
      });
    }
  });
  $unfollowButton.find('.js-hotlist-shops-fav-btn-sr').text($unfollowButton.data('favorite-message'));
}
__WEBPACK_IMPORTED_MODULE_0_jquery___default()(function () {
  // Execute only if at least one of the container elements exists
  if (__WEBPACK_IMPORTED_MODULE_0_jquery___default()(SELECTORS.FOLLOWED.CONTAINER).length || __WEBPACK_IMPORTED_MODULE_0_jquery___default()(SELECTORS.RECOMMENDED.CONTAINER).length || __WEBPACK_IMPORTED_MODULE_0_jquery___default()(SELECTORS.HOT_LIST.CONTAINER).length) {
    SELECTORS.RECOMMENDED.HEART_ICON = "".concat(SELECTORS.RECOMMENDED.CONTAINER, "__favorite");
    SELECTORS.RECOMMENDED.ACTIVE_CLASS = 'recommended-shops__favorite--active';
    SELECTORS.FOLLOWED.CARD_CONTAINER = '.card--shops';
    SELECTORS.FOLLOWED.HEART_ICON = "".concat(SELECTORS.FOLLOWED.CARD_CONTAINER, "__header-icon");
    SELECTORS.HOT_LIST.HEART_ICON = "".concat(SELECTORS.HOT_LIST.CONTAINER, "__favorite");
    addFollowButtonListener();
    addUnfollowButtonListener();
    addHotlistHeartButtonListener();
  } else if (__WEBPACK_IMPORTED_MODULE_0_jquery___default()(SELECTORS.CPL.CONTAINER).length) {
    SELECTORS.CPL.ACTIVE_CLASS = 'action-button--shops-cpl--active';
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()(SELECTORS.CPL.CONTAINER).on('click', function toggleFavorite() {
      var $heartButton = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this);
      if (!$heartButton.hasClass(SELECTORS.CPL.ACTIVE_CLASS)) {
        $heartButton.toggleClass(SELECTORS.CPL.ACTIVE_CLASS).addClass('action-button--dark').find('.favorite-msg').text('Following This Shop');
        var data = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.param({
          cplId: $heartButton.data('cpl-id'),
          operation: window.rcProps.myShops.myShopAddOperation
        });
        __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.ajax({
          url: window.rcProps.myShops.updateMyShopPath,
          type: 'post',
          data: data,
          success: function success() {
            __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.modal({
              open: 'add-my-shop-confirm-modal',
              type: 'notification',
              triggerOpen: true,
              returnFocus: SELECTORS.CPL.CONTAINER,
              closeButton: false
            });
          }
        });
      } else {
        $heartButton.toggleClass(SELECTORS.CPL.ACTIVE_CLASS).removeClass('action-button--dark').find('.favorite-msg').text('Follow This Shop');
        var _data = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.param({
          cplId: $heartButton.data('cpl-id'),
          operation: window.rcProps.myShops.myShopRemoveOperation
        });
        __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.ajax({
          url: window.rcProps.myShops.updateMyShopPath,
          type: 'post',
          data: _data,
          success: function success() {
            __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.modal({
              open: 'remove-my-shop-confirm-modal',
              type: 'notification',
              triggerOpen: true,
              returnFocus: SELECTORS.CPL.CONTAINER,
              closeButton: false
            });
          }
        });
      }
    });
  }
});

/***/ }),
/* 274 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export PLUGIN_NAME */
/* unused harmony export DEFAULTS */
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__custom_video_player__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_register_jquery_plugin__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_merge_options__ = __webpack_require__(2);
/**
 * Mobile Video Player Module
 * @module mobileVideoPlayer
 *
 * Handles click-to-overlay video behavior for mobile PDP Size & Fit tab.
 * No floating/dragging logic — opens a full-screen overlay instead.
 */





var PLUGIN_NAME = 'mobileVideoPlayer';
var DEFAULTS = {
  videoMuted: false,
  hideMute: false,
  $originalTrigger: __WEBPACK_IMPORTED_MODULE_0_jquery___default()(),
  titleClass: 'floating-video__title',
  captionClass: 'floating-video__caption'
};
var createOverlayHTML = function createOverlayHTML(videoUrl, videoPosterUrl) {
  return __WEBPACK_IMPORTED_MODULE_0_jquery___default()("\n  <div class=\"mobile-video-player js-mobile-video-player\">\n    <button class=\"mobile-video-player__close js-mobile-video-player__close\" type=\"button\" aria-label=\"Close video\">\n      <span class=\"icon icon--x icon--md\">\n        <svg viewBox=\"0 0 16 16\" aria-hidden=\"true\" focusable=\"false\" role=\"presentation\">\n          <path d=\"M9.06 8l2.72-2.72A.75.75 0 0 0 10.72 4.22L8 6.94 5.28 4.22A.75.75 0 0 0 4.22 5.28L6.94 8l-2.72 2.72A.75.75 0 1 0 5.28 11.78L8 9.06l2.72 2.72a.75.75 0 0 0 1.061-1.061z\"/>\n        </svg>\n      </span>\n    </button>\n    <video class=\"u-full-width\" poster=\"".concat(videoPosterUrl, "\" playsinline loop>\n      <source src=\"").concat(videoUrl, "\" type=\"video/mp4\">\n    </video>\n  </div>\n"));
};
var showVideo = function showVideo($el, options) {
  var videoUrl = $el.data('videoUrl');
  var videoPosterUrl = $el.data('videoPosterUrl');
  var $overlay = createOverlayHTML(videoUrl, videoPosterUrl);
  var $video = $overlay.find('video');
  var $closeButton = $overlay.find('.js-mobile-video-player__close');
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-mobile-video-player').remove();
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('body').append($overlay).addClass('u-overflow--hidden');
  $closeButton.on('click', function () {
    $overlay.remove();
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()('body').removeClass('u-overflow--hidden');
  });
  $video.customVideoPlayer(options);
};
function mobileVideoPlayer(el) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var $el = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(el);
  var opts = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__lib_merge_options__["a" /* default */])(DEFAULTS, options, $el);
  opts.$originalTrigger = $el;
  $el.on('click', function () {
    showVideo($el, opts);
  });
  return {};
}
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__lib_register_jquery_plugin__["a" /* default */])(PLUGIN_NAME, mobileVideoPlayer);

/***/ }),
/* 275 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export PLUGIN_NAME */
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_register_jquery_plugin__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_merge_options__ = __webpack_require__(2);
/* eslint-disable */



var PLUGIN_NAME = 'modelSwitch';
var DEFAULTS = {
  model: -1,
  modelHeight: '',
  modelSize: ''
};
var $sizeEl = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.multiple-models__size');
var $heightEl = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.multiple-models__height');
var switchModel = function switchModel($el, opts) {
  var _$el$data = $el.data(),
    code = _$el$data.code,
    modelHeight = _$el$data.modelHeight,
    modelSize = _$el$data.modelSize,
    modelNum = _$el$data.modelNum;
  $sizeEl.text(modelSize);
  $heightEl.text(modelHeight);
  if (typeof logEngagementWithDetails === 'function') {
    var logData = {
      modelHeight: modelHeight,
      modelSize: modelSize,
      modelNum: modelNum
    };
    logEngagementWithDetails(window.location.href, 'PDP Change Model', 'Size Change', JSON.stringify(logData));
  }
  window.insertStylisticsImagesByAjax(code, modelNum);
};
var addEventListeners = function addEventListeners($el, opts) {
  $el.on('click', function () {
    return switchModel($el, opts);
  });
};
function modelSwitch(el, options) {
  var $el = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(el);
  var opts = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__lib_merge_options__["a" /* default */])(DEFAULTS, options, $el);
  addEventListeners($el, opts);
}
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__lib_register_jquery_plugin__["a" /* default */])(PLUGIN_NAME, modelSwitch);

/***/ }),
/* 276 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export PLUGIN_NAME */
/* unused harmony export CLICK_EVENT */
/* unused harmony export AUTO_VALUE */
/* unused harmony export BLOCK_VALUE */
/* unused harmony export CHECKED_ATTR */
/* unused harmony export FORCE_OPEN_CLASS */
/* unused harmony export DEFAULTS */
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__horizontal_scroll__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__no_focus__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_props__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib_register_jquery_plugin__ = __webpack_require__(1);
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * Responsible for creating an accordion based on elements existing in the DOM
 * @module modules/accordion
 */






var PLUGIN_NAME = 'accordion';
var CLICK_EVENT = 'click';
var AUTO_VALUE = 'auto';
var BLOCK_VALUE = 'block';
var CHECKED_ATTR = 'checked';
var FORCE_OPEN_CLASS = '.accordion__item--force';

/**
 * AB### for R Mobile Faster Accordions
 */
var isFasterAcc = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__lib_props__["a" /* get */])('rcProps.fasterAccordions', false);
var DEFAULTS = {
  accItem: '.accordion__item',
  accContent: '.accordion__content',
  accActive: 'accordion__item--active',
  accRadio: 'js-accordion-radio',
  accLabel: '.accordion__label',
  accSpeed: isFasterAcc ? 100 : 200,
  accToggle: false,
  accDataToggleAttr: 'toggle',
  accQueryOpen: false,
  accDataQueryAttr: 'queryString',
  onComplete: function onComplete() {},
  onLoad: function onLoad() {},
  noFocus: false
};

/**
 * Merges together all the options and the various conditions in which they
 * can be set.
 * @private
 * @param  {jQuery} $el - The container element
 * @param  {Object} [options={}] - Any options provided upon initialization
 * @return {Object} Immutable version of the options
 */
var mergeOptions = function mergeOptions($el) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var opts = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.extend({}, DEFAULTS, options);
  var _opts = opts,
    accDataToggleAttr = _opts.accDataToggleAttr,
    accDataQueryAttr = _opts.accDataQueryAttr;
  if ($el.data(accDataToggleAttr) === true) {
    opts = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.extend({}, opts, {
      accToggle: true
    });
  }
  if ($el.data(accDataQueryAttr) === true) {
    opts = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.extend({}, opts, {
      accQueryOpen: true
    });
  }
  if ($el.data('acc-speed') !== undefined) {
    opts = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.extend({}, opts, {
      accSpeed: $el.data('acc-speed')
    });
  }
  return opts;
};

/**
 * Handles any sort of defaults when the accordion is called upon.
 * @private
 * @param  {jQuery} $el - The container element
 * @param  {Object} options - Any options provided upon initialization
 * @param  {string} options.accActive - Selector representing the active
 * className
 * @param  {string} options.accContent - Selector representing the content for
 * the tab
 */
var applyDefaultsToActive = function applyDefaultsToActive($el, _ref) {
  var accActive = _ref.accActive,
    accContent = _ref.accContent,
    accLabel = _ref.accLabel;
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()(".".concat(accActive), $el).find(accContent).css({
    display: BLOCK_VALUE,
    height: AUTO_VALUE
  }).find(accLabel).attr('aria-expanded', 'true');
};

/**
 * Handles any sort of defaults when the accordion is using radio buttons.
 * @private
 * @param  {jQuery} $el - The container element
 * @param  {Object} options - Any options provided upon initialization
 * @param  {string} options.accActive - Selector representing the active
 * className
 * @param  {string} options.accContent - Selector representing the content for
 * the tab
 * @param  {string} options.accItem - Selector representing the tab
 * @param  {string} options.accRadio - Selector representing a radio button
 */
var applyDefaultsToRadio = function applyDefaultsToRadio($el, _ref2) {
  var accActive = _ref2.accActive,
    accContent = _ref2.accContent,
    accItem = _ref2.accItem,
    accRadio = _ref2.accRadio;
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()(".".concat(accRadio, ":").concat(CHECKED_ATTR), $el).parents(accItem).addClass(accActive).find(accContent).css({
    height: AUTO_VALUE
  });
};
var applyDefaultsToForce = function applyDefaultsToForce($el, _ref3) {
  var accContent = _ref3.accContent;
  var $forceContents = $el.find(FORCE_OPEN_CLASS).find(accContent);
  $forceContents.css({
    display: BLOCK_VALUE,
    height: AUTO_VALUE
  });
};

/**
 * Closes the active tab
 * @private
 * @param  {jQuery} $parent - The parent containing the entire tab.
 * @param  {Object} options - Any options provided upon initialization
 * @param  {string} options.accLabel - Selector representing the label className
 * @param  {string} options.accActive - Selector representing the active
 * className
 * @param  {string} options.accContent - Selector representing the content for
 * the tab
 * @param  {string} options.accItem - Selector representing the tab
 * @param  {number} options.accSpeed - Speed in ms for the closing animation
 */
var closeActiveTab = function closeActiveTab($el, _ref4) {
  var accLabel = _ref4.accLabel,
    accActive = _ref4.accActive,
    accContent = _ref4.accContent,
    accItem = _ref4.accItem,
    accSpeed = _ref4.accSpeed;
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()(".".concat(accActive), $el).find(accContent).stop().animate({
    height: 0
  }, accSpeed, function callback() {
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).removeAttr('style');
  });
  $el.find(accLabel).attr('aria-expanded', false);
  $el.find(accItem).removeClass(accActive);
};

/**
 * Lazy loads images inside the accordion content when opened.
 * @private
 * @param {Object} content - The content of the interacted label
 */
var lazyloadImages = function lazyloadImages(content) {
  // If images need to be lazy loaded - follow example markup below to load them
  // <img class="js-lazy-image"
  //      src="data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw=="
  //      data-lazy="image/url"
  //      alt=""
  // />
  var lazyImages = content.find('.js-lazy-image').not('.loaded');
  if (lazyImages) {
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()(lazyImages).each(function eachLazyImage() {
      var $lazyImage = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this);
      if (!$lazyImage.hasClass('loaded')) {
        $lazyImage.attr('src', $lazyImage.attr('data-lazy')).addClass('loaded');
      }
    });
  }
};

/**
 * Initialize a Horizonal Scroll module in the accordion content when opened.
 * @private
 * @param {Object} content - The content of the interacted label
 */
var lazyloadHorizontalScroll = function lazyloadHorizontalScroll(content) {
  var horizontalScroll = content.find('.js-horizontal-scroll-accordion');
  if (horizontalScroll) {
    horizontalScroll.horizontalScroll();
  }
};

/**
 * Opens a tab and provides any DOM manipulation and styles used to show a tab.
 * @private
 * @param {jQuery} $el - Containing the elements for the accordion
 * @param {jQuery} $parent - The parent of the interacted label
 * @param  {Object} options - Any options provided upon initialization
 * @param  {string} options.accLabel - Selector representing the label className
 * @param  {string} options.accActive - Selector representing the active
 * className
 * @param  {string} options.accContent - Selector representing the content for
 * the tab
 * @param  {string} options.accRadio - Selector representing a radio button
 * @param  {number} options.accSpeed - Speed in ms for the closing animation
 * @param  {Function} options.onComplete - Called on when animation has
 * completed
 */
var openTab = function openTab($el, $parent, _ref5) {
  var accLabel = _ref5.accLabel,
    accActive = _ref5.accActive,
    accContent = _ref5.accContent,
    accRadio = _ref5.accRadio,
    accSpeed = _ref5.accSpeed,
    onComplete = _ref5.onComplete;
  var content = $parent.find(accContent);
  content.css({
    height: AUTO_VALUE,
    display: BLOCK_VALUE
  });
  var contentHeight = content.outerHeight(true);
  lazyloadImages(content);
  lazyloadHorizontalScroll(content);
  content.css({
    height: 0
  }).stop().animate({
    height: contentHeight
  }, accSpeed, function () {
    content.css({
      height: AUTO_VALUE
    });
    if ($el.attr('data-resize-colorbox') === 'true') {
      if (__WEBPACK_IMPORTED_MODULE_0_jquery___default.a.colorbox && typeof __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.colorbox.resize === 'function') {
        __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.colorbox.resize();
      }
    }
    // Check if we're not in a test environment before scrolling
    if (!window.fixture && typeof window !== 'undefined') {
      // Only scroll if the data-scroll-to-view attribute is present
      var shouldScroll = $parent.attr('data-scroll-to-view') === 'true' || $el.attr('data-scroll-to-view') === 'true';
      if (shouldScroll) {
        var headerOffset = $parent.offset().top;
        // Check for a custom offset value
        var scrollOffset = parseInt($parent.attr('data-scroll-offset') || $el.attr('data-scroll-offset') || 0, 10);
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()('html, body').animate({
          scrollTop: headerOffset - scrollOffset
        }, 300);
      }
    }
    onComplete();
  });
  $parent.find(accLabel).attr('aria-expanded', true);
  $parent.addClass(accActive).children(accRadio).prop(CHECKED_ATTR, true);
};

/**
 * Closes an existing tab that has directly been interacted with.
 * @private
 * @param  {jQuery} $parent - The parent containing the entire tab.
 * @param  {Object} options - Any options provided upon initialization
 * @param  {string} options.accLabel - Selector representing the label className
 * @param  {string} options.accActive - Selector representing the active
 * className
 * @param  {string} options.accContent - Selector representing the content for
 * the tab
 * @param  {number} options.accSpeed - Speed in ms for the closing animation
 */
var closeExistingActiveTab = function closeExistingActiveTab($parent, _ref6) {
  var accLabel = _ref6.accLabel,
    accActive = _ref6.accActive,
    accContent = _ref6.accContent,
    accSpeed = _ref6.accSpeed;
  $parent.find(accContent).stop().animate({
    height: 0
  }, accSpeed, function callback() {
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).removeAttr('style');
    $parent.removeClass(accActive);
  });
  $parent.find(accLabel).attr('aria-expanded', false);
};

/**
 * Handles the click event when a label has been interacted with.
 * @private
 * @param {jQuery.Event} evt - A jQuery event
 * @param {HTMLElement} currentTarget - The current target interacted with
 * @param {jQuery} $el - Containing the elements for the accordion
 * @param {Object} opts - Options passed along from initialization
 */
var itemClickHandler = function itemClickHandler(_ref7, $el, opts) {
  var currentTarget = _ref7.currentTarget;
  var accActive = opts.accActive,
    accItem = opts.accItem,
    accToggle = opts.accToggle;
  var $parent = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(currentTarget).closest(accItem);
  opts.onLoad({
    target: $el,
    opts: opts
  });
  if (!$parent.hasClass(accActive)) {
    if (!accToggle) {
      closeActiveTab($el, opts);
    }
    openTab($el, $parent, opts);
  } else {
    closeExistingActiveTab($parent, opts);
  }
};

/**
 * Utility function to pull query parameter form URL
 * @private
 * @param {String} name - String to look for in URL
 */
var getParameterByName = function getParameterByName(name) {
  var nameReplace = name.replace(/[[]/, '\\[').replace(/[\]]/, '\\]');
  var regex = new RegExp("[\\?&]".concat(nameReplace, "=([^&#]*)"));
  var results = regex.exec(location.search);
  return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
};

/**
 * Applies any sort of event handlers for the accordion.
 * @private
 * @param {jQuery} $el - Containing the elements for the accordion
 * @param {Object} options - Options used for wiring up the accordion
 * @see DEFAULTS
 */
var applyEventHandlers = function applyEventHandlers($el, $activeLabels) {
  var opts = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var accItem = opts.accItem,
    accQueryOpen = opts.accQueryOpen;
  // check if accordion has data attr set to true
  if (accQueryOpen) {
    // check for query string in URL
    var accordionOpen = getParameterByName('accordionOpen');
    if (accordionOpen) {
      // set parent for openTab
      var $parent = $el.find("#".concat(accordionOpen)).closest(accItem);
      //  Set animation speed to 0 so default active tab closes as quick as possible.
      closeActiveTab($el, _objectSpread(_objectSpread({}, opts), {}, {
        accSpeed: 0
      }));
      openTab($el, $parent, _objectSpread(_objectSpread({}, opts), {}, {
        accSpeed: 0
      }));
    }
  }
  $activeLabels.on(CLICK_EVENT, function (evt) {
    evt.preventDefault();
    itemClickHandler(evt, $el, opts);
  });
};

/**
 * Initializes an accordion based on provided parameters.
 * @param {HTMLElement} el - An element containing the elements for the
 * accordion
 * @param {Object} options - Options used for wiring up the accordion
 * @see DEFAULTS
 */
function accordion(el) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var $el = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(el);
  var opts = mergeOptions($el, options);
  var $activeLabels = $el.find(opts.accItem).not(FORCE_OPEN_CLASS).find(opts.accLabel);
  if (opts.noFocus) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__no_focus__["a" /* default */])();
  }
  applyDefaultsToActive($el, opts);
  applyDefaultsToRadio($el, opts);
  applyDefaultsToForce($el, opts);
  applyEventHandlers($el, $activeLabels, opts);
  return {
    closeAll: function closeAll() {
      return closeActiveTab($el, opts);
    }
  };
}

// Expose the function as a jQuery plugin for ease of use
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib_register_jquery_plugin__["a" /* default */])(PLUGIN_NAME, accordion);

/***/ }),
/* 277 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export PLUGIN_NAME */
/* unused harmony export DEFAULTS */
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_register_jquery_plugin__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_merge_options__ = __webpack_require__(2);
/**
 * Countdown days, hours, minutes and seconds
 * @module addToCalendar
 */





// Expose the function as a jQuery plugin for ease of use
var PLUGIN_NAME = 'addToCalendar';
var DEFAULTS = {
  icsServices: ['iCal', 'Outlook']
};
var formatTime = function formatTime(date) {
  var newDate = new Date(date);
  return newDate.toISOString().replace(/-|:|\.\d+/g, '');
};
var calculateEndTime = function calculateEndTime(startTime, endTime, opts) {
  var duration = opts.duration;
  var MS_IN_MINUTES = 60 * 1000;
  return endTime ? formatTime(endTime) : formatTime(new Date(startTime.getTime() + duration * MS_IN_MINUTES));
};
var googleGenerator = function googleGenerator(startTime, endTime, opts) {
  var title = opts.title,
    description = opts.description,
    address = opts.address;
  var formatedStartTime = formatTime(startTime);
  var calEndTime = calculateEndTime(startTime, endTime, opts);
  var href = encodeURI("https://www.google.com/calendar/render?action=TEMPLATE&text=".concat(title || '', "&dates=").concat(formatedStartTime || '', "/").concat(calEndTime || '', "&details=").concat(description || '', "&location=").concat(address || '', "&sprop=&sprop=name:"));
  return "<a class=\"action-button action-button--md action-button--full\" target=\"_blank\" href=\"".concat(href, "\">Google Calendar</a>");
};
var yahooGenerator = function yahooGenerator(startTime, endTime, opts) {
  var title = opts.title,
    description = opts.description,
    address = opts.address,
    duration = opts.duration;
  var formatedStartTime = formatTime(opts.start);
  var MS_IN_MINUTES = 60 * 1000;
  var eventDuration = endTime ? (endTime.getTime() - startTime.getTime()) / MS_IN_MINUTES : duration;

  // Yahoo dates are crazy, we need to convert the duration from minutes to hh:mm
  var hourDuration = eventDuration < 600 ? "0".concat(Math.floor(eventDuration / 60)) : "".concat(Math.floor(eventDuration / 60));
  var minuteDuration = eventDuration % 60 < 10 ? "0".concat(eventDuration % 60) : "".concat(eventDuration % 60);
  var formatedEventDuration = "".concat(hourDuration).concat(minuteDuration);
  var href = encodeURI("http://calendar.yahoo.com/?v=60&view=d&type=20&title=".concat(title || '', "&st=").concat(formatedStartTime, "&dur=").concat(formatedEventDuration || '', "&desc=").concat(description || '', "&in_loc=").concat(address || ''));
  return "<a class=\"action-button action-button--md action-button--full\" target=\"_blank\" href=\"".concat(href, "\">Yahoo! Calendar</a>");
};
var icsGenerator = function icsGenerator(startTime, endTime, opts) {
  var icsServices = opts.icsServices,
    url = opts.url,
    title = opts.title,
    description = opts.description,
    address = opts.address;
  var formatedStartTime = formatTime(startTime);
  var calcEndTime = calculateEndTime(startTime, endTime, opts);
  var icsButtons = icsServices.map(function (calendarName) {
    /* eslint-disable prefer-template */
    var href = encodeURI('data:text/calendar;charset=utf8,' + ['BEGIN:VCALENDAR', 'VERSION:2.0', 'BEGIN:VEVENT', 'URL:' + url, 'DTSTART:' + (formatedStartTime || ''), 'DTEND:' + (calcEndTime || ''), 'SUMMARY:' + (title || ''), 'DESCRIPTION:' + (description || ''), 'LOCATION:' + (address || ''), 'END:VEVENT', 'END:VCALENDAR'].join('\n'));
    return "<a class=\"action-button action-button--md action-button--full\" target=\"_blank\"\n    href=\"".concat(href, "\">").concat(calendarName, " Calendar</a>");
  });
  return icsButtons;
};
var generateMarkup = function generateMarkup($el, startTime, endTime, opts) {
  var googleBtn = googleGenerator(startTime, endTime, opts);
  var yahooBtn = yahooGenerator(startTime, endTime, opts);
  var otherServicesBtn = icsGenerator(startTime, endTime, opts);
  $el.append(googleBtn, yahooBtn, otherServicesBtn);
};

/**
 * Initializes addToCalendar
 * @param {HTMLElement} el - link
 * @param {Object} options - Options used for wiring up the modal
 * @see DEFAULTS
 */
function addToCalendar(el) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var $el = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(el);
  var opts = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__lib_merge_options__["a" /* default */])(DEFAULTS, options, $el);
  var start = opts.start,
    end = opts.end;
  var startTime = new Date(start);
  var endTime = new Date(end);
  generateMarkup($el, startTime, endTime, opts);
}
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__lib_register_jquery_plugin__["a" /* default */])(PLUGIN_NAME, addToCalendar);

/***/ }),
/* 278 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export BACK_BUTTON_CLASS */
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_register_jquery_plugin__ = __webpack_require__(1);
/**
 * Responsible for handling back button functionality
 * @module module/backButton
 */



/**
 * Defines the class name for the back button
 * @type {string}
 */
var BACK_BUTTON_CLASS = 'back-button';

/**
 * Defines the default options for the back button
 * @type {Object}
 */
var DEFAULT_OPTIONS = {
  back: function back() {
    return history.back(-1);
  }
};

/**
 * Adds onclick event to element to go back
 * @param {HTMLElement} el - The anchor/button we're attaching to
 * @see DEFAULT_OPTIONS
 */
function backButton(el, options) {
  var _$$extend = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.extend({}, DEFAULT_OPTIONS, options),
    back = _$$extend.back;
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()(el).on('click', function (evt) {
    evt.preventDefault();
    back();
  });
}
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__lib_register_jquery_plugin__["a" /* default */])('backButton', backButton);

/***/ }),
/* 279 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export PLUGIN_NAME */
/* unused harmony export CLICK_EVENT */
/* unused harmony export DEFAULTS */
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_body_scroll_lock__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_body_scroll_lock___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_body_scroll_lock__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_register_jquery_plugin__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_merge_options__ = __webpack_require__(2);
/**
 * Responsible for handling category menu
 * @module modules/toggleContent
 */





var PLUGIN_NAME = 'categoryMenu';
var CLICK_EVENT = 'click';
var DEFAULTS = {
  speed: 500
};
var closeAllCategoryMenu = function closeAllCategoryMenu() {
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()("[category-body-lock='true']").categoryMenu('toggle');
};
var setMenuHeight = function setMenuHeight($el) {
  if ($el.length) {
    $el.show();
    var menuHeight = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(window).height() - $el.offset().top;
    $el.hide();
    $el.css({
      maxHeight: menuHeight
    });
  }
};
/**
 * Handles the click event when a label has been iteracted with.
 * @private
 * @param {jQuery.Event} evt - A jQuery event
 * @param {HTMLElement} currentTarget - The current target interacted with
 * @param {jQuery} $el - Containing the elements for the toggleContent
 */
var itemClickHandler = function itemClickHandler(_ref, $el) {
  var currentTarget = _ref.currentTarget;
  var $scrollEl = __WEBPACK_IMPORTED_MODULE_0_jquery___default()($el.attr('data-toggle-select-this'));
  if ($el.hasClass('is-active')) {
    $el.attr('category-body-lock', '');
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_body_scroll_lock__["enableBodyScroll"])($scrollEl[0]);
    $scrollEl.slideUp();
    $scrollEl.removeClass('is-active');
    $el.removeClass('is-active');
    $scrollEl.off('scroll.catmenu');
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()('html, body').stop();
  } else {
    $el.attr('category-body-lock', 'true');
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_body_scroll_lock__["disableBodyScroll"])($scrollEl[0]);
    $scrollEl.slideDown(400, function () {
      $scrollEl.css('overflow', '');
    });
    $scrollEl.addClass('is-active');
    $el.addClass('is-active');
    $scrollEl.on('scroll.catmenu', function () {
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()('html, body').animate({
        scrollTop: -1
      }, 0);
    });
  }
};
/**
 * Applies any sort of event handlers for the toggleContent.
 * @private
 * @param {jQuery} $el - Containing the elements for the toggleContent
 * @param {Object} options - Options used for wiring up the toggleContent
 * @see DEFAULTS
 */
var applyEventHandlers = function applyEventHandlers($el) {
  var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  $el.on(CLICK_EVENT, function (evt) {
    return itemClickHandler(evt, $el, opts);
  });
};
/**
 * Initializes an categoryMenu
 * @param {HTMLElement} el - An element containing the elements for the
 * toggleContent
 * @see DEFAULTS
 */
function categoryMenu(el) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var $el = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(el);
  var opts = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__lib_merge_options__["a" /* default */])(DEFAULTS, options, $el);
  setMenuHeight(__WEBPACK_IMPORTED_MODULE_0_jquery___default()($el.attr('data-toggle-select-this')));
  applyEventHandlers($el, opts);
  return {
    toggle: function toggle() {
      return itemClickHandler(opts, $el);
    }
  };
}
__WEBPACK_IMPORTED_MODULE_0_jquery___default.a.categoryMenu = function (options) {
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('<div/>').categoryMenu(options);
};
__WEBPACK_IMPORTED_MODULE_0_jquery___default.a.categoryMenu.close = function () {
  closeAllCategoryMenu();
};
// Expose the function as a jQuery plugin for ease of use
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__lib_register_jquery_plugin__["a" /* default */])(PLUGIN_NAME, categoryMenu);

/***/ }),
/* 280 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export PLUGIN_NAME */
/* unused harmony export regExList */
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery_mask_plugin__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery_mask_plugin___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_jquery_mask_plugin__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_register_jquery_plugin__ = __webpack_require__(1);
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
/**
 * Responsible for using the creditcard behavior within a floating label.
 * @module elements/fields/iconifyCreditCard
 */



var PLUGIN_NAME = 'ccMask';

/**
 * Contains the list of regex associated with credicards
 * @type {Array}
 */
var regExList = [{
  name: 'visa',
  regex: '^4'
}, {
  name: 'amex',
  regex: '^(34|37)'
}, {
  name: 'master',
  regex: '^5[1-5]'
}, {
  name: 'jcb',
  regex: '^(352[89]|35[3-8][0-9])'
}, {
  name: 'discover',
  regex: '^(6011|65|64[4-9]|622(1(2[6-9]|[3-9])|[2-8]{2}|9([01]|2[0-5])))'
}];

/**
 * Shows the active credit card icon
 * @param {HTMLFormElement} formField - The form element in the floating label
 * @param {HTMLElement} container - The icon container
 * @param {Object} iconNodes - icons keyed by icon name with icon HTML element
 */
var getCardIcon = function getCardIcon($el, defaultCCTemplate, amexCCTemplate, initRegExpList, maskOptions) {
  var ccNum = $el.val();
  var _initRegExpList$filte = initRegExpList.filter(function (_ref) {
      var regex = _ref.regex;
      return regex.test(ccNum);
    }),
    _initRegExpList$filte2 = _slicedToArray(_initRegExpList$filte, 1),
    _initRegExpList$filte3 = _initRegExpList$filte2[0],
    _initRegExpList$filte4 = _initRegExpList$filte3 === void 0 ? {
      name: 'generic'
    } : _initRegExpList$filte3,
    activeCard = _initRegExpList$filte4.name;
  // const $activeCard = $(iconNodes[activeCard]);
  $el.mask(activeCard === 'amex' ? amexCCTemplate : defaultCCTemplate, maskOptions);
  // showCard($activeCard, container);
};
/**
 * Initialize credit cards' regex
 * @private
 * @returns {Array} - returns initialized regex array
 */
var initRegex = function initRegex() {
  return regExList.map(function (_ref2) {
    var name = _ref2.name,
      regex = _ref2.regex;
    return {
      name: name,
      regex: new RegExp(regex)
    };
  });
};
/**
 * Set Data Attributes for each credit card icons
 * @private
 * @param {HTMLFormElement} formField - The form element in the floating label
 * @param {HTMLElement} container - The icon container
 * @param {Object} iconNodes - icons keyed by icon name with icon HTML element
 */
var applyMask = function applyMask($el) {
  var defaultCCTemplate = '0000 0000 0000 0000';
  var amexCCTemplate = '0000 000000 00000';
  var initRegExpList = initRegex();
  var maskOptions = {
    onKeyPress: function onKeyPress() {
      getCardIcon($el, defaultCCTemplate, amexCCTemplate, initRegExpList, maskOptions);
    },
    translation: {
      0: {
        pattern: /[0-9*]/
      }
    }
  };
  getCardIcon($el, defaultCCTemplate, amexCCTemplate, initRegExpList, maskOptions);
  $el.mask(defaultCCTemplate, maskOptions);
};

/**
 * Initializes an ccMask based on provided parameters.
 * @param {HTMLElement} el - An element containing the elements for the
 * ccMask
 * @param {Object} options - Options used for wiring up the ccMask
 * @see DEFAULTS
 */
function ccMask(el) {
  var $el = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(el);
  applyMask($el);
}

// Expose the function as a jQuery plugin for ease of use
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__lib_register_jquery_plugin__["a" /* default */])(PLUGIN_NAME, ccMask);

/***/ }),
/* 281 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export PLUGIN_NAME */
/* unused harmony export DEFAULTS */
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_register_jquery_plugin__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_merge_options__ = __webpack_require__(2);
/**
 * Handles all radios and checkboxes to be togglable with enter key
 * @module charCounter
 */


// import Keyboard from './keyboard';



// Expose the function as a jQuery plugin for ease of use
var PLUGIN_NAME = 'charCounter';
var DEFAULTS = {};
var getMaxChar = function getMaxChar($el) {
  var maxChar = $el.attr('maxlength');
  return maxChar;
};
var countCurrentChar = function countCurrentChar($el) {
  var charCount = $el.val().length;
  return charCount;
};
var displayMaxChar = function displayMaxChar($el) {
  var maxCharContianer = $el.attr('data-count-max');
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()(maxCharContianer).text(getMaxChar($el));
};
var displayCharCount = function displayCharCount($el) {
  var charCountContainer = $el.attr('data-count-total');
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()(charCountContainer).text(countCurrentChar($el));
};

/**
 * Applies any sort of event handlers for the checkboxes or radios.
 * @param  {jQuery} $el - checkbox / radio
 * @param  {Object} [options={}] - Any options provided upon initialization
 */
var setEventListeners = function setEventListeners($el) {
  $el.on('input', function () {
    return displayCharCount($el);
  });
};

/**
 * Initializes charCounter.
 * @param {HTMLElement} el - button /element that opens charCounter
 * @param {Object} options - Options used for wiring up the charCounter
 * @param {Object} deregister - Performs a deregisteration on the plugin
 * @see DEFAULTS
 */
function charCounter(el) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var $el = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(el);
  var opts = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__lib_merge_options__["a" /* default */])(DEFAULTS, options, $el);
  displayMaxChar($el, getMaxChar);
  setEventListeners($el, opts);
}
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__lib_register_jquery_plugin__["a" /* default */])(PLUGIN_NAME, charCounter);

/***/ }),
/* 282 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export PLUGIN_NAME */
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_register_jquery_plugin__ = __webpack_require__(1);
/**
 * Handles close banners
 * @module closeBanner
 */



var PLUGIN_NAME = 'closeBanner';
var closeBannerEventHandlers = function closeBannerEventHandlers() {
  var closeBannerChild = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-close-banner');
  var closeBannerParent = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-close-parent');
  closeBannerChild.on('click', function () {
    closeBannerParent.hide();

    // cls cookie update
    var cookie = closeBannerChild.data('cookie');
    if (cookie) {
      window.updateClsCookieObject(cookie, 0);
    }
  });
};
// $el trigger
function bannerCloseBtn() {
  var $el = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-close-banner');
  closeBannerEventHandlers($el);
}
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__lib_register_jquery_plugin__["a" /* default */])(PLUGIN_NAME, bannerCloseBtn);

/***/ }),
/* 283 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export PLUGIN_NAME */
/* unused harmony export DEFAULTS */
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_register_jquery_plugin__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_merge_options__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__keyboard__ = __webpack_require__(3);
/**
 * Toggle classes
 * @module cookiesBanner
 */






// Expose the function as a jQuery plugin for ease of use
var PLUGIN_NAME = 'cookiesBanner';
var userHasScrolled = false;
var $html = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('html');
var DEFAULTS = {
  trapFocusFunc: __WEBPACK_IMPORTED_MODULE_3__keyboard__["a" /* default */].trapFocus.bind(__WEBPACK_IMPORTED_MODULE_3__keyboard__["a" /* default */]),
  releaseFocusFunc: __WEBPACK_IMPORTED_MODULE_3__keyboard__["a" /* default */].releaseFocus.bind(__WEBPACK_IMPORTED_MODULE_3__keyboard__["a" /* default */])
};
var handleToggle = function handleToggle($cookieBanner, $contentToShow, $contentToHide, activeClass, opts) {
  var $el = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-cookies-banner-toggle');
  var startingHeight = $cookieBanner[0].offsetHeight;
  $cookieBanner.css('height', startingHeight);
  if (activeClass) {
    $cookieBanner.removeClass('active');
    $el.attr('aria-expanded', 'false');
    $cookieBanner.attr('aria-modal', 'false');
    $cookieBanner.removeAttr('role', 'dialog');
    if ($html.hasClass('focus-active')) {
      opts.releaseFocusFunc($cookieBanner);
    }
  } else {
    $cookieBanner.addClass('active');
    $el.attr('aria-expanded', 'true');
    $cookieBanner.attr('aria-modal', 'true');
    $cookieBanner.attr('role', 'dialog');
    if ($html.hasClass('focus-active')) {
      opts.trapFocusFunc($cookieBanner);
    }
  }
  var newHeight = $contentToShow[0].offsetHeight + 22;
  $cookieBanner.animate({
    height: newHeight
  }, 300);
};
var handleClick = function handleClick($cookieBanner, $initialContent, $newContent, opts) {
  var hasActiveClass = $cookieBanner.hasClass('active');
  if (hasActiveClass) {
    handleToggle($cookieBanner, $initialContent, $newContent, true, opts);
  } else {
    handleToggle($cookieBanner, $newContent, $initialContent, false, opts);
  }
};
var handleScroll = function handleScroll(scrollPosY, $cookieBanner, $initialContent, $newContent, opts) {
  var hasActiveClass = $cookieBanner.hasClass('active');
  if (!userHasScrolled && scrollPosY !== 0 && hasActiveClass) {
    handleToggle($cookieBanner, $initialContent, $newContent, true, opts);
    userHasScrolled = true;
  }
};

/**
 * Applies any sort of event handlers for the cookiesBanner.
 * @param  {jQuery} $el - link
 * @param  {Object} [options={}] - Any options provided upon initialization
 */
var setEventListeners = function setEventListeners($el, opts) {
  var $cookieBanner = $el.closest('.cookies-banner');
  var $initialContent = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.cookies-banner__head');
  var $newContent = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.cookies-banner__details--v2');
  $el.on('keydown', function (evt) {
    var hasActiveClass = $cookieBanner.hasClass('active');
    if (__WEBPACK_IMPORTED_MODULE_3__keyboard__["a" /* default */].parseKey(evt) === __WEBPACK_IMPORTED_MODULE_3__keyboard__["a" /* default */].keys.ESCAPE) {
      if (hasActiveClass) {
        handleToggle($cookieBanner, $initialContent, $newContent, true, opts);
      } else {
        handleToggle($cookieBanner, $initialContent, $newContent, false, opts);
      }
    }
  });
  $el.on('click', function () {
    handleClick($cookieBanner, $initialContent, $newContent, opts);
  });
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()(window).on('scroll resize', function () {
    var scrollPosY = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(window).scrollTop();
    handleScroll(scrollPosY, $cookieBanner, $initialContent, $newContent, opts);
  });
};
/**
 * Initializes cookiesBanner.
 * @param {HTMLElement} el - link
 * @param {Object} options - Options used for wiring up the modal
 * @see DEFAULTS
 */
function cookiesBanner(el) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var $el = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(el);
  var opts = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__lib_merge_options__["a" /* default */])(DEFAULTS, options, $el);
  setEventListeners($el, opts);
}
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__lib_register_jquery_plugin__["a" /* default */])(PLUGIN_NAME, cookiesBanner);

/***/ }),
/* 284 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export PLUGIN_NAME */
/* unused harmony export CLICK_EVENT */
/* unused harmony export DEFAULTS */
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_register_jquery_plugin__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_merge_options__ = __webpack_require__(2);
/**
* Creates a counter
* @module copyToClipboard
*/



var PLUGIN_NAME = 'copyToClipboard';
var CLICK_EVENT = 'click';
var DEFAULTS = {
  container: '.js-copy-clipboard-wrapper',
  textToCopy: '.js-copy-clipboard-text',
  notify: 'false',
  activeClass: ''
};
var copyToClipboardFunc = function copyToClipboardFunc($el, opts) {
  var container = opts.container;
  var textContainer = opts.textToCopy;
  var textToCopy = $el.closest(container).find(textContainer);
  var el = textToCopy.get(0);
  if (navigator.userAgent.match(/ipad|ipod|iphone/i)) {
    var editable = el.contentEditable;
    var readOnly = el.readOnly;
    el.contentEditable = true;
    el.readOnly = true;
    var range = document.createRange();
    range.selectNodeContents(el);
    var sel = window.getSelection();
    sel.removeAllRanges();
    sel.addRange(range);
    if (el.type === 'email') {
      el.type = 'text';
    }
    el.setSelectionRange(0, 999999);
    el.contentEditable = editable;
    el.readOnly = readOnly;
  }
  textToCopy.select();
  document.execCommand('copy');
  textToCopy.blur();
  if (el.id === 'clipboard-copy-email-address') {
    el.type = 'email';
  }
};
var copyToClipboardNotification = function copyToClipboardNotification($el, opts) {
  var activeClass = opts.activeClass;
  if (opts.notify === true) {
    $el.addClass(activeClass);
    var removeActive = function removeActive() {
      $el.removeClass(activeClass);
    };
    setTimeout(removeActive, 3000);
  }
};
/**
* Applies any sort of event handlers for the count incrementation.
* @param {jQuery} $el - Containing the elements for the Counter
* @param {Object} options - Options used for wiring up the Counter
* @see DEFAULTS
*/
var applyEventHandlers = function applyEventHandlers($el) {
  var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  $el.on(CLICK_EVENT, function () {
    copyToClipboardFunc($el, opts);
    copyToClipboardNotification($el, opts);
  });
};
/**
* Initializes blank based on provided parameters.
* @param {HTMLElement} el - An element containing the elements for the
* Counter
* @param {Object} options - Options used for wiring up the Count
* @see DEFAULTS
*/
function copyToClipboard(el) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var $el = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(el);
  var opts = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__lib_merge_options__["a" /* default */])(DEFAULTS, options, $el);
  applyEventHandlers($el, opts);
}
// Expose the function as a jQuery plugin for ease of use
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__lib_register_jquery_plugin__["a" /* default */])(PLUGIN_NAME, copyToClipboard);

/***/ }),
/* 285 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export SECOND */
/* unused harmony export MINUTE */
/* unused harmony export HOUR */
/* unused harmony export DAY */
/* unused harmony export DAY_CONTAINER */
/* unused harmony export HOURS_AS_DAYS_CONTAINER */
/* unused harmony export HOUR_CONTAINER */
/* unused harmony export MINUTE_CONTAINER */
/* unused harmony export SECOND_CONTAINER */
/* unused harmony export DAY_LABEL */
/* unused harmony export HOURS_AS_DAYS_LABEL */
/* unused harmony export HOUR_LABEL */
/* unused harmony export MINUTE_LABEL */
/* unused harmony export SECOND_LABEL */
/* unused harmony export PLUGIN_NAME */
/* unused harmony export DEFAULTS */
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_register_jquery_plugin__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_merge_options__ = __webpack_require__(2);
/**
 * Countdown days, hours, minutes and seconds
 * @module countdown
 */

// Styleguide documenation URL: /r_c5e9d7052a36ab7c7c9f78b83ae37039badec36a/r_src/main/styleguide/site/modules.html#countdown




var SECOND = 1000;
var MINUTE = SECOND * 60;
var HOUR = MINUTE * 60;
var DAY = HOUR * 24;
var DAY_CONTAINER = '.js-countdown-day';
var HOURS_AS_DAYS_CONTAINER = '.js-countdown-hours-as-days';
var HOUR_CONTAINER = '.js-countdown-hour';
var MINUTE_CONTAINER = '.js-countdown-minute';
var SECOND_CONTAINER = '.js-countdown-second';
var DAY_LABEL = '.js-countdown-day-label';
var HOURS_AS_DAYS_LABEL = '.js-countdown-hours-as-days-label';
var HOUR_LABEL = '.js-countdown-hour-label';
var MINUTE_LABEL = '.js-countdown-minute-label';
var SECOND_LABEL = '.js-countdown-second-label';

// Expose the function as a jQuery plugin for ease of use
var PLUGIN_NAME = 'countdown';
var DEFAULTS = {
  targetDateTime: '2029-12-01T00:00:00-08:00',
  countdownEndText: null,
  countdownRemove: false
};
/**
 * Update countdown heading or remove when time expires
 * @param  {jQuery} $el - link
 * @param  {Object} [opts] - Any options provided upon initialization
 */
var updateCountdownHeading = function updateCountdownHeading($el, opts) {
  // Get the countdown heading
  var $countdownHed = $el.find('.js-countdown__hed');
  // Get data-countdown-end-text value - must be set on parent
  var countdownEndText = opts.countdownEndText;
  // If countdown heading exists and there is a countdownEndText value
  if ($countdownHed.length && countdownEndText !== null) {
    $countdownHed.text(countdownEndText);
  }
};
/**
 * Boolean to see if seconds should be displayed
 * @param  {Object} [opts] - Any options provided upon initialization
 */
var getThreshold = function getThreshold(opts) {
  return !opts.displaySeconds ? 60 : 0;
};
/**
 * Boolean to see if time has expired
 * @param  {Object} [opts] - Any options provided upon initialization
 */
var initialTimeCheck = function initialTimeCheck(target, opts) {
  var now = new Date().getTime();
  var initialTimeLeft = target - now;
  var initialSecondsRemaining = Math.floor(initialTimeLeft / 1000);
  // Check it time remaining is more than the thershold
  return initialSecondsRemaining > getThreshold(opts);
};
/**
* Creates an object to cach countdown elements
* @param  {jQuery} $el - link
*/
var queryElements = function queryElements($el) {
  return {
    dayContainer: $el.find(DAY_CONTAINER),
    hourContainer: $el.find(HOUR_CONTAINER),
    hourAsDaysContainer: $el.find(HOURS_AS_DAYS_CONTAINER),
    minuteContainer: $el.find(MINUTE_CONTAINER),
    secondContainer: $el.find(SECOND_CONTAINER),
    dayLabel: $el.find(DAY_LABEL),
    hourLabel: $el.find(HOUR_LABEL),
    hourAsDaysLabel: $el.find(HOURS_AS_DAYS_LABEL),
    minuteLabel: $el.find(MINUTE_LABEL),
    secondLabel: $el.find(SECOND_LABEL)
  };
};
/**
 * Updates the countdown display elements
 * @param  {jQuery} $el - link
 * @param  {Object} [options={}] - Any options provided upon initialization
 * @param  {number} timeLeft - amount of time still left in the countdown
 */
var updateCountdownDisplay = function updateCountdownDisplay($el, $elements, opts, timeLeft) {
  var daysLeft = Math.floor(timeLeft / DAY);
  daysLeft = daysLeft < 10 ? "0".concat(daysLeft).slice(-2) : daysLeft;
  var daysLeftCheck = daysLeft === 0 ? daysLeft : daysLeft * 24;
  var hoursDaysLeft = Math.floor(timeLeft % DAY / HOUR + daysLeftCheck);
  hoursDaysLeft = hoursDaysLeft < 10 ? "0".concat(hoursDaysLeft).slice(-2) : hoursDaysLeft;
  var hoursLeft = "0".concat(Math.floor(timeLeft % DAY / HOUR)).slice(-2);
  var minutesLeft = "0".concat(Math.floor(timeLeft % HOUR / MINUTE)).slice(-2);
  var secondsLeft = "0".concat(Math.floor(timeLeft % MINUTE / SECOND)).slice(-2);
  $elements.dayContainer.text(daysLeft);
  $elements.hourContainer.text(hoursLeft);
  $elements.hourAsDaysContainer.text(hoursDaysLeft);
  $elements.minuteContainer.text(minutesLeft);
  $elements.secondContainer.text(secondsLeft);
  $elements.dayLabel.text(daysLeft === 1 ? 'day' : 'days');
  $elements.hourLabel.text(hoursLeft === '01' ? 'hour' : 'hours');
  $elements.hourAsDaysLabel.text(parseInt(hoursDaysLeft, 10) === 1 ? 'hour' : 'hours');
  $elements.minuteLabel.text(minutesLeft === '01' ? 'minute' : 'minutes');
  $elements.secondLabel.text(secondsLeft === '01' ? 'second' : 'seconds');
};
/**
 * Runs the countdown and sets the interval
 * @param  {jQuery} $el - link
 * @param  {Object} [options={}] - Any options provided upon initialization
 */
var runCountdown = function runCountdown($el, $elements, opts) {
  var target = new Date(opts.targetDateTime).getTime();
  // initial check to see if any time remains
  var timeRemains = initialTimeCheck(target, opts);
  // if no time remains
  if (!timeRemains) {
    // Check if countdown should be removed otherwise zero it out
    if (opts.countdownRemove) {
      $el.children().not('.js-countdown__hed').remove();
    } else {
      updateCountdownDisplay($el, $elements, opts, 0);
    }
    // Display end text if provided
    updateCountdownHeading($el, opts);
    // Show countdown markup
    $el.removeClass('u-hide');
    return;
  }
  $el.removeClass('u-hide');
  var intervalId = setInterval(function () {
    var now = new Date().getTime();
    var timeLeft = target - now;
    var secondsRemaining = Math.floor(timeLeft / 1000);
    // Check if countdown has expired
    if (secondsRemaining <= getThreshold(opts)) {
      clearInterval(intervalId);
      updateCountdownDisplay($el, $elements, opts, 0);
      // Display end text if provided
      updateCountdownHeading($el, opts);
      // Remove countdown elements if option is enabled
      if (opts.countdownRemove) {
        $el.children().not('.js-countdown__hed').remove();
      }
      return;
    }
    updateCountdownDisplay($el, $elements, opts, timeLeft);
  }, SECOND);
};
/**
 * Initializes countdown
 * @param {HTMLElement} el - link
 * @param {Object} options - Options used for wiring up the modal
 * @see DEFAULTS
 */
function countdown(el) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var $el = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(el);
  var opts = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__lib_merge_options__["a" /* default */])(DEFAULTS, options, $el);
  // Check boolean options on initialization for countdown removal
  opts.countdownRemove = opts.countdownRemove === true || opts.countdownRemove === '';
  var $elements = queryElements($el);
  // Check if seconds markup is present
  opts.displaySeconds = $el.find('.js-countdown-second').length;
  runCountdown($el, $elements, opts);
}
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__lib_register_jquery_plugin__["a" /* default */])(PLUGIN_NAME, countdown);

/***/ }),
/* 286 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export PLUGIN_NAME */
/* unused harmony export CLICK_HANDLER */
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_register_jquery_plugin__ = __webpack_require__(1);
/**
 * counter on click
 * @module counter
 */



var PLUGIN_NAME = 'counter';
var CLICK_HANDLER = 'click';

/**
 * Handle Toggling Event
 * @param  {jQuery} $el - button /element that toggles text
 * @param  {Object} [options={}] - Any options provided upon initialization
 */
var $counter = 1;
var $counterVal = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-counter-value');
var counterAddHandler = function counterAddHandler($el) {
  var $countAddTarget = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-counter-add');
  var $counterAdd = __WEBPACK_IMPORTED_MODULE_0_jquery___default()($el.data('counter-add'));
  if (parseInt($counterAdd.text(), 5) <= 5) {
    $counter += 1;
    $counterVal.text(function () {
      return $counter;
    });
    if (parseInt($counterAdd.text(), 10) === 5) {
      $counterVal.text(function () {
        return $counter;
      });
      $countAddTarget.attr('disabled', true);
    }
  } else {
    $counterVal.text(function () {
      return $counter;
    });
    $countAddTarget.attr('disabled', false);
  }
};
var counterSubHandler = function counterSubHandler($el) {
  var $countSubTarget = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-counter-sub');
  var $counterSub = __WEBPACK_IMPORTED_MODULE_0_jquery___default()($el.data('counter-sub'));
  if (parseInt($counterSub.text(), 10) > 1) {
    $counter -= 1;
    $counterVal.text(function () {
      return $counter;
    });
    $el.removeAttr('disabled');
  }
  if (parseInt($counterSub.text(), 10) < 2) {
    $counterVal.text(function () {
      return $counter;
    });
    $countSubTarget.attr('disabled', true);
  } else {
    $counterVal.text(function () {
      return $counter;
    });
    $countSubTarget.attr('disabled', false);
  }
};
var setEventListeners = function setEventListeners($el, options) {
  $el.on(CLICK_HANDLER, function () {
    counterAddHandler($el, options);
    counterSubHandler($el, options);
  });
};

/**
 * Initializes Header.
 * @param {HTMLElement} el - trigger
 * @param {Object} options - Options used for wiring up the modal
 * @see DEFAULTS
 */
function counter(el) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var $el = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(el);
  setEventListeners($el, options);
}
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__lib_register_jquery_plugin__["a" /* default */])(PLUGIN_NAME, counter);

/***/ }),
/* 287 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export PLUGIN_NAME */
/* unused harmony export DEFAULTS */
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__keyboard__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_register_jquery_plugin__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_merge_options__ = __webpack_require__(2);
/**
 * Toggle classes
 * @module drawer
 */






// Expose the function as a jQuery plugin for ease of use
var PLUGIN_NAME = 'drawer';
var DEFAULTS = {
  drawerClass: '',
  drawerTarget: '',
  returnFocus: '',
  trapFocusFunc: __WEBPACK_IMPORTED_MODULE_1__keyboard__["a" /* default */].trapFocus.bind(__WEBPACK_IMPORTED_MODULE_1__keyboard__["a" /* default */]),
  releaseFocusFunc: __WEBPACK_IMPORTED_MODULE_1__keyboard__["a" /* default */].releaseFocus.bind(__WEBPACK_IMPORTED_MODULE_1__keyboard__["a" /* default */])
};
/**
 * Save last focus element that opened drawer
 * @param  {jQuery} $el - last focusable element
 */
var drawerLastFocus = function drawerLastFocus($el) {
  // if (!$el.parents('.modal__content').length) {
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).data('lastFocus', $el);
  // }
};
/**
 * Callback after css animation
 * @param {jQuery} $el - css animated element
 */
var afterAnimation = function afterAnimation($el, cb) {
  var animationDone = false;
  $el.on('transitionend', function (e) {
    if (e.propertyName === 'transform' && !animationDone) {
      animationDone = true;
      cb();
    }
  });
  setTimeout(function () {
    if (!animationDone) {
      animationDone = true;
      cb();
    }
  }, 350);
};
/**
 * Applies any sort of event handlers for the drawer.
 * @param  {jQuery} $el - link
 * @param  {Object} [options={}] - Any options provided upon initialization
 */
var setEventListeners = function setEventListeners($el) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  $el.on('click', function (evt) {
    evt.preventDefault();
    var $changingElClass = __WEBPACK_IMPORTED_MODULE_0_jquery___default()($el.attr('href'));
    // If a data-swap-target attribute was used instead of href
    if (options.drawerTarget !== '') {
      $changingElClass = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(options.drawerTarget);
    }
    $changingElClass.toggleClass(options.drawerClass);

    // Shift and trap focus to modal after animation
    afterAnimation($changingElClass, function () {
      options.trapFocusFunc($changingElClass);
      if ($changingElClass.find('.drawer__hed').length) {
        $changingElClass.find('.drawer__hed').children('.drawer__link').focus();
      }
      if (!options.returnFocus) {
        drawerLastFocus($el);
      }
      if (options.returnFocus) {
        options.releaseFocusFunc($el, __WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).data('lastFocus'));
      }
    });
  });
};
/**
* Initializes drawer.
* @param {HTMLElement} el - link
* @param {Object} options - Options used for wiring up the modal
* @see DEFAULTS
*/
function drawer(el) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var $el = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(el);
  var opts = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__lib_merge_options__["a" /* default */])(DEFAULTS, options, $el);
  setEventListeners($el, opts);
}
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__lib_register_jquery_plugin__["a" /* default */])(PLUGIN_NAME, drawer);

/***/ }),
/* 288 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export PLUGIN_NAME */
/* unused harmony export DD_CLASS */
/* unused harmony export DD_MENU_CLASS */
/* unused harmony export DD_TRIGGER_CLASS */
/* unused harmony export DD_OPEN_STATE */
/* unused harmony export DD_DISABLED_STATE */
/* unused harmony export DEFAULTS */
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_throttle__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_throttle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_throttle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_debounce__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_debounce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_debounce__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_body_scroll_lock__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_body_scroll_lock___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_body_scroll_lock__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib_register_jquery_plugin__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__keyboard__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__lib_merge_options__ = __webpack_require__(2);
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
/**
 * Dropdown
 * Handles dropdown functions
 * Improved UX
 * Improved accessibility
 * @module dropdown
 */






// import { get } from '../lib/props';

var PLUGIN_NAME = 'dropdown';
var DD_CLASS = '.js-dropdown';
var DD_MENU_CLASS = '.js-dropdown__menu';
var DD_TRIGGER_CLASS = '.js-dropdown__trigger';
var DD_OPEN_STATE = 'dd-is-open';
var DD_DISABLED_STATE = 'is-disabled';
var DEFAULTS = {
  animationSpeed: 200,
  wait: 100,
  returnFocus: null,
  offsetContent: false
};
/**
 * Handles the height of the dropdown so it takes over the screen
 * @private
 */
function QuickNavHeight() {
  var quickNav = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#global-nav-sub-div');
  if (quickNav.length) {
    var docHeight = document.documentElement.clientHeight;
    var $jsDropdownMenu = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-dropdown__menu.dd-is-open');
    var navHeight = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-header__wrap').height();
    $jsDropdownMenu.css({
      maxHeight: docHeight - navHeight
    });
  }
}
/**
 * Set Open State
 * @param  {jQuery} $el - dropdown wrap
 * @param  {jQuery} $ddTrigger - dropdown trigger element
 * @param  {jQuery} $ddMenu - dropdown content element
 */
var setOpenState = function setOpenState($el, $ddTrigger, $ddMenu) {
  $el.addClass(DD_OPEN_STATE);
  $ddTrigger.addClass(DD_OPEN_STATE);
  $ddMenu.addClass(DD_OPEN_STATE);
  $el.trigger('dropdown.open');
  QuickNavHeight();
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_body_scroll_lock__["disableBodyScroll"])($ddMenu[0]);
};
/**
 * Remove Open State
 * @param  {jQuery} $el - dropdown wrap
 * @param  {jQuery} $ddTrigger - dropdown trigger element
 * @param  {jQuery} $ddMenu - dropdown content element
 */
var removeOpenState = function removeOpenState($el, $ddTrigger, $ddMenu) {
  $el.removeClass(DD_OPEN_STATE);
  $ddTrigger.removeClass(DD_OPEN_STATE);
  $ddMenu.removeClass(DD_OPEN_STATE);
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_body_scroll_lock__["enableBodyScroll"])($ddMenu[0]);
};
/**
 * Set Aria Expanded
 * @param  {jQuery} $el - dropdown trigger element
 * @param  {boolean} $ddMenu - dropdown content element
 */
var ariaExpanded = function ariaExpanded($el, bool) {
  $el.attr('aria-expanded', bool);
};
/**
 * Release Trap Focus
 * @param  {jQuery} $el - dropdown wrap
 * @param  {jQuery} $returnFocus - returnFocus
 */
var releaseTrapFocus = function releaseTrapFocus($el, $returnFocus) {
  if ($el.hasClass('trapped')) {
    $el.removeClass('trapped');
    if ($returnFocus) {
      __WEBPACK_IMPORTED_MODULE_5__keyboard__["a" /* default */].releaseFocus($el, $returnFocus);
    } else {
      __WEBPACK_IMPORTED_MODULE_5__keyboard__["a" /* default */].releaseFocus($el);
    }
  }
};
/**
 * Close Dropdown
 * @param  {jQuery} $el - dropdown wrap
 * @param  {jQuery} $ddTrigger - dropdown trigger element
 * @param  {jQuery} $ddMenu - dropdown content element
 * @param  {lodash} openDebounce - debounce for opening dropdown
 * @param  {Object} [options={}] - Any options provided upon initialization
 */
var closeDropdown = function closeDropdown($el, $ddTrigger, $ddMenu, openDebounce, opts) {
  /* This setTimeout is use for IE 11 focus issue. This is allows focus flow
   * to happen naturally. It seems like without the setTimeout the focus order
   * gets thrown off.
   */
  setTimeout(function () {
    // Cancel the trailing debounced invocation.
    openDebounce.cancel();
    removeOpenState($el, $ddTrigger, $ddMenu);
    $ddMenu.stop().animate({
      opacity: 0
    }, opts.animationSpeed / 2, function () {
      ariaExpanded($ddTrigger, false);
      $ddMenu.css('display', 'none');
    });
  }, 1);
};
/**
 * Focus on dropdown trigger
 * @param  {jQuery} $el - dropdown wrap
 */
var focusOnTrigger = function focusOnTrigger($el) {
  $el.find(DD_TRIGGER_CLASS).first().focus();
};
/**
 * Top Level Menu Items Handler
 * @param  {event} evt - key event
 * @param  {boolean} isTrigger - if element is a trigger
 * @param  {jQuery} $targetMenu - targeted dropdown
 * @param  {jQuery} $siblingsMenu - Siblings Menu
 * @param  {string} direction - prev or next
 * @param  {jQuery} $el - dropdown wrap
 * @param  {jQuery} $ddTrigger - dropdown trigger element
 * @param  {jQuery} $ddMenu - dropdown content element
 * @param  {lodash} openDebounce - debounce for opening dropdown
 * @param  {Object} [options={}] - Any options provided upon initialization
 */
var topLevelMenuItemHandler = function topLevelMenuItemHandler(evt, $targetMenu, $siblingsMenu, direction, $el, $ddTrigger, $ddMenu, openDebounce, opts) {
  var $newTargetMenu = $targetMenu;
  if (!$targetMenu.length) {
    if (direction === 'next') {
      $newTargetMenu = $siblingsMenu.first();
    } else {
      $newTargetMenu = $siblingsMenu.last();
    }
  }
  closeDropdown($el, $ddTrigger, $ddMenu, openDebounce, opts);
  focusOnTrigger($newTargetMenu);
};
/**
 * Arrow Handler
 * @param  {event} evt - key event
 * @param  {jQuery} $el - dropdown wrap
 * @param  {jQuery} $ddTrigger - dropdown trigger element
 * @param  {jQuery} $ddMenu - dropdown content element
 * @param  {lodash} openDebounce - debounce for opening dropdown
 * @param  {Object} [options={}] - Any options provided upon initialization
 * @param  {jQuery} $focusable - dropdown focusable elements
 * @param  {jQuery} $firstFocusable - first focusable element
 * @param  {string} direction - prev or next
 */
var arrowHandler = function arrowHandler(evt, $el, $ddTrigger, $ddMenu, openDebounce, opts, $focusable, $firstFocusable, direction) {
  var $siblingsMenu = $el.siblings(DD_CLASS);
  var isNav = $siblingsMenu.length > 1;
  var $currentEl = $el.find(':focus');
  var isTrigger = $currentEl.hasClass(DD_TRIGGER_CLASS.replace('.', ''));
  var isArrowRight = __WEBPACK_IMPORTED_MODULE_5__keyboard__["a" /* default */].parseKey(evt) === 'ARROWRIGHT';
  var isArrowDown = __WEBPACK_IMPORTED_MODULE_5__keyboard__["a" /* default */].parseKey(evt) === 'ARROWDOWN';
  var isArrowLeft = __WEBPACK_IMPORTED_MODULE_5__keyboard__["a" /* default */].parseKey(evt) === 'ARROWLEFT';
  var focusList = _toConsumableArray($focusable);
  var currentIndex = focusList.indexOf($currentEl[0]);
  var targetIndex = direction === 'next' ? currentIndex + 1 : currentIndex - 1;
  var $targetFocusableEl = focusList[targetIndex];
  var $targetMenu = direction === 'next' ? $el.next(DD_CLASS) : $el.prev(DD_CLASS);
  var isTargetMenu = $targetMenu.length;
  var noTargetMenuAndItem = !$targetMenu.length && !$targetFocusableEl;
  if (isNav) {
    evt.preventDefault();
    evt.stopPropagation();
  }
  if (isNav) {
    if (isTrigger) {
      if (isArrowRight || isArrowLeft) {
        topLevelMenuItemHandler(evt, $targetMenu, $siblingsMenu, direction, $el, $ddTrigger, $ddMenu, openDebounce, opts);
      }
    }
    if ($targetFocusableEl) {
      if (!isTrigger || isArrowDown) {
        $targetFocusableEl.focus();
      }
    }
    if (!isTrigger && !$targetFocusableEl) {
      closeDropdown($el, $ddTrigger, $ddMenu, openDebounce, opts);
      if (isTargetMenu) {
        focusOnTrigger($targetMenu);
      }
      if (noTargetMenuAndItem) {
        focusOnTrigger($siblingsMenu.first());
      }
    }
  }
};
/**
 * Lazy Load Content within Dropdown
 * @param  {jQuery} $el - dropdown wrap
 */
var lazyLoadContent = function lazyLoadContent($el) {
  if ($el.data('lazy-load')) {
    var $lazyImages = $el.find('img[data-lazy]');
    $lazyImages.each(function lazyImages() {
      var $lazyImage = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this);
      var imageSource = $lazyImage.attr('src');
      var dataSource = $lazyImage.data('lazy');
      var srcset = $lazyImage.data('srcset');
      if (imageSource !== dataSource) {
        $lazyImage.attr('src', dataSource);
      }
      if (srcset) {
        $lazyImage.attr('srcset', srcset);
      }
    });
  }
};
/**
 * Open Dropdown
 * @param  {jQuery} $el - dropdown wrap
 * @param  {jQuery} $ddTrigger - dropdown trigger element
 * @param  {jQuery} $ddMenu - dropdown content element
 * @param  {Object} [options={}] - Any options provided upon initialization
 */
var openDropdown = function openDropdown($el, $ddTrigger, $ddMenu, opts) {
  if ($ddMenu.hasClass(DD_OPEN_STATE)) {
    return;
  }
  lazyLoadContent($el);
  setOpenState($el, $ddTrigger, $ddMenu);
  $ddMenu.css({
    display: 'block',
    opacity: 0
  }).stop().animate({
    opacity: 1
  }, opts.animationSpeed, function () {
    ariaExpanded($ddTrigger, true);
  });
};
/**
 * Open Dropdown Handler
 * @param  {jQuery} $el - dropdown wrap
 * @param  {jQuery} $ddTrigger - dropdown trigger element
 * @param  {jQuery} $ddMenu - dropdown content element
 * @param  {Object} [options={}] - Any options provided upon initialization
 */
var openDebounceHandler = function openDebounceHandler($el, $ddTrigger, $ddMenu, opts) {
  if (!$el.hasClass(DD_DISABLED_STATE)) {
    openDropdown($el, $ddTrigger, $ddMenu, opts);
  }
};
/**
 * Keydown Handler
 * @param  {event} evt - key event
 * @param  {jQuery} $el - dropdown wrap
 * @param  {jQuery} $ddTrigger - dropdown trigger element
 * @param  {jQuery} $ddMenu - dropdown content element
 * @param  {lodash} openDebounce - debounce for opening dropdown
 * @param  {Object} [options={}] - Any options provided upon initialization
 */
var keydownHandler = function keydownHandler(evt, $el, $ddTrigger, $ddMenu, openDebounce, opts) {
  var $focusable = __WEBPACK_IMPORTED_MODULE_5__keyboard__["a" /* default */].findFocusable($el);
  var $firstFocusable = $focusable.eq(0);
  var $lastFocusable = $focusable.eq(-1);
  var isTab = __WEBPACK_IMPORTED_MODULE_5__keyboard__["a" /* default */].parseKey(evt) === 'TAB';
  var isShiftTab = __WEBPACK_IMPORTED_MODULE_5__keyboard__["a" /* default */].parseKey(evt) === 'SHIFT_TAB';
  var isEnter = __WEBPACK_IMPORTED_MODULE_5__keyboard__["a" /* default */].parseKey(evt) === 'ENTER';
  var isSpace = __WEBPACK_IMPORTED_MODULE_5__keyboard__["a" /* default */].parseKey(evt) === 'SPACE';
  var isClick = evt.type === 'click';
  var isEscape = __WEBPACK_IMPORTED_MODULE_5__keyboard__["a" /* default */].parseKey(evt) === __WEBPACK_IMPORTED_MODULE_5__keyboard__["a" /* default */].keys.ESCAPE;
  var isNextArrows = __WEBPACK_IMPORTED_MODULE_5__keyboard__["a" /* default */].parseKey(evt) === 'ARROWRIGHT' || __WEBPACK_IMPORTED_MODULE_5__keyboard__["a" /* default */].parseKey(evt) === 'ARROWDOWN';
  var isPrevArrows = __WEBPACK_IMPORTED_MODULE_5__keyboard__["a" /* default */].parseKey(evt) === 'ARROWLEFT' || __WEBPACK_IMPORTED_MODULE_5__keyboard__["a" /* default */].parseKey(evt) === 'ARROWUP';
  var isFirstItem = evt.target === $firstFocusable[0];
  var isLastItem = evt.target === $lastFocusable[0];
  var $returnFocus = $el.data('returnFocus');

  // prevent default for enter and space when trigger element is focused
  if ((isEnter || isSpace) && evt.target === $ddTrigger[0]) {
    evt.preventDefault();
  }
  if (evt.clientX === 0) {
    evt.preventDefault();
  }
  if (isEscape) {
    evt.stopPropagation();
    // Close current dropdown
    closeDropdown($el, $ddTrigger, $ddMenu, openDebounce, opts);
    if ($el.hasClass('trapped')) {
      releaseTrapFocus($el, $returnFocus);
    } else {
      focusOnTrigger($el);
    }
    // Close new dropdown because of new focus
    closeDropdown($el, $ddTrigger, $ddMenu, openDebounce, opts);
  }
  if (isEnter || isClick || isSpace) {
    if ($el.hasClass('dropdown') && !$el.hasClass('dd-is-open')) {
      openDebounceHandler($el, $ddTrigger, $ddMenu, opts);
    } else if ($el.hasClass('dropdown') && $el.hasClass('dd-is-open')) {
      closeDropdown($el, $ddTrigger, $ddMenu, openDebounce, opts);
    }
    // use case for when enter key is used for popover
    if ($el.hasClass('popover') && !$el.hasClass('dd-is-open')) {
      openDebounceHandler($el, $ddTrigger, $ddMenu, opts);
    } else if ($el.hasClass('popover') && $el.hasClass('dd-is-open')) {
      closeDropdown($el, $ddTrigger, $ddMenu, openDebounce, opts);
    }
  }
  if (!$el.hasClass('trapped')) {
    if (isLastItem && isTab || isFirstItem && isShiftTab) {
      closeDropdown($el, $ddTrigger, $ddMenu, openDebounce, opts);
    }
  }
  if (isNextArrows) {
    arrowHandler(evt, $el, $ddTrigger, $ddMenu, openDebounce, opts, $focusable, $firstFocusable, 'next');
  }
  if (isPrevArrows) {
    arrowHandler(evt, $el, $ddTrigger, $ddMenu, openDebounce, opts, $focusable, $firstFocusable, 'prev');
  }
};
/**
 * Set Aria Controls
 * @param  {jQuery} $ddTrigger - dropdown trigger element
 * @param  {jQuery} $ddMenu - dropdown content element
 */
var setAriaControls = function setAriaControls($ddTrigger, $ddMenu) {
  if ($ddMenu.length) {
    var ddMenuID = $ddMenu.attr('id');
    if (_typeof(ddMenuID) !== ( true ? "undefined" : _typeof(undefined)) && ddMenuID !== false) {
      $ddTrigger.attr('aria-controls', ddMenuID);
    } else {
      var randomNum = Math.ceil(Math.random() * 10000000000);
      var newMenuID = "dd-menu-".concat(randomNum);
      $ddTrigger.attr('aria-controls', newMenuID);
      $ddMenu.attr('id', newMenuID);
    }
  }
};
/**
 * Set Aria
 * @param  {jQuery} $el - dropdown wrap
 * @param  {jQuery} $ddTrigger - dropdown trigger element
 * @param  {jQuery} $ddMenu - dropdown content element
 */
var setA11y = function setA11y($el, $ddTrigger, $ddMenu) {
  $ddTrigger.attr('aria-haspopup', 'dialog');
  // If dropdown is an anchor add role="button" attribute
  if ($ddTrigger.closest('a').length) {
    $ddTrigger.attr('role', 'button');
  }
  ariaExpanded($ddTrigger, false);
  setAriaControls($ddTrigger, $ddMenu);
};
/**
 * Set Aria
 * @param  {jQuery} $el - dropdown wrap
 * @param  {jQuery} $ddTrigger - dropdown trigger element
 * @param  {jQuery} $ddMenu - dropdown content element
 */
var offsetContent = function offsetContent($el, $ddMenu) {
  var menuWidth = $ddMenu.outerWidth();
  var btnOffset = $el.offset().left;
  var windowWidth = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(window).width();
  if (menuWidth + btnOffset > windowWidth) {
    $ddMenu.css({
      right: 0,
      left: 'auto'
    });
  } else if (menuWidth > btnOffset) {
    $ddMenu.css({
      left: 0,
      right: 'auto'
    });
  }
};
/**
 * Prevent Hash
 * @param  {event} interaction event
 * @param  {jQuery} $ddTrigger - dropdown trigger element
 */
var preventHash = function preventHash(evt, $ddTrigger) {
  if (__WEBPACK_IMPORTED_MODULE_5__keyboard__["a" /* default */].parseKey(evt) === 'ENTER' || evt.type === 'click') {
    if ($ddTrigger.attr('href') === '#') {
      evt.preventDefault();
    }
  }
};
/**
 * Set Event Listeners
 * @param  {jQuery} $el - dropdown wrap
 * @param  {jQuery} $ddTrigger - dropdown trigger element
 * @param  {jQuery} $ddMenu - dropdown content element
 * @param  {lodash} openDebounce - debounce for opening dropdown
 * @param  {Object} [options={}] - Any options provided upon initialization
 */
var closeDropdownOutside = function closeDropdownOutside($el, $ddTrigger, $ddMenu, openDebounce, opts, evt) {
  if (!$el.is(evt.target) && $el.has(evt.target).length === 0) {
    releaseTrapFocus($el);
    closeDropdown($el, $ddTrigger, $ddMenu, openDebounce, opts);
  }
};
/**
 * Set Close Timeout
 * Some users accidentally leaves dropdown when entering the dropdown content.
 * This set timeout allows buffer time for user to reenter the dropdown
 * @param  {jQuery} $el - dropdown wrap
 * @param  {jQuery} $ddTrigger - dropdown trigger element
 * @param  {jQuery} $ddMenu - dropdown content element
 * @param  {lodash} openDebounce - debounce for opening dropdown
 * @param  {Object} [options={}] - Any options provided upon initialization
 */
var setCloseTimeout = function setCloseTimeout($el, $ddTrigger, $ddMenu, openDebounce, opts) {
  openDebounce.cancel();
  $el.data('close-timeout', setTimeout(function () {
    closeDropdown($el, $ddTrigger, $ddMenu, openDebounce, opts);
  }, 150));
};
/**
 * Clear set timeout for closing the dropdown
 * @param  {jQuery} $el - dropdown wrap
 */
var clearCloseTimeout = function clearCloseTimeout($el) {
  clearTimeout($el.data('close-timeout'));
};
/**
 * Set Event Listeners
 * @param  {jQuery} $el - dropdown wrap
 * @param  {jQuery} $ddTrigger - dropdown trigger element
 * @param  {jQuery} $ddMenu - dropdown content element
 * @param  {lodash} openDebounce - debounce for opening dropdown
 * @param  {Object} [options={}] - Any options provided upon initialization
 */
var setEventListeners = function setEventListeners($el, $ddTrigger, $ddMenu, openDebounce, opts) {
  $el.on('mousemove.dropdown', openDebounce).on('mouseleave.dropdown', function () {
    return setCloseTimeout($el, $ddTrigger, $ddMenu, openDebounce, opts);
  }).on('mouseenter.dropdown', function () {
    return clearCloseTimeout($el);
  }).on('keydown.dropdown', function (evt) {
    return keydownHandler(evt, $el, $ddTrigger, $ddMenu, openDebounce, opts);
  }).on('click.dropdown', '.js-dropdown-close', function () {
    closeDropdown($el, $ddTrigger, $ddMenu, openDebounce, opts);
    focusOnTrigger($el);
    closeDropdown($el, $ddTrigger, $ddMenu, openDebounce, opts);
  });
  $ddTrigger.on('click.dropdown', function (evt) {
    var isVoiceOverClick = evt.offsetX === 0 && evt.offsetY === 0 && evt.detail === 1;
    var isAnchor = evt.target.tagName === 'A';
    if (isAnchor) {
      // VoiceOver "click" on anchor, so prevent navigation to another page but handle dropdown
      if (isVoiceOverClick) {
        evt.preventDefault();
      }
      preventHash(evt, $ddTrigger);
    }
    keydownHandler(evt, $el, $ddTrigger, $ddMenu, openDebounce, opts);
  }).on('keydown.dropdown', function (evt) {
    return preventHash(evt, $ddTrigger);
  });
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).on('mouseup.dropdown', function (evt) {
    closeDropdownOutside($el, $ddTrigger, $ddMenu, openDebounce, opts, evt);
  });
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).on('touchstart.dropdown', function (evt) {
    closeDropdownOutside($el, $ddTrigger, $ddMenu, openDebounce, opts, evt);
  });
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()(window).on('resize', __WEBPACK_IMPORTED_MODULE_1_lodash_throttle___default()(function () {
    offsetContent($el, $ddMenu);
  }, 300));
};
/**
 * Open and Trap another dropdown
 * @param  {jQuery} $el - dropdown wrap
 * @param  {jQuery} $ddTrigger - dropdown trigger element
 * @param  {jQuery} $ddMenu - dropdown content element
 * @param  {jQuery} $returnFocus - return focus
 * @param  {Object} [options={}] - Any options provided upon initialization
 */
var _openAndTrap = function openAndTrap($el, $ddTrigger, $ddMenu, $returnFocus, opts) {
  openDebounceHandler($el, $ddTrigger, $ddMenu, opts);
  __WEBPACK_IMPORTED_MODULE_5__keyboard__["a" /* default */].trapFocus($ddMenu);
  $el.addClass('trapped').data('returnFocus', $returnFocus);
  var headingFocus = __WEBPACK_IMPORTED_MODULE_0_jquery___default()($ddMenu.find('h2:visible').first());
  if (headingFocus) {
    headingFocus.focus();
  } else {
    $ddTrigger.focus();
  }
};
/**
 * Initializes Header.
 * @param {HTMLElement} el - dropdown wrap
 * @param {Object} options - Options used for wiring up the modal
 * @see DEFAULTS
 */
function dropdown(el) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var $el = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(el);
  var opts = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib_merge_options__["a" /* default */])(DEFAULTS, options, $el);
  var $ddMenu = $el.find(DD_MENU_CLASS).first();
  var $ddTrigger = $el.find(DD_TRIGGER_CLASS);
  var openDebounce = __WEBPACK_IMPORTED_MODULE_2_lodash_debounce___default()(function () {
    openDebounceHandler($el, $ddTrigger, $ddMenu, opts);
  }, opts.wait);
  setA11y($el, $ddTrigger, $ddMenu);
  $ddMenu.attr('role', 'dialog');
  if (opts.offsetContent) {
    offsetContent($el, $ddMenu);
  }
  setEventListeners($el, $ddTrigger, $ddMenu, openDebounce, opts);
  return {
    open: function open() {
      return openDebounceHandler($el, $ddTrigger, $ddMenu, opts);
    },
    openAndTrap: function openAndTrap($returnFocus) {
      return _openAndTrap($el, $ddTrigger, $ddMenu, $returnFocus, opts);
    },
    close: function close() {
      return closeDropdown($el, $ddTrigger, $ddMenu, openDebounce, opts);
    }
  };
}
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib_register_jquery_plugin__["a" /* default */])(PLUGIN_NAME, dropdown);

/***/ }),
/* 289 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export PLUGIN_NAME */
/* unused harmony export DEFAULTS */
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery_mask_plugin__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery_mask_plugin___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_jquery_mask_plugin__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_register_jquery_plugin__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_merge_options__ = __webpack_require__(2);
/**
 * Handles all focus to anchor
 * @module enabledButton to
 */






// Expose the function as a jQuery plugin for ease of uses
var PLUGIN_NAME = 'enabledButton';
var DEFAULTS = {
  ebRequiredInputs: '',
  ebAtLeastOne: false
};

/**
 * Check if any inputs has a value
 * @param  {jQuery} $el - the disabled button
 * @param  {Array} inputArrays - array of inputs
 */
var atLeastOne = function atLeastOne($el, inputArrays) {
  var hasValue = false;
  inputArrays.forEach(function (el) {
    if (__WEBPACK_IMPORTED_MODULE_0_jquery___default()(el).val() && !hasValue) {
      hasValue = true;
    }
  });
  if (hasValue) {
    $el.prop('disabled', false);
  } else {
    $el.prop('disabled', true);
  }
};
/**
 * Check if any inputs has a value
 * @param  {jQuery} $el - the disabled button
 * @param  {regex} pattern - regex pattern
 * * @param  {val} string - input value
 */
var validatePattern = function validatePattern($el, pattern, val) {
  var re = new RegExp(pattern);
  if (re.test(val)) {
    $el.prop('disabled', false);
  } else {
    $el.prop('disabled', true);
  }
};

/**
 * Add Event Listeners to inputs
 * can be set.
 * @param  {jQuery} $el - button /element that opens modal
 * @param  {Object} opts - Any options provided upon initialization
 */
var addEventListerners = function addEventListerners($el) {
  var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var ebRequiredInputs = opts.ebRequiredInputs,
    ebAtLeastOne = opts.ebAtLeastOne;
  var inputArrays = ebRequiredInputs.split(',');
  inputArrays.forEach(function (el) {
    var $input = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(el);
    var pattern = $input.attr('pattern');
    $input.on('keyup', function () {
      if (ebAtLeastOne) {
        atLeastOne($el, inputArrays);
      } else if (pattern) {
        validatePattern($el, pattern, $input.val());
      }
    });
  });
};

/**
 * Initializes focusTo.
 * @param {HTMLElement} el - button /element that opens focusTo
 * @param {Object} options - Options used for wiring up the focusTo
 * @see DEFAULTS
 */
function enabledButton(el) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var $el = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(el);
  var opts = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__lib_merge_options__["a" /* default */])(DEFAULTS, options, $el);
  addEventListerners($el, opts);
}
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__lib_register_jquery_plugin__["a" /* default */])(PLUGIN_NAME, enabledButton);

/***/ }),
/* 290 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export PLUGIN_NAME */
/* unused harmony export DEFAULTS */
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_register_jquery_plugin__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_merge_options__ = __webpack_require__(2);
/**
 * Handles all focus to anchor
 * @module focus to
 */




// Expose the function as a jQuery plugin for ease of uses
var PLUGIN_NAME = 'focusTo';
var DEFAULTS = {
  updateURL: false
};

/**
 * Prevents focus scroll
 * @param {HTMLElement} $target - element sending focus to
 */
var focusWithoutScroll = function focusWithoutScroll($target) {
  var x = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).scrollLeft();
  var y = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).scrollTop();
  $target.focus();
  window.scrollTo(x, y);
};

/**
 * Scrolls to element
 * @param {HTMLElement} $target - element sending focus to
 * @param {number} scrollPosOffset - offset number
 */
var scrollToElement = function scrollToElement($target, scrollPosOffset) {
  var focusActive = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('html').hasClass('focus-active');
  if (focusActive) {
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()('html, body').stop().animate({
      scrollTop: $target.offset().top - 6
    }, 400);
  } else {
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()('html, body').stop().animate({
      scrollTop: $target.offset().top - scrollPosOffset - 0
    }, 400);
  }
};

/**
 * Initiates Focus / Scroll
 * @param {HTMLElement} el - button /element that opens focusTo
 * @param {object} evt - event object
 */
function focusStart(el, evt) {
  evt.preventDefault(evt);
  var headerHeight = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-fixed-header').height();
  var headerIsFixed = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-fixed-header').hasClass('is-fixed');
  var hash = el.hash;
  var $target = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(hash);
  var scrollPosOffset = 0;
  if (headerIsFixed) {
    scrollPosOffset = 0;
  } else {
    scrollPosOffset = headerHeight;
  }
  window.history.pushState('', '', hash);
  focusWithoutScroll($target);
  scrollToElement($target, scrollPosOffset);
}
/**
 * Handles Event Listeners.
 * @param  {jQuery} $el - button /element selector
 * @param {HTMLElement} el - button /element that opens focusTo
 */
function setEventListeners($el, el) {
  $el.on('click', function (evt) {
    focusStart(el, evt);
  });
}

/**
 * Initializes focusTo.
 * @param {HTMLElement} el - button /element that opens focusTo
 * @param {Object} options - Options used for wiring up the focusTo
 * @param {Object} deregister - Performs a deregisteration on the plugin
 * @see DEFAULTS
 */
function focusTo(el) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var $el = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(el);
  var opts = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__lib_merge_options__["a" /* default */])(DEFAULTS, options, $el);
  setEventListeners($el, el, opts);
}
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__lib_register_jquery_plugin__["a" /* default */])(PLUGIN_NAME, focusTo);

/***/ }),
/* 291 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export PLUGIN_NAME */
/* unused harmony export DEFAULTS */
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_register_jquery_plugin__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_merge_options__ = __webpack_require__(2);
/**
 * Handles image upload and preview functionality
 * @module imageUploader
 */




var PLUGIN_NAME = 'imageUploader';
var DEFAULTS = {
  uploadButton: '.js-trigger-upload-btn',
  fileInput: '#js-image-upload-target',
  previewImage: '.js-preview-img',
  removeButton: '.js-remove-img',
  imagePlaceholder: '.js-image-upload-ph',
  dropzone: '.js-dropzone'
};

/**
 * Handles the image preview functionality.
 * @param  {Object} opts - The options provided by the user or defaults.
 */

var previewImage = function previewImage(file, opts) {
  var $previewImg = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(opts.previewImage);
  var $removeImgBtn = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(opts.removeButton);
  var $imgPlaceholder = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(opts.imagePlaceholder);
  if (file) {
    window.uploadedImage = file;
    window.updatedImage = true;
    var reader = new FileReader();
    reader.onload = function (e) {
      $previewImg.attr('src', e.target.result);
      $previewImg.show();
      $removeImgBtn.removeClass('u-hide');
      $imgPlaceholder.hide();
    };
    reader.readAsDataURL(file);
  }
};
var handleImageUpload = function handleImageUpload(opts) {
  var $fileInput = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(opts.fileInput);
  $fileInput.on('change', function (event) {
    var file = event.target.files[0];
    previewImage(file, opts);
  });
};
var handleDragAndDrop = function handleDragAndDrop(opts) {
  var $dropzone = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(opts.dropzone);
  $dropzone.on('dragover', function (e) {
    e.preventDefault();
    $dropzone.addClass('drag-over');
  });
  $dropzone.on('dragleave', function () {
    $dropzone.removeClass('drag-over');
  });
  $dropzone.on('drop', function (e) {
    e.preventDefault();
    $dropzone.removeClass('drag-over');
    var file = e.originalEvent.dataTransfer.files[0]; // Get the dropped file
    previewImage(file, opts); // Preview the dropped image
    var $fileInput = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(opts.fileInput);
    $fileInput.prop('files', e.originalEvent.dataTransfer.files);
  });
};

/**
 * Handles image removal functionality.
 * @param  {Object} opts - The options provided by the user or defaults.
 */
var handleImageRemove = function handleImageRemove(opts) {
  var $fileInput = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(opts.fileInput);
  var $previewImg = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(opts.previewImage);
  var $removeImgBtn = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(opts.removeButton);
  var $imgPlaceholder = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(opts.imagePlaceholder);
  $removeImgBtn.on('click', function removeImageButton() {
    $fileInput.val('');
    $previewImg.attr('src', '#').hide();
    $imgPlaceholder.show();
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).hide();
    window.uploadedImage = null;
    window.updatedImage = true;
  });
};

/**
 * Initializes the image uploader plugin.
 * @param {HTMLElement} el - The form element or container triggering the upload
 * @param {Object} options - Options for configuring the image uploader
 * @see DEFAULTS
 */
function imageUploader(el) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var $el = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(el);
  var opts = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__lib_merge_options__["a" /* default */])(DEFAULTS, options, $el);
  var $uploadButton = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(opts.uploadButton);
  var $fileInput = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(opts.fileInput);

  // When the "Upload Image" button is clicked, trigger the file input
  $uploadButton.on('click', function (e) {
    e.preventDefault();
    $fileInput.trigger('click');
  });

  // Set up the handlers for image upload and remove
  handleImageUpload(opts);
  handleDragAndDrop(opts);
  handleImageRemove(opts);
}

// Register the plugin with jQuery
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__lib_register_jquery_plugin__["a" /* default */])(PLUGIN_NAME, imageUploader);

/***/ }),
/* 292 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export PLUGIN_NAME */
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_register_jquery_plugin__ = __webpack_require__(1);
/**
 * Toggle classes
 * @module impressionsControls
 */




// Expose the function as a jQuery plugin for ease of use
var PLUGIN_NAME = 'impressionsControls';

/**
 * Applies any sort of event handlers for the impressionsControls.
 */
var setEventListeners = function setEventListeners($el) {
  var activeClass = 'ab-controls--active';
  $el.find('.js-impressions-controls-btn').on('click', function () {
    if ($el.hasClass(activeClass)) {
      $el.removeClass(activeClass);
    } else {
      $el.addClass(activeClass);
    }
  });
  $el.find('.js-impressions-controls-close').on('click', function (e) {
    e.preventDefault();
    $el.removeClass('ab-controls--show');
    localStorage.setItem('abControls', 'false');
  });
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).on('mouseup.dropdown', function (e) {
    if (!$el.is(e.target) && $el.has(e.target).length === 0) {
      $el.removeClass(activeClass);
    }
  });
};

/**
 * Impressions polling
 * @param  {jQuery} $el - link
 */
var _doPoll = function doPoll($el) {
  __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.get('/dbadmin/spring-controller/impressions/impressions-data', function (data) {
    $el.find('.impressions-widget-data').html(data);
    setEventListeners($el);
    setTimeout(function () {
      _doPoll($el);
    }, 3000);
  });
};

/**
 * Initializes impressionsControls.
 * @param {HTMLElement} el - link
 */
function impressionsControls(el) {
  var $el = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(el);
  __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.ajax({
    url: '/dbadmin/spring-controller/impressions/impressions-widget',
    type: 'GET',
    data: {
      device: 'mobile'
    },
    success: function success(data) {
      $el.append(data);
      _doPoll($el);
      if (localStorage.getItem('impressionsControls') === 'false') {
        $el.removeClass('ab-controls--show');
      } else if (localStorage.getItem('impressionsControls') === 'true' || localStorage.getItem('impressionsControls') === null) {
        $el.addClass('ab-controls--show');
        localStorage.setItem('impressionsControls', 'true');
      }
    }
  });
}
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__lib_register_jquery_plugin__["a" /* default */])(PLUGIN_NAME, impressionsControls);

/***/ }),
/* 293 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export PLUGIN_NAME */
/* unused harmony export DEFAULTS */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_register_jquery_plugin__ = __webpack_require__(1);
/**
 * Handles instruction overlay functionality with fade out
 * @module modules/instruction-overlay
 */



var PLUGIN_NAME = 'instructionOverlay';
var DEFAULTS = {
  fadeOutDelay: 2000,
  overlaySelector: '.instruction-overlay',
  onFadeOutComplete: function onFadeOutComplete() {}
};

/**
 * Handles the instruction overlay functionality
 * @param {Object} [options={}] - Plugin options
 * @param {number} [options.fadeOutDelay=2000] - Delay before fade out starts
 * @param {string} [options.overlaySelector='.instruction-overlay']
 * - Selector for the overlay element
 * @param {Function} [options.onFadeOutComplete] - Callback when fade out completes
 */
function instructionOverlay(el) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var settings = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.extend({}, DEFAULTS, options);
  var $overlay = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(el);

  // Handle fade out
  setTimeout(function () {
    $overlay.addClass('fade-out');
  }, settings.fadeOutDelay);

  // Handle transition end
  $overlay.on('transitionend', function () {
    $overlay.addClass('u-hide');
    settings.onFadeOutComplete();
  });
}

// Expose the function as a jQuery plugin for ease of use
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__lib_register_jquery_plugin__["a" /* default */])(PLUGIN_NAME, instructionOverlay);

/***/ }),
/* 294 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_register_jquery_plugin__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_merge_options__ = __webpack_require__(2);
/**
 * Responsible for creating an toggleContent based on elements existing in the DOM
 * @module toggleContent
 */




var throttle = __webpack_require__(15);
var PLUGIN_NAME = 'lazyLoadImage';
var CLICK_EVENT = 'scroll.lazyloadimage';
// const ACTIVE_CLASS = 'is-active';

var DEFAULTS = {};

/**
 * Handles the click event when a label has been iteracted with.
 * @param {jQuery.Event} evt - A jQuery event
 * @param {HTMLElement} currentTarget - The current target interacted with
 * @param {jQuery} $el - Containing the elements for the toggleContent
 * @param {Object} opts - Options passed along from initialization
 */
function loadImage($el, opts, $window, windowBottomPosition, imagePosition, imageSrc) {
  if (windowBottomPosition >= imagePosition) {
    $el.attr('src', imageSrc);
    $el.attr('lazytriggeredimg', 'true');
  }
}
function checkLoadedImage($el, opts, $window) {
  var imageLoadedState = $el.attr('lazytriggeredimg');
  if (imageLoadedState === 'true') {
    $window.off(CLICK_EVENT);
  }
}

/**
 * Applies any sort of event handlers for the toggleContent.
 * @param {jQuery} $el - Containing the elements for the toggleContent
 * @param {Object} options - Options used for wiring up the toggleContent
 * @see DEFAULTS
 */
function applyEventHandlers($el) {
  var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var $window = arguments.length > 2 ? arguments[2] : undefined;
  var windowBottomPosition = arguments.length > 3 ? arguments[3] : undefined;
  var imagePosition = arguments.length > 4 ? arguments[4] : undefined;
  var imageSrc = arguments.length > 5 ? arguments[5] : undefined;
  $window.on(CLICK_EVENT, throttle(function () {
    loadImage($el, opts, $window, windowBottomPosition, imagePosition, imageSrc);
    checkLoadedImage($el, opts, $window);
  }, 100));
}

/**
 * Initializes an toggleContent based on provided parameters.
 * @param {HTMLElement} el - An element containing the elements for the
 * toggleContent
 * @param {Object} options - Options used for wiring up the toggleContent
 * @see DEFAULTS
 */
function toggleDisplay(el) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var $el = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(el);
  var $window = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(window);
  var opts = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__lib_merge_options__["a" /* default */])(DEFAULTS, options, $el);
  var windowHeight = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(window).height();
  var windowBottomPosition = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(window).scrollTop() + windowHeight;
  var imagePosition = $el.offset().top;
  var imageSrc = $el.attr('data-lazy-img');
  $el.attr('lazytriggeredimg', 'false');

  // $(window).off(CLICK_EVENT);
  applyEventHandlers($el, opts, $window, windowBottomPosition, imagePosition, imageSrc, windowHeight);
}
__WEBPACK_IMPORTED_MODULE_0_jquery___default.a.extend(toggleDisplay, {
  PLUGIN_NAME: PLUGIN_NAME,
  CLICK_EVENT: CLICK_EVENT
});

// Expose the function as a jQuery plugin for ease of use
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__lib_register_jquery_plugin__["a" /* default */])(PLUGIN_NAME, toggleDisplay);

/***/ }),
/* 295 */
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__(0);
var defaults = __webpack_require__(30);
var assign = __webpack_require__(467);
var throttle = __webpack_require__(15);
var slideshows = $('.js-lazyload-slick');
var defaultSettings = {
  slideshowSettings: {}
};
var offsetLoadY = 100;
__webpack_require__(12);
function checkScroll(settings) {
  var $window = $(this);
  var totalSlideshows = slideshows.length;
  var slideshowIteratorCount = 0;
  slideshows.each(function allSlides() {
    var $slideshow = $(this);
    if ($slideshow.attr('lazyTriggered') === 'false') {
      var y = $slideshow.offset().top;
      var visibleY = $window.scrollTop() + $window.innerHeight();
      if (y < visibleY + offsetLoadY) {
        $slideshow.removeClass('js-lazyload-slick');
        $slideshow.slick(settings.slideshowSettings);
        $slideshow.attr('lazyTriggered', true);
      }
    } else {
      slideshowIteratorCount += 1;
    }
  });
  if (slideshowIteratorCount === totalSlideshows) {
    $(window).off('scroll.lazyloadSlideshow resize.lazyloadSlideshow');
  }
}
function init(userSettings) {
  var settings = assign({}, defaultSettings, userSettings);
  slideshows = $('.js-lazyload-slick').not('.slick-initialized');
  slideshows.attr('lazyTriggered', false);
  $(window).on('scroll.lazyloadSlideshow resize.lazyloadSlideshow', throttle(function () {
    checkScroll(settings);
  }, 100));
  checkScroll(settings);
}
module.exports = init;
defaults(module.exports, {});

/***/ }),
/* 296 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery_mask_plugin__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery_mask_plugin___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_jquery_mask_plugin__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__accordion__ = __webpack_require__(276);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__enabled_button__ = __webpack_require__(289);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__back_button__ = __webpack_require__(278);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__countdown__ = __webpack_require__(285);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__focus_to__ = __webpack_require__(290);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__dropdown__ = __webpack_require__(288);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__toggle_dropdown__ = __webpack_require__(321);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__toggle_display__ = __webpack_require__(320);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__toggle_reveal__ = __webpack_require__(323);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__toggle_elements__ = __webpack_require__(322);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__category_menu__ = __webpack_require__(279);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__drawer__ = __webpack_require__(287);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__toggle_text__ = __webpack_require__(324);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__truncate__ = __webpack_require__(326);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__close_banner__ = __webpack_require__(282);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__product_size_change__ = __webpack_require__(304);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__product_size_click__ = __webpack_require__(305);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__product_add_to_bag__ = __webpack_require__(298);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__product_color_change__ = __webpack_require__(299);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__product_oos__ = __webpack_require__(303);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__product_zoom__ = __webpack_require__(306);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__horizontal_scroll__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__image_carousel__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__tabs__ = __webpack_require__(318);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__rating_scale_rating_scale__ = __webpack_require__(309);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__ab_controls__ = __webpack_require__(272);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__impressions_controls__ = __webpack_require__(292);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__modal__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__track_video__ = __webpack_require__(325);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__vanish_vanish__ = __webpack_require__(327);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__slick_slider__ = __webpack_require__(313);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__switch_class__ = __webpack_require__(317);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__rich_nav__ = __webpack_require__(310);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__lazyload__ = __webpack_require__(295);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__lazyload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_35__lazyload__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__lazyload_image__ = __webpack_require__(294);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__toggle_change__ = __webpack_require__(319);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__shipping_options_from_bag__ = __webpack_require__(311);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__copy_clipboard__ = __webpack_require__(284);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__char_counter__ = __webpack_require__(281);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__cc_mask__ = __webpack_require__(280);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__progressiveButton__ = __webpack_require__(308);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__progress_ring__ = __webpack_require__(307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__counter__ = __webpack_require__(286);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__add_to_calendar__ = __webpack_require__(277);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__visual_nav__ = __webpack_require__(328);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47__swipe_view__ = __webpack_require__(316);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48__cookies_banner__ = __webpack_require__(283);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49__side_panel__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50__abtest_follow_shops__ = __webpack_require__(273);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51__image_upload__ = __webpack_require__(291);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_52__sticky_nav__ = __webpack_require__(315);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_53__instruction_overlay__ = __webpack_require__(293);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_54__abtest_custom_video_player__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_55__abtest_mobile_video_player__ = __webpack_require__(274);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_56__abtests_ab553__ = __webpack_require__(249);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_57__no_focus__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_58__modules_abtest_model_switch__ = __webpack_require__(275);





























// import updateNotifyMe from './notify-me-update';































// lazyload
function setupLazyLoad() {
  __WEBPACK_IMPORTED_MODULE_35__lazyload___default()({
    slideshowSettings: {
      arrows: false,
      infinite: false,
      mobileFirst: true,
      slidesToShow: 2.5,
      slidesToScroll: 2,
      lazyLoad: 'ondemand',
      accessibility: false
    }
  });
}
function filterSetup() {
  var $pageHeaderOverlay = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-page-header-overlay');
  var $pageHeaderTitle = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.page-header__title');
  $pageHeaderOverlay.on('click', function () {
    $pageHeaderTitle.click();
  });
}
window.resetLazyLoad = function resetLazyLoadFunc() {
  setupLazyLoad();
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-lazyload-slick').removeClass('js-lazyload-slick');
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-horizontal-scroll').horizontalScroll();
};
window.setupImageCarousel = function () {
  // Image Carousels
  var IMAGE_CAROUSEL_SELECTOR = '.image-carousel';
  var PRODUCT_ZOOM_SELECTOR = "".concat(IMAGE_CAROUSEL_SELECTOR, "--product-zoom");
  var $imageCarousel = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(IMAGE_CAROUSEL_SELECTOR);
  var videos = [];
  $imageCarousel.on('init', function () {
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.image-carousel__item').each(function (index, val) {
      var hasVideo = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(val).hasClass('image-carousel__item--vid');
      if (hasVideo) {
        // has video
        var vidIndex = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(val).index();
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.image-carousel__dots li').eq(vidIndex).children('.image-carousel__dot-button').addClass('image-carousel__dot-button--vid');
        var vidSrc = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.image-carousel--product-zoom li').eq(vidIndex).find('source').attr('src');
        videos.push(vidSrc);
      }
    });
  });
  $imageCarousel.filter(":not(".concat(PRODUCT_ZOOM_SELECTOR, ")")).imageCarousel();
  $imageCarousel.filter(PRODUCT_ZOOM_SELECTOR).each(function setupZoomCarousel() {
    var carousel = new __WEBPACK_IMPORTED_MODULE_24__image_carousel__["a" /* default */](this);
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).productZoom({
      slideFunc: carousel.setSlideNumber.bind(carousel),
      beforeUnmount: carousel.transitionSlide.bind(carousel),
      targetSelector: 'img,video',
      videos: videos
    });
  });
};
window.setUpProductHandlers = function () {
  var $product = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.product');
  $product.find('.product__size select:not(.js-products-as-sizes):not(.js-size-select-sb), .product__size input').sizeChange().trigger('change');
  var sizeInputs = $product.find('#pdp-size-options input').pdpSizeClick();
  // in order to display the preorder notification info
  if (sizeInputs.length === 1 && __WEBPACK_IMPORTED_MODULE_0_jquery___default()(sizeInputs[0]).data('preorder')) {
    sizeInputs.trigger('click');
  }
  $product.find('.product__color select').colorChange();
  $product.find('.js-products-as-sizes').colorChange();
  $product.find('form').filter('[data-open="product-added-confirmation"]').addToBag();
  $product.find('.product-oos').oosProduct();
};
__WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).ready(function () {
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-enabled-button').enabledButton();
  filterSetup();
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_57__no_focus__["a" /* default */])();
  setupLazyLoad();
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-horizontal-scroll').horizontalScroll();
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-lazyload-image').lazyLoadImage();
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#shippingTableFromBag').shippingOptionsFromBag();
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-accordion').accordion();
  // issue with sizeguide, remove once cleaned up
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-accordion-nav').accordion();
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-tabs').tabs();
  // UX-17870
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-order-tabs').tabs({
    tab: '.pill-button--white',
    tabContent: '.tabs__content',
    tabContentActive: 'tabs__content--active',
    tabActive: 'pill-button--black'
  });
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-toggle-text').toggleText();
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-toggle-elements').toggleElements();
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-toggle-dropdown').toggleDropdown();
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-toggle-reveal').toggleReveal();
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-progress-ring').progressRing();
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-modal').modal();
  __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.modal.a11y();
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-track-video').trackVideo();
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('[data-truncate]').truncate();
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.back-button').backButton();
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-switch-class').switchClass();
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-mask-cc').ccMask();
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-progressive-button').progressiveButton();
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-toggle-display').toggleDisplay();
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-counter').counter();
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-add-to-calendar').addToCalendar();
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-upload-form').imageUploader();
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-nav-switch-class').switchClass({
    isActive: function isActive() {
      // Close category menu
      __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.toggleDropdown.close();
      __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.categoryMenu.close();
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).trigger('removeConstrainPage');
    }
  });
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-countdown').countdown();
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#js-rich-nav').richNav();
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-toggle-change').toggleChange();
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-char-counter').charCounter();
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-close-banner').closeBanner();
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-category-menu').categoryMenu();
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-swipe-view').swipeView();
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-lazyload-slick').removeClass('js-lazyload-slick');
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-sticky-nav').stickyNav();
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-focus-to').focusTo();
  // const used for rtl slick
  var language = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('html').attr('lang');
  var rtlBool = language === 'ar';
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-featured-slides').slick({
    arrows: false,
    infinite: false,
    mobileFirst: true,
    slidesToShow: 1.5,
    slidesToScroll: 1,
    lazyLoad: 'progressive',
    accessibility: false,
    touchThreshold: 20
  });
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#js-featured-shops-slider').slick({
    arrows: false,
    infinite: false,
    mobileFirst: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    lazyLoad: 'progressive',
    accessibility: false,
    dots: true,
    touchThreshold: 20
  });
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-carousel-single-product').slick({
    // Used for landing pages - UX-14577
    arrows: true,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    nextArrow: '.js-carousel__nav-next-single',
    prevArrow: '.js-carousel__nav-prev-single',
    touchThreshold: 20
  });

  // drawer animation of dynamic content in buy now modal on PDP
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-drawer-class').drawer();
  // Global Banner slider
  var bannerSlideshow = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-slideshow');
  if (bannerSlideshow.children('.banner--slider-list__item').length > 1) {
    if (language === 'ar') {
      bannerSlideshow.attr('dir', 'rtl');
    }
    bannerSlideshow.slick({
      autoplay: true,
      autoplaySpeed: 6000,
      prevArrow: '.banner__slick-prev',
      nextArrow: '.banner__slick-next',
      rtl: rtlBool,
      touchThreshold: 20
    });
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.banner__slick-next, .banner__slick-prev').on('click', function () {
      bannerSlideshow.slick('slickPause');
    });
  } else {
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.banner__slick-next, .banner__slick-prev').hide();
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.banner--slider-list').show();
  }

  // Voyages slider
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-voyages-package').each(function voyagesPackage() {
    var $voyagesSelf = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this);
    var $voyagersSlideshow = $voyagesSelf.find('.js-voyagers-slideshow');
    $voyagersSlideshow.slick({
      lazyLoad: 'ondemand',
      arrows: false,
      infinite: false,
      dots: true,
      touchThreshold: 20
    });
  });
  var $activeLink = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.pill-button--black');
  // Check if the element exists
  var $scrollTarget = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-scroll-target');

  // Set the scroll position immediately without animation
  if ($scrollTarget.length && $activeLink.length) {
    // Get the position of the active link relative to the scroll container
    var targetOffsetLeft = $activeLink.offset().left;
    var scrollContainerOffsetLeft = $scrollTarget.offset().left + 16;
    // Find the scrollable container
    $scrollTarget.scrollLeft(targetOffsetLeft - scrollContainerOffsetLeft);
    // Focus on the active link immediately after adjusting the scroll
  }
  // input masking
  if (__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-mask-tel-us').length) {
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-mask-tel-us').mask('+1(000) 000-0000');
  }
  if (__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-mask-date').length) {
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-mask-date').mask('00/00/0000');
  }
  if (__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-mask-mx').length) {
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-mask-mx').mask('+52#000000000');
  }
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-copy-clipboard').copyToClipboard();
  window.setUpProductHandlers();
  window.setupImageCarousel();

  // const notifyMeClass = 'notify-me';

  // $(`.${notifyMeClass}`).find('.product__size select, .product__size input')
  //   .sizeChange({ wrapBlockClass: notifyMeClass, update: updateNotifyMe })
  //   .trigger('change');

  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-rating-scale').ratingScale({
    titleSelector: '.form-section__title'
  });
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-model-switch').modelSwitch();
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-mobile-video-trigger').mobileVideoPlayer();
  if (__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.multiple-models').length) {
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.multiple-models__button').on('click', function () {
      // NOTE: URL for `url` will need to be changed
      __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.modal({
        url: './dialog/multiple-models-modal.html',
        type: 'toast',
        triggerOpen: true,
        closeButton: true,
        onComplete: function onComplete() {
          __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-tabs-size-guide').tabs({
            tab: '.tabs-size-guide__link',
            tabActive: 'tabs-size-guide__link--active',
            tabContentActive: 'sizeguide-tab-content--active'
          });
          __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-model-switch').modelSwitch();
        }
      });
    });
  }

  // ai-chat window AB 568
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()(document.getElementsByClassName('vanish')).vanish();
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-ab-controls').abControls(); // Ab Testing Controls for previewing on testing servers
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-impressions-controls').impressionsControls();
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-cookies-banner-toggle').cookiesBanner();
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-dropdown').dropdown();
});
__WEBPACK_IMPORTED_MODULE_0_jquery___default()(window).on('load', function () {
  // get width of the nav links for overflow purposes
  var totalNavLinksWidth = 0;
  var navBar = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.nav.nav--justified');
  var navBarWrapper = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('ul.nav__wrapper.container');
  var navBarInViewWidth = navBarWrapper.width();
  var navLinks = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.nav.nav--justified .nav__wrapper .nav__item');
  navLinks.each(function (i, el) {
    totalNavLinksWidth += parseInt(__WEBPACK_IMPORTED_MODULE_0_jquery___default()(el).outerWidth(), 10);
  });
  if (totalNavLinksWidth > navBarInViewWidth) {
    navBar.addClass('nav__overflow');
  }
});

/***/ }),
/* 297 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export DEFAULTS */
/* harmony export (immutable) */ __webpack_exports__["a"] = notificationPopup;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__keyboard__ = __webpack_require__(3);
/**
 * Handles notification popups (NON-MODAL)
 * @module notificationPopup
 */



var DEFAULTS = {
  message: '',
  duration: 5000,
  container: document.body,
  showCloseButton: true,
  trapFocusFunc: __WEBPACK_IMPORTED_MODULE_1__keyboard__["a" /* default */].trapFocus.bind(__WEBPACK_IMPORTED_MODULE_1__keyboard__["a" /* default */]),
  releaseFocusFunc: __WEBPACK_IMPORTED_MODULE_1__keyboard__["a" /* default */].releaseFocus.bind(__WEBPACK_IMPORTED_MODULE_1__keyboard__["a" /* default */])
};

/**
 * Creates a notification popup
 * @private
 * @param {string} message - The message of the notification
 * @param {boolean} showCloseButton - Whether to show the close button
 * @returns {string} Fully qualified notification
 */
var createNotification = function createNotification(_ref) {
  var message = _ref.message,
    showCloseButton = _ref.showCloseButton;
  var closeButton = showCloseButton ? "\n    <div class=\"u-center u-margin-t--sm\">\n      <button class=\"js-notification-popup-close link u-color--white u-text--lg\" type=\"button\">\n        close\n      </button>\n    </div>\n  " : '';
  return "\n    <div class=\"js-notification-popup notification-popup\" role=\"status\" aria-live=\"polite\">\n      <p class=\"u-margin-b--none u-center modal__focus-element\">".concat(message, "</p>\n      ").concat(closeButton, "\n    </div>\n  ");
};

/**
 * Return focus to the element that triggered the notification
 * @private
 * @param {jQuery} $notification - The notification element
 */
var returnToLastFocus = function returnToLastFocus($notification, releaseFocusFunc) {
  var $lastFocus = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).data('notificationLastFocus');
  if (typeof releaseFocusFunc === 'function') {
    releaseFocusFunc($notification, $lastFocus);
  }
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).removeData('notificationLastFocus');
};

/**
 * Closes and removes a notification
 * @private
 * @param {jQuery} $notification - The notification element to close
 */
var closeNotification = function closeNotification($notification, releaseFocusFunc) {
  $notification.removeClass('is-active');

  // Remove from DOM after transition
  setTimeout(function () {
    returnToLastFocus($notification, releaseFocusFunc);
    $notification.off('keydown.notificationEscape');
    $notification.remove();
  }, 300); // Match CSS transition duration
};

/**
 * Save last focus element before showing notification
 * @private
 * @param {jQuery} $triggerElement - Element that triggered the notification
 */
var saveLastFocus = function saveLastFocus($triggerElement) {
  if ($triggerElement && $triggerElement.length) {
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).data('notificationLastFocus', $triggerElement);
  }
};

/**
 * Handle escape key to close notification
 * @private
 * @param {Event} evt - Keyboard event
 * @param {jQuery} $notification - The notification element
 * @param {Function} releaseFocusFunc - Function to release focus trap
 */
var escapeNotification = function escapeNotification(evt, $notification, releaseFocusFunc) {
  if (__WEBPACK_IMPORTED_MODULE_1__keyboard__["a" /* default */].parseKey(evt) === __WEBPACK_IMPORTED_MODULE_1__keyboard__["a" /* default */].keys.ESCAPE) {
    closeNotification($notification, releaseFocusFunc);
  }
};

/**
 * Shows a notification popup
 * @param {Object} options - Configuration options
 * @see DEFAULTS
 */
function notificationPopup() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var opts = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.extend({}, DEFAULTS, options);

  // Close any existing notifications first
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-notification-popup.is-active').each(function closePopup() {
    closeNotification(__WEBPACK_IMPORTED_MODULE_0_jquery___default()(this));
  });

  // Save the currently focused element
  saveLastFocus(__WEBPACK_IMPORTED_MODULE_0_jquery___default()(document.activeElement));
  var $notification = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(createNotification({
    message: opts.message,
    showCloseButton: opts.showCloseButton
  }));
  $notification.appendTo(opts.container);
  $notification.addClass('is-active');

  // Set up escape key handler
  $notification.on('keydown.notificatinEscape', function (evt) {
    escapeNotification(evt, $notification, opts.releaseFocusFunc);
  });

  // Add click handler for close button if present
  if (opts.showCloseButton) {
    $notification.find('.js-notification-popup-close').on('click', function () {
      closeNotification($notification, opts.releaseFocusFunc);
    });
  }

  // Trap focus and move focus to notification
  opts.trapFocusFunc($notification);

  // Focus on the message or close button
  var $focusTarget = opts.showCloseButton ? $notification.find('.js-notification-popup-close') : $notification.find('.modal__focus-element');
  $focusTarget.focus();

  // Auto-remove after duration
  if (opts.duration > 0) {
    setTimeout(function () {
      closeNotification($notification, opts.releaseFocusFunc);
    }, opts.duration);
  }
  return {
    close: function close() {
      return closeNotification($notification, opts.releaseFocusFunc);
    }
  };
}

/**
 * Utility function for showing notifications
 * @param {string|Object} messageOrOptions - Message string or options object
 */
__WEBPACK_IMPORTED_MODULE_0_jquery___default.a.notificationPopup = function (messageOrOptions) {
  if (typeof messageOrOptions === 'string') {
    return notificationPopup({
      message: messageOrOptions
    });
  }
  return notificationPopup(messageOrOptions);
};

/**
 * Utility function for closing all notifications
 */
__WEBPACK_IMPORTED_MODULE_0_jquery___default.a.notificationPopup.close = function () {
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-notification-popup.is-active').each(function closePopup() {
    closeNotification(__WEBPACK_IMPORTED_MODULE_0_jquery___default()(this), DEFAULTS.releaseFocusFunc);
  });
};

/***/ }),
/* 298 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export MODAL_ID */
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_register_jquery_plugin__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modal__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_constants_pdp__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib_create_product_data__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__product_price_update__ = __webpack_require__(27);
/**
 * Click event attached to product form to show confirmation
 * @module modules/addToBag
 */








/**
 * Confirmation modal's default `id` attribute
 */
var MODAL_ID = 'product-added-confirmation';

/**
 * Function to open the modal, using the modal module
 * @private
 * @param {HTMLElement} el - element the handler is attached to
 * @param {String} open - id of the modal id to be opened
 */
var openModal = function openModal(el, open) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__modal__["a" /* default */])(el, {
    open: open,
    triggerOpen: true
  });
};

/**
 * Function to update the modal's content
 * @private
 * @param {HTMLElement} btn - button that was clicked
 */
var updateModal = function updateModal(form, open) {
  var dropdown = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(form).find(".".concat(__WEBPACK_IMPORTED_MODULE_3__lib_constants_pdp__["m" /* SIZE_BLOCK_ELEMENT */], " select"))[0];
  var data = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib_create_product_data__["a" /* default */])(dropdown);

  // make sure modal element exists
  var modalEl = document.getElementById(open);
  if (!modalEl) {
    throw new Error('Modal element does not exist (addToBag)');
  }

  // create modalData to point at modal
  var wrap = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(modalEl).find(".".concat(__WEBPACK_IMPORTED_MODULE_3__lib_constants_pdp__["a" /* PRODUCT_BLOCK */]));
  var modalData = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.extend({}, data, {
    wrap: wrap
  });
  var options = dropdown.options,
    selectedIndex = dropdown.selectedIndex;
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib_create_product_data__["b" /* updateChosenData */])(modalData, options[selectedIndex]);

  // expect price to update in modal
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__product_price_update__["a" /* default */])(modalData);
};

/**
 * Adds 'submit' listener to parent 'form'.
 * @private
 * @param {HTMLElement} el - The element the modal is attached to
 * @param {String} open - modal id
 * @param {Function} updateFunc - function to update the modal contents
 * @param {Function} openFunc - function to open the modal
 */
var clickHandler = function clickHandler(el, _ref) {
  var open = _ref.modalId,
    updateFunc = _ref.updateModal,
    openFunc = _ref.openModal;
  updateFunc(el, open);
  openFunc(el, open);
};

/**
 * @namespace
 * @property {String} modalId - id of the modal to use
 * @property {Function} clickHandler - fires when the button is clicked
 * @property {Function} updateModal - the function to update the modal contents
 * @property {Function} openModal - the function fired to show the modal
 */
var DEFAULT_OPTIONS = {
  modalId: MODAL_ID,
  clickHandler: clickHandler,
  updateModal: updateModal,
  openModal: openModal
};
/**
 * Initializes color dropdown changes.
 * @param {HTMLElement} el - The form we're attaching to
 * @see DEFAULT_OPTIONS
 */
function addToBag(el) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var $el = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(el);
  var opts = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.extend({}, DEFAULT_OPTIONS, options, $el.data());
  var clickFunc = opts.clickHandler;
  $el.on('submit', function (e) {
    e.preventDefault();
    clickFunc(el, opts);
  });
}
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__lib_register_jquery_plugin__["a" /* default */])('addToBag', addToBag);

/***/ }),
/* 299 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export PLUGIN_NAME */
/* unused harmony export USE_AJAX_ATTR */
/* unused harmony export runUpdates */
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_redirect_href__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_register_jquery_plugin__ = __webpack_require__(1);
/**
 *
 * Attaches change event listener to color dropdown, firing necessary updates
 * (typically attached to '.product-option--color .product-option__select')
 * @module modules/colorChange
 */




var _require = __webpack_require__(103),
  loadColorMarkup = _require.loadColorMarkup;

// Expose the function as a jQuery plugin for ease of use
var PLUGIN_NAME = 'colorChange';
var USE_AJAX_ATTR = 'useAjax';
function loadMarkup(result, code, chosen, size) {
  if (result.success) {
    // js-modal moves this out of the markup that gets replaced
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#product-added-confirmation').remove();
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#detailsMarkup').html(result.detailsMarkup);
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#accordionMarkup').html(result.accordionMarkup);
    if (result.bestSellerBadge) {
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#js-bs-badge-container').html(result.bestSellerBadge);
    } else {
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#js-bs-badge-container').empty();
    }
    // reload similar items
    var $similarItems = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#similarItemsMarkup');
    if ($similarItems.length) {
      if (result.similarItemsMarkup) {
        $similarItems.html(result.similarItemsMarkup).find('.js-horizontal-scroll').horizontalScroll();
      } else {
        $similarItems.html('');
      }
    }
    var $fitPredictorRoot = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.fp-root');
    var allSizes = [];
    var availableSizes = [];
    var fpSize = null;
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#size option').each(function optionFP() {
      var thisSize = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).val();
      if (thisSize) {
        allSizes.push(thisSize);
        var isAvailable = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).attr('data-oos') !== 'true';
        if (isAvailable) {
          availableSizes.push(thisSize);
          if (thisSize === size) {
            if ($fitPredictorRoot.length) {
              fpSize = size;
            }
          }
        }
      }
    });
    if ($fitPredictorRoot.length) {
      window.ssp('set', 'product', {
        productId: $fitPredictorRoot.data('productId'),
        size: fpSize,
        color: __WEBPACK_IMPORTED_MODULE_0_jquery___default()(chosen).data('colorName'),
        sizes: allSizes,
        availableSizes: availableSizes,
        variantId: code
      });
      window.ssp('start', 'fitpredictor');
    }
    window.initPDPJs(code);
    var $completeTheLook = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#completeTheLookMarkup');
    if ($completeTheLook.length) {
      if (result.completeTheLookMarkup) {
        $completeTheLook.html(result.completeTheLookMarkup).find('.js-horizontal-scroll').horizontalScroll();
      } else {
        $completeTheLook.html('');
      }
    }

    // page track and update history state
    window.rcProps.pdp.ajaxedColorChange = true;
    window.rcProps.pdp.newReferrer = window.location.href;
    window.insertPageTrackForMobileWithData({
      productCode: code
    });
    var url = new URL(__WEBPACK_IMPORTED_MODULE_0_jquery___default()(chosen).data('href'), window.location.origin);
    url.searchParams.set('sizeSelected', 'true');
    window.history.replaceState({
      code: code,
      colorClicked: true
    }, result.title, url);
    document.title = result.title;
  } else {
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-price-range').show();
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-price-single').hide();
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__lib_redirect_href__["a" /* default */])(chosen);
    var _url = new URL(window.location.href);
    _url.searchParams["delete"]('sizeSelected');
    window.history.replaceState({}, document.title, _url.toString());
  }
  if (typeof window.getPDPCustomerReviewsHTML === 'function') {
    window.getPDPCustomerReviewsHTML(code, undefined, 1);
  }
  // favorite status has been changed in this window after markup was loaded
  var $heartButton = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#main-content .js-fav-button');
  var productHearts = window.productHearts || {};
  if (Object.prototype.hasOwnProperty.call(productHearts, code) && window.rcProps && window.rcProps.favoriteActiveClass && $heartButton.length) {
    if (window.productHearts[code]) {
      $heartButton.addClass(window.rcProps.favoriteActiveClass);
      $heartButton.attr('aria-checked', true);
    } else {
      $heartButton.removeClass(window.rcProps.favoriteActiveClass);
      $heartButton.attr('aria-checked', false);
    }
  }
}

/**
 * List of all updates made on change.
 * @param {HTMLElement} evt - The select dropdown we're attaching to
 */
var runUpdates = function runUpdates(_ref) {
  var currentTarget = _ref.currentTarget;
  // whether input or select, find the chosen element
  var options = currentTarget.options,
    selectedIndex = currentTarget.selectedIndex;
  var chosen = options ? options[selectedIndex] : currentTarget;
  var code = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(chosen).data('code');
  var useAjax = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(chosen).data(USE_AJAX_ATTR);
  var sizeOption = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#size-products option:selected');
  var size = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#size').val();
  if ((size === undefined || typeof size === 'undefined') && sizeOption) {
    size = sizeOption.val();
  }
  if (size && typeof size !== 'undefined') {
    var url = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(chosen).data('href');
    url += (url.indexOf('?') >= 0 ? '&' : '?') + __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.param({
      size: size
    });
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()(chosen).attr('data-href', url);
    if (sizeOption && sizeOption.data('reload') === true) {
      url += (url.indexOf('?') >= 0 ? '&' : '?') + __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.param({
        sizeSelected: true
      });
      document.location.href = url;
      return;
    }
  }
  if (typeof useAjax !== 'undefined' && !useAjax) {
    // Only redirect if defined as `false`
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__lib_redirect_href__["a" /* default */])(chosen);
  } else {
    window.rcProps.colorSwatchMarkup = window.rcProps.colorSwatchMarkup || {};
    var colorData = window.rcProps.colorSwatchMarkup[code];
    // check for required items that are used in `loadMarkup`, especially if there's a failure in
    // the JS that stores pieces of data for the initial product fails
    if (colorData && typeof colorData.then !== 'function' && (!('success' in colorData) || !('title' in colorData) || !('detailsMarkup' in colorData) || !('similarItemsMarkup' in colorData)
    // 'bestSellerBadge' is also checked and used but only if there's a badge
    || !('accordionMarkup' in colorData) || !('completeTheLookMarkup' in colorData))) {
      colorData = null;
    }
    // it's a promise currently being loaded, just execute when it finishes
    if (colorData) {
      if (typeof colorData.then === 'function') {
        colorData.then(function () {
          loadMarkup(window.rcProps.colorSwatchMarkup[code], code, chosen, size);
        });
      } else {
        loadMarkup(colorData, code, chosen, size);
      }
    } else {
      loadColorMarkup([code]).then(function () {
        loadMarkup(window.rcProps.colorSwatchMarkup[code], code, chosen, size);
      });
    }
  }
};

/**
 * Attaches change event to select dropdown.
 * @private
 * @param {HTMLElement} dropdown - The select dropdown
 */
var attachChangeListener = function attachChangeListener(dropdown) {
  return dropdown.change(function (evt) {
    return runUpdates(evt);
  });
};

/**
 * Initializes color dropdown changes.
 * @param {HTMLElement} el - The select dropdown we're attaching to
 */
function colorChange(el) {
  var dropdown = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(el);
  attachChangeListener(dropdown);
}
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__lib_register_jquery_plugin__["a" /* default */])(PLUGIN_NAME, colorChange);

/***/ }),
/* 300 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export PLUGIN_NAME */
/* unused harmony export DEFAULTS */
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styleguide_lib_merge_options__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_register_jquery_plugin__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_props__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__product_filter_count__ = __webpack_require__(69);
/**
 * Sidebar product filter search
 * @module productFilterActiveSearch
 */






var PLUGIN_NAME = 'productFilterActiveButton';
var DEFAULTS = {
  clearAllText: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__lib_props__["a" /* get */])('rcProps.filter.clearAllText', 'Clear')
};
var createCloseIcon = function createCloseIcon() {
  return "<span class=\"icon icon--x icon--xs u-margin-l--sm\">\n  <svg viewBox=\"0 0 16 16\" aria-hidden=\"true\" focusable=\"false\"\n      role=\"presentation\">\n      <path\n          d=\"M9.06 8l2.72-2.72A.75.75 0 0 0 10.72 4.22L8 6.94 5.28\n             4.22A.75.75 0 0 0 4.22 5.28L6.94 8l-2.72 2.72A.75.75 0 1 0 5.28 11.78L8\n             9.06l2.72 2.72a.75.75 0 0 0 1.061-1.061z\">\n      </path>\n  </svg>\n</span>";
};
var createFilterButton = function createFilterButton(text) {
  return "<li class=\"horizontal-scroll__item\n     horizontal-scroll__item--basis-none\">\n  <button class=\"pill-button pill-button--light-grey\">\n      ".concat(text, "\n      ").concat(createCloseIcon(), "\n  </button>\n</li>");
};

// Getting rid of Clear button for AB testing
var createContainerButtons = function createContainerButtons() {
  return "<div class=\"horizontal-scroll u-margin-b--none u-width-plus-16\">\n  <ul\n      class=\"horizontal-scroll__item-wrap horizontal-scroll__item-wrap--first-no-padding u-margin-b--none\">\n  </ul>\n</div>";
};

// const createContainerButtons = (clearAllText) => `
// <div class="horizontal-scroll u-margin-b--none u-width-plus-16">
//   <ul
//       class="horizontal-scroll__item-wrap horizontal-scroll__item-wrap--first-no-padding
//           u-margin-b--none">
//       <li class="horizontal-scroll__item horizontal-scroll__item--basis-none">
//           <button class="pill-button pill-button--black">
//               ${clearAllText}
//           </button>
//       </li>
//   </ul>
// </div>
// `;

var addButtonsContainer = function addButtonsContainer($container, $checkboxes, _ref) {
  var clearAllText = _ref.clearAllText;
  var $buttonContainer = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(createContainerButtons(clearAllText));
  var $clearAllButton = $buttonContainer.find('button');
  $container.prepend($buttonContainer);
  $clearAllButton.on('click', function () {
    $checkboxes.each(function (index, checkbox) {
      if (checkbox.checked) {
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()(checkbox).prop('checked', false).trigger('change');
      }
    });
  });
  return {
    $buttonListContainer: $buttonContainer,
    $buttonList: $buttonContainer.find('ul')
  };
};
var addButtonToList = function addButtonToList($checkbox, $buttonList) {
  var innserSpan = $checkbox.next().children('span');
  var checkboxText;
  if (innserSpan.length) {
    checkboxText = innserSpan.eq(0).text();
  } else {
    checkboxText = $checkbox.next().text();
  }
  var $filterButton = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(createFilterButton(checkboxText));
  $buttonList.append($filterButton);
  $filterButton.on('click', function () {
    $checkbox.prop('checked', false).trigger('change');
  });
  return $filterButton;
};
var countChecked = function countChecked($checkboxes) {
  return $checkboxes.filter(':checked').length;
};
var checkButtonListVisibility = function checkButtonListVisibility($buttonListContainer, $checkboxes) {
  if (countChecked($checkboxes)) {
    $buttonListContainer.removeClass('u-hide');
    return;
  }
  $buttonListContainer.addClass('u-hide');
};
var initActiveButtons = function initActiveButtons($buttonListContainer, $buttonList, $checkboxes) {
  $checkboxes.each(function (index, checkbox) {
    var $checkbox = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(checkbox);
    var $filterButton;
    if (checkbox.checked) {
      $filterButton = addButtonToList($checkbox, $buttonList);
    }
    $checkbox.on('change', function () {
      if (checkbox.checked) {
        $filterButton = addButtonToList($checkbox, $buttonList);
      } else {
        $filterButton.remove();
      }
      checkButtonListVisibility($buttonListContainer, $checkboxes);
    });
  });
};

/**
 * Initializes productFilterActiveButton.
 * @param {HTMLElement} container - filter container
 * @param {Object} options - Options used for wiring up the plugin
 * @see DEFAULTS
 */
function productFilterActiveButton(container) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var $container = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(container);
  var opts = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_styleguide_lib_merge_options__["a" /* default */])(DEFAULTS, options, $container);
  var $count = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(opts.filterCount);
  var $checkboxes = $container.find('input[type="checkbox"]');
  var _addButtonsContainer = addButtonsContainer($container, $checkboxes, opts),
    $buttonListContainer = _addButtonsContainer.$buttonListContainer,
    $buttonList = _addButtonsContainer.$buttonList;
  initActiveButtons($buttonListContainer, $buttonList, $checkboxes, $count);
  checkButtonListVisibility($buttonListContainer, $checkboxes);
  $container.productFilterCount();
}
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__lib_register_jquery_plugin__["a" /* default */])(PLUGIN_NAME, productFilterActiveButton);

/***/ }),
/* 301 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export PLUGIN_NAME */
/* unused harmony export DEFAULTS */
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_register_jquery_plugin__ = __webpack_require__(1);
/**
 * Product Filter Clear All
 * @module productFilterClearAll
 */



var PLUGIN_NAME = 'productFilterClearAll';
var DEFAULTS = {};
var ZeroChecked = function ZeroChecked($checkboxes) {
  return $checkboxes.filter(':checked').length === 0;
};
var clearAllVisibility = function clearAllVisibility($checkboxes, $clearButton) {
  var isZeroChecked = ZeroChecked($checkboxes);
  if (isZeroChecked) {
    $clearButton.hide();
  } else {
    $clearButton.show();
  }
};
var onChangeListener = function onChangeListener($checkboxes, $clearButton) {
  return $checkboxes.on('change', function () {
    return clearAllVisibility($checkboxes, $clearButton);
  });
};

/**
 * Initializes productFilterClearAll.
 * @param {HTMLElement} container - filter container
 * @param {Object} options - Options used for wiring up the plugin
 * @see DEFAULTS
 */
function productFilterClearAll(container) {
  var $container = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(container);
  var $checkboxes = $container.find('input[type="checkbox"]');
  var $clearButton = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-product-filter-clear-all-button');
  $clearButton.on('click', function () {
    $checkboxes.each(function (index, checkbox) {
      if (checkbox.checked) {
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()(checkbox).prop('checked', false).trigger('change');
      }
    });
  });
  clearAllVisibility($checkboxes, $clearButton);
  onChangeListener($checkboxes, $clearButton);
}
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__lib_register_jquery_plugin__["a" /* default */])(PLUGIN_NAME, productFilterClearAll);

/***/ }),
/* 302 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export PLUGIN_NAME */
/* unused harmony export DEFAULTS */
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styleguide_lib_merge_options__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_register_jquery_plugin__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_props__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__product_filter_count__ = __webpack_require__(69);
/**
 * Sidebar product filter search
 * @module productFilterSearch
 */






var PLUGIN_NAME = 'productFilterSearch';
var DEFAULTS = {
  zeroResultsText: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__lib_props__["a" /* get */])('rcProps.filter.zeroResults', 'There are 0 results. Try a new search.')
};
var findMatches = function findMatches(phraseToMatch, list) {
  return list.filter(function (item) {
    var regex = new RegExp(phraseToMatch, 'ig');
    return item.value.match(regex);
  }).map(function (item) {
    return item.index;
  });
};
var createData = function createData($checkboxes) {
  return $checkboxes.toArray().map(function (checkbox, index) {
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()(checkbox).data('data-original-text', checkbox.value);
    return {
      value: checkbox.value,
      index: index
    };
  });
};
var highlightText = function highlightText(phraseToMatch, text) {
  var regex = new RegExp(phraseToMatch, 'ig');
  return text.replace(regex, function (match) {
    return "<strong>".concat(match, "</strong>");
  });
};
var createZeroResults = function createZeroResults($container, _ref) {
  var zeroResultsText = _ref.zeroResultsText;
  var $zeroResults = __WEBPACK_IMPORTED_MODULE_0_jquery___default()("<p class='u-hide'>".concat(zeroResultsText, "</p>"));
  $container.find('#designer-search').closest('.field').after($zeroResults);
  return $zeroResults;
};
var countVisible = function countVisible($checkboxes) {
  return $checkboxes.filter(':visible').length;
};
var checkZeroResults = function checkZeroResults($checkboxes, $zeroResults) {
  if (countVisible($checkboxes) === 0) {
    $zeroResults.removeClass('u-hide');
  } else {
    $zeroResults.addClass('u-hide');
  }
};

/**
 * Initializes productFilterSearch
 * @param {HTMLElement} el - filter container
 * @param {Object} options - Options used for wiring up the plugin
 * @see DEFAULTS
 */
function productFilterSearch(container) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var $container = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(container);
  var opts = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_styleguide_lib_merge_options__["a" /* default */])(DEFAULTS, options, $container);
  var $checkboxes = $container.find('input[type="checkbox"]');
  var checkboxData = createData($checkboxes);
  var $searchField = $container.find('input[type="text"');
  var $zeroResults = createZeroResults($container, opts);
  $container.productFilterCount();
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('[aria-controls=alldesigners]').on('click', function () {
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#alldesigners').formField();
  });
  $searchField.on('input', function () {
    var matches = findMatches($searchField.val(), checkboxData);
    $checkboxes.each(function (index, checkbox) {
      var $checkbox = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(checkbox);
      var $checkboxContainer = $checkbox.closest('.accordion__height-cap');
      var $label = $checkboxContainer.find('.checkbox__label');

      // show checkbox option
      if (matches.includes(index)) {
        $checkboxContainer.removeClass('u-hide');
        if ($searchField.val() === '') {
          $label.html($checkbox.data('data-original-text'));
          $container.removeClass('hasValue');
        } else {
          $container.addClass('hasValue');
          var highlight = highlightText($searchField.val(), $checkbox.data('data-original-text'));
          $label.html(highlight);
        }

        //  hide checkbox option
      } else {
        $checkboxContainer.addClass('u-hide');
      }
    });
    checkZeroResults($checkboxes, $zeroResults);
  });
}
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__lib_register_jquery_plugin__["a" /* default */])(PLUGIN_NAME, productFilterSearch);

/***/ }),
/* 303 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export PLUGIN_NAME */
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_create_product_data__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_register_jquery_plugin__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__product_cta_update__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__delivery_date_update__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__product_price_update__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__defect_disclaimer_update__ = __webpack_require__(66);
/**
 * Updates page for Out Of Stock product
 * @module modules/oosProduct
 */








// Expose the function as a jQuery plugin for ease of use
var PLUGIN_NAME = 'oosProduct';

/**
 * Initializes changes for oos product.
 * @param {HTMLElement} el - The select dropdown we're attaching to
 */
function oosProduct(el) {
  var data = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__lib_create_product_data__["a" /* default */])(el);
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__delivery_date_update__["a" /* default */])(data);
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__product_cta_update__["a" /* default */])(data);
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__product_price_update__["a" /* default */])(data);
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__defect_disclaimer_update__["a" /* default */])(data);
}
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__lib_register_jquery_plugin__["a" /* default */])(PLUGIN_NAME, oosProduct);

/***/ }),
/* 304 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export PLUGIN_NAME */
/* unused harmony export getChosen */
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_register_jquery_plugin__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__product_price_update__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__product_notification_show__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__product_cta_update__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__delivery_date_update__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__lib_redirect_href__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__product_unavailable_update__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__lib_create_product_data__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__defect_disclaimer_update__ = __webpack_require__(66);
/**
 * Attaches change event listener to size dropdown, firing necessary updates
 * (typically attached to '.product-option--size .product-option__select')
 * @module modules/sizeChange
 */












// Expose the function as a jQuery plugin for ease of use
var PLUGIN_NAME = 'sizeChange';

/**
 * Attaches change event to select dropdown.
 * @private
 * @param {Object} data - Object containing relevant data about the product
 * @param {Function} updateFunc - Function to update the page
 */
var attachChangeListener = function attachChangeListener(data, updateFunc) {
  return __WEBPACK_IMPORTED_MODULE_0_jquery___default()(data.sizeEl).change(function () {
    updateFunc(data);
  });
};

/**
 * Helper to get chosen size
 * @param {HTMLElement} sizeEl - Size Element
 * @return {Object} Chosen size data
 */
var getChosen = function getChosen(sizeEl) {
  // whether input or select, find the chosen element
  var options = sizeEl.options,
    selectedIndex = sizeEl.selectedIndex;
  return options ? options[selectedIndex] : sizeEl;
};
function showFittingRoom(chosen) {
  if (__WEBPACK_IMPORTED_MODULE_0_jquery___default()('#fittingRoomSizeContents').length === 0) {
    return;
  }
  if (typeof window.clickFittingRoomCheckbox !== 'undefined' && __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.isFunction(window.clickFittingRoomCheckbox)) {
    window.clickFittingRoomCheckbox(true, chosen.value);
  }
}
function updateSellableDefectSizeMessage(_ref) {
  var _ref$chosen = _ref.chosen,
    chosen = _ref$chosen === void 0 ? {} : _ref$chosen;
  var $assignedItemSerialNumber = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#assignedSellableDefectItemSerialNumber');
  if ($assignedItemSerialNumber.length && $assignedItemSerialNumber.val().length > 0) {
    var $assignedItemDisclaimer = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#sellable-defect-item-disclaimer');
    if ($assignedItemDisclaimer.length) {
      $assignedItemDisclaimer.show();
    }
  } else {
    var sellableDefectItemPrice = chosen.sellableDefectItemPrice,
      sellableDefectItemLink = chosen.sellableDefectItemLink;
    var $itemPrice = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#sellableDefectItemPrice');
    var $itemLink = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#sellableDefectItemLink');
    var $itemMsg = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#sellableDefectItemMsg');
    if ($itemPrice.length && $itemLink.length && $itemMsg.length) {
      if (sellableDefectItemPrice.length > 0 && sellableDefectItemLink.length > 0) {
        $itemPrice.text(sellableDefectItemPrice);
        $itemLink.prop('href', sellableDefectItemLink);
        $itemMsg.show();
      } else {
        $itemMsg.hide();
      }
    }
  }
}

/**
 * Callback function to update the page.
 * @private
 * @param {Object} data - Object containing relevant data about the product
 */
function update(data) {
  var chosen = getChosen(data.sizeEl);
  var sizeChosen = chosen.value;
  if (sizeChosen === 'so') {
    return;
  }
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__lib_create_product_data__["b" /* updateChosenData */])(data, chosen);
  // run updates
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib_redirect_href__["a" /* default */])(chosen);
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__product_price_update__["a" /* default */])(data);
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__product_notification_show__["a" /* default */])(data);
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__product_cta_update__["a" /* default */])(data);
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__delivery_date_update__["a" /* default */])(data);
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__product_unavailable_update__["a" /* default */])(data);
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__defect_disclaimer_update__["a" /* default */])(data);
  showFittingRoom(chosen);
  updateSellableDefectSizeMessage(data);
}

/**
 * @namespace
 * @param {Function} update - Function fired to update page on size change
 */
var DEFAULT_OPTIONS = {
  update: update
};

/**
 * Initializes size changes.
 * @param {HTMLElement} el - The select dropdown we're attaching to
 * @see DEFAULT_OPTIONS
 */
function sizeChange(el) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var combinedOptions = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.extend({}, DEFAULT_OPTIONS, options);
  var updateFunc = combinedOptions.update;
  var data = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__lib_create_product_data__["a" /* default */])(el, combinedOptions);
  attachChangeListener(data, updateFunc);
}
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__lib_register_jquery_plugin__["a" /* default */])(PLUGIN_NAME, sizeChange);

/***/ }),
/* 305 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export PLUGIN_NAME */
/* unused harmony export getChosen */
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_register_jquery_plugin__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__product_price_update__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__product_notification_show__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__product_cta_update__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__delivery_date_update__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__lib_redirect_href__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__product_unavailable_update__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__lib_create_product_data__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__defect_disclaimer_update__ = __webpack_require__(66);
/**
 * Attaches change event listener to size dropdown, firing necessary updates
 * (typically attached to '.product-option--size .product-option__select')
 * @module modules/pdpSizeClick
 */












// Expose the function as a jQuery plugin for ease of use
var PLUGIN_NAME = 'pdpSizeClick';

/**
 * Attaches change event to select dropdown.
 * @private
 * @param {Object} data - Object containing relevant data about the product
 * @param {Function} updateFunc - Function to update the page
 */
var attachChangeListener = function attachChangeListener(data, updateFunc) {
  return __WEBPACK_IMPORTED_MODULE_0_jquery___default()(data.sizeEl).click(function () {
    updateFunc(data);
  });
};

/**
 * Helper to get chosen size
 * @param {HTMLElement} sizeEl - Size Element
 * @return {Object} Chosen size data
 */
var getChosen = function getChosen(sizeEl) {
  // whether input or select, find the chosen element
  var options = sizeEl.options,
    selectedIndex = sizeEl.selectedIndex;
  return options ? options[selectedIndex] : sizeEl;
};

/**
 * Callback function to update the page.
 * @private
 * @param {Object} data - Object containing relevant data about the product
 */
function update(data) {
  var chosen = getChosen(data.sizeEl);
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__lib_create_product_data__["b" /* updateChosenData */])(data, chosen);

  // run updates
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib_redirect_href__["a" /* default */])(chosen);
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__product_price_update__["a" /* default */])(data);
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__product_notification_show__["a" /* default */])(data);
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__product_cta_update__["a" /* default */])(data);
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__delivery_date_update__["a" /* default */])(data);
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__product_unavailable_update__["a" /* default */])(data);
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__defect_disclaimer_update__["a" /* default */])(data);
}

/**
 * @namespace
 * @param {Function} update - Function fired to update page on size change
 */
var DEFAULT_OPTIONS = {
  update: update
};

/**
 * Initializes size changes.
 * @param {HTMLElement} el - The select dropdown we're attaching to
 * @see DEFAULT_OPTIONS
 */
function pdpSizeClick(el) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var combinedOptions = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.extend({}, DEFAULT_OPTIONS, options);
  var updateFunc = combinedOptions.update;
  var data = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__lib_create_product_data__["a" /* default */])(el, combinedOptions);
  attachChangeListener(data, updateFunc);
}
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__lib_register_jquery_plugin__["a" /* default */])(PLUGIN_NAME, pdpSizeClick);

/***/ }),
/* 306 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export FAVORITE_ID */
/* unused harmony export FADE_OUT_BADGE_CLASS_NAME */
/* unused harmony export ZOOM_BADGE_ID */
/* unused harmony export ZOOM_BADGE_TRANSITION_EVENT */
/* unused harmony export ZOOM_BADGE_COOKIE */
/* unused harmony export PINCH_ZOOM_BADGE_COOKIE */
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_js_cookie__ = __webpack_require__(354);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_js_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_js_cookie__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__slick_carousel__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__slick_carousel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__slick_carousel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__keyboard__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__elements_toggle_favorite__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lib_register_jquery_plugin__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__zoom_slider_zoom__ = __webpack_require__(330);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__lib_data_props__ = __webpack_require__(270);
/**
 * Responsible for rendering a product specific zoom
 * @module modules/productZoom
 */









/**
 * Defines the options which can be provided for the product zoom.
 * @type {Object}
 */
var DEFAULTS = {
  sliderZoom: __WEBPACK_IMPORTED_MODULE_6__zoom_slider_zoom__["a" /* default */],
  targetSelector: '',
  slideFunc: function slideFunc(num) {
    return num;
  },
  didUnmount: function didUnmount() {},
  zoomBadgeDuration: 2000,
  returnFocus: '',
  trapFocusFunc: __WEBPACK_IMPORTED_MODULE_3__keyboard__["a" /* default */].trapFocus.bind(__WEBPACK_IMPORTED_MODULE_3__keyboard__["a" /* default */])
};

/**
 * Defines the default props for the component.
 * @type {Object}
 */
var DEFAULT_PROPS = {
  images: [],
  imagesRetina: [],
  noImages: 'No images found :(',
  tapToZoom: 'Tap to Zoom',
  pinchToZoom: 'Pinch to Zoom'
};

/**
 * Defines the id for the favorite element.
 * @type {String}
 */
var FAVORITE_ID = 'product-zoom-favorite';

/**
 * Defines the fade out className.
 * @type {String}
 */
var FADE_OUT_BADGE_CLASS_NAME = 'product-badge--fade-out';

/**
 * Defines the element ID for a zoom badge.
 * @type {String}
 */
var ZOOM_BADGE_ID = 'zoom-badge';

/**
 * Defines the event used for finishing a transition.
 * @type {String}
 */
var ZOOM_BADGE_TRANSITION_EVENT = 'transitionend';

/**
 * Contains fields for interacting with a badge cookie.
 * @type {Object}
 */
var ZOOM_BADGE_COOKIE = {
  name: 'zb',
  expires: 14
};

/**
 * Contains fields for interacting with a pinch to zoom cookie.
 * @type {Object}
 */
var PINCH_ZOOM_BADGE_COOKIE = {
  name: 'pzb',
  expires: 14
};

/**
 * Setup used for hiding the zoom badge so that it can be shown and later on
 * removed.
 * @private
 * @param  {number} zoomBadgeDuration - The duration in milliseconds when the
 *                                      badge should be removed
 */
var setupHideZoomBadge = function setupHideZoomBadge(zoomBadgeDuration) {
  setTimeout(function () {
    var $zoomBadge = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(document.getElementById(ZOOM_BADGE_ID));
    $zoomBadge.addClass(FADE_OUT_BADGE_CLASS_NAME).remove();
  }, zoomBadgeDuration);
};

/**
 * Contains the component used for rendering zoom info badge.
 * @private
 * @param  {string} text - Text used in the badge
 * @return {string} Rendered template containing the badge
 */
var infoBadgeComponent = function infoBadgeComponent(_ref) {
  var text = _ref.text;
  return "\n  <div id=\"".concat(ZOOM_BADGE_ID, "\" class=\"product-badge product-badge--center u-absolute product-badge--inline\" tabindex=\"0\">\n    ").concat(text, "\n  </div>");
};

/**
 * Renders an info badge if the necessary cookie isn't present.
 * @private
 * @param  {number} zoomBadgeDuration - Represents duration in milliseconds
 * @param  {string} text - Text used inside zoom badge
 * @return {string} The info badge if the logic checks out
 */
var renderInfoBadge = function renderInfoBadge(_ref2) {
  var zoomBadgeDuration = _ref2.zoomBadgeDuration,
    text = _ref2.text,
    badgeCookie = _ref2.badgeCookie;
  var name = badgeCookie.name,
    expires = badgeCookie.expires;
  var sawZoomBadge = __WEBPACK_IMPORTED_MODULE_1_js_cookie___default.a.get(name);
  if (!sawZoomBadge) {
    __WEBPACK_IMPORTED_MODULE_1_js_cookie___default.a.set(name, 1, {
      expires: expires
    });
    setupHideZoomBadge(zoomBadgeDuration);
    return infoBadgeComponent({
      text: text
    });
  }
  return '';
};

/**
 * Renders any additional markup that goes in the menu.
 * @private
 * @return {string} A fully render template for the menu.
 */
var favoriteButtonComponent = function favoriteButtonComponent() {
  var $favBtn = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-fav-button');
  var extraCss = '';
  if ($favBtn.hasClass('favorite-button--active')) {
    extraCss = 'favorite-button--active';
  }
  if ($favBtn.hasClass('favorite-button--men')) {
    extraCss += ' favorite-button--men';
  }
  var code = $favBtn.data('code');
  var favMsg = $favBtn.data('favorite-message');
  var unFavMsg = $favBtn.data('unfavorite-message');
  var notification = $favBtn.data('favorite-notification');
  var unFavNotification = $favBtn.data('unfavorite-notification');
  var markup = "<button id=\"".concat(FAVORITE_ID, "\" class=\"favorite-button zoom-menu__favorite ").concat(extraCss, "\"\n      data-code=\"").concat(code, "\"\n      data-favorite-message=\"").concat(favMsg, "\"\n      data-unfavorite-message=\"").concat(unFavMsg, "\"\n      data-favorite-notification=\"").concat(notification, "\"\n      data-unfavorite-notification=\"").concat(unFavNotification, "\"\n    >\n    <span class=\"favorite-button__icon icon icon--heart-fill\">\n      <svg viewBox=\"0 0 16 16\" aria-hidden=\"true\" focusable=\"false\">\n        <path d=\"M7.093 2.228a4.129 4.129 0 0 0-5.876 0 4.218 4.218 0 0 0 0 5.928L8 15l6.783-6.844a4.219 4.219 0 0 0 0-5.928 4.129 4.129 0 0 0-5.876 0L8 3.143z\"/>\n      </svg>\n    </span>\n  </button>");
  return markup;
};
var logFavoriteClick = function logFavoriteClick(isAddedToFavorites) {
  if (typeof window.logEngagementWithDetails === 'function') {
    window.logEngagementWithDetails(window.location.href, 'pdp zoom modal', 'add to favorites', isAddedToFavorites ? 'added' : 'removed');
  }
};

/**
 * Used to bind the events for the product zoom.
 * @private
 */
var didRender = function didRender() {
  var btn = document.getElementById(FAVORITE_ID);
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__elements_toggle_favorite__["a" /* default */])(btn, {
    logFavoriteClick: logFavoriteClick
  });
  if (typeof window.addFavEvent === 'function') {
    window.addFavEvent(btn);
  }
};

/**
 * Determines whether a function should be ran based on images existing.
 * @private
 * @param  {array}   images - A list of image sources
 * @param  {Function} callback - Callback to return if logic is valid
 * @return {Function} Used for execution based on logic
 */
var shouldRun = function shouldRun(images, callback) {
  return images.length ? callback : function () {
    return '';
  };
};

/**
 * Responsible for adding the click zoom event listener
 * @param {HTMLElement} el - The element used for opening up the product zoom
 * @param {Object} [options={}] - Forwarded along options
 */
function addZoomClickListener(el, opts) {
  var sliderZoomFunc = opts.sliderZoom,
    zoomBadgeDuration = opts.zoomBadgeDuration,
    targetSelector = opts.targetSelector;
  var _dataProps = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__lib_data_props__["a" /* default */])(el, DEFAULT_PROPS),
    images = _dataProps.images,
    imagesRetina = _dataProps.imagesRetina,
    noImages = _dataProps.noImages,
    pinchToZoom = _dataProps.pinchToZoom;
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()(el).on('click.product-zoom', targetSelector, function (e) {
    /* Mock Content Start UX-20630 */
    // AB-test guard: when the click originates inside a mobile video trigger
    // (e.g. the inline employee-video tile at gallery slide 3), the trigger
    // opens its own fullscreen overlay via mobileVideoPlayer — the product
    // zoom modal should not also open behind it.
    if (__WEBPACK_IMPORTED_MODULE_0_jquery___default()(e.target).closest('.js-mobile-video-trigger').length) {
      return;
    }
    /* Mock Content End UX-20630 */

    var $slickActive = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(e.target).closest('.slick-active');
    var slickIndex = $slickActive.data('slick-index');
    if (slickIndex === undefined || slickIndex < 0) {
      return; // Exit early for invalid or cloned slides
    }
    handleZoom(e, el, opts, sliderZoomFunc, zoomBadgeDuration, noImages, pinchToZoom, images, imagesRetina, slickIndex);
  });
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()(el).on('keydown.product-zoom', function (e) {
    var $slickActive = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(e.target).find('.slick-active');
    var slickIndex = $slickActive.data('slick-index');
    if (e.key === 'Enter' || e.keyCode === 13) {
      if (__WEBPACK_IMPORTED_MODULE_0_jquery___default()(e.target).closest('.slick-arrow').length > 0) {
        return;
      }
      handleZoom(e, el, opts, sliderZoomFunc, zoomBadgeDuration, noImages, pinchToZoom, images, imagesRetina, slickIndex);
    }
  });
}
var logOpenZoomModal = function logOpenZoomModal() {
  if (typeof window.logEngagement === 'function') {
    window.logEngagement(window.location.href, 'pdp zoom modal', 'open zoom');
  }
};
function handleZoom(e, el, opts, sliderZoomFunc, zoomBadgeDuration, noImages, pinchToZoom, images, imagesRetina, slickIndex) {
  // stylitics
  var $imageLink = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(e.target).parent('a');
  if ($imageLink.data('styliticsShop')) {
    return;
  }
  var startingIndex = images.length ? slickIndex : null;
  sliderZoomFunc(images, __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.extend({}, opts, {
    images: images,
    imagesRetina: imagesRetina,
    menuRender: shouldRun(images, favoriteButtonComponent),
    didRender: shouldRun(images, didRender),
    startingIndex: startingIndex,
    noImages: noImages,
    zoomClickListener: function zoomClickListener() {
      addZoomClickListener(el, opts);
    },
    imageLoaded: function imageLoaded($dialog) {
      var badgeHTML = renderInfoBadge({
        text: pinchToZoom,
        zoomBadgeDuration: zoomBadgeDuration,
        badgeCookie: PINCH_ZOOM_BADGE_COOKIE
      });
      $dialog.prepend(badgeHTML);
    }
  }));
  logOpenZoomModal();
}

/**
 * Responsible for rendering a slider zoom that's specifically used showcasing
 * a product.
 * @see DEFAULTS
 * @param {HTMLElement} el - The element used for opening up the product zoom
 * @param {Object} [options={}] - Forwarded along options
 */
function productZoom(el) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var opts = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.extend({}, DEFAULTS, options);
  var zoomBadgeDuration = opts.zoomBadgeDuration;
  var _dataProps2 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__lib_data_props__["a" /* default */])(el, DEFAULT_PROPS),
    images = _dataProps2.images,
    tapToZoom = _dataProps2.tapToZoom;
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()(el).append(shouldRun(images, renderInfoBadge({
    text: tapToZoom,
    zoomBadgeDuration: zoomBadgeDuration,
    badgeCookie: ZOOM_BADGE_COOKIE
  })));
  addZoomClickListener(el, opts);
}
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib_register_jquery_plugin__["a" /* default */])('productZoom', productZoom);

/***/ }),
/* 307 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export PLUGIN_NAME */
/* unused harmony export DEFAULTS */
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_register_jquery_plugin__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_merge_options__ = __webpack_require__(2);
/**
 * Progress Ring module
 * @module progressRing
 */
/* eslint-disable */




// Expose the function as a jQuery plugin for ease of use
var PLUGIN_NAME = 'progressRing';
var DEFAULTS = {
  filled: 0,
  filledRing: '.progress-ring__circle--fill',
  pending: 0,
  pendingRing: '.progress-ring__circle--pending',
  progressRings: '.progress-ring__circle',
  progressRingSVG: 'progress-ring__diagram',
  strokeWidth: 17,
  width: 144
};

/**
 * Calculates the radius of the circle. The radius needs to take into account
 * the added width from the stroke
 * @param  {Object} [options={}] - Any options provided upon initialization
 * @return {Number} The radius of the progress ring
 */
var calculateRadius = function calculateRadius(options) {
  return options.width / 2 - options.strokeWidth / 2;
};

/**
 * Calculates the circumference of the progress ring. This number allows
 * us to calculate the value for the percentage of the progress ring
 * that should be filled
 * @param  {Number} radius - The radius of the progress ring
 * @return {Number} The circumference of the progress ring
 */
var calculateCircumference = function calculateCircumference(radius) {
  return radius * 2 * Math.PI;
};

/**
 * Calculates and adds the stroke-dashoffset attribute to the pending progress ring
 * @param  {jQuery} $el - progress ring element
 * @param  {Object} [options={}] - Any options provided upon initialization
 * @param  {Number} circumference - The circumference of the progress ring
 */
var setPendingRing = function setPendingRing($el, options, circumference) {
  options.filled = options.filled < 0 ? 0 : options.filled;
  var amountFilled = circumference * (1 - (parseFloat(options.pending) + parseFloat(options.filled)));
  var parent = $el.find(options.pendingRing);
  parent.attr("stroke-dashoffset", amountFilled);
  parent.children().attr('from', circumference);
  parent.children().attr('to', amountFilled);
};

/**
 * Calculates and adds the stroke-dashoffset attribute to the filled progress ring
 * @param  {jQuery} $el - progress ring element
 * @param  {Object} [options={}] - Any options provided upon initialization
 * @param  {Number} circumference - The circumference of the progress ring
 */
var setFilledRing = function setFilledRing($el, options, circumference) {
  options.filled = options.filled < 0 ? 0 : options.filled;
  var amountFilled = circumference * (1 - options.filled);
  var parent = $el.find(options.filledRing);
  parent.attr("stroke-dashoffset", amountFilled);
  parent.children().attr('from', circumference);
  parent.children().attr('to', amountFilled);
};

/**
 * Sets the viewBox property on the <svg> tag dynamically based on the width option
 * @param  {jQuery} $el - progress ring element
 * @param  {Object} [options={}] - Any options provided upon initialization
 */
var setSVGViewBox = function setSVGViewBox($el, options) {
  // jQuery attr() does not work with the viewBox attribute so must convert from
  // jQuery to JavaScript to use the setAttribute() method
  var el = $el.get(0);
  var progressRingSVG = el.getElementsByClassName(options.progressRingSVG)[0];
  progressRingSVG.setAttribute("viewBox", "0 0 ".concat(options.width, " ").concat(options.width));
};

/**
 * Sets the calculated attributes to each of the <circle> elements in the
 * progress ring module
 * @param  {jQuery} $el - progress ring element
 * @param  {Object} [options={}] - Any options provided upon initialization
 */
var setProgressRingAttributes = function setProgressRingAttributes($el, options) {
  var radius = calculateRadius(options);
  var circumference = calculateCircumference(radius);
  $el.find(options.progressRings).each(function (index, progressRing) {
    progressRing.setAttribute("cx", options.width / 2);
    progressRing.setAttribute("cy", options.width / 2);
    progressRing.setAttribute("r", radius - 1);
    progressRing.setAttribute("stroke-dasharray", circumference);
    progressRing.setAttribute("stroke-width", options.strokeWidth);
  });
  setPendingRing($el, options, circumference);
  setFilledRing($el, options, circumference);
  setSVGViewBox($el, options);
};

/**
 * Updates the values of the progress ring and rerenders it.
 * Meant to be used if the progress ring needs to be updated after the page
 * has already been rendered.
 * @param  {jQuery} $el - progress ring element
 * @param  {Number} filled - % of the progress ring that should be filled
 * @param  {Number} pending - % of the progress ring that is pending
 * @param  {Object} [options={}] - Any options provided upon initialization
 */
var _rerender = function rerender($el, filled, pending, options) {
  var updatedOptions = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__lib_merge_options__["a" /* default */])(DEFAULTS, {
    filled: filled,
    pending: pending
  }, $el);
  setProgressRingAttributes($el, updatedOptions);
};

/**
 * Initializes progressRing
 * @param {HTMLElement} el - progress ring element
 * @param {Object} options - Options used for wiring up the progressRing
 * @see DEFAULTS
 */
function progressRing(el) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var $el = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(el);
  var opts = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__lib_merge_options__["a" /* default */])(DEFAULTS, options, $el);
  setProgressRingAttributes($el, opts);
  return {
    rerender: function rerender(filled, pending) {
      return _rerender($el, filled, pending, opts);
    }
  };
}
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__lib_register_jquery_plugin__["a" /* default */])(PLUGIN_NAME, progressRing);
/* eslint-disable */

/***/ }),
/* 308 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export PLUGIN_NAME */
/* unused harmony export CLICK_HANDLER */
/* unused harmony export DEFAULTS */
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_register_jquery_plugin__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_merge_options_js__ = __webpack_require__(2);
/**
 * Progressive Button on click
 * @module progressiveButton
 */




var PLUGIN_NAME = 'progressiveButton';
var CLICK_HANDLER = 'click';
var DEFAULTS = {
  time: 2000
};

/**
 * Handle Toggling Event
 * @param  {jQuery} $el - button /element that toggles text
 * @param  {Object} [options={}] - Any options provided upon initialization
 */
var progressiveFlow = function progressiveFlow($el, options) {
  // Get button-specific data attributes
  var onLoadSelector = $el.data('on-load-state');
  var finalBtnSelector = $el.data('final-state');
  var textSubmit = $el.data('text-on-submit');

  // Find closest parent container to scope the selectors
  var $elParent = $el.closest('.js-progressive-button__container');
  var $container = $elParent.length ? $elParent : $el.parent();

  // Find elements within the same container instead of global document
  var $onLoad = $container.find(onLoadSelector);
  var $finalBtn = $container.find(finalBtnSelector);
  setTimeout(function () {
    $el.attr('disabled', true);
  });

  // if there's another button to show,
  // hide the original button
  if (finalBtnSelector) {
    $el.hide();
  }
  $onLoad.removeClass('u-hide');
  if (textSubmit) {
    if ($el.is('input')) {
      $el.val(textSubmit);
    } else {
      $el.text(textSubmit);
    }
  }
  if (finalBtnSelector) {
    setTimeout(function () {
      $onLoad.hide();
      $finalBtn.removeClass('u-hide');
    }, options.time);
  }
};
var _reset = function reset($el) {
  // Get button-specific data attributes directly from the element
  var onLoadSelector = $el.data('on-load-state');
  var finalBtnSelector = $el.data('final-state');
  var dataText = $el.data('text');
  setTimeout(function () {
    $el.removeAttr('disabled');
  });
  if (dataText) {
    if ($el.is('input')) {
      $el.val(dataText);
    } else {
      $el.text(dataText);
    }
  }
  if (finalBtnSelector) {
    $el.show();
  }
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()(onLoadSelector).removeClass('u-inline-block');
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()(onLoadSelector).addClass('u-hide');
};
var setEventListeners = function setEventListeners($el, options) {
  $el.on(CLICK_HANDLER, function (e) {
    e.stopPropagation();
    progressiveFlow($el, options);
  });
};
/**
 * Initializes Header.
 * @param {HTMLElement} el - trigger
 * @param {Object} options - Options used for wiring up the button
 * @see DEFAULTS
 */
function progressiveButton(el) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var $el = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(el);
  var opts = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__lib_merge_options_js__["a" /* default */])(DEFAULTS, options, $el);
  setEventListeners($el, opts);
  return {
    reset: function reset() {
      return _reset($el);
    },
    // Mock Content Start - AB Test 400
    run: function run() {
      return progressiveFlow($el, opts);
    }
    // Mock Content End - AB Test 400
  };
}
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__lib_register_jquery_plugin__["a" /* default */])(PLUGIN_NAME, progressiveButton);

/***/ }),
/* 309 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export RATING_SCALE_OPTIONS */
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_findIndex__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_findIndex___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_findIndex__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_register_jquery_plugin__ = __webpack_require__(1);
/**
 * Responsible for the interacting with the rating scale which allows a user to
 * select a rating for a given product
 * @module modules/rating-scale/ratingScale
 */




/**
 * Defines the defaults around the rating scale.
 * @type {Object}
 */
var RATING_SCALE_OPTIONS = {
  titleSelector: 'h2',
  block: 'rating-scale-field',
  inputElement: 'input',
  labelElement: 'label',
  filledModifier: 'filled'
};

/**
 * Will apply class names to the block, input, and label based on the
 * operation, i.e. add/remove.
 * @private
 * @param {HTMLElement} el - Contains the star ratings
 * @param {String} op - The operation applied to the class name
 * @param {String} block - Block name containing the rating
 * @param {String} inputElement - Input element name with the rating value
 * @param {String} labelElement - Label element name with the rating content
 * @param {String} filledModifier - The filled modifier name
 */
var updateField = function updateField(el, op, block, inputElement, labelElement, filledModifier) {
  el.classList[op]("".concat(block, "--").concat(filledModifier));
  var inputBlockElement = "".concat(block, "__").concat(inputElement);
  el.querySelector(".".concat(inputBlockElement)).classList[op]("".concat(inputBlockElement, "--").concat(filledModifier));
  var labelBlockElement = "".concat(block, "__").concat(labelElement);
  el.querySelector(".".concat(labelBlockElement)).classList[op]("".concat(labelBlockElement, "--").concat(filledModifier));
};

/**
 * Removes filled CSS class names.
 * @private
 * @param {HTMLElement} el - Contains the star ratings
 * @param {String} block - Block name containing the rating
 * @param {String} inputElement - Input element name with the rating value
 * @param {String} labelElement - Label element name with the rating content
 * @param {String} filledModifier - The filled modifier name
 */
var removeFilledClassNames = function removeFilledClassNames(el, block, inputElement, labelElement, filledModifier) {
  return updateField(el, 'remove', block, inputElement, labelElement, filledModifier);
};

/**
 * Adds filled CSS class names.
 * @private
 * @param {HTMLElement} el - Contains the star ratings
 * @param {String} block - Block name containing the rating
 * @param {String} inputElement - Input element name with the rating value
 * @param {String} labelElement - Label element name with the rating content
 * @param {String} filledModifier - The filled modifier name
 */
var addFilledClassNames = function addFilledClassNames(el, block, inputElement, labelElement, filledModifier) {
  return updateField(el, 'add', block, inputElement, labelElement, filledModifier);
};

/**
 * Will apply the filled modifier to any elements considered to be filled.
 * @private
 * @param {HTMLElement} wrap - Contains the star ratings
 * @param {HTMLElement} target - The block interacted with
 * @param {String} block - Block name containing the rating
 * @param {String} inputElement - Input element name with the rating value
 * @param {String} labelElement - Label element name with the rating content
 * @param {String} filledModifier - The filled modifier name
 */
var applyFilledState = function applyFilledState(wrap, target, block, inputElement, labelElement, filledModifier) {
  var sections = Array.from(wrap.querySelectorAll(".".concat(block)));
  var selectedIndex = __WEBPACK_IMPORTED_MODULE_1_lodash_findIndex___default()(sections, function (blockEl) {
    return blockEl === target;
  });
  sections.some(function (field, index) {
    if (index > selectedIndex) {
      return true;
    }
    addFilledClassNames(field, block, inputElement, labelElement, filledModifier);
    return false;
  });
};

/**
 * Updates the title based on the element interacted with.
 * @private
 * @param {Event} e - Event object
 * @param {HTMLElement} titleEl - The title element
 */
var updateTitle = function updateTitle(e, titleEl) {
  /* eslint-disable no-param-reassign */
  var ratingText = e.currentTarget.dataset.ratingText;
  if (ratingText) {
    titleEl.textContent = ratingText;
  }
  /* eslint-enable no-param-reassign */
};

/**
 * Removes all filled modifiers.
 * @private
 * @param {HTMLElement} el - Contains the star ratings
 * @param {String} block - Block name containing the rating
 * @param {String} inputElement - Input element name with the rating value
 * @param {String} labelElement - Label element name with the rating content
 * @param {String} filledModifier - The filled modifier name
 */
var resetFilled = function resetFilled(el, block, inputElement, labelElement, filledModifier) {
  Array.from(el.querySelectorAll(".".concat(block))).forEach(function (field) {
    removeFilledClassNames(field, block, inputElement, labelElement, filledModifier);
  });
};

/**
 * Responsible for the basic interactivity around the fit rating scale. It
 * expects a set of radio inputs that represents the rating from the form. It
 * assumes the following DOM structure with defaults provided:
 *
 * @example
 * <fieldset>
 *   <legend>Some Title</legend>
 *   <div class="rating-scale-field" data-rating-text="So Lame">
 *     <input type="radio" name="rating-scale" value="1" id="1-star"
 *     class="rating-scale-field__input">
 *     <label for="1-star" class="rating-scale-field__label icon">1 Star</label>
 *   </div>
 *   <div class="rating-scale-field" data-rating-text="Sorta Stoked">
 *     <input type="radio" name="rating-scale" value="2" id="2-star"
 *     class="rating-scale-field__input">
 *     <label for="2-star" class="rating-scale-field__label icon">2 Star</label>
 *   </div>
 *   <div class="rating-scale-field" data-rating-text="Totally Stoked">
 *     <input type="radio" name="rating-scale" value="3" id="3-star"
 *     class="rating-scale-field__input">
 *     <label for="3-star" class="rating-scale-field__label icon">3 Star</label>
 *   </div>
 *   <div class="rating-scale-field" data-rating-text="Mind Blown">
 *     <input type="radio" name="rating-scale" value="4" id="4-star"
 *     class="rating-scale-field__input">
 *     <label for="4-star" class="rating-scale-field__label icon">4 Star</label>
 *   </div>
 * </fieldset>
 *
 * Whenever a star rating has been interacted with, it'll do the following:
 *
 * - Apply filled class names to all .rating-scale-field that appear before the
 *   selected choice
 * - Will update the title of the section based on the data-rating-text
 *   attribute
 * - Will naturally select the input as the value
 *
 * @see RATING_SCALE_OPTIONS
 * @param {HTMLElement} wrap - Contains the star ratings
 * @param {Object} options - Configurable options
 */
function ratingScale(wrap) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _$$extend = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.extend({}, RATING_SCALE_OPTIONS, options),
    block = _$$extend.block,
    inputElement = _$$extend.inputElement,
    labelElement = _$$extend.labelElement,
    filledModifier = _$$extend.filledModifier,
    titleSelector = _$$extend.titleSelector;
  var titleEl = wrap.querySelector(titleSelector);
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()(wrap).on('click', ".".concat(block), function (e) {
    var input = e.currentTarget.querySelector(".".concat(block, "__").concat(inputElement));
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()(wrap).find('.js-review-error__rating').hide();
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()(wrap).find('.form-section__title').removeClass('u-error');
    if (input !== e.target) {
      return;
    }
    resetFilled(wrap, block, inputElement, labelElement, filledModifier);
    updateTitle(e, titleEl);
    applyFilledState(wrap, e.currentTarget, block, inputElement, labelElement, filledModifier);
  });
}
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__lib_register_jquery_plugin__["a" /* default */])('ratingScale', ratingScale);

/***/ }),
/* 310 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export PLUGIN_NAME */
/* unused harmony export GLOBAL_CLASS */
/* unused harmony export GLOBAL_ACCOUNT_CLASS */
/* unused harmony export MAIN_NAV */
/* unused harmony export RICH_NAV_ID */
/* unused harmony export SUB_NAV_MENU */
/* unused harmony export MENU_WRAPPER */
/* unused harmony export CLICK_EVENT */
/* unused harmony export WOMENS_ENDPOINT_URL */
/* unused harmony export MENS_ENDPOINT_URL */
/* unused harmony export WOMENS_HOMEPAGE_URL */
/* unused harmony export MENS_HOMEPAGE_URL */
/* unused harmony export BEAUTY_HOMEPAGE_URL */
/* unused harmony export $burgerIcon */
/* unused harmony export $plpCatNavLink */
/* unused harmony export SPARKLE_ANIMATION_HTML */
/* unused harmony export DEFAULTS */
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_register_jquery_plugin__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_merge_options__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__src_scripts_modules_global_log_engagement__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__keyboard__ = __webpack_require__(3);
/**
 * Rich Nav - menus
 * @module richNav
 */







// Expose the function as a jQuery plugin for ease of use
var PLUGIN_NAME = 'richNav';
var GLOBAL_CLASS = '.js-global__nav';
var GLOBAL_ACCOUNT_CLASS = '.js-global__account';
// export const GLOBAL_ACCOUNT_SETTINGS_CLASS = '.js-global__account__settings';
var MAIN_NAV = '#rich-nav-container';
var RICH_NAV_ID = '#js-rich-nav';
var SUB_NAV_MENU = '.sub-menu__wrapper';
var MENU_WRAPPER = '.js-menu-wrapper';
var CLICK_EVENT = 'click';
var WOMENS_ENDPOINT_URL = '/r/ipadApp/MenuTree.jsp?deviceType=revolvemobile&loadAll=true&richNav=true';
var MENS_ENDPOINT_URL = '/r/ipadApp/MenuTree.jsp?deviceType=revolvemobile&d=Mens&loadAll=true&richNav=true';
var WOMENS_HOMEPAGE_URL = '/r/mobile/index_women.jsp';
var MENS_HOMEPAGE_URL = '/r/mobile/index_men.jsp';
var BEAUTY_HOMEPAGE_URL = '/content/lp/beauty/mobile/';
var $burgerIcon = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#tr-burger-icon');
var $plpCatNavLink = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#plp-category-nav-link');

// Sparkle animation HTML for "Build A Look" link
var SPARKLE_ANIMATION_HTML = "<span class=\"r-zelig__animation\">\n  <span class=\"icon r-zelig__animation-icon\">\n    <svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" aria-hidden=\"true\" focusable=\"false\" role=\"presentation\">\n      <path d=\"M20.7 20.7c-3.8-1.2-6.8-4.2-8.1-8.1l-.5-1.6c0-.2-.3-.4-.5-.4s-.4.2-.5.4l-.5 1.6c-1.3 3.9-4.3 6.9-8.1 8.1-.2 0-.4.3-.4.6s.2.5.4.6c3.8 1.2 6.8 4.2 8 8.1l.5 1.6c0 .2.3.4.5.4s.4-.2.5-.4l.5-1.6c1.3-3.9 4.3-6.9 8.1-8.1.2 0 .4-.3.4-.6s-.2-.5-.4-.6Z\"></path>\n      <path d=\"M25.9 12.8l.3-.9c.7-2.3 2.5-4 4.7-4.8.1 0 .2-.2.2-.3s0-.3-.2-.3C28.7 5.8 27 4 26.2 1.8l-.3-.9c0-.1-.2-.2-.3-.2s-.3 0-.3.2l-.3.9c-.7 2.3-2.5 4-4.7 4.8-.1 0-.2.2-.2.3s0 .3.2.3c2.2.7 4 2.5 4.7 4.7l.3.9c0 .1.2.2.3.2s.3 0 .3-.2Z\"></path>\n      <path d=\"M31.9 28c-1.3-.4-2.4-1.5-2.8-2.8l-.2-.5s0-.1-.2-.1-.2 0-.2.1l-.2.5c-.5 1.4-1.5 2.4-2.8 2.8 0 0-.1.1-.1.2s0 .2.1.2c1.3.4 2.4 1.5 2.8 2.8l.2.5s0 .1.2.1.2 0 .2-.1l.2-.5c.5-1.4 1.5-2.4 2.8-2.8 0 0 .1-.1.1-.2s0-.2-.1-.2Z\"></path>\n      <path d=\"M3.2 7.3s0 .1.2.1.2 0 .2-.1l.2-.5C4.3 5.4 5.3 4.4 6.6 4c0 0 .1-.1.1-.2s0-.2-.1-.2C5.3 3.2 4.2 2.1 3.8.8L3.6.3s0-.1-.2-.1-.2 0-.2.1L3 .8C2.5 2.2 1.5 3.2.2 3.6c0 0-.1.1-.1.2s0 .2.1.2c1.3.4 2.4 1.5 2.8 2.8l.2.5Z\"></path>\n    </svg>\n  </span>\n</span>";
var DEFAULTS = {
  swapClass: '',
  swapTarget: '',
  rnItem: '.js-rich-nav',
  returnFocus: '',
  trapFocusFunc: __WEBPACK_IMPORTED_MODULE_4__keyboard__["a" /* default */].trapFocus.bind(__WEBPACK_IMPORTED_MODULE_4__keyboard__["a" /* default */]),
  releaseFocusFunc: __WEBPACK_IMPORTED_MODULE_4__keyboard__["a" /* default */].releaseFocus.bind(__WEBPACK_IMPORTED_MODULE_4__keyboard__["a" /* default */])
};
var defaultMenuOpened = false;

/**
  * Set focus to first anchor in open side nav
  */
function openSideNavFocus(opts) {
  var $openSideNav = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.is--open').last();
  if ($openSideNav.length > 0) {
    var $firstListItem = $openSideNav.find('.nav-side__list').first();
    // Look for anchors, buttons, and elements with tabindex not set to -1
    var $firstListItemToFocus = $firstListItem.find('button, a, [tabindex]:not([tabindex="-1"])').eq(0);
    $firstListItemToFocus[0].focus();
    opts.trapFocusFunc($openSideNav);
  } else {
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#rich-nav-title').find('a').first().focus();
    if (window.rcProps.richNav && window.rcProps.richNav.richMenuState) {
      opts.trapFocusFunc(__WEBPACK_IMPORTED_MODULE_0_jquery___default()('#rich-nav-container'));
    } else {
      opts.trapFocusFunc(__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.main-menu__wrapper'));
    }
  }
}
/**
 * Lazy load images inside the rich navigation
 * @param {jQuery} $mainMenuContent - The container element (modal, menu, etc.)
 */
function lazyLoadImages() {
  var $mainMenuContent = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.main-menu__content');
  var $lazyImages = $mainMenuContent.find('img[data-lazy]');
  $lazyImages.each(function () {
    var $image = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this);
    var lazySrc = $image.data('lazy'); // Get the actual image URL from data-src
    if (lazySrc && $image.attr('src') !== lazySrc) {
      $image.attr('src', lazySrc); // Set the src to the actual image
      $image.removeAttr('data-src'); // Optionally remove data-src to prevent future checks
    }
  });
}
/**
  * Open Rich Nav
  */
function openSideNav(opts) {
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()(RICH_NAV_ID).parent().attr('aria-modal', 'true');
  // Set focus to the first element in the current sub nav
  openSideNavFocus(opts);
  lazyLoadImages();
}
/**
  * Close Rich Nav
  */
function closeSideNav(opts) {
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()(RICH_NAV_ID).parent().attr('aria-modal', 'false');
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#nav-side-page-wrapper').removeClass('nav__sidebar--open');
  opts.releaseFocusFunc(__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-menu-wrapper'), '');
}

/**
 * Create New Element
 * @param {Object} element - Elemnt used for generating New Element
 */
function createNode(element) {
  return document.createElement(element);
}
/**
 * Create New Element
 * @param {Object} parent - Parent element that items get appended to
 * @param {Object} el - Element that is appended to the parent
 */
function appender(parent, el) {
  return parent.appendChild(el);
}
function getTranslatedText(text) {
  if (!window.rcProps.richNav.textFields[text]) {
    return text;
  }
  return window.rcProps.richNav.textFields[text];
}
/**
  * Create Close Menu button
  */
function closeMenuBtn() {
  var closeButton = createNode('button');
  closeButton.className = 'js-rich-nav-close nav-side__item--close-btn action-button action-button--full u-padding-a--md';
  closeButton.innerHTML = getTranslatedText('Close Menu');
  var closeBtnWrapper = createNode('li');
  closeBtnWrapper.className = 'nav-side__item nav-side__item--close';
  appender(closeBtnWrapper, closeButton);
  return closeBtnWrapper;
}
/**
* Clone Element
* @param {Object} element - Element to clone
*/
function cloneElement(element) {
  return __WEBPACK_IMPORTED_MODULE_0_jquery___default()(element).clone(true);
}

/**
* Error Handler
* @param {Object} response - response
*/
function handleErrors(response) {
  if (!response.ok) {
    throw Error(response.statusText);
  }
  return response;
}
function getCurrentMenuDep() {
  if (window.rcProps.richNav && window.rcProps.richNav.richMenuState) {
    var match = window.rcProps.richNav.richMenuState[0].match(/\.(.*?)-/);
    if (match) {
      return match[1]; // womens, beauty, or mens
    }
  }
  return 'womens'; // default dep
}
function openDefaultMenu() {
  if (window.rcProps.richNav && window.rcProps.richNav.richMenuState) {
    var currentOpenMenus = window.rcProps.richNav.richMenuState;
    var i = 0;
    var parentSelector = RICH_NAV_ID;
    var tabName = getCurrentMenuDep();
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#".concat(tabName, "-tab-link")).click(); // open correct tab
    for (i = tabName === 'womens' ? 0 : 1; i < currentOpenMenus.length; i += 1) {
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()(parentSelector).find("button[data-swap-target=\"".concat(currentOpenMenus[i], "\"]")).not('.return-link').click();
      parentSelector = currentOpenMenus[i];
    }
  }
}

// Method to close all submenus
function removeAllSubMenus() {
  var mainMenuContent = document.querySelector('.main-menu__content');
  var elements = document.querySelectorAll('.sub-menu__wrapper');
  mainMenuContent.classList.remove('u-hide');
  elements.forEach(function (element) {
    element.classList.remove('is--open');
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()(element).children().addClass('u-hide'); // hide for a11y - beauty revieve banner issue
  });
}
function hidePreviousContent($subNavContainer, $mainContentWrapper, isBackButton) {
  $subNavContainer.on('transitionend webkitTransitionEnd oTransitionEnd', function () {
    if ($mainContentWrapper) {
      $mainContentWrapper.addClass('u-hide');
    } else {
      $subNavContainer.find('.sub-menu__list').addClass('u-hide');
      $subNavContainer.children().addClass('u-hide'); //  hide for a11y - Beauty Revieve Banner issue
    }
    if (isBackButton) {
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#rich-nav-container').children().last().remove();
      $subNavContainer.find('.sub-menu__list').addClass('u-hide'); // hide for a11y
    }
    $subNavContainer.off('transitionend webkitTransitionEnd oTransitionEnd');
  });
}

/**
 * Toggle Class
 * @param {Object} options - Options used for wiring up the List
 */
function toggleMenuClass($el, $currentElement) {
  var dataSwapTarget = __WEBPACK_IMPORTED_MODULE_0_jquery___default()($currentElement).data('swapTarget');
  var isBackButton = $currentElement.hasClass('js-rich-nav-back');
  // If a data-swap-target attribute was used instead of href
  if (isBackButton) {
    // back level
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()(dataSwapTarget).last().find('.sub-menu__list').removeClass('u-hide');
    var $subNavContainer = $currentElement.closest('.sub-menu__wrapper');
    hidePreviousContent($subNavContainer, null, isBackButton);
    $currentElement.closest('.sub-menu__wrapper').removeClass('is--open');
  } else if (!isBackButton) {
    // next level
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()(dataSwapTarget).addClass('is--open');
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()(dataSwapTarget).find('.sub-menu__list').removeClass('u-hide');
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()(dataSwapTarget).children().removeClass('u-hide'); // hide for a11y - Beauty Revieve Banner issue
    var $mainContentWrapper = $currentElement.closest('.main-menu__content');
    if ($mainContentWrapper.length) {
      hidePreviousContent(__WEBPACK_IMPORTED_MODULE_0_jquery___default()(dataSwapTarget), $mainContentWrapper);
    }
  }
}
/**
 * Scroll Element to Top
 * @param {Object} element - Element that is being checked
 */
function scrollToTop(element) {
  element.animate({
    scrollTop: 0
  }, 'fast');
}
/**
 * Build Wrapper Element - ie: div
 * @param {Object} elem - Elemnt used for generating New Element
 * @param {Object} dataElement - Data element that is being checked
 * @param {string} parentListDataId - string representing parent id attribute
 */
function buildWrapperElement(elem, dataElement, dataId) {
  var el = createNode("".concat(elem));
  el.className = "sub-menu__wrapper js-menu-wrapper ".concat(dataId, "-menu__").concat(dataElement);
  var fasterSubMenuClass = window.rcProps.richNav.fasterSubMenuAnimationClass;
  if (fasterSubMenuClass) {
    el.className = "".concat(el.className, " ").concat(fasterSubMenuClass);
  }
  el.dataset.element = "".concat(dataElement);
  return el;
}
/**
 * Global elements to clone
 */
function cloneGLobalElements() {
  var globalNav = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(GLOBAL_CLASS);
  var globalNavClone = cloneElement(globalNav);
  return globalNavClone;
}

/**
 * Global elements to clone
 */
function cloneGLobalAccountElements(isMens) {
  var globalAccountNav = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(GLOBAL_ACCOUNT_CLASS);
  var globalAccountNavClone = cloneElement(globalAccountNav);
  var myFavLink = globalAccountNavClone.find('.js-my-fav-link');
  var myFavHref = myFavLink.data('baseUrl');
  if (isMens) {
    myFavLink.attr('href', "".concat(myFavHref, "&d=Mens&departmentFilter=Mens"));
  } else {
    myFavLink.attr('href', myFavHref);
  }
  return globalAccountNavClone;
}

/**
 * Global elements to clone
 */
// function cloneGLobalAccountSettingsElements() {
//   const globalAccountSettingsNav = $(GLOBAL_ACCOUNT_SETTINGS_CLASS);
//   const globalAccountSettingsNavClone = cloneElement(globalAccountSettingsNav);
//   globalAccountSettingsNavClone.find('.return-link').parent('li').remove();
//   return globalAccountSettingsNavClone;
// }
/**
 * Build List Element - ie: ul
 * @param {Object} elem - Elemnt used for generating New Element
 * @param {Object} dataElement - Data element that is being checked
 * @param {string} dataId - Data id of menu
 */
function buildListElement(elem, dataElement, dataId, nameDisplay) {
  var el = createNode("".concat(elem));
  if (dataId === 'beauty') {
    el.className = 'nav-side__list';
  } else {
    el.className = 'nav-side__list sub-menu__list';
  }

  // Set id to mens or womens - mens logic will be needed
  el.dataset.id = dataId;
  el.dataset.category = dataElement;
  el.dataset.nameDisplay = nameDisplay;
  return el;
}
/**
 * Build List Item Link - ie: li > a
 * @param {Object} elem - Elemnt used for generating New Element
 * @param {Object} dataElement - Data element that is being checked
 */
function buildListItemElement(elem) {
  var el = createNode("".concat(elem));
  el.className = 'nav-side__item';
  return el;
}
/**
 * Build List Item Link - ie: li > button
 * @param {Object} elem - Elemnt used for generating New Element
 * @param {Object} dataElement - Data element that is being checked
 */
function buildListItemButtonElement(dataElement, dataId, htmlContent, swapTargetID) {
  var el = createNode('button');
  el.className = 'nav-side__link nav-side__link--main return-link js-rich-nav js-rich-nav-back';
  el.dataset.swapClass = 'is--open';
  if (typeof swapTargetID !== 'undefined') {
    el.dataset.swapTarget = ".".concat(dataId, "-menu__").concat(swapTargetID);
  } else {
    el.dataset.swapTarget = ".".concat(dataId, "-menu__").concat(dataElement);
  }
  el.dataset.element = dataElement;
  el.innerHTML = htmlContent;
  return el;
}
/**
 * Build List Items and Links - ie: li > a
 * @param {Object} elem - Elemnt used for generating New Element
 * @param {Object} dataElement - Data element that is being checked
 */
function buildListItems(data, ul, dataElement, dataId, dataCategory, dataLevel) {
  var categories = {};
  if (dataElement === 'new' || dataCategory === 'new') {
    categories = data.filter(function (cat) {
      return cat.catName.toLowerCase() === 'new';
    });
  } else if ((dataElement === 'sale' || dataCategory === 'sale') && dataCategory !== 'beauty') {
    categories = data.filter(function (cat) {
      return cat.catName.toLowerCase() === 'sale';
    });
  } else if (dataElement === 'featured-shops' && dataCategory !== 'clothing' || dataCategory === 'featured-shops') {
    categories = data.filter(function (cat) {
      return cat.catName.toLowerCase() === 'featured shops';
    });
  } else if (dataElement === 'most-wanted' || dataCategory === 'most-wanted') {
    categories = data.filter(function (cat) {
      return cat.catName.toLowerCase() === 'most wanted';
    });
  } else if (dataElement === 'what-to-wear' && dataCategory !== 'clothing') {
    categories = data.filter(function (cat) {
      return cat.catName.toLowerCase() === 'what to wear';
    });
  } else if (dataElement === 'festival') {
    categories = data.filter(function (cat) {
      return cat.catName.toLowerCase() === 'festival';
    });
  } else {
    categories = data.filter(function (cat) {
      return cat.catName.toLowerCase() === 'categories';
    });
  }
  var subCategories = categories[0].subCategoryList;
  var links;
  // if level one go deeper and get sub sub categories
  if (dataLevel === '1' && dataCategory !== 'sale') {
    // should check parent/category
    var subSubCats = subCategories.filter(function (item) {
      return item.catName.replace(/[^A-Z0-9]/ig, '-').toLowerCase() === dataCategory;
    });
    var subSubSubLinks = subSubCats[0].subCategoryList;

    // links = subSubLinks[0].subCategoryList;
    var deepLinks = subSubSubLinks.filter(function (item) {
      return item.catName.replace(/[^A-Z0-9]/ig, '-').toLowerCase() === dataElement;
    });
    links = deepLinks[0].subCategoryList;
  } else if (dataLevel === '2') {
    // CLEAN THIS UP CURRENTLY SPECIFIC TO BEAUTY
    var _subSubCats = subCategories.filter(function (item) {
      return item.catName.replace(/[^A-Z0-9]/ig, '-').toLowerCase() === 'beauty';
    });
    if (dataCategory === 'activewear' || dataCategory === 'swimsuits---cover-ups') {
      _subSubCats = subCategories.filter(function (item) {
        return item.catName.replace(/[^A-Z0-9]/ig, '-').toLowerCase() === 'clothing';
      });
    }
    if (dataCategory === 'home') {
      _subSubCats = subCategories.filter(function (item) {
        return item.catName.replace(/[^A-Z0-9]/ig, '-').toLowerCase() === 'home';
      });
      var subSubSubCats = _subSubCats[0].subCategoryList;
      var elementLinks = subSubSubCats.filter(function (item) {
        return item.catName.replace(/[^A-Z0-9]/ig, '-').toLowerCase() === dataElement;
      });
      links = elementLinks[0].subCategoryList;
    } else {
      var _subSubSubCats = _subSubCats[0].subCategoryList;
      var _deepLinks = _subSubSubCats.filter(function (item) {
        return item.catName.replace(/[^A-Z0-9]/ig, '-').toLowerCase() === dataCategory;
      });
      var deeperLinks = _deepLinks[0].subCategoryList;
      var superDeepLinks = deeperLinks.filter(function (item) {
        return item.catName.replace(/[^A-Z0-9]/ig, '-').toLowerCase() === dataElement;
      });
      links = superDeepLinks[0].subCategoryList;
    }
  } else {
    // Go deeper if it's not New
    var _subSubCats2;
    if (dataElement !== 'new' && dataElement !== 'sale' && dataElement !== 'featured-shops' && dataElement !== 'most-wanted' && dataElement !== 'what-to-wear' && dataElement !== 'festival') {
      _subSubCats2 = subCategories.filter(function (item) {
        return item.catName.replace(/[^A-Z0-9]/ig, '-').toLowerCase() === dataElement;
      });
      links = _subSubCats2[0].subCategoryList;
    } else {
      _subSubCats2 = subCategories;
      if (dataElement === 'new') {
        // Get Arrival Dates subCategory List
        var arrivalSubCats = _subSubCats2[0].subCategoryList;
        // FIlter down to Category Names
        var arrivalLinksArray = arrivalSubCats.filter(function (item) {
          return item.catName;
        });
        // Get Category Array from "new"
        var category = _subSubCats2[1];
        // Push category on to arrival dates links
        arrivalLinksArray.push(category);
        if (_subSubCats2.length > 2) {
          var designer = _subSubCats2[2];
          arrivalLinksArray.push(designer);
        }

        // Set links to Arrivals links array
        links = arrivalLinksArray;
      } else {
        links = _subSubCats2;
      }
    }
  }
  links = links.filter(function (link) {
    return link !== undefined;
  });
  // create html markup for list items
  links.map(function (link) {
    var categoryName = link.catName.replace(/[^A-Z0-9]/ig, '-');
    // create list items for anchor tags
    var li = createNode('li');
    li.className = 'nav-side__item';
    if (link.isSubHeader) {
      li.className = 'nav-side__item nav-side__item--sub-title';
    }

    // create anchor tags or button tag
    var a = createNode('a');
    var btn = createNode('button');
    if (link.subCategoryList === undefined) {
      a.className = 'nav-side__link';
      a.href = link.href;
      if (link.catName.toLowerCase() === 'build a look') {
        a.innerHTML = link.nameDisplay + SPARKLE_ANIMATION_HTML;
      } else {
        a.innerHTML = link.nameDisplay;
      }
      if (link.isSubHeader) {
        li.innerHTML = link.nameDisplay;
      } else {
        appender(li, a);
      }
    } else {
      // create a button
      btn.className = 'nav-side__link nav-side__link--category js-rich-nav';
      btn.dataset.swapClass = 'is--open';
      btn.dataset.swapTarget = ".".concat(dataId, "-menu__").concat(categoryName);
      btn.dataset.element = categoryName;
      btn.dataset.level = link.level;
      btn.innerHTML = link.nameDisplay;
      appender(li, btn);
    }
    appender(ul, li);
    return true;
  });
}
/**
 * Create New Navigation Menu
 * @param {Object} $currentElement - Elemnt used for generating New Menu
 */
function generateMarkup($currentElement, dataElement, properDataElement, dataLevel, dataCategory, properDataCategory, $parentList, parentListDataId, parentWrapperElement, wrapperHeight, lastWrapperHeight) {
  // create div wrapper for ul list and set height
  var div = buildWrapperElement('div', dataElement, parentListDataId, wrapperHeight, lastWrapperHeight);
  // create ul for list items with classes
  var ul = buildListElement('ul', dataElement, parentListDataId, $currentElement.html());
  // Add ul to wrapping div
  appender(div, ul);
  // clone my account and customer care list
  if (__WEBPACK_IMPORTED_MODULE_0_jquery___default()(GLOBAL_CLASS)[0]) {
    var globalNavigation = cloneGLobalElements();
    // Add My Account and Cutomer care after ul
    if ($currentElement.html() !== 'My Settings') {
      var globalAccountNavigation = cloneGLobalAccountElements(parentListDataId === 'mens');
      appender(div, globalAccountNavigation[0]);
    }
    appender(div, globalNavigation[0]);
    // if ($(GLOBAL_ACCOUNT_SETTINGS_CLASS)[0]) {
    //   const globalAccountSettingsNavigation = cloneGLobalAccountSettingsElements();
    //   appender(div, globalAccountSettingsNavigation[0]);
    // }
  }
  if (parentListDataId === 'beauty' && dataCategory === '') {
    // create 'main menu' back link for beauty menu as it is dynamically built menu
    var li = buildListItemElement('li');
    var btn = buildListItemButtonElement(dataElement, parentListDataId, getTranslatedText('main menu'));
    appender(li, btn);
    appender(ul, li);
  }

  // create category back Link
  if (dataCategory !== '') {
    var categoryLink = buildListItemElement('li');
    categoryLink.classList.add('nav-side__link--main');
    var categoryButton = buildListItemButtonElement(dataElement, parentListDataId, $parentList[0].dataset.nameDisplay, $parentList[0].dataset.category);
    appender(categoryLink, categoryButton);
    appender(ul, categoryLink);
  }

  // create subCategory List Item without hyphens for display purposes
  var subCategoryLink = buildListItemElement('li');
  if ($currentElement.html() && ($currentElement.html().toLowerCase() === getTranslatedText('beauty') || $currentElement.html().toLowerCase() === getTranslatedText('collections'))) {
    var subCategoryListItem = createNode('a');
    if ($currentElement.html().toLowerCase() === getTranslatedText('beauty')) {
      subCategoryListItem.className = 'nav-side__link nav-side__link--main js-rich-nav-hp js-rich-nav-beauty js-active';
      subCategoryListItem.href = '/content/lp/beauty/mobile/?navsrc=main_hm';
    } else {
      subCategoryListItem.className = 'nav-side__link nav-side__link--main';
      subCategoryListItem.href = '/content/lp/collections-shop/mobile/?navsrc=main_hm';
    }
    subCategoryListItem.innerHTML = $currentElement.html();
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()(subCategoryListItem).click(window.richNavHpClickHandler);
    appender(subCategoryLink, subCategoryListItem);
  } else {
    var _subCategoryListItem = createNode('span');
    _subCategoryListItem.className = 'nav-side__link nav-side__link--no-link nav-side__link--main';
    _subCategoryListItem.innerHTML = $currentElement.html();
    appender(subCategoryLink, _subCategoryListItem);
  }
  appender(ul, subCategoryLink);

  // Append revieve banner if available
  if (parentListDataId === 'beauty') {
    fetch(window.rcProps.richNav.revieveBannerHref).then(handleErrors).then(function (response) {
      return response.text();
    }).then(function (data) {
      if (data) {
        ul.insertAdjacentHTML('afterend', data);
      }
    })["catch"](function (error) {
      // eslint-disable-next-line no-console
      console.log(error);
    });
  }

  // Set proper variables for mens and womens data
  var endpoint = parentListDataId === 'womens' || parentListDataId === 'beauty' ? WOMENS_ENDPOINT_URL : MENS_ENDPOINT_URL;
  var storeData = parentListDataId === 'womens' || parentListDataId === 'beauty' ? 'womens-data' : 'mens-data';
  if (sessionStorage.getItem(storeData)) {
    var data = JSON.parse(sessionStorage.getItem(storeData));
    // Build List Items from data object in local storage
    buildListItems(data, ul, dataElement, parentListDataId, dataCategory, dataLevel);
    var closeMenu = closeMenuBtn();
    appender(ul, closeMenu);
  } else {
    // const womensData = getEndpoint(WOMENS_ENDPOINT_URL);
    fetch(endpoint, {
      credentials: 'same-origin'
    }).then(handleErrors).then(function (response) {
      return response.json();
    }).then(function (data) {
      // Build List Items from data object
      buildListItems(data, ul, dataElement, parentListDataId, dataCategory, dataLevel);
      // Create and Append Close Menu button
      var closeMenu = closeMenuBtn();
      appender(ul, closeMenu);
      // set data in local storage
      sessionStorage.setItem(storeData, JSON.stringify(data));
    })["catch"](function (error) {
      console.log(error); // eslint-disable-line no-console
    });
  }
  lazyLoadImages();
  return div;
}
function updateUrlTracking(el, urlTrackingKey, urlTrackingValue) {
  if (!el || !urlTrackingKey) {
    return;
  }
  if (el.nodeName === 'A') {
    var href = el.getAttribute('href');
    if (href) {
      var url = new URL(href, window.location.origin);
      if (url.searchParams.has(urlTrackingKey)) {
        url.searchParams.set(urlTrackingKey, urlTrackingValue);
        el.setAttribute('href', url.pathname + url.search + url.hash);
      }
    }
  }
  if (el.children) {
    for (var i = 0; i < el.children.length; i += 1) {
      updateUrlTracking(el.children[i], urlTrackingKey, urlTrackingValue);
    }
  }
}

/**
/**
 * Handles the click event when a Menu Item has been interacted with.
 * @private
 * @param {jQuery.Event} evt - A jQuery event
 * @param {HTMLElement} currentTarget - The current target interacted with
 * @param {jQuery} $el - Containing the elements for the accordion
 * @param {Object} opts - Options passed along from initialization
 */
var itemClickHandler = function itemClickHandler(_ref, $el, wrapperHeight, opts) {
  var currentTarget = _ref.currentTarget;
  var $currentElement = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(currentTarget);
  // Get current parent ul div wrapper data element
  var parentWrapperElement = $currentElement.closest('.js-menu-wrapper')[0].dataset.element;
  // Get current parent ul
  var $parentList = $currentElement.parents('ul');
  var dataLevel = $currentElement.attr('data-level');
  var dataElement = $currentElement.attr('data-element').replace(/[^A-Z0-9]/ig, '-').toLowerCase(); // current element clicked
  // generate the proper classes and data for menus
  // Get current parent ul category data attribute
  var dataCategory = $parentList[0].dataset.category;
  // Some links are in multiple places (e.g., top-level and under Accessories)
  // Keep it consistent by only generating top-level
  var isDresses = dataElement === 'dresses';
  var fromClothingCategory = dataCategory === 'clothing';
  if (fromClothingCategory && isDresses) {
    $parentList = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#womens-menu__content').children('ul'); // dresses are available for women's dep only
    dataCategory = $parentList && $parentList.length > 0 ? $parentList[0].dataset.category : '';
    dataLevel = 0;
  }
  var properDataCategory = dataCategory.replace(/-{3}/ig, ' & ').replace(/-/ig, ' ');
  // Get current parent ul id data attribute
  var parentListDataId = $parentList[0].dataset.id;
  var properDataElement = dataElement.replace(/-{3}/ig, ' & ').replace(/-/ig, ' ');
  // Object Level value
  var swapTarget = $currentElement.data('swapTarget');
  var subMenu = $el.find(swapTarget);
  // Get height of last sub menu
  var lastWrapperHeight = $currentElement.parents(SUB_NAV_MENU).outerHeight(true);
  // Release trap focus
  opts.releaseFocusFunc(__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-menu-wrapper'), __WEBPACK_IMPORTED_MODULE_0_jquery___default()(opts.returnFocus));
  if (defaultMenuOpened) {
    // Log engagement here (instead of the end of the function) since there are early returns
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__src_scripts_modules_global_log_engagement__["b" /* logEngagementWithDetails */])(window.location.href, 'hamburger_inner_menu', 'click', JSON.stringify({
      from: dataCategory,
      to: $currentElement.hasClass('js-rich-nav-back') ? 'back' : dataElement
    }));
  }

  // if clicking womens or main menu
  if ($currentElement.html() === getTranslatedText('womens') || $currentElement.html() === getTranslatedText('main menu') || $currentElement.data('returnToMain')) {
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.main-menu__content').removeClass('u-hide');
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()(SUB_NAV_MENU).removeClass('is--open');
    hidePreviousContent(__WEBPACK_IMPORTED_MODULE_0_jquery___default()(SUB_NAV_MENU));
    openSideNavFocus(opts);
    return;
  }
  if ($currentElement.html() === getTranslatedText('beauty') && dataCategory && dataCategory !== 'beauty') {
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.main-menu__content').removeClass('u-hide');
    // $('.sub-menu__wrapper').not('.beauty-menu__beauty').removeClass('is--open');
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()(SUB_NAV_MENU).removeClass('is--open');
    hidePreviousContent(__WEBPACK_IMPORTED_MODULE_0_jquery___default()(SUB_NAV_MENU));
    openSideNavFocus(opts);
    return;
  }
  if ($currentElement.html() === getTranslatedText('mens') && dataCategory && dataCategory !== 'mens') {
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.main-menu__content').removeClass('u-hide');
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()(SUB_NAV_MENU).removeClass('is--open');
    hidePreviousContent(__WEBPACK_IMPORTED_MODULE_0_jquery___default()(SUB_NAV_MENU));
    openSideNavFocus(opts);
    return;
  }
  if ($currentElement.html() === 'My Settings') {
    var $subNavContainer = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(SUB_NAV_MENU).not('.menu__my-settings');
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.main-menu__content').removeClass('u-hide');
    $subNavContainer.removeClass('is--open');
    hidePreviousContent($subNavContainer);
    openSideNavFocus(opts);
    // return;
  }
  if ($currentElement.html() === 'Information' || $currentElement.html() === 'Customer Care' || $currentElement.html() === 'My Revolve') {
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()(SUB_NAV_MENU).removeClass('is--open');
  }
  if (dataElement === 'beauty') {
    parentListDataId = 'beauty';
  }
  var $currentList;
  // Conditional to check if menu is already built
  if (!subMenu.length) {
    // if subMenu does not exist build it - subMenuListId !== parentListDataId
    var newList = generateMarkup($currentElement, dataElement, properDataElement, dataLevel, dataCategory, properDataCategory, $parentList, parentListDataId, parentWrapperElement, wrapperHeight, lastWrapperHeight, opts);
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()(MAIN_NAV).append(newList);
    var $newList = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(newList);
    // setTimeout allows for the slide in effect to occur
    setTimeout(function () {
      var $subNavList = $currentElement.closest('.nav-side__list');
      var $mainContent = $currentElement.closest('.main-menu__content').length;
      if ($mainContent) {
        hidePreviousContent(__WEBPACK_IMPORTED_MODULE_0_jquery___default()(newList), __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.main-menu__content'));
      } else {
        hidePreviousContent(__WEBPACK_IMPORTED_MODULE_0_jquery___default()(newList), $subNavList);
      }
      $newList.addClass('is--open');
    }, 200);
    scrollToTop($el);
    $currentList = $newList;
  } else {
    // Check if Existing Menu has global elements
    if (!subMenu.find(GLOBAL_CLASS).length) {
      if (__WEBPACK_IMPORTED_MODULE_0_jquery___default()(GLOBAL_CLASS)[0]) {
        // check if any gloabl menus are present
        // clone my account and customer care list
        var globalNavigation = cloneGLobalElements();
        if ($currentElement.html() !== 'My Settings') {
          var globalAccountNavigation = cloneGLobalAccountElements(parentListDataId === 'mens' || dataElement === 'mens');
          appender(subMenu[0], globalAccountNavigation[0]);
        }
        appender(subMenu[0], globalNavigation[0]);
      }
    }
    toggleMenuClass($el, $currentElement, wrapperHeight, lastWrapperHeight, opts);
    scrollToTop($el);
    // .is--open added in toggleMenuClass but there are (often) 2 elements so get the last one
    $currentList = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-menu-wrapper.is--open').last();
  }

  // BI wants different tracking if clicking through Clothing vs Dresses top-level
  if ($currentList.length > 0 && isDresses) {
    var navSrc = fromClothingCategory ? 'subClothing' : 'subDresses';
    updateUrlTracking($currentList[0], 'navsrc', navSrc);
  }
  setTimeout(function () {
    // Get the last sub menu with the class of is--open
    openSideNavFocus(opts);
  }, 400);
  // Hacky way to help with categories that are in multiple levels.
  // It gets the data-swap-target of the clicked category, before going to next level
  // Then, it replaces the back button's data-swap-target
  var isBackButton = $currentElement.hasClass('js-rich-nav-back');

  // getDataCategory was added because in the main menu wrapper (.main-menu__wrapper)
  // there's a class womens-menu__womens,
  // and this classes is used as well in Women's category level.
  // so the check ensures that it won't go straight to the main menu if you're clicking back if
  // you're deep into multiple categories.
  var getDataCategory = $currentElement.closest('.sub-menu__list').data('category');
  if (!isBackButton && getDataCategory !== 'womens') {
    var getDataId = $currentElement.closest('.sub-menu__list').data('id');
    var dataSwapTarget = $currentElement.data('swapTarget');
    var getDataElement = $currentElement.closest('.js-menu-wrapper').data('element');
    if (!getDataElement) return;
    // this grabs the main text from the menu, the text is always at the second li element.
    var getText = $currentElement.closest('.js-menu-wrapper').find('ul').children('li').eq(1).text();
    var newSwapTarget = ".".concat(getDataId, "-menu__").concat(getDataElement);
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()(dataSwapTarget).find('.js-rich-nav-back').data('swapTarget', newSwapTarget).html(getText);
  }
};

/**
 * Bind a keyup event to the document to listen for the Escape key.
 * If pressed, it will close the side nav and focus the burger icon.
 * @param  {Object} opts - Object containing the releaseFocusFunc & returnFocus string
 * @return {undefined}
 */
function bindEscKeyEventOnOpenSideNav(event, opts) {
  var $elTarget = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(event.target);
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).on('keyup.closeSideNav', function (e) {
    if (e.key === 'Escape') {
      // escape key maps to keycode `27`
      if (__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.nav__sidebar--open').length === 0) return;
      // return focus to element that triggered the rich nav
      $elTarget.focus();
      closeSideNav(opts);
      unbindEscKeyEvent();
    }
  });
}

/**
 * Unbinds the keyup event handler from the document.
 * @return {undefined}
 */
function unbindEscKeyEvent() {
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).off('keyup.closeSideNav');
}

/**
 * Applies any sort of event handlers for the richNav.
 * @param  {jQuery} $el - link
 * @param  {Object} [options={}] - Any options provided upon initialization
 */
var applyEventHandlers = function applyEventHandlers($el, wrapperHeight) {
  var opts = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var rnItem = opts.rnItem;
  $el.on(CLICK_EVENT, rnItem, function (evt) {
    evt.preventDefault();
    itemClickHandler(evt, $el, wrapperHeight, opts);
  });
  // Open or Close Rich Nav
  $burgerIcon.on(CLICK_EVENT, function (e) {
    openSideNav(opts);

    // Close Rich Nav with Escape Key
    bindEscKeyEventOnOpenSideNav(e, opts);
  });

  // PLP Cateroy Rich Nav Link
  $plpCatNavLink.on(CLICK_EVENT, function (e) {
    openSideNav(opts);

    // Close Rich Nav with Escape Key
    bindEscKeyEventOnOpenSideNav(e, opts);
  });

  // Close side nav with Keyboard - Accessibility
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).on(CLICK_EVENT, '.js-rich-nav-close', function (e) {
    if (e.type === 'keydown' && e.key !== 'Enter') {
      return;
    }
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#tr-burger-icon').focus();
    closeSideNav(opts);
  });

  // Close Side Nav Sign In with Keyboard - Accessibility
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).on(CLICK_EVENT, '.js-signin-close', function (e) {
    if (e.type === 'keydown' && e.key !== 'Enter') {
      return;
    }
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#tr-burger-icon').focus();
    closeSideNav(opts);
  });

  // Close side nav with Overlay
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#js-nav-side__overlay').on(CLICK_EVENT, function () {
    closeSideNav(opts);
  });

  // close all sub menus when tabs are clicked
  $el.on(CLICK_EVENT, '.tabs__link', function (e) {
    if (e.type === 'keydown' && e.key !== 'Enter') {
      return;
    }
    removeAllSubMenus();
  });
};
function getMenuData(storeData, onDataGet) {
  if (sessionStorage.getItem(storeData)) {
    var data = JSON.parse(sessionStorage.getItem(storeData));
    onDataGet(data);
  } else {
    fetch(WOMENS_ENDPOINT_URL, {
      credentials: 'same-origin'
    }).then(handleErrors).then(function (response) {
      return response.json();
    }).then(function (data) {
      // set data in local storage
      sessionStorage.setItem(storeData, JSON.stringify(data));
      onDataGet(data);
    })["catch"](function (error) {
      console.log(error); // eslint-disable-line no-console
    });
  }
}
function buildBeautyTabMenuList(data) {
  var cats = data.find(function (obj) {
    return obj.id === '--categories--';
  });
  if (cats && cats.subCategoryList) {
    var beautyData = cats.subCategoryList.find(function (obj) {
      return obj && obj.id === '-c-beauty--';
    });
    if (beautyData && beautyData.subCategoryList) {
      var id = beautyData.category.toLowerCase();
      var category = id;
      var catName = getTranslatedText(beautyData.catName).toLowerCase();
      var ul = buildListElement('ul', id, category, catName);
      beautyData.subCategoryList.forEach(function (element) {
        var li = buildListItemElement('li');
        if (element.isSubHeader) {
          li.className = 'nav-side__item nav-side__item--sub-title';
          li.textContent = element.catName;
        } else if (element.subCategoryList) {
          var btn = createNode('button');
          var categoryName = element.catName.replace(/[^A-Z0-9]/ig, '-').toLowerCase();
          btn.className = 'nav-side__link nav-side__link--category js-rich-nav';
          btn.dataset.swapClass = 'is--open';
          btn.dataset.swapTarget = ".beauty-menu__".concat(categoryName);
          btn.dataset.element = categoryName;
          btn.dataset.level = element.level;
          btn.innerHTML = element.nameDisplay.toLowerCase();
          appender(li, btn);
        } else {
          var a = createNode('a');
          a.href = element.href;
          a.innerHTML = element.nameDisplay.toLowerCase();
          if (element.catName.toLowerCase() === 'holiday') {
            a.className = 'nav-side__link u-color-holiday';
          } else {
            a.className = 'nav-side__link';
          }
          appender(li, a);
        }
        appender(ul, li);
      });
      appender(__WEBPACK_IMPORTED_MODULE_0_jquery___default()('#beauty-menu__content')[0], ul);
    }
  }
}
function getBeautyTabContent() {
  var $beautyMenuContent = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#beauty-menu__content');
  if ($beautyMenuContent.length && __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.trim($beautyMenuContent.html()) === '') {
    // The div is empty, add your logic here
    getMenuData('womens-data', buildBeautyTabMenuList);
  }
}

/**
* Initializes richNav.
* @param {HTMLElement} el - link
* @param {Object} options - Options used for wiring up the modal
* @see DEFAULTS
*/
function richNav(el) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var $el = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(el);
  var mainWrapper = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(MAIN_NAV);
  var wrapperHeight = mainWrapper.outerHeight(true);
  var opts = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__lib_merge_options__["a" /* default */])(DEFAULTS, options, $el);
  applyEventHandlers($el, wrapperHeight, opts);
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-tabs').tabs();
  getBeautyTabContent();
  defaultMenuOpened = false; // force `false` since was `true` after clicking via the rich nav
  openDefaultMenu();
  defaultMenuOpened = true; // turn on engagement tracking after the initial menu is "clicked"
}
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__lib_register_jquery_plugin__["a" /* default */])(PLUGIN_NAME, richNav);

/***/ }),
/* 311 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export PLUGIN_NAME */
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_register_jquery_plugin__ = __webpack_require__(1);


var PLUGIN_NAME = 'shippingOptionsFromBag';
var SWITCHED = false;
function splitTable(original) {
  original.wrap('<div class="table-wrapper" />');
  var copy = original.clone(true, true);
  original.wrap('<div class="scrollable" />');
  original.css({
    'margin-left': copy.width()
  });
  copy.css({
    width: copy.width()
  });
}
function unsplitTable(original) {
  original.closest('.table-wrapper').find('.pinned').remove();
  original.css({
    'margin-left': 0
  });
  original.unwrap();
  original.unwrap();
}

// Responsive Tables
function updateTables() {
  if (__WEBPACK_IMPORTED_MODULE_0_jquery___default()(window).width() < 767 && !SWITCHED) {
    SWITCHED = true;
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()('table.responsive').each(function (i, element) {
      splitTable(__WEBPACK_IMPORTED_MODULE_0_jquery___default()(element));
    });
    return true;
  } else if (SWITCHED && __WEBPACK_IMPORTED_MODULE_0_jquery___default()(window).width() > 767) {
    SWITCHED = false;
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()('table.responsive').each(function (i, element) {
      unsplitTable(__WEBPACK_IMPORTED_MODULE_0_jquery___default()(element));
    });
  }
  return false;
}
function usTableInsert() {
  __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.get('../src/partials/shipping-options-us-table.html', function (data) {
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#shipContentBag').html(data);
    SWITCHED = false;
    updateTables();
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()(window).bind('resize', updateTables);
  });
}
function rowTableInsert() {
  __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.get('../src/partials/shipping-options-row-table.html', function (data) {
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#shipContentBag').html(data);
    SWITCHED = false;
    updateTables();
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()(window).bind('resize', updateTables);
  });
}
function shippingOptions(el) {
  var $el = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(el);
  SWITCHED = false;
  usTableInsert();
  $el.on('change', function switchRegion() {
    var regionTableId = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).find('option:selected').attr('id');
    if (__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.pinned').length === 1) {
      unsplitTable(__WEBPACK_IMPORTED_MODULE_0_jquery___default()('table.responsive'));
    }
    if (regionTableId === 'usTable') {
      usTableInsert();
    } else {
      rowTableInsert();
    }
  });
}

// Expose the function as a jQuery plugin for ease of use
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__lib_register_jquery_plugin__["a" /* default */])(PLUGIN_NAME, shippingOptions);

/***/ }),
/* 312 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export SLICK_ACTIVE_CLASSNAME */
/* unused harmony export KEYS */
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__slick_carousel__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__slick_carousel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__slick_carousel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_register_jquery_plugin__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__slick_custom_paging__ = __webpack_require__(120);




var SLICK_ACTIVE_CLASSNAME = 'slick-active';

/**
 * Takes any defaults coming from slick along with some additional
 * properties to override any builtin accessibility coming from slick.
 * @type {Object}
 */
var SLICK_ACCESSIBLE_OPTIONS = {
  accessibility: false,
  arrows: true,
  customPaging: __WEBPACK_IMPORTED_MODULE_3__slick_custom_paging__["a" /* default */],
  dots: false,
  dotsClass: 'slick-dots',
  dotsTagElement: 'ol',
  dotsWrapperSelector: '<nav />',
  focusOnSelect: true,
  slide: 'li'
};

/**
 * Strips any accessibility related attributes from the dots container since
 * they are incorrect.
 * @param {jQuery} $dots - Current dots container
 * @param {string} wrapperSelector - Used to wrap the dots
 */
var resetDotsWrapper = function resetDotsWrapper($dots, wrapperSelector) {
  return $dots.wrap(wrapperSelector).removeAttr('role');
};

/**
 * Strips any accessibility related attributes from the individual dots since
 * they are incorrect.
 * @param {jQuery} $dots - Current dots container.
 */
var resetDots = function resetDots($dots) {
  return $dots.find('li').removeAttr('aria-hidden role')
  // Use detach to keep the existing elements intact
  .detach();
};

/**
 * Creates the updated dots element and acquires all the existing attributes
 * from the current dots. Since element names are immutable, we create a new
 * element with the intention to remove it later on once all the high jacking is
 * complete.
 * @param {jQuery} $dots - Current dots container
 * @param {jQuery} $li - list items representing the dots
 * @param {string} tagElement - The tagName to use for the dots container
 * @returns {jQuery} - The updated dots
 */
var createUpdatedDots = function createUpdatedDots($dots, $li, tagElement) {
  var $ol = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(document.createElement(tagElement)).append($li);
  var attrs = Array.from($dots[0].attributes);
  attrs.forEach(function (_ref) {
    var nodeName = _ref.nodeName,
      nodeValue = _ref.nodeValue;
    $ol.attr(nodeName, nodeValue);
  });
  return $ol;
};

/**
 * Replaces the existing dots with an updated version that makes things more
 * "accessible".
 * @param {jQuery} $dots - Current dots container
 * @param {jQuery} $updatedDots - Updated dots container
 */
var insertUpdatedDots = function insertUpdatedDots($dots, $updatedDots) {
  return $dots.after($updatedDots).remove();
};

/**
 * Applies an active slide based on a slick listener. Since slick applies it's
 * active slider via the container and since said container referenced within
 * slick exists, we need to handle this manually. Yeah, lame, I know.
 * TODO: See if we can get a patch into slick so that we can remove a good of
 * this code here.
 * @param {jQuery} $li - List elements representing dots
 */
var applyActiveSlide = function applyActiveSlide($li) {
  return function (event, slick, currentSlide, nextSlide) {
    $li.eq(currentSlide).removeClass(SLICK_ACTIVE_CLASSNAME);
    $li.eq(nextSlide).addClass(SLICK_ACTIVE_CLASSNAME);
  };
};

/**
 * Applies focus on active slide
 * @param {jQuery} $li - List elements representing dots
 */
var applyActiveSlideFocus = function applyActiveSlideFocus($li) {
  return function (event, slick, currentSlide) {
    var slide = __WEBPACK_IMPORTED_MODULE_0_jquery___default()($li.eq(currentSlide).find('a').attr('href'));
    slide.focus();
  };
};

/**
 * Responsible for resetting accessibility applied by slick when dots have been
 * requested by the caller.
 * @param {jQuery} $el - Elements receiving carousel
 * @param {jQuery} $dots - Dots container
 * @param {string} dotsTagElement - tagName used for the dots
 * @param {string} dotsWrapperSelector - Selector used for wrapper the dots
 */
var resetDotsA11y = function resetDotsA11y($el, $dots, _ref2) {
  var dotsTagElement = _ref2.dotsTagElement,
    dotsWrapperSelector = _ref2.dotsWrapperSelector;
  resetDotsWrapper($dots, dotsWrapperSelector);
  var $li = resetDots($dots);
  var $updatedDots = createUpdatedDots($dots, $li, dotsTagElement);
  insertUpdatedDots($dots, $updatedDots);
  $el.on('beforeChange', applyActiveSlide($li));
  $el.on('afterChange', applyActiveSlideFocus($li));
};

/**
 * Looks for dots if configured properly.
 * @param {string} appendDots - Where to append dots
 * @param {string} dotsClass - className to apply to dots
 * @returns {jQuery} - Dots container
 */
var findDots = function findDots(_ref3) {
  var appendDots = _ref3.appendDots,
    dotsClass = _ref3.dotsClass;
  return __WEBPACK_IMPORTED_MODULE_0_jquery___default()(appendDots).find(".".concat(dotsClass))
  // There's a chance that the dots are hidden in the DOM, so make sure that
  // the dots are visible. In order to remove this, we would need to make
  // things such as modals either in script or template tags.
  .filter(':visible');
};

/**
 * Human readable mapping of key codes for keyboard support.
 * @type {Object}
 */
var KEYS = {
  LEFT: 37,
  RIGHT: 39
};

/**
 * Adds custom keyboard support to the slick image carousel.
 * When carousel is in focus, left/right arrow keys rotate the images.
 * @param {jQuery} $el - Carousel element
 */
var addKeyboardSupport = function addKeyboardSupport($el) {
  $el.on('keydown', function (_ref4) {
    var which = _ref4.which;
    var LEFT = KEYS.LEFT,
      RIGHT = KEYS.RIGHT;
    switch (which) {
      case LEFT:
        $el.slick('slickPrev');
        break;
      case RIGHT:
        $el.slick('slickNext');
        break;
      default:
        break;
    }
  });
};
var countDots = function countDots(opts) {
  return findDots(opts).children().length;
};
var displayDots = function displayDots(dotCount, $dots, $el, opts) {
  if ($dots.length && dotCount > 1) {
    resetDotsA11y($el, $dots, opts);
  } else {
    $dots.hide();
  }
};

/**
 * Applies custom accessibility to slick since there are people out there who
 * feel that slick does accessibility incorrectly yet recommend it? Yeah, I'm
 * confused. Anyways, the goal of this work will override any accessibility
 * defaults provided by slick so they meet the need of UX-3936.
 * @see SLICK_ACCESSIBLE_OPTIONS
 * @param {HTMLElement} el - Element getting slick carousel
 * @param {Object} options - Configurable options
 */
function slickAccessible(el) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var opts = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.extend({}, SLICK_ACCESSIBLE_OPTIONS, options);
  var $el = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(el);
  var slickInstance = $el.slick(opts);
  var $dots = findDots(opts);
  var dotCount = countDots(opts);
  displayDots(dotCount, $dots, $el, opts);
  addKeyboardSupport($el);
  return slickInstance;
}
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__lib_register_jquery_plugin__["a" /* default */])('slickAccessible', slickAccessible);

/***/ }),
/* 313 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export PLUGIN_NAME */
/* unused harmony export DEFAULTS */
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__slick_carousel__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__slick_carousel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__slick_carousel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_register_jquery_plugin__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_merge_options__ = __webpack_require__(2);





// import slick from 'slick-carousel';
// Expose the function as a jQuery plugin for ease of use
// Expose the function as a jQuery plugin for ease of use
/**
* Merges together all the options and the various conditions in which they
* can be set.
* @param  {jQuery} $el - The container element
* @param  {Object} [options={}] - Any options provided upon initialization
* @return {Object} Immutable version of the options
*/

var initSlick = function initSlick($carouselTrack) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  $carouselTrack.slick({
    arrows: false,
    infinite: options.infinite,
    slidesToShow: options.numSlides,
    slidesToScroll: 1,
    touchThreshold: 20
  });
};
var getTrack = function getTrack($el) {
  return $el.find('.slick-carousel, .slick-carousel--extend').css({
    display: 'block'
  });
};
var PLUGIN_NAME = 'slickSlider';
var DEFAULTS = {
  infinite: true,
  numSlides: 3
};
function slickSlider(el) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var $el = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(el);
  var opts = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__lib_merge_options__["a" /* default */])(DEFAULTS, options, $el);
  var $carouselTrack = getTrack($el);
  initSlick($carouselTrack, opts);
}
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__lib_register_jquery_plugin__["a" /* default */])(PLUGIN_NAME, slickSlider);

/***/ }),
/* 314 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = slickArrow;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__image_carousel__ = __webpack_require__(115);


/**
 * Creates optional next/previous arrow buttons for slick carousel.
 * @param {string} element - BEM element name within image-carousel
 * @param {string} title - Title text and aria-label for svg icon
 * @param {string} svg - File name of the svg
 * @return {string} - HTML for button element
 */
function slickArrow(element, title, svg) {
  if (svg === 'arrow-right') {
    return "\n      <button type=\"button\" class=\"".concat(__WEBPACK_IMPORTED_MODULE_0__image_carousel__["b" /* BLOCK_NAME */], "__").concat(element, " u-hide\" aria-label=\"").concat(title, "\">\n        <span class=\"icon icon--sm icon--").concat(svg, "\">\n          <svg viewBox=\"0 0 16 16\" aria-hidden=\"true\" focusable=\"false\">\n            <path d=\"M6.25 12a.75.75 0 0 1-.51-1.3L8.648 8 5.74 5.3A.75.75 0 1 1 6.76 4.2l3.5 3.25a.75.75 0 0 1 0 1.1l-3.5 3.25a.749.749 0 0 1-.51.2z\"></path>\n          </svg>\n          <span class=\"u-screen-reader\">").concat(title, "</span>\n        </span>\n      </button>\n    ");
  }
  if (svg === 'arrow-left') {
    return "\n      <button type=\"button\" class=\"".concat(__WEBPACK_IMPORTED_MODULE_0__image_carousel__["b" /* BLOCK_NAME */], "__").concat(element, " u-hide\" aria-label=\"").concat(title, "\">\n        <span class=\"icon icon--sm icon--").concat(svg, "\">\n          <svg viewBox=\"0 0 16 16\" aria-hidden=\"true\" focusable=\"false\">\n            <path d=\"M9.75 12a.749.749 0 0 1-.51-.2l-3.5-3.25a.75.75 0 0 1 0-1.1l3.5-3.25a.75.75 0 0 1 1.02 1.1L7.352 8l2.908 2.7a.75.75 0 0 1-.51 1.3z\"/>\n          </svg>\n          <span class=\"u-screen-reader\">").concat(title, "</span>\n        </span>\n      </button>\n    ");
  }
  return "\n    <button type=\"button\" class=\"".concat(__WEBPACK_IMPORTED_MODULE_0__image_carousel__["b" /* BLOCK_NAME */], "__").concat(element, " u-hide\" aria-label=\"").concat(title, "\">\n      <span class=\"icon icon--sm icon--").concat(svg, "\">\n        <svg viewBox=\"0 0 16 16\" aria-hidden=\"true\" focusable=\"false\">\n          <use xmlns:xlink=\"http://www.w3.org/1999/xlink\" xlink:href=\"#icon-").concat(svg, "\"></use>\n        </svg>\n        <span class=\"u-screen-reader\">").concat(title, "</span>\n      </span>\n    </button>\n  ");
}
//

/***/ }),
/* 315 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export PLUGIN_NAME */
/* unused harmony export DEFAULTS */
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_throttle__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_throttle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_throttle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_merge_options__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__keyboard__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib_register_jquery_plugin__ = __webpack_require__(1);
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
/**
 * Fixed Nav.
 * @module header
 */






var PLUGIN_NAME = 'stickyNav';
var DEFAULTS = {
  stickyElement: '',
  topPosition: 0,
  navLinks: '.js-sticky-nav-link',
  sections: '.js-sticky-nav-section'
};
/**
 * Toggle .is-scrolled using IntersectionObserver
 * @param {jQuery} $html
 */
var initStickyObserver = function initStickyObserver($html) {
  var sentinel = document.querySelector('.sticky-nav-sentinel');
  if (!sentinel) return;
  var observer = new IntersectionObserver(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 1),
      entry = _ref2[0];
    $html.toggleClass('is-scrolled', !entry.isIntersecting);
  }, {
    threshold: 0
  });
  observer.observe(sentinel);
};

/**
 * Unfix Site's Header
 * @param  {jQuery} $el - header element
 */
var unStickyNav = function unStickyNav($el) {
  $el.css({
    position: 'static'
  });
};

/**
 * Make Navigation Sticky
 * @param {jQuery} $el - header element
 * @param {jQuery} $html - html element
 */
var setStickyPosition = function setStickyPosition($el) {
  $el.css({
    position: 'sticky'
  });
};

/**
 * Update Active Navigation Link
 * @param {jQuery} $el - header element
 * @param {jQuery} $window - window element
 * @param {Object} opts - options object
 */
var updateActiveNav = function updateActiveNav($el, $window, opts) {
  var navLinks = opts.navLinks,
    sections = opts.sections;
  var stickyNavHeight = $el.outerHeight();
  var windowScrollTop = $window.scrollTop();
  var sectionsArray = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(sections).toArray();
  sectionsArray.forEach(function (section) {
    var sectionTop = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(section).offset().top - stickyNavHeight - 50;
    var sectionBottom = sectionTop + __WEBPACK_IMPORTED_MODULE_0_jquery___default()(section).outerHeight();
    if (windowScrollTop >= sectionTop && windowScrollTop < sectionBottom) {
      var sectionId = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(section).attr('id');
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()(navLinks).removeClass('active');
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()("a[href=\"#".concat(sectionId, "\"]")).addClass('active');
    }
  });
};

/**
 * Handle Tab Scrolling
 * @param {Event} evt - event object
 * @param {jQuery} $el - header element
 * @param {Object} opts - options object
 */
var handleSectionScroll = function handleSectionScroll(evt, $el) {
  evt.preventDefault();
  var $sectionClicked = __WEBPACK_IMPORTED_MODULE_0_jquery___default()("".concat(evt.currentTarget.hash));
  var stickyNavHeight = $el.outerHeight();
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('html, body').animate({
    scrollTop: $sectionClicked.offset().top - stickyNavHeight
  }, 500);
};

/**
 * Update Scroll Position
 * @param {jQuery} $el - header element
 * @param {jQuery} $window - window element
 * @param {Object} opts - options object
 */
var scrollPositionHandler = function scrollPositionHandler($el, $window, opts) {
  updateActiveNav($el, $window, opts);
};

/**
 * Set Navigation Offset
 * @param {jQuery} $el - header element
 * @param {Object} opts - options object
 */
var setNavOffsetValue = function setNavOffsetValue($el, opts) {
  var topPosition = opts.topPosition;
  $el.css({
    top: "".concat(topPosition, "px")
  });
};

/**
 * Handle Tab Key Events
 * @param {jQuery} $el - header element
 * @param {Event} evt - key event
 */
var tabEventHandler = function tabEventHandler($el, evt) {
  if (['TAB', 'SHIFT_TAB'].includes(__WEBPACK_IMPORTED_MODULE_3__keyboard__["a" /* default */].parseKey(evt))) {
    unStickyNav($el);
  }
};

/**
 * Set Event Listeners
 * @param {jQuery} $el - header element
 * @param {jQuery} $html - html element
 * @param {jQuery} $window - window element
 * @param {jQuery} $body - body element
 * @param {Object} opts - options object
 */
var setEventListeners = function setEventListeners($el, $html, $window, opts) {
  var navLinks = opts.navLinks;
  $html.on('mousedown.stickyNav', function () {
    return setStickyPosition($el);
  });
  $html.on('keyup.stickyNav', function (evt) {
    return tabEventHandler($el, evt);
  });
  $window.on('scroll.stickyNav', __WEBPACK_IMPORTED_MODULE_1_lodash_throttle___default()(function () {
    return scrollPositionHandler($el, $window, opts);
  }, 100));
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()(navLinks).on('click', function (evt) {
    return handleSectionScroll(evt, $el);
  });
};

/**
 * Initialize Fixed Navigation
 * @param {HTMLElement} el - header element
 * @param {Object} options - options object
 */
function stickyNav(el) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var $html = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('html');
  var $window = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(window);
  var $el = DEFAULTS.stickyElement ? __WEBPACK_IMPORTED_MODULE_0_jquery___default()(DEFAULTS.stickyElement) : __WEBPACK_IMPORTED_MODULE_0_jquery___default()(el);
  var opts = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__lib_merge_options__["a" /* default */])(DEFAULTS, options, $el);
  setNavOffsetValue($el, opts);
  setEventListeners($el, $html, $window, opts);
  initStickyObserver($html);
}

// Register jQuery plugin
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib_register_jquery_plugin__["a" /* default */])(PLUGIN_NAME, stickyNav);

/***/ }),
/* 316 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export PLUGIN_NAME */
/* unused harmony export DEFAULTS */
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_scriptjs__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_scriptjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_scriptjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_register_jquery_plugin__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_merge_options__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib_props__ = __webpack_require__(11);
/**
 * Handles radios and checkboxes change event to toggle a class to a given element
 * @module swipeView
 */





// import { init } from 'browser-sync';

var HAMMERJS_FALLBACK = 'https://ajax.googleapis.com/ajax/libs/hammerjs/2.0.8/hammer.min.js';
var PLUGIN_NAME = 'swipeView';

/**
 * Makes a request for HammerJS.
 * @private
 * @return {Promise} Denotes when the request has been successfully executed
 */
var loadHammerJSFunc = function loadHammerJSFunc() {
  return new Promise(function (resolve) {
    __WEBPACK_IMPORTED_MODULE_1_scriptjs___default()(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib_props__["a" /* get */])('scripts.hammerJS', HAMMERJS_FALLBACK), function () {
      resolve(window.Hammer);
    });
  });
};
var DEFAULTS = {
  loadHammerJS: loadHammerJSFunc
};

/**
* Applies any sort of event handlers for the checkboxes or radios.
* @param  {jQuery} $el - checkbox / radio
* @param  {Object} [options={}] - Any options provided upon initialization
*/
var setEventListeners = function setEventListeners($el, hammertime) {
  var activeClass = 'active';
  hammertime.on('swiperight', function () {
    var isActive = $el.hasClass(activeClass);
    if (isActive) {
      $el.removeClass(activeClass);
    }
  });
  hammertime.on('swipeleft', function () {
    var isActive = $el.hasClass(activeClass);
    if (!isActive) {
      $el.addClass(activeClass);
    }
  });
};

/**
 * Applies any sort of event handlers for the checkboxes or radios.
 * @param  {jQuery} $el - checkbox / radio
 * @param  {Object} [options={}] - Any options provided upon initialization
 */
var initHammer = function initHammer($el, opts) {
  opts.loadHammerJS().then(function (Hammer) {
    var hammertime = new Hammer($el[0]);
    hammertime.get('swipe').set({
      direction: Hammer.DIRECTION_HORIZONTAL
    });
    setEventListeners($el, hammertime);
  });
};

/**
 * Initializes swipeView.
 * @param {HTMLElement} el - button /element that triggers swipeView
 * @param {Object} options - Options used for wiring up the swipeView
 * @param {Object} deregister - Performs a deregisteration on the plugin
 * @see DEFAULTS
 */
function swipeView(el) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var $el = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(el);
  var opts = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__lib_merge_options__["a" /* default */])(DEFAULTS, options, $el);
  initHammer($el, opts);
}
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__lib_register_jquery_plugin__["a" /* default */])(PLUGIN_NAME, swipeView);

/***/ }),
/* 317 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export PLUGIN_NAME */
/* unused harmony export DEFAULTS */
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery_lazy_plugins_jquery_lazy_ajax__ = __webpack_require__(353);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery_lazy_plugins_jquery_lazy_ajax___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_jquery_lazy_plugins_jquery_lazy_ajax__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_register_jquery_plugin__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_merge_options__ = __webpack_require__(2);
/**
 * Toggle classes
 * @module switchClass
 */






// Expose the function as a jQuery plugin for ease of use
var PLUGIN_NAME = 'switchClass';
var DEFAULTS = {
  switchClass: '',
  switchTarget: '',
  lazyLoadImg: 'false',
  ariaControls: '',
  ariaExpanded: '',
  isActive: function isActive() {}
};
/**
 * Applies any sort of event handlers for the switchClass.
 * @param  {jQuery} $el - link
 * @param  {Object} [options={}] - Any options provided upon initialization
 */
var setEventListeners = function setEventListeners($el) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var lazyLoadImg = options.lazyLoadImg;
  $el.on('click', function (evt) {
    evt.preventDefault();
    var $changingElClass = __WEBPACK_IMPORTED_MODULE_0_jquery___default()($el.attr('href'));
    // If a data-switch-target attribute was used instead of href
    if (options.switchTarget !== '') {
      $changingElClass = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(options.switchTarget);
    }
    $changingElClass.toggleClass(options.switchClass);
    if ($el.hasClass('switch-gift-expand')) {
      $el.removeClass(options.switchClass);
    }
    if ($changingElClass.hasClass(options.switchClass)) {
      options.isActive();
    }
    if (lazyLoadImg) {
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-lazy-switch-class').lazy({
        bind: 'event',
        effect: 'fadeIn',
        effectTime: 300
      });
    }
    if ($el.data('aria-expanded') && $el.data('aria-expanded') === 'true') {
      $el.attr('aria-expanded', false);
    } else if ($el.data('aria-expanded') && $el.data('aria-expanded') === 'false') {
      $el.attr('aria-expanded', true);
    }
  });
};
/**
 * Adds ARIA attributes.
 * @param {jQuery} $el - jQuery element object
 * @param {Object} options - Options used
 * @see DEFAULTS
 */
var addA11y = function addA11y($el) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  $el.attr('aria-controls', options.ariaControls);
  if ($el.data('aria-expanded') && $el.data('aria-expanded').length) {
    $el.attr('aria-expanded', options.ariaExpanded);
  }
};
/**
 * Initializes switchClass.
 * @param {HTMLElement} el - link
 * @param {Object} options - Options used for wiring up the modal
 * @see DEFAULTS
 */
function switchClass(el) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var $el = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(el);
  var opts = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__lib_merge_options__["a" /* default */])(DEFAULTS, options, $el);
  setEventListeners($el, opts);
  if (opts.ariaControls) {
    addA11y($el, opts);
  }
}
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__lib_register_jquery_plugin__["a" /* default */])(PLUGIN_NAME, switchClass);

/***/ }),
/* 318 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_register_jquery_plugin__ = __webpack_require__(1);
/**
 * Responsible for showing/hiding content based on a tab structure
 * @module modules/tabs
 */


var JS_TABS_DEFAULT_OPTIONS = {
  tab: '.tabs__link',
  tabContent: '.tabs__content',
  tabContentActive: 'tabs__content--active',
  tabActive: 'tabs__link--active'
};
var makeToggleTab = function makeToggleTab($tab, initialActiveClass, activeClass) {
  return function ($target) {
    $tab.removeClass(activeClass).find('.u-screen-reader').remove();
    $target.addClass(activeClass).append('<span class="u-screen-reader" aria-live="assertive"> has been selected</span>');
    if (initialActiveClass) {
      $tab.removeClass(initialActiveClass);
      $target.addClass(initialActiveClass);
    }
  };
};
var makeToggleContent = function makeToggleContent($content, tabContentActive) {
  return function ($target) {
    var contentSelector = $target.data('tab-content');
    var tabHorizontalScroll = $target.data('tab-horizontal-scroll');
    var imageLoaded = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(contentSelector).find('img').first().hasClass('loaded');
    $content.removeClass(tabContentActive);
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()(contentSelector).addClass(tabContentActive);
    if (tabHorizontalScroll && !imageLoaded) {
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()(window).trigger('scroll');
    }
  };
};
// LOGIC FOR AB TEST 789 START
// Added isFocusable for a native focus check since :focusable is not compatible with our jquery
var isFocusable = function isFocusable($el) {
  var el = $el[0];
  if (!el) return false;
  var focusableTags = ['A', 'INPUT', 'BUTTON', 'SELECT', 'TEXTAREA'];
  var tabIndex = el.getAttribute('tabindex');
  return !el.hasAttribute('disabled') && (focusableTags.includes(el.tagName) || tabIndex !== null);
};
// LOGIC FOR AB TEST 789 END
var tabs = function tabs(el) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var $el = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(el);
  var _Object$assign = Object.assign({}, JS_TABS_DEFAULT_OPTIONS, $el.data(), options),
    tab = _Object$assign.tab,
    tabContent = _Object$assign.tabContent,
    tabActive = _Object$assign.tabActive,
    tabContentActive = _Object$assign.tabContentActive;
  var $tab = $el.find(tab);
  var $content = $el.find(tabContent);
  var activeTabClass = $el.data('active-tab') ? $el.data('active-tab').replace('.', '') : false;
  var toggleTab = makeToggleTab($tab, activeTabClass, tabActive);
  var toggleContent = makeToggleContent($content, tabContentActive);
  $tab.on('click', function (e) {
    var $target = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(e.currentTarget);
    var tabUrl = $target.data('tab-url');
    var href = $target.attr('href');
    // LOGIC FOR AB TEST 789 STARTS
    // If the href starts with '#' and you want the browser to jump to that element:
    if (href && href.charAt(0) === '#' && href.length > 1 && $target.hasClass('js-anchor-scroll')) {
      toggleTab($target);
      toggleContent($target);
      // Allow the default behavior to update the URL hash and scroll to the element.
      // You can also manually scroll to the element if necessary:
      var $elementToFocus = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(href);
      if ($elementToFocus.length) {
        // Option 1: Let the default anchor behavior do its job by not preventing default.
        // Option 2: Or manually update the URL and scroll:
        var stickyNavHeight = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-sticky-nav').outerHeight() || 0;
        var elementTop = $elementToFocus.offset().top;
        var scrollTarget = elementTop - stickyNavHeight;
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()('html, body').animate({
          scrollTop: scrollTarget
        }, 400);
        // Set tabindex if not focusable
        if (!isFocusable($elementToFocus)) {
          $elementToFocus.attr('tabindex', '-1');
        }
        $elementToFocus.focus(); // Focus after scroll finishes
        window.history.pushState(null, '', href); // Update hash manually
      }
    }
    // LOGIC FOR AB TEST 789 END
    e.preventDefault();
    toggleTab($target);
    toggleContent($target);
    if (tabUrl && !$target.hasClass('loaded')) {
      __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.ajax({
        url: tabUrl,
        success: function success(response) {
          var contentSelector = $target.data('tab-content');
          var $tabContent = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(contentSelector);
          $tabContent.html(response).find('.horizontal-scroll').horizontalScroll();
          $target.addClass('loaded');
        }
      });
    }
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).trigger('tabs:click', $target.data('tab-content'));
  });
};
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__lib_register_jquery_plugin__["a" /* default */])('tabs', tabs);

/***/ }),
/* 319 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export PLUGIN_NAME */
/* unused harmony export DEFAULTS */
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_register_jquery_plugin__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_merge_options__ = __webpack_require__(2);
/**
 * Handles radios and checkboxes change event to toggle a class to a given element
 * @module toggleChange
 */




var PLUGIN_NAME = 'toggleChange';
var DEFAULTS = {
  ctToggleClass: '',
  ctSelector: '',
  ctInverse: false
};

/**
 * Return the input type of the element
 * @param  {jQuery} $el - checkbox / radio
 * @return {String} type of either checkbox or radio
 */
var inputType = function inputType($el) {
  return $el.attr('type');
};

/**
 * Return radio group
 * @param  {jQuery} $el - checkbox / radio
 * @return {jQuery} radio group
 */
var radioGroup = function radioGroup($el) {
  var groupName = $el.attr('name');
  return __WEBPACK_IMPORTED_MODULE_0_jquery___default()("input[type=\"radio\"][name=\"".concat(groupName, "\"]"));
};
var toggleClassHandler = function toggleClassHandler($el, action, opts) {
  if (action === 'add' && !opts.ctInverse || action === 'remove' && opts.ctInverse) {
    $el.addClass(opts.ctToggleClass);
  }
  if (action === 'remove' && !opts.ctInverse || action === 'add' && opts.ctInverse) {
    $el.removeClass(opts.ctToggleClass);
  }
};

/**
 * Applies any sort of event handlers for the checkboxes or radios.
 * @param  {jQuery} $el - checkbox / radio
 * @param  {Object} [options={}] - Any options provided upon initialization
 */
var setEventListeners = function setEventListeners($el) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var $selector = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(options.ctSelector);
  var type = inputType($el);
  if (type === 'radio') {
    var $radioGroup = radioGroup($el);
    var deselectEvent = "deselect-".concat($el.attr('name'));
    $radioGroup.on('click', function customDeselectEvent() {
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()("input[name=\"".concat(__WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).attr('name'), "\"]")).not(__WEBPACK_IMPORTED_MODULE_0_jquery___default()(this)).trigger(deselectEvent);
    });
    $el.on('change', function () {
      toggleClassHandler($selector, 'add', options);
    }).on(deselectEvent, function () {
      toggleClassHandler($selector, 'remove', options);
    });
  }
  if (type === 'checkbox') {
    $el.on('change', function (evt) {
      if (evt.currentTarget.checked) {
        toggleClassHandler($selector, 'add', options);
      }
      if (!evt.currentTarget.checked) {
        toggleClassHandler($selector, 'remove', options);
      }
    });
  }
};
/**
 * Set dom state if element is checked
 * @param  {jQuery} $el - checkbox / radio
 * @param  {Object} [options={}] - Any options provided upon initialization
 */
var setChecked = function setChecked($el) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var $selector = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(options.ctSelector);
  if ($el[0].checked && !options.ctInverse) {
    $selector.addClass(options.ctToggleClass);
  }
};
/**
 * Initializes toggleChange.
 * @param {HTMLElement} el - button /element that triggers toggleChange
 * @param {Object} options - Options used for wiring up the toggleChange
 * @param {Object} deregister - Performs a deregisteration on the plugin
 * @see DEFAULTS
 */
function toggleChange(el) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var $el = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(el);
  var opts = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__lib_merge_options__["a" /* default */])(DEFAULTS, options, $el);
  setEventListeners($el, opts);
  setChecked($el, opts);
}
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__lib_register_jquery_plugin__["a" /* default */])(PLUGIN_NAME, toggleChange);

/***/ }),
/* 320 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export PLUGIN_NAME */
/* unused harmony export CLICK_HANDLER */
/* unused harmony export CHANGE_HANDLER */
/* unused harmony export DEFAULTS */
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_register_jquery_plugin__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_merge_options__ = __webpack_require__(2);
/**
 * Toggle Display on click
 * @module toggleDisplay
 */




var PLUGIN_NAME = 'toggleDisplay';
var CLICK_HANDLER = 'click';
var CHANGE_HANDLER = 'change';
var DEFAULTS = {};

/**
 * Handle Toggling Event
 * @param  {jQuery} $el - button /element that toggles text
 * @param  {Object} [options={}] - Any options provided upon initialization
 */
var toggler = function toggler($el, TOGGLE_SHOW, TOGGLE_HIDE, ANIMATION_TYPE) {
  if (ANIMATION_TYPE === 'pop') {
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()(TOGGLE_SHOW).show();
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()(TOGGLE_HIDE).hide();
  } else {
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()(TOGGLE_SHOW).slideDown();
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()(TOGGLE_HIDE).slideUp();
  }
};
var selfToggler = function selfToggler($el, TOGGLE_THIS, ANIMATION_TYPE) {
  if (ANIMATION_TYPE === 'slide') {
    if ($el.hasClass('is-active')) {
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()(TOGGLE_THIS).slideUp();
      $el.removeClass('is-active');
    } else {
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()(TOGGLE_THIS).slideDown();
      $el.addClass('is-active');
    }
  } else if (ANIMATION_TYPE === 'pop') {
    if ($el.hasClass('is-active')) {
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()(TOGGLE_THIS).hide();
      $el.removeClass('is-active');
    } else {
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()(TOGGLE_THIS).show();
      $el.addClass('is-active');
    }
  }
};
var setEventListeners = function setEventListeners($el, TOGGLE_THIS, TOGGLE_SHOW, TOGGLE_HIDE, ANIMATION_TYPE, options) {
  $el.on(CLICK_HANDLER, function (event) {
    event.preventDefault();
    if (TOGGLE_THIS) {
      selfToggler($el, TOGGLE_THIS, ANIMATION_TYPE, options);
    } else {
      toggler($el, TOGGLE_SHOW, TOGGLE_HIDE, ANIMATION_TYPE, options);
    }
  });
  $el.on(CHANGE_HANDLER, function () {
    var selectedOption = $el.find(':selected');
    var $showElements = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(selectedOption.attr('data-toggle-select-show'));
    var $hideElements = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(selectedOption.attr('data-toggle-select-hide'));
    var $animationType = selectedOption.attr('data-toggle-select-animation');
    if ($showElements && $hideElements) {
      toggler(selectedOption, $showElements, $hideElements, $animationType, options);
    }
  });
};

/**
 * Initializes Header.
 * @param {HTMLElement} el - trigger
 * @param {Object} options - Options used for wiring up the modal
 * @see DEFAULTS
 */
function toggleDisplay(el) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var $el = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(el);
  var opts = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__lib_merge_options__["a" /* default */])(options, $el);
  var TOGGLE_SHOW = $el.data('toggle-select-show');
  var TOGGLE_HIDE = $el.data('toggle-select-hide');
  var TOGGLE_THIS = $el.data('toggle-select-this');
  var ANIMATION_TYPE = $el.data('toggle-select-animation');
  setEventListeners($el, TOGGLE_THIS, TOGGLE_SHOW, TOGGLE_HIDE, ANIMATION_TYPE, opts);
}
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__lib_register_jquery_plugin__["a" /* default */])(PLUGIN_NAME, toggleDisplay);

/***/ }),
/* 321 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export PLUGIN_NAME */
/* unused harmony export CLICK_EVENT */
/* unused harmony export DEFAULTS */
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_body_scroll_lock__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_body_scroll_lock___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_body_scroll_lock__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_register_jquery_plugin__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_merge_options__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__keyboard__ = __webpack_require__(3);
/**
 * Responsible for creating an toggleContent based on elements existing in the DOM
 * @module modules/toggleContent
 */






var PLUGIN_NAME = 'toggleDropdown';
var CLICK_EVENT = 'click';
var $html = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('html');
var DEFAULTS = {
  scrollLock: true,
  returnFocus: '',
  trapFocusFunc: __WEBPACK_IMPORTED_MODULE_4__keyboard__["a" /* default */].trapFocus.bind(__WEBPACK_IMPORTED_MODULE_4__keyboard__["a" /* default */]),
  releaseFocusFunc: __WEBPACK_IMPORTED_MODULE_4__keyboard__["a" /* default */].releaseFocus.bind(__WEBPACK_IMPORTED_MODULE_4__keyboard__["a" /* default */]),
  toggleTarget: '',
  closeOnEscKey: false
};
var closeAllToggleDropdowns = function closeAllToggleDropdowns() {
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()("[toggle-body-lock='true']").toggleDropdown('toggle');
};
var getToggleTargets = function getToggleTargets($el, opts) {
  var $toggleThis = __WEBPACK_IMPORTED_MODULE_0_jquery___default()($el.attr('data-toggle-select-this'));
  var toggleTargetSelector = opts.toggleTarget || '.js-toggle-container';
  var $toggleTarget = $el.data('toggle-target') === opts.toggleTarget ? $toggleThis : __WEBPACK_IMPORTED_MODULE_0_jquery___default()(toggleTargetSelector);
  return {
    $toggleThis: $toggleThis,
    $toggleTarget: $toggleTarget
  };
};

/**
 * Handles the height of the dropdown so it takes over the screen
 * @private
 */
function titleHeaderDropdownHeight() {
  var headerDropdown = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#plpheader_dropdown');
  if (headerDropdown.length) {
    var docHeight = document.documentElement.clientHeight;
    var $jsPageheaderNavList = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-page-header__nav-list');
    var titleHeight = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-toggle-container').height();
    $jsPageheaderNavList.css({
      maxHeight: docHeight - titleHeight
    });
  }
}

/**
 * Handles the click event when a label has been iteracted with.
 * @private
 * @param {jQuery.Event} evt - A jQuery event
 * @param {jQuery} $el - Containing the elements for the toggleContent
 * @param {Object} options - Options used for wiring up the toggleContent
 */
var itemClickHandler = function itemClickHandler($el, opts) {
  var _getToggleTargets = getToggleTargets($el, opts),
    $toggleThis = _getToggleTargets.$toggleThis,
    $toggleTarget = _getToggleTargets.$toggleTarget;
  var $toggleCloseButton = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#toggle-dropdown-close');
  if ($el.hasClass('is-active')) {
    $toggleThis.slideUp();
    $toggleThis.removeClass('is-active');
    $el.attr('aria-expanded', 'false');
    $toggleTarget.attr('aria-modal', 'false');
    $el.removeClass('is-active');
    if ($html.hasClass('focus-active')) {
      opts.releaseFocusFunc($toggleTarget, __WEBPACK_IMPORTED_MODULE_0_jquery___default()(opts.returnFocus));
      $toggleCloseButton.off('click', closeAllToggleDropdowns);
      $el.focus();
    }
    $el.focus();
    if (opts.scrollLock) {
      $el.attr('toggle-body-lock', '');
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_body_scroll_lock__["enableBodyScroll"])($toggleThis[0]);
      $toggleThis.off('scroll.toggledropdown');
    }
  } else {
    $toggleThis.slideDown();
    $toggleThis.addClass('is-active');
    $el.attr('aria-expanded', 'true');
    $toggleTarget.attr('aria-modal', 'true');
    $el.addClass('is-active');
    if ($html.hasClass('focus-active')) {
      opts.trapFocusFunc($toggleTarget);
      $toggleCloseButton.on('click', closeAllToggleDropdowns);
    }
    if ($toggleCloseButton.length) {
      $toggleCloseButton.on('click', closeAllToggleDropdowns);
    }
    if (opts.scrollLock) {
      $el.attr('toggle-body-lock', 'true');
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()('html, body').scrollTop(__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-toggle-container').offset().top);
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_body_scroll_lock__["disableBodyScroll"])($toggleThis[0]);
    }
    $el.focus();
  }
  titleHeaderDropdownHeight();
};
/**
 * Applies any sort of event handlers for the toggleContent.
 * @private
 * @param {jQuery} $el - Containing the elements for the toggleContent
 * @param {Object} options - Options used for wiring up the toggleContent
 * @see DEFAULTS
 */
var applyEventHandlers = function applyEventHandlers($el) {
  var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  $el.on(CLICK_EVENT, function () {
    return itemClickHandler($el, opts);
  });
  if (opts.closeOnEscKey === true) {
    var _getToggleTargets2 = getToggleTargets($el, opts),
      $toggleTarget = _getToggleTargets2.$toggleTarget;
    $toggleTarget.on('keydown.dropdownEsc', function (event) {
      if (__WEBPACK_IMPORTED_MODULE_4__keyboard__["a" /* default */].parseKey(event) === __WEBPACK_IMPORTED_MODULE_4__keyboard__["a" /* default */].keys.ESCAPE && $el.hasClass('is-active')) {
        itemClickHandler($el, opts);
      }
    });
  }
};
/**
 * Initializes an toggleContent based on provided parameters.
 * @param {HTMLElement} el - An element containing the elements for the
 * toggleContent
 * @param {Object} options - Options used for wiring up the toggleContent
 * @see DEFAULTS
 */
function toggleDropdown(el) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var $el = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(el);
  var opts = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__lib_merge_options__["a" /* default */])(DEFAULTS, options, $el);
  applyEventHandlers($el, opts);
  return {
    toggle: function toggle() {
      return itemClickHandler($el, opts);
    }
  };
}
__WEBPACK_IMPORTED_MODULE_0_jquery___default.a.toggleDropdown = function (options) {
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('<div/>').toggleDropdown(options);
};
__WEBPACK_IMPORTED_MODULE_0_jquery___default.a.toggleDropdown.close = function () {
  closeAllToggleDropdowns();
};

// Expose the function as a jQuery plugin for ease of use
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__lib_register_jquery_plugin__["a" /* default */])(PLUGIN_NAME, toggleDropdown);

/***/ }),
/* 322 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export PLUGIN_NAME */
/* unused harmony export ACTIVE_CLASS */
/* unused harmony export DEFAULTS */
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_register_jquery_plugin__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_merge_options__ = __webpack_require__(2);
/**
 * Toggle Elements on click
 * @module toggleElements
 */




var PLUGIN_NAME = 'toggleElements';
var ACTIVE_CLASS = 'toggle-text--is-active';
var DEFAULTS = {
  toggleElementDefault: '',
  // Corrected option names
  toggleElementAlt: '',
  // Corrected option names
  toggleTextPoliteness: 'assertive'
};

/**
 * Add aria live attribute to targeted el
 * @param  {jQuery} $el - button /element that toggles text or elements
 * @param  {Object} [options={}] - Any options provided upon initialization
 */
var setEventListeners = function setEventListeners($el, _ref) {
  var toggleElementDefault = _ref.toggleElementDefault,
    toggleElementAlt = _ref.toggleElementAlt;
  var toggleElements = function toggleElements() {
    var isChecked = $el.is(':checked');
    var $defaultElement = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(".".concat(toggleElementDefault));
    var $altElement = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(".".concat(toggleElementAlt));
    if (isChecked) {
      $defaultElement.hide();
      $altElement.show();
    } else {
      $defaultElement.show();
      $altElement.hide();
    }
    $el.toggleClass(ACTIVE_CLASS);
  };
  $el.on('click.triggerElements', toggleElements);
  $el.on('change.triggerElements', toggleElements);
};

/**
 * Initializes the toggleElement or toggleElements.
 * @param {HTMLElement} el - trigger
 * @param {Object} options - Options used for wiring up the modal
 * @see DEFAULTS
 */
function toggleElement(el) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var $el = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(el);
  var opts = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__lib_merge_options__["a" /* default */])(DEFAULTS, options, $el);
  setEventListeners($el, opts);
}
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__lib_register_jquery_plugin__["a" /* default */])(PLUGIN_NAME, toggleElement);

/***/ }),
/* 323 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export PLUGIN_NAME */
/* unused harmony export DEFAULTS */
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_register_jquery_plugin__ = __webpack_require__(1);
/* eslint no-console:0 */

/**
 * Handles back to top button
 * @module toggleReveal
 */



var PLUGIN_NAME = 'toggleReveal';
var DEFAULTS = {};
var makeDisableFocus = function makeDisableFocus(toggleContainer, toggleButton) {
  return function () {
    toggleContainer.find('a').not(toggleButton).attr('tabindex', -1);
  };
};
var makeEnableFocus = function makeEnableFocus(toggleContainer, toggleButton) {
  return function () {
    var anchors = toggleContainer.find('a');
    anchors.not(toggleButton).attr('tabindex', 0);
    anchors.first().focus();
  };
};
var updateButtonCopy = function updateButtonCopy(toggleButton) {
  var currentText = toggleButton.find('.action-button__copy').text();
  var newToggleText = toggleButton.data('close-copy');
  toggleButton.data('close-copy', currentText).find('.action-button__copy').text(newToggleText);
};
var makeHandleReveal = function makeHandleReveal(toggleButton, toggleContainer, disableFocus, enableFocus) {
  return function () {
    var redirectUrl = toggleButton.data('url');
    var loadProductURL = toggleButton.data('load-product-url');
    if (!toggleContainer.hasClass('active')) {
      if (toggleButton.hasClass('js-slidedown--toggle-display')) {
        toggleButton.hide();
      }
      toggleContainer.addClass('active');
      updateButtonCopy(toggleButton);
    } else {
      // Check if toggleButton has data-url
      if (redirectUrl) {
        if (toggleButton.prop('tagName').toLowerCase() === 'button') {
          var btnURL = "window.location = '".concat(redirectUrl, "'");
          toggleButton.attr('onClick', btnURL).trigger('click');
        } else {
          // assumes it's an anchor tag
          toggleButton.attr('href', redirectUrl);
        }
      }
      // Check if toggleButton has data-load-product-url
      if (loadProductURL && toggleContainer.hasClass('active')) {
        // Get last Product before the AJAX load
        var lastProduct = toggleContainer.find('.js-plp-container').last();
        __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.ajax({
          url: loadProductURL,
          success: function success(response) {
            toggleContainer.append(response);
          },
          complete: function complete() {
            toggleButton.data('load-product-url', false); // sets the false value
            toggleButton.attr('data-load-product-url', false); // Visually changes the copy to "false"
            toggleButton.data('close-copy', 'view more');
            toggleButton.data('expand-copy', 'view less');
            toggleButton.find('.action-button__copy').text('view less');
            // Use the last product before the ajax load and focus on it
            lastProduct.find('a').first().focus();
            __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-lazy-image').lazy();
          },
          error: function error(jqXHR, textStatus, errorThrown) {
            console.error("".concat(textStatus, " ").concat(errorThrown));
          }
        });
      }
      // Check if toggleButton has No data-load-product-url and No data-url
      if (!loadProductURL && !redirectUrl) {
        toggleContainer.toggleClass('active');
        updateButtonCopy(toggleButton);
      }
    }
    if (toggleContainer.hasClass('active')) {
      enableFocus();
    } else {
      disableFocus();
    }
  };
};
function toggleReveal() {
  var toggleButton = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-toggle-reveal');
  var toggleContainer = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-toggle-reveal-trigger');
  var disableFocus = makeDisableFocus(toggleContainer, toggleButton);
  var enableFocus = makeEnableFocus(toggleContainer, toggleButton);
  var handleReveal = makeHandleReveal(toggleButton, toggleContainer, disableFocus, enableFocus);
  disableFocus();
  toggleButton.on('click', handleReveal);
}
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__lib_register_jquery_plugin__["a" /* default */])(PLUGIN_NAME, toggleReveal);

/***/ }),
/* 324 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export PLUGIN_NAME */
/* unused harmony export ACTIVE_CLASS */
/* unused harmony export DEFAULTS */
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_register_jquery_plugin__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_merge_options__ = __webpack_require__(2);
/**
 * Toggle Text on click
 * @module toggleText
 */




var PLUGIN_NAME = 'toggleText';
var ACTIVE_CLASS = 'toggle-text--is-active';
var DEFAULTS = {
  toggleTextTargetClass: '',
  toggleTextDefault: '',
  toggleTextAlt: '',
  toggleTextPoliteness: 'assertive'
};

/**
 * Applies any event handlers to toggle text trigger
 * @param  {jQuery} $el - button /element that toggles text
 * @param  {Object} [options={}] - Any options provided upon initialization
 */
var makeAccessible = function makeAccessible(_ref) {
  var toggleTextTargetClass = _ref.toggleTextTargetClass,
    toggleTextPoliteness = _ref.toggleTextPoliteness;
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()(".".concat(toggleTextTargetClass)).each(function ariaLiveTriggers() {
    var $el = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this);
    if (!$el.data('no-aria-live')) {
      $el.attr('aria-live', toggleTextPoliteness);
    }
  });
};
/**
 * Add aria live attribute to targeted el
 * @param  {jQuery} $el - button /element that toggles text
 * @param  {Object} [options={}] - Any options provided upon initialization
 */
var setEventListeners = function setEventListeners($el, _ref2) {
  var toggleTextTargetClass = _ref2.toggleTextTargetClass,
    toggleTextDefault = _ref2.toggleTextDefault,
    toggleTextAlt = _ref2.toggleTextAlt;
  $el.on('click.triggerText', function () {
    var isActive = $el.hasClass(ACTIVE_CLASS);
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()(".".concat(toggleTextTargetClass)).each(function changeText() {
      var $changingEl = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this);
      if ($changingEl.data('toggle-text-reverse')) {
        $changingEl.text(isActive ? toggleTextAlt : toggleTextDefault);
      } else {
        $changingEl.text(isActive ? toggleTextDefault : toggleTextAlt);
      }
    });
    $el.toggleClass(ACTIVE_CLASS);
  });
  $el.on('change.triggerText', function () {
    var isChecked = $el.is(':checked');
    var isActive = $el.hasClass(ACTIVE_CLASS);
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()(".".concat(toggleTextTargetClass)).each(function changeText() {
      var $changingEl = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this);
      if ($changingEl.data('toggle-text-reverse')) {
        $changingEl.text(isActive ? toggleTextAlt : toggleTextDefault);
      } else {
        $changingEl.text(isChecked ? toggleTextAlt : toggleTextDefault);
      }
    });
    $el.toggleClass(ACTIVE_CLASS);
  });
};
var hasHash = function hasHash($el) {
  var href = $el.attr('href');
  if (href) {
    if (href.toLowerCase().indexOf('#') !== -1 && href.length > 1) {
      return href;
    }
  }
  return false;
};
/**
 * Give <a> a unique href value, in order to avoid users hearing
 * "visited" on links they've yet to visit.
 * @param  {jQuery} $el - button /element that toggles text
 */
var makeUniqueHash = function makeUniqueHash($el) {
  if ($el.is('a') && !hasHash($el)) {
    $el.attr('href', "#toggle-text-uid-".concat(Math.ceil(Math.random() * 10000000000)));
  }
};
/**
 * Initializes Header.
 * @param {HTMLElement} el - trigger
 * @param {Object} options - Options used for wiring up the modal
 * @see DEFAULTS
 */
function toggleText(el) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var $el = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(el);
  var opts = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__lib_merge_options__["a" /* default */])(DEFAULTS, options, $el);
  makeAccessible(opts);
  makeUniqueHash($el);
  setEventListeners($el, opts);
}
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__lib_register_jquery_plugin__["a" /* default */])(PLUGIN_NAME, toggleText);

/***/ }),
/* 325 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export DEFAULTS */
/* unused harmony export PLUGIN_NAME */
/* unused harmony export VIMEO_API_URL */
/* unused harmony export YOUTUBE_API_URL */
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_register_jquery_plugin__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_merge_options__ = __webpack_require__(2);
/**
 * Handles all Video tracking
 * @module modules/trackVideo
 */




var DEFAULTS = {
  eventCategory: 'Beauty Video'
};

// Expose the function as a jQuery plugin for ease of use
var PLUGIN_NAME = 'trackVideo';
var VIMEO_API_URL = 'https://player.vimeo.com/api/player.js';
var YOUTUBE_API_URL = 'https://www.youtube.com/iframe_api';

/**
 * Setup players for respective video sources
 * @param  {jQuery} $el - iframe of video to track
 * @param  {string} string of video type to test source against
 */
var playerType = function playerType($el, type) {
  if ($el.data('loader') === type) {
    return true;
  }
  if ($el.attr('src')) {
    var src = $el.attr('src').toLowerCase();
    if (src.indexOf(type) !== -1) {
      return true;
    }
  }
  return false;
};

/**
 * Clean title for GA tracking
 * @private
 * @param  {string} video title
 * @return {string} clean title with no space or special characters
 */
var cleanTitle = function cleanTitle(title) {
  return title.replace(/[^a-z0-9\s]/gi, '').replace(/[_\s]/g, '-');
};

/**
 * Track with GA
 * @private
 * @param  {string} Video title to send to GA
 */
var sendToGA = function sendToGA(videoTitle, _ref) {
  var eventCategory = _ref.eventCategory;
  if (window.ga && ga.create) {
    ga('send', 'event', {
      eventCategory: eventCategory,
      eventAction: 'play',
      eventLabel: videoTitle
    });
  }
};
/**
 * Set up Vimeo player event
 * @private
 * @param  {object} vimeo player
 */
var setVimeoEvents = function setVimeoEvents(player, opts) {
  var videoTitle;
  player.getVideoTitle().then(function (title) {
    videoTitle = cleanTitle(title);
  });
  player.on('play', function () {
    sendToGA(videoTitle, opts);
  });
};
/**
 * Clean title for GA tracking
 * @private
 * @param  {jQuery} $el - iframe of video to track
 * @return {string} unique id for youtube initialization
 */
var createUniqueID = function createUniqueID($el) {
  var ytid = "yt-".concat(Math.ceil(Math.random() * 10000000000));
  $el.attr('id', ytid);
  return ytid;
};
/**
 * Init YouTube Player
 * @private
 * @param  {event} youtube player event
 */
var onYouTubePlayerReady = function onYouTubePlayerReady(event) {
  var videoTitle = cleanTitle(event.target.getVideoData().title);
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()(event.target.a).data('video-title', videoTitle);
};

/**
 * Set up YouTube player event
 * @private
 * @param  {event} youtube play event
 */
var setYouTubeEvents = function setYouTubeEvents(event, opts) {
  var videoTitle = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(event.target.a).data('video-title');
  switch (event.data) {
    case 1:
      sendToGA(videoTitle, opts);
      break;
    default:
  }
};
/**
 * Init YouTube Player
 * @private
 * @param  {jQuery} $el - iframe of video to track
* @return {object} YT Object
 */
var initYouTubeVideo = function initYouTubeVideo($el, opts) {
  var ytid = createUniqueID($el);
  return new YT.Player(ytid, {
    events: {
      onReady: onYouTubePlayerReady,
      onStateChange: function onStateChange(event) {
        setYouTubeEvents(event, opts);
      }
    }
  });
};
/**
 * Setup players for respective video sources
 * @private
 * @param  {jQuery} $el - iframe of video to track
 */
var setupPlayer = function setupPlayer($el, opts) {
  if (playerType($el, 'vimeo')) {
    var player = new Vimeo.Player($el);
    setVimeoEvents(player, opts);
  } else if (playerType($el, 'youtube')) {
    if (window.youtubeLoaded) {
      initYouTubeVideo($el, opts);
    }
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()(window).on('youtubeLoaded', function () {
      initYouTubeVideo($el, opts);
    });
  }
};
/**
 * Load correct api base on url
 * @private
 * @param  {jQuery} $el - iframe of video to track
 */
var loadAPI = function loadAPI($el, opts) {
  var apiURL;
  if (playerType($el, 'vimeo')) {
    apiURL = VIMEO_API_URL;
  } else if (playerType($el, 'youtube')) {
    apiURL = YOUTUBE_API_URL;
  }
  __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.ajax({
    url: apiURL,
    cache: true,
    dataType: 'script'
  }).done(function () {
    setupPlayer($el, opts);
  });
};
/**
 * Initializes modal.
 * @param {HTMLElement} el - iframe of video to track
 * @see DEFAULTS
 */
function trackVideo(el) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var $el = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(el);
  var opts = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__lib_merge_options__["a" /* default */])(DEFAULTS, options, $el);
  loadAPI($el, opts);
}

/**
* Add event for YouTube API ready method
*/
window.onYouTubeIframeAPIReady = function () {
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()(window).trigger('youtubeLoaded');
  window.youtubeLoaded = true;
};
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__lib_register_jquery_plugin__["a" /* default */])(PLUGIN_NAME, trackVideo);

/***/ }),
/* 326 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export PLUGIN_NAME */
/* unused harmony export TRUNCATE_CLASS */
/* unused harmony export SHOW_MODIFIER */
/* unused harmony export BTN_TOGGLE_ATTR */
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_register_jquery_plugin__ = __webpack_require__(1);
/**
 * Responsible for truncating text with the intention that the full text can be
 * expanded when interacted by the user
 * @module modules/truncate
 */



// Expose the function as a jQuery plugin for ease of use
var PLUGIN_NAME = 'truncate';

/**
 * Defines the class name responsible for truncating
 * @type {string}
 */
var TRUNCATE_CLASS = 'u-truncate';

/**
 * Defines the modifier name responsible showing truncated text
 * @type {string}
 */
var SHOW_MODIFIER = 'show';

/**
 * Defines the data attribute for the button's toggle text
 * @type {string}
 */
var BTN_TOGGLE_ATTR = 'toggle';

/**
 * Defines the default options for truncating
 * @namespace
 * @param {string} truncateShowMore - default text for "show more" toggle button
 * @param {string} truncateShowLess - default text for "show less" toggle button
 */
var DEFAULT_OPTIONS = {
  truncateShowMore: 'more',
  truncateShowLess: 'less'
};

/**
 * Adds "more|less" button when content is long enough to truncate
 *
 * HTML example, including required and optional data attributes
 * <p data-truncate="true"
 *    data-truncate-show-more="{{#more}}{{.}}{{else}}more{{/more}}"
 *    data-truncate-show-less="{{#less}}{{.}}{{else}}less{{/less}}"
 *    data-truncate-lines="4">
 *   I've moved on, I've moved on. And I'm in the dating pool, so...
 *   But it's funny, you know, I love having clothes made for me but, I don't know, ladies, you
 *   have this situation, but no matter what you're buying, in a store you always hear "wear it
 *   with jeans." I don't care what I'm buying -- "Oh, wear it with jeans." One time, this lady
 *   said to me, "You know, if you're going to a rock concert..." I go, "A rock concert?!"
 *   That's hilarious to me. Me at a rock concert. Ok. Wear it with jeans. Jeans. Pay attention
 *   from now on.
 * </p>
 *
 * @param {HTMLElement} el - The element whose content we're truncating
 * @see DEFAULT_OPTIONS
 */
function truncate(el) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var $el = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(el);
  var _$$extend = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.extend({}, DEFAULT_OPTIONS, options, el.dataset),
    truncateShowMore = _$$extend.truncateShowMore,
    truncateShowLess = _$$extend.truncateShowLess,
    truncateLines = _$$extend.truncateLines;

  // get initial height
  var initialHeight = $el.height();

  // truncate, adding helper & optional modifier
  $el.addClass(TRUNCATE_CLASS);
  if (truncateLines) {
    $el.addClass("".concat(TRUNCATE_CLASS, "--").concat(truncateLines));
  }

  // get new height
  var newHeight = $el.height();

  // when truncating changed height, add toggle button
  if (initialHeight > newHeight) {
    // create toggle button
    var $toggleBtn = __WEBPACK_IMPORTED_MODULE_0_jquery___default()("\n      <button class=\"truncate-toggle-button link link--bold u-margin--center\" data-".concat(BTN_TOGGLE_ATTR, "=\"").concat(truncateShowLess, "\">\n        ").concat(truncateShowMore, "\n      </button>\n    "));

    // attach click event to toggle button
    $toggleBtn.on('click', function () {
      // show/hide truncated content
      $el.toggleClass("".concat(TRUNCATE_CLASS, "--").concat(SHOW_MODIFIER));

      // toggle button text
      var text = $toggleBtn.text();
      $toggleBtn.text($toggleBtn.data(BTN_TOGGLE_ATTR)).data(BTN_TOGGLE_ATTR, text);
    });

    // append toggle button
    $el.after($toggleBtn);
  }
}
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__lib_register_jquery_plugin__["a" /* default */])(PLUGIN_NAME, truncate);

/***/ }),
/* 327 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_register_jquery_plugin__ = __webpack_require__(1);
/**
 * Responsible for having an item disappear when interacting with a target
 * @module modules/vanish/vanish
 */



/**
 * Defines the defaults around the disappear module.
 * @type {Object}
 */
var DISAPPEAR_DEFAULTS = {
  vanishHiddenClassName: 'vanish--hide',
  vanishTarget: '.vanish__action',
  vanishRemoveDelay: 500
};

/**
 * Will destroy and resolve the removal of the container element.
 * @private
 * @param {jQuery} $el - The container element
 * @param {number} delay - Time in milliseconds to remove the element
 * @param {Function} resolve - Function determining when removal has completed
 */
var remove = function remove($el, delay, resolve) {
  setTimeout(function () {
    $el.remove();
    resolve();
  }, delay);
};

/**
 * Responsible for removing an element/container based on interacting with an
 * a child element within said container. This is done by either looking to a
 * data attribute called data-vanish-target which contains a selector with the
 * elements that should trigger this behavior. It includes other data
 * attributes such as:
 *
 * - data-vanish-hidden-class-name: The class name applied when the target
 *   has been interacted with.
 * - data-vanish-remove-delay: The amount of time in milliseconds the element
 *   should be removed from the DOM.
 *
 * @see DISAPPEAR_DEFAULTS
 * @param {HTMLElement} el - The container element to potentially be removed
 * @param {Object} options - Any configurable options
 * @returns {Promise}
 */
function vanish(el) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var $el = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(el);
  var _$$extend = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.extend({}, DISAPPEAR_DEFAULTS, options, $el.data()),
    target = _$$extend.vanishTarget,
    hideClassName = _$$extend.vanishHiddenClassName,
    removeDelay = _$$extend.vanishRemoveDelay;
  return new Promise(function (resolve) {
    $el.on('click', target, function (e) {
      e.preventDefault();
      $el.addClass(hideClassName).on('transitionend', function () {
        return remove($el, removeDelay, resolve);
      });
    });
  });
}
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__lib_register_jquery_plugin__["a" /* default */])('vanish', vanish);

/***/ }),
/* 328 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__keyboard__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styleguide_src_assets_lib_props__ = __webpack_require__(11);



var VISUAL_NAV_JS = 'js-visual-nav';
var ATTRIBUTE_CLASS = 'visual-nav__attr';
var ATTRIBUTE_ITEM_CLASS = 'visual-nav__attr-item';
var ATTRIBUTE_LIST_BUTTON_CLASS = 'visual-nav__attr-list-button';
var ATTRIBUTE_BUTTON_CLASS = 'visual-nav__attr-button';
var ATTRIBUTE_ITEM_ACTIVE_CLASS = 'visual-nav__attr-item--active';
var ATTRIBUTE_LIST_ITEM_BUTTON_ACTIVE_CLASS = 'visual-nav__attr-list-button--active';
var ATTRIBUTE_CONTAINERS_CLASS = 'visual-nav__attrs';
var ATTRIBUTE_BUTTON_SELECTED_CLASS = 'visual-nav__attr-button--selected';

// AB Test - 1028 Remove Fade-In UX-20295
var ATTRIBUTE_ITEM_ACTIVE_NO_FADE = 'visual-nav__attr-item--active-no-fade';
var ATTRIBUTE_ITEM_CLASS_NO_FADE = 'visual-nav__attr-item-no-fade';
var isNoFade = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__styleguide_src_assets_lib_props__["a" /* get */])('visualNav.noFadeIn', false);
var getAttributesId = function getAttributesId(attributeGroupName) {
  return "#visual-nav-attrs-".concat(attributeGroupName);
};
var animateInAttributes = function animateInAttributes($activeAttributeItems) {
  var animationDelay = 80;
  $activeAttributeItems.each(function animationOfAttributes(i) {
    var _this = this;
    setTimeout(function () {
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()(_this).addClass(ATTRIBUTE_ITEM_ACTIVE_CLASS);
    }, animationDelay * i);
  });
};
var showAttributesById = function showAttributesById(id) {
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()(".".concat(ATTRIBUTE_ITEM_ACTIVE_CLASS)).removeClass(ATTRIBUTE_ITEM_ACTIVE_CLASS);
  var $activeAttributeContainer = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(id);
  var $activeAttributeItems = $activeAttributeContainer.find(".".concat(ATTRIBUTE_ITEM_CLASS));
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()(".".concat(ATTRIBUTE_CONTAINERS_CLASS)).hide();
  $activeAttributeContainer.show();

  // AB Test - 1028 Remove Fade-In UX-20295
  if (isNoFade) {
    var $activeAttributeItemsNoFade = $activeAttributeContainer.find(".".concat(ATTRIBUTE_ITEM_CLASS_NO_FADE));
    $activeAttributeItemsNoFade.addClass("".concat(ATTRIBUTE_ITEM_ACTIVE_NO_FADE));
  } else {
    animateInAttributes($activeAttributeItems);
  }
};
var highlightAttributeGroupItem = function highlightAttributeGroupItem($el) {
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()(".".concat(ATTRIBUTE_LIST_ITEM_BUTTON_ACTIVE_CLASS)).removeClass(ATTRIBUTE_LIST_ITEM_BUTTON_ACTIVE_CLASS);
  $el.addClass(ATTRIBUTE_LIST_ITEM_BUTTON_ACTIVE_CLASS);
};
var scrollAllAttributesToLeft = function scrollAllAttributesToLeft() {
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()(".".concat(ATTRIBUTE_CLASS)).scrollLeft(0);
};
function updateUiFromAvailableLabels(availableLabels) {
  var $attributeButtons = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.visual-nav__attr-button');
  var $attributeGroupButtons = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.visual-nav__attr-list-button');

  // Update Attribute Buttons
  $attributeButtons.each(function (i, attributeEl) {
    var $attribute = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(attributeEl);
    var attributeName = $attribute.data('attr');
    var isAvailable = availableLabels.includes(attributeName);
    if (isAvailable) {
      $attribute.attr('disabled', false);
    } else {
      $attribute.attr('disabled', true);
    }
  });
  function hasEnabledAttribute($attributes) {
    var result = false;
    __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.each($attributes, function (key, el) {
      // console.log(key, $(el));
      if (__WEBPACK_IMPORTED_MODULE_0_jquery___default()(el).attr('disabled') === undefined) {
        result = true;
        // This will only exit the anonymous function and
        // stop the iteration immediately.
        return false;
      }
      return true;
    });

    // This will exit the function with return true;
    return result;
  }

  // Update Attribute List Buttons
  $attributeGroupButtons.each(function (i, attributeGroupEl) {
    var $attributeGroupButton = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(attributeGroupEl);
    var $attributesContainer = __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#visual-nav-attrs-".concat($attributeGroupButton.data('name')));
    var $attributes = $attributesContainer.find('.visual-nav__attr-button');
    var enabled = hasEnabledAttribute($attributes);
    if (enabled) {
      $attributeGroupButton.attr('disabled', false);
    } else {
      $attributeGroupButton.attr('disabled', true);
    }
  });
}

/**
 * Renders the state of attr buttons based on the selected class
 * @param {jQuery} $attributeButtons - attr buttons of a particular filter.
 */
var renderStateAttributeButtons = function renderStateAttributeButtons($attributeButtons) {
  $attributeButtons.each(function renderStateAttributeButton() {
    var $attributeButton = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this);
    var isAttributeSelected = $attributeButton.hasClass(ATTRIBUTE_BUTTON_SELECTED_CLASS);
    if (isAttributeSelected === true) {
      var imgSelected = $attributeButton.data('img-selected');
      $attributeButton.find('img').attr('src', imgSelected);
    } else {
      var img = $attributeButton.data('img');
      $attributeButton.find('img').attr('src', img);
    }
  });
};
var updateAttributeListCounter = function updateAttributeListCounter($attributeButton) {
  var $attributeContainer = $attributeButton.parents('.visual-nav__attrs');
  var attributeGroupButtonId = $attributeContainer.attr('id');
  var attributeSelected = $attributeContainer.find(".".concat(ATTRIBUTE_BUTTON_SELECTED_CLASS));
  var attributeSelectedCount = attributeSelected.length;
  var $attributeGroupButton = __WEBPACK_IMPORTED_MODULE_0_jquery___default()("[aria-controls=\"".concat(attributeGroupButtonId, "\"]"));
  var $attributeGroupTextContainer = $attributeGroupButton.find('.visual-nav__attr-list-text');
  var $counter = $attributeGroupTextContainer.find('.visual-nav__attr-list-counter');
  if (attributeSelectedCount === 0) {
    $counter.remove();
    return;
  }
  if ($counter.length === 0) {
    $attributeGroupTextContainer.append("<span class=\"visual-nav__attr-list-counter\">(".concat(attributeSelectedCount, ")</span>"));
  } else {
    $counter.text("(".concat(attributeSelectedCount, ")"));
  }
};

/**
 * Reset Aria Attributes
 * @param  {jQuery} $listButtons - the top level list buttons
 */
var resetAriaAttributes = function resetAriaAttributes($listButtons) {
  $listButtons.each(function (key, listButton) {
    var $listButton = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(listButton);
    $listButton.attr('aria-expanded', false);
    $listButton.attr('aria-selected', false);
  });
};

/**
 * Sets Aria Attributes for newly selected list button
 * @param  {jQuery} $selectedButton - selected list button
 */
var setAriaAttributes = function setAriaAttributes($selectedButton) {
  $selectedButton.attr('aria-expanded', true);
  $selectedButton.attr('aria-selected', true);
};

/**
 * Arrow Handler
 * @param  {string} direction - direction of focus, next or previous el
 * @param  {jQuery} $focusedEl - el currently in focus
 * @param  {jQuery} $siblings - list of focusable elements
 */
var arrowHandler = function arrowHandler(direction, $focusedEl, $siblings) {
  var currentIndex = $siblings.index($focusedEl);
  var targetIndex;
  // hit right arrow on the last element, focus goes to the first in the list
  if (currentIndex === $siblings.length - 1 && direction === 'next') {
    targetIndex = 0;
    // hit left arrow on the first element, focus goes to the last in the list
  } else if (currentIndex === 0 && direction === 'prev') {
    targetIndex = $siblings.length - 1;
  } else {
    targetIndex = direction === 'next' ? currentIndex + 1 : currentIndex - 1;
  }
  $siblings[targetIndex].focus();
};

/**
 * Keydown Handler
 * @param  {event} evt - key event
 * @param  {jQuery} $visualNav - visual nav module
 */
var handleKeydown = function handleKeydown(evt, $visualNav) {
  var $currentFocusedEl = $visualNav.find(':focus');
  var isGroupButton = $currentFocusedEl.hasClass(ATTRIBUTE_LIST_BUTTON_CLASS);
  var isEscape = __WEBPACK_IMPORTED_MODULE_1__keyboard__["a" /* default */].parseKey(evt) === __WEBPACK_IMPORTED_MODULE_1__keyboard__["a" /* default */].keys.ESCAPE;
  var isNextArrows = __WEBPACK_IMPORTED_MODULE_1__keyboard__["a" /* default */].parseKey(evt) === 'ARROWRIGHT' || __WEBPACK_IMPORTED_MODULE_1__keyboard__["a" /* default */].parseKey(evt) === 'ARROWDOWN';
  var isPrevArrows = __WEBPACK_IMPORTED_MODULE_1__keyboard__["a" /* default */].parseKey(evt) === 'ARROWLEFT' || __WEBPACK_IMPORTED_MODULE_1__keyboard__["a" /* default */].parseKey(evt) === 'ARROWUP';

  // Group Item keyboard listeners
  if (isGroupButton) {
    var $groupButtons = $visualNav.find(".".concat(ATTRIBUTE_LIST_BUTTON_CLASS));
    if (isNextArrows) {
      arrowHandler('next', $currentFocusedEl, $groupButtons);
    }
    if (isPrevArrows) {
      arrowHandler('prev', $currentFocusedEl, $groupButtons);
    }
  }

  // Attribute keyboard listeners
  if (!isGroupButton) {
    var $attributeButtons = $visualNav.find(".".concat(ATTRIBUTE_ITEM_ACTIVE_CLASS, " .").concat(ATTRIBUTE_BUTTON_CLASS));
    if (isEscape) {
      // use data-parent-hash to move focus to parent list button
      var parentID = $currentFocusedEl.data('parent-hash');
      var $parentListItem = $visualNav.find("[aria-controls=\"visual-nav-attrs-".concat(parentID, "\"]"));
      $parentListItem.focus();
    }
    if (isNextArrows) {
      arrowHandler('next', $currentFocusedEl, $attributeButtons);
    }
    if (isPrevArrows) {
      arrowHandler('prev', $currentFocusedEl, $attributeButtons);
    }
  }
};
var findFirstFocusableAttribute = function findFirstFocusableAttribute($listButton, $visualNav) {
  var controlValue = $listButton.attr('aria-controls');
  var $targetPanel = $visualNav.find("#".concat(controlValue));
  var $targetAttribute = __WEBPACK_IMPORTED_MODULE_1__keyboard__["a" /* default */].findFocusable($targetPanel).eq(0);
  $targetAttribute.focus();
};
var handleAttributeClick = function handleAttributeClick($attributeButton, doSearch) {
  var $attributeContainer = $attributeButton.parents('.visual-nav__attrs');
  var selectedBehavior = $attributeContainer.data('select-behavior');
  var $attributeButtons = $attributeContainer.find('.visual-nav__attr-button');
  var isAttributeSelected = $attributeButton.hasClass(ATTRIBUTE_BUTTON_SELECTED_CLASS);
  if (selectedBehavior === 'single') {
    // Remove selected state from all attr buttons
    $attributeButtons.removeClass(ATTRIBUTE_BUTTON_SELECTED_CLASS);
  }

  // Toggle class of clicked attr button
  if (isAttributeSelected) {
    $attributeButton.removeClass(ATTRIBUTE_BUTTON_SELECTED_CLASS);
  } else {
    $attributeButton.addClass(ATTRIBUTE_BUTTON_SELECTED_CLASS);
  }
  renderStateAttributeButtons($attributeButtons);
  updateAttributeListCounter($attributeButton);
  if (doSearch) {
    window.doVisualSearch(1);
  }
};
var lazyLoadImagesById = function lazyLoadImagesById(id) {
  var images = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(id).find('[data-vn-lazy]');
  __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.each(images, function (index, image) {
    var $image = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(image);
    $image.attr('src', $image.data('vn-lazy'));
    $image.removeAttr('data-vn-lazy');
  });
};
var handleAttributeGroupClick = function handleAttributeGroupClick($el) {
  var attributeGroupName = $el.data('name');
  var id = getAttributesId(attributeGroupName);
  highlightAttributeGroupItem($el);
  showAttributesById(id);
  scrollAllAttributesToLeft();
  lazyLoadImagesById(id);
};
var addEventsToAttributeGroupButtons = function addEventsToAttributeGroupButtons($attributeGroupButtons, $visualNav) {
  $attributeGroupButtons.on('click', function attributeGroupButtonsHandleClick() {
    handleAttributeGroupClick(__WEBPACK_IMPORTED_MODULE_0_jquery___default()(this));
    resetAriaAttributes($attributeGroupButtons);
    setAriaAttributes(__WEBPACK_IMPORTED_MODULE_0_jquery___default()(this));
    findFirstFocusableAttribute(__WEBPACK_IMPORTED_MODULE_0_jquery___default()(this), $visualNav);
  });
};
var addEventsToAttributeButtons = function addEventsToAttributeButtons($visualNav) {
  $visualNav.on('click', ".".concat(ATTRIBUTE_BUTTON_CLASS), function attributeButtonHandleClick() {
    handleAttributeClick(__WEBPACK_IMPORTED_MODULE_0_jquery___default()(this), true);
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).trigger('visualFilterSelected');
  });
};
function init() {
  var $visualNav = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(".".concat(VISUAL_NAV_JS));
  var $attributeGroupButtons = $visualNav.find(".".concat(ATTRIBUTE_LIST_BUTTON_CLASS));
  handleAttributeGroupClick($attributeGroupButtons.first());
  addEventsToAttributeGroupButtons($attributeGroupButtons, $visualNav);
  addEventsToAttributeButtons($visualNav);
  $visualNav.on('keydown.visualnav', function (evt) {
    handleKeydown(evt, $visualNav);
  });
}
init();
window.visualNav = {
  updateUiFromAvailableLabels: updateUiFromAvailableLabels,
  handleAttributeClick: handleAttributeClick,
  handleAttributeGroupClick: handleAttributeGroupClick
};

/***/ }),
/* 329 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = imageZoom;
/**
 * Zoom/pan image with HammerJS using stable pinch-center math.
 * Returns a Hammer instance synchronously.
 *
 * @param {Function} Hammer - HammerJS constructor
 * @param {HTMLElement} el  - The <img> receiving zoom
 * @return {Hammer} An instance of Hammer
 */
function imageZoom(Hammer, el) {
  var img = el;
  var container = img.parentElement;

  // Configuration
  var MIN_SCALE = 1;
  var MAX_SCALE = 8;

  // Current transform state
  var scale = 1;
  var lastScale = 1; // Scale committed at end of last gesture
  var tx = 0; // Translation X in CSS pixels
  var ty = 0; // Translation Y in CSS pixels
  var lastTx = 0; // Translation X committed at end of last gesture
  var lastTy = 0; // Translation Y committed at end of last gesture

  // Gesture state - captured at start of each pinch
  var gestureStartScale = 1;
  var gestureStartTx = 0;
  var gestureStartTy = 0;
  var pinchCx = 0; // Pinch center in image-space coordinates
  var pinchCy = 0;

  // Gesture control flag
  var isPinching = false;

  // Prepare element styles to prevent browser interference
  if (container) container.style.touchAction = 'none';
  img.style.transformOrigin = '0 0';
  img.style.willChange = 'transform';
  img.style.userSelect = 'none';
  img.style.webkitUserDrag = 'none';
  img.style.transition = 'none';

  // Initialize HammerJS
  var hammertime = new Hammer(container || img, {
    domEvents: true
  });
  hammertime.get('pinch').set({
    enable: true
  });

  /**
   * Clamp scale to MIN_SCALE and MAX_SCALE boundaries
   */
  function clampScale(s) {
    if (s < MIN_SCALE) return MIN_SCALE;
    if (s > MAX_SCALE) return MAX_SCALE;
    return s;
  }

  /**
   * Clamp translation to keep image within viewport bounds.
   * If image is smaller than viewport on any axis, center it.
   *
   * @param {number} nx - Proposed translation X
   * @param {number} ny - Proposed translation Y
   * @param {number} currentScale - Current scale to use for boundary calculation
   * @return {Object} Clamped coordinates {x, y}
   */
  function clampTranslate(nx, ny, currentScale) {
    var baseW = img.offsetWidth || img.clientWidth || 0;
    var baseH = img.offsetHeight || img.clientHeight || 0;
    var viewportW = (container ? container.clientWidth : baseW) || baseW;
    var viewportH = (container ? container.clientHeight : baseH) || baseH;
    var scaledW = baseW * currentScale;
    var scaledH = baseH * currentScale;
    var minX;
    var maxX;
    var minY;
    var maxY;

    // If scaled image is smaller than viewport, center it
    if (scaledW <= viewportW) {
      var centeredX = (viewportW - scaledW) / 2;
      minX = centeredX;
      maxX = centeredX;
    } else {
      // Otherwise, allow panning but keep edges within viewport
      minX = viewportW - scaledW; // Left edge limit
      maxX = 0; // Right edge limit
    }
    if (scaledH <= viewportH) {
      var centeredY = (viewportH - scaledH) / 2;
      minY = centeredY;
      maxY = centeredY;
    } else {
      minY = viewportH - scaledH; // Top edge limit
      maxY = 0; // Bottom edge limit
    }
    return {
      x: Math.max(minX, Math.min(nx, maxX)),
      y: Math.max(minY, Math.min(ny, maxY))
    };
  }

  /**
   * Apply current transform state to the image element.
   * Resets to identity transform if scale is at minimum.
   */
  function apply() {
    // Reset everything if we're at minimum scale
    if (scale <= 1.0001) {
      scale = 1;
      tx = 0;
      ty = 0;
      lastScale = 1;
      lastTx = 0;
      lastTy = 0;
    }
    img.style.transform = "translate3d(".concat(tx, "px, ").concat(ty, "px, 0) scale3d(").concat(scale, ", ").concat(scale, ", 1)");
  }

  // --- Pan gesture handlers ---

  hammertime.on('panstart', function () {
    // Don't start pan if we're in the middle of a pinch
    if (isPinching) return;
    lastTx = tx;
    lastTy = ty;
  });
  hammertime.on('pan', function (e) {
    // Only allow panning when zoomed in and not pinching
    if (scale <= 1 || isPinching) return;
    var clamped = clampTranslate(lastTx + e.deltaX, lastTy + e.deltaY, scale);
    tx = clamped.x;
    ty = clamped.y;
    apply();
  });

  // --- Pinch gesture handlers ---

  hammertime.on('pinchstart', function (e) {
    // Ignore phantom pinchstart events that can fire immediately after pinchend
    if (isPinching) {
      return;
    }
    isPinching = true;

    // Capture the committed state from the previous gesture
    gestureStartScale = lastScale;
    gestureStartTx = lastTx;
    gestureStartTy = lastTy;

    // Calculate pinch center in viewport coordinates
    var ref = (container || img).getBoundingClientRect();
    var px = e.center.x - ref.left;
    var py = e.center.y - ref.top;

    // Convert pinch center to image-space coordinates
    // This allows us to keep the point under the fingers stationary during zoom
    pinchCx = (px - gestureStartTx) / gestureStartScale;
    pinchCy = (py - gestureStartTy) / gestureStartScale;
  });
  hammertime.on('pinch', function (e) {
    // Calculate new scale relative to gesture start
    scale = clampScale(gestureStartScale * e.scale);

    // Keep the pinch center stationary using the formula:
    // t' = t0 + c*(s0 - s')
    // Where t0 is initial translation, c is pinch center, s0 is initial scale, s' is new scale
    var nx = gestureStartTx + pinchCx * (gestureStartScale - scale);
    var ny = gestureStartTy + pinchCy * (gestureStartScale - scale);
    tx = nx;
    ty = ny;
    apply();
  });
  hammertime.on('pinchend', function (e) {
    if (!isPinching) {
      return;
    }
    e.preventDefault();

    // Calculate viewport and scaled image dimensions
    var baseW = img.offsetWidth || img.clientWidth || 0;
    var baseH = img.offsetHeight || img.clientHeight || 0;
    var viewportW = (container ? container.clientWidth : baseW) || baseW;
    var viewportH = (container ? container.clientHeight : baseH) || baseH;
    var scaledW = baseW * scale;
    var scaledH = baseH * scale;

    // Determine if clamping is needed
    var needsClampX = scaledW > viewportW && (tx > 0 || tx < viewportW - scaledW);
    var needsClampY = scaledH > viewportH && (ty > 0 || ty < viewportH - scaledH);
    var needsCentering = scaledW <= viewportW || scaledH <= viewportH;

    // Only clamp if image is out of bounds or needs centering
    if (needsClampX || needsClampY || needsCentering) {
      var clamped = clampTranslate(tx, ty, scale);
      tx = clamped.x;
      ty = clamped.y;
      apply();
    }

    // Commit the final values for next gesture
    lastScale = scale;
    lastTx = tx;
    lastTy = ty;

    // Delay clearing isPinching flag to prevent phantom pinchstart events
    // that can fire immediately after pinchend from re-anchoring the image
    setTimeout(function () {
      isPinching = false;
    }, 50);
  });

  // --- Double-tap to zoom ---

  hammertime.add(new Hammer.Tap({
    event: 'doubletap',
    taps: 2
  }));
  hammertime.on('doubletap', function (e) {
    // Calculate tap position
    var ref = (container || img).getBoundingClientRect();
    var px = e.center.x - ref.left;
    var py = e.center.y - ref.top;

    // Use current committed state as gesture start
    gestureStartScale = lastScale;
    gestureStartTx = lastTx;
    gestureStartTy = lastTy;

    // Convert tap point to image-space coordinates
    pinchCx = (px - gestureStartTx) / gestureStartScale;
    pinchCy = (py - gestureStartTy) / gestureStartScale;

    // Zoom to 2x
    scale = clampScale(gestureStartScale * 2);

    // Calculate new position to keep tap point stationary
    var nx = gestureStartTx + pinchCx * (gestureStartScale - scale);
    var ny = gestureStartTy + pinchCy * (gestureStartScale - scale);

    // Clamp and apply
    var clamped = clampTranslate(nx, ny, scale);
    tx = clamped.x;
    ty = clamped.y;

    // Commit values
    lastScale = scale;
    lastTx = tx;
    lastTy = ty;
    apply();
  });
  return hammertime;
}

/***/ }),
/* 330 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export CLOSE_ID */
/* unused harmony export ZOOM_SLIDER_ID */
/* unused harmony export ZOOM_THUMB_ID */
/* unused harmony export CONTENT_CLASSNAME */
/* harmony export (immutable) */ __webpack_exports__["a"] = sliderZoom;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_scriptjs__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_scriptjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_scriptjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__slick_carousel__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__slick_carousel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__slick_carousel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__slick_custom_paging__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lib_props__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__image_zoom__ = __webpack_require__(329);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__keyboard__ = __webpack_require__(3);
/**
 * Responsible for creating a slider zoom or in other words a carousel where the
 * images in the carousel can be interacted with so that they can be zoomed in
 * @module modules/zoom/sliderZoom
 */








var HAMMERJS_FALLBACK = 'https://ajax.googleapis.com/ajax/libs/hammerjs/2.0.8/hammer.min.js';
var renderNoop = function renderNoop() {
  return '';
};

/**
 * Makes a request for HammerJS.
 * @private
 * @return {Promise} Denotes when the request has been successfully executed
 */
var loadHammerJSFunc = function loadHammerJSFunc() {
  return new Promise(function (resolve) {
    __WEBPACK_IMPORTED_MODULE_2_scriptjs___default()(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib_props__["a" /* get */])('scripts.hammerJS', HAMMERJS_FALLBACK), function () {
      resolve(window.Hammer);
    });
  });
};

/**
 * Defines the options which can be provided for the image zoom.
 * @type {Object}
 */
var DEFAULTS = {
  loadHammerJS: loadHammerJSFunc,
  startingIndex: 0,
  speed: 300,
  slideFunc: function slideFunc(num) {
    return num;
  },
  menuRender: renderNoop,
  beforeContentRender: renderNoop,
  didRender: function didRender() {},
  beforeUnmount: function beforeUnmount() {},
  didUnmount: function didUnmount() {},
  didSlideTransition: function didSlideTransition(prev, current) {
    return {
      prev: prev,
      current: current
    };
  },
  zoomClickListener: function zoomClickListener() {},
  noImages: '',
  trapFocus: '',
  trapFocusFunc: __WEBPACK_IMPORTED_MODULE_7__keyboard__["a" /* default */].trapFocus.bind(__WEBPACK_IMPORTED_MODULE_7__keyboard__["a" /* default */]),
  releaseFocusFunc: __WEBPACK_IMPORTED_MODULE_7__keyboard__["a" /* default */].releaseFocus.bind(__WEBPACK_IMPORTED_MODULE_7__keyboard__["a" /* default */])
};

/**
 * Defines the id for the close element.
 * @type {String}
 */
var CLOSE_ID = 'close-zoom-menu';

/**
 * Defines the id for the zoom slider.
 * @type {String}
 */
var ZOOM_SLIDER_ID = 'zoom-slider';

/**
 * Defines the id for the zoom slider.
 * @type {String}
 */
var ZOOM_THUMB_ID = 'zoom-thumb';

/**
 * Defines the content className
 * @type {String}
 */
var CONTENT_CLASSNAME = 'zoom-slider__content';

/**
 * Binds an event to the close element
 * @private
 * @param  {Function} callback - The event handler for the close element
 */
var bindClose = function bindClose(callback) {
  var $closeButton = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(document.getElementById(CLOSE_ID));

  // Ensure the close button exists before binding
  if ($closeButton.length) {
    // Bind click event to the close button
    $closeButton.on('click.closeZoom', callback);
  } else {
    console.warn("Element with ID \"".concat(CLOSE_ID, "\" not found."));
  }

  // Bind keydown event to the document for the Escape key
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).on('keydown.closeZoom', function (e) {
    if (e.key === 'Escape' || e.key === 'Esc' || e.keyCode === 27) {
      if (!__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.dialog__container').is(':visible')) return;
      e.preventDefault();
      callback();
    }
  });
};
var logCloseZoom = function logCloseZoom() {
  if (typeof window.logEngagement === 'function') {
    window.logEngagement(window.location.href, 'pdp zoom modal', 'close zoom');
  }
};

/**
 * Closes the dialog.
 * @private
 * @param  {Dialog} dialog - Instance of a dialog
 * @param  {Function} didUnmount - Called once the dialog has closed
 */
var closeDialog = function closeDialog(didUnmount) {
  // Unbind the click and keydown events on close
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.image-carousel').off('click.product-zoom');
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.image-carousel').off('keydown.product-zoom');

  // Focus back on the parent element
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.image-carousel').focus();
  didUnmount();
  logCloseZoom();
};

/**
 * Stupid helper that concats the element id based on an id for a slide.
 * @private
 * @param  {string} id - The id of the slide being requested
 * @return {string} - A slide id
 */
var getSlideId = function getSlideId(id) {
  return "zoom-slider__item-".concat(id);
};

/**
 * Obtains a slide or image basd on the id provided in the template.
 * @private
 * @param  {number} id - The id of the slide being requested
 * @return {HTMLElement} An element representing a slide or image
 */
var getSlide = function getSlide(id) {
  return document.getElementById(getSlideId(id));
};

/**
 * Executes in the future the close callback. The callback is responsible for
 * clean up to ensure nothing is left in memory.
 * @private
 * @param  {jQuery} $zoomSlider
 * @param  {Hammer} hammer - An instance of Hammer from hammerjs
 * @param  {Function} didUnmount - Used to denote when closed
 * @return {Function} Callback function used for the event
 */
var teardownFull = function teardownFull($zoomSlider, hammer, beforeUnmount, didUnmount, zoomClickListener) {
  return function () {
    beforeUnmount();
    hammer.destroy();
    $zoomSlider.slick('unslick');
    // Properly close modal first
    __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.modal.close();
    // Remove the modal HTML from the DOM
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#zoom-modal').remove();
    closeDialog(didUnmount);
    zoomClickListener();
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).off('keydown.closeZoom');
    // bring back NTF
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-fixed-corner').show();
  };
};

/**
 * Simple rendering when no images are found.
 * @private
 * @param  {String} noImages - Text indicating no images were found
 * @return {string} Template containing content around no visible images
 */
var renderNoImages = function renderNoImages(_ref) {
  var noImages = _ref.noImages;
  return "\n  <p class=\"".concat(CONTENT_CLASSNAME, "\">").concat(noImages, "</p>\n");
};

/**
 * Template containing what is to be rendered in the dialog.
 * @private
 * @param  {array} images - A list of images
 * @param  {Function} [menuRender=renderNoop] - Used for additional rendering
 * @param  {Function} [beforeContentRender=renderNoop] - Optional rendering
 * before the main content
 * @return {String} A fully rendered template as a string
 */
var renderDialog = function renderDialog(_ref2) {
  var images = _ref2.images,
    _ref2$imagesRetina = _ref2.imagesRetina,
    imagesRetina = _ref2$imagesRetina === void 0 ? [] : _ref2$imagesRetina,
    videos = _ref2.videos,
    noImages = _ref2.noImages,
    _ref2$menuRender = _ref2.menuRender,
    menuRender = _ref2$menuRender === void 0 ? renderNoop : _ref2$menuRender,
    _ref2$beforeContentRe = _ref2.beforeContentRender,
    beforeContentRender = _ref2$beforeContentRe === void 0 ? renderNoop : _ref2$beforeContentRe;
  return "\n    ".concat(beforeContentRender(), "\n    <div id=\"zoom-modal\" class=\"modal\">\n          <h2 class=\"modal__hed u-screen-reader\">Zoom Modal</h2>\n          <div id=\"zoom-menu\" class=\"zoom-menu\">\n      <span class=\"zoom-menu__extra\">").concat(menuRender(), "</span>\n      <button id=\"").concat(CLOSE_ID, "\" class=\"js-modal-close zoom-menu__close\">\n        <span class=\"icon icon--md icon--x-icon\">\n          <svg aria-hidden=\"true\" focusable=\"false\" viewBox=\"0 0 16 16\">\n            <path d=\"M9.06 8l2.72-2.72A.75.75 0 0 0 10.72 4.22L8 6.94 5.28 4.22A.75.75 0 0 0 4.22 5.28L6.94 8l-2.72 2.72A.75.75 0 1 0 5.28 11.78L8 9.06l2.72 2.72a.75.75 0 0 0 1.061-1.061z\"/>\n          </svg>\n        </span>\n      </button>\n    </div>\n\n    <div id=\"").concat(ZOOM_SLIDER_ID, "\" class=\"zoom-slider u-margin-l--none\">\n      ").concat(images.length ? images.map(function (src2x, i) {
    // Keep your existing mp4 handling
    if (src2x.includes('.mp4')) {
      return "<div><video class=\"zoom-slider__item\" id=\"".concat(getSlideId(i), "\" data-video=\"true\" muted loop='loop' playsinline>\n                <source src=\"").concat(src2x, "\" type=\"video/mp4\">\n              </video></div>");
    }
    var src3x = imagesRetina[i]; // 3x candidate
    var srcset = src3x ? "".concat(src2x, " 2x, ").concat(src3x, " 3x") : "".concat(src2x, " 2x");
    return "<div><img src=\"".concat(src2x, "\" srcset=\"").concat(srcset, "\" class=\"zoom-slider__item\" id=\"").concat(getSlideId(i), "\"></div>");
  }).join('') : renderNoImages({
    noImages: noImages
  }), "\n\n      ").concat(videos.length ? videos.map(function (video, i) {
    return "<li><video class=\"zoom-slider__item\" id=\"".concat(getSlideId(i + images.length), "\" data-video=\"true\" controls>\n                <source src=\"").concat(video, "\" type=\"video/mp4\">\n              </video></li>");
  }).join('') : '', "\n    </div>\n  ");
};

/**
 * Merges or concats options to be passed along to slick.
 * @private
 * @param  {Object} [options={}] - Options sent along to slick
 * @return {Object} A mergingin of options for slick
 */
var mergeSliderOptions = function mergeSliderOptions() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.extend({
    arrows: false,
    dots: true,
    infinite: true,
    slidesToShow: 1,
    rtl: __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(window, 'rcProps.isRtl', false),
    appendDots: '#zoom-menu',
    dotsClass: 'slider-dots__menu image-carousel__dots',
    slide: 'li',
    customPaging: __WEBPACK_IMPORTED_MODULE_4__slick_custom_paging__["a" /* default */],
    touchThreshold: 20
  }, options);
};

// When the slide is changing
function playPauseVideo(slick, control) {
  var currentSlide = slick.find('.slick-current');
  var player = currentSlide.find('iframe').get(0) || currentSlide.find('video').get(0);
  if (!player) return;
  if (player !== null) {
    if (control === 'play') {
      player.play();
    } else {
      player.pause();
    }
  }
}
var focusOnStartingIndex = function focusOnStartingIndex(startingIndex) {
  if (__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.focus-active').length) {
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.horizontal-scroll__item').eq(startingIndex).focus();
  }
};

/**
 * Responsible for rendering a slider zoom. More specifically, it will create
 * a dialog/modal such that n number of images are used for creating a slider.
 * On top of that, each image will have the ability for pinch/zoom/moving
 * around an image such that the image can be examined by the end user.
 * @see DEFAULTS
 * @param {array} images - A list of images used for the slider and zooming
 * @param {Object} options - Additional hooks to interact with the slider zoom
 * @return {Promise} Denotes when the slier zoom has been fully rendered
 */
function sliderZoom(images) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _$$extend = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.extend({}, DEFAULTS, options),
    startingIndex = _$$extend.startingIndex,
    speed = _$$extend.speed,
    slideFunc = _$$extend.slideFunc,
    menuRender = _$$extend.menuRender,
    didRender = _$$extend.didRender,
    beforeUnmount = _$$extend.beforeUnmount,
    didUnmount = _$$extend.didUnmount,
    loadHammerJS = _$$extend.loadHammerJS,
    didSlideTransition = _$$extend.didSlideTransition,
    noImages = _$$extend.noImages,
    zoomClickListener = _$$extend.zoomClickListener,
    beforeContentRender = _$$extend.beforeContentRender;
  var videos = options.videos || [];
  return loadHammerJS().then(function (Hammer) {
    var output = renderDialog({
      images: images,
      videos: videos,
      menuRender: menuRender,
      noImages: noImages,
      beforeContentRender: beforeContentRender
    });

    // hide NTF
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-fixed-corner').hide();
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#zoom-modal').remove();
    var $modalHtml = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(output);
    $modalHtml.appendTo('body');
    __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.modal({
      type: 'full',
      open: 'zoom-modal',
      triggerOpen: true
    });
    didRender();
    if (!images.length) {
      bindClose(function () {
        closeDialog(didUnmount);
      });
      return;
    }
    slideFunc(startingIndex);
    var $zoomSlider = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(document.getElementById(ZOOM_SLIDER_ID));
    var currentSliderItem = getSlide(startingIndex);
    var hammerInstance = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__image_zoom__["a" /* default */])(Hammer, currentSliderItem);
    var currentNum = startingIndex;
    var previous;
    var isVideo = false;
    var dotLength = $zoomSlider.children().length;
    var mergeSliderOptionsParams = {
      speed: speed,
      initialSlide: startingIndex,
      dots: dotLength > 1
    };
    $zoomSlider.on('init', function (evt, slick) {
      slick.$slides.each(function (i, slide) {
        if (__WEBPACK_IMPORTED_MODULE_0_jquery___default()(slide).children('video').length) {
          __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.zoom-menu .image-carousel__dots li a').eq(i).addClass('image-carousel__dot-button--vid');
        }
      });
      images.forEach(function (value, index) {
        // if slide is video type, change the pagination to
        // show the play button instead of the default circle
        if (value.toLowerCase().endsWith('.mp4')) {
          __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#zoom-menu .slider-dots__menu li button').eq(index).addClass('image-carousel__dot-button--vid');
        }
      });
      playPauseVideo($zoomSlider, 'play');
    }).on('afterChange', function (evt, slide, currentSlide) {
      // when at the beginning or end, do not reset zooming
      if (currentNum === currentSlide) {
        return;
      }
      currentNum = currentSlide;
      slideFunc(currentNum);
      previous = currentSliderItem;
      hammerInstance.destroy();
      beforeUnmount();
      currentSliderItem = getSlide(currentNum);
      isVideo = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(currentSliderItem).data('video');
      if (!isVideo) {
        hammerInstance = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__image_zoom__["a" /* default */])(Hammer, currentSliderItem);
      }

      // use a setTimeout instead of the afterChange event since it'll
      // provide to long of a delay between swipe change when the image
      // has been zoomed in too much, yeah, a whole lot of edge cases
      // happening here.
      setTimeout(function () {
        /* eslint-disable no-param-reassign */
        previous.style.transform = 'none';
        /* eslint-enable no-param-reassign */
        didSlideTransition(previous, currentSliderItem);
      }, speed);

      // video play/pause
      playPauseVideo($zoomSlider, 'pause');
    }).on('beforeChange', function (event, slick) {
      var $slick = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(slick.$slider);
      playPauseVideo($slick, 'pause');
    }).on('afterChange', function (event, slick) {
      var $slick = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(slick.$slider);
      playPauseVideo($slick, 'play');
    });
    $zoomSlider.slick(mergeSliderOptions(mergeSliderOptionsParams));
    focusOnStartingIndex(startingIndex);
    bindClose(teardownFull($zoomSlider, hammerInstance, beforeUnmount, didUnmount, zoomClickListener));
  });
}

/***/ }),
/* 331 */
/***/ (function(module, exports, __webpack_require__) {

/*!
 * Cropper.js v1.6.2
 * https://fengyuanchen.github.io/cropperjs
 *
 * Copyright 2015-present Chen Fengyuan
 * Released under the MIT license
 *
 * Date: 2024-04-21T07:43:05.335Z
 */

(function (global, factory) {
   true ? module.exports = factory() :
  typeof define === 'function' && define.amd ? define(factory) :
  (global = typeof globalThis !== 'undefined' ? globalThis : global || self, global.Cropper = factory());
})(this, (function () { 'use strict';

  function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
      var o = Object.getOwnPropertySymbols(e);
      r && (o = o.filter(function (r) {
        return Object.getOwnPropertyDescriptor(e, r).enumerable;
      })), t.push.apply(t, o);
    }
    return t;
  }
  function _objectSpread2(e) {
    for (var r = 1; r < arguments.length; r++) {
      var t = null != arguments[r] ? arguments[r] : {};
      r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
        _defineProperty(e, r, t[r]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
        Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
      });
    }
    return e;
  }
  function _toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
      var i = e.call(t, r || "default");
      if ("object" != typeof i) return i;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
  }
  function _toPropertyKey(t) {
    var i = _toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
  }
  function _typeof(o) {
    "@babel/helpers - typeof";

    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
      return typeof o;
    } : function (o) {
      return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, _typeof(o);
  }
  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }
  function _defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
    }
  }
  function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
      writable: false
    });
    return Constructor;
  }
  function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }
    return obj;
  }
  function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
  }
  function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
  }
  function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
  }
  function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
  }
  function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
    return arr2;
  }
  function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }

  var IS_BROWSER = typeof window !== 'undefined' && typeof window.document !== 'undefined';
  var WINDOW = IS_BROWSER ? window : {};
  var IS_TOUCH_DEVICE = IS_BROWSER && WINDOW.document.documentElement ? 'ontouchstart' in WINDOW.document.documentElement : false;
  var HAS_POINTER_EVENT = IS_BROWSER ? 'PointerEvent' in WINDOW : false;
  var NAMESPACE = 'cropper';

  // Actions
  var ACTION_ALL = 'all';
  var ACTION_CROP = 'crop';
  var ACTION_MOVE = 'move';
  var ACTION_ZOOM = 'zoom';
  var ACTION_EAST = 'e';
  var ACTION_WEST = 'w';
  var ACTION_SOUTH = 's';
  var ACTION_NORTH = 'n';
  var ACTION_NORTH_EAST = 'ne';
  var ACTION_NORTH_WEST = 'nw';
  var ACTION_SOUTH_EAST = 'se';
  var ACTION_SOUTH_WEST = 'sw';

  // Classes
  var CLASS_CROP = "".concat(NAMESPACE, "-crop");
  var CLASS_DISABLED = "".concat(NAMESPACE, "-disabled");
  var CLASS_HIDDEN = "".concat(NAMESPACE, "-hidden");
  var CLASS_HIDE = "".concat(NAMESPACE, "-hide");
  var CLASS_INVISIBLE = "".concat(NAMESPACE, "-invisible");
  var CLASS_MODAL = "".concat(NAMESPACE, "-modal");
  var CLASS_MOVE = "".concat(NAMESPACE, "-move");

  // Data keys
  var DATA_ACTION = "".concat(NAMESPACE, "Action");
  var DATA_PREVIEW = "".concat(NAMESPACE, "Preview");

  // Drag modes
  var DRAG_MODE_CROP = 'crop';
  var DRAG_MODE_MOVE = 'move';
  var DRAG_MODE_NONE = 'none';

  // Events
  var EVENT_CROP = 'crop';
  var EVENT_CROP_END = 'cropend';
  var EVENT_CROP_MOVE = 'cropmove';
  var EVENT_CROP_START = 'cropstart';
  var EVENT_DBLCLICK = 'dblclick';
  var EVENT_TOUCH_START = IS_TOUCH_DEVICE ? 'touchstart' : 'mousedown';
  var EVENT_TOUCH_MOVE = IS_TOUCH_DEVICE ? 'touchmove' : 'mousemove';
  var EVENT_TOUCH_END = IS_TOUCH_DEVICE ? 'touchend touchcancel' : 'mouseup';
  var EVENT_POINTER_DOWN = HAS_POINTER_EVENT ? 'pointerdown' : EVENT_TOUCH_START;
  var EVENT_POINTER_MOVE = HAS_POINTER_EVENT ? 'pointermove' : EVENT_TOUCH_MOVE;
  var EVENT_POINTER_UP = HAS_POINTER_EVENT ? 'pointerup pointercancel' : EVENT_TOUCH_END;
  var EVENT_READY = 'ready';
  var EVENT_RESIZE = 'resize';
  var EVENT_WHEEL = 'wheel';
  var EVENT_ZOOM = 'zoom';

  // Mime types
  var MIME_TYPE_JPEG = 'image/jpeg';

  // RegExps
  var REGEXP_ACTIONS = /^e|w|s|n|se|sw|ne|nw|all|crop|move|zoom$/;
  var REGEXP_DATA_URL = /^data:/;
  var REGEXP_DATA_URL_JPEG = /^data:image\/jpeg;base64,/;
  var REGEXP_TAG_NAME = /^img|canvas$/i;

  // Misc
  // Inspired by the default width and height of a canvas element.
  var MIN_CONTAINER_WIDTH = 200;
  var MIN_CONTAINER_HEIGHT = 100;

  var DEFAULTS = {
    // Define the view mode of the cropper
    viewMode: 0,
    // 0, 1, 2, 3

    // Define the dragging mode of the cropper
    dragMode: DRAG_MODE_CROP,
    // 'crop', 'move' or 'none'

    // Define the initial aspect ratio of the crop box
    initialAspectRatio: NaN,
    // Define the aspect ratio of the crop box
    aspectRatio: NaN,
    // An object with the previous cropping result data
    data: null,
    // A selector for adding extra containers to preview
    preview: '',
    // Re-render the cropper when resize the window
    responsive: true,
    // Restore the cropped area after resize the window
    restore: true,
    // Check if the current image is a cross-origin image
    checkCrossOrigin: true,
    // Check the current image's Exif Orientation information
    checkOrientation: true,
    // Show the black modal
    modal: true,
    // Show the dashed lines for guiding
    guides: true,
    // Show the center indicator for guiding
    center: true,
    // Show the white modal to highlight the crop box
    highlight: true,
    // Show the grid background
    background: true,
    // Enable to crop the image automatically when initialize
    autoCrop: true,
    // Define the percentage of automatic cropping area when initializes
    autoCropArea: 0.8,
    // Enable to move the image
    movable: true,
    // Enable to rotate the image
    rotatable: true,
    // Enable to scale the image
    scalable: true,
    // Enable to zoom the image
    zoomable: true,
    // Enable to zoom the image by dragging touch
    zoomOnTouch: true,
    // Enable to zoom the image by wheeling mouse
    zoomOnWheel: true,
    // Define zoom ratio when zoom the image by wheeling mouse
    wheelZoomRatio: 0.1,
    // Enable to move the crop box
    cropBoxMovable: true,
    // Enable to resize the crop box
    cropBoxResizable: true,
    // Toggle drag mode between "crop" and "move" when click twice on the cropper
    toggleDragModeOnDblclick: true,
    // Size limitation
    minCanvasWidth: 0,
    minCanvasHeight: 0,
    minCropBoxWidth: 0,
    minCropBoxHeight: 0,
    minContainerWidth: MIN_CONTAINER_WIDTH,
    minContainerHeight: MIN_CONTAINER_HEIGHT,
    // Shortcuts of events
    ready: null,
    cropstart: null,
    cropmove: null,
    cropend: null,
    crop: null,
    zoom: null
  };

  var TEMPLATE = '<div class="cropper-container" touch-action="none">' + '<div class="cropper-wrap-box">' + '<div class="cropper-canvas"></div>' + '</div>' + '<div class="cropper-drag-box"></div>' + '<div class="cropper-crop-box">' + '<span class="cropper-view-box"></span>' + '<span class="cropper-dashed dashed-h"></span>' + '<span class="cropper-dashed dashed-v"></span>' + '<span class="cropper-center"></span>' + '<span class="cropper-face"></span>' + '<span class="cropper-line line-e" data-cropper-action="e"></span>' + '<span class="cropper-line line-n" data-cropper-action="n"></span>' + '<span class="cropper-line line-w" data-cropper-action="w"></span>' + '<span class="cropper-line line-s" data-cropper-action="s"></span>' + '<span class="cropper-point point-e" data-cropper-action="e"></span>' + '<span class="cropper-point point-n" data-cropper-action="n"></span>' + '<span class="cropper-point point-w" data-cropper-action="w"></span>' + '<span class="cropper-point point-s" data-cropper-action="s"></span>' + '<span class="cropper-point point-ne" data-cropper-action="ne"></span>' + '<span class="cropper-point point-nw" data-cropper-action="nw"></span>' + '<span class="cropper-point point-sw" data-cropper-action="sw"></span>' + '<span class="cropper-point point-se" data-cropper-action="se"></span>' + '</div>' + '</div>';

  /**
   * Check if the given value is not a number.
   */
  var isNaN = Number.isNaN || WINDOW.isNaN;

  /**
   * Check if the given value is a number.
   * @param {*} value - The value to check.
   * @returns {boolean} Returns `true` if the given value is a number, else `false`.
   */
  function isNumber(value) {
    return typeof value === 'number' && !isNaN(value);
  }

  /**
   * Check if the given value is a positive number.
   * @param {*} value - The value to check.
   * @returns {boolean} Returns `true` if the given value is a positive number, else `false`.
   */
  var isPositiveNumber = function isPositiveNumber(value) {
    return value > 0 && value < Infinity;
  };

  /**
   * Check if the given value is undefined.
   * @param {*} value - The value to check.
   * @returns {boolean} Returns `true` if the given value is undefined, else `false`.
   */
  function isUndefined(value) {
    return typeof value === 'undefined';
  }

  /**
   * Check if the given value is an object.
   * @param {*} value - The value to check.
   * @returns {boolean} Returns `true` if the given value is an object, else `false`.
   */
  function isObject(value) {
    return _typeof(value) === 'object' && value !== null;
  }
  var hasOwnProperty = Object.prototype.hasOwnProperty;

  /**
   * Check if the given value is a plain object.
   * @param {*} value - The value to check.
   * @returns {boolean} Returns `true` if the given value is a plain object, else `false`.
   */
  function isPlainObject(value) {
    if (!isObject(value)) {
      return false;
    }
    try {
      var _constructor = value.constructor;
      var prototype = _constructor.prototype;
      return _constructor && prototype && hasOwnProperty.call(prototype, 'isPrototypeOf');
    } catch (error) {
      return false;
    }
  }

  /**
   * Check if the given value is a function.
   * @param {*} value - The value to check.
   * @returns {boolean} Returns `true` if the given value is a function, else `false`.
   */
  function isFunction(value) {
    return typeof value === 'function';
  }
  var slice = Array.prototype.slice;

  /**
   * Convert array-like or iterable object to an array.
   * @param {*} value - The value to convert.
   * @returns {Array} Returns a new array.
   */
  function toArray(value) {
    return Array.from ? Array.from(value) : slice.call(value);
  }

  /**
   * Iterate the given data.
   * @param {*} data - The data to iterate.
   * @param {Function} callback - The process function for each element.
   * @returns {*} The original data.
   */
  function forEach(data, callback) {
    if (data && isFunction(callback)) {
      if (Array.isArray(data) || isNumber(data.length) /* array-like */) {
        toArray(data).forEach(function (value, key) {
          callback.call(data, value, key, data);
        });
      } else if (isObject(data)) {
        Object.keys(data).forEach(function (key) {
          callback.call(data, data[key], key, data);
        });
      }
    }
    return data;
  }

  /**
   * Extend the given object.
   * @param {*} target - The target object to extend.
   * @param {*} args - The rest objects for merging to the target object.
   * @returns {Object} The extended object.
   */
  var assign = Object.assign || function assign(target) {
    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }
    if (isObject(target) && args.length > 0) {
      args.forEach(function (arg) {
        if (isObject(arg)) {
          Object.keys(arg).forEach(function (key) {
            target[key] = arg[key];
          });
        }
      });
    }
    return target;
  };
  var REGEXP_DECIMALS = /\.\d*(?:0|9){12}\d*$/;

  /**
   * Normalize decimal number.
   * Check out {@link https://0.30000000000000004.com/}
   * @param {number} value - The value to normalize.
   * @param {number} [times=100000000000] - The times for normalizing.
   * @returns {number} Returns the normalized number.
   */
  function normalizeDecimalNumber(value) {
    var times = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 100000000000;
    return REGEXP_DECIMALS.test(value) ? Math.round(value * times) / times : value;
  }
  var REGEXP_SUFFIX = /^width|height|left|top|marginLeft|marginTop$/;

  /**
   * Apply styles to the given element.
   * @param {Element} element - The target element.
   * @param {Object} styles - The styles for applying.
   */
  function setStyle(element, styles) {
    var style = element.style;
    forEach(styles, function (value, property) {
      if (REGEXP_SUFFIX.test(property) && isNumber(value)) {
        value = "".concat(value, "px");
      }
      style[property] = value;
    });
  }

  /**
   * Check if the given element has a special class.
   * @param {Element} element - The element to check.
   * @param {string} value - The class to search.
   * @returns {boolean} Returns `true` if the special class was found.
   */
  function hasClass(element, value) {
    return element.classList ? element.classList.contains(value) : element.className.indexOf(value) > -1;
  }

  /**
   * Add classes to the given element.
   * @param {Element} element - The target element.
   * @param {string} value - The classes to be added.
   */
  function addClass(element, value) {
    if (!value) {
      return;
    }
    if (isNumber(element.length)) {
      forEach(element, function (elem) {
        addClass(elem, value);
      });
      return;
    }
    if (element.classList) {
      element.classList.add(value);
      return;
    }
    var className = element.className.trim();
    if (!className) {
      element.className = value;
    } else if (className.indexOf(value) < 0) {
      element.className = "".concat(className, " ").concat(value);
    }
  }

  /**
   * Remove classes from the given element.
   * @param {Element} element - The target element.
   * @param {string} value - The classes to be removed.
   */
  function removeClass(element, value) {
    if (!value) {
      return;
    }
    if (isNumber(element.length)) {
      forEach(element, function (elem) {
        removeClass(elem, value);
      });
      return;
    }
    if (element.classList) {
      element.classList.remove(value);
      return;
    }
    if (element.className.indexOf(value) >= 0) {
      element.className = element.className.replace(value, '');
    }
  }

  /**
   * Add or remove classes from the given element.
   * @param {Element} element - The target element.
   * @param {string} value - The classes to be toggled.
   * @param {boolean} added - Add only.
   */
  function toggleClass(element, value, added) {
    if (!value) {
      return;
    }
    if (isNumber(element.length)) {
      forEach(element, function (elem) {
        toggleClass(elem, value, added);
      });
      return;
    }

    // IE10-11 doesn't support the second parameter of `classList.toggle`
    if (added) {
      addClass(element, value);
    } else {
      removeClass(element, value);
    }
  }
  var REGEXP_CAMEL_CASE = /([a-z\d])([A-Z])/g;

  /**
   * Transform the given string from camelCase to kebab-case
   * @param {string} value - The value to transform.
   * @returns {string} The transformed value.
   */
  function toParamCase(value) {
    return value.replace(REGEXP_CAMEL_CASE, '$1-$2').toLowerCase();
  }

  /**
   * Get data from the given element.
   * @param {Element} element - The target element.
   * @param {string} name - The data key to get.
   * @returns {string} The data value.
   */
  function getData(element, name) {
    if (isObject(element[name])) {
      return element[name];
    }
    if (element.dataset) {
      return element.dataset[name];
    }
    return element.getAttribute("data-".concat(toParamCase(name)));
  }

  /**
   * Set data to the given element.
   * @param {Element} element - The target element.
   * @param {string} name - The data key to set.
   * @param {string} data - The data value.
   */
  function setData(element, name, data) {
    if (isObject(data)) {
      element[name] = data;
    } else if (element.dataset) {
      element.dataset[name] = data;
    } else {
      element.setAttribute("data-".concat(toParamCase(name)), data);
    }
  }

  /**
   * Remove data from the given element.
   * @param {Element} element - The target element.
   * @param {string} name - The data key to remove.
   */
  function removeData(element, name) {
    if (isObject(element[name])) {
      try {
        delete element[name];
      } catch (error) {
        element[name] = undefined;
      }
    } else if (element.dataset) {
      // #128 Safari not allows to delete dataset property
      try {
        delete element.dataset[name];
      } catch (error) {
        element.dataset[name] = undefined;
      }
    } else {
      element.removeAttribute("data-".concat(toParamCase(name)));
    }
  }
  var REGEXP_SPACES = /\s\s*/;
  var onceSupported = function () {
    var supported = false;
    if (IS_BROWSER) {
      var once = false;
      var listener = function listener() {};
      var options = Object.defineProperty({}, 'once', {
        get: function get() {
          supported = true;
          return once;
        },
        /**
         * This setter can fix a `TypeError` in strict mode
         * {@link https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Errors/Getter_only}
         * @param {boolean} value - The value to set
         */
        set: function set(value) {
          once = value;
        }
      });
      WINDOW.addEventListener('test', listener, options);
      WINDOW.removeEventListener('test', listener, options);
    }
    return supported;
  }();

  /**
   * Remove event listener from the target element.
   * @param {Element} element - The event target.
   * @param {string} type - The event type(s).
   * @param {Function} listener - The event listener.
   * @param {Object} options - The event options.
   */
  function removeListener(element, type, listener) {
    var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
    var handler = listener;
    type.trim().split(REGEXP_SPACES).forEach(function (event) {
      if (!onceSupported) {
        var listeners = element.listeners;
        if (listeners && listeners[event] && listeners[event][listener]) {
          handler = listeners[event][listener];
          delete listeners[event][listener];
          if (Object.keys(listeners[event]).length === 0) {
            delete listeners[event];
          }
          if (Object.keys(listeners).length === 0) {
            delete element.listeners;
          }
        }
      }
      element.removeEventListener(event, handler, options);
    });
  }

  /**
   * Add event listener to the target element.
   * @param {Element} element - The event target.
   * @param {string} type - The event type(s).
   * @param {Function} listener - The event listener.
   * @param {Object} options - The event options.
   */
  function addListener(element, type, listener) {
    var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
    var _handler = listener;
    type.trim().split(REGEXP_SPACES).forEach(function (event) {
      if (options.once && !onceSupported) {
        var _element$listeners = element.listeners,
          listeners = _element$listeners === void 0 ? {} : _element$listeners;
        _handler = function handler() {
          delete listeners[event][listener];
          element.removeEventListener(event, _handler, options);
          for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
            args[_key2] = arguments[_key2];
          }
          listener.apply(element, args);
        };
        if (!listeners[event]) {
          listeners[event] = {};
        }
        if (listeners[event][listener]) {
          element.removeEventListener(event, listeners[event][listener], options);
        }
        listeners[event][listener] = _handler;
        element.listeners = listeners;
      }
      element.addEventListener(event, _handler, options);
    });
  }

  /**
   * Dispatch event on the target element.
   * @param {Element} element - The event target.
   * @param {string} type - The event type(s).
   * @param {Object} data - The additional event data.
   * @returns {boolean} Indicate if the event is default prevented or not.
   */
  function dispatchEvent(element, type, data) {
    var event;

    // Event and CustomEvent on IE9-11 are global objects, not constructors
    if (isFunction(Event) && isFunction(CustomEvent)) {
      event = new CustomEvent(type, {
        detail: data,
        bubbles: true,
        cancelable: true
      });
    } else {
      event = document.createEvent('CustomEvent');
      event.initCustomEvent(type, true, true, data);
    }
    return element.dispatchEvent(event);
  }

  /**
   * Get the offset base on the document.
   * @param {Element} element - The target element.
   * @returns {Object} The offset data.
   */
  function getOffset(element) {
    var box = element.getBoundingClientRect();
    return {
      left: box.left + (window.pageXOffset - document.documentElement.clientLeft),
      top: box.top + (window.pageYOffset - document.documentElement.clientTop)
    };
  }
  var location = WINDOW.location;
  var REGEXP_ORIGINS = /^(\w+:)\/\/([^:/?#]*):?(\d*)/i;

  /**
   * Check if the given URL is a cross origin URL.
   * @param {string} url - The target URL.
   * @returns {boolean} Returns `true` if the given URL is a cross origin URL, else `false`.
   */
  function isCrossOriginURL(url) {
    var parts = url.match(REGEXP_ORIGINS);
    return parts !== null && (parts[1] !== location.protocol || parts[2] !== location.hostname || parts[3] !== location.port);
  }

  /**
   * Add timestamp to the given URL.
   * @param {string} url - The target URL.
   * @returns {string} The result URL.
   */
  function addTimestamp(url) {
    var timestamp = "timestamp=".concat(new Date().getTime());
    return url + (url.indexOf('?') === -1 ? '?' : '&') + timestamp;
  }

  /**
   * Get transforms base on the given object.
   * @param {Object} obj - The target object.
   * @returns {string} A string contains transform values.
   */
  function getTransforms(_ref) {
    var rotate = _ref.rotate,
      scaleX = _ref.scaleX,
      scaleY = _ref.scaleY,
      translateX = _ref.translateX,
      translateY = _ref.translateY;
    var values = [];
    if (isNumber(translateX) && translateX !== 0) {
      values.push("translateX(".concat(translateX, "px)"));
    }
    if (isNumber(translateY) && translateY !== 0) {
      values.push("translateY(".concat(translateY, "px)"));
    }

    // Rotate should come first before scale to match orientation transform
    if (isNumber(rotate) && rotate !== 0) {
      values.push("rotate(".concat(rotate, "deg)"));
    }
    if (isNumber(scaleX) && scaleX !== 1) {
      values.push("scaleX(".concat(scaleX, ")"));
    }
    if (isNumber(scaleY) && scaleY !== 1) {
      values.push("scaleY(".concat(scaleY, ")"));
    }
    var transform = values.length ? values.join(' ') : 'none';
    return {
      WebkitTransform: transform,
      msTransform: transform,
      transform: transform
    };
  }

  /**
   * Get the max ratio of a group of pointers.
   * @param {string} pointers - The target pointers.
   * @returns {number} The result ratio.
   */
  function getMaxZoomRatio(pointers) {
    var pointers2 = _objectSpread2({}, pointers);
    var maxRatio = 0;
    forEach(pointers, function (pointer, pointerId) {
      delete pointers2[pointerId];
      forEach(pointers2, function (pointer2) {
        var x1 = Math.abs(pointer.startX - pointer2.startX);
        var y1 = Math.abs(pointer.startY - pointer2.startY);
        var x2 = Math.abs(pointer.endX - pointer2.endX);
        var y2 = Math.abs(pointer.endY - pointer2.endY);
        var z1 = Math.sqrt(x1 * x1 + y1 * y1);
        var z2 = Math.sqrt(x2 * x2 + y2 * y2);
        var ratio = (z2 - z1) / z1;
        if (Math.abs(ratio) > Math.abs(maxRatio)) {
          maxRatio = ratio;
        }
      });
    });
    return maxRatio;
  }

  /**
   * Get a pointer from an event object.
   * @param {Object} event - The target event object.
   * @param {boolean} endOnly - Indicates if only returns the end point coordinate or not.
   * @returns {Object} The result pointer contains start and/or end point coordinates.
   */
  function getPointer(_ref2, endOnly) {
    var pageX = _ref2.pageX,
      pageY = _ref2.pageY;
    var end = {
      endX: pageX,
      endY: pageY
    };
    return endOnly ? end : _objectSpread2({
      startX: pageX,
      startY: pageY
    }, end);
  }

  /**
   * Get the center point coordinate of a group of pointers.
   * @param {Object} pointers - The target pointers.
   * @returns {Object} The center point coordinate.
   */
  function getPointersCenter(pointers) {
    var pageX = 0;
    var pageY = 0;
    var count = 0;
    forEach(pointers, function (_ref3) {
      var startX = _ref3.startX,
        startY = _ref3.startY;
      pageX += startX;
      pageY += startY;
      count += 1;
    });
    pageX /= count;
    pageY /= count;
    return {
      pageX: pageX,
      pageY: pageY
    };
  }

  /**
   * Get the max sizes in a rectangle under the given aspect ratio.
   * @param {Object} data - The original sizes.
   * @param {string} [type='contain'] - The adjust type.
   * @returns {Object} The result sizes.
   */
  function getAdjustedSizes(_ref4) {
    var aspectRatio = _ref4.aspectRatio,
      height = _ref4.height,
      width = _ref4.width;
    var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'contain';
    var isValidWidth = isPositiveNumber(width);
    var isValidHeight = isPositiveNumber(height);
    if (isValidWidth && isValidHeight) {
      var adjustedWidth = height * aspectRatio;
      if (type === 'contain' && adjustedWidth > width || type === 'cover' && adjustedWidth < width) {
        height = width / aspectRatio;
      } else {
        width = height * aspectRatio;
      }
    } else if (isValidWidth) {
      height = width / aspectRatio;
    } else if (isValidHeight) {
      width = height * aspectRatio;
    }
    return {
      width: width,
      height: height
    };
  }

  /**
   * Get the new sizes of a rectangle after rotated.
   * @param {Object} data - The original sizes.
   * @returns {Object} The result sizes.
   */
  function getRotatedSizes(_ref5) {
    var width = _ref5.width,
      height = _ref5.height,
      degree = _ref5.degree;
    degree = Math.abs(degree) % 180;
    if (degree === 90) {
      return {
        width: height,
        height: width
      };
    }
    var arc = degree % 90 * Math.PI / 180;
    var sinArc = Math.sin(arc);
    var cosArc = Math.cos(arc);
    var newWidth = width * cosArc + height * sinArc;
    var newHeight = width * sinArc + height * cosArc;
    return degree > 90 ? {
      width: newHeight,
      height: newWidth
    } : {
      width: newWidth,
      height: newHeight
    };
  }

  /**
   * Get a canvas which drew the given image.
   * @param {HTMLImageElement} image - The image for drawing.
   * @param {Object} imageData - The image data.
   * @param {Object} canvasData - The canvas data.
   * @param {Object} options - The options.
   * @returns {HTMLCanvasElement} The result canvas.
   */
  function getSourceCanvas(image, _ref6, _ref7, _ref8) {
    var imageAspectRatio = _ref6.aspectRatio,
      imageNaturalWidth = _ref6.naturalWidth,
      imageNaturalHeight = _ref6.naturalHeight,
      _ref6$rotate = _ref6.rotate,
      rotate = _ref6$rotate === void 0 ? 0 : _ref6$rotate,
      _ref6$scaleX = _ref6.scaleX,
      scaleX = _ref6$scaleX === void 0 ? 1 : _ref6$scaleX,
      _ref6$scaleY = _ref6.scaleY,
      scaleY = _ref6$scaleY === void 0 ? 1 : _ref6$scaleY;
    var aspectRatio = _ref7.aspectRatio,
      naturalWidth = _ref7.naturalWidth,
      naturalHeight = _ref7.naturalHeight;
    var _ref8$fillColor = _ref8.fillColor,
      fillColor = _ref8$fillColor === void 0 ? 'transparent' : _ref8$fillColor,
      _ref8$imageSmoothingE = _ref8.imageSmoothingEnabled,
      imageSmoothingEnabled = _ref8$imageSmoothingE === void 0 ? true : _ref8$imageSmoothingE,
      _ref8$imageSmoothingQ = _ref8.imageSmoothingQuality,
      imageSmoothingQuality = _ref8$imageSmoothingQ === void 0 ? 'low' : _ref8$imageSmoothingQ,
      _ref8$maxWidth = _ref8.maxWidth,
      maxWidth = _ref8$maxWidth === void 0 ? Infinity : _ref8$maxWidth,
      _ref8$maxHeight = _ref8.maxHeight,
      maxHeight = _ref8$maxHeight === void 0 ? Infinity : _ref8$maxHeight,
      _ref8$minWidth = _ref8.minWidth,
      minWidth = _ref8$minWidth === void 0 ? 0 : _ref8$minWidth,
      _ref8$minHeight = _ref8.minHeight,
      minHeight = _ref8$minHeight === void 0 ? 0 : _ref8$minHeight;
    var canvas = document.createElement('canvas');
    var context = canvas.getContext('2d');
    var maxSizes = getAdjustedSizes({
      aspectRatio: aspectRatio,
      width: maxWidth,
      height: maxHeight
    });
    var minSizes = getAdjustedSizes({
      aspectRatio: aspectRatio,
      width: minWidth,
      height: minHeight
    }, 'cover');
    var width = Math.min(maxSizes.width, Math.max(minSizes.width, naturalWidth));
    var height = Math.min(maxSizes.height, Math.max(minSizes.height, naturalHeight));

    // Note: should always use image's natural sizes for drawing as
    // imageData.naturalWidth === canvasData.naturalHeight when rotate % 180 === 90
    var destMaxSizes = getAdjustedSizes({
      aspectRatio: imageAspectRatio,
      width: maxWidth,
      height: maxHeight
    });
    var destMinSizes = getAdjustedSizes({
      aspectRatio: imageAspectRatio,
      width: minWidth,
      height: minHeight
    }, 'cover');
    var destWidth = Math.min(destMaxSizes.width, Math.max(destMinSizes.width, imageNaturalWidth));
    var destHeight = Math.min(destMaxSizes.height, Math.max(destMinSizes.height, imageNaturalHeight));
    var params = [-destWidth / 2, -destHeight / 2, destWidth, destHeight];
    canvas.width = normalizeDecimalNumber(width);
    canvas.height = normalizeDecimalNumber(height);
    context.fillStyle = fillColor;
    context.fillRect(0, 0, width, height);
    context.save();
    context.translate(width / 2, height / 2);
    context.rotate(rotate * Math.PI / 180);
    context.scale(scaleX, scaleY);
    context.imageSmoothingEnabled = imageSmoothingEnabled;
    context.imageSmoothingQuality = imageSmoothingQuality;
    context.drawImage.apply(context, [image].concat(_toConsumableArray(params.map(function (param) {
      return Math.floor(normalizeDecimalNumber(param));
    }))));
    context.restore();
    return canvas;
  }
  var fromCharCode = String.fromCharCode;

  /**
   * Get string from char code in data view.
   * @param {DataView} dataView - The data view for read.
   * @param {number} start - The start index.
   * @param {number} length - The read length.
   * @returns {string} The read result.
   */
  function getStringFromCharCode(dataView, start, length) {
    var str = '';
    length += start;
    for (var i = start; i < length; i += 1) {
      str += fromCharCode(dataView.getUint8(i));
    }
    return str;
  }
  var REGEXP_DATA_URL_HEAD = /^data:.*,/;

  /**
   * Transform Data URL to array buffer.
   * @param {string} dataURL - The Data URL to transform.
   * @returns {ArrayBuffer} The result array buffer.
   */
  function dataURLToArrayBuffer(dataURL) {
    var base64 = dataURL.replace(REGEXP_DATA_URL_HEAD, '');
    var binary = atob(base64);
    var arrayBuffer = new ArrayBuffer(binary.length);
    var uint8 = new Uint8Array(arrayBuffer);
    forEach(uint8, function (value, i) {
      uint8[i] = binary.charCodeAt(i);
    });
    return arrayBuffer;
  }

  /**
   * Transform array buffer to Data URL.
   * @param {ArrayBuffer} arrayBuffer - The array buffer to transform.
   * @param {string} mimeType - The mime type of the Data URL.
   * @returns {string} The result Data URL.
   */
  function arrayBufferToDataURL(arrayBuffer, mimeType) {
    var chunks = [];

    // Chunk Typed Array for better performance (#435)
    var chunkSize = 8192;
    var uint8 = new Uint8Array(arrayBuffer);
    while (uint8.length > 0) {
      // XXX: Babel's `toConsumableArray` helper will throw error in IE or Safari 9
      // eslint-disable-next-line prefer-spread
      chunks.push(fromCharCode.apply(null, toArray(uint8.subarray(0, chunkSize))));
      uint8 = uint8.subarray(chunkSize);
    }
    return "data:".concat(mimeType, ";base64,").concat(btoa(chunks.join('')));
  }

  /**
   * Get orientation value from given array buffer.
   * @param {ArrayBuffer} arrayBuffer - The array buffer to read.
   * @returns {number} The read orientation value.
   */
  function resetAndGetOrientation(arrayBuffer) {
    var dataView = new DataView(arrayBuffer);
    var orientation;

    // Ignores range error when the image does not have correct Exif information
    try {
      var littleEndian;
      var app1Start;
      var ifdStart;

      // Only handle JPEG image (start by 0xFFD8)
      if (dataView.getUint8(0) === 0xFF && dataView.getUint8(1) === 0xD8) {
        var length = dataView.byteLength;
        var offset = 2;
        while (offset + 1 < length) {
          if (dataView.getUint8(offset) === 0xFF && dataView.getUint8(offset + 1) === 0xE1) {
            app1Start = offset;
            break;
          }
          offset += 1;
        }
      }
      if (app1Start) {
        var exifIDCode = app1Start + 4;
        var tiffOffset = app1Start + 10;
        if (getStringFromCharCode(dataView, exifIDCode, 4) === 'Exif') {
          var endianness = dataView.getUint16(tiffOffset);
          littleEndian = endianness === 0x4949;
          if (littleEndian || endianness === 0x4D4D /* bigEndian */) {
            if (dataView.getUint16(tiffOffset + 2, littleEndian) === 0x002A) {
              var firstIFDOffset = dataView.getUint32(tiffOffset + 4, littleEndian);
              if (firstIFDOffset >= 0x00000008) {
                ifdStart = tiffOffset + firstIFDOffset;
              }
            }
          }
        }
      }
      if (ifdStart) {
        var _length = dataView.getUint16(ifdStart, littleEndian);
        var _offset;
        var i;
        for (i = 0; i < _length; i += 1) {
          _offset = ifdStart + i * 12 + 2;
          if (dataView.getUint16(_offset, littleEndian) === 0x0112 /* Orientation */) {
            // 8 is the offset of the current tag's value
            _offset += 8;

            // Get the original orientation value
            orientation = dataView.getUint16(_offset, littleEndian);

            // Override the orientation with its default value
            dataView.setUint16(_offset, 1, littleEndian);
            break;
          }
        }
      }
    } catch (error) {
      orientation = 1;
    }
    return orientation;
  }

  /**
   * Parse Exif Orientation value.
   * @param {number} orientation - The orientation to parse.
   * @returns {Object} The parsed result.
   */
  function parseOrientation(orientation) {
    var rotate = 0;
    var scaleX = 1;
    var scaleY = 1;
    switch (orientation) {
      // Flip horizontal
      case 2:
        scaleX = -1;
        break;

      // Rotate left 180°
      case 3:
        rotate = -180;
        break;

      // Flip vertical
      case 4:
        scaleY = -1;
        break;

      // Flip vertical and rotate right 90°
      case 5:
        rotate = 90;
        scaleY = -1;
        break;

      // Rotate right 90°
      case 6:
        rotate = 90;
        break;

      // Flip horizontal and rotate right 90°
      case 7:
        rotate = 90;
        scaleX = -1;
        break;

      // Rotate left 90°
      case 8:
        rotate = -90;
        break;
    }
    return {
      rotate: rotate,
      scaleX: scaleX,
      scaleY: scaleY
    };
  }

  var render = {
    render: function render() {
      this.initContainer();
      this.initCanvas();
      this.initCropBox();
      this.renderCanvas();
      if (this.cropped) {
        this.renderCropBox();
      }
    },
    initContainer: function initContainer() {
      var element = this.element,
        options = this.options,
        container = this.container,
        cropper = this.cropper;
      var minWidth = Number(options.minContainerWidth);
      var minHeight = Number(options.minContainerHeight);
      addClass(cropper, CLASS_HIDDEN);
      removeClass(element, CLASS_HIDDEN);
      var containerData = {
        width: Math.max(container.offsetWidth, minWidth >= 0 ? minWidth : MIN_CONTAINER_WIDTH),
        height: Math.max(container.offsetHeight, minHeight >= 0 ? minHeight : MIN_CONTAINER_HEIGHT)
      };
      this.containerData = containerData;
      setStyle(cropper, {
        width: containerData.width,
        height: containerData.height
      });
      addClass(element, CLASS_HIDDEN);
      removeClass(cropper, CLASS_HIDDEN);
    },
    // Canvas (image wrapper)
    initCanvas: function initCanvas() {
      var containerData = this.containerData,
        imageData = this.imageData;
      var viewMode = this.options.viewMode;
      var rotated = Math.abs(imageData.rotate) % 180 === 90;
      var naturalWidth = rotated ? imageData.naturalHeight : imageData.naturalWidth;
      var naturalHeight = rotated ? imageData.naturalWidth : imageData.naturalHeight;
      var aspectRatio = naturalWidth / naturalHeight;
      var canvasWidth = containerData.width;
      var canvasHeight = containerData.height;
      if (containerData.height * aspectRatio > containerData.width) {
        if (viewMode === 3) {
          canvasWidth = containerData.height * aspectRatio;
        } else {
          canvasHeight = containerData.width / aspectRatio;
        }
      } else if (viewMode === 3) {
        canvasHeight = containerData.width / aspectRatio;
      } else {
        canvasWidth = containerData.height * aspectRatio;
      }
      var canvasData = {
        aspectRatio: aspectRatio,
        naturalWidth: naturalWidth,
        naturalHeight: naturalHeight,
        width: canvasWidth,
        height: canvasHeight
      };
      this.canvasData = canvasData;
      this.limited = viewMode === 1 || viewMode === 2;
      this.limitCanvas(true, true);
      canvasData.width = Math.min(Math.max(canvasData.width, canvasData.minWidth), canvasData.maxWidth);
      canvasData.height = Math.min(Math.max(canvasData.height, canvasData.minHeight), canvasData.maxHeight);
      canvasData.left = (containerData.width - canvasData.width) / 2;
      canvasData.top = (containerData.height - canvasData.height) / 2;
      canvasData.oldLeft = canvasData.left;
      canvasData.oldTop = canvasData.top;
      this.initialCanvasData = assign({}, canvasData);
    },
    limitCanvas: function limitCanvas(sizeLimited, positionLimited) {
      var options = this.options,
        containerData = this.containerData,
        canvasData = this.canvasData,
        cropBoxData = this.cropBoxData;
      var viewMode = options.viewMode;
      var aspectRatio = canvasData.aspectRatio;
      var cropped = this.cropped && cropBoxData;
      if (sizeLimited) {
        var minCanvasWidth = Number(options.minCanvasWidth) || 0;
        var minCanvasHeight = Number(options.minCanvasHeight) || 0;
        if (viewMode > 1) {
          minCanvasWidth = Math.max(minCanvasWidth, containerData.width);
          minCanvasHeight = Math.max(minCanvasHeight, containerData.height);
          if (viewMode === 3) {
            if (minCanvasHeight * aspectRatio > minCanvasWidth) {
              minCanvasWidth = minCanvasHeight * aspectRatio;
            } else {
              minCanvasHeight = minCanvasWidth / aspectRatio;
            }
          }
        } else if (viewMode > 0) {
          if (minCanvasWidth) {
            minCanvasWidth = Math.max(minCanvasWidth, cropped ? cropBoxData.width : 0);
          } else if (minCanvasHeight) {
            minCanvasHeight = Math.max(minCanvasHeight, cropped ? cropBoxData.height : 0);
          } else if (cropped) {
            minCanvasWidth = cropBoxData.width;
            minCanvasHeight = cropBoxData.height;
            if (minCanvasHeight * aspectRatio > minCanvasWidth) {
              minCanvasWidth = minCanvasHeight * aspectRatio;
            } else {
              minCanvasHeight = minCanvasWidth / aspectRatio;
            }
          }
        }
        var _getAdjustedSizes = getAdjustedSizes({
          aspectRatio: aspectRatio,
          width: minCanvasWidth,
          height: minCanvasHeight
        });
        minCanvasWidth = _getAdjustedSizes.width;
        minCanvasHeight = _getAdjustedSizes.height;
        canvasData.minWidth = minCanvasWidth;
        canvasData.minHeight = minCanvasHeight;
        canvasData.maxWidth = Infinity;
        canvasData.maxHeight = Infinity;
      }
      if (positionLimited) {
        if (viewMode > (cropped ? 0 : 1)) {
          var newCanvasLeft = containerData.width - canvasData.width;
          var newCanvasTop = containerData.height - canvasData.height;
          canvasData.minLeft = Math.min(0, newCanvasLeft);
          canvasData.minTop = Math.min(0, newCanvasTop);
          canvasData.maxLeft = Math.max(0, newCanvasLeft);
          canvasData.maxTop = Math.max(0, newCanvasTop);
          if (cropped && this.limited) {
            canvasData.minLeft = Math.min(cropBoxData.left, cropBoxData.left + (cropBoxData.width - canvasData.width));
            canvasData.minTop = Math.min(cropBoxData.top, cropBoxData.top + (cropBoxData.height - canvasData.height));
            canvasData.maxLeft = cropBoxData.left;
            canvasData.maxTop = cropBoxData.top;
            if (viewMode === 2) {
              if (canvasData.width >= containerData.width) {
                canvasData.minLeft = Math.min(0, newCanvasLeft);
                canvasData.maxLeft = Math.max(0, newCanvasLeft);
              }
              if (canvasData.height >= containerData.height) {
                canvasData.minTop = Math.min(0, newCanvasTop);
                canvasData.maxTop = Math.max(0, newCanvasTop);
              }
            }
          }
        } else {
          canvasData.minLeft = -canvasData.width;
          canvasData.minTop = -canvasData.height;
          canvasData.maxLeft = containerData.width;
          canvasData.maxTop = containerData.height;
        }
      }
    },
    renderCanvas: function renderCanvas(changed, transformed) {
      var canvasData = this.canvasData,
        imageData = this.imageData;
      if (transformed) {
        var _getRotatedSizes = getRotatedSizes({
            width: imageData.naturalWidth * Math.abs(imageData.scaleX || 1),
            height: imageData.naturalHeight * Math.abs(imageData.scaleY || 1),
            degree: imageData.rotate || 0
          }),
          naturalWidth = _getRotatedSizes.width,
          naturalHeight = _getRotatedSizes.height;
        var width = canvasData.width * (naturalWidth / canvasData.naturalWidth);
        var height = canvasData.height * (naturalHeight / canvasData.naturalHeight);
        canvasData.left -= (width - canvasData.width) / 2;
        canvasData.top -= (height - canvasData.height) / 2;
        canvasData.width = width;
        canvasData.height = height;
        canvasData.aspectRatio = naturalWidth / naturalHeight;
        canvasData.naturalWidth = naturalWidth;
        canvasData.naturalHeight = naturalHeight;
        this.limitCanvas(true, false);
      }
      if (canvasData.width > canvasData.maxWidth || canvasData.width < canvasData.minWidth) {
        canvasData.left = canvasData.oldLeft;
      }
      if (canvasData.height > canvasData.maxHeight || canvasData.height < canvasData.minHeight) {
        canvasData.top = canvasData.oldTop;
      }
      canvasData.width = Math.min(Math.max(canvasData.width, canvasData.minWidth), canvasData.maxWidth);
      canvasData.height = Math.min(Math.max(canvasData.height, canvasData.minHeight), canvasData.maxHeight);
      this.limitCanvas(false, true);
      canvasData.left = Math.min(Math.max(canvasData.left, canvasData.minLeft), canvasData.maxLeft);
      canvasData.top = Math.min(Math.max(canvasData.top, canvasData.minTop), canvasData.maxTop);
      canvasData.oldLeft = canvasData.left;
      canvasData.oldTop = canvasData.top;
      setStyle(this.canvas, assign({
        width: canvasData.width,
        height: canvasData.height
      }, getTransforms({
        translateX: canvasData.left,
        translateY: canvasData.top
      })));
      this.renderImage(changed);
      if (this.cropped && this.limited) {
        this.limitCropBox(true, true);
      }
    },
    renderImage: function renderImage(changed) {
      var canvasData = this.canvasData,
        imageData = this.imageData;
      var width = imageData.naturalWidth * (canvasData.width / canvasData.naturalWidth);
      var height = imageData.naturalHeight * (canvasData.height / canvasData.naturalHeight);
      assign(imageData, {
        width: width,
        height: height,
        left: (canvasData.width - width) / 2,
        top: (canvasData.height - height) / 2
      });
      setStyle(this.image, assign({
        width: imageData.width,
        height: imageData.height
      }, getTransforms(assign({
        translateX: imageData.left,
        translateY: imageData.top
      }, imageData))));
      if (changed) {
        this.output();
      }
    },
    initCropBox: function initCropBox() {
      var options = this.options,
        canvasData = this.canvasData;
      var aspectRatio = options.aspectRatio || options.initialAspectRatio;
      var autoCropArea = Number(options.autoCropArea) || 0.8;
      var cropBoxData = {
        width: canvasData.width,
        height: canvasData.height
      };
      if (aspectRatio) {
        if (canvasData.height * aspectRatio > canvasData.width) {
          cropBoxData.height = cropBoxData.width / aspectRatio;
        } else {
          cropBoxData.width = cropBoxData.height * aspectRatio;
        }
      }
      this.cropBoxData = cropBoxData;
      this.limitCropBox(true, true);

      // Initialize auto crop area
      cropBoxData.width = Math.min(Math.max(cropBoxData.width, cropBoxData.minWidth), cropBoxData.maxWidth);
      cropBoxData.height = Math.min(Math.max(cropBoxData.height, cropBoxData.minHeight), cropBoxData.maxHeight);

      // The width/height of auto crop area must large than "minWidth/Height"
      cropBoxData.width = Math.max(cropBoxData.minWidth, cropBoxData.width * autoCropArea);
      cropBoxData.height = Math.max(cropBoxData.minHeight, cropBoxData.height * autoCropArea);
      cropBoxData.left = canvasData.left + (canvasData.width - cropBoxData.width) / 2;
      cropBoxData.top = canvasData.top + (canvasData.height - cropBoxData.height) / 2;
      cropBoxData.oldLeft = cropBoxData.left;
      cropBoxData.oldTop = cropBoxData.top;
      this.initialCropBoxData = assign({}, cropBoxData);
    },
    limitCropBox: function limitCropBox(sizeLimited, positionLimited) {
      var options = this.options,
        containerData = this.containerData,
        canvasData = this.canvasData,
        cropBoxData = this.cropBoxData,
        limited = this.limited;
      var aspectRatio = options.aspectRatio;
      if (sizeLimited) {
        var minCropBoxWidth = Number(options.minCropBoxWidth) || 0;
        var minCropBoxHeight = Number(options.minCropBoxHeight) || 0;
        var maxCropBoxWidth = limited ? Math.min(containerData.width, canvasData.width, canvasData.width + canvasData.left, containerData.width - canvasData.left) : containerData.width;
        var maxCropBoxHeight = limited ? Math.min(containerData.height, canvasData.height, canvasData.height + canvasData.top, containerData.height - canvasData.top) : containerData.height;

        // The min/maxCropBoxWidth/Height must be less than container's width/height
        minCropBoxWidth = Math.min(minCropBoxWidth, containerData.width);
        minCropBoxHeight = Math.min(minCropBoxHeight, containerData.height);
        if (aspectRatio) {
          if (minCropBoxWidth && minCropBoxHeight) {
            if (minCropBoxHeight * aspectRatio > minCropBoxWidth) {
              minCropBoxHeight = minCropBoxWidth / aspectRatio;
            } else {
              minCropBoxWidth = minCropBoxHeight * aspectRatio;
            }
          } else if (minCropBoxWidth) {
            minCropBoxHeight = minCropBoxWidth / aspectRatio;
          } else if (minCropBoxHeight) {
            minCropBoxWidth = minCropBoxHeight * aspectRatio;
          }
          if (maxCropBoxHeight * aspectRatio > maxCropBoxWidth) {
            maxCropBoxHeight = maxCropBoxWidth / aspectRatio;
          } else {
            maxCropBoxWidth = maxCropBoxHeight * aspectRatio;
          }
        }

        // The minWidth/Height must be less than maxWidth/Height
        cropBoxData.minWidth = Math.min(minCropBoxWidth, maxCropBoxWidth);
        cropBoxData.minHeight = Math.min(minCropBoxHeight, maxCropBoxHeight);
        cropBoxData.maxWidth = maxCropBoxWidth;
        cropBoxData.maxHeight = maxCropBoxHeight;
      }
      if (positionLimited) {
        if (limited) {
          cropBoxData.minLeft = Math.max(0, canvasData.left);
          cropBoxData.minTop = Math.max(0, canvasData.top);
          cropBoxData.maxLeft = Math.min(containerData.width, canvasData.left + canvasData.width) - cropBoxData.width;
          cropBoxData.maxTop = Math.min(containerData.height, canvasData.top + canvasData.height) - cropBoxData.height;
        } else {
          cropBoxData.minLeft = 0;
          cropBoxData.minTop = 0;
          cropBoxData.maxLeft = containerData.width - cropBoxData.width;
          cropBoxData.maxTop = containerData.height - cropBoxData.height;
        }
      }
    },
    renderCropBox: function renderCropBox() {
      var options = this.options,
        containerData = this.containerData,
        cropBoxData = this.cropBoxData;
      if (cropBoxData.width > cropBoxData.maxWidth || cropBoxData.width < cropBoxData.minWidth) {
        cropBoxData.left = cropBoxData.oldLeft;
      }
      if (cropBoxData.height > cropBoxData.maxHeight || cropBoxData.height < cropBoxData.minHeight) {
        cropBoxData.top = cropBoxData.oldTop;
      }
      cropBoxData.width = Math.min(Math.max(cropBoxData.width, cropBoxData.minWidth), cropBoxData.maxWidth);
      cropBoxData.height = Math.min(Math.max(cropBoxData.height, cropBoxData.minHeight), cropBoxData.maxHeight);
      this.limitCropBox(false, true);
      cropBoxData.left = Math.min(Math.max(cropBoxData.left, cropBoxData.minLeft), cropBoxData.maxLeft);
      cropBoxData.top = Math.min(Math.max(cropBoxData.top, cropBoxData.minTop), cropBoxData.maxTop);
      cropBoxData.oldLeft = cropBoxData.left;
      cropBoxData.oldTop = cropBoxData.top;
      if (options.movable && options.cropBoxMovable) {
        // Turn to move the canvas when the crop box is equal to the container
        setData(this.face, DATA_ACTION, cropBoxData.width >= containerData.width && cropBoxData.height >= containerData.height ? ACTION_MOVE : ACTION_ALL);
      }
      setStyle(this.cropBox, assign({
        width: cropBoxData.width,
        height: cropBoxData.height
      }, getTransforms({
        translateX: cropBoxData.left,
        translateY: cropBoxData.top
      })));
      if (this.cropped && this.limited) {
        this.limitCanvas(true, true);
      }
      if (!this.disabled) {
        this.output();
      }
    },
    output: function output() {
      this.preview();
      dispatchEvent(this.element, EVENT_CROP, this.getData());
    }
  };

  var preview = {
    initPreview: function initPreview() {
      var element = this.element,
        crossOrigin = this.crossOrigin;
      var preview = this.options.preview;
      var url = crossOrigin ? this.crossOriginUrl : this.url;
      var alt = element.alt || 'The image to preview';
      var image = document.createElement('img');
      if (crossOrigin) {
        image.crossOrigin = crossOrigin;
      }
      image.src = url;
      image.alt = alt;
      this.viewBox.appendChild(image);
      this.viewBoxImage = image;
      if (!preview) {
        return;
      }
      var previews = preview;
      if (typeof preview === 'string') {
        previews = element.ownerDocument.querySelectorAll(preview);
      } else if (preview.querySelector) {
        previews = [preview];
      }
      this.previews = previews;
      forEach(previews, function (el) {
        var img = document.createElement('img');

        // Save the original size for recover
        setData(el, DATA_PREVIEW, {
          width: el.offsetWidth,
          height: el.offsetHeight,
          html: el.innerHTML
        });
        if (crossOrigin) {
          img.crossOrigin = crossOrigin;
        }
        img.src = url;
        img.alt = alt;

        /**
         * Override img element styles
         * Add `display:block` to avoid margin top issue
         * Add `height:auto` to override `height` attribute on IE8
         * (Occur only when margin-top <= -height)
         */
        img.style.cssText = 'display:block;' + 'width:100%;' + 'height:auto;' + 'min-width:0!important;' + 'min-height:0!important;' + 'max-width:none!important;' + 'max-height:none!important;' + 'image-orientation:0deg!important;"';
        el.innerHTML = '';
        el.appendChild(img);
      });
    },
    resetPreview: function resetPreview() {
      forEach(this.previews, function (element) {
        var data = getData(element, DATA_PREVIEW);
        setStyle(element, {
          width: data.width,
          height: data.height
        });
        element.innerHTML = data.html;
        removeData(element, DATA_PREVIEW);
      });
    },
    preview: function preview() {
      var imageData = this.imageData,
        canvasData = this.canvasData,
        cropBoxData = this.cropBoxData;
      var cropBoxWidth = cropBoxData.width,
        cropBoxHeight = cropBoxData.height;
      var width = imageData.width,
        height = imageData.height;
      var left = cropBoxData.left - canvasData.left - imageData.left;
      var top = cropBoxData.top - canvasData.top - imageData.top;
      if (!this.cropped || this.disabled) {
        return;
      }
      setStyle(this.viewBoxImage, assign({
        width: width,
        height: height
      }, getTransforms(assign({
        translateX: -left,
        translateY: -top
      }, imageData))));
      forEach(this.previews, function (element) {
        var data = getData(element, DATA_PREVIEW);
        var originalWidth = data.width;
        var originalHeight = data.height;
        var newWidth = originalWidth;
        var newHeight = originalHeight;
        var ratio = 1;
        if (cropBoxWidth) {
          ratio = originalWidth / cropBoxWidth;
          newHeight = cropBoxHeight * ratio;
        }
        if (cropBoxHeight && newHeight > originalHeight) {
          ratio = originalHeight / cropBoxHeight;
          newWidth = cropBoxWidth * ratio;
          newHeight = originalHeight;
        }
        setStyle(element, {
          width: newWidth,
          height: newHeight
        });
        setStyle(element.getElementsByTagName('img')[0], assign({
          width: width * ratio,
          height: height * ratio
        }, getTransforms(assign({
          translateX: -left * ratio,
          translateY: -top * ratio
        }, imageData))));
      });
    }
  };

  var events = {
    bind: function bind() {
      var element = this.element,
        options = this.options,
        cropper = this.cropper;
      if (isFunction(options.cropstart)) {
        addListener(element, EVENT_CROP_START, options.cropstart);
      }
      if (isFunction(options.cropmove)) {
        addListener(element, EVENT_CROP_MOVE, options.cropmove);
      }
      if (isFunction(options.cropend)) {
        addListener(element, EVENT_CROP_END, options.cropend);
      }
      if (isFunction(options.crop)) {
        addListener(element, EVENT_CROP, options.crop);
      }
      if (isFunction(options.zoom)) {
        addListener(element, EVENT_ZOOM, options.zoom);
      }
      addListener(cropper, EVENT_POINTER_DOWN, this.onCropStart = this.cropStart.bind(this));
      if (options.zoomable && options.zoomOnWheel) {
        addListener(cropper, EVENT_WHEEL, this.onWheel = this.wheel.bind(this), {
          passive: false,
          capture: true
        });
      }
      if (options.toggleDragModeOnDblclick) {
        addListener(cropper, EVENT_DBLCLICK, this.onDblclick = this.dblclick.bind(this));
      }
      addListener(element.ownerDocument, EVENT_POINTER_MOVE, this.onCropMove = this.cropMove.bind(this));
      addListener(element.ownerDocument, EVENT_POINTER_UP, this.onCropEnd = this.cropEnd.bind(this));
      if (options.responsive) {
        addListener(window, EVENT_RESIZE, this.onResize = this.resize.bind(this));
      }
    },
    unbind: function unbind() {
      var element = this.element,
        options = this.options,
        cropper = this.cropper;
      if (isFunction(options.cropstart)) {
        removeListener(element, EVENT_CROP_START, options.cropstart);
      }
      if (isFunction(options.cropmove)) {
        removeListener(element, EVENT_CROP_MOVE, options.cropmove);
      }
      if (isFunction(options.cropend)) {
        removeListener(element, EVENT_CROP_END, options.cropend);
      }
      if (isFunction(options.crop)) {
        removeListener(element, EVENT_CROP, options.crop);
      }
      if (isFunction(options.zoom)) {
        removeListener(element, EVENT_ZOOM, options.zoom);
      }
      removeListener(cropper, EVENT_POINTER_DOWN, this.onCropStart);
      if (options.zoomable && options.zoomOnWheel) {
        removeListener(cropper, EVENT_WHEEL, this.onWheel, {
          passive: false,
          capture: true
        });
      }
      if (options.toggleDragModeOnDblclick) {
        removeListener(cropper, EVENT_DBLCLICK, this.onDblclick);
      }
      removeListener(element.ownerDocument, EVENT_POINTER_MOVE, this.onCropMove);
      removeListener(element.ownerDocument, EVENT_POINTER_UP, this.onCropEnd);
      if (options.responsive) {
        removeListener(window, EVENT_RESIZE, this.onResize);
      }
    }
  };

  var handlers = {
    resize: function resize() {
      if (this.disabled) {
        return;
      }
      var options = this.options,
        container = this.container,
        containerData = this.containerData;
      var ratioX = container.offsetWidth / containerData.width;
      var ratioY = container.offsetHeight / containerData.height;
      var ratio = Math.abs(ratioX - 1) > Math.abs(ratioY - 1) ? ratioX : ratioY;

      // Resize when width changed or height changed
      if (ratio !== 1) {
        var canvasData;
        var cropBoxData;
        if (options.restore) {
          canvasData = this.getCanvasData();
          cropBoxData = this.getCropBoxData();
        }
        this.render();
        if (options.restore) {
          this.setCanvasData(forEach(canvasData, function (n, i) {
            canvasData[i] = n * ratio;
          }));
          this.setCropBoxData(forEach(cropBoxData, function (n, i) {
            cropBoxData[i] = n * ratio;
          }));
        }
      }
    },
    dblclick: function dblclick() {
      if (this.disabled || this.options.dragMode === DRAG_MODE_NONE) {
        return;
      }
      this.setDragMode(hasClass(this.dragBox, CLASS_CROP) ? DRAG_MODE_MOVE : DRAG_MODE_CROP);
    },
    wheel: function wheel(event) {
      var _this = this;
      var ratio = Number(this.options.wheelZoomRatio) || 0.1;
      var delta = 1;
      if (this.disabled) {
        return;
      }
      event.preventDefault();

      // Limit wheel speed to prevent zoom too fast (#21)
      if (this.wheeling) {
        return;
      }
      this.wheeling = true;
      setTimeout(function () {
        _this.wheeling = false;
      }, 50);
      if (event.deltaY) {
        delta = event.deltaY > 0 ? 1 : -1;
      } else if (event.wheelDelta) {
        delta = -event.wheelDelta / 120;
      } else if (event.detail) {
        delta = event.detail > 0 ? 1 : -1;
      }
      this.zoom(-delta * ratio, event);
    },
    cropStart: function cropStart(event) {
      var buttons = event.buttons,
        button = event.button;
      if (this.disabled

      // Handle mouse event and pointer event and ignore touch event
      || (event.type === 'mousedown' || event.type === 'pointerdown' && event.pointerType === 'mouse') && (
      // No primary button (Usually the left button)
      isNumber(buttons) && buttons !== 1 || isNumber(button) && button !== 0

      // Open context menu
      || event.ctrlKey)) {
        return;
      }
      var options = this.options,
        pointers = this.pointers;
      var action;
      if (event.changedTouches) {
        // Handle touch event
        forEach(event.changedTouches, function (touch) {
          pointers[touch.identifier] = getPointer(touch);
        });
      } else {
        // Handle mouse event and pointer event
        pointers[event.pointerId || 0] = getPointer(event);
      }
      if (Object.keys(pointers).length > 1 && options.zoomable && options.zoomOnTouch) {
        action = ACTION_ZOOM;
      } else {
        action = getData(event.target, DATA_ACTION);
      }
      if (!REGEXP_ACTIONS.test(action)) {
        return;
      }
      if (dispatchEvent(this.element, EVENT_CROP_START, {
        originalEvent: event,
        action: action
      }) === false) {
        return;
      }

      // This line is required for preventing page zooming in iOS browsers
      event.preventDefault();
      this.action = action;
      this.cropping = false;
      if (action === ACTION_CROP) {
        this.cropping = true;
        addClass(this.dragBox, CLASS_MODAL);
      }
    },
    cropMove: function cropMove(event) {
      var action = this.action;
      if (this.disabled || !action) {
        return;
      }
      var pointers = this.pointers;
      event.preventDefault();
      if (dispatchEvent(this.element, EVENT_CROP_MOVE, {
        originalEvent: event,
        action: action
      }) === false) {
        return;
      }
      if (event.changedTouches) {
        forEach(event.changedTouches, function (touch) {
          // The first parameter should not be undefined (#432)
          assign(pointers[touch.identifier] || {}, getPointer(touch, true));
        });
      } else {
        assign(pointers[event.pointerId || 0] || {}, getPointer(event, true));
      }
      this.change(event);
    },
    cropEnd: function cropEnd(event) {
      if (this.disabled) {
        return;
      }
      var action = this.action,
        pointers = this.pointers;
      if (event.changedTouches) {
        forEach(event.changedTouches, function (touch) {
          delete pointers[touch.identifier];
        });
      } else {
        delete pointers[event.pointerId || 0];
      }
      if (!action) {
        return;
      }
      event.preventDefault();
      if (!Object.keys(pointers).length) {
        this.action = '';
      }
      if (this.cropping) {
        this.cropping = false;
        toggleClass(this.dragBox, CLASS_MODAL, this.cropped && this.options.modal);
      }
      dispatchEvent(this.element, EVENT_CROP_END, {
        originalEvent: event,
        action: action
      });
    }
  };

  var change = {
    change: function change(event) {
      var options = this.options,
        canvasData = this.canvasData,
        containerData = this.containerData,
        cropBoxData = this.cropBoxData,
        pointers = this.pointers;
      var action = this.action;
      var aspectRatio = options.aspectRatio;
      var left = cropBoxData.left,
        top = cropBoxData.top,
        width = cropBoxData.width,
        height = cropBoxData.height;
      var right = left + width;
      var bottom = top + height;
      var minLeft = 0;
      var minTop = 0;
      var maxWidth = containerData.width;
      var maxHeight = containerData.height;
      var renderable = true;
      var offset;

      // Locking aspect ratio in "free mode" by holding shift key
      if (!aspectRatio && event.shiftKey) {
        aspectRatio = width && height ? width / height : 1;
      }
      if (this.limited) {
        minLeft = cropBoxData.minLeft;
        minTop = cropBoxData.minTop;
        maxWidth = minLeft + Math.min(containerData.width, canvasData.width, canvasData.left + canvasData.width);
        maxHeight = minTop + Math.min(containerData.height, canvasData.height, canvasData.top + canvasData.height);
      }
      var pointer = pointers[Object.keys(pointers)[0]];
      var range = {
        x: pointer.endX - pointer.startX,
        y: pointer.endY - pointer.startY
      };
      var check = function check(side) {
        switch (side) {
          case ACTION_EAST:
            if (right + range.x > maxWidth) {
              range.x = maxWidth - right;
            }
            break;
          case ACTION_WEST:
            if (left + range.x < minLeft) {
              range.x = minLeft - left;
            }
            break;
          case ACTION_NORTH:
            if (top + range.y < minTop) {
              range.y = minTop - top;
            }
            break;
          case ACTION_SOUTH:
            if (bottom + range.y > maxHeight) {
              range.y = maxHeight - bottom;
            }
            break;
        }
      };
      switch (action) {
        // Move crop box
        case ACTION_ALL:
          left += range.x;
          top += range.y;
          break;

        // Resize crop box
        case ACTION_EAST:
          if (range.x >= 0 && (right >= maxWidth || aspectRatio && (top <= minTop || bottom >= maxHeight))) {
            renderable = false;
            break;
          }
          check(ACTION_EAST);
          width += range.x;
          if (width < 0) {
            action = ACTION_WEST;
            width = -width;
            left -= width;
          }
          if (aspectRatio) {
            height = width / aspectRatio;
            top += (cropBoxData.height - height) / 2;
          }
          break;
        case ACTION_NORTH:
          if (range.y <= 0 && (top <= minTop || aspectRatio && (left <= minLeft || right >= maxWidth))) {
            renderable = false;
            break;
          }
          check(ACTION_NORTH);
          height -= range.y;
          top += range.y;
          if (height < 0) {
            action = ACTION_SOUTH;
            height = -height;
            top -= height;
          }
          if (aspectRatio) {
            width = height * aspectRatio;
            left += (cropBoxData.width - width) / 2;
          }
          break;
        case ACTION_WEST:
          if (range.x <= 0 && (left <= minLeft || aspectRatio && (top <= minTop || bottom >= maxHeight))) {
            renderable = false;
            break;
          }
          check(ACTION_WEST);
          width -= range.x;
          left += range.x;
          if (width < 0) {
            action = ACTION_EAST;
            width = -width;
            left -= width;
          }
          if (aspectRatio) {
            height = width / aspectRatio;
            top += (cropBoxData.height - height) / 2;
          }
          break;
        case ACTION_SOUTH:
          if (range.y >= 0 && (bottom >= maxHeight || aspectRatio && (left <= minLeft || right >= maxWidth))) {
            renderable = false;
            break;
          }
          check(ACTION_SOUTH);
          height += range.y;
          if (height < 0) {
            action = ACTION_NORTH;
            height = -height;
            top -= height;
          }
          if (aspectRatio) {
            width = height * aspectRatio;
            left += (cropBoxData.width - width) / 2;
          }
          break;
        case ACTION_NORTH_EAST:
          if (aspectRatio) {
            if (range.y <= 0 && (top <= minTop || right >= maxWidth)) {
              renderable = false;
              break;
            }
            check(ACTION_NORTH);
            height -= range.y;
            top += range.y;
            width = height * aspectRatio;
          } else {
            check(ACTION_NORTH);
            check(ACTION_EAST);
            if (range.x >= 0) {
              if (right < maxWidth) {
                width += range.x;
              } else if (range.y <= 0 && top <= minTop) {
                renderable = false;
              }
            } else {
              width += range.x;
            }
            if (range.y <= 0) {
              if (top > minTop) {
                height -= range.y;
                top += range.y;
              }
            } else {
              height -= range.y;
              top += range.y;
            }
          }
          if (width < 0 && height < 0) {
            action = ACTION_SOUTH_WEST;
            height = -height;
            width = -width;
            top -= height;
            left -= width;
          } else if (width < 0) {
            action = ACTION_NORTH_WEST;
            width = -width;
            left -= width;
          } else if (height < 0) {
            action = ACTION_SOUTH_EAST;
            height = -height;
            top -= height;
          }
          break;
        case ACTION_NORTH_WEST:
          if (aspectRatio) {
            if (range.y <= 0 && (top <= minTop || left <= minLeft)) {
              renderable = false;
              break;
            }
            check(ACTION_NORTH);
            height -= range.y;
            top += range.y;
            width = height * aspectRatio;
            left += cropBoxData.width - width;
          } else {
            check(ACTION_NORTH);
            check(ACTION_WEST);
            if (range.x <= 0) {
              if (left > minLeft) {
                width -= range.x;
                left += range.x;
              } else if (range.y <= 0 && top <= minTop) {
                renderable = false;
              }
            } else {
              width -= range.x;
              left += range.x;
            }
            if (range.y <= 0) {
              if (top > minTop) {
                height -= range.y;
                top += range.y;
              }
            } else {
              height -= range.y;
              top += range.y;
            }
          }
          if (width < 0 && height < 0) {
            action = ACTION_SOUTH_EAST;
            height = -height;
            width = -width;
            top -= height;
            left -= width;
          } else if (width < 0) {
            action = ACTION_NORTH_EAST;
            width = -width;
            left -= width;
          } else if (height < 0) {
            action = ACTION_SOUTH_WEST;
            height = -height;
            top -= height;
          }
          break;
        case ACTION_SOUTH_WEST:
          if (aspectRatio) {
            if (range.x <= 0 && (left <= minLeft || bottom >= maxHeight)) {
              renderable = false;
              break;
            }
            check(ACTION_WEST);
            width -= range.x;
            left += range.x;
            height = width / aspectRatio;
          } else {
            check(ACTION_SOUTH);
            check(ACTION_WEST);
            if (range.x <= 0) {
              if (left > minLeft) {
                width -= range.x;
                left += range.x;
              } else if (range.y >= 0 && bottom >= maxHeight) {
                renderable = false;
              }
            } else {
              width -= range.x;
              left += range.x;
            }
            if (range.y >= 0) {
              if (bottom < maxHeight) {
                height += range.y;
              }
            } else {
              height += range.y;
            }
          }
          if (width < 0 && height < 0) {
            action = ACTION_NORTH_EAST;
            height = -height;
            width = -width;
            top -= height;
            left -= width;
          } else if (width < 0) {
            action = ACTION_SOUTH_EAST;
            width = -width;
            left -= width;
          } else if (height < 0) {
            action = ACTION_NORTH_WEST;
            height = -height;
            top -= height;
          }
          break;
        case ACTION_SOUTH_EAST:
          if (aspectRatio) {
            if (range.x >= 0 && (right >= maxWidth || bottom >= maxHeight)) {
              renderable = false;
              break;
            }
            check(ACTION_EAST);
            width += range.x;
            height = width / aspectRatio;
          } else {
            check(ACTION_SOUTH);
            check(ACTION_EAST);
            if (range.x >= 0) {
              if (right < maxWidth) {
                width += range.x;
              } else if (range.y >= 0 && bottom >= maxHeight) {
                renderable = false;
              }
            } else {
              width += range.x;
            }
            if (range.y >= 0) {
              if (bottom < maxHeight) {
                height += range.y;
              }
            } else {
              height += range.y;
            }
          }
          if (width < 0 && height < 0) {
            action = ACTION_NORTH_WEST;
            height = -height;
            width = -width;
            top -= height;
            left -= width;
          } else if (width < 0) {
            action = ACTION_SOUTH_WEST;
            width = -width;
            left -= width;
          } else if (height < 0) {
            action = ACTION_NORTH_EAST;
            height = -height;
            top -= height;
          }
          break;

        // Move canvas
        case ACTION_MOVE:
          this.move(range.x, range.y);
          renderable = false;
          break;

        // Zoom canvas
        case ACTION_ZOOM:
          this.zoom(getMaxZoomRatio(pointers), event);
          renderable = false;
          break;

        // Create crop box
        case ACTION_CROP:
          if (!range.x || !range.y) {
            renderable = false;
            break;
          }
          offset = getOffset(this.cropper);
          left = pointer.startX - offset.left;
          top = pointer.startY - offset.top;
          width = cropBoxData.minWidth;
          height = cropBoxData.minHeight;
          if (range.x > 0) {
            action = range.y > 0 ? ACTION_SOUTH_EAST : ACTION_NORTH_EAST;
          } else if (range.x < 0) {
            left -= width;
            action = range.y > 0 ? ACTION_SOUTH_WEST : ACTION_NORTH_WEST;
          }
          if (range.y < 0) {
            top -= height;
          }

          // Show the crop box if is hidden
          if (!this.cropped) {
            removeClass(this.cropBox, CLASS_HIDDEN);
            this.cropped = true;
            if (this.limited) {
              this.limitCropBox(true, true);
            }
          }
          break;
      }
      if (renderable) {
        cropBoxData.width = width;
        cropBoxData.height = height;
        cropBoxData.left = left;
        cropBoxData.top = top;
        this.action = action;
        this.renderCropBox();
      }

      // Override
      forEach(pointers, function (p) {
        p.startX = p.endX;
        p.startY = p.endY;
      });
    }
  };

  var methods = {
    // Show the crop box manually
    crop: function crop() {
      if (this.ready && !this.cropped && !this.disabled) {
        this.cropped = true;
        this.limitCropBox(true, true);
        if (this.options.modal) {
          addClass(this.dragBox, CLASS_MODAL);
        }
        removeClass(this.cropBox, CLASS_HIDDEN);
        this.setCropBoxData(this.initialCropBoxData);
      }
      return this;
    },
    // Reset the image and crop box to their initial states
    reset: function reset() {
      if (this.ready && !this.disabled) {
        this.imageData = assign({}, this.initialImageData);
        this.canvasData = assign({}, this.initialCanvasData);
        this.cropBoxData = assign({}, this.initialCropBoxData);
        this.renderCanvas();
        if (this.cropped) {
          this.renderCropBox();
        }
      }
      return this;
    },
    // Clear the crop box
    clear: function clear() {
      if (this.cropped && !this.disabled) {
        assign(this.cropBoxData, {
          left: 0,
          top: 0,
          width: 0,
          height: 0
        });
        this.cropped = false;
        this.renderCropBox();
        this.limitCanvas(true, true);

        // Render canvas after crop box rendered
        this.renderCanvas();
        removeClass(this.dragBox, CLASS_MODAL);
        addClass(this.cropBox, CLASS_HIDDEN);
      }
      return this;
    },
    /**
     * Replace the image's src and rebuild the cropper
     * @param {string} url - The new URL.
     * @param {boolean} [hasSameSize] - Indicate if the new image has the same size as the old one.
     * @returns {Cropper} this
     */
    replace: function replace(url) {
      var hasSameSize = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      if (!this.disabled && url) {
        if (this.isImg) {
          this.element.src = url;
        }
        if (hasSameSize) {
          this.url = url;
          this.image.src = url;
          if (this.ready) {
            this.viewBoxImage.src = url;
            forEach(this.previews, function (element) {
              element.getElementsByTagName('img')[0].src = url;
            });
          }
        } else {
          if (this.isImg) {
            this.replaced = true;
          }
          this.options.data = null;
          this.uncreate();
          this.load(url);
        }
      }
      return this;
    },
    // Enable (unfreeze) the cropper
    enable: function enable() {
      if (this.ready && this.disabled) {
        this.disabled = false;
        removeClass(this.cropper, CLASS_DISABLED);
      }
      return this;
    },
    // Disable (freeze) the cropper
    disable: function disable() {
      if (this.ready && !this.disabled) {
        this.disabled = true;
        addClass(this.cropper, CLASS_DISABLED);
      }
      return this;
    },
    /**
     * Destroy the cropper and remove the instance from the image
     * @returns {Cropper} this
     */
    destroy: function destroy() {
      var element = this.element;
      if (!element[NAMESPACE]) {
        return this;
      }
      element[NAMESPACE] = undefined;
      if (this.isImg && this.replaced) {
        element.src = this.originalUrl;
      }
      this.uncreate();
      return this;
    },
    /**
     * Move the canvas with relative offsets
     * @param {number} offsetX - The relative offset distance on the x-axis.
     * @param {number} [offsetY=offsetX] - The relative offset distance on the y-axis.
     * @returns {Cropper} this
     */
    move: function move(offsetX) {
      var offsetY = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : offsetX;
      var _this$canvasData = this.canvasData,
        left = _this$canvasData.left,
        top = _this$canvasData.top;
      return this.moveTo(isUndefined(offsetX) ? offsetX : left + Number(offsetX), isUndefined(offsetY) ? offsetY : top + Number(offsetY));
    },
    /**
     * Move the canvas to an absolute point
     * @param {number} x - The x-axis coordinate.
     * @param {number} [y=x] - The y-axis coordinate.
     * @returns {Cropper} this
     */
    moveTo: function moveTo(x) {
      var y = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : x;
      var canvasData = this.canvasData;
      var changed = false;
      x = Number(x);
      y = Number(y);
      if (this.ready && !this.disabled && this.options.movable) {
        if (isNumber(x)) {
          canvasData.left = x;
          changed = true;
        }
        if (isNumber(y)) {
          canvasData.top = y;
          changed = true;
        }
        if (changed) {
          this.renderCanvas(true);
        }
      }
      return this;
    },
    /**
     * Zoom the canvas with a relative ratio
     * @param {number} ratio - The target ratio.
     * @param {Event} _originalEvent - The original event if any.
     * @returns {Cropper} this
     */
    zoom: function zoom(ratio, _originalEvent) {
      var canvasData = this.canvasData;
      ratio = Number(ratio);
      if (ratio < 0) {
        ratio = 1 / (1 - ratio);
      } else {
        ratio = 1 + ratio;
      }
      return this.zoomTo(canvasData.width * ratio / canvasData.naturalWidth, null, _originalEvent);
    },
    /**
     * Zoom the canvas to an absolute ratio
     * @param {number} ratio - The target ratio.
     * @param {Object} pivot - The zoom pivot point coordinate.
     * @param {Event} _originalEvent - The original event if any.
     * @returns {Cropper} this
     */
    zoomTo: function zoomTo(ratio, pivot, _originalEvent) {
      var options = this.options,
        canvasData = this.canvasData;
      var width = canvasData.width,
        height = canvasData.height,
        naturalWidth = canvasData.naturalWidth,
        naturalHeight = canvasData.naturalHeight;
      ratio = Number(ratio);
      if (ratio >= 0 && this.ready && !this.disabled && options.zoomable) {
        var newWidth = naturalWidth * ratio;
        var newHeight = naturalHeight * ratio;
        if (dispatchEvent(this.element, EVENT_ZOOM, {
          ratio: ratio,
          oldRatio: width / naturalWidth,
          originalEvent: _originalEvent
        }) === false) {
          return this;
        }
        if (_originalEvent) {
          var pointers = this.pointers;
          var offset = getOffset(this.cropper);
          var center = pointers && Object.keys(pointers).length ? getPointersCenter(pointers) : {
            pageX: _originalEvent.pageX,
            pageY: _originalEvent.pageY
          };

          // Zoom from the triggering point of the event
          canvasData.left -= (newWidth - width) * ((center.pageX - offset.left - canvasData.left) / width);
          canvasData.top -= (newHeight - height) * ((center.pageY - offset.top - canvasData.top) / height);
        } else if (isPlainObject(pivot) && isNumber(pivot.x) && isNumber(pivot.y)) {
          canvasData.left -= (newWidth - width) * ((pivot.x - canvasData.left) / width);
          canvasData.top -= (newHeight - height) * ((pivot.y - canvasData.top) / height);
        } else {
          // Zoom from the center of the canvas
          canvasData.left -= (newWidth - width) / 2;
          canvasData.top -= (newHeight - height) / 2;
        }
        canvasData.width = newWidth;
        canvasData.height = newHeight;
        this.renderCanvas(true);
      }
      return this;
    },
    /**
     * Rotate the canvas with a relative degree
     * @param {number} degree - The rotate degree.
     * @returns {Cropper} this
     */
    rotate: function rotate(degree) {
      return this.rotateTo((this.imageData.rotate || 0) + Number(degree));
    },
    /**
     * Rotate the canvas to an absolute degree
     * @param {number} degree - The rotate degree.
     * @returns {Cropper} this
     */
    rotateTo: function rotateTo(degree) {
      degree = Number(degree);
      if (isNumber(degree) && this.ready && !this.disabled && this.options.rotatable) {
        this.imageData.rotate = degree % 360;
        this.renderCanvas(true, true);
      }
      return this;
    },
    /**
     * Scale the image on the x-axis.
     * @param {number} scaleX - The scale ratio on the x-axis.
     * @returns {Cropper} this
     */
    scaleX: function scaleX(_scaleX) {
      var scaleY = this.imageData.scaleY;
      return this.scale(_scaleX, isNumber(scaleY) ? scaleY : 1);
    },
    /**
     * Scale the image on the y-axis.
     * @param {number} scaleY - The scale ratio on the y-axis.
     * @returns {Cropper} this
     */
    scaleY: function scaleY(_scaleY) {
      var scaleX = this.imageData.scaleX;
      return this.scale(isNumber(scaleX) ? scaleX : 1, _scaleY);
    },
    /**
     * Scale the image
     * @param {number} scaleX - The scale ratio on the x-axis.
     * @param {number} [scaleY=scaleX] - The scale ratio on the y-axis.
     * @returns {Cropper} this
     */
    scale: function scale(scaleX) {
      var scaleY = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : scaleX;
      var imageData = this.imageData;
      var transformed = false;
      scaleX = Number(scaleX);
      scaleY = Number(scaleY);
      if (this.ready && !this.disabled && this.options.scalable) {
        if (isNumber(scaleX)) {
          imageData.scaleX = scaleX;
          transformed = true;
        }
        if (isNumber(scaleY)) {
          imageData.scaleY = scaleY;
          transformed = true;
        }
        if (transformed) {
          this.renderCanvas(true, true);
        }
      }
      return this;
    },
    /**
     * Get the cropped area position and size data (base on the original image)
     * @param {boolean} [rounded=false] - Indicate if round the data values or not.
     * @returns {Object} The result cropped data.
     */
    getData: function getData() {
      var rounded = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var options = this.options,
        imageData = this.imageData,
        canvasData = this.canvasData,
        cropBoxData = this.cropBoxData;
      var data;
      if (this.ready && this.cropped) {
        data = {
          x: cropBoxData.left - canvasData.left,
          y: cropBoxData.top - canvasData.top,
          width: cropBoxData.width,
          height: cropBoxData.height
        };
        var ratio = imageData.width / imageData.naturalWidth;
        forEach(data, function (n, i) {
          data[i] = n / ratio;
        });
        if (rounded) {
          // In case rounding off leads to extra 1px in right or bottom border
          // we should round the top-left corner and the dimension (#343).
          var bottom = Math.round(data.y + data.height);
          var right = Math.round(data.x + data.width);
          data.x = Math.round(data.x);
          data.y = Math.round(data.y);
          data.width = right - data.x;
          data.height = bottom - data.y;
        }
      } else {
        data = {
          x: 0,
          y: 0,
          width: 0,
          height: 0
        };
      }
      if (options.rotatable) {
        data.rotate = imageData.rotate || 0;
      }
      if (options.scalable) {
        data.scaleX = imageData.scaleX || 1;
        data.scaleY = imageData.scaleY || 1;
      }
      return data;
    },
    /**
     * Set the cropped area position and size with new data
     * @param {Object} data - The new data.
     * @returns {Cropper} this
     */
    setData: function setData(data) {
      var options = this.options,
        imageData = this.imageData,
        canvasData = this.canvasData;
      var cropBoxData = {};
      if (this.ready && !this.disabled && isPlainObject(data)) {
        var transformed = false;
        if (options.rotatable) {
          if (isNumber(data.rotate) && data.rotate !== imageData.rotate) {
            imageData.rotate = data.rotate;
            transformed = true;
          }
        }
        if (options.scalable) {
          if (isNumber(data.scaleX) && data.scaleX !== imageData.scaleX) {
            imageData.scaleX = data.scaleX;
            transformed = true;
          }
          if (isNumber(data.scaleY) && data.scaleY !== imageData.scaleY) {
            imageData.scaleY = data.scaleY;
            transformed = true;
          }
        }
        if (transformed) {
          this.renderCanvas(true, true);
        }
        var ratio = imageData.width / imageData.naturalWidth;
        if (isNumber(data.x)) {
          cropBoxData.left = data.x * ratio + canvasData.left;
        }
        if (isNumber(data.y)) {
          cropBoxData.top = data.y * ratio + canvasData.top;
        }
        if (isNumber(data.width)) {
          cropBoxData.width = data.width * ratio;
        }
        if (isNumber(data.height)) {
          cropBoxData.height = data.height * ratio;
        }
        this.setCropBoxData(cropBoxData);
      }
      return this;
    },
    /**
     * Get the container size data.
     * @returns {Object} The result container data.
     */
    getContainerData: function getContainerData() {
      return this.ready ? assign({}, this.containerData) : {};
    },
    /**
     * Get the image position and size data.
     * @returns {Object} The result image data.
     */
    getImageData: function getImageData() {
      return this.sized ? assign({}, this.imageData) : {};
    },
    /**
     * Get the canvas position and size data.
     * @returns {Object} The result canvas data.
     */
    getCanvasData: function getCanvasData() {
      var canvasData = this.canvasData;
      var data = {};
      if (this.ready) {
        forEach(['left', 'top', 'width', 'height', 'naturalWidth', 'naturalHeight'], function (n) {
          data[n] = canvasData[n];
        });
      }
      return data;
    },
    /**
     * Set the canvas position and size with new data.
     * @param {Object} data - The new canvas data.
     * @returns {Cropper} this
     */
    setCanvasData: function setCanvasData(data) {
      var canvasData = this.canvasData;
      var aspectRatio = canvasData.aspectRatio;
      if (this.ready && !this.disabled && isPlainObject(data)) {
        if (isNumber(data.left)) {
          canvasData.left = data.left;
        }
        if (isNumber(data.top)) {
          canvasData.top = data.top;
        }
        if (isNumber(data.width)) {
          canvasData.width = data.width;
          canvasData.height = data.width / aspectRatio;
        } else if (isNumber(data.height)) {
          canvasData.height = data.height;
          canvasData.width = data.height * aspectRatio;
        }
        this.renderCanvas(true);
      }
      return this;
    },
    /**
     * Get the crop box position and size data.
     * @returns {Object} The result crop box data.
     */
    getCropBoxData: function getCropBoxData() {
      var cropBoxData = this.cropBoxData;
      var data;
      if (this.ready && this.cropped) {
        data = {
          left: cropBoxData.left,
          top: cropBoxData.top,
          width: cropBoxData.width,
          height: cropBoxData.height
        };
      }
      return data || {};
    },
    /**
     * Set the crop box position and size with new data.
     * @param {Object} data - The new crop box data.
     * @returns {Cropper} this
     */
    setCropBoxData: function setCropBoxData(data) {
      var cropBoxData = this.cropBoxData;
      var aspectRatio = this.options.aspectRatio;
      var widthChanged;
      var heightChanged;
      if (this.ready && this.cropped && !this.disabled && isPlainObject(data)) {
        if (isNumber(data.left)) {
          cropBoxData.left = data.left;
        }
        if (isNumber(data.top)) {
          cropBoxData.top = data.top;
        }
        if (isNumber(data.width) && data.width !== cropBoxData.width) {
          widthChanged = true;
          cropBoxData.width = data.width;
        }
        if (isNumber(data.height) && data.height !== cropBoxData.height) {
          heightChanged = true;
          cropBoxData.height = data.height;
        }
        if (aspectRatio) {
          if (widthChanged) {
            cropBoxData.height = cropBoxData.width / aspectRatio;
          } else if (heightChanged) {
            cropBoxData.width = cropBoxData.height * aspectRatio;
          }
        }
        this.renderCropBox();
      }
      return this;
    },
    /**
     * Get a canvas drawn the cropped image.
     * @param {Object} [options={}] - The config options.
     * @returns {HTMLCanvasElement} - The result canvas.
     */
    getCroppedCanvas: function getCroppedCanvas() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      if (!this.ready || !window.HTMLCanvasElement) {
        return null;
      }
      var canvasData = this.canvasData;
      var source = getSourceCanvas(this.image, this.imageData, canvasData, options);

      // Returns the source canvas if it is not cropped.
      if (!this.cropped) {
        return source;
      }
      var _this$getData = this.getData(options.rounded),
        initialX = _this$getData.x,
        initialY = _this$getData.y,
        initialWidth = _this$getData.width,
        initialHeight = _this$getData.height;
      var ratio = source.width / Math.floor(canvasData.naturalWidth);
      if (ratio !== 1) {
        initialX *= ratio;
        initialY *= ratio;
        initialWidth *= ratio;
        initialHeight *= ratio;
      }
      var aspectRatio = initialWidth / initialHeight;
      var maxSizes = getAdjustedSizes({
        aspectRatio: aspectRatio,
        width: options.maxWidth || Infinity,
        height: options.maxHeight || Infinity
      });
      var minSizes = getAdjustedSizes({
        aspectRatio: aspectRatio,
        width: options.minWidth || 0,
        height: options.minHeight || 0
      }, 'cover');
      var _getAdjustedSizes = getAdjustedSizes({
          aspectRatio: aspectRatio,
          width: options.width || (ratio !== 1 ? source.width : initialWidth),
          height: options.height || (ratio !== 1 ? source.height : initialHeight)
        }),
        width = _getAdjustedSizes.width,
        height = _getAdjustedSizes.height;
      width = Math.min(maxSizes.width, Math.max(minSizes.width, width));
      height = Math.min(maxSizes.height, Math.max(minSizes.height, height));
      var canvas = document.createElement('canvas');
      var context = canvas.getContext('2d');
      canvas.width = normalizeDecimalNumber(width);
      canvas.height = normalizeDecimalNumber(height);
      context.fillStyle = options.fillColor || 'transparent';
      context.fillRect(0, 0, width, height);
      var _options$imageSmoothi = options.imageSmoothingEnabled,
        imageSmoothingEnabled = _options$imageSmoothi === void 0 ? true : _options$imageSmoothi,
        imageSmoothingQuality = options.imageSmoothingQuality;
      context.imageSmoothingEnabled = imageSmoothingEnabled;
      if (imageSmoothingQuality) {
        context.imageSmoothingQuality = imageSmoothingQuality;
      }

      // https://developer.mozilla.org/en-US/docs/Web/API/CanvasRenderingContext2D.drawImage
      var sourceWidth = source.width;
      var sourceHeight = source.height;

      // Source canvas parameters
      var srcX = initialX;
      var srcY = initialY;
      var srcWidth;
      var srcHeight;

      // Destination canvas parameters
      var dstX;
      var dstY;
      var dstWidth;
      var dstHeight;
      if (srcX <= -initialWidth || srcX > sourceWidth) {
        srcX = 0;
        srcWidth = 0;
        dstX = 0;
        dstWidth = 0;
      } else if (srcX <= 0) {
        dstX = -srcX;
        srcX = 0;
        srcWidth = Math.min(sourceWidth, initialWidth + srcX);
        dstWidth = srcWidth;
      } else if (srcX <= sourceWidth) {
        dstX = 0;
        srcWidth = Math.min(initialWidth, sourceWidth - srcX);
        dstWidth = srcWidth;
      }
      if (srcWidth <= 0 || srcY <= -initialHeight || srcY > sourceHeight) {
        srcY = 0;
        srcHeight = 0;
        dstY = 0;
        dstHeight = 0;
      } else if (srcY <= 0) {
        dstY = -srcY;
        srcY = 0;
        srcHeight = Math.min(sourceHeight, initialHeight + srcY);
        dstHeight = srcHeight;
      } else if (srcY <= sourceHeight) {
        dstY = 0;
        srcHeight = Math.min(initialHeight, sourceHeight - srcY);
        dstHeight = srcHeight;
      }
      var params = [srcX, srcY, srcWidth, srcHeight];

      // Avoid "IndexSizeError"
      if (dstWidth > 0 && dstHeight > 0) {
        var scale = width / initialWidth;
        params.push(dstX * scale, dstY * scale, dstWidth * scale, dstHeight * scale);
      }

      // All the numerical parameters should be integer for `drawImage`
      // https://github.com/fengyuanchen/cropper/issues/476
      context.drawImage.apply(context, [source].concat(_toConsumableArray(params.map(function (param) {
        return Math.floor(normalizeDecimalNumber(param));
      }))));
      return canvas;
    },
    /**
     * Change the aspect ratio of the crop box.
     * @param {number} aspectRatio - The new aspect ratio.
     * @returns {Cropper} this
     */
    setAspectRatio: function setAspectRatio(aspectRatio) {
      var options = this.options;
      if (!this.disabled && !isUndefined(aspectRatio)) {
        // 0 -> NaN
        options.aspectRatio = Math.max(0, aspectRatio) || NaN;
        if (this.ready) {
          this.initCropBox();
          if (this.cropped) {
            this.renderCropBox();
          }
        }
      }
      return this;
    },
    /**
     * Change the drag mode.
     * @param {string} mode - The new drag mode.
     * @returns {Cropper} this
     */
    setDragMode: function setDragMode(mode) {
      var options = this.options,
        dragBox = this.dragBox,
        face = this.face;
      if (this.ready && !this.disabled) {
        var croppable = mode === DRAG_MODE_CROP;
        var movable = options.movable && mode === DRAG_MODE_MOVE;
        mode = croppable || movable ? mode : DRAG_MODE_NONE;
        options.dragMode = mode;
        setData(dragBox, DATA_ACTION, mode);
        toggleClass(dragBox, CLASS_CROP, croppable);
        toggleClass(dragBox, CLASS_MOVE, movable);
        if (!options.cropBoxMovable) {
          // Sync drag mode to crop box when it is not movable
          setData(face, DATA_ACTION, mode);
          toggleClass(face, CLASS_CROP, croppable);
          toggleClass(face, CLASS_MOVE, movable);
        }
      }
      return this;
    }
  };

  var AnotherCropper = WINDOW.Cropper;
  var Cropper = /*#__PURE__*/function () {
    /**
     * Create a new Cropper.
     * @param {Element} element - The target element for cropping.
     * @param {Object} [options={}] - The configuration options.
     */
    function Cropper(element) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      _classCallCheck(this, Cropper);
      if (!element || !REGEXP_TAG_NAME.test(element.tagName)) {
        throw new Error('The first argument is required and must be an <img> or <canvas> element.');
      }
      this.element = element;
      this.options = assign({}, DEFAULTS, isPlainObject(options) && options);
      this.cropped = false;
      this.disabled = false;
      this.pointers = {};
      this.ready = false;
      this.reloading = false;
      this.replaced = false;
      this.sized = false;
      this.sizing = false;
      this.init();
    }
    return _createClass(Cropper, [{
      key: "init",
      value: function init() {
        var element = this.element;
        var tagName = element.tagName.toLowerCase();
        var url;
        if (element[NAMESPACE]) {
          return;
        }
        element[NAMESPACE] = this;
        if (tagName === 'img') {
          this.isImg = true;

          // e.g.: "img/picture.jpg"
          url = element.getAttribute('src') || '';
          this.originalUrl = url;

          // Stop when it's a blank image
          if (!url) {
            return;
          }

          // e.g.: "https://example.com/img/picture.jpg"
          url = element.src;
        } else if (tagName === 'canvas' && window.HTMLCanvasElement) {
          url = element.toDataURL();
        }
        this.load(url);
      }
    }, {
      key: "load",
      value: function load(url) {
        var _this = this;
        if (!url) {
          return;
        }
        this.url = url;
        this.imageData = {};
        var element = this.element,
          options = this.options;
        if (!options.rotatable && !options.scalable) {
          options.checkOrientation = false;
        }

        // Only IE10+ supports Typed Arrays
        if (!options.checkOrientation || !window.ArrayBuffer) {
          this.clone();
          return;
        }

        // Detect the mime type of the image directly if it is a Data URL
        if (REGEXP_DATA_URL.test(url)) {
          // Read ArrayBuffer from Data URL of JPEG images directly for better performance
          if (REGEXP_DATA_URL_JPEG.test(url)) {
            this.read(dataURLToArrayBuffer(url));
          } else {
            // Only a JPEG image may contains Exif Orientation information,
            // the rest types of Data URLs are not necessary to check orientation at all.
            this.clone();
          }
          return;
        }

        // 1. Detect the mime type of the image by a XMLHttpRequest.
        // 2. Load the image as ArrayBuffer for reading orientation if its a JPEG image.
        var xhr = new XMLHttpRequest();
        var clone = this.clone.bind(this);
        this.reloading = true;
        this.xhr = xhr;

        // 1. Cross origin requests are only supported for protocol schemes:
        // http, https, data, chrome, chrome-extension.
        // 2. Access to XMLHttpRequest from a Data URL will be blocked by CORS policy
        // in some browsers as IE11 and Safari.
        xhr.onabort = clone;
        xhr.onerror = clone;
        xhr.ontimeout = clone;
        xhr.onprogress = function () {
          // Abort the request directly if it not a JPEG image for better performance
          if (xhr.getResponseHeader('content-type') !== MIME_TYPE_JPEG) {
            xhr.abort();
          }
        };
        xhr.onload = function () {
          _this.read(xhr.response);
        };
        xhr.onloadend = function () {
          _this.reloading = false;
          _this.xhr = null;
        };

        // Bust cache when there is a "crossOrigin" property to avoid browser cache error
        if (options.checkCrossOrigin && isCrossOriginURL(url) && element.crossOrigin) {
          url = addTimestamp(url);
        }

        // The third parameter is required for avoiding side-effect (#682)
        xhr.open('GET', url, true);
        xhr.responseType = 'arraybuffer';
        xhr.withCredentials = element.crossOrigin === 'use-credentials';
        xhr.send();
      }
    }, {
      key: "read",
      value: function read(arrayBuffer) {
        var options = this.options,
          imageData = this.imageData;

        // Reset the orientation value to its default value 1
        // as some iOS browsers will render image with its orientation
        var orientation = resetAndGetOrientation(arrayBuffer);
        var rotate = 0;
        var scaleX = 1;
        var scaleY = 1;
        if (orientation > 1) {
          // Generate a new URL which has the default orientation value
          this.url = arrayBufferToDataURL(arrayBuffer, MIME_TYPE_JPEG);
          var _parseOrientation = parseOrientation(orientation);
          rotate = _parseOrientation.rotate;
          scaleX = _parseOrientation.scaleX;
          scaleY = _parseOrientation.scaleY;
        }
        if (options.rotatable) {
          imageData.rotate = rotate;
        }
        if (options.scalable) {
          imageData.scaleX = scaleX;
          imageData.scaleY = scaleY;
        }
        this.clone();
      }
    }, {
      key: "clone",
      value: function clone() {
        var element = this.element,
          url = this.url;
        var crossOrigin = element.crossOrigin;
        var crossOriginUrl = url;
        if (this.options.checkCrossOrigin && isCrossOriginURL(url)) {
          if (!crossOrigin) {
            crossOrigin = 'anonymous';
          }

          // Bust cache when there is not a "crossOrigin" property (#519)
          crossOriginUrl = addTimestamp(url);
        }
        this.crossOrigin = crossOrigin;
        this.crossOriginUrl = crossOriginUrl;
        var image = document.createElement('img');
        if (crossOrigin) {
          image.crossOrigin = crossOrigin;
        }
        image.src = crossOriginUrl || url;
        image.alt = element.alt || 'The image to crop';
        this.image = image;
        image.onload = this.start.bind(this);
        image.onerror = this.stop.bind(this);
        addClass(image, CLASS_HIDE);
        element.parentNode.insertBefore(image, element.nextSibling);
      }
    }, {
      key: "start",
      value: function start() {
        var _this2 = this;
        var image = this.image;
        image.onload = null;
        image.onerror = null;
        this.sizing = true;

        // Match all browsers that use WebKit as the layout engine in iOS devices,
        // such as Safari for iOS, Chrome for iOS, and in-app browsers.
        var isIOSWebKit = WINDOW.navigator && /(?:iPad|iPhone|iPod).*?AppleWebKit/i.test(WINDOW.navigator.userAgent);
        var done = function done(naturalWidth, naturalHeight) {
          assign(_this2.imageData, {
            naturalWidth: naturalWidth,
            naturalHeight: naturalHeight,
            aspectRatio: naturalWidth / naturalHeight
          });
          _this2.initialImageData = assign({}, _this2.imageData);
          _this2.sizing = false;
          _this2.sized = true;
          _this2.build();
        };

        // Most modern browsers (excepts iOS WebKit)
        if (image.naturalWidth && !isIOSWebKit) {
          done(image.naturalWidth, image.naturalHeight);
          return;
        }
        var sizingImage = document.createElement('img');
        var body = document.body || document.documentElement;
        this.sizingImage = sizingImage;
        sizingImage.onload = function () {
          done(sizingImage.width, sizingImage.height);
          if (!isIOSWebKit) {
            body.removeChild(sizingImage);
          }
        };
        sizingImage.src = image.src;

        // iOS WebKit will convert the image automatically
        // with its orientation once append it into DOM (#279)
        if (!isIOSWebKit) {
          sizingImage.style.cssText = 'left:0;' + 'max-height:none!important;' + 'max-width:none!important;' + 'min-height:0!important;' + 'min-width:0!important;' + 'opacity:0;' + 'position:absolute;' + 'top:0;' + 'z-index:-1;';
          body.appendChild(sizingImage);
        }
      }
    }, {
      key: "stop",
      value: function stop() {
        var image = this.image;
        image.onload = null;
        image.onerror = null;
        image.parentNode.removeChild(image);
        this.image = null;
      }
    }, {
      key: "build",
      value: function build() {
        if (!this.sized || this.ready) {
          return;
        }
        var element = this.element,
          options = this.options,
          image = this.image;

        // Create cropper elements
        var container = element.parentNode;
        var template = document.createElement('div');
        template.innerHTML = TEMPLATE;
        var cropper = template.querySelector(".".concat(NAMESPACE, "-container"));
        var canvas = cropper.querySelector(".".concat(NAMESPACE, "-canvas"));
        var dragBox = cropper.querySelector(".".concat(NAMESPACE, "-drag-box"));
        var cropBox = cropper.querySelector(".".concat(NAMESPACE, "-crop-box"));
        var face = cropBox.querySelector(".".concat(NAMESPACE, "-face"));
        this.container = container;
        this.cropper = cropper;
        this.canvas = canvas;
        this.dragBox = dragBox;
        this.cropBox = cropBox;
        this.viewBox = cropper.querySelector(".".concat(NAMESPACE, "-view-box"));
        this.face = face;
        canvas.appendChild(image);

        // Hide the original image
        addClass(element, CLASS_HIDDEN);

        // Inserts the cropper after to the current image
        container.insertBefore(cropper, element.nextSibling);

        // Show the hidden image
        removeClass(image, CLASS_HIDE);
        this.initPreview();
        this.bind();
        options.initialAspectRatio = Math.max(0, options.initialAspectRatio) || NaN;
        options.aspectRatio = Math.max(0, options.aspectRatio) || NaN;
        options.viewMode = Math.max(0, Math.min(3, Math.round(options.viewMode))) || 0;
        addClass(cropBox, CLASS_HIDDEN);
        if (!options.guides) {
          addClass(cropBox.getElementsByClassName("".concat(NAMESPACE, "-dashed")), CLASS_HIDDEN);
        }
        if (!options.center) {
          addClass(cropBox.getElementsByClassName("".concat(NAMESPACE, "-center")), CLASS_HIDDEN);
        }
        if (options.background) {
          addClass(cropper, "".concat(NAMESPACE, "-bg"));
        }
        if (!options.highlight) {
          addClass(face, CLASS_INVISIBLE);
        }
        if (options.cropBoxMovable) {
          addClass(face, CLASS_MOVE);
          setData(face, DATA_ACTION, ACTION_ALL);
        }
        if (!options.cropBoxResizable) {
          addClass(cropBox.getElementsByClassName("".concat(NAMESPACE, "-line")), CLASS_HIDDEN);
          addClass(cropBox.getElementsByClassName("".concat(NAMESPACE, "-point")), CLASS_HIDDEN);
        }
        this.render();
        this.ready = true;
        this.setDragMode(options.dragMode);
        if (options.autoCrop) {
          this.crop();
        }
        this.setData(options.data);
        if (isFunction(options.ready)) {
          addListener(element, EVENT_READY, options.ready, {
            once: true
          });
        }
        dispatchEvent(element, EVENT_READY);
      }
    }, {
      key: "unbuild",
      value: function unbuild() {
        if (!this.ready) {
          return;
        }
        this.ready = false;
        this.unbind();
        this.resetPreview();
        var parentNode = this.cropper.parentNode;
        if (parentNode) {
          parentNode.removeChild(this.cropper);
        }
        removeClass(this.element, CLASS_HIDDEN);
      }
    }, {
      key: "uncreate",
      value: function uncreate() {
        if (this.ready) {
          this.unbuild();
          this.ready = false;
          this.cropped = false;
        } else if (this.sizing) {
          this.sizingImage.onload = null;
          this.sizing = false;
          this.sized = false;
        } else if (this.reloading) {
          this.xhr.onabort = null;
          this.xhr.abort();
        } else if (this.image) {
          this.stop();
        }
      }

      /**
       * Get the no conflict cropper class.
       * @returns {Cropper} The cropper class.
       */
    }], [{
      key: "noConflict",
      value: function noConflict() {
        window.Cropper = AnotherCropper;
        return Cropper;
      }

      /**
       * Change the default options.
       * @param {Object} options - The new default options.
       */
    }, {
      key: "setDefaults",
      value: function setDefaults(options) {
        assign(DEFAULTS, isPlainObject(options) && options);
      }
    }]);
  }();
  assign(Cropper.prototype, render, preview, events, handlers, change, methods);

  return Cropper;

}));


/***/ }),
/* 332 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// eslint-disable-next-line no-empty-function
module.exports = function () {};


/***/ }),
/* 333 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = __webpack_require__(334)() ? Object.assign : __webpack_require__(335);


/***/ }),
/* 334 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function () {
	var assign = Object.assign, obj;
	if (typeof assign !== "function") return false;
	obj = { foo: "raz" };
	assign(obj, { bar: "dwa" }, { trzy: "trzy" });
	return obj.foo + obj.bar + obj.trzy === "razdwatrzy";
};


/***/ }),
/* 335 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var keys  = __webpack_require__(336)
  , value = __webpack_require__(340)
  , max   = Math.max;

module.exports = function (dest, src /*, …srcn*/) {
	var error, i, length = max(arguments.length, 2), assign;
	dest = Object(value(dest));
	assign = function (key) {
		try {
			dest[key] = src[key];
		} catch (e) {
			if (!error) error = e;
		}
	};
	for (i = 1; i < length; ++i) {
		src = arguments[i];
		keys(src).forEach(assign);
	}
	if (error !== undefined) throw error;
	return dest;
};


/***/ }),
/* 336 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = __webpack_require__(337)() ? Object.keys : __webpack_require__(338);


/***/ }),
/* 337 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function () {
	try {
		Object.keys("primitive");
		return true;
	} catch (e) {
		return false;
	}
};


/***/ }),
/* 338 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isValue = __webpack_require__(70);

var keys = Object.keys;

module.exports = function (object) { return keys(isValue(object) ? Object(object) : object); };


/***/ }),
/* 339 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isValue = __webpack_require__(70);

var forEach = Array.prototype.forEach, create = Object.create;

var process = function (src, obj) {
	var key;
	for (key in src) obj[key] = src[key];
};

// eslint-disable-next-line no-unused-vars
module.exports = function (opts1 /*, …options*/) {
	var result = create(null);
	forEach.call(arguments, function (options) {
		if (!isValue(options)) return;
		process(Object(options), result);
	});
	return result;
};


/***/ }),
/* 340 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isValue = __webpack_require__(70);

module.exports = function (value) {
	if (!isValue(value)) throw new TypeError("Cannot use null or undefined");
	return value;
};


/***/ }),
/* 341 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = __webpack_require__(342)() ? String.prototype.contains : __webpack_require__(343);


/***/ }),
/* 342 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var str = "razdwatrzy";

module.exports = function () {
	if (typeof str.contains !== "function") return false;
	return str.contains("dwa") === true && str.contains("foo") === false;
};


/***/ }),
/* 343 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var indexOf = String.prototype.indexOf;

module.exports = function (searchString /*, position*/) {
	return indexOf.call(this, searchString, arguments[1]) > -1;
};


/***/ }),
/* 344 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var global     = __webpack_require__(41)
  , validTypes = { object: true, symbol: true };

module.exports = function () {
	var Symbol = global.Symbol;
	var symbol;
	if (typeof Symbol !== "function") return false;
	symbol = Symbol("test symbol");
	try { String(symbol); }
	catch (e) { return false; }

	// Return 'true' also for polyfills
	if (!validTypes[typeof Symbol.iterator]) return false;
	if (!validTypes[typeof Symbol.toPrimitive]) return false;
	if (!validTypes[typeof Symbol.toStringTag]) return false;

	return true;
};


/***/ }),
/* 345 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function (value) {
	if (!value) return false;
	if (typeof value === "symbol") return true;
	if (!value.constructor) return false;
	if (value.constructor.name !== "Symbol") return false;
	return value[value.constructor.toStringTag] === "Symbol";
};


/***/ }),
/* 346 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var d = __webpack_require__(40);

var create = Object.create, defineProperty = Object.defineProperty, objPrototype = Object.prototype;

var created = create(null);
module.exports = function (desc) {
	var postfix = 0, name, ie11BugWorkaround;
	while (created[desc + (postfix || "")]) ++postfix;
	desc += postfix || "";
	created[desc] = true;
	name = "@@" + desc;
	defineProperty(
		objPrototype, name,
		d.gs(null, function (value) {
			// For IE11 issue see:
			// https://connect.microsoft.com/IE/feedbackdetail/view/1928508/
			//    ie11-broken-getters-on-dom-objects
			// https://github.com/medikoo/es6-symbol/issues/12
			if (ie11BugWorkaround) return;
			ie11BugWorkaround = true;
			defineProperty(this, name, d(value));
			ie11BugWorkaround = false;
		})
	);
	return name;
};


/***/ }),
/* 347 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var d            = __webpack_require__(40)
  , NativeSymbol = __webpack_require__(41).Symbol;

module.exports = function (SymbolPolyfill) {
	return Object.defineProperties(SymbolPolyfill, {
		// To ensure proper interoperability with other native functions (e.g. Array.from)
		// fallback to eventual native implementation of given symbol
		hasInstance: d(
			"", (NativeSymbol && NativeSymbol.hasInstance) || SymbolPolyfill("hasInstance")
		),
		isConcatSpreadable: d(
			"",
			(NativeSymbol && NativeSymbol.isConcatSpreadable) ||
				SymbolPolyfill("isConcatSpreadable")
		),
		iterator: d("", (NativeSymbol && NativeSymbol.iterator) || SymbolPolyfill("iterator")),
		match: d("", (NativeSymbol && NativeSymbol.match) || SymbolPolyfill("match")),
		replace: d("", (NativeSymbol && NativeSymbol.replace) || SymbolPolyfill("replace")),
		search: d("", (NativeSymbol && NativeSymbol.search) || SymbolPolyfill("search")),
		species: d("", (NativeSymbol && NativeSymbol.species) || SymbolPolyfill("species")),
		split: d("", (NativeSymbol && NativeSymbol.split) || SymbolPolyfill("split")),
		toPrimitive: d(
			"", (NativeSymbol && NativeSymbol.toPrimitive) || SymbolPolyfill("toPrimitive")
		),
		toStringTag: d(
			"", (NativeSymbol && NativeSymbol.toStringTag) || SymbolPolyfill("toStringTag")
		),
		unscopables: d(
			"", (NativeSymbol && NativeSymbol.unscopables) || SymbolPolyfill("unscopables")
		)
	});
};


/***/ }),
/* 348 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var d              = __webpack_require__(40)
  , validateSymbol = __webpack_require__(122);

var registry = Object.create(null);

module.exports = function (SymbolPolyfill) {
	return Object.defineProperties(SymbolPolyfill, {
		for: d(function (key) {
			if (registry[key]) return registry[key];
			return (registry[key] = SymbolPolyfill(String(key)));
		}),
		keyFor: d(function (symbol) {
			var key;
			validateSymbol(symbol);
			for (key in registry) {
				if (registry[key] === symbol) return key;
			}
			return undefined;
		})
	});
};


/***/ }),
/* 349 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// ES2015 Symbol polyfill for environments that do not (or partially) support it



var d                    = __webpack_require__(40)
  , validateSymbol       = __webpack_require__(122)
  , NativeSymbol         = __webpack_require__(41).Symbol
  , generateName         = __webpack_require__(346)
  , setupStandardSymbols = __webpack_require__(347)
  , setupSymbolRegistry  = __webpack_require__(348);

var create = Object.create
  , defineProperties = Object.defineProperties
  , defineProperty = Object.defineProperty;

var SymbolPolyfill, HiddenSymbol, isNativeSafe;

if (typeof NativeSymbol === "function") {
	try {
		String(NativeSymbol());
		isNativeSafe = true;
	} catch (ignore) {}
} else {
	NativeSymbol = null;
}

// Internal constructor (not one exposed) for creating Symbol instances.
// This one is used to ensure that `someSymbol instanceof Symbol` always return false
HiddenSymbol = function Symbol(description) {
	if (this instanceof HiddenSymbol) throw new TypeError("Symbol is not a constructor");
	return SymbolPolyfill(description);
};

// Exposed `Symbol` constructor
// (returns instances of HiddenSymbol)
module.exports = SymbolPolyfill = function Symbol(description) {
	var symbol;
	if (this instanceof Symbol) throw new TypeError("Symbol is not a constructor");
	if (isNativeSafe) return NativeSymbol(description);
	symbol = create(HiddenSymbol.prototype);
	description = description === undefined ? "" : String(description);
	return defineProperties(symbol, {
		__description__: d("", description),
		__name__: d("", generateName(description))
	});
};

setupStandardSymbols(SymbolPolyfill);
setupSymbolRegistry(SymbolPolyfill);

// Internal tweaks for real symbol producer
defineProperties(HiddenSymbol.prototype, {
	constructor: d(SymbolPolyfill),
	toString: d("", function () { return this.__name__; })
});

// Proper implementation of methods exposed on Symbol.prototype
// They won't be accessible on produced symbol instances as they derive from HiddenSymbol.prototype
defineProperties(SymbolPolyfill.prototype, {
	toString: d(function () { return "Symbol (" + validateSymbol(this).__description__ + ")"; }),
	valueOf: d(function () { return validateSymbol(this); })
});
defineProperty(
	SymbolPolyfill.prototype, SymbolPolyfill.toPrimitive,
	d("", function () {
		var symbol = validateSymbol(this);
		if (typeof symbol === "symbol") return symbol;
		return symbol.toString();
	})
);
defineProperty(SymbolPolyfill.prototype, SymbolPolyfill.toStringTag, d("c", "Symbol"));

// Proper implementaton of toPrimitive and toStringTag for returned symbol instances
defineProperty(
	HiddenSymbol.prototype, SymbolPolyfill.toStringTag,
	d("c", SymbolPolyfill.prototype[SymbolPolyfill.toStringTag])
);

// Note: It's important to define `toPrimitive` as last one, as some implementations
// implement `toPrimitive` natively without implementing `toStringTag` (or other specified symbols)
// And that may invoke error in definition flow:
// See: https://github.com/medikoo/es6-symbol/issues/13#issuecomment-164146149
defineProperty(
	HiddenSymbol.prototype, SymbolPolyfill.toPrimitive,
	d("c", SymbolPolyfill.prototype[SymbolPolyfill.toPrimitive])
);


/***/ }),
/* 350 */
/***/ (function(module, exports) {

var naiveFallback = function () {
	if (typeof self === "object" && self) return self;
	if (typeof window === "object" && window) return window;
	throw new Error("Unable to resolve global `this`");
};

module.exports = (function () {
	if (this) return this;

	// Unexpected strict mode (may happen if e.g. bundled into ESM module)

	// Thanks @mathiasbynens -> https://mathiasbynens.be/notes/globalthis
	// In all ES5+ engines global object inherits from Object.prototype
	// (if you approached one that doesn't please report)
	try {
		Object.defineProperty(Object.prototype, "__global__", {
			get: function () { return this; },
			configurable: true
		});
	} catch (error) {
		// Unfortunate case of Object.prototype being sealed (via preventExtensions, seal or freeze)
		return naiveFallback();
	}
	try {
		// Safari case (window.__global__ is resolved with global context, but __global__ does not)
		if (!__global__) return naiveFallback();
		return __global__;
	} finally {
		delete Object.prototype.__global__;
	}
})();


/***/ }),
/* 351 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function () {
	if (typeof globalThis !== "object") return false;
	if (!globalThis) return false;
	return globalThis.Array === Array;
};


/***/ }),
/* 352 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 353 */
/***/ (function(module, exports) {

/*!
 * jQuery & Zepto Lazy - AJAX Plugin - v1.4
 * http://jquery.eisbehr.de/lazy/
 *
 * Copyright 2012 - 2018, Daniel 'Eisbehr' Kern
 *
 * Dual licensed under the MIT and GPL-2.0 licenses:
 * http://www.opensource.org/licenses/mit-license.php
 * http://www.gnu.org/licenses/gpl-2.0.html
 */
;(function($) {
    // load data by ajax request and pass them to elements inner html, like:
    // <div data-loader="ajax" data-src="url.html" data-method="post" data-type="html"></div>
    $.lazy('ajax', function(element, response) {
        ajaxRequest(this, element, response, element.attr('data-method'));
    });

    // load data by ajax get request and pass them to elements inner html, like:
    // <div data-loader="get" data-src="url.html" data-type="html"></div>
    $.lazy('get', function(element, response) {
        ajaxRequest(this, element, response, 'GET');
    });

    // load data by ajax post request and pass them to elements inner html, like:
    // <div data-loader="post" data-src="url.html" data-type="html"></div>
    $.lazy('post', function(element, response) {
        ajaxRequest(this, element, response, 'POST');
    });

    // load data by ajax put request and pass them to elements inner html, like:
    // <div data-loader="put" data-src="url.html" data-type="html"></div>
    $.lazy('put', function(element, response) {
        ajaxRequest(this, element, response, 'PUT');
    });

    /**
     * execute ajax request and handle response
     * @param {object} instance
     * @param {jQuery|object} element
     * @param {function} response
     * @param {string} [method]
     */
    function ajaxRequest(instance, element, response, method) {
        method = method ? method.toUpperCase() : 'GET';

        var data;
        if ((method === 'POST' || method === 'PUT') && instance.config('ajaxCreateData')) {
            data = instance.config('ajaxCreateData').apply(instance, [element]);
        }

        $.ajax({
            url: element.attr('data-src'),
            type: method === 'POST' || method === 'PUT' ? method : 'GET',
            data: data,
            dataType: element.attr('data-type') || 'html',

            /**
             * success callback
             * @access private
             * @param {*} content
             * @return {void}
             */
            success: function(content) {
                // set responded data to element's inner html
                element.html(content);

                // use response function for Zepto
                response(true);

                // remove attributes
                if (instance.config('removeAttribute')) {
                    element.removeAttr('data-src data-method data-type');
                }
            },

            /**
             * error callback
             * @access private
             * @return {void}
             */
            error: function() {
                // pass error state to lazy
                // use response function for Zepto
                response(false);
            }
        });
    }
})(window.jQuery || window.Zepto);

/***/ }),
/* 354 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * JavaScript Cookie v2.2.1
 * https://github.com/js-cookie/js-cookie
 *
 * Copyright 2006, 2015 Klaus Hartl & Fagner Brack
 * Released under the MIT license
 */
;(function (factory) {
	var registeredInModuleLoader;
	if (true) {
		!(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		registeredInModuleLoader = true;
	}
	if (true) {
		module.exports = factory();
		registeredInModuleLoader = true;
	}
	if (!registeredInModuleLoader) {
		var OldCookies = window.Cookies;
		var api = window.Cookies = factory();
		api.noConflict = function () {
			window.Cookies = OldCookies;
			return api;
		};
	}
}(function () {
	function extend () {
		var i = 0;
		var result = {};
		for (; i < arguments.length; i++) {
			var attributes = arguments[ i ];
			for (var key in attributes) {
				result[key] = attributes[key];
			}
		}
		return result;
	}

	function decode (s) {
		return s.replace(/(%[0-9A-Z]{2})+/g, decodeURIComponent);
	}

	function init (converter) {
		function api() {}

		function set (key, value, attributes) {
			if (typeof document === 'undefined') {
				return;
			}

			attributes = extend({
				path: '/'
			}, api.defaults, attributes);

			if (typeof attributes.expires === 'number') {
				attributes.expires = new Date(new Date() * 1 + attributes.expires * 864e+5);
			}

			// We're using "expires" because "max-age" is not supported by IE
			attributes.expires = attributes.expires ? attributes.expires.toUTCString() : '';

			try {
				var result = JSON.stringify(value);
				if (/^[\{\[]/.test(result)) {
					value = result;
				}
			} catch (e) {}

			value = converter.write ?
				converter.write(value, key) :
				encodeURIComponent(String(value))
					.replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent);

			key = encodeURIComponent(String(key))
				.replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent)
				.replace(/[\(\)]/g, escape);

			var stringifiedAttributes = '';
			for (var attributeName in attributes) {
				if (!attributes[attributeName]) {
					continue;
				}
				stringifiedAttributes += '; ' + attributeName;
				if (attributes[attributeName] === true) {
					continue;
				}

				// Considers RFC 6265 section 5.2:
				// ...
				// 3.  If the remaining unparsed-attributes contains a %x3B (";")
				//     character:
				// Consume the characters of the unparsed-attributes up to,
				// not including, the first %x3B (";") character.
				// ...
				stringifiedAttributes += '=' + attributes[attributeName].split(';')[0];
			}

			return (document.cookie = key + '=' + value + stringifiedAttributes);
		}

		function get (key, json) {
			if (typeof document === 'undefined') {
				return;
			}

			var jar = {};
			// To prevent the for loop in the first place assign an empty array
			// in case there are no cookies at all.
			var cookies = document.cookie ? document.cookie.split('; ') : [];
			var i = 0;

			for (; i < cookies.length; i++) {
				var parts = cookies[i].split('=');
				var cookie = parts.slice(1).join('=');

				if (!json && cookie.charAt(0) === '"') {
					cookie = cookie.slice(1, -1);
				}

				try {
					var name = decode(parts[0]);
					cookie = (converter.read || converter)(cookie, name) ||
						decode(cookie);

					if (json) {
						try {
							cookie = JSON.parse(cookie);
						} catch (e) {}
					}

					jar[name] = cookie;

					if (key === name) {
						break;
					}
				} catch (e) {}
			}

			return key ? jar[key] : jar;
		}

		api.set = set;
		api.get = function (key) {
			return get(key, false /* read as raw */);
		};
		api.getJSON = function (key) {
			return get(key, true /* read as json */);
		};
		api.remove = function (key, attributes) {
			set(key, '', extend(attributes, {
				expires: -1
			}));
		};

		api.defaults = {};

		api.withConverter = init;

		return api;
	}

	return init(function () {});
}));


/***/ }),
/* 355 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(19),
    root = __webpack_require__(4);

/* Built-in method references that are verified to be native. */
var DataView = getNative(root, 'DataView');

module.exports = DataView;


/***/ }),
/* 356 */
/***/ (function(module, exports, __webpack_require__) {

var hashClear = __webpack_require__(422),
    hashDelete = __webpack_require__(423),
    hashGet = __webpack_require__(424),
    hashHas = __webpack_require__(425),
    hashSet = __webpack_require__(426);

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

module.exports = Hash;


/***/ }),
/* 357 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(19),
    root = __webpack_require__(4);

/* Built-in method references that are verified to be native. */
var Promise = getNative(root, 'Promise');

module.exports = Promise;


/***/ }),
/* 358 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function arrayFilter(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result[resIndex++] = value;
    }
  }
  return result;
}

module.exports = arrayFilter;


/***/ }),
/* 359 */
/***/ (function(module, exports) {

/**
 * This function is like `arrayIncludes` except that it accepts a comparator.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @param {Function} comparator The comparator invoked per element.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */
function arrayIncludesWith(array, value, comparator) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (comparator(value, array[index])) {
      return true;
    }
  }
  return false;
}

module.exports = arrayIncludesWith;


/***/ }),
/* 360 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

module.exports = arrayMap;


/***/ }),
/* 361 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.reduce` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @param {boolean} [initAccum] Specify using the first element of `array` as
 *  the initial value.
 * @returns {*} Returns the accumulated value.
 */
function arrayReduce(array, iteratee, accumulator, initAccum) {
  var index = -1,
      length = array == null ? 0 : array.length;

  if (initAccum && length) {
    accumulator = array[++index];
  }
  while (++index < length) {
    accumulator = iteratee(accumulator, array[index], index, array);
  }
  return accumulator;
}

module.exports = arrayReduce;


/***/ }),
/* 362 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */
function arraySome(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (predicate(array[index], index, array)) {
      return true;
    }
  }
  return false;
}

module.exports = arraySome;


/***/ }),
/* 363 */
/***/ (function(module, exports) {

/**
 * Converts an ASCII `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function asciiToArray(string) {
  return string.split('');
}

module.exports = asciiToArray;


/***/ }),
/* 364 */
/***/ (function(module, exports) {

/** Used to match words composed of alphanumeric characters. */
var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;

/**
 * Splits an ASCII `string` into an array of its words.
 *
 * @private
 * @param {string} The string to inspect.
 * @returns {Array} Returns the words of `string`.
 */
function asciiWords(string) {
  return string.match(reAsciiWord) || [];
}

module.exports = asciiWords;


/***/ }),
/* 365 */
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__(18),
    keys = __webpack_require__(20);

/**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssign(object, source) {
  return object && copyObject(source, keys(source), object);
}

module.exports = baseAssign;


/***/ }),
/* 366 */
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__(18),
    keysIn = __webpack_require__(26);

/**
 * The base implementation of `_.assignIn` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssignIn(object, source) {
  return object && copyObject(source, keysIn(source), object);
}

module.exports = baseAssignIn;


/***/ }),
/* 367 */
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(43),
    arrayEach = __webpack_require__(128),
    assignValue = __webpack_require__(76),
    baseAssign = __webpack_require__(365),
    baseAssignIn = __webpack_require__(366),
    cloneBuffer = __webpack_require__(142),
    copyArray = __webpack_require__(46),
    copySymbols = __webpack_require__(400),
    copySymbolsIn = __webpack_require__(401),
    getAllKeys = __webpack_require__(152),
    getAllKeysIn = __webpack_require__(415),
    getTag = __webpack_require__(49),
    initCloneArray = __webpack_require__(427),
    initCloneByTag = __webpack_require__(428),
    initCloneObject = __webpack_require__(157),
    isArray = __webpack_require__(9),
    isBuffer = __webpack_require__(56),
    isMap = __webpack_require__(477),
    isObject = __webpack_require__(7),
    isSet = __webpack_require__(480),
    keys = __webpack_require__(20),
    keysIn = __webpack_require__(26);

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG = 1,
    CLONE_FLAT_FLAG = 2,
    CLONE_SYMBOLS_FLAG = 4;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values supported by `_.clone`. */
var cloneableTags = {};
cloneableTags[argsTag] = cloneableTags[arrayTag] =
cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
cloneableTags[boolTag] = cloneableTags[dateTag] =
cloneableTags[float32Tag] = cloneableTags[float64Tag] =
cloneableTags[int8Tag] = cloneableTags[int16Tag] =
cloneableTags[int32Tag] = cloneableTags[mapTag] =
cloneableTags[numberTag] = cloneableTags[objectTag] =
cloneableTags[regexpTag] = cloneableTags[setTag] =
cloneableTags[stringTag] = cloneableTags[symbolTag] =
cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
cloneableTags[errorTag] = cloneableTags[funcTag] =
cloneableTags[weakMapTag] = false;

/**
 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
 * traversed objects.
 *
 * @private
 * @param {*} value The value to clone.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Deep clone
 *  2 - Flatten inherited properties
 *  4 - Clone symbols
 * @param {Function} [customizer] The function to customize cloning.
 * @param {string} [key] The key of `value`.
 * @param {Object} [object] The parent object of `value`.
 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
 * @returns {*} Returns the cloned value.
 */
function baseClone(value, bitmask, customizer, key, object, stack) {
  var result,
      isDeep = bitmask & CLONE_DEEP_FLAG,
      isFlat = bitmask & CLONE_FLAT_FLAG,
      isFull = bitmask & CLONE_SYMBOLS_FLAG;

  if (customizer) {
    result = object ? customizer(value, key, object, stack) : customizer(value);
  }
  if (result !== undefined) {
    return result;
  }
  if (!isObject(value)) {
    return value;
  }
  var isArr = isArray(value);
  if (isArr) {
    result = initCloneArray(value);
    if (!isDeep) {
      return copyArray(value, result);
    }
  } else {
    var tag = getTag(value),
        isFunc = tag == funcTag || tag == genTag;

    if (isBuffer(value)) {
      return cloneBuffer(value, isDeep);
    }
    if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
      result = (isFlat || isFunc) ? {} : initCloneObject(value);
      if (!isDeep) {
        return isFlat
          ? copySymbolsIn(value, baseAssignIn(result, value))
          : copySymbols(value, baseAssign(result, value));
      }
    } else {
      if (!cloneableTags[tag]) {
        return object ? value : {};
      }
      result = initCloneByTag(value, tag, isDeep);
    }
  }
  // Check for circular references and return its corresponding clone.
  stack || (stack = new Stack);
  var stacked = stack.get(value);
  if (stacked) {
    return stacked;
  }
  stack.set(value, result);

  if (isSet(value)) {
    value.forEach(function(subValue) {
      result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
    });
  } else if (isMap(value)) {
    value.forEach(function(subValue, key) {
      result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
    });
  }

  var keysFunc = isFull
    ? (isFlat ? getAllKeysIn : getAllKeys)
    : (isFlat ? keysIn : keys);

  var props = isArr ? undefined : keysFunc(value);
  arrayEach(props || value, function(subValue, key) {
    if (props) {
      key = subValue;
      subValue = value[key];
    }
    // Recursively populate clone (susceptible to call stack limits).
    assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
  });
  return result;
}

module.exports = baseClone;


/***/ }),
/* 368 */
/***/ (function(module, exports, __webpack_require__) {

var createBaseFor = __webpack_require__(404);

/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */
var baseFor = createBaseFor();

module.exports = baseFor;


/***/ }),
/* 369 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.has` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */
function baseHas(object, key) {
  return object != null && hasOwnProperty.call(object, key);
}

module.exports = baseHas;


/***/ }),
/* 370 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */
function baseHasIn(object, key) {
  return object != null && key in Object(object);
}

module.exports = baseHasIn;


/***/ }),
/* 371 */
/***/ (function(module, exports, __webpack_require__) {

var baseFindIndex = __webpack_require__(133),
    baseIsNaN = __webpack_require__(376),
    strictIndexOf = __webpack_require__(459);

/**
 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseIndexOf(array, value, fromIndex) {
  return value === value
    ? strictIndexOf(array, value, fromIndex)
    : baseFindIndex(array, baseIsNaN, fromIndex);
}

module.exports = baseIndexOf;


/***/ }),
/* 372 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(16),
    isObjectLike = __webpack_require__(10);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]';

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return isObjectLike(value) && baseGetTag(value) == argsTag;
}

module.exports = baseIsArguments;


/***/ }),
/* 373 */
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(43),
    equalArrays = __webpack_require__(150),
    equalByTag = __webpack_require__(413),
    equalObjects = __webpack_require__(414),
    getTag = __webpack_require__(49),
    isArray = __webpack_require__(9),
    isBuffer = __webpack_require__(56),
    isTypedArray = __webpack_require__(95);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    objectTag = '[object Object]';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
  var objIsArr = isArray(object),
      othIsArr = isArray(other),
      objTag = objIsArr ? arrayTag : getTag(object),
      othTag = othIsArr ? arrayTag : getTag(other);

  objTag = objTag == argsTag ? objectTag : objTag;
  othTag = othTag == argsTag ? objectTag : othTag;

  var objIsObj = objTag == objectTag,
      othIsObj = othTag == objectTag,
      isSameTag = objTag == othTag;

  if (isSameTag && isBuffer(object)) {
    if (!isBuffer(other)) {
      return false;
    }
    objIsArr = true;
    objIsObj = false;
  }
  if (isSameTag && !objIsObj) {
    stack || (stack = new Stack);
    return (objIsArr || isTypedArray(object))
      ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
      : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
  }
  if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object.value() : object,
          othUnwrapped = othIsWrapped ? other.value() : other;

      stack || (stack = new Stack);
      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
    }
  }
  if (!isSameTag) {
    return false;
  }
  stack || (stack = new Stack);
  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}

module.exports = baseIsEqualDeep;


/***/ }),
/* 374 */
/***/ (function(module, exports, __webpack_require__) {

var getTag = __webpack_require__(49),
    isObjectLike = __webpack_require__(10);

/** `Object#toString` result references. */
var mapTag = '[object Map]';

/**
 * The base implementation of `_.isMap` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 */
function baseIsMap(value) {
  return isObjectLike(value) && getTag(value) == mapTag;
}

module.exports = baseIsMap;


/***/ }),
/* 375 */
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(43),
    baseIsEqual = __webpack_require__(136);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */
function baseIsMatch(object, source, matchData, customizer) {
  var index = matchData.length,
      length = index,
      noCustomizer = !customizer;

  if (object == null) {
    return !length;
  }
  object = Object(object);
  while (index--) {
    var data = matchData[index];
    if ((noCustomizer && data[2])
          ? data[1] !== object[data[0]]
          : !(data[0] in object)
        ) {
      return false;
    }
  }
  while (++index < length) {
    data = matchData[index];
    var key = data[0],
        objValue = object[key],
        srcValue = data[1];

    if (noCustomizer && data[2]) {
      if (objValue === undefined && !(key in object)) {
        return false;
      }
    } else {
      var stack = new Stack;
      if (customizer) {
        var result = customizer(objValue, srcValue, key, object, source, stack);
      }
      if (!(result === undefined
            ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
            : result
          )) {
        return false;
      }
    }
  }
  return true;
}

module.exports = baseIsMatch;


/***/ }),
/* 376 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.isNaN` without support for number objects.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 */
function baseIsNaN(value) {
  return value !== value;
}

module.exports = baseIsNaN;


/***/ }),
/* 377 */
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__(92),
    isMasked = __webpack_require__(432),
    isObject = __webpack_require__(7),
    toSource = __webpack_require__(167);

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

module.exports = baseIsNative;


/***/ }),
/* 378 */
/***/ (function(module, exports, __webpack_require__) {

var getTag = __webpack_require__(49),
    isObjectLike = __webpack_require__(10);

/** `Object#toString` result references. */
var setTag = '[object Set]';

/**
 * The base implementation of `_.isSet` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 */
function baseIsSet(value) {
  return isObjectLike(value) && getTag(value) == setTag;
}

module.exports = baseIsSet;


/***/ }),
/* 379 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(16),
    isLength = __webpack_require__(93),
    isObjectLike = __webpack_require__(10);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
typedArrayTags[errorTag] = typedArrayTags[funcTag] =
typedArrayTags[mapTag] = typedArrayTags[numberTag] =
typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
typedArrayTags[setTag] = typedArrayTags[stringTag] =
typedArrayTags[weakMapTag] = false;

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return isObjectLike(value) &&
    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}

module.exports = baseIsTypedArray;


/***/ }),
/* 380 */
/***/ (function(module, exports, __webpack_require__) {

var isPrototype = __webpack_require__(51),
    nativeKeys = __webpack_require__(446);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

module.exports = baseKeys;


/***/ }),
/* 381 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(7),
    isPrototype = __webpack_require__(51),
    nativeKeysIn = __webpack_require__(447);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeysIn(object) {
  if (!isObject(object)) {
    return nativeKeysIn(object);
  }
  var isProto = isPrototype(object),
      result = [];

  for (var key in object) {
    if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = baseKeysIn;


/***/ }),
/* 382 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsMatch = __webpack_require__(375),
    getMatchData = __webpack_require__(417),
    matchesStrictComparable = __webpack_require__(159);

/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatches(source) {
  var matchData = getMatchData(source);
  if (matchData.length == 1 && matchData[0][2]) {
    return matchesStrictComparable(matchData[0][0], matchData[0][1]);
  }
  return function(object) {
    return object === source || baseIsMatch(object, source, matchData);
  };
}

module.exports = baseMatches;


/***/ }),
/* 383 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqual = __webpack_require__(136),
    get = __webpack_require__(8),
    hasIn = __webpack_require__(475),
    isKey = __webpack_require__(87),
    isStrictComparable = __webpack_require__(158),
    matchesStrictComparable = __webpack_require__(159),
    toKey = __webpack_require__(54);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatchesProperty(path, srcValue) {
  if (isKey(path) && isStrictComparable(srcValue)) {
    return matchesStrictComparable(toKey(path), srcValue);
  }
  return function(object) {
    var objValue = get(object, path);
    return (objValue === undefined && objValue === srcValue)
      ? hasIn(object, path)
      : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
  };
}

module.exports = baseMatchesProperty;


/***/ }),
/* 384 */
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(43),
    assignMergeValue = __webpack_require__(132),
    baseFor = __webpack_require__(368),
    baseMergeDeep = __webpack_require__(385),
    isObject = __webpack_require__(7),
    keysIn = __webpack_require__(26),
    safeGet = __webpack_require__(162);

/**
 * The base implementation of `_.merge` without support for multiple sources.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} [customizer] The function to customize merged values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */
function baseMerge(object, source, srcIndex, customizer, stack) {
  if (object === source) {
    return;
  }
  baseFor(source, function(srcValue, key) {
    stack || (stack = new Stack);
    if (isObject(srcValue)) {
      baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
    }
    else {
      var newValue = customizer
        ? customizer(safeGet(object, key), srcValue, (key + ''), object, source, stack)
        : undefined;

      if (newValue === undefined) {
        newValue = srcValue;
      }
      assignMergeValue(object, key, newValue);
    }
  }, keysIn);
}

module.exports = baseMerge;


/***/ }),
/* 385 */
/***/ (function(module, exports, __webpack_require__) {

var assignMergeValue = __webpack_require__(132),
    cloneBuffer = __webpack_require__(142),
    cloneTypedArray = __webpack_require__(143),
    copyArray = __webpack_require__(46),
    initCloneObject = __webpack_require__(157),
    isArguments = __webpack_require__(91),
    isArray = __webpack_require__(9),
    isArrayLikeObject = __webpack_require__(476),
    isBuffer = __webpack_require__(56),
    isFunction = __webpack_require__(92),
    isObject = __webpack_require__(7),
    isPlainObject = __webpack_require__(479),
    isTypedArray = __webpack_require__(95),
    safeGet = __webpack_require__(162),
    toPlainObject = __webpack_require__(488);

/**
 * A specialized version of `baseMerge` for arrays and objects which performs
 * deep merges and tracks traversed objects enabling objects with circular
 * references to be merged.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {string} key The key of the value to merge.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} mergeFunc The function to merge values.
 * @param {Function} [customizer] The function to customize assigned values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */
function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
  var objValue = safeGet(object, key),
      srcValue = safeGet(source, key),
      stacked = stack.get(srcValue);

  if (stacked) {
    assignMergeValue(object, key, stacked);
    return;
  }
  var newValue = customizer
    ? customizer(objValue, srcValue, (key + ''), object, source, stack)
    : undefined;

  var isCommon = newValue === undefined;

  if (isCommon) {
    var isArr = isArray(srcValue),
        isBuff = !isArr && isBuffer(srcValue),
        isTyped = !isArr && !isBuff && isTypedArray(srcValue);

    newValue = srcValue;
    if (isArr || isBuff || isTyped) {
      if (isArray(objValue)) {
        newValue = objValue;
      }
      else if (isArrayLikeObject(objValue)) {
        newValue = copyArray(objValue);
      }
      else if (isBuff) {
        isCommon = false;
        newValue = cloneBuffer(srcValue, true);
      }
      else if (isTyped) {
        isCommon = false;
        newValue = cloneTypedArray(srcValue, true);
      }
      else {
        newValue = [];
      }
    }
    else if (isPlainObject(srcValue) || isArguments(srcValue)) {
      newValue = objValue;
      if (isArguments(objValue)) {
        newValue = toPlainObject(objValue);
      }
      else if (!isObject(objValue) || isFunction(objValue)) {
        newValue = initCloneObject(srcValue);
      }
    }
    else {
      isCommon = false;
    }
  }
  if (isCommon) {
    // Recursively merge objects and arrays (susceptible to call stack limits).
    stack.set(srcValue, newValue);
    mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
    stack['delete'](srcValue);
  }
  assignMergeValue(object, key, newValue);
}

module.exports = baseMergeDeep;


/***/ }),
/* 386 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function baseProperty(key) {
  return function(object) {
    return object == null ? undefined : object[key];
  };
}

module.exports = baseProperty;


/***/ }),
/* 387 */
/***/ (function(module, exports, __webpack_require__) {

var baseGet = __webpack_require__(134);

/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function basePropertyDeep(path) {
  return function(object) {
    return baseGet(object, path);
  };
}

module.exports = basePropertyDeep;


/***/ }),
/* 388 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.propertyOf` without support for deep paths.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Function} Returns the new accessor function.
 */
function basePropertyOf(object) {
  return function(key) {
    return object == null ? undefined : object[key];
  };
}

module.exports = basePropertyOf;


/***/ }),
/* 389 */
/***/ (function(module, exports) {

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeFloor = Math.floor,
    nativeRandom = Math.random;

/**
 * The base implementation of `_.random` without support for returning
 * floating-point numbers.
 *
 * @private
 * @param {number} lower The lower bound.
 * @param {number} upper The upper bound.
 * @returns {number} Returns the random number.
 */
function baseRandom(lower, upper) {
  return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
}

module.exports = baseRandom;


/***/ }),
/* 390 */
/***/ (function(module, exports, __webpack_require__) {

var constant = __webpack_require__(472),
    defineProperty = __webpack_require__(149),
    identity = __webpack_require__(31);

/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var baseSetToString = !defineProperty ? identity : function(func, string) {
  return defineProperty(func, 'toString', {
    'configurable': true,
    'enumerable': false,
    'value': constant(string),
    'writable': true
  });
};

module.exports = baseSetToString;


/***/ }),
/* 391 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.slice` without an iteratee call guard.
 *
 * @private
 * @param {Array} array The array to slice.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the slice of `array`.
 */
function baseSlice(array, start, end) {
  var index = -1,
      length = array.length;

  if (start < 0) {
    start = -start > length ? 0 : (length + start);
  }
  end = end > length ? length : end;
  if (end < 0) {
    end += length;
  }
  length = start > end ? 0 : ((end - start) >>> 0);
  start >>>= 0;

  var result = Array(length);
  while (++index < length) {
    result[index] = array[index + start];
  }
  return result;
}

module.exports = baseSlice;


/***/ }),
/* 392 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(29),
    arrayMap = __webpack_require__(360),
    isArray = __webpack_require__(9),
    isSymbol = __webpack_require__(57);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isArray(value)) {
    // Recursively convert values (susceptible to call stack limits).
    return arrayMap(value, baseToString) + '';
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = baseToString;


/***/ }),
/* 393 */
/***/ (function(module, exports, __webpack_require__) {

var trimmedEndIndex = __webpack_require__(462);

/** Used to match leading whitespace. */
var reTrimStart = /^\s+/;

/**
 * The base implementation of `_.trim`.
 *
 * @private
 * @param {string} string The string to trim.
 * @returns {string} Returns the trimmed string.
 */
function baseTrim(string) {
  return string
    ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '')
    : string;
}

module.exports = baseTrim;


/***/ }),
/* 394 */
/***/ (function(module, exports, __webpack_require__) {

var SetCache = __webpack_require__(125),
    arrayIncludes = __webpack_require__(129),
    arrayIncludesWith = __webpack_require__(359),
    cacheHas = __webpack_require__(140),
    createSet = __webpack_require__(410),
    setToArray = __webpack_require__(89);

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * The base implementation of `_.uniqBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 */
function baseUniq(array, iteratee, comparator) {
  var index = -1,
      includes = arrayIncludes,
      length = array.length,
      isCommon = true,
      result = [],
      seen = result;

  if (comparator) {
    isCommon = false;
    includes = arrayIncludesWith;
  }
  else if (length >= LARGE_ARRAY_SIZE) {
    var set = iteratee ? null : createSet(array);
    if (set) {
      return setToArray(set);
    }
    isCommon = false;
    includes = cacheHas;
    seen = new SetCache;
  }
  else {
    seen = iteratee ? [] : result;
  }
  outer:
  while (++index < length) {
    var value = array[index],
        computed = iteratee ? iteratee(value) : value;

    value = (comparator || value !== 0) ? value : 0;
    if (isCommon && computed === computed) {
      var seenIndex = seen.length;
      while (seenIndex--) {
        if (seen[seenIndex] === computed) {
          continue outer;
        }
      }
      if (iteratee) {
        seen.push(computed);
      }
      result.push(value);
    }
    else if (!includes(seen, computed, comparator)) {
      if (seen !== result) {
        seen.push(computed);
      }
      result.push(value);
    }
  }
  return result;
}

module.exports = baseUniq;


/***/ }),
/* 395 */
/***/ (function(module, exports, __webpack_require__) {

var identity = __webpack_require__(31);

/**
 * Casts `value` to `identity` if it's not a function.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Function} Returns cast function.
 */
function castFunction(value) {
  return typeof value == 'function' ? value : identity;
}

module.exports = castFunction;


/***/ }),
/* 396 */
/***/ (function(module, exports, __webpack_require__) {

var baseSlice = __webpack_require__(391);

/**
 * Casts `array` to a slice if it's needed.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {number} start The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the cast slice.
 */
function castSlice(array, start, end) {
  var length = array.length;
  end = end === undefined ? length : end;
  return (!start && end >= length) ? array : baseSlice(array, start, end);
}

module.exports = castSlice;


/***/ }),
/* 397 */
/***/ (function(module, exports, __webpack_require__) {

var cloneArrayBuffer = __webpack_require__(81);

/**
 * Creates a clone of `dataView`.
 *
 * @private
 * @param {Object} dataView The data view to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned data view.
 */
function cloneDataView(dataView, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
  return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}

module.exports = cloneDataView;


/***/ }),
/* 398 */
/***/ (function(module, exports) {

/** Used to match `RegExp` flags from their coerced string values. */
var reFlags = /\w*$/;

/**
 * Creates a clone of `regexp`.
 *
 * @private
 * @param {Object} regexp The regexp to clone.
 * @returns {Object} Returns the cloned regexp.
 */
function cloneRegExp(regexp) {
  var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
  result.lastIndex = regexp.lastIndex;
  return result;
}

module.exports = cloneRegExp;


/***/ }),
/* 399 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(29);

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * Creates a clone of the `symbol` object.
 *
 * @private
 * @param {Object} symbol The symbol object to clone.
 * @returns {Object} Returns the cloned symbol object.
 */
function cloneSymbol(symbol) {
  return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
}

module.exports = cloneSymbol;


/***/ }),
/* 400 */
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__(18),
    getSymbols = __webpack_require__(85);

/**
 * Copies own symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */
function copySymbols(source, object) {
  return copyObject(source, getSymbols(source), object);
}

module.exports = copySymbols;


/***/ }),
/* 401 */
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__(18),
    getSymbolsIn = __webpack_require__(154);

/**
 * Copies own and inherited symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */
function copySymbolsIn(source, object) {
  return copyObject(source, getSymbolsIn(source), object);
}

module.exports = copySymbolsIn;


/***/ }),
/* 402 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(4);

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

module.exports = coreJsData;


/***/ }),
/* 403 */
/***/ (function(module, exports) {

/**
 * Gets the number of `placeholder` occurrences in `array`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} placeholder The placeholder to search for.
 * @returns {number} Returns the placeholder count.
 */
function countHolders(array, placeholder) {
  var length = array.length,
      result = 0;

  while (length--) {
    if (array[length] === placeholder) {
      ++result;
    }
  }
  return result;
}

module.exports = countHolders;


/***/ }),
/* 404 */
/***/ (function(module, exports) {

/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseFor(fromRight) {
  return function(object, iteratee, keysFunc) {
    var index = -1,
        iterable = Object(object),
        props = keysFunc(object),
        length = props.length;

    while (length--) {
      var key = props[fromRight ? length : ++index];
      if (iteratee(iterable[key], key, iterable) === false) {
        break;
      }
    }
    return object;
  };
}

module.exports = createBaseFor;


/***/ }),
/* 405 */
/***/ (function(module, exports, __webpack_require__) {

var createCtor = __webpack_require__(47),
    root = __webpack_require__(4);

/** Used to compose bitmasks for function metadata. */
var WRAP_BIND_FLAG = 1;

/**
 * Creates a function that wraps `func` to invoke it with the optional `this`
 * binding of `thisArg`.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {*} [thisArg] The `this` binding of `func`.
 * @returns {Function} Returns the new wrapped function.
 */
function createBind(func, bitmask, thisArg) {
  var isBind = bitmask & WRAP_BIND_FLAG,
      Ctor = createCtor(func);

  function wrapper() {
    var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
    return fn.apply(isBind ? thisArg : this, arguments);
  }
  return wrapper;
}

module.exports = createBind;


/***/ }),
/* 406 */
/***/ (function(module, exports, __webpack_require__) {

var castSlice = __webpack_require__(396),
    hasUnicode = __webpack_require__(156),
    stringToArray = __webpack_require__(460),
    toString = __webpack_require__(32);

/**
 * Creates a function like `_.lowerFirst`.
 *
 * @private
 * @param {string} methodName The name of the `String` case method to use.
 * @returns {Function} Returns the new case function.
 */
function createCaseFirst(methodName) {
  return function(string) {
    string = toString(string);

    var strSymbols = hasUnicode(string)
      ? stringToArray(string)
      : undefined;

    var chr = strSymbols
      ? strSymbols[0]
      : string.charAt(0);

    var trailing = strSymbols
      ? castSlice(strSymbols, 1).join('')
      : string.slice(1);

    return chr[methodName]() + trailing;
  };
}

module.exports = createCaseFirst;


/***/ }),
/* 407 */
/***/ (function(module, exports, __webpack_require__) {

var apply = __webpack_require__(75),
    createCtor = __webpack_require__(47),
    createHybrid = __webpack_require__(147),
    createRecurry = __webpack_require__(148),
    getHolder = __webpack_require__(83),
    replaceHolders = __webpack_require__(53),
    root = __webpack_require__(4);

/**
 * Creates a function that wraps `func` to enable currying.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {number} arity The arity of `func`.
 * @returns {Function} Returns the new wrapped function.
 */
function createCurry(func, bitmask, arity) {
  var Ctor = createCtor(func);

  function wrapper() {
    var length = arguments.length,
        args = Array(length),
        index = length,
        placeholder = getHolder(wrapper);

    while (index--) {
      args[index] = arguments[index];
    }
    var holders = (length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder)
      ? []
      : replaceHolders(args, placeholder);

    length -= holders.length;
    if (length < arity) {
      return createRecurry(
        func, bitmask, createHybrid, wrapper.placeholder, undefined,
        args, holders, undefined, undefined, arity - length);
    }
    var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
    return apply(fn, this, args);
  }
  return wrapper;
}

module.exports = createCurry;


/***/ }),
/* 408 */
/***/ (function(module, exports, __webpack_require__) {

var baseIteratee = __webpack_require__(137),
    isArrayLike = __webpack_require__(25),
    keys = __webpack_require__(20);

/**
 * Creates a `_.find` or `_.findLast` function.
 *
 * @private
 * @param {Function} findIndexFunc The function to find the collection index.
 * @returns {Function} Returns the new find function.
 */
function createFind(findIndexFunc) {
  return function(collection, predicate, fromIndex) {
    var iterable = Object(collection);
    if (!isArrayLike(collection)) {
      var iteratee = baseIteratee(predicate, 3);
      collection = keys(collection);
      predicate = function(key) { return iteratee(iterable[key], key, iterable); };
    }
    var index = findIndexFunc(collection, predicate, fromIndex);
    return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
  };
}

module.exports = createFind;


/***/ }),
/* 409 */
/***/ (function(module, exports, __webpack_require__) {

var apply = __webpack_require__(75),
    createCtor = __webpack_require__(47),
    root = __webpack_require__(4);

/** Used to compose bitmasks for function metadata. */
var WRAP_BIND_FLAG = 1;

/**
 * Creates a function that wraps `func` to invoke it with the `this` binding
 * of `thisArg` and `partials` prepended to the arguments it receives.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} partials The arguments to prepend to those provided to
 *  the new function.
 * @returns {Function} Returns the new wrapped function.
 */
function createPartial(func, bitmask, thisArg, partials) {
  var isBind = bitmask & WRAP_BIND_FLAG,
      Ctor = createCtor(func);

  function wrapper() {
    var argsIndex = -1,
        argsLength = arguments.length,
        leftIndex = -1,
        leftLength = partials.length,
        args = Array(leftLength + argsLength),
        fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;

    while (++leftIndex < leftLength) {
      args[leftIndex] = partials[leftIndex];
    }
    while (argsLength--) {
      args[leftIndex++] = arguments[++argsIndex];
    }
    return apply(fn, isBind ? thisArg : this, args);
  }
  return wrapper;
}

module.exports = createPartial;


/***/ }),
/* 410 */
/***/ (function(module, exports, __webpack_require__) {

var Set = __webpack_require__(124),
    noop = __webpack_require__(97),
    setToArray = __webpack_require__(89);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/**
 * Creates a set object of `values`.
 *
 * @private
 * @param {Array} values The values to add to the set.
 * @returns {Object} Returns the new set.
 */
var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
  return new Set(values);
};

module.exports = createSet;


/***/ }),
/* 411 */
/***/ (function(module, exports, __webpack_require__) {

var baseSetData = __webpack_require__(138),
    createBind = __webpack_require__(405),
    createCurry = __webpack_require__(407),
    createHybrid = __webpack_require__(147),
    createPartial = __webpack_require__(409),
    getData = __webpack_require__(153),
    mergeData = __webpack_require__(445),
    setData = __webpack_require__(163),
    setWrapToString = __webpack_require__(165),
    toInteger = __webpack_require__(98);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/** Used to compose bitmasks for function metadata. */
var WRAP_BIND_FLAG = 1,
    WRAP_BIND_KEY_FLAG = 2,
    WRAP_CURRY_FLAG = 8,
    WRAP_CURRY_RIGHT_FLAG = 16,
    WRAP_PARTIAL_FLAG = 32,
    WRAP_PARTIAL_RIGHT_FLAG = 64;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * Creates a function that either curries or invokes `func` with optional
 * `this` binding and partially applied arguments.
 *
 * @private
 * @param {Function|string} func The function or method name to wrap.
 * @param {number} bitmask The bitmask flags.
 *    1 - `_.bind`
 *    2 - `_.bindKey`
 *    4 - `_.curry` or `_.curryRight` of a bound function
 *    8 - `_.curry`
 *   16 - `_.curryRight`
 *   32 - `_.partial`
 *   64 - `_.partialRight`
 *  128 - `_.rearg`
 *  256 - `_.ary`
 *  512 - `_.flip`
 * @param {*} [thisArg] The `this` binding of `func`.
 * @param {Array} [partials] The arguments to be partially applied.
 * @param {Array} [holders] The `partials` placeholder indexes.
 * @param {Array} [argPos] The argument positions of the new function.
 * @param {number} [ary] The arity cap of `func`.
 * @param {number} [arity] The arity of `func`.
 * @returns {Function} Returns the new wrapped function.
 */
function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
  var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
  if (!isBindKey && typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var length = partials ? partials.length : 0;
  if (!length) {
    bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
    partials = holders = undefined;
  }
  ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
  arity = arity === undefined ? arity : toInteger(arity);
  length -= holders ? holders.length : 0;

  if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
    var partialsRight = partials,
        holdersRight = holders;

    partials = holders = undefined;
  }
  var data = isBindKey ? undefined : getData(func);

  var newData = [
    func, bitmask, thisArg, partials, holders, partialsRight, holdersRight,
    argPos, ary, arity
  ];

  if (data) {
    mergeData(newData, data);
  }
  func = newData[0];
  bitmask = newData[1];
  thisArg = newData[2];
  partials = newData[3];
  holders = newData[4];
  arity = newData[9] = newData[9] === undefined
    ? (isBindKey ? 0 : func.length)
    : nativeMax(newData[9] - length, 0);

  if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) {
    bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
  }
  if (!bitmask || bitmask == WRAP_BIND_FLAG) {
    var result = createBind(func, bitmask, thisArg);
  } else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) {
    result = createCurry(func, bitmask, arity);
  } else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) {
    result = createPartial(func, bitmask, thisArg, partials);
  } else {
    result = createHybrid.apply(undefined, newData);
  }
  var setter = data ? baseSetData : setData;
  return setWrapToString(setter(result, newData), func, bitmask);
}

module.exports = createWrap;


/***/ }),
/* 412 */
/***/ (function(module, exports, __webpack_require__) {

var basePropertyOf = __webpack_require__(388);

/** Used to map Latin Unicode letters to basic Latin letters. */
var deburredLetters = {
  // Latin-1 Supplement block.
  '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
  '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
  '\xc7': 'C',  '\xe7': 'c',
  '\xd0': 'D',  '\xf0': 'd',
  '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
  '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
  '\xcc': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
  '\xec': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
  '\xd1': 'N',  '\xf1': 'n',
  '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
  '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
  '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
  '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
  '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
  '\xc6': 'Ae', '\xe6': 'ae',
  '\xde': 'Th', '\xfe': 'th',
  '\xdf': 'ss',
  // Latin Extended-A block.
  '\u0100': 'A',  '\u0102': 'A', '\u0104': 'A',
  '\u0101': 'a',  '\u0103': 'a', '\u0105': 'a',
  '\u0106': 'C',  '\u0108': 'C', '\u010a': 'C', '\u010c': 'C',
  '\u0107': 'c',  '\u0109': 'c', '\u010b': 'c', '\u010d': 'c',
  '\u010e': 'D',  '\u0110': 'D', '\u010f': 'd', '\u0111': 'd',
  '\u0112': 'E',  '\u0114': 'E', '\u0116': 'E', '\u0118': 'E', '\u011a': 'E',
  '\u0113': 'e',  '\u0115': 'e', '\u0117': 'e', '\u0119': 'e', '\u011b': 'e',
  '\u011c': 'G',  '\u011e': 'G', '\u0120': 'G', '\u0122': 'G',
  '\u011d': 'g',  '\u011f': 'g', '\u0121': 'g', '\u0123': 'g',
  '\u0124': 'H',  '\u0126': 'H', '\u0125': 'h', '\u0127': 'h',
  '\u0128': 'I',  '\u012a': 'I', '\u012c': 'I', '\u012e': 'I', '\u0130': 'I',
  '\u0129': 'i',  '\u012b': 'i', '\u012d': 'i', '\u012f': 'i', '\u0131': 'i',
  '\u0134': 'J',  '\u0135': 'j',
  '\u0136': 'K',  '\u0137': 'k', '\u0138': 'k',
  '\u0139': 'L',  '\u013b': 'L', '\u013d': 'L', '\u013f': 'L', '\u0141': 'L',
  '\u013a': 'l',  '\u013c': 'l', '\u013e': 'l', '\u0140': 'l', '\u0142': 'l',
  '\u0143': 'N',  '\u0145': 'N', '\u0147': 'N', '\u014a': 'N',
  '\u0144': 'n',  '\u0146': 'n', '\u0148': 'n', '\u014b': 'n',
  '\u014c': 'O',  '\u014e': 'O', '\u0150': 'O',
  '\u014d': 'o',  '\u014f': 'o', '\u0151': 'o',
  '\u0154': 'R',  '\u0156': 'R', '\u0158': 'R',
  '\u0155': 'r',  '\u0157': 'r', '\u0159': 'r',
  '\u015a': 'S',  '\u015c': 'S', '\u015e': 'S', '\u0160': 'S',
  '\u015b': 's',  '\u015d': 's', '\u015f': 's', '\u0161': 's',
  '\u0162': 'T',  '\u0164': 'T', '\u0166': 'T',
  '\u0163': 't',  '\u0165': 't', '\u0167': 't',
  '\u0168': 'U',  '\u016a': 'U', '\u016c': 'U', '\u016e': 'U', '\u0170': 'U', '\u0172': 'U',
  '\u0169': 'u',  '\u016b': 'u', '\u016d': 'u', '\u016f': 'u', '\u0171': 'u', '\u0173': 'u',
  '\u0174': 'W',  '\u0175': 'w',
  '\u0176': 'Y',  '\u0177': 'y', '\u0178': 'Y',
  '\u0179': 'Z',  '\u017b': 'Z', '\u017d': 'Z',
  '\u017a': 'z',  '\u017c': 'z', '\u017e': 'z',
  '\u0132': 'IJ', '\u0133': 'ij',
  '\u0152': 'Oe', '\u0153': 'oe',
  '\u0149': "'n", '\u017f': 's'
};

/**
 * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
 * letters to basic Latin letters.
 *
 * @private
 * @param {string} letter The matched letter to deburr.
 * @returns {string} Returns the deburred letter.
 */
var deburrLetter = basePropertyOf(deburredLetters);

module.exports = deburrLetter;


/***/ }),
/* 413 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(29),
    Uint8Array = __webpack_require__(126),
    eq = __webpack_require__(24),
    equalArrays = __webpack_require__(150),
    mapToArray = __webpack_require__(443),
    setToArray = __webpack_require__(89);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/** `Object#toString` result references. */
var boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]';

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
  switch (tag) {
    case dataViewTag:
      if ((object.byteLength != other.byteLength) ||
          (object.byteOffset != other.byteOffset)) {
        return false;
      }
      object = object.buffer;
      other = other.buffer;

    case arrayBufferTag:
      if ((object.byteLength != other.byteLength) ||
          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
        return false;
      }
      return true;

    case boolTag:
    case dateTag:
    case numberTag:
      // Coerce booleans to `1` or `0` and dates to milliseconds.
      // Invalid dates are coerced to `NaN`.
      return eq(+object, +other);

    case errorTag:
      return object.name == other.name && object.message == other.message;

    case regexpTag:
    case stringTag:
      // Coerce regexes to strings and treat strings, primitives and objects,
      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
      // for more details.
      return object == (other + '');

    case mapTag:
      var convert = mapToArray;

    case setTag:
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
      convert || (convert = setToArray);

      if (object.size != other.size && !isPartial) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked) {
        return stacked == other;
      }
      bitmask |= COMPARE_UNORDERED_FLAG;

      // Recursively compare objects (susceptible to call stack limits).
      stack.set(object, other);
      var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
      stack['delete'](object);
      return result;

    case symbolTag:
      if (symbolValueOf) {
        return symbolValueOf.call(object) == symbolValueOf.call(other);
      }
  }
  return false;
}

module.exports = equalByTag;


/***/ }),
/* 414 */
/***/ (function(module, exports, __webpack_require__) {

var getAllKeys = __webpack_require__(152);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      objProps = getAllKeys(object),
      objLength = objProps.length,
      othProps = getAllKeys(other),
      othLength = othProps.length;

  if (objLength != othLength && !isPartial) {
    return false;
  }
  var index = objLength;
  while (index--) {
    var key = objProps[index];
    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
      return false;
    }
  }
  // Check that cyclic values are equal.
  var objStacked = stack.get(object);
  var othStacked = stack.get(other);
  if (objStacked && othStacked) {
    return objStacked == other && othStacked == object;
  }
  var result = true;
  stack.set(object, other);
  stack.set(other, object);

  var skipCtor = isPartial;
  while (++index < objLength) {
    key = objProps[index];
    var objValue = object[key],
        othValue = other[key];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, objValue, key, other, object, stack)
        : customizer(objValue, othValue, key, object, other, stack);
    }
    // Recursively compare objects (susceptible to call stack limits).
    if (!(compared === undefined
          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
          : compared
        )) {
      result = false;
      break;
    }
    skipCtor || (skipCtor = key == 'constructor');
  }
  if (result && !skipCtor) {
    var objCtor = object.constructor,
        othCtor = other.constructor;

    // Non `Object` object instances with different constructors are not equal.
    if (objCtor != othCtor &&
        ('constructor' in object && 'constructor' in other) &&
        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
      result = false;
    }
  }
  stack['delete'](object);
  stack['delete'](other);
  return result;
}

module.exports = equalObjects;


/***/ }),
/* 415 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetAllKeys = __webpack_require__(135),
    getSymbolsIn = __webpack_require__(154),
    keysIn = __webpack_require__(26);

/**
 * Creates an array of own and inherited enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeysIn(object) {
  return baseGetAllKeys(object, keysIn, getSymbolsIn);
}

module.exports = getAllKeysIn;


/***/ }),
/* 416 */
/***/ (function(module, exports, __webpack_require__) {

var realNames = __webpack_require__(450);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Gets the name of `func`.
 *
 * @private
 * @param {Function} func The function to query.
 * @returns {string} Returns the function name.
 */
function getFuncName(func) {
  var result = (func.name + ''),
      array = realNames[result],
      length = hasOwnProperty.call(realNames, result) ? array.length : 0;

  while (length--) {
    var data = array[length],
        otherFunc = data.func;
    if (otherFunc == null || otherFunc == func) {
      return data.name;
    }
  }
  return result;
}

module.exports = getFuncName;


/***/ }),
/* 417 */
/***/ (function(module, exports, __webpack_require__) {

var isStrictComparable = __webpack_require__(158),
    keys = __webpack_require__(20);

/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */
function getMatchData(object) {
  var result = keys(object),
      length = result.length;

  while (length--) {
    var key = result[length],
        value = object[key];

    result[length] = [key, value, isStrictComparable(value)];
  }
  return result;
}

module.exports = getMatchData;


/***/ }),
/* 418 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(29);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

module.exports = getRawTag;


/***/ }),
/* 419 */
/***/ (function(module, exports) {

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

module.exports = getValue;


/***/ }),
/* 420 */
/***/ (function(module, exports) {

/** Used to match wrap detail comments. */
var reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/,
    reSplitDetails = /,? & /;

/**
 * Extracts wrapper details from the `source` body comment.
 *
 * @private
 * @param {string} source The source to inspect.
 * @returns {Array} Returns the wrapper details.
 */
function getWrapDetails(source) {
  var match = source.match(reWrapDetails);
  return match ? match[1].split(reSplitDetails) : [];
}

module.exports = getWrapDetails;


/***/ }),
/* 421 */
/***/ (function(module, exports) {

/** Used to detect strings that need a more robust regexp to match words. */
var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;

/**
 * Checks if `string` contains a word composed of Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a word is found, else `false`.
 */
function hasUnicodeWord(string) {
  return reHasUnicodeWord.test(string);
}

module.exports = hasUnicodeWord;


/***/ }),
/* 422 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(52);

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
  this.size = 0;
}

module.exports = hashClear;


/***/ }),
/* 423 */
/***/ (function(module, exports) {

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = hashDelete;


/***/ }),
/* 424 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(52);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

module.exports = hashGet;


/***/ }),
/* 425 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(52);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
}

module.exports = hashHas;


/***/ }),
/* 426 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(52);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

module.exports = hashSet;


/***/ }),
/* 427 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Initializes an array clone.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the initialized clone.
 */
function initCloneArray(array) {
  var length = array.length,
      result = new array.constructor(length);

  // Add properties assigned by `RegExp#exec`.
  if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
    result.index = array.index;
    result.input = array.input;
  }
  return result;
}

module.exports = initCloneArray;


/***/ }),
/* 428 */
/***/ (function(module, exports, __webpack_require__) {

var cloneArrayBuffer = __webpack_require__(81),
    cloneDataView = __webpack_require__(397),
    cloneRegExp = __webpack_require__(398),
    cloneSymbol = __webpack_require__(399),
    cloneTypedArray = __webpack_require__(143);

/** `Object#toString` result references. */
var boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/**
 * Initializes an object clone based on its `toStringTag`.
 *
 * **Note:** This function only supports cloning values with tags of
 * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
 *
 * @private
 * @param {Object} object The object to clone.
 * @param {string} tag The `toStringTag` of the object to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneByTag(object, tag, isDeep) {
  var Ctor = object.constructor;
  switch (tag) {
    case arrayBufferTag:
      return cloneArrayBuffer(object);

    case boolTag:
    case dateTag:
      return new Ctor(+object);

    case dataViewTag:
      return cloneDataView(object, isDeep);

    case float32Tag: case float64Tag:
    case int8Tag: case int16Tag: case int32Tag:
    case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
      return cloneTypedArray(object, isDeep);

    case mapTag:
      return new Ctor;

    case numberTag:
    case stringTag:
      return new Ctor(object);

    case regexpTag:
      return cloneRegExp(object);

    case setTag:
      return new Ctor;

    case symbolTag:
      return cloneSymbol(object);
  }
}

module.exports = initCloneByTag;


/***/ }),
/* 429 */
/***/ (function(module, exports) {

/** Used to match wrap detail comments. */
var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/;

/**
 * Inserts wrapper `details` in a comment at the top of the `source` body.
 *
 * @private
 * @param {string} source The source to modify.
 * @returns {Array} details The details to insert.
 * @returns {string} Returns the modified source.
 */
function insertWrapDetails(source, details) {
  var length = details.length;
  if (!length) {
    return source;
  }
  var lastIndex = length - 1;
  details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
  details = details.join(length > 2 ? ', ' : ' ');
  return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
}

module.exports = insertWrapDetails;


/***/ }),
/* 430 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

module.exports = isKeyable;


/***/ }),
/* 431 */
/***/ (function(module, exports, __webpack_require__) {

var LazyWrapper = __webpack_require__(72),
    getData = __webpack_require__(153),
    getFuncName = __webpack_require__(416),
    lodash = __webpack_require__(492);

/**
 * Checks if `func` has a lazy counterpart.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
 *  else `false`.
 */
function isLaziable(func) {
  var funcName = getFuncName(func),
      other = lodash[funcName];

  if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) {
    return false;
  }
  if (func === other) {
    return true;
  }
  var data = getData(other);
  return !!data && func === data[0];
}

module.exports = isLaziable;


/***/ }),
/* 432 */
/***/ (function(module, exports, __webpack_require__) {

var coreJsData = __webpack_require__(402);

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

module.exports = isMasked;


/***/ }),
/* 433 */
/***/ (function(module, exports) {

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

module.exports = listCacheClear;


/***/ }),
/* 434 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(44);

/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

module.exports = listCacheDelete;


/***/ }),
/* 435 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(44);

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

module.exports = listCacheGet;


/***/ }),
/* 436 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(44);

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

module.exports = listCacheHas;


/***/ }),
/* 437 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(44);

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

module.exports = listCacheSet;


/***/ }),
/* 438 */
/***/ (function(module, exports, __webpack_require__) {

var Hash = __webpack_require__(356),
    ListCache = __webpack_require__(42),
    Map = __webpack_require__(73);

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

module.exports = mapCacheClear;


/***/ }),
/* 439 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(48);

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  var result = getMapData(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = mapCacheDelete;


/***/ }),
/* 440 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(48);

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

module.exports = mapCacheGet;


/***/ }),
/* 441 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(48);

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

module.exports = mapCacheHas;


/***/ }),
/* 442 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(48);

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  var data = getMapData(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

module.exports = mapCacheSet;


/***/ }),
/* 443 */
/***/ (function(module, exports) {

/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */
function mapToArray(map) {
  var index = -1,
      result = Array(map.size);

  map.forEach(function(value, key) {
    result[++index] = [key, value];
  });
  return result;
}

module.exports = mapToArray;


/***/ }),
/* 444 */
/***/ (function(module, exports, __webpack_require__) {

var memoize = __webpack_require__(481);

/** Used as the maximum memoize cache size. */
var MAX_MEMOIZE_SIZE = 500;

/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */
function memoizeCapped(func) {
  var result = memoize(func, function(key) {
    if (cache.size === MAX_MEMOIZE_SIZE) {
      cache.clear();
    }
    return key;
  });

  var cache = result.cache;
  return result;
}

module.exports = memoizeCapped;


/***/ }),
/* 445 */
/***/ (function(module, exports, __webpack_require__) {

var composeArgs = __webpack_require__(144),
    composeArgsRight = __webpack_require__(145),
    replaceHolders = __webpack_require__(53);

/** Used as the internal argument placeholder. */
var PLACEHOLDER = '__lodash_placeholder__';

/** Used to compose bitmasks for function metadata. */
var WRAP_BIND_FLAG = 1,
    WRAP_BIND_KEY_FLAG = 2,
    WRAP_CURRY_BOUND_FLAG = 4,
    WRAP_CURRY_FLAG = 8,
    WRAP_ARY_FLAG = 128,
    WRAP_REARG_FLAG = 256;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMin = Math.min;

/**
 * Merges the function metadata of `source` into `data`.
 *
 * Merging metadata reduces the number of wrappers used to invoke a function.
 * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
 * may be applied regardless of execution order. Methods like `_.ary` and
 * `_.rearg` modify function arguments, making the order in which they are
 * executed important, preventing the merging of metadata. However, we make
 * an exception for a safe combined case where curried functions have `_.ary`
 * and or `_.rearg` applied.
 *
 * @private
 * @param {Array} data The destination metadata.
 * @param {Array} source The source metadata.
 * @returns {Array} Returns `data`.
 */
function mergeData(data, source) {
  var bitmask = data[1],
      srcBitmask = source[1],
      newBitmask = bitmask | srcBitmask,
      isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);

  var isCombo =
    ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_CURRY_FLAG)) ||
    ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_REARG_FLAG) && (data[7].length <= source[8])) ||
    ((srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG)) && (source[7].length <= source[8]) && (bitmask == WRAP_CURRY_FLAG));

  // Exit early if metadata can't be merged.
  if (!(isCommon || isCombo)) {
    return data;
  }
  // Use source `thisArg` if available.
  if (srcBitmask & WRAP_BIND_FLAG) {
    data[2] = source[2];
    // Set when currying a bound function.
    newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
  }
  // Compose partial arguments.
  var value = source[3];
  if (value) {
    var partials = data[3];
    data[3] = partials ? composeArgs(partials, value, source[4]) : value;
    data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
  }
  // Compose partial right arguments.
  value = source[5];
  if (value) {
    partials = data[5];
    data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
    data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
  }
  // Use source `argPos` if available.
  value = source[7];
  if (value) {
    data[7] = value;
  }
  // Use source `ary` if it's smaller.
  if (srcBitmask & WRAP_ARY_FLAG) {
    data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
  }
  // Use source `arity` if one is not provided.
  if (data[9] == null) {
    data[9] = source[9];
  }
  // Use source `func` and merge bitmasks.
  data[0] = source[0];
  data[1] = newBitmask;

  return data;
}

module.exports = mergeData;


/***/ }),
/* 446 */
/***/ (function(module, exports, __webpack_require__) {

var overArg = __webpack_require__(161);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = overArg(Object.keys, Object);

module.exports = nativeKeys;


/***/ }),
/* 447 */
/***/ (function(module, exports) {

/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function nativeKeysIn(object) {
  var result = [];
  if (object != null) {
    for (var key in Object(object)) {
      result.push(key);
    }
  }
  return result;
}

module.exports = nativeKeysIn;


/***/ }),
/* 448 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

module.exports = objectToString;


/***/ }),
/* 449 */
/***/ (function(module, exports, __webpack_require__) {

var apply = __webpack_require__(75);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */
function overRest(func, start, transform) {
  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
  return function() {
    var args = arguments,
        index = -1,
        length = nativeMax(args.length - start, 0),
        array = Array(length);

    while (++index < length) {
      array[index] = args[start + index];
    }
    index = -1;
    var otherArgs = Array(start + 1);
    while (++index < start) {
      otherArgs[index] = args[index];
    }
    otherArgs[start] = transform(array);
    return apply(func, this, otherArgs);
  };
}

module.exports = overRest;


/***/ }),
/* 450 */
/***/ (function(module, exports) {

/** Used to lookup unminified function names. */
var realNames = {};

module.exports = realNames;


/***/ }),
/* 451 */
/***/ (function(module, exports, __webpack_require__) {

var copyArray = __webpack_require__(46),
    isIndex = __webpack_require__(50);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMin = Math.min;

/**
 * Reorder `array` according to the specified indexes where the element at
 * the first index is assigned as the first element, the element at
 * the second index is assigned as the second element, and so on.
 *
 * @private
 * @param {Array} array The array to reorder.
 * @param {Array} indexes The arranged array indexes.
 * @returns {Array} Returns `array`.
 */
function reorder(array, indexes) {
  var arrLength = array.length,
      length = nativeMin(indexes.length, arrLength),
      oldArray = copyArray(array);

  while (length--) {
    var index = indexes[length];
    array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
  }
  return array;
}

module.exports = reorder;


/***/ }),
/* 452 */
/***/ (function(module, exports) {

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */
function setCacheAdd(value) {
  this.__data__.set(value, HASH_UNDEFINED);
  return this;
}

module.exports = setCacheAdd;


/***/ }),
/* 453 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {boolean} Returns `true` if `value` is found, else `false`.
 */
function setCacheHas(value) {
  return this.__data__.has(value);
}

module.exports = setCacheHas;


/***/ }),
/* 454 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(42);

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new ListCache;
  this.size = 0;
}

module.exports = stackClear;


/***/ }),
/* 455 */
/***/ (function(module, exports) {

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  var data = this.__data__,
      result = data['delete'](key);

  this.size = data.size;
  return result;
}

module.exports = stackDelete;


/***/ }),
/* 456 */
/***/ (function(module, exports) {

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

module.exports = stackGet;


/***/ }),
/* 457 */
/***/ (function(module, exports) {

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

module.exports = stackHas;


/***/ }),
/* 458 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(42),
    Map = __webpack_require__(73),
    MapCache = __webpack_require__(74);

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var data = this.__data__;
  if (data instanceof ListCache) {
    var pairs = data.__data__;
    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new MapCache(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}

module.exports = stackSet;


/***/ }),
/* 459 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.indexOf` which performs strict equality
 * comparisons of values, i.e. `===`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function strictIndexOf(array, value, fromIndex) {
  var index = fromIndex - 1,
      length = array.length;

  while (++index < length) {
    if (array[index] === value) {
      return index;
    }
  }
  return -1;
}

module.exports = strictIndexOf;


/***/ }),
/* 460 */
/***/ (function(module, exports, __webpack_require__) {

var asciiToArray = __webpack_require__(363),
    hasUnicode = __webpack_require__(156),
    unicodeToArray = __webpack_require__(463);

/**
 * Converts `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function stringToArray(string) {
  return hasUnicode(string)
    ? unicodeToArray(string)
    : asciiToArray(string);
}

module.exports = stringToArray;


/***/ }),
/* 461 */
/***/ (function(module, exports, __webpack_require__) {

var memoizeCapped = __webpack_require__(444);

/** Used to match property names within property paths. */
var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath = memoizeCapped(function(string) {
  var result = [];
  if (string.charCodeAt(0) === 46 /* . */) {
    result.push('');
  }
  string.replace(rePropName, function(match, number, quote, subString) {
    result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
});

module.exports = stringToPath;


/***/ }),
/* 462 */
/***/ (function(module, exports) {

/** Used to match a single whitespace character. */
var reWhitespace = /\s/;

/**
 * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
 * character of `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the index of the last non-whitespace character.
 */
function trimmedEndIndex(string) {
  var index = string.length;

  while (index-- && reWhitespace.test(string.charAt(index))) {}
  return index;
}

module.exports = trimmedEndIndex;


/***/ }),
/* 463 */
/***/ (function(module, exports) {

/** Used to compose unicode character classes. */
var rsAstralRange = '\\ud800-\\udfff',
    rsComboMarksRange = '\\u0300-\\u036f',
    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
    rsComboSymbolsRange = '\\u20d0-\\u20ff',
    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
    rsVarRange = '\\ufe0e\\ufe0f';

/** Used to compose unicode capture groups. */
var rsAstral = '[' + rsAstralRange + ']',
    rsCombo = '[' + rsComboRange + ']',
    rsFitz = '\\ud83c[\\udffb-\\udfff]',
    rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
    rsNonAstral = '[^' + rsAstralRange + ']',
    rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
    rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
    rsZWJ = '\\u200d';

/** Used to compose unicode regexes. */
var reOptMod = rsModifier + '?',
    rsOptVar = '[' + rsVarRange + ']?',
    rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
    rsSeq = rsOptVar + reOptMod + rsOptJoin,
    rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';

/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');

/**
 * Converts a Unicode `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function unicodeToArray(string) {
  return string.match(reUnicode) || [];
}

module.exports = unicodeToArray;


/***/ }),
/* 464 */
/***/ (function(module, exports) {

/** Used to compose unicode character classes. */
var rsAstralRange = '\\ud800-\\udfff',
    rsComboMarksRange = '\\u0300-\\u036f',
    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
    rsComboSymbolsRange = '\\u20d0-\\u20ff',
    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
    rsDingbatRange = '\\u2700-\\u27bf',
    rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff',
    rsMathOpRange = '\\xac\\xb1\\xd7\\xf7',
    rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',
    rsPunctuationRange = '\\u2000-\\u206f',
    rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000',
    rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde',
    rsVarRange = '\\ufe0e\\ufe0f',
    rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;

/** Used to compose unicode capture groups. */
var rsApos = "['\u2019]",
    rsBreak = '[' + rsBreakRange + ']',
    rsCombo = '[' + rsComboRange + ']',
    rsDigits = '\\d+',
    rsDingbat = '[' + rsDingbatRange + ']',
    rsLower = '[' + rsLowerRange + ']',
    rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']',
    rsFitz = '\\ud83c[\\udffb-\\udfff]',
    rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
    rsNonAstral = '[^' + rsAstralRange + ']',
    rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
    rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
    rsUpper = '[' + rsUpperRange + ']',
    rsZWJ = '\\u200d';

/** Used to compose unicode regexes. */
var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')',
    rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')',
    rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?',
    rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?',
    reOptMod = rsModifier + '?',
    rsOptVar = '[' + rsVarRange + ']?',
    rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
    rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])',
    rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])',
    rsSeq = rsOptVar + reOptMod + rsOptJoin,
    rsEmoji = '(?:' + [rsDingbat, rsRegional, rsSurrPair].join('|') + ')' + rsSeq;

/** Used to match complex or compound words. */
var reUnicodeWord = RegExp([
  rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [rsBreak, rsUpper, '$'].join('|') + ')',
  rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [rsBreak, rsUpper + rsMiscLower, '$'].join('|') + ')',
  rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
  rsUpper + '+' + rsOptContrUpper,
  rsOrdUpper,
  rsOrdLower,
  rsDigits,
  rsEmoji
].join('|'), 'g');

/**
 * Splits a Unicode `string` into an array of its words.
 *
 * @private
 * @param {string} The string to inspect.
 * @returns {Array} Returns the words of `string`.
 */
function unicodeWords(string) {
  return string.match(reUnicodeWord) || [];
}

module.exports = unicodeWords;


/***/ }),
/* 465 */
/***/ (function(module, exports, __webpack_require__) {

var arrayEach = __webpack_require__(128),
    arrayIncludes = __webpack_require__(129);

/** Used to compose bitmasks for function metadata. */
var WRAP_BIND_FLAG = 1,
    WRAP_BIND_KEY_FLAG = 2,
    WRAP_CURRY_FLAG = 8,
    WRAP_CURRY_RIGHT_FLAG = 16,
    WRAP_PARTIAL_FLAG = 32,
    WRAP_PARTIAL_RIGHT_FLAG = 64,
    WRAP_ARY_FLAG = 128,
    WRAP_REARG_FLAG = 256,
    WRAP_FLIP_FLAG = 512;

/** Used to associate wrap methods with their bit flags. */
var wrapFlags = [
  ['ary', WRAP_ARY_FLAG],
  ['bind', WRAP_BIND_FLAG],
  ['bindKey', WRAP_BIND_KEY_FLAG],
  ['curry', WRAP_CURRY_FLAG],
  ['curryRight', WRAP_CURRY_RIGHT_FLAG],
  ['flip', WRAP_FLIP_FLAG],
  ['partial', WRAP_PARTIAL_FLAG],
  ['partialRight', WRAP_PARTIAL_RIGHT_FLAG],
  ['rearg', WRAP_REARG_FLAG]
];

/**
 * Updates wrapper `details` based on `bitmask` flags.
 *
 * @private
 * @returns {Array} details The details to modify.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @returns {Array} Returns `details`.
 */
function updateWrapDetails(details, bitmask) {
  arrayEach(wrapFlags, function(pair) {
    var value = '_.' + pair[0];
    if ((bitmask & pair[1]) && !arrayIncludes(details, value)) {
      details.push(value);
    }
  });
  return details.sort();
}

module.exports = updateWrapDetails;


/***/ }),
/* 466 */
/***/ (function(module, exports, __webpack_require__) {

var LazyWrapper = __webpack_require__(72),
    LodashWrapper = __webpack_require__(123),
    copyArray = __webpack_require__(46);

/**
 * Creates a clone of `wrapper`.
 *
 * @private
 * @param {Object} wrapper The wrapper to clone.
 * @returns {Object} Returns the cloned wrapper.
 */
function wrapperClone(wrapper) {
  if (wrapper instanceof LazyWrapper) {
    return wrapper.clone();
  }
  var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
  result.__actions__ = copyArray(wrapper.__actions__);
  result.__index__  = wrapper.__index__;
  result.__values__ = wrapper.__values__;
  return result;
}

module.exports = wrapperClone;


/***/ }),
/* 467 */
/***/ (function(module, exports, __webpack_require__) {

var assignValue = __webpack_require__(76),
    copyObject = __webpack_require__(18),
    createAssigner = __webpack_require__(82),
    isArrayLike = __webpack_require__(25),
    isPrototype = __webpack_require__(51),
    keys = __webpack_require__(20);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Assigns own enumerable string keyed properties of source objects to the
 * destination object. Source objects are applied from left to right.
 * Subsequent sources overwrite property assignments of previous sources.
 *
 * **Note:** This method mutates `object` and is loosely based on
 * [`Object.assign`](https://mdn.io/Object/assign).
 *
 * @static
 * @memberOf _
 * @since 0.10.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @see _.assignIn
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * function Bar() {
 *   this.c = 3;
 * }
 *
 * Foo.prototype.b = 2;
 * Bar.prototype.d = 4;
 *
 * _.assign({ 'a': 0 }, new Foo, new Bar);
 * // => { 'a': 1, 'c': 3 }
 */
var assign = createAssigner(function(object, source) {
  if (isPrototype(source) || isArrayLike(source)) {
    copyObject(source, keys(source), object);
    return;
  }
  for (var key in source) {
    if (hasOwnProperty.call(source, key)) {
      assignValue(object, key, source[key]);
    }
  }
});

module.exports = assign;


/***/ }),
/* 468 */
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__(18),
    createAssigner = __webpack_require__(82),
    keys = __webpack_require__(20);

/**
 * This method is like `_.assign` except that it accepts `customizer`
 * which is invoked to produce the assigned values. If `customizer` returns
 * `undefined`, assignment is handled by the method instead. The `customizer`
 * is invoked with five arguments: (objValue, srcValue, key, object, source).
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} sources The source objects.
 * @param {Function} [customizer] The function to customize assigned values.
 * @returns {Object} Returns `object`.
 * @see _.assignInWith
 * @example
 *
 * function customizer(objValue, srcValue) {
 *   return _.isUndefined(objValue) ? srcValue : objValue;
 * }
 *
 * var defaults = _.partialRight(_.assignWith, customizer);
 *
 * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
 * // => { 'a': 1, 'b': 2 }
 */
var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
  copyObject(source, keys(source), object, customizer);
});

module.exports = assignWith;


/***/ }),
/* 469 */
/***/ (function(module, exports, __webpack_require__) {

var capitalize = __webpack_require__(470),
    createCompounder = __webpack_require__(146);

/**
 * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the camel cased string.
 * @example
 *
 * _.camelCase('Foo Bar');
 * // => 'fooBar'
 *
 * _.camelCase('--foo-bar--');
 * // => 'fooBar'
 *
 * _.camelCase('__FOO_BAR__');
 * // => 'fooBar'
 */
var camelCase = createCompounder(function(result, word, index) {
  word = word.toLowerCase();
  return result + (index ? capitalize(word) : word);
});

module.exports = camelCase;


/***/ }),
/* 470 */
/***/ (function(module, exports, __webpack_require__) {

var toString = __webpack_require__(32),
    upperFirst = __webpack_require__(490);

/**
 * Converts the first character of `string` to upper case and the remaining
 * to lower case.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to capitalize.
 * @returns {string} Returns the capitalized string.
 * @example
 *
 * _.capitalize('FRED');
 * // => 'Fred'
 */
function capitalize(string) {
  return upperFirst(toString(string).toLowerCase());
}

module.exports = capitalize;


/***/ }),
/* 471 */
/***/ (function(module, exports, __webpack_require__) {

var baseClone = __webpack_require__(367);

/** Used to compose bitmasks for cloning. */
var CLONE_SYMBOLS_FLAG = 4;

/**
 * Creates a shallow clone of `value`.
 *
 * **Note:** This method is loosely based on the
 * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
 * and supports cloning arrays, array buffers, booleans, date objects, maps,
 * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
 * arrays. The own enumerable properties of `arguments` objects are cloned
 * as plain objects. An empty object is returned for uncloneable values such
 * as error objects, functions, DOM nodes, and WeakMaps.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to clone.
 * @returns {*} Returns the cloned value.
 * @see _.cloneDeep
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var shallow = _.clone(objects);
 * console.log(shallow[0] === objects[0]);
 * // => true
 */
function clone(value) {
  return baseClone(value, CLONE_SYMBOLS_FLAG);
}

module.exports = clone;


/***/ }),
/* 472 */
/***/ (function(module, exports) {

/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */
function constant(value) {
  return function() {
    return value;
  };
}

module.exports = constant;


/***/ }),
/* 473 */
/***/ (function(module, exports, __webpack_require__) {

var deburrLetter = __webpack_require__(412),
    toString = __webpack_require__(32);

/** Used to match Latin Unicode letters (excluding mathematical operators). */
var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;

/** Used to compose unicode character classes. */
var rsComboMarksRange = '\\u0300-\\u036f',
    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
    rsComboSymbolsRange = '\\u20d0-\\u20ff',
    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange;

/** Used to compose unicode capture groups. */
var rsCombo = '[' + rsComboRange + ']';

/**
 * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
 * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
 */
var reComboMark = RegExp(rsCombo, 'g');

/**
 * Deburrs `string` by converting
 * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
 * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
 * letters to basic Latin letters and removing
 * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to deburr.
 * @returns {string} Returns the deburred string.
 * @example
 *
 * _.deburr('déjà vu');
 * // => 'deja vu'
 */
function deburr(string) {
  string = toString(string);
  return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
}

module.exports = deburr;


/***/ }),
/* 474 */
/***/ (function(module, exports, __webpack_require__) {

var baseHas = __webpack_require__(369),
    hasPath = __webpack_require__(155);

/**
 * Checks if `path` is a direct property of `object`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = { 'a': { 'b': 2 } };
 * var other = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.has(object, 'a');
 * // => true
 *
 * _.has(object, 'a.b');
 * // => true
 *
 * _.has(object, ['a', 'b']);
 * // => true
 *
 * _.has(other, 'a');
 * // => false
 */
function has(object, path) {
  return object != null && hasPath(object, path, baseHas);
}

module.exports = has;


/***/ }),
/* 475 */
/***/ (function(module, exports, __webpack_require__) {

var baseHasIn = __webpack_require__(370),
    hasPath = __webpack_require__(155);

/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */
function hasIn(object, path) {
  return object != null && hasPath(object, path, baseHasIn);
}

module.exports = hasIn;


/***/ }),
/* 476 */
/***/ (function(module, exports, __webpack_require__) {

var isArrayLike = __webpack_require__(25),
    isObjectLike = __webpack_require__(10);

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return isObjectLike(value) && isArrayLike(value);
}

module.exports = isArrayLikeObject;


/***/ }),
/* 477 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsMap = __webpack_require__(374),
    baseUnary = __webpack_require__(80),
    nodeUtil = __webpack_require__(88);

/* Node.js helper references. */
var nodeIsMap = nodeUtil && nodeUtil.isMap;

/**
 * Checks if `value` is classified as a `Map` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 * @example
 *
 * _.isMap(new Map);
 * // => true
 *
 * _.isMap(new WeakMap);
 * // => false
 */
var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;

module.exports = isMap;


/***/ }),
/* 478 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(16),
    isObjectLike = __webpack_require__(10);

/** `Object#toString` result references. */
var numberTag = '[object Number]';

/**
 * Checks if `value` is classified as a `Number` primitive or object.
 *
 * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
 * classified as numbers, use the `_.isFinite` method.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a number, else `false`.
 * @example
 *
 * _.isNumber(3);
 * // => true
 *
 * _.isNumber(Number.MIN_VALUE);
 * // => true
 *
 * _.isNumber(Infinity);
 * // => true
 *
 * _.isNumber('3');
 * // => false
 */
function isNumber(value) {
  return typeof value == 'number' ||
    (isObjectLike(value) && baseGetTag(value) == numberTag);
}

module.exports = isNumber;


/***/ }),
/* 479 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(16),
    getPrototype = __webpack_require__(84),
    isObjectLike = __webpack_require__(10);

/** `Object#toString` result references. */
var objectTag = '[object Object]';

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to infer the `Object` constructor. */
var objectCtorString = funcToString.call(Object);

/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject(value) {
  if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
    return false;
  }
  var proto = getPrototype(value);
  if (proto === null) {
    return true;
  }
  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
    funcToString.call(Ctor) == objectCtorString;
}

module.exports = isPlainObject;


/***/ }),
/* 480 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsSet = __webpack_require__(378),
    baseUnary = __webpack_require__(80),
    nodeUtil = __webpack_require__(88);

/* Node.js helper references. */
var nodeIsSet = nodeUtil && nodeUtil.isSet;

/**
 * Checks if `value` is classified as a `Set` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 * @example
 *
 * _.isSet(new Set);
 * // => true
 *
 * _.isSet(new WeakSet);
 * // => false
 */
var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;

module.exports = isSet;


/***/ }),
/* 481 */
/***/ (function(module, exports, __webpack_require__) {

var MapCache = __webpack_require__(74);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize(func, resolver) {
  if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result) || cache;
    return result;
  };
  memoized.cache = new (memoize.Cache || MapCache);
  return memoized;
}

// Expose `MapCache`.
memoize.Cache = MapCache;

module.exports = memoize;


/***/ }),
/* 482 */
/***/ (function(module, exports, __webpack_require__) {

var baseMerge = __webpack_require__(384),
    createAssigner = __webpack_require__(82);

/**
 * This method is like `_.assign` except that it recursively merges own and
 * inherited enumerable string keyed properties of source objects into the
 * destination object. Source properties that resolve to `undefined` are
 * skipped if a destination value exists. Array and plain object properties
 * are merged recursively. Other objects and value types are overridden by
 * assignment. Source objects are applied from left to right. Subsequent
 * sources overwrite property assignments of previous sources.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 0.5.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = {
 *   'a': [{ 'b': 2 }, { 'd': 4 }]
 * };
 *
 * var other = {
 *   'a': [{ 'c': 3 }, { 'e': 5 }]
 * };
 *
 * _.merge(object, other);
 * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
 */
var merge = createAssigner(function(object, source, srcIndex) {
  baseMerge(object, source, srcIndex);
});

module.exports = merge;


/***/ }),
/* 483 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(4);

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now = function() {
  return root.Date.now();
};

module.exports = now;


/***/ }),
/* 484 */
/***/ (function(module, exports, __webpack_require__) {

var baseRest = __webpack_require__(79),
    createWrap = __webpack_require__(411),
    getHolder = __webpack_require__(83),
    replaceHolders = __webpack_require__(53);

/** Used to compose bitmasks for function metadata. */
var WRAP_PARTIAL_FLAG = 32;

/**
 * Creates a function that invokes `func` with `partials` prepended to the
 * arguments it receives. This method is like `_.bind` except it does **not**
 * alter the `this` binding.
 *
 * The `_.partial.placeholder` value, which defaults to `_` in monolithic
 * builds, may be used as a placeholder for partially applied arguments.
 *
 * **Note:** This method doesn't set the "length" property of partially
 * applied functions.
 *
 * @static
 * @memberOf _
 * @since 0.2.0
 * @category Function
 * @param {Function} func The function to partially apply arguments to.
 * @param {...*} [partials] The arguments to be partially applied.
 * @returns {Function} Returns the new partially applied function.
 * @example
 *
 * function greet(greeting, name) {
 *   return greeting + ' ' + name;
 * }
 *
 * var sayHelloTo = _.partial(greet, 'hello');
 * sayHelloTo('fred');
 * // => 'hello fred'
 *
 * // Partially applied with placeholders.
 * var greetFred = _.partial(greet, _, 'fred');
 * greetFred('hi');
 * // => 'hi fred'
 */
var partial = baseRest(function(func, partials) {
  var holders = replaceHolders(partials, getHolder(partial));
  return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
});

// Assign default placeholders.
partial.placeholder = {};

module.exports = partial;


/***/ }),
/* 485 */
/***/ (function(module, exports, __webpack_require__) {

var baseRandom = __webpack_require__(389),
    isIterateeCall = __webpack_require__(86),
    toFinite = __webpack_require__(171);

/** Built-in method references without a dependency on `root`. */
var freeParseFloat = parseFloat;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMin = Math.min,
    nativeRandom = Math.random;

/**
 * Produces a random number between the inclusive `lower` and `upper` bounds.
 * If only one argument is provided a number between `0` and the given number
 * is returned. If `floating` is `true`, or either `lower` or `upper` are
 * floats, a floating-point number is returned instead of an integer.
 *
 * **Note:** JavaScript follows the IEEE-754 standard for resolving
 * floating-point values which can produce unexpected results.
 *
 * **Note:** If `lower` is greater than `upper`, the values are swapped.
 *
 * @static
 * @memberOf _
 * @since 0.7.0
 * @category Number
 * @param {number} [lower=0] The lower bound.
 * @param {number} [upper=1] The upper bound.
 * @param {boolean} [floating] Specify returning a floating-point number.
 * @returns {number} Returns the random number.
 * @example
 *
 * _.random(0, 5);
 * // => an integer between 0 and 5
 *
 * // when lower is greater than upper the values are swapped
 * _.random(5, 0);
 * // => an integer between 0 and 5
 *
 * _.random(5);
 * // => also an integer between 0 and 5
 *
 * _.random(-5);
 * // => an integer between -5 and 0
 *
 * _.random(5, true);
 * // => a floating-point number between 0 and 5
 *
 * _.random(1.2, 5.2);
 * // => a floating-point number between 1.2 and 5.2
 */
function random(lower, upper, floating) {
  if (floating && typeof floating != 'boolean' && isIterateeCall(lower, upper, floating)) {
    upper = floating = undefined;
  }
  if (floating === undefined) {
    if (typeof upper == 'boolean') {
      floating = upper;
      upper = undefined;
    }
    else if (typeof lower == 'boolean') {
      floating = lower;
      lower = undefined;
    }
  }
  if (lower === undefined && upper === undefined) {
    lower = 0;
    upper = 1;
  }
  else {
    lower = toFinite(lower);
    if (upper === undefined) {
      upper = lower;
      lower = 0;
    } else {
      upper = toFinite(upper);
    }
  }
  if (lower > upper) {
    var temp = lower;
    lower = upper;
    upper = temp;
  }
  if (floating || lower % 1 || upper % 1) {
    var rand = nativeRandom();
    return nativeMin(lower + (rand * (upper - lower + freeParseFloat('1e-' + ((rand + '').length - 1)))), upper);
  }
  return baseRandom(lower, upper);
}

module.exports = random;


/***/ }),
/* 486 */
/***/ (function(module, exports) {

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = stubFalse;


/***/ }),
/* 487 */
/***/ (function(module, exports, __webpack_require__) {

var baseTimes = __webpack_require__(139),
    castFunction = __webpack_require__(395),
    toInteger = __webpack_require__(98);

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** Used as references for the maximum length and index of an array. */
var MAX_ARRAY_LENGTH = 4294967295;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMin = Math.min;

/**
 * Invokes the iteratee `n` times, returning an array of the results of
 * each invocation. The iteratee is invoked with one argument; (index).
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 * @example
 *
 * _.times(3, String);
 * // => ['0', '1', '2']
 *
 *  _.times(4, _.constant(0));
 * // => [0, 0, 0, 0]
 */
function times(n, iteratee) {
  n = toInteger(n);
  if (n < 1 || n > MAX_SAFE_INTEGER) {
    return [];
  }
  var index = MAX_ARRAY_LENGTH,
      length = nativeMin(n, MAX_ARRAY_LENGTH);

  iteratee = castFunction(iteratee);
  n -= MAX_ARRAY_LENGTH;

  var result = baseTimes(length, iteratee);
  while (++index < n) {
    iteratee(index);
  }
  return result;
}

module.exports = times;


/***/ }),
/* 488 */
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__(18),
    keysIn = __webpack_require__(26);

/**
 * Converts `value` to a plain object flattening inherited enumerable string
 * keyed properties of `value` to own properties of the plain object.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {Object} Returns the converted plain object.
 * @example
 *
 * function Foo() {
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.assign({ 'a': 1 }, new Foo);
 * // => { 'a': 1, 'b': 2 }
 *
 * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
 * // => { 'a': 1, 'b': 2, 'c': 3 }
 */
function toPlainObject(value) {
  return copyObject(value, keysIn(value));
}

module.exports = toPlainObject;


/***/ }),
/* 489 */
/***/ (function(module, exports, __webpack_require__) {

var baseUniq = __webpack_require__(394);

/**
 * Creates a duplicate-free version of an array, using
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons, in which only the first occurrence of each element
 * is kept. The order of result values is determined by the order they occur
 * in the array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @returns {Array} Returns the new duplicate free array.
 * @example
 *
 * _.uniq([2, 1, 2]);
 * // => [2, 1]
 */
function uniq(array) {
  return (array && array.length) ? baseUniq(array) : [];
}

module.exports = uniq;


/***/ }),
/* 490 */
/***/ (function(module, exports, __webpack_require__) {

var createCaseFirst = __webpack_require__(406);

/**
 * Converts the first character of `string` to upper case.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.upperFirst('fred');
 * // => 'Fred'
 *
 * _.upperFirst('FRED');
 * // => 'FRED'
 */
var upperFirst = createCaseFirst('toUpperCase');

module.exports = upperFirst;


/***/ }),
/* 491 */
/***/ (function(module, exports, __webpack_require__) {

var asciiWords = __webpack_require__(364),
    hasUnicodeWord = __webpack_require__(421),
    toString = __webpack_require__(32),
    unicodeWords = __webpack_require__(464);

/**
 * Splits `string` into an array of its words.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to inspect.
 * @param {RegExp|string} [pattern] The pattern to match words.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Array} Returns the words of `string`.
 * @example
 *
 * _.words('fred, barney, & pebbles');
 * // => ['fred', 'barney', 'pebbles']
 *
 * _.words('fred, barney, & pebbles', /[^, ]+/g);
 * // => ['fred', 'barney', '&', 'pebbles']
 */
function words(string, pattern, guard) {
  string = toString(string);
  pattern = guard ? undefined : pattern;

  if (pattern === undefined) {
    return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
  }
  return string.match(pattern) || [];
}

module.exports = words;


/***/ }),
/* 492 */
/***/ (function(module, exports, __webpack_require__) {

var LazyWrapper = __webpack_require__(72),
    LodashWrapper = __webpack_require__(123),
    baseLodash = __webpack_require__(78),
    isArray = __webpack_require__(9),
    isObjectLike = __webpack_require__(10),
    wrapperClone = __webpack_require__(466);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Creates a `lodash` object which wraps `value` to enable implicit method
 * chain sequences. Methods that operate on and return arrays, collections,
 * and functions can be chained together. Methods that retrieve a single value
 * or may return a primitive value will automatically end the chain sequence
 * and return the unwrapped value. Otherwise, the value must be unwrapped
 * with `_#value`.
 *
 * Explicit chain sequences, which must be unwrapped with `_#value`, may be
 * enabled using `_.chain`.
 *
 * The execution of chained methods is lazy, that is, it's deferred until
 * `_#value` is implicitly or explicitly called.
 *
 * Lazy evaluation allows several methods to support shortcut fusion.
 * Shortcut fusion is an optimization to merge iteratee calls; this avoids
 * the creation of intermediate arrays and can greatly reduce the number of
 * iteratee executions. Sections of a chain sequence qualify for shortcut
 * fusion if the section is applied to an array and iteratees accept only
 * one argument. The heuristic for whether a section qualifies for shortcut
 * fusion is subject to change.
 *
 * Chaining is supported in custom builds as long as the `_#value` method is
 * directly or indirectly included in the build.
 *
 * In addition to lodash methods, wrappers have `Array` and `String` methods.
 *
 * The wrapper `Array` methods are:
 * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
 *
 * The wrapper `String` methods are:
 * `replace` and `split`
 *
 * The wrapper methods that support shortcut fusion are:
 * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
 * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
 * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
 *
 * The chainable wrapper methods are:
 * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
 * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
 * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
 * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
 * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
 * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
 * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
 * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
 * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
 * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
 * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
 * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
 * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
 * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
 * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
 * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
 * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
 * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
 * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
 * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
 * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
 * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
 * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
 * `zipObject`, `zipObjectDeep`, and `zipWith`
 *
 * The wrapper methods that are **not** chainable by default are:
 * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
 * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
 * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
 * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
 * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
 * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
 * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
 * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
 * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
 * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
 * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
 * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
 * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
 * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
 * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
 * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
 * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
 * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
 * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
 * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
 * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
 * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
 * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
 * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
 * `upperFirst`, `value`, and `words`
 *
 * @name _
 * @constructor
 * @category Seq
 * @param {*} value The value to wrap in a `lodash` instance.
 * @returns {Object} Returns the new `lodash` wrapper instance.
 * @example
 *
 * function square(n) {
 *   return n * n;
 * }
 *
 * var wrapped = _([1, 2, 3]);
 *
 * // Returns an unwrapped value.
 * wrapped.reduce(_.add);
 * // => 6
 *
 * // Returns a wrapped value.
 * var squares = wrapped.map(square);
 *
 * _.isArray(squares);
 * // => false
 *
 * _.isArray(squares.value());
 * // => true
 */
function lodash(value) {
  if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
    if (value instanceof LodashWrapper) {
      return value;
    }
    if (hasOwnProperty.call(value, '__wrapped__')) {
      return wrapperClone(value);
    }
  }
  return new LodashWrapper(value);
}

// Ensure wrappers are instances of `baseLodash`.
lodash.prototype = baseLodash.prototype;
lodash.prototype.constructor = lodash;

module.exports = lodash;


/***/ }),
/* 493 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * mustache.js - Logic-less {{mustache}} templates with JavaScript
 * http://github.com/janl/mustache.js
 */

/*global define: false Mustache: true*/

(function defineMustache (global, factory) {
  if (typeof exports === 'object' && exports && typeof exports.nodeName !== 'string') {
    factory(exports); // CommonJS
  } else if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)); // AMD
  } else {
    global.Mustache = {};
    factory(global.Mustache); // script, wsh, asp
  }
}(this, function mustacheFactory (mustache) {

  var objectToString = Object.prototype.toString;
  var isArray = Array.isArray || function isArrayPolyfill (object) {
    return objectToString.call(object) === '[object Array]';
  };

  function isFunction (object) {
    return typeof object === 'function';
  }

  /**
   * More correct typeof string handling array
   * which normally returns typeof 'object'
   */
  function typeStr (obj) {
    return isArray(obj) ? 'array' : typeof obj;
  }

  function escapeRegExp (string) {
    return string.replace(/[\-\[\]{}()*+?.,\\\^$|#\s]/g, '\\$&');
  }

  /**
   * Null safe way of checking whether or not an object,
   * including its prototype, has a given property
   */
  function hasProperty (obj, propName) {
    return obj != null && typeof obj === 'object' && (propName in obj);
  }

  // Workaround for https://issues.apache.org/jira/browse/COUCHDB-577
  // See https://github.com/janl/mustache.js/issues/189
  var regExpTest = RegExp.prototype.test;
  function testRegExp (re, string) {
    return regExpTest.call(re, string);
  }

  var nonSpaceRe = /\S/;
  function isWhitespace (string) {
    return !testRegExp(nonSpaceRe, string);
  }

  var entityMap = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;',
    '/': '&#x2F;',
    '`': '&#x60;',
    '=': '&#x3D;'
  };

  function escapeHtml (string) {
    return String(string).replace(/[&<>"'`=\/]/g, function fromEntityMap (s) {
      return entityMap[s];
    });
  }

  var whiteRe = /\s*/;
  var spaceRe = /\s+/;
  var equalsRe = /\s*=/;
  var curlyRe = /\s*\}/;
  var tagRe = /#|\^|\/|>|\{|&|=|!/;

  /**
   * Breaks up the given `template` string into a tree of tokens. If the `tags`
   * argument is given here it must be an array with two string values: the
   * opening and closing tags used in the template (e.g. [ "<%", "%>" ]). Of
   * course, the default is to use mustaches (i.e. mustache.tags).
   *
   * A token is an array with at least 4 elements. The first element is the
   * mustache symbol that was used inside the tag, e.g. "#" or "&". If the tag
   * did not contain a symbol (i.e. {{myValue}}) this element is "name". For
   * all text that appears outside a symbol this element is "text".
   *
   * The second element of a token is its "value". For mustache tags this is
   * whatever else was inside the tag besides the opening symbol. For text tokens
   * this is the text itself.
   *
   * The third and fourth elements of the token are the start and end indices,
   * respectively, of the token in the original template.
   *
   * Tokens that are the root node of a subtree contain two more elements: 1) an
   * array of tokens in the subtree and 2) the index in the original template at
   * which the closing tag for that section begins.
   */
  function parseTemplate (template, tags) {
    if (!template)
      return [];

    var sections = [];     // Stack to hold section tokens
    var tokens = [];       // Buffer to hold the tokens
    var spaces = [];       // Indices of whitespace tokens on the current line
    var hasTag = false;    // Is there a {{tag}} on the current line?
    var nonSpace = false;  // Is there a non-space char on the current line?

    // Strips all whitespace tokens array for the current line
    // if there was a {{#tag}} on it and otherwise only space.
    function stripSpace () {
      if (hasTag && !nonSpace) {
        while (spaces.length)
          delete tokens[spaces.pop()];
      } else {
        spaces = [];
      }

      hasTag = false;
      nonSpace = false;
    }

    var openingTagRe, closingTagRe, closingCurlyRe;
    function compileTags (tagsToCompile) {
      if (typeof tagsToCompile === 'string')
        tagsToCompile = tagsToCompile.split(spaceRe, 2);

      if (!isArray(tagsToCompile) || tagsToCompile.length !== 2)
        throw new Error('Invalid tags: ' + tagsToCompile);

      openingTagRe = new RegExp(escapeRegExp(tagsToCompile[0]) + '\\s*');
      closingTagRe = new RegExp('\\s*' + escapeRegExp(tagsToCompile[1]));
      closingCurlyRe = new RegExp('\\s*' + escapeRegExp('}' + tagsToCompile[1]));
    }

    compileTags(tags || mustache.tags);

    var scanner = new Scanner(template);

    var start, type, value, chr, token, openSection;
    while (!scanner.eos()) {
      start = scanner.pos;

      // Match any text between tags.
      value = scanner.scanUntil(openingTagRe);

      if (value) {
        for (var i = 0, valueLength = value.length; i < valueLength; ++i) {
          chr = value.charAt(i);

          if (isWhitespace(chr)) {
            spaces.push(tokens.length);
          } else {
            nonSpace = true;
          }

          tokens.push([ 'text', chr, start, start + 1 ]);
          start += 1;

          // Check for whitespace on the current line.
          if (chr === '\n')
            stripSpace();
        }
      }

      // Match the opening tag.
      if (!scanner.scan(openingTagRe))
        break;

      hasTag = true;

      // Get the tag type.
      type = scanner.scan(tagRe) || 'name';
      scanner.scan(whiteRe);

      // Get the tag value.
      if (type === '=') {
        value = scanner.scanUntil(equalsRe);
        scanner.scan(equalsRe);
        scanner.scanUntil(closingTagRe);
      } else if (type === '{') {
        value = scanner.scanUntil(closingCurlyRe);
        scanner.scan(curlyRe);
        scanner.scanUntil(closingTagRe);
        type = '&';
      } else {
        value = scanner.scanUntil(closingTagRe);
      }

      // Match the closing tag.
      if (!scanner.scan(closingTagRe))
        throw new Error('Unclosed tag at ' + scanner.pos);

      token = [ type, value, start, scanner.pos ];
      tokens.push(token);

      if (type === '#' || type === '^') {
        sections.push(token);
      } else if (type === '/') {
        // Check section nesting.
        openSection = sections.pop();

        if (!openSection)
          throw new Error('Unopened section "' + value + '" at ' + start);

        if (openSection[1] !== value)
          throw new Error('Unclosed section "' + openSection[1] + '" at ' + start);
      } else if (type === 'name' || type === '{' || type === '&') {
        nonSpace = true;
      } else if (type === '=') {
        // Set the tags for the next time around.
        compileTags(value);
      }
    }

    // Make sure there are no open sections when we're done.
    openSection = sections.pop();

    if (openSection)
      throw new Error('Unclosed section "' + openSection[1] + '" at ' + scanner.pos);

    return nestTokens(squashTokens(tokens));
  }

  /**
   * Combines the values of consecutive text tokens in the given `tokens` array
   * to a single token.
   */
  function squashTokens (tokens) {
    var squashedTokens = [];

    var token, lastToken;
    for (var i = 0, numTokens = tokens.length; i < numTokens; ++i) {
      token = tokens[i];

      if (token) {
        if (token[0] === 'text' && lastToken && lastToken[0] === 'text') {
          lastToken[1] += token[1];
          lastToken[3] = token[3];
        } else {
          squashedTokens.push(token);
          lastToken = token;
        }
      }
    }

    return squashedTokens;
  }

  /**
   * Forms the given array of `tokens` into a nested tree structure where
   * tokens that represent a section have two additional items: 1) an array of
   * all tokens that appear in that section and 2) the index in the original
   * template that represents the end of that section.
   */
  function nestTokens (tokens) {
    var nestedTokens = [];
    var collector = nestedTokens;
    var sections = [];

    var token, section;
    for (var i = 0, numTokens = tokens.length; i < numTokens; ++i) {
      token = tokens[i];

      switch (token[0]) {
        case '#':
        case '^':
          collector.push(token);
          sections.push(token);
          collector = token[4] = [];
          break;
        case '/':
          section = sections.pop();
          section[5] = token[2];
          collector = sections.length > 0 ? sections[sections.length - 1][4] : nestedTokens;
          break;
        default:
          collector.push(token);
      }
    }

    return nestedTokens;
  }

  /**
   * A simple string scanner that is used by the template parser to find
   * tokens in template strings.
   */
  function Scanner (string) {
    this.string = string;
    this.tail = string;
    this.pos = 0;
  }

  /**
   * Returns `true` if the tail is empty (end of string).
   */
  Scanner.prototype.eos = function eos () {
    return this.tail === '';
  };

  /**
   * Tries to match the given regular expression at the current position.
   * Returns the matched text if it can match, the empty string otherwise.
   */
  Scanner.prototype.scan = function scan (re) {
    var match = this.tail.match(re);

    if (!match || match.index !== 0)
      return '';

    var string = match[0];

    this.tail = this.tail.substring(string.length);
    this.pos += string.length;

    return string;
  };

  /**
   * Skips all text until the given regular expression can be matched. Returns
   * the skipped string, which is the entire tail if no match can be made.
   */
  Scanner.prototype.scanUntil = function scanUntil (re) {
    var index = this.tail.search(re), match;

    switch (index) {
      case -1:
        match = this.tail;
        this.tail = '';
        break;
      case 0:
        match = '';
        break;
      default:
        match = this.tail.substring(0, index);
        this.tail = this.tail.substring(index);
    }

    this.pos += match.length;

    return match;
  };

  /**
   * Represents a rendering context by wrapping a view object and
   * maintaining a reference to the parent context.
   */
  function Context (view, parentContext) {
    this.view = view;
    this.cache = { '.': this.view };
    this.parent = parentContext;
  }

  /**
   * Creates a new context using the given view with this context
   * as the parent.
   */
  Context.prototype.push = function push (view) {
    return new Context(view, this);
  };

  /**
   * Returns the value of the given name in this context, traversing
   * up the context hierarchy if the value is absent in this context's view.
   */
  Context.prototype.lookup = function lookup (name) {
    var cache = this.cache;

    var value;
    if (cache.hasOwnProperty(name)) {
      value = cache[name];
    } else {
      var context = this, names, index, lookupHit = false;

      while (context) {
        if (name.indexOf('.') > 0) {
          value = context.view;
          names = name.split('.');
          index = 0;

          /**
           * Using the dot notion path in `name`, we descend through the
           * nested objects.
           *
           * To be certain that the lookup has been successful, we have to
           * check if the last object in the path actually has the property
           * we are looking for. We store the result in `lookupHit`.
           *
           * This is specially necessary for when the value has been set to
           * `undefined` and we want to avoid looking up parent contexts.
           **/
          while (value != null && index < names.length) {
            if (index === names.length - 1)
              lookupHit = hasProperty(value, names[index]);

            value = value[names[index++]];
          }
        } else {
          value = context.view[name];
          lookupHit = hasProperty(context.view, name);
        }

        if (lookupHit)
          break;

        context = context.parent;
      }

      cache[name] = value;
    }

    if (isFunction(value))
      value = value.call(this.view);

    return value;
  };

  /**
   * A Writer knows how to take a stream of tokens and render them to a
   * string, given a context. It also maintains a cache of templates to
   * avoid the need to parse the same template twice.
   */
  function Writer () {
    this.cache = {};
  }

  /**
   * Clears all cached templates in this writer.
   */
  Writer.prototype.clearCache = function clearCache () {
    this.cache = {};
  };

  /**
   * Parses and caches the given `template` and returns the array of tokens
   * that is generated from the parse.
   */
  Writer.prototype.parse = function parse (template, tags) {
    var cache = this.cache;
    var tokens = cache[template];

    if (tokens == null)
      tokens = cache[template] = parseTemplate(template, tags);

    return tokens;
  };

  /**
   * High-level method that is used to render the given `template` with
   * the given `view`.
   *
   * The optional `partials` argument may be an object that contains the
   * names and templates of partials that are used in the template. It may
   * also be a function that is used to load partial templates on the fly
   * that takes a single argument: the name of the partial.
   */
  Writer.prototype.render = function render (template, view, partials) {
    var tokens = this.parse(template);
    var context = (view instanceof Context) ? view : new Context(view);
    return this.renderTokens(tokens, context, partials, template);
  };

  /**
   * Low-level method that renders the given array of `tokens` using
   * the given `context` and `partials`.
   *
   * Note: The `originalTemplate` is only ever used to extract the portion
   * of the original template that was contained in a higher-order section.
   * If the template doesn't use higher-order sections, this argument may
   * be omitted.
   */
  Writer.prototype.renderTokens = function renderTokens (tokens, context, partials, originalTemplate) {
    var buffer = '';

    var token, symbol, value;
    for (var i = 0, numTokens = tokens.length; i < numTokens; ++i) {
      value = undefined;
      token = tokens[i];
      symbol = token[0];

      if (symbol === '#') value = this.renderSection(token, context, partials, originalTemplate);
      else if (symbol === '^') value = this.renderInverted(token, context, partials, originalTemplate);
      else if (symbol === '>') value = this.renderPartial(token, context, partials, originalTemplate);
      else if (symbol === '&') value = this.unescapedValue(token, context);
      else if (symbol === 'name') value = this.escapedValue(token, context);
      else if (symbol === 'text') value = this.rawValue(token);

      if (value !== undefined)
        buffer += value;
    }

    return buffer;
  };

  Writer.prototype.renderSection = function renderSection (token, context, partials, originalTemplate) {
    var self = this;
    var buffer = '';
    var value = context.lookup(token[1]);

    // This function is used to render an arbitrary template
    // in the current context by higher-order sections.
    function subRender (template) {
      return self.render(template, context, partials);
    }

    if (!value) return;

    if (isArray(value)) {
      for (var j = 0, valueLength = value.length; j < valueLength; ++j) {
        buffer += this.renderTokens(token[4], context.push(value[j]), partials, originalTemplate);
      }
    } else if (typeof value === 'object' || typeof value === 'string' || typeof value === 'number') {
      buffer += this.renderTokens(token[4], context.push(value), partials, originalTemplate);
    } else if (isFunction(value)) {
      if (typeof originalTemplate !== 'string')
        throw new Error('Cannot use higher-order sections without the original template');

      // Extract the portion of the original template that the section contains.
      value = value.call(context.view, originalTemplate.slice(token[3], token[5]), subRender);

      if (value != null)
        buffer += value;
    } else {
      buffer += this.renderTokens(token[4], context, partials, originalTemplate);
    }
    return buffer;
  };

  Writer.prototype.renderInverted = function renderInverted (token, context, partials, originalTemplate) {
    var value = context.lookup(token[1]);

    // Use JavaScript's definition of falsy. Include empty arrays.
    // See https://github.com/janl/mustache.js/issues/186
    if (!value || (isArray(value) && value.length === 0))
      return this.renderTokens(token[4], context, partials, originalTemplate);
  };

  Writer.prototype.renderPartial = function renderPartial (token, context, partials) {
    if (!partials) return;

    var value = isFunction(partials) ? partials(token[1]) : partials[token[1]];
    if (value != null)
      return this.renderTokens(this.parse(value), context, partials, value);
  };

  Writer.prototype.unescapedValue = function unescapedValue (token, context) {
    var value = context.lookup(token[1]);
    if (value != null)
      return value;
  };

  Writer.prototype.escapedValue = function escapedValue (token, context) {
    var value = context.lookup(token[1]);
    if (value != null)
      return mustache.escape(value);
  };

  Writer.prototype.rawValue = function rawValue (token) {
    return token[1];
  };

  mustache.name = 'mustache.js';
  mustache.version = '2.3.2';
  mustache.tags = [ '{{', '}}' ];

  // All high-level mustache.* functions use this writer.
  var defaultWriter = new Writer();

  /**
   * Clears all cached templates in the default writer.
   */
  mustache.clearCache = function clearCache () {
    return defaultWriter.clearCache();
  };

  /**
   * Parses and caches the given template in the default writer and returns the
   * array of tokens it contains. Doing this ahead of time avoids the need to
   * parse templates on the fly as they are rendered.
   */
  mustache.parse = function parse (template, tags) {
    return defaultWriter.parse(template, tags);
  };

  /**
   * Renders the `template` with the given `view` and `partials` using the
   * default writer.
   */
  mustache.render = function render (template, view, partials) {
    if (typeof template !== 'string') {
      throw new TypeError('Invalid template! Template should be a "string" ' +
                          'but "' + typeStr(template) + '" was given as the first ' +
                          'argument for mustache#render(template, view, partials)');
    }

    return defaultWriter.render(template, view, partials);
  };

  // This is here for backwards compatibility with 0.4.x.,
  /*eslint-disable */ // eslint wants camel cased function name
  mustache.to_html = function to_html (template, view, partials, send) {
    /*eslint-enable*/

    var result = mustache.render(template, view, partials);

    if (isFunction(send)) {
      send(result);
    } else {
      return result;
    }
  };

  // Export the escaping function so that the user may override it.
  // See https://github.com/janl/mustache.js/issues/244
  mustache.escape = escapeHtml;

  // Export these mainly for testing, but also for advanced usage.
  mustache.Scanner = Scanner;
  mustache.Context = Context;
  mustache.Writer = Writer;

  return mustache;
}));


/***/ }),
/* 494 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 495 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, process) {(function (global, undefined) {
    "use strict";

    if (global.setImmediate) {
        return;
    }

    var nextHandle = 1; // Spec says greater than zero
    var tasksByHandle = {};
    var currentlyRunningATask = false;
    var doc = global.document;
    var registerImmediate;

    function setImmediate(callback) {
      // Callback can either be a function or a string
      if (typeof callback !== "function") {
        callback = new Function("" + callback);
      }
      // Copy function arguments
      var args = new Array(arguments.length - 1);
      for (var i = 0; i < args.length; i++) {
          args[i] = arguments[i + 1];
      }
      // Store and register the task
      var task = { callback: callback, args: args };
      tasksByHandle[nextHandle] = task;
      registerImmediate(nextHandle);
      return nextHandle++;
    }

    function clearImmediate(handle) {
        delete tasksByHandle[handle];
    }

    function run(task) {
        var callback = task.callback;
        var args = task.args;
        switch (args.length) {
        case 0:
            callback();
            break;
        case 1:
            callback(args[0]);
            break;
        case 2:
            callback(args[0], args[1]);
            break;
        case 3:
            callback(args[0], args[1], args[2]);
            break;
        default:
            callback.apply(undefined, args);
            break;
        }
    }

    function runIfPresent(handle) {
        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
        // So if we're currently running a task, we'll need to delay this invocation.
        if (currentlyRunningATask) {
            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
            // "too much recursion" error.
            setTimeout(runIfPresent, 0, handle);
        } else {
            var task = tasksByHandle[handle];
            if (task) {
                currentlyRunningATask = true;
                try {
                    run(task);
                } finally {
                    clearImmediate(handle);
                    currentlyRunningATask = false;
                }
            }
        }
    }

    function installNextTickImplementation() {
        registerImmediate = function(handle) {
            process.nextTick(function () { runIfPresent(handle); });
        };
    }

    function canUsePostMessage() {
        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
        // where `global.postMessage` means something completely different and can't be used for this purpose.
        if (global.postMessage && !global.importScripts) {
            var postMessageIsAsynchronous = true;
            var oldOnMessage = global.onmessage;
            global.onmessage = function() {
                postMessageIsAsynchronous = false;
            };
            global.postMessage("", "*");
            global.onmessage = oldOnMessage;
            return postMessageIsAsynchronous;
        }
    }

    function installPostMessageImplementation() {
        // Installs an event handler on `global` for the `message` event: see
        // * https://developer.mozilla.org/en/DOM/window.postMessage
        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages

        var messagePrefix = "setImmediate$" + Math.random() + "$";
        var onGlobalMessage = function(event) {
            if (event.source === global &&
                typeof event.data === "string" &&
                event.data.indexOf(messagePrefix) === 0) {
                runIfPresent(+event.data.slice(messagePrefix.length));
            }
        };

        if (global.addEventListener) {
            global.addEventListener("message", onGlobalMessage, false);
        } else {
            global.attachEvent("onmessage", onGlobalMessage);
        }

        registerImmediate = function(handle) {
            global.postMessage(messagePrefix + handle, "*");
        };
    }

    function installMessageChannelImplementation() {
        var channel = new MessageChannel();
        channel.port1.onmessage = function(event) {
            var handle = event.data;
            runIfPresent(handle);
        };

        registerImmediate = function(handle) {
            channel.port2.postMessage(handle);
        };
    }

    function installReadyStateChangeImplementation() {
        var html = doc.documentElement;
        registerImmediate = function(handle) {
            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
            var script = doc.createElement("script");
            script.onreadystatechange = function () {
                runIfPresent(handle);
                script.onreadystatechange = null;
                html.removeChild(script);
                script = null;
            };
            html.appendChild(script);
        };
    }

    function installSetTimeoutImplementation() {
        registerImmediate = function(handle) {
            setTimeout(runIfPresent, 0, handle);
        };
    }

    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;

    // Don't get fooled by e.g. browserify environments.
    if ({}.toString.call(global.process) === "[object process]") {
        // For Node.js before 0.9
        installNextTickImplementation();

    } else if (canUsePostMessage()) {
        // For non-IE10 modern browsers
        installPostMessageImplementation();

    } else if (global.MessageChannel) {
        // For web workers, where supported
        installMessageChannelImplementation();

    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
        // For IE 6–8
        installReadyStateChangeImplementation();

    } else {
        // For older browsers
        installSetTimeoutImplementation();
    }

    attachTo.setImmediate = setImmediate;
    attachTo.clearImmediate = clearImmediate;
}(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(100), __webpack_require__(494)))

/***/ }),
/* 496 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var scope = (typeof global !== "undefined" && global) ||
            (typeof self !== "undefined" && self) ||
            window;
var apply = Function.prototype.apply;

// DOM APIs, for completeness

exports.setTimeout = function() {
  return new Timeout(apply.call(setTimeout, scope, arguments), clearTimeout);
};
exports.setInterval = function() {
  return new Timeout(apply.call(setInterval, scope, arguments), clearInterval);
};
exports.clearTimeout =
exports.clearInterval = function(timeout) {
  if (timeout) {
    timeout.close();
  }
};

function Timeout(id, clearFn) {
  this._id = id;
  this._clearFn = clearFn;
}
Timeout.prototype.unref = Timeout.prototype.ref = function() {};
Timeout.prototype.close = function() {
  this._clearFn.call(scope, this._id);
};

// Does not start the time, just sets up the members needed.
exports.enroll = function(item, msecs) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = msecs;
};

exports.unenroll = function(item) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = -1;
};

exports._unrefActive = exports.active = function(item) {
  clearTimeout(item._idleTimeoutId);

  var msecs = item._idleTimeout;
  if (msecs >= 0) {
    item._idleTimeoutId = setTimeout(function onTimeout() {
      if (item._onTimeout)
        item._onTimeout();
    }, msecs);
  }
};

// setimmediate attaches itself to the global object
__webpack_require__(495);
// On some exotic environments, it's not clear which object `setimmediate` was
// able to install onto.  Search each possibility in the same order as the
// `setimmediate` library.
exports.setImmediate = (typeof self !== "undefined" && self.setImmediate) ||
                       (typeof global !== "undefined" && global.setImmediate) ||
                       (this && this.setImmediate);
exports.clearImmediate = (typeof self !== "undefined" && self.clearImmediate) ||
                         (typeof global !== "undefined" && global.clearImmediate) ||
                         (this && this.clearImmediate);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(100)))

/***/ }),
/* 497 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isPrototype = __webpack_require__(500);

module.exports = function (value) {
	if (typeof value !== "function") return false;

	if (!hasOwnProperty.call(value, "length")) return false;

	try {
		if (typeof value.length !== "number") return false;
		if (typeof value.call !== "function") return false;
		if (typeof value.apply !== "function") return false;
	} catch (error) {
		return false;
	}

	return !isPrototype(value);
};


/***/ }),
/* 498 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isValue = __webpack_require__(173);

// prettier-ignore
var possibleTypes = { "object": true, "function": true, "undefined": true /* document.all */ };

module.exports = function (value) {
	if (!isValue(value)) return false;
	return hasOwnProperty.call(possibleTypes, typeof value);
};


/***/ }),
/* 499 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isFunction = __webpack_require__(497);

var classRe = /^\s*class[\s{/}]/, functionToString = Function.prototype.toString;

module.exports = function (value) {
	if (!isFunction(value)) return false;
	if (classRe.test(functionToString.call(value))) return false;
	return true;
};


/***/ }),
/* 500 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isObject = __webpack_require__(498);

module.exports = function (value) {
	if (!isObject(value)) return false;
	try {
		if (!value.constructor) return false;
		return value.constructor.prototype === value;
	} catch (error) {
		return false;
	}
};


/***/ }),
/* 501 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isFDQN;

var _assertString = __webpack_require__(502);

var _assertString2 = _interopRequireDefault(_assertString);

var _merge = __webpack_require__(503);

var _merge2 = _interopRequireDefault(_merge);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var default_fqdn_options = {
  require_tld: true,
  allow_underscores: false,
  allow_trailing_dot: false
};

function isFDQN(str, options) {
  (0, _assertString2.default)(str);
  options = (0, _merge2.default)(options, default_fqdn_options);

  /* Remove the optional trailing dot before checking validity */
  if (options.allow_trailing_dot && str[str.length - 1] === '.') {
    str = str.substring(0, str.length - 1);
  }
  var parts = str.split('.');
  if (options.require_tld) {
    var tld = parts.pop();
    if (!parts.length || !/^([a-z\u00a1-\uffff]{2,}|xn[a-z0-9-]{2,})$/i.test(tld)) {
      return false;
    }
    // disallow spaces
    if (/[\s\u2002-\u200B\u202F\u205F\u3000\uFEFF\uDB40\uDC20]/.test(tld)) {
      return false;
    }
  }
  for (var part, i = 0; i < parts.length; i++) {
    part = parts[i];
    if (options.allow_underscores) {
      part = part.replace(/_/g, '');
    }
    if (!/^[a-z\u00a1-\uffff0-9-]+$/i.test(part)) {
      return false;
    }
    // disallow full-width chars
    if (/[\uff01-\uff5e]/.test(part)) {
      return false;
    }
    if (part[0] === '-' || part[part.length - 1] === '-') {
      return false;
    }
  }
  return true;
}
module.exports = exports['default'];

/***/ }),
/* 502 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = assertString;
function assertString(input) {
  var isString = typeof input === 'string' || input instanceof String;

  if (!isString) {
    throw new TypeError('This library (validator.js) validates strings only');
  }
}
module.exports = exports['default'];

/***/ }),
/* 503 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = merge;
function merge() {
  var obj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var defaults = arguments[1];

  for (var key in defaults) {
    if (typeof obj[key] === 'undefined') {
      obj[key] = defaults[key];
    }
  }
  return obj;
}
module.exports = exports['default'];

/***/ }),
/* 504 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export CLSThresholds */
/* unused harmony export FCPThresholds */
/* unused harmony export FIDThresholds */
/* unused harmony export INPThresholds */
/* unused harmony export LCPThresholds */
/* unused harmony export TTFBThresholds */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return S; });
/* unused harmony export getFCP */
/* unused harmony export getFID */
/* unused harmony export getINP */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return W; });
/* unused harmony export getTTFB */
/* unused harmony export onCLS */
/* unused harmony export onFCP */
/* unused harmony export onFID */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return Q; });
/* unused harmony export onLCP */
/* unused harmony export onTTFB */
var e,n,t,i,r,a=-1,o=function(e){addEventListener("pageshow",(function(n){n.persisted&&(a=n.timeStamp,e(n))}),!0)},c=function(){return window.performance&&performance.getEntriesByType&&performance.getEntriesByType("navigation")[0]},u=function(){var e=c();return e&&e.activationStart||0},f=function(e,n){var t=c(),i="navigate";a>=0?i="back-forward-cache":t&&(document.prerendering||u()>0?i="prerender":document.wasDiscarded?i="restore":t.type&&(i=t.type.replace(/_/g,"-")));return{name:e,value:void 0===n?-1:n,rating:"good",delta:0,entries:[],id:"v3-".concat(Date.now(),"-").concat(Math.floor(8999999999999*Math.random())+1e12),navigationType:i}},s=function(e,n,t){try{if(PerformanceObserver.supportedEntryTypes.includes(e)){var i=new PerformanceObserver((function(e){Promise.resolve().then((function(){n(e.getEntries())}))}));return i.observe(Object.assign({type:e,buffered:!0},t||{})),i}}catch(e){}},d=function(e,n,t,i){var r,a;return function(o){n.value>=0&&(o||i)&&((a=n.value-(r||0))||void 0===r)&&(r=n.value,n.delta=a,n.rating=function(e,n){return e>n[1]?"poor":e>n[0]?"needs-improvement":"good"}(n.value,t),e(n))}},l=function(e){requestAnimationFrame((function(){return requestAnimationFrame((function(){return e()}))}))},p=function(e){var n=function(n){"pagehide"!==n.type&&"hidden"!==document.visibilityState||e(n)};addEventListener("visibilitychange",n,!0),addEventListener("pagehide",n,!0)},v=function(e){var n=!1;return function(t){n||(e(t),n=!0)}},m=-1,h=function(){return"hidden"!==document.visibilityState||document.prerendering?1/0:0},g=function(e){"hidden"===document.visibilityState&&m>-1&&(m="visibilitychange"===e.type?e.timeStamp:0,T())},y=function(){addEventListener("visibilitychange",g,!0),addEventListener("prerenderingchange",g,!0)},T=function(){removeEventListener("visibilitychange",g,!0),removeEventListener("prerenderingchange",g,!0)},E=function(){return m<0&&(m=h(),y(),o((function(){setTimeout((function(){m=h(),y()}),0)}))),{get firstHiddenTime(){return m}}},C=function(e){document.prerendering?addEventListener("prerenderingchange",(function(){return e()}),!0):e()},L=[1800,3e3],w=function(e,n){n=n||{},C((function(){var t,i=E(),r=f("FCP"),a=s("paint",(function(e){e.forEach((function(e){"first-contentful-paint"===e.name&&(a.disconnect(),e.startTime<i.firstHiddenTime&&(r.value=Math.max(e.startTime-u(),0),r.entries.push(e),t(!0)))}))}));a&&(t=d(e,r,L,n.reportAllChanges),o((function(i){r=f("FCP"),t=d(e,r,L,n.reportAllChanges),l((function(){r.value=performance.now()-i.timeStamp,t(!0)}))})))}))},b=[.1,.25],S=function(e,n){n=n||{},w(v((function(){var t,i=f("CLS",0),r=0,a=[],c=function(e){e.forEach((function(e){if(!e.hadRecentInput){var n=a[0],t=a[a.length-1];r&&e.startTime-t.startTime<1e3&&e.startTime-n.startTime<5e3?(r+=e.value,a.push(e)):(r=e.value,a=[e])}})),r>i.value&&(i.value=r,i.entries=a,t())},u=s("layout-shift",c);u&&(t=d(e,i,b,n.reportAllChanges),p((function(){c(u.takeRecords()),t(!0)})),o((function(){r=0,i=f("CLS",0),t=d(e,i,b,n.reportAllChanges),l((function(){return t()}))})),setTimeout(t,0))})))},A={passive:!0,capture:!0},I=new Date,P=function(i,r){e||(e=r,n=i,t=new Date,k(removeEventListener),F())},F=function(){if(n>=0&&n<t-I){var r={entryType:"first-input",name:e.type,target:e.target,cancelable:e.cancelable,startTime:e.timeStamp,processingStart:e.timeStamp+n};i.forEach((function(e){e(r)})),i=[]}},M=function(e){if(e.cancelable){var n=(e.timeStamp>1e12?new Date:performance.now())-e.timeStamp;"pointerdown"==e.type?function(e,n){var t=function(){P(e,n),r()},i=function(){r()},r=function(){removeEventListener("pointerup",t,A),removeEventListener("pointercancel",i,A)};addEventListener("pointerup",t,A),addEventListener("pointercancel",i,A)}(n,e):P(n,e)}},k=function(e){["mousedown","keydown","touchstart","pointerdown"].forEach((function(n){return e(n,M,A)}))},D=[100,300],x=function(t,r){r=r||{},C((function(){var a,c=E(),u=f("FID"),l=function(e){e.startTime<c.firstHiddenTime&&(u.value=e.processingStart-e.startTime,u.entries.push(e),a(!0))},m=function(e){e.forEach(l)},h=s("first-input",m);a=d(t,u,D,r.reportAllChanges),h&&p(v((function(){m(h.takeRecords()),h.disconnect()}))),h&&o((function(){var o;u=f("FID"),a=d(t,u,D,r.reportAllChanges),i=[],n=-1,e=null,k(addEventListener),o=l,i.push(o),F()}))}))},B=0,R=1/0,H=0,N=function(e){e.forEach((function(e){e.interactionId&&(R=Math.min(R,e.interactionId),H=Math.max(H,e.interactionId),B=H?(H-R)/7+1:0)}))},O=function(){return r?B:performance.interactionCount||0},q=function(){"interactionCount"in performance||r||(r=s("event",N,{type:"event",buffered:!0,durationThreshold:0}))},j=[200,500],_=0,z=function(){return O()-_},G=[],J={},K=function(e){var n=G[G.length-1],t=J[e.interactionId];if(t||G.length<10||e.duration>n.latency){if(t)t.entries.push(e),t.latency=Math.max(t.latency,e.duration);else{var i={id:e.interactionId,latency:e.duration,entries:[e]};J[i.id]=i,G.push(i)}G.sort((function(e,n){return n.latency-e.latency})),G.splice(10).forEach((function(e){delete J[e.id]}))}},Q=function(e,n){n=n||{},C((function(){var t;q();var i,r=f("INP"),a=function(e){e.forEach((function(e){(e.interactionId&&K(e),"first-input"===e.entryType)&&(!G.some((function(n){return n.entries.some((function(n){return e.duration===n.duration&&e.startTime===n.startTime}))}))&&K(e))}));var n,t=(n=Math.min(G.length-1,Math.floor(z()/50)),G[n]);t&&t.latency!==r.value&&(r.value=t.latency,r.entries=t.entries,i())},c=s("event",a,{durationThreshold:null!==(t=n.durationThreshold)&&void 0!==t?t:40});i=d(e,r,j,n.reportAllChanges),c&&("PerformanceEventTiming"in window&&"interactionId"in PerformanceEventTiming.prototype&&c.observe({type:"first-input",buffered:!0}),p((function(){a(c.takeRecords()),r.value<0&&z()>0&&(r.value=0,r.entries=[]),i(!0)})),o((function(){G=[],_=O(),r=f("INP"),i=d(e,r,j,n.reportAllChanges)})))}))},U=[2500,4e3],V={},W=function(e,n){n=n||{},C((function(){var t,i=E(),r=f("LCP"),a=function(e){var n=e[e.length-1];n&&n.startTime<i.firstHiddenTime&&(r.value=Math.max(n.startTime-u(),0),r.entries=[n],t())},c=s("largest-contentful-paint",a);if(c){t=d(e,r,U,n.reportAllChanges);var m=v((function(){V[r.id]||(a(c.takeRecords()),c.disconnect(),V[r.id]=!0,t(!0))}));["keydown","click"].forEach((function(e){addEventListener(e,(function(){return setTimeout(m,0)}),!0)})),p(m),o((function(i){r=f("LCP"),t=d(e,r,U,n.reportAllChanges),l((function(){r.value=performance.now()-i.timeStamp,V[r.id]=!0,t(!0)}))}))}}))},X=[800,1800],Y=function e(n){document.prerendering?C((function(){return e(n)})):"complete"!==document.readyState?addEventListener("load",(function(){return e(n)}),!0):setTimeout(n,0)},Z=function(e,n){n=n||{};var t=f("TTFB"),i=d(e,t,X,n.reportAllChanges);Y((function(){var r=c();if(r){var a=r.responseStart;if(a<=0||a>performance.now())return;t.value=Math.max(a-u(),0),t.entries=[r],i(!0),o((function(){t=f("TTFB",0),(i=d(e,t,X,n.reportAllChanges))(!0)}))}}))};


/***/ })
/******/ ]);


// WEBPACK FOOTER //
// dist/chrome.js